//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class MediaService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getItems(source: MediaItemSource | undefined, request: ListRequestOfContentTypeFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfMediaItem> {
        let url_ = this.baseUrl + "/api/media/all?";
        if (source === null)
            throw new globalThis.Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: AxiosResponse): Promise<ListResponseOfMediaItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMediaItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMediaItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMediaItem>(null as any);
    }

    getItem(itemId: string, source: MediaItemSource | undefined, cancelToken?: CancelToken): Promise<ResponseOfMediaItem> {
        let url_ = this.baseUrl + "/api/media/{itemId}?";
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (source === null)
            throw new globalThis.Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItem(_response);
        });
    }

    protected processGetItem(response: AxiosResponse): Promise<ResponseOfMediaItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfMediaItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfMediaItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfMediaItem>(null as any);
    }

    saveItem(source: MediaItemSource | undefined, saveRequest: MediaItemSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/media?";
        if (source === null)
            throw new globalThis.Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveItem(_response);
        });
    }

    protected processSaveItem(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    generateFileUploadUrl(request: FileUploadRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfFileUploadUrls> {
        let url_ = this.baseUrl + "/api/media/generate-file-upload-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateFileUploadUrl(_response);
        });
    }

    protected processGenerateFileUploadUrl(response: AxiosResponse): Promise<ResponseOfFileUploadUrls> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfFileUploadUrls.fromJS(resultData200);
            return Promise.resolve<ResponseOfFileUploadUrls>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfFileUploadUrls>(null as any);
    }
}

export class NotificationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEmailTheme( cancelToken?: CancelToken): Promise<ResponseOfSettingCache> {
        let url_ = this.baseUrl + "/api/contents/notifications/email-theme";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTheme(_response);
        });
    }

    protected processGetEmailTheme(response: AxiosResponse): Promise<ResponseOfSettingCache> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSettingCache.fromJS(resultData200);
            return Promise.resolve<ResponseOfSettingCache>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSettingCache>(null as any);
    }

    saveEmailTheme(request: SaveEmailThemeRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/contents/notifications/email-theme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmailTheme(_response);
        });
    }

    protected processSaveEmailTheme(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getEmailThemeByOrganization(emailThemeRequest: EmailThemeRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfSettingCache> {
        let url_ = this.baseUrl + "/api/contents/notifications/email-theme/by-organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailThemeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailThemeByOrganization(_response);
        });
    }

    protected processGetEmailThemeByOrganization(response: AxiosResponse): Promise<ResponseOfSettingCache> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSettingCache.fromJS(resultData200);
            return Promise.resolve<ResponseOfSettingCache>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSettingCache>(null as any);
    }

    deleteEmailTheme(settingValueId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/contents/notifications/email-theme/{settingValueId}";
        if (settingValueId === undefined || settingValueId === null)
            throw new globalThis.Error("The parameter 'settingValueId' must be defined.");
        url_ = url_.replace("{settingValueId}", encodeURIComponent("" + settingValueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmailTheme(_response);
        });
    }

    protected processDeleteEmailTheme(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class SettingsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSettings(request: AdminListRequestOfSettingFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSettingListItem> {
        let url_ = this.baseUrl + "/api/settings/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<ListResponseOfSettingListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSettingListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSettingListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSettingListItem>(null as any);
    }

    getSettingById(settingId: string, cancelToken?: CancelToken): Promise<ResponseOfSettingCache> {
        let url_ = this.baseUrl + "/api/settings/{settingId}";
        if (settingId === undefined || settingId === null)
            throw new globalThis.Error("The parameter 'settingId' must be defined.");
        url_ = url_.replace("{settingId}", encodeURIComponent("" + settingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingById(_response);
        });
    }

    protected processGetSettingById(response: AxiosResponse): Promise<ResponseOfSettingCache> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSettingCache.fromJS(resultData200);
            return Promise.resolve<ResponseOfSettingCache>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSettingCache>(null as any);
    }

    getSettingTypes(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSettingType> {
        let url_ = this.baseUrl + "/api/settings/setting-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingTypes(_response);
        });
    }

    protected processGetSettingTypes(response: AxiosResponse): Promise<ListResponseOfSettingType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSettingType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSettingType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSettingType>(null as any);
    }

    getSettingGroups(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSettingGroup> {
        let url_ = this.baseUrl + "/api/settings/groups/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingGroups(_response);
        });
    }

    protected processGetSettingGroups(response: AxiosResponse): Promise<ListResponseOfSettingGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSettingGroup.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSettingGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSettingGroup>(null as any);
    }

    getDescendantSettings(request: AdminListRequestOfDescendantSettingFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfDescendantSettingCache> {
        let url_ = this.baseUrl + "/api/settings/descendant/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDescendantSettings(_response);
        });
    }

    protected processGetDescendantSettings(response: AxiosResponse): Promise<ListResponseOfDescendantSettingCache> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfDescendantSettingCache.fromJS(resultData200);
            return Promise.resolve<ListResponseOfDescendantSettingCache>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfDescendantSettingCache>(null as any);
    }

    getApplicationOverrides(settingId: string, cancelToken?: CancelToken): Promise<ListResponseOfSettingCache> {
        let url_ = this.baseUrl + "/api/settings/{settingId}/application-overrides";
        if (settingId === undefined || settingId === null)
            throw new globalThis.Error("The parameter 'settingId' must be defined.");
        url_ = url_.replace("{settingId}", encodeURIComponent("" + settingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationOverrides(_response);
        });
    }

    protected processGetApplicationOverrides(response: AxiosResponse): Promise<ListResponseOfSettingCache> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSettingCache.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSettingCache>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSettingCache>(null as any);
    }

    resyncSettingsCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/settings/resync-cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResyncSettingsCache(_response);
        });
    }

    protected processResyncSettingsCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSettingValue(settingValueId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/settings/setting-values/{settingValueId}";
        if (settingValueId === undefined || settingValueId === null)
            throw new globalThis.Error("The parameter 'settingValueId' must be defined.");
        url_ = url_.replace("{settingValueId}", encodeURIComponent("" + settingValueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSettingValue(_response);
        });
    }

    protected processDeleteSettingValue(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveSettingValue(request: SaveSettingValueRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/settings/setting-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSettingValue(_response);
        });
    }

    protected processSaveSettingValue(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class SiteSettingService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSiteSettings( cancelToken?: CancelToken): Promise<SiteSettings> {
        let url_ = this.baseUrl + "/api/site-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSiteSettings(_response);
        });
    }

    protected processGetSiteSettings(response: AxiosResponse): Promise<SiteSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteSettings.fromJS(resultData200);
            return Promise.resolve<SiteSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteSettings>(null as any);
    }
}

export class SiteThemeService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSiteThemeByOrganization(organizationId: string, cancelToken?: CancelToken): Promise<SiteTheme> {
        let url_ = this.baseUrl + "/api/site-theme/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSiteThemeByOrganization(_response);
        });
    }

    protected processGetSiteThemeByOrganization(response: AxiosResponse): Promise<SiteTheme> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteTheme.fromJS(resultData200);
            return Promise.resolve<SiteTheme>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteTheme>(null as any);
    }
}

export class ScormExportedFilesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getExportedFiles(request: ListRequestOfScormExportedFilesFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfScormExportedFile> {
        let url_ = this.baseUrl + "/api/v1/rustici/exported-files/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportedFiles(_response);
        });
    }

    protected processGetExportedFiles(response: AxiosResponse): Promise<ListResponseOfScormExportedFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfScormExportedFile.fromJS(resultData200);
            return Promise.resolve<ListResponseOfScormExportedFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfScormExportedFile>(null as any);
    }

    getExportedFileTags( cancelToken?: CancelToken): Promise<ListResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/rustici/exported-files/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportedFileTags(_response);
        });
    }

    protected processGetExportedFileTags(response: AxiosResponse): Promise<ListResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfString.fromJS(resultData200);
            return Promise.resolve<ListResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfString>(null as any);
    }

    downloadExportedFile(runFileId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/rustici/exported-files/{runFileId}/content";
        if (runFileId === undefined || runFileId === null)
            throw new globalThis.Error("The parameter 'runFileId' must be defined.");
        url_ = url_.replace("{runFileId}", encodeURIComponent("" + runFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExportedFile(_response);
        });
    }

    protected processDownloadExportedFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadExportedFiles(request: ScormExportedFilesDownloadRequest | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/rustici/exported-files/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExportedFiles(_response);
        });
    }

    protected processDownloadExportedFiles(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadExportedFiles(request: ScormExportedFilesUploadRequest | null | undefined, cancelToken?: CancelToken): Promise<ScormExportedFilesUploadResponse> {
        let url_ = this.baseUrl + "/api/v1/rustici/exported-files/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadExportedFiles(_response);
        });
    }

    protected processUploadExportedFiles(response: AxiosResponse): Promise<ScormExportedFilesUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScormExportedFilesUploadResponse.fromJS(resultData200);
            return Promise.resolve<ScormExportedFilesUploadResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScormExportedFilesUploadResponse>(null as any);
    }
}

export class ScormMetadataService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getScormMetadata(includeWebinars: boolean | undefined, includeSelfStudyDownloads: boolean | undefined, includeSelfStudyWebcasts: boolean | undefined, cancelToken?: CancelToken): Promise<ListResponseOfScormMetadataRow> {
        let url_ = this.baseUrl + "/api/v1/rustici/metadata?";
        if (includeWebinars === null)
            throw new globalThis.Error("The parameter 'includeWebinars' cannot be null.");
        else if (includeWebinars !== undefined)
            url_ += "IncludeWebinars=" + encodeURIComponent("" + includeWebinars) + "&";
        if (includeSelfStudyDownloads === null)
            throw new globalThis.Error("The parameter 'includeSelfStudyDownloads' cannot be null.");
        else if (includeSelfStudyDownloads !== undefined)
            url_ += "IncludeSelfStudyDownloads=" + encodeURIComponent("" + includeSelfStudyDownloads) + "&";
        if (includeSelfStudyWebcasts === null)
            throw new globalThis.Error("The parameter 'includeSelfStudyWebcasts' cannot be null.");
        else if (includeSelfStudyWebcasts !== undefined)
            url_ += "IncludeSelfStudyWebcasts=" + encodeURIComponent("" + includeSelfStudyWebcasts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScormMetadata(_response);
        });
    }

    protected processGetScormMetadata(response: AxiosResponse): Promise<ListResponseOfScormMetadataRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfScormMetadataRow.fromJS(resultData200);
            return Promise.resolve<ListResponseOfScormMetadataRow>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfScormMetadataRow>(null as any);
    }
}

export class AccessLevelService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    saveAccessLevel(request: AccessLevelSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/access-levels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccessLevel(_response);
        });
    }

    protected processSaveAccessLevel(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getAccessLevels(request: AccessLevelListRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAccessLevelModel> {
        let url_ = this.baseUrl + "/api/access-levels/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessLevels(_response);
        });
    }

    protected processGetAccessLevels(response: AxiosResponse): Promise<ListResponseOfAccessLevelModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAccessLevelModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAccessLevelModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAccessLevelModel>(null as any);
    }

    deleteAccessLevel(accessLevelId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/access-levels/{accessLevelId}";
        if (accessLevelId === undefined || accessLevelId === null)
            throw new globalThis.Error("The parameter 'accessLevelId' must be defined.");
        url_ = url_.replace("{accessLevelId}", encodeURIComponent("" + accessLevelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccessLevel(_response);
        });
    }

    protected processDeleteAccessLevel(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    updateAccessLevelsSequence(request: UpdateAccessLevelsSequenceRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/access-levels/sequence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccessLevelsSequence(_response);
        });
    }

    protected processUpdateAccessLevelsSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class AttendanceRecordService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAttendanceRecords(request: ListRequestOfAttendanceRecordFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAttendanceRecord> {
        let url_ = this.baseUrl + "/api/attendance-records/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttendanceRecords(_response);
        });
    }

    protected processGetAttendanceRecords(response: AxiosResponse): Promise<ListResponseOfAttendanceRecord> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAttendanceRecord.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAttendanceRecord>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAttendanceRecord>(null as any);
    }

    exportAttendanceRecords(skuId: string, request: ListRequestOfAttendanceRecordFilterRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/attendance-records/{skuId}/export";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAttendanceRecords(_response);
        });
    }

    protected processExportAttendanceRecords(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getDownloadUrl(fileId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/attendance-records/attendance-records/get-download-url?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadUrl(_response);
        });
    }

    protected processGetDownloadUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getAttendanceRecordStatus(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/attendance-records/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttendanceRecordStatus(_response);
        });
    }

    protected processGetAttendanceRecordStatus(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }
}

export class UserSkuService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    addEnrollment(request: UserEnrollmentRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/enrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddEnrollment(_response);
        });
    }

    protected processAddEnrollment(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    addBulkEnrollment(request: BulkUserEnrollmentRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/bulk-enrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBulkEnrollment(_response);
        });
    }

    protected processAddBulkEnrollment(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    resolveUsersByEmails(request: ResolveUsersByEmailsRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResolvedUser> {
        let url_ = this.baseUrl + "/api/user-skus/resolve-users-by-emails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveUsersByEmails(_response);
        });
    }

    protected processResolveUsersByEmails(response: AxiosResponse): Promise<ListResponseOfResolvedUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResolvedUser.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResolvedUser>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResolvedUser>(null as any);
    }

    getRegistrationStatuses(request: ListRequestOfRegistrationStateFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRegistrationStatus> {
        let url_ = this.baseUrl + "/api/user-skus/registration-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationStatuses(_response);
        });
    }

    protected processGetRegistrationStatuses(response: AxiosResponse): Promise<ListResponseOfRegistrationStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRegistrationStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRegistrationStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRegistrationStatus>(null as any);
    }

    certifyUserSku(request: CertifyUserSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/certify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCertifyUserSku(_response);
        });
    }

    protected processCertifyUserSku(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getUserSkus(request: AdminUserSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfUserSkuExtended> {
        let url_ = this.baseUrl + "/api/user-skus/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSkus(_response);
        });
    }

    protected processGetUserSkus(response: AxiosResponse): Promise<ListResponseOfUserSkuExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserSkuExtended.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserSkuExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserSkuExtended>(null as any);
    }

    getUserSku(userId: string | undefined, organizationId: string | undefined, userSkuId: string, cancelToken?: CancelToken): Promise<ResponseOfUserSkuExtended> {
        let url_ = this.baseUrl + "/api/user-skus/{userSkuId}?";
        if (userSkuId === undefined || userSkuId === null)
            throw new globalThis.Error("The parameter 'userSkuId' must be defined.");
        url_ = url_.replace("{userSkuId}", encodeURIComponent("" + userSkuId));
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSku(_response);
        });
    }

    protected processGetUserSku(response: AxiosResponse): Promise<ResponseOfUserSkuExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfUserSkuExtended.fromJS(resultData200);
            return Promise.resolve<ResponseOfUserSkuExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfUserSkuExtended>(null as any);
    }

    getParentUserSkus(request: AdminUserSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfUserSkuExtended> {
        let url_ = this.baseUrl + "/api/user-skus/parent-user-skus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParentUserSkus(_response);
        });
    }

    protected processGetParentUserSkus(response: AxiosResponse): Promise<ListResponseOfUserSkuExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserSkuExtended.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserSkuExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserSkuExtended>(null as any);
    }

    getUserId(userSkuId: string, cancelToken?: CancelToken): Promise<ResponseOfGuid> {
        let url_ = this.baseUrl + "/api/user-skus/{userSkuId}/user-id";
        if (userSkuId === undefined || userSkuId === null)
            throw new globalThis.Error("The parameter 'userSkuId' must be defined.");
        url_ = url_.replace("{userSkuId}", encodeURIComponent("" + userSkuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserId(_response);
        });
    }

    protected processGetUserId(response: AxiosResponse): Promise<ResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfGuid.fromJS(resultData200);
            return Promise.resolve<ResponseOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfGuid>(null as any);
    }

    deleteUserSku(request: DeleteUserSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserSku(_response);
        });
    }

    protected processDeleteUserSku(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    processUserChargeback(request: UserChargebackRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/chargeback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessUserChargeback(_response);
        });
    }

    protected processProcessUserChargeback(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    modifyEnrollment(modifyEnrollmentRequest: ModifyEnrollmentRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/modify-enrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modifyEnrollmentRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyEnrollment(_response);
        });
    }

    protected processModifyEnrollment(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    markAsAttended(request: MarkAsAttendedRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/mark-as-attended";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsAttended(_response);
        });
    }

    protected processMarkAsAttended(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    canRegisterUserSku(request: CanRegisterUserSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/user-skus/can-register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCanRegisterUserSku(_response);
        });
    }

    protected processCanRegisterUserSku(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    getSkuRegistrations(skuId: string, request: ListRequestOfStateFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuRegistration> {
        let url_ = this.baseUrl + "/api/user-skus/{skuId}/registrations";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuRegistrations(_response);
        });
    }

    protected processGetSkuRegistrations(response: AxiosResponse): Promise<ListResponseOfSkuRegistration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuRegistration.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuRegistration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuRegistration>(null as any);
    }

    exportSkuRegistrations(skuId: string, request: ListRequestOfStateFilterRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/{skuId}/registrations/export";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSkuRegistrations(_response);
        });
    }

    protected processExportSkuRegistrations(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getDownloadUrl(fileId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/user-skus/registrations/get-download-url?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadUrl(_response);
        });
    }

    protected processGetDownloadUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getUserSkuActivities(request: ListRequestOfUserSkuActivitiesFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfUserSkuActivity> {
        let url_ = this.baseUrl + "/api/user-skus/activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSkuActivities(_response);
        });
    }

    protected processGetUserSkuActivities(response: AxiosResponse): Promise<ListResponseOfUserSkuActivity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserSkuActivity.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserSkuActivity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserSkuActivity>(null as any);
    }

    getUserSkuAuditTimeline(request: ListRequestOfUserSkuActivitiesFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfUserSkuAuditTimelineEntry> {
        let url_ = this.baseUrl + "/api/user-skus/audit-timeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSkuAuditTimeline(_response);
        });
    }

    protected processGetUserSkuAuditTimeline(response: AxiosResponse): Promise<ListResponseOfUserSkuAuditTimelineEntry> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserSkuAuditTimelineEntry.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserSkuAuditTimelineEntry>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserSkuAuditTimelineEntry>(null as any);
    }

    moveSkuRegistrations(sourceSkuId: string, targetSkuId: string, expireSourceRegistrations: boolean | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/{sourceSkuId}/registrations/move/{targetSkuId}?";
        if (sourceSkuId === undefined || sourceSkuId === null)
            throw new globalThis.Error("The parameter 'sourceSkuId' must be defined.");
        url_ = url_.replace("{sourceSkuId}", encodeURIComponent("" + sourceSkuId));
        if (targetSkuId === undefined || targetSkuId === null)
            throw new globalThis.Error("The parameter 'targetSkuId' must be defined.");
        url_ = url_.replace("{targetSkuId}", encodeURIComponent("" + targetSkuId));
        if (expireSourceRegistrations === null)
            throw new globalThis.Error("The parameter 'expireSourceRegistrations' cannot be null.");
        else if (expireSourceRegistrations !== undefined)
            url_ += "expireSourceRegistrations=" + encodeURIComponent("" + expireSourceRegistrations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveSkuRegistrations(_response);
        });
    }

    protected processMoveSkuRegistrations(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    changeParentUserSku(changeParentUserSkuRequest: ChangeParentUserSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-skus/change-parent-user-sku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeParentUserSkuRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeParentUserSku(_response);
        });
    }

    protected processChangeParentUserSku(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getUserSkuStates(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfUserSkuState> {
        let url_ = this.baseUrl + "/api/user-skus/states/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSkuStates(_response);
        });
    }

    protected processGetUserSkuStates(response: AxiosResponse): Promise<ListResponseOfUserSkuState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserSkuState.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserSkuState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserSkuState>(null as any);
    }
}

export class RusticiCourseService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    resolveScope( cancelToken?: CancelToken): Promise<RusticiScopeInfo> {
        let url_ = this.baseUrl + "/api/v1/rustici/courses/scope";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveScope(_response);
        });
    }

    protected processResolveScope(response: AxiosResponse): Promise<RusticiScopeInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RusticiScopeInfo.fromJS(resultData200);
            return Promise.resolve<RusticiScopeInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RusticiScopeInfo>(null as any);
    }

    findCoursesToDeactivate(request: RusticiCourseSearchRequest | null | undefined, cancelToken?: CancelToken): Promise<RusticiCourseSearchResult> {
        let url_ = this.baseUrl + "/api/v1/rustici/courses/enabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindCoursesToDeactivate(_response);
        });
    }

    protected processFindCoursesToDeactivate(response: AxiosResponse): Promise<RusticiCourseSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RusticiCourseSearchResult.fromJS(resultData200);
            return Promise.resolve<RusticiCourseSearchResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RusticiCourseSearchResult>(null as any);
    }

    deactivateCourses(request: RusticiDeactivationRequest | null | undefined, cancelToken?: CancelToken): Promise<RusticiDeactivationSummary> {
        let url_ = this.baseUrl + "/api/v1/rustici/courses/deactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateCourses(_response);
        });
    }

    protected processDeactivateCourses(response: AxiosResponse): Promise<RusticiDeactivationSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RusticiDeactivationSummary.fromJS(resultData200);
            return Promise.resolve<RusticiDeactivationSummary>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RusticiDeactivationSummary>(null as any);
    }

    getExportOrganizations( cancelToken?: CancelToken): Promise<RusticiExportOrganization[]> {
        let url_ = this.baseUrl + "/api/v1/rustici/courses/export/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportOrganizations(_response);
        });
    }

    protected processGetExportOrganizations(response: AxiosResponse): Promise<RusticiExportOrganization[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RusticiExportOrganization.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RusticiExportOrganization[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RusticiExportOrganization[]>(null as any);
    }

    startCourseExport(organizationIds: string[] | null | undefined, skus: string[] | null | undefined, contentType: string | null | undefined, exportOnly: boolean | undefined, tag: string | null | undefined, maxConcurrentThreads: number | undefined, metadataFile: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/rustici/courses/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (organizationIds !== null && organizationIds !== undefined)
            organizationIds.forEach(item_ => content_.append("OrganizationIds", item_.toString()));
        if (skus !== null && skus !== undefined)
            skus.forEach(item_ => content_.append("Skus", item_.toString()));
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (exportOnly === null || exportOnly === undefined)
            throw new globalThis.Error("The parameter 'exportOnly' cannot be null.");
        else
            content_.append("ExportOnly", exportOnly.toString());
        if (tag !== null && tag !== undefined)
            content_.append("Tag", tag.toString());
        if (maxConcurrentThreads === null || maxConcurrentThreads === undefined)
            throw new globalThis.Error("The parameter 'maxConcurrentThreads' cannot be null.");
        else
            content_.append("MaxConcurrentThreads", maxConcurrentThreads.toString());
        if (metadataFile !== null && metadataFile !== undefined)
            content_.append("MetadataFile", metadataFile.data, metadataFile.fileName ? metadataFile.fileName : "MetadataFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartCourseExport(_response);
        });
    }

    protected processStartCourseExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PdfService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    preview(request: PreviewPdfRequest | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/pdf/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AgreementService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStatuses( cancelToken?: CancelToken): Promise<ListResponseOfAgreementStatusResponse> {
        let url_ = this.baseUrl + "/api/agreements/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatuses(_response);
        });
    }

    protected processGetStatuses(response: AxiosResponse): Promise<ListResponseOfAgreementStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAgreementStatusResponse.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAgreementStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAgreementStatusResponse>(null as any);
    }

    saveAgreement(request: AgreementRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/agreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAgreement(_response);
        });
    }

    protected processSaveAgreement(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    updateContent(request: AgreementContentRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/agreements/content";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContent(_response);
        });
    }

    protected processUpdateContent(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getAgreement(agreementId: string, cancelToken?: CancelToken): Promise<ResponseOfAgreementResponse> {
        let url_ = this.baseUrl + "/api/agreements/{agreementId}";
        if (agreementId === undefined || agreementId === null)
            throw new globalThis.Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreement(_response);
        });
    }

    protected processGetAgreement(response: AxiosResponse): Promise<ResponseOfAgreementResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAgreementResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfAgreementResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAgreementResponse>(null as any);
    }

    getAgreements(agreementFilter: ListRequestOfAgreementFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAgreementResponse> {
        let url_ = this.baseUrl + "/api/agreements/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agreementFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreements(_response);
        });
    }

    protected processGetAgreements(response: AxiosResponse): Promise<ListResponseOfAgreementResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAgreementResponse.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAgreementResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAgreementResponse>(null as any);
    }

    getPlaceholders(agreementId: string | undefined, filter: AdminListRequestOfPlaceholderFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfPlaceholderAdmin> {
        let url_ = this.baseUrl + "/api/agreements/placeholders?";
        if (agreementId === null)
            throw new globalThis.Error("The parameter 'agreementId' cannot be null.");
        else if (agreementId !== undefined)
            url_ += "agreementId=" + encodeURIComponent("" + agreementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaceholders(_response);
        });
    }

    protected processGetPlaceholders(response: AxiosResponse): Promise<ListResponseOfPlaceholderAdmin> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfPlaceholderAdmin.fromJS(resultData200);
            return Promise.resolve<ListResponseOfPlaceholderAdmin>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfPlaceholderAdmin>(null as any);
    }
}

export class ApplicationUserService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getApplicationUsersByOrganizationUserId(filter: ListRequestOfApplicationUserFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfApplicationUser> {
        let url_ = this.baseUrl + "/api/application-users/by-organization-userid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationUsersByOrganizationUserId(_response);
        });
    }

    protected processGetApplicationUsersByOrganizationUserId(response: AxiosResponse): Promise<ListResponseOfApplicationUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfApplicationUser.fromJS(resultData200);
            return Promise.resolve<ListResponseOfApplicationUser>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfApplicationUser>(null as any);
    }

    enableAccessForApplication(organizationUserId: string, applicationId: string, cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/application-users/{organizationUserId}/applications/{applicationId}";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableAccessForApplication(_response);
        });
    }

    protected processEnableAccessForApplication(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    removeAccessForApplication(organizationUserId: string, applicationId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/application-users/{organizationUserId}/applications/{applicationId}";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveAccessForApplication(_response);
        });
    }

    protected processRemoveAccessForApplication(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class CatalogSkuService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrganizationCatalogSkus(request: OrganizationCatalogSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationCatalogSku> {
        let url_ = this.baseUrl + "/api/catalog-skus/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationCatalogSkus(_response);
        });
    }

    protected processGetOrganizationCatalogSkus(response: AxiosResponse): Promise<ListResponseOfOrganizationCatalogSku> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationCatalogSku.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationCatalogSku>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationCatalogSku>(null as any);
    }

    saveOrganizationCatalogSku(saveOrganizationCatalogSkuRequest: SaveOrganizationCatalogSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/catalog-skus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveOrganizationCatalogSkuRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOrganizationCatalogSku(_response);
        });
    }

    protected processSaveOrganizationCatalogSku(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteOrganizationCatalogSku(organizationCatalogSkuId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/catalog-skus/{organizationCatalogSkuId}";
        if (organizationCatalogSkuId === undefined || organizationCatalogSkuId === null)
            throw new globalThis.Error("The parameter 'organizationCatalogSkuId' must be defined.");
        url_ = url_.replace("{organizationCatalogSkuId}", encodeURIComponent("" + organizationCatalogSkuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganizationCatalogSku(_response);
        });
    }

    protected processDeleteOrganizationCatalogSku(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class CatalogSkuTypesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrganizationCatalogSkuTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationCatalogSkuTypes> {
        let url_ = this.baseUrl + "/api/catalog-sku-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationCatalogSkuTypes(_response);
        });
    }

    protected processGetOrganizationCatalogSkuTypes(response: AxiosResponse): Promise<ListResponseOfOrganizationCatalogSkuTypes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationCatalogSkuTypes.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationCatalogSkuTypes>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationCatalogSkuTypes>(null as any);
    }
}

export class ContractService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getContract(contractId: string, cancelToken?: CancelToken): Promise<ResponseOfContract> {
        let url_ = this.baseUrl + "/api/contracts/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContract(_response);
        });
    }

    protected processGetContract(response: AxiosResponse): Promise<ResponseOfContract> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfContract.fromJS(resultData200);
            return Promise.resolve<ResponseOfContract>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfContract>(null as any);
    }

    deleteContract(contractId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/contracts/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContract(_response);
        });
    }

    protected processDeleteContract(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getContracts(request: ContractListRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfContract> {
        let url_ = this.baseUrl + "/api/contracts/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContracts(_response);
        });
    }

    protected processGetContracts(response: AxiosResponse): Promise<ListResponseOfContract> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfContract.fromJS(resultData200);
            return Promise.resolve<ListResponseOfContract>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfContract>(null as any);
    }

    saveContract(request: SaveContractRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveContract(_response);
        });
    }

    protected processSaveContract(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getContractTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfContractType> {
        let url_ = this.baseUrl + "/api/contracts/contract-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractTypes(_response);
        });
    }

    protected processGetContractTypes(response: AxiosResponse): Promise<ListResponseOfContractType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfContractType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfContractType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfContractType>(null as any);
    }

    getContractStatuses(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfContractStatus> {
        let url_ = this.baseUrl + "/api/contracts/contract-statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractStatuses(_response);
        });
    }

    protected processGetContractStatuses(response: AxiosResponse): Promise<ListResponseOfContractStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfContractStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfContractStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfContractStatus>(null as any);
    }
}

export class OrganizationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrganizations(request: AdminListRequestOfOrganizationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationModel> {
        let url_ = this.baseUrl + "/api/organizations/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizations(_response);
        });
    }

    protected processGetOrganizations(response: AxiosResponse): Promise<ListResponseOfOrganizationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationModel>(null as any);
    }

    getFirstLevelOrganizationChildren(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationModel> {
        let url_ = this.baseUrl + "/api/organizations/children/first-level";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirstLevelOrganizationChildren(_response);
        });
    }

    protected processGetFirstLevelOrganizationChildren(response: AxiosResponse): Promise<ListResponseOfOrganizationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationModel>(null as any);
    }

    saveAdminUser(saveRequest: OrganizationAdminRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/organizations/admin-users/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAdminUser(_response);
        });
    }

    protected processSaveAdminUser(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteAdminUser(adminUserId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organizations/admin-users/{adminUserId}";
        if (adminUserId === undefined || adminUserId === null)
            throw new globalThis.Error("The parameter 'adminUserId' must be defined.");
        url_ = url_.replace("{adminUserId}", encodeURIComponent("" + adminUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAdminUser(_response);
        });
    }

    protected processDeleteAdminUser(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getAdminConflicts(request: OrganizationAdminConflictsRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfOrganizationAdminConflicts> {
        let url_ = this.baseUrl + "/api/organizations/admin-users/conflicts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminConflicts(_response);
        });
    }

    protected processGetAdminConflicts(response: AxiosResponse): Promise<ResponseOfOrganizationAdminConflicts> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfOrganizationAdminConflicts.fromJS(resultData200);
            return Promise.resolve<ResponseOfOrganizationAdminConflicts>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfOrganizationAdminConflicts>(null as any);
    }

    getAdminUsers(organizationId: string, request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationAdminModel> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/admin-users/all";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminUsers(_response);
        });
    }

    protected processGetAdminUsers(response: AxiosResponse): Promise<ListResponseOfOrganizationAdminModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationAdminModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationAdminModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationAdminModel>(null as any);
    }

    saveOrganization(saveRequest: OrganizationSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOrganization(_response);
        });
    }

    protected processSaveOrganization(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getOrganization(organizationId: string, cancelToken?: CancelToken): Promise<ResponseOfOrganizationDetails> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganization(_response);
        });
    }

    protected processGetOrganization(response: AxiosResponse): Promise<ResponseOfOrganizationDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfOrganizationDetails.fromJS(resultData200);
            return Promise.resolve<ResponseOfOrganizationDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfOrganizationDetails>(null as any);
    }

    isDescendantOrganization(organizationId: string, cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/is-descendant";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsDescendantOrganization(_response);
        });
    }

    protected processIsDescendantOrganization(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    syncOrganizations( cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organizations/sync-organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncOrganizations(_response);
        });
    }

    protected processSyncOrganizations(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveOrganizationApplicationDomain(saveRequest: OrganizationApplicationDomainSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/organizations/applications-domains/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOrganizationApplicationDomain(_response);
        });
    }

    protected processSaveOrganizationApplicationDomain(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getOrganizationApplicationDomains(request: ListRequestOfDomainFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationApplicationDomain> {
        let url_ = this.baseUrl + "/api/organizations/application-domains/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationApplicationDomains(_response);
        });
    }

    protected processGetOrganizationApplicationDomains(response: AxiosResponse): Promise<ListResponseOfOrganizationApplicationDomain> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationApplicationDomain.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationApplicationDomain>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationApplicationDomain>(null as any);
    }

    getOrganizationTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/organizations/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationTypes(_response);
        });
    }

    protected processGetOrganizationTypes(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getOrganizationStatuses(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/organizations/statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationStatuses(_response);
        });
    }

    protected processGetOrganizationStatuses(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    deleteOrganizationApplicationDomain(organizationApplicationDomainId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organizations/applications/{organizationApplicationDomainId}";
        if (organizationApplicationDomainId === undefined || organizationApplicationDomainId === null)
            throw new globalThis.Error("The parameter 'organizationApplicationDomainId' must be defined.");
        url_ = url_.replace("{organizationApplicationDomainId}", encodeURIComponent("" + organizationApplicationDomainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganizationApplicationDomain(_response);
        });
    }

    protected processDeleteOrganizationApplicationDomain(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getOrganizationExternalReferences(request: ListRequestOfOrganizationExternalReferenceAdminFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationExternalReferenceModel> {
        let url_ = this.baseUrl + "/api/organizations/external-references/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationExternalReferences(_response);
        });
    }

    protected processGetOrganizationExternalReferences(response: AxiosResponse): Promise<ListResponseOfOrganizationExternalReferenceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationExternalReferenceModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationExternalReferenceModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationExternalReferenceModel>(null as any);
    }

    getOrganizationExternalReferencePartnerNames( cancelToken?: CancelToken): Promise<ListResponseOfString> {
        let url_ = this.baseUrl + "/api/organizations/external-references/partner-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationExternalReferencePartnerNames(_response);
        });
    }

    protected processGetOrganizationExternalReferencePartnerNames(response: AxiosResponse): Promise<ListResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfString.fromJS(resultData200);
            return Promise.resolve<ListResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfString>(null as any);
    }

    saveOrganizationExternalReference(saveRequest: OrganizationExternalReferenceSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/organizations/external-references/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOrganizationExternalReference(_response);
        });
    }

    protected processSaveOrganizationExternalReference(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteOrganizationExternalReference(organizationId: string, organizationExternalReferenceId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organizations/external-references/{organizationId}/{organizationExternalReferenceId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (organizationExternalReferenceId === undefined || organizationExternalReferenceId === null)
            throw new globalThis.Error("The parameter 'organizationExternalReferenceId' must be defined.");
        url_ = url_.replace("{organizationExternalReferenceId}", encodeURIComponent("" + organizationExternalReferenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganizationExternalReference(_response);
        });
    }

    protected processDeleteOrganizationExternalReference(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getDefaultProgressionGates(request: DefaultProgressionGateRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuProgressionGate> {
        let url_ = this.baseUrl + "/api/organizations/progression-gates/default/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultProgressionGates(_response);
        });
    }

    protected processGetDefaultProgressionGates(response: AxiosResponse): Promise<ListResponseOfSkuProgressionGate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuProgressionGate.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuProgressionGate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuProgressionGate>(null as any);
    }

    saveDefaultProgressionGate(skuProgressionGateRequest: SkuProgressionGateRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/organizations/progression-gates/default";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuProgressionGateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDefaultProgressionGate(_response);
        });
    }

    protected processSaveDefaultProgressionGate(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getOrganizationTree( cancelToken?: CancelToken): Promise<ResponseOfOrganizationTreeItem> {
        let url_ = this.baseUrl + "/api/organizations/tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationTree(_response);
        });
    }

    protected processGetOrganizationTree(response: AxiosResponse): Promise<ResponseOfOrganizationTreeItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfOrganizationTreeItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfOrganizationTreeItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfOrganizationTreeItem>(null as any);
    }

    switchOrganization(request: SwitchOrganizationRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfSwitchOrganizationResponse> {
        let url_ = this.baseUrl + "/api/organizations/switch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchOrganization(_response);
        });
    }

    protected processSwitchOrganization(response: AxiosResponse): Promise<ResponseOfSwitchOrganizationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSwitchOrganizationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfSwitchOrganizationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSwitchOrganizationResponse>(null as any);
    }
}

export class OrganizationUserService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrganizationUserDetails(organizationUserId: string, cancelToken?: CancelToken): Promise<OrganizationUserDetails> {
        let url_ = this.baseUrl + "/api/organization-users/{organizationUserId}";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationUserDetails(_response);
        });
    }

    protected processGetOrganizationUserDetails(response: AxiosResponse): Promise<OrganizationUserDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUserDetails.fromJS(resultData200);
            return Promise.resolve<OrganizationUserDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUserDetails>(null as any);
    }

    searchOrganizationUsers(request: AdminListRequestOfSearchOrganizationUsersFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationUserListItem> {
        let url_ = this.baseUrl + "/api/organization-users/by-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchOrganizationUsers(_response);
        });
    }

    protected processSearchOrganizationUsers(response: AxiosResponse): Promise<ListResponseOfOrganizationUserListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationUserListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationUserListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationUserListItem>(null as any);
    }
}

export class DataToolsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTools( cancelToken?: CancelToken): Promise<ListResponseOfDataToolDescriptor> {
        let url_ = this.baseUrl + "/api/data-tools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTools(_response);
        });
    }

    protected processGetTools(response: AxiosResponse): Promise<ListResponseOfDataToolDescriptor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfDataToolDescriptor.fromJS(resultData200);
            return Promise.resolve<ListResponseOfDataToolDescriptor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfDataToolDescriptor>(null as any);
    }

    getScriptTargets( cancelToken?: CancelToken): Promise<ListResponseOfString> {
        let url_ = this.baseUrl + "/api/data-tools/script-targets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScriptTargets(_response);
        });
    }

    protected processGetScriptTargets(response: AxiosResponse): Promise<ListResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfString.fromJS(resultData200);
            return Promise.resolve<ListResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfString>(null as any);
    }

    runTool(toolKey: string, request: RunToolRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfToolRunDto> {
        let url_ = this.baseUrl + "/api/data-tools/{toolKey}/run";
        if (toolKey === undefined || toolKey === null)
            throw new globalThis.Error("The parameter 'toolKey' must be defined.");
        url_ = url_.replace("{toolKey}", encodeURIComponent("" + toolKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRunTool(_response);
        });
    }

    protected processRunTool(response: AxiosResponse): Promise<ResponseOfToolRunDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfToolRunDto.fromJS(resultData200);
            return Promise.resolve<ResponseOfToolRunDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfToolRunDto>(null as any);
    }

    cancelRun(runId: string, cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/data-tools/runs/{runId}/cancel";
        if (runId === undefined || runId === null)
            throw new globalThis.Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelRun(_response);
        });
    }

    protected processCancelRun(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    getRuns(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfToolRunDto> {
        let url_ = this.baseUrl + "/api/data-tools/runs/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuns(_response);
        });
    }

    protected processGetRuns(response: AxiosResponse): Promise<ListResponseOfToolRunDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfToolRunDto.fromJS(resultData200);
            return Promise.resolve<ListResponseOfToolRunDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfToolRunDto>(null as any);
    }

    getRun(runId: string, cancelToken?: CancelToken): Promise<ResponseOfToolRunDto> {
        let url_ = this.baseUrl + "/api/data-tools/runs/{runId}";
        if (runId === undefined || runId === null)
            throw new globalThis.Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRun(_response);
        });
    }

    protected processGetRun(response: AxiosResponse): Promise<ResponseOfToolRunDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfToolRunDto.fromJS(resultData200);
            return Promise.resolve<ResponseOfToolRunDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfToolRunDto>(null as any);
    }

    getLogs(runId: string, request: ListRequestOfToolLogFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfToolLogDto> {
        let url_ = this.baseUrl + "/api/data-tools/runs/{runId}/logs";
        if (runId === undefined || runId === null)
            throw new globalThis.Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogs(_response);
        });
    }

    protected processGetLogs(response: AxiosResponse): Promise<ListResponseOfToolLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfToolLogDto.fromJS(resultData200);
            return Promise.resolve<ListResponseOfToolLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfToolLogDto>(null as any);
    }

    downloadLogs(runId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/data-tools/runs/{runId}/logs/download";
        if (runId === undefined || runId === null)
            throw new globalThis.Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadLogs(_response);
        });
    }

    protected processDownloadLogs(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DeveloperDashboardService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getBugs(year: number | undefined, month: number | undefined, categories: string[] | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfBugsDashboard> {
        let url_ = this.baseUrl + "/api/developer-dashboard/bugs?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (categories !== undefined && categories !== null)
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBugs(_response);
        });
    }

    protected processGetBugs(response: AxiosResponse): Promise<ResponseOfBugsDashboard> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBugsDashboard.fromJS(resultData200);
            return Promise.resolve<ResponseOfBugsDashboard>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBugsDashboard>(null as any);
    }

    getBugsTrend(year: number | undefined, month: number | undefined, compareMonths: string[] | null | undefined, categories: string[] | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfBugsTrend> {
        let url_ = this.baseUrl + "/api/developer-dashboard/bugs/trend?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (compareMonths !== undefined && compareMonths !== null)
            compareMonths && compareMonths.forEach(item => { url_ += "compareMonths=" + encodeURIComponent("" + item) + "&"; });
        if (categories !== undefined && categories !== null)
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBugsTrend(_response);
        });
    }

    protected processGetBugsTrend(response: AxiosResponse): Promise<ResponseOfBugsTrend> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBugsTrend.fromJS(resultData200);
            return Promise.resolve<ResponseOfBugsTrend>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBugsTrend>(null as any);
    }

    getAvailableMonths( cancelToken?: CancelToken): Promise<ResponseOfIReadOnlyListOfAvailableMonth> {
        let url_ = this.baseUrl + "/api/developer-dashboard/months";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableMonths(_response);
        });
    }

    protected processGetAvailableMonths(response: AxiosResponse): Promise<ResponseOfIReadOnlyListOfAvailableMonth> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfIReadOnlyListOfAvailableMonth.fromJS(resultData200);
            return Promise.resolve<ResponseOfIReadOnlyListOfAvailableMonth>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfIReadOnlyListOfAvailableMonth>(null as any);
    }

    getOpenPrs( cancelToken?: CancelToken): Promise<ResponseOfOpenPrs> {
        let url_ = this.baseUrl + "/api/developer-dashboard/pull-requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenPrs(_response);
        });
    }

    protected processGetOpenPrs(response: AxiosResponse): Promise<ResponseOfOpenPrs> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfOpenPrs.fromJS(resultData200);
            return Promise.resolve<ResponseOfOpenPrs>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfOpenPrs>(null as any);
    }

    getReviewerRanking(year: number | undefined, month: number | undefined, cancelToken?: CancelToken): Promise<ResponseOfReviewerRanking> {
        let url_ = this.baseUrl + "/api/developer-dashboard/reviewer-ranking?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReviewerRanking(_response);
        });
    }

    protected processGetReviewerRanking(response: AxiosResponse): Promise<ResponseOfReviewerRanking> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfReviewerRanking.fromJS(resultData200);
            return Promise.resolve<ResponseOfReviewerRanking>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfReviewerRanking>(null as any);
    }

    refresh( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/developer-dashboard/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class E2eRegressionTestsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getResults( cancelToken?: CancelToken): Promise<ResponseOfE2eRegressionTestResults> {
        let url_ = this.baseUrl + "/api/e2e-regression-tests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResults(_response);
        });
    }

    protected processGetResults(response: AxiosResponse): Promise<ResponseOfE2eRegressionTestResults> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfE2eRegressionTestResults.fromJS(resultData200);
            return Promise.resolve<ResponseOfE2eRegressionTestResults>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfE2eRegressionTestResults>(null as any);
    }
}

export class MicroservicesStatusService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMicroservicesStatus( cancelToken?: CancelToken): Promise<ListResponseOfMicroserviceStatus> {
        let url_ = this.baseUrl + "/api/microservices-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicroservicesStatus(_response);
        });
    }

    protected processGetMicroservicesStatus(response: AxiosResponse): Promise<ListResponseOfMicroserviceStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMicroserviceStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMicroserviceStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMicroserviceStatus>(null as any);
    }
}

export class RedisCacheService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    flushCache( cancelToken?: CancelToken): Promise<CacheFlushResult> {
        let url_ = this.baseUrl + "/api/redis-cache/flush";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlushCache(_response);
        });
    }

    protected processFlushCache(response: AxiosResponse): Promise<CacheFlushResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CacheFlushResult.fromJS(resultData200);
            return Promise.resolve<CacheFlushResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CacheFlushResult>(null as any);
    }
}

export class WebhooksService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getNotifications(request: ListRequestOfWebhookFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfWebhookNotificationViewModel> {
        let url_ = this.baseUrl + "/api/webhooks/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: AxiosResponse): Promise<ListResponseOfWebhookNotificationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfWebhookNotificationViewModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfWebhookNotificationViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfWebhookNotificationViewModel>(null as any);
    }

    repostNotifications(request: WebhookRepostApiRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfListOfWebhookRepostResult> {
        let url_ = this.baseUrl + "/api/webhooks/repost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRepostNotifications(_response);
        });
    }

    protected processRepostNotifications(response: AxiosResponse): Promise<ResponseOfListOfWebhookRepostResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfListOfWebhookRepostResult.fromJS(resultData200);
            return Promise.resolve<ResponseOfListOfWebhookRepostResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfListOfWebhookRepostResult>(null as any);
    }
}

export class EmailService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    resendEmail(request: EmailResendRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfEmail> {
        let url_ = this.baseUrl + "/api/notifications/emails/resend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendEmail(_response);
        });
    }

    protected processResendEmail(response: AxiosResponse): Promise<ListResponseOfEmail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEmail.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEmail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEmail>(null as any);
    }

    getEmails(request: ListRequestOfEmailFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfEmailPreview> {
        let url_ = this.baseUrl + "/api/notifications/emails/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmails(_response);
        });
    }

    protected processGetEmails(response: AxiosResponse): Promise<ListResponseOfEmailPreview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEmailPreview.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEmailPreview>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEmailPreview>(null as any);
    }

    getEmail(emailId: string, cancelToken?: CancelToken): Promise<Email> {
        let url_ = this.baseUrl + "/api/notifications/emails/{emailId}";
        if (emailId === undefined || emailId === null)
            throw new globalThis.Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmail(_response);
        });
    }

    protected processGetEmail(response: AxiosResponse): Promise<Email> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Email.fromJS(resultData200);
            return Promise.resolve<Email>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Email>(null as any);
    }

    getEmailTemplates(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfEmailTemplateModel> {
        let url_ = this.baseUrl + "/api/notifications/emails/templates/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTemplates(_response);
        });
    }

    protected processGetEmailTemplates(response: AxiosResponse): Promise<ListResponseOfEmailTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEmailTemplateModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEmailTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEmailTemplateModel>(null as any);
    }

    getUsedEmailTemplates( cancelToken?: CancelToken): Promise<ListResponseOfEmailTemplateModel> {
        let url_ = this.baseUrl + "/api/notifications/emails/templates/used";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsedEmailTemplates(_response);
        });
    }

    protected processGetUsedEmailTemplates(response: AxiosResponse): Promise<ListResponseOfEmailTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEmailTemplateModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEmailTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEmailTemplateModel>(null as any);
    }

    getEmailTemplate(emailTemplateId: string, cancelToken?: CancelToken): Promise<ResponseOfEmailTemplateModel> {
        let url_ = this.baseUrl + "/api/notifications/emails/templates/{emailTemplateId}";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new globalThis.Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTemplate(_response);
        });
    }

    protected processGetEmailTemplate(response: AxiosResponse): Promise<ResponseOfEmailTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfEmailTemplateModel.fromJS(resultData200);
            return Promise.resolve<ResponseOfEmailTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfEmailTemplateModel>(null as any);
    }

    deleteEmailTemplate(emailTemplateId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/notifications/emails/templates/{emailTemplateId}";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new globalThis.Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmailTemplate(_response);
        });
    }

    protected processDeleteEmailTemplate(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveEmailTemplate(request: EmailTemplateRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/notifications/emails/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmailTemplate(_response);
        });
    }

    protected processSaveEmailTemplate(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    cloneEmailTemplate(emailTemplateId: string, cancelToken?: CancelToken): Promise<ResponseOfEmailTemplateModel> {
        let url_ = this.baseUrl + "/api/notifications/emails/templates/{emailTemplateId}/clone";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new globalThis.Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneEmailTemplate(_response);
        });
    }

    protected processCloneEmailTemplate(response: AxiosResponse): Promise<ResponseOfEmailTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfEmailTemplateModel.fromJS(resultData200);
            return Promise.resolve<ResponseOfEmailTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfEmailTemplateModel>(null as any);
    }
}

export class NotificationsConfigurationsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getNotificationsConfigurations(request: ListRequestOfNotificationConfigurationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfNotificationConfigurationInfo> {
        let url_ = this.baseUrl + "/api/notifications-configuration/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationsConfigurations(_response);
        });
    }

    protected processGetNotificationsConfigurations(response: AxiosResponse): Promise<ListResponseOfNotificationConfigurationInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfNotificationConfigurationInfo.fromJS(resultData200);
            return Promise.resolve<ListResponseOfNotificationConfigurationInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfNotificationConfigurationInfo>(null as any);
    }

    getNotificationConfiguration(notificationJobRoutingId: string, cancelToken?: CancelToken): Promise<ResponseOfNotificationConfigurationModel> {
        let url_ = this.baseUrl + "/api/notifications-configuration/{notificationJobRoutingId}";
        if (notificationJobRoutingId === undefined || notificationJobRoutingId === null)
            throw new globalThis.Error("The parameter 'notificationJobRoutingId' must be defined.");
        url_ = url_.replace("{notificationJobRoutingId}", encodeURIComponent("" + notificationJobRoutingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationConfiguration(_response);
        });
    }

    protected processGetNotificationConfiguration(response: AxiosResponse): Promise<ResponseOfNotificationConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfNotificationConfigurationModel.fromJS(resultData200);
            return Promise.resolve<ResponseOfNotificationConfigurationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfNotificationConfigurationModel>(null as any);
    }

    deleteNotificationConfiguration(notificationJobRoutingId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/notifications-configuration/{notificationJobRoutingId}";
        if (notificationJobRoutingId === undefined || notificationJobRoutingId === null)
            throw new globalThis.Error("The parameter 'notificationJobRoutingId' must be defined.");
        url_ = url_.replace("{notificationJobRoutingId}", encodeURIComponent("" + notificationJobRoutingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNotificationConfiguration(_response);
        });
    }

    protected processDeleteNotificationConfiguration(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveNotificationConfiguration(request: NotificationConfigurationRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/notifications-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveNotificationConfiguration(_response);
        });
    }

    protected processSaveNotificationConfiguration(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getNotificationJobEvents( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/notifications-configuration/job-events";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationJobEvents(_response);
        });
    }

    protected processGetNotificationJobEvents(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getNotificationRoutingTypes( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/notifications-configuration/routing-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationRoutingTypes(_response);
        });
    }

    protected processGetNotificationRoutingTypes(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getNotificationConfigurationStatuses( cancelToken?: CancelToken): Promise<ListResponseOfNotificationConfigurationStatus> {
        let url_ = this.baseUrl + "/api/notifications-configuration/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationConfigurationStatuses(_response);
        });
    }

    protected processGetNotificationConfigurationStatuses(response: AxiosResponse): Promise<ListResponseOfNotificationConfigurationStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfNotificationConfigurationStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfNotificationConfigurationStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfNotificationConfigurationStatus>(null as any);
    }

    getDisplayModes( cancelToken?: CancelToken): Promise<ListResponseOfDisplayMode> {
        let url_ = this.baseUrl + "/api/notifications-configuration/display-modes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDisplayModes(_response);
        });
    }

    protected processGetDisplayModes(response: AxiosResponse): Promise<ListResponseOfDisplayMode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfDisplayMode.fromJS(resultData200);
            return Promise.resolve<ListResponseOfDisplayMode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfDisplayMode>(null as any);
    }

    getFrequencyTypes( cancelToken?: CancelToken): Promise<ListResponseOfFrequencyType> {
        let url_ = this.baseUrl + "/api/notifications-configuration/frequency-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFrequencyTypes(_response);
        });
    }

    protected processGetFrequencyTypes(response: AxiosResponse): Promise<ListResponseOfFrequencyType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfFrequencyType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfFrequencyType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfFrequencyType>(null as any);
    }

    getDismissalTypes( cancelToken?: CancelToken): Promise<ListResponseOfDismissalType> {
        let url_ = this.baseUrl + "/api/notifications-configuration/dismissal-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDismissalTypes(_response);
        });
    }

    protected processGetDismissalTypes(response: AxiosResponse): Promise<ListResponseOfDismissalType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfDismissalType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfDismissalType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfDismissalType>(null as any);
    }

    getIntervalTypes( cancelToken?: CancelToken): Promise<ListResponseOfIntervalType> {
        let url_ = this.baseUrl + "/api/notifications-configuration/interval-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntervalTypes(_response);
        });
    }

    protected processGetIntervalTypes(response: AxiosResponse): Promise<ListResponseOfIntervalType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIntervalType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIntervalType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIntervalType>(null as any);
    }
}

export class LoggingService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAuditLog(request: ListRequestOfAuditLogRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAuditLogEntry> {
        let url_ = this.baseUrl + "/api/logging/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLog(_response);
        });
    }

    protected processGetAuditLog(response: AxiosResponse): Promise<ListResponseOfAuditLogEntry> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAuditLogEntry.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAuditLogEntry>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAuditLogEntry>(null as any);
    }

    getUserAuditLog(request: ListRequestOfAuditLogRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAuditLogEntry> {
        let url_ = this.baseUrl + "/api/logging/user-audit-logs/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAuditLog(_response);
        });
    }

    protected processGetUserAuditLog(response: AxiosResponse): Promise<ListResponseOfAuditLogEntry> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAuditLogEntry.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAuditLogEntry>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAuditLogEntry>(null as any);
    }

    getLatestProcessAuditLogs(request: ListRequestOfProcessAuditLogFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProcessAuditLog> {
        let url_ = this.baseUrl + "/api/logging/process-audit-logs/latest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestProcessAuditLogs(_response);
        });
    }

    protected processGetLatestProcessAuditLogs(response: AxiosResponse): Promise<ListResponseOfProcessAuditLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProcessAuditLog.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProcessAuditLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProcessAuditLog>(null as any);
    }
}

export class MigrationJobService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    entryCheck(request: EntryCheckRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfEntryCheckResponse> {
        let url_ = this.baseUrl + "/api/migration/job/entry-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEntryCheck(_response);
        });
    }

    protected processEntryCheck(response: AxiosResponse): Promise<ResponseOfEntryCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfEntryCheckResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfEntryCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfEntryCheckResponse>(null as any);
    }

    entriesCheck(request: EntryCheckRequest[] | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfListOfEntryCheckResponse> {
        let url_ = this.baseUrl + "/api/migration/job/entries-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEntriesCheck(_response);
        });
    }

    protected processEntriesCheck(response: AxiosResponse): Promise<ResponseOfListOfEntryCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfListOfEntryCheckResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfListOfEntryCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfListOfEntryCheckResponse>(null as any);
    }

    getImportJobSummaries(request: AdminListRequestOfJobSummaryFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfImportJobSummary> {
        let url_ = this.baseUrl + "/api/migration/job/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportJobSummaries(_response);
        });
    }

    protected processGetImportJobSummaries(response: AxiosResponse): Promise<ListResponseOfImportJobSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfImportJobSummary.fromJS(resultData200);
            return Promise.resolve<ListResponseOfImportJobSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfImportJobSummary>(null as any);
    }

    getImportJobSummary(jobId: string, cancelToken?: CancelToken): Promise<ResponseOfImportJobSummary> {
        let url_ = this.baseUrl + "/api/migration/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportJobSummary(_response);
        });
    }

    protected processGetImportJobSummary(response: AxiosResponse): Promise<ResponseOfImportJobSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfImportJobSummary.fromJS(resultData200);
            return Promise.resolve<ResponseOfImportJobSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfImportJobSummary>(null as any);
    }

    createFileJob(request: CreateFileJobRequestExtended | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/migration/job";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFileJob(_response);
        });
    }

    protected processCreateFileJob(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getFileProcessingSnapshot(jobId: string, cancelToken?: CancelToken): Promise<ResponseOfFileProcessingSnapshot> {
        let url_ = this.baseUrl + "/api/migration/job/{jobId}/snapshot";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileProcessingSnapshot(_response);
        });
    }

    protected processGetFileProcessingSnapshot(response: AxiosResponse): Promise<ResponseOfFileProcessingSnapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfFileProcessingSnapshot.fromJS(resultData200);
            return Promise.resolve<ResponseOfFileProcessingSnapshot>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfFileProcessingSnapshot>(null as any);
    }

    getJobStatuses(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfImportJobStatus> {
        let url_ = this.baseUrl + "/api/migration/job/statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobStatuses(_response);
        });
    }

    protected processGetJobStatuses(response: AxiosResponse): Promise<ListResponseOfImportJobStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfImportJobStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfImportJobStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfImportJobStatus>(null as any);
    }

    getImportSourceTypes( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/migration/job/source-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportSourceTypes(_response);
        });
    }

    protected processGetImportSourceTypes(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    cancelJob(jobId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/migration/job/{jobId}/cancel";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelJob(_response);
        });
    }

    protected processCancelJob(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    importJobData(importJobId: string, importDataRequest: FileDataRequest | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/migration/job/data/{importJobId}/import";
        if (importJobId === undefined || importJobId === null)
            throw new globalThis.Error("The parameter 'importJobId' must be defined.");
        url_ = url_.replace("{importJobId}", encodeURIComponent("" + importJobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportJobData(_response);
        });
    }

    protected processImportJobData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getJobDataStatuses(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfImportJobDataStatus> {
        let url_ = this.baseUrl + "/api/migration/job/data/statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobDataStatuses(_response);
        });
    }

    protected processGetJobDataStatuses(response: AxiosResponse): Promise<ListResponseOfImportJobDataStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfImportJobDataStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfImportJobDataStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfImportJobDataStatus>(null as any);
    }

    getJobDataSummaries(jobId: string, request: ListRequestOfJobDataSummaryFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfJobDataSummary> {
        let url_ = this.baseUrl + "/api/migration/job/data/{jobId}/summary";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobDataSummaries(_response);
        });
    }

    protected processGetJobDataSummaries(response: AxiosResponse): Promise<ListResponseOfJobDataSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfJobDataSummary.fromJS(resultData200);
            return Promise.resolve<ListResponseOfJobDataSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfJobDataSummary>(null as any);
    }

    getImportJobGraph(jobId: string, cancelToken?: CancelToken): Promise<ResponseOfImportJobGraph> {
        let url_ = this.baseUrl + "/api/migration/job/data/{jobId}/graph";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportJobGraph(_response);
        });
    }

    protected processGetImportJobGraph(response: AxiosResponse): Promise<ResponseOfImportJobGraph> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfImportJobGraph.fromJS(resultData200);
            return Promise.resolve<ResponseOfImportJobGraph>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfImportJobGraph>(null as any);
    }

    cancelJobData(jobDataId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/migration/job/data/{jobDataId}/cancel";
        if (jobDataId === undefined || jobDataId === null)
            throw new globalThis.Error("The parameter 'jobDataId' must be defined.");
        url_ = url_.replace("{jobDataId}", encodeURIComponent("" + jobDataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelJobData(_response);
        });
    }

    protected processCancelJobData(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getImportJobTypes(request: ListRequestOfJobTypeFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfImportJobType> {
        let url_ = this.baseUrl + "/api/migration/job/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportJobTypes(_response);
        });
    }

    protected processGetImportJobTypes(response: AxiosResponse): Promise<ListResponseOfImportJobType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfImportJobType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfImportJobType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfImportJobType>(null as any);
    }

    getImportJobTypeFields(importJobTypeId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfImportJobTypeField> {
        let url_ = this.baseUrl + "/api/migration/job/types/{importJobTypeId}/fields";
        if (importJobTypeId === undefined || importJobTypeId === null)
            throw new globalThis.Error("The parameter 'importJobTypeId' must be defined.");
        url_ = url_.replace("{importJobTypeId}", encodeURIComponent("" + importJobTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportJobTypeFields(_response);
        });
    }

    protected processGetImportJobTypeFields(response: AxiosResponse): Promise<ListResponseOfImportJobTypeField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfImportJobTypeField.fromJS(resultData200);
            return Promise.resolve<ListResponseOfImportJobTypeField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfImportJobTypeField>(null as any);
    }
}

export class QuestionService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getQuestions(request: AdminListRequestOfQuestionFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQuestion> {
        let url_ = this.baseUrl + "/api/questions/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestions(_response);
        });
    }

    protected processGetQuestions(response: AxiosResponse): Promise<ListResponseOfQuestion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQuestion.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQuestion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQuestion>(null as any);
    }

    getQuestionTypes(request: AdminListRequestOfQuestionTypeFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQuestionType> {
        let url_ = this.baseUrl + "/api/questions/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionTypes(_response);
        });
    }

    protected processGetQuestionTypes(response: AxiosResponse): Promise<ListResponseOfQuestionType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQuestionType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQuestionType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQuestionType>(null as any);
    }

    getQuestionById(questionId: string, cancelToken?: CancelToken): Promise<ResponseOfQuestion> {
        let url_ = this.baseUrl + "/api/questions/{questionId}";
        if (questionId === undefined || questionId === null)
            throw new globalThis.Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionById(_response);
        });
    }

    protected processGetQuestionById(response: AxiosResponse): Promise<ResponseOfQuestion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfQuestion.fromJS(resultData200);
            return Promise.resolve<ResponseOfQuestion>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfQuestion>(null as any);
    }

    disableQuestion(questionId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/questions/{questionId}";
        if (questionId === undefined || questionId === null)
            throw new globalThis.Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableQuestion(_response);
        });
    }

    protected processDisableQuestion(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    isQuestionEditable(questionId: string, cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/questions/{questionId}/isEditable";
        if (questionId === undefined || questionId === null)
            throw new globalThis.Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsQuestionEditable(_response);
        });
    }

    protected processIsQuestionEditable(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    saveQuestion(question: SaveQuestion | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(question);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveQuestion(_response);
        });
    }

    protected processSaveQuestion(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    importQuestions(questions: SaveQuestion[] | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfGuid> {
        let url_ = this.baseUrl + "/api/questions/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportQuestions(_response);
        });
    }

    protected processImportQuestions(response: AxiosResponse): Promise<ListResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfGuid.fromJS(resultData200);
            return Promise.resolve<ListResponseOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfGuid>(null as any);
    }

    getRatingSettings(request: AdminListRequestOfRatingSettingFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRatingSetting> {
        let url_ = this.baseUrl + "/api/questions/ratingSettings/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRatingSettings(_response);
        });
    }

    protected processGetRatingSettings(response: AxiosResponse): Promise<ListResponseOfRatingSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRatingSetting.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRatingSetting>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRatingSetting>(null as any);
    }

    saveRatingSetting(request: RatingSetting | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfRatingSetting> {
        let url_ = this.baseUrl + "/api/questions/ratingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRatingSetting(_response);
        });
    }

    protected processSaveRatingSetting(response: AxiosResponse): Promise<ResponseOfRatingSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRatingSetting.fromJS(resultData200);
            return Promise.resolve<ResponseOfRatingSetting>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRatingSetting>(null as any);
    }
}

export class EvaluationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEvaluations(request: AdminListRequestOfEvaluationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfEvaluation> {
        let url_ = this.baseUrl + "/api/evaluations/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvaluations(_response);
        });
    }

    protected processGetEvaluations(response: AxiosResponse): Promise<ListResponseOfEvaluation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEvaluation.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEvaluation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEvaluation>(null as any);
    }

    getEvaluationById(evaluationId: string, cancelToken?: CancelToken): Promise<ResponseOfEvaluation> {
        let url_ = this.baseUrl + "/api/evaluations/{evaluationId}";
        if (evaluationId === undefined || evaluationId === null)
            throw new globalThis.Error("The parameter 'evaluationId' must be defined.");
        url_ = url_.replace("{evaluationId}", encodeURIComponent("" + evaluationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvaluationById(_response);
        });
    }

    protected processGetEvaluationById(response: AxiosResponse): Promise<ResponseOfEvaluation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfEvaluation.fromJS(resultData200);
            return Promise.resolve<ResponseOfEvaluation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfEvaluation>(null as any);
    }

    disableEvaluation(evaluationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/evaluations/{evaluationId}";
        if (evaluationId === undefined || evaluationId === null)
            throw new globalThis.Error("The parameter 'evaluationId' must be defined.");
        url_ = url_.replace("{evaluationId}", encodeURIComponent("" + evaluationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableEvaluation(_response);
        });
    }

    protected processDisableEvaluation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveEvaluation(evaluation: SaveEvaluationRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/evaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evaluation);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEvaluation(_response);
        });
    }

    protected processSaveEvaluation(response: AxiosResponse): Promise<ResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfIdNameModel>(null as any);
    }

    cloneEvaluation(evaluationId: string, cancelToken?: CancelToken): Promise<ResponseOfEvaluation> {
        let url_ = this.baseUrl + "/api/evaluations/{evaluationId}/clone";
        if (evaluationId === undefined || evaluationId === null)
            throw new globalThis.Error("The parameter 'evaluationId' must be defined.");
        url_ = url_.replace("{evaluationId}", encodeURIComponent("" + evaluationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneEvaluation(_response);
        });
    }

    protected processCloneEvaluation(response: AxiosResponse): Promise<ResponseOfEvaluation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfEvaluation.fromJS(resultData200);
            return Promise.resolve<ResponseOfEvaluation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfEvaluation>(null as any);
    }

    updateEvaluationCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/evaluations/updateEvaluationCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEvaluationCache(_response);
        });
    }

    protected processUpdateEvaluationCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    importQuestions(file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfListOfQuestion> {
        let url_ = this.baseUrl + "/api/evaluations/import-questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportQuestions(_response);
        });
    }

    protected processImportQuestions(response: AxiosResponse): Promise<ResponseOfListOfQuestion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfListOfQuestion.fromJS(resultData200);
            return Promise.resolve<ResponseOfListOfQuestion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfListOfQuestion>(null as any);
    }

    getEvaluationTypes(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfEvaluationType> {
        let url_ = this.baseUrl + "/api/evaluations/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvaluationTypes(_response);
        });
    }

    protected processGetEvaluationTypes(response: AxiosResponse): Promise<ListResponseOfEvaluationType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEvaluationType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEvaluationType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEvaluationType>(null as any);
    }

    getEvaluationTypeById(evaluationTypeId: string, cancelToken?: CancelToken): Promise<ResponseOfEvaluationType> {
        let url_ = this.baseUrl + "/api/evaluations/types/{evaluationTypeId}";
        if (evaluationTypeId === undefined || evaluationTypeId === null)
            throw new globalThis.Error("The parameter 'evaluationTypeId' must be defined.");
        url_ = url_.replace("{evaluationTypeId}", encodeURIComponent("" + evaluationTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvaluationTypeById(_response);
        });
    }

    protected processGetEvaluationTypeById(response: AxiosResponse): Promise<ResponseOfEvaluationType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfEvaluationType.fromJS(resultData200);
            return Promise.resolve<ResponseOfEvaluationType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfEvaluationType>(null as any);
    }

    getSkuEvaluations(skuId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuEvaluation> {
        let url_ = this.baseUrl + "/api/evaluations/sku-evaluations/{skuId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuEvaluations(_response);
        });
    }

    protected processGetSkuEvaluations(response: AxiosResponse): Promise<ListResponseOfSkuEvaluation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuEvaluation.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuEvaluation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuEvaluation>(null as any);
    }
}

export class UserEvaluationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getManualGradingExams(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfManualGradingUserExam> {
        let url_ = this.baseUrl + "/api/user-evaluations/exams/manual-grading/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManualGradingExams(_response);
        });
    }

    protected processGetManualGradingExams(response: AxiosResponse): Promise<ListResponseOfManualGradingUserExam> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfManualGradingUserExam.fromJS(resultData200);
            return Promise.resolve<ListResponseOfManualGradingUserExam>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfManualGradingUserExam>(null as any);
    }

    getManualGradingExamDetails(userExamId: string, cancelToken?: CancelToken): Promise<ResponseOfManualGradingUserExamDetails> {
        let url_ = this.baseUrl + "/api/user-evaluations/exams/manual-grading/{userExamId}";
        if (userExamId === undefined || userExamId === null)
            throw new globalThis.Error("The parameter 'userExamId' must be defined.");
        url_ = url_.replace("{userExamId}", encodeURIComponent("" + userExamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManualGradingExamDetails(_response);
        });
    }

    protected processGetManualGradingExamDetails(response: AxiosResponse): Promise<ResponseOfManualGradingUserExamDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfManualGradingUserExamDetails.fromJS(resultData200);
            return Promise.resolve<ResponseOfManualGradingUserExamDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfManualGradingUserExamDetails>(null as any);
    }

    submitManualGradingExam(userExamId: string, request: SubmitManualGradingExamRequest | null | undefined, cancelToken?: CancelToken): Promise<SubmitExamResponse> {
        let url_ = this.baseUrl + "/api/user-evaluations/exams/manual-grading/{userExamId}";
        if (userExamId === undefined || userExamId === null)
            throw new globalThis.Error("The parameter 'userExamId' must be defined.");
        url_ = url_.replace("{userExamId}", encodeURIComponent("" + userExamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitManualGradingExam(_response);
        });
    }

    protected processSubmitManualGradingExam(response: AxiosResponse): Promise<SubmitExamResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitExamResponse.fromJS(resultData200);
            return Promise.resolve<SubmitExamResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitExamResponse>(null as any);
    }

    getExamAttempts(request: ListRequestOfExamAttemptFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfExamAttempt> {
        let url_ = this.baseUrl + "/api/user-evaluations/exams/attempts/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamAttempts(_response);
        });
    }

    protected processGetExamAttempts(response: AxiosResponse): Promise<ListResponseOfExamAttempt> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfExamAttempt.fromJS(resultData200);
            return Promise.resolve<ListResponseOfExamAttempt>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfExamAttempt>(null as any);
    }

    getExamAttemptDetails(examAttemptId: string, cancelToken?: CancelToken): Promise<ResponseOfExamAttemptDetails> {
        let url_ = this.baseUrl + "/api/user-evaluations/exams/attempts/{examAttemptId}";
        if (examAttemptId === undefined || examAttemptId === null)
            throw new globalThis.Error("The parameter 'examAttemptId' must be defined.");
        url_ = url_.replace("{examAttemptId}", encodeURIComponent("" + examAttemptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamAttemptDetails(_response);
        });
    }

    protected processGetExamAttemptDetails(response: AxiosResponse): Promise<ResponseOfExamAttemptDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfExamAttemptDetails.fromJS(resultData200);
            return Promise.resolve<ResponseOfExamAttemptDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfExamAttemptDetails>(null as any);
    }

    getActiveExamForSku(request: ActiveExamRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfExam> {
        let url_ = this.baseUrl + "/api/user-evaluations/exams/active";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveExamForSku(_response);
        });
    }

    protected processGetActiveExamForSku(response: AxiosResponse): Promise<ResponseOfExam> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfExam.fromJS(resultData200);
            return Promise.resolve<ResponseOfExam>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfExam>(null as any);
    }

    invalidateExamAttempt(request: InvalidateExamAttemptRequest | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/user-evaluations/exams/attempts/invalidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateExamAttempt(_response);
        });
    }

    protected processInvalidateExamAttempt(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProductDeliverableService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProductDeliverables(productId: string, request: ListRequestOfProductDeliverableFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProductDeliverableInfo> {
        let url_ = this.baseUrl + "/api/product-deliverables/{productId}/all";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDeliverables(_response);
        });
    }

    protected processGetProductDeliverables(response: AxiosResponse): Promise<ListResponseOfProductDeliverableInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProductDeliverableInfo.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProductDeliverableInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProductDeliverableInfo>(null as any);
    }

    saveProductDeliverable(request: SaveProductDeliverableRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/product-deliverables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProductDeliverable(_response);
        });
    }

    protected processSaveProductDeliverable(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteProductDeliverable(productDeliverableId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/product-deliverables/{productDeliverableId}";
        if (productDeliverableId === undefined || productDeliverableId === null)
            throw new globalThis.Error("The parameter 'productDeliverableId' must be defined.");
        url_ = url_.replace("{productDeliverableId}", encodeURIComponent("" + productDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProductDeliverable(_response);
        });
    }

    protected processDeleteProductDeliverable(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    updateProductDeliverableSequence(productId: string, sequences: { [key: string]: number; } | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/product-deliverables/{productId}/sequences";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sequences);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductDeliverableSequence(_response);
        });
    }

    protected processUpdateProductDeliverableSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class SkuDeliverableService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSkuDeliverables(skuId: string, request: ListRequestOfSkuDeliverableFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuDeliverableInfo> {
        let url_ = this.baseUrl + "/api/sku-deliverables/{skuId}/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuDeliverables(_response);
        });
    }

    protected processGetSkuDeliverables(response: AxiosResponse): Promise<ListResponseOfSkuDeliverableInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuDeliverableInfo.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuDeliverableInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuDeliverableInfo>(null as any);
    }

    saveSkuDeliverable(request: SaveSkuDeliverableRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/sku-deliverables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuDeliverable(_response);
        });
    }

    protected processSaveSkuDeliverable(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuDeliverable(skuDeliverableId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/sku-deliverables/{skuDeliverableId}";
        if (skuDeliverableId === undefined || skuDeliverableId === null)
            throw new globalThis.Error("The parameter 'skuDeliverableId' must be defined.");
        url_ = url_.replace("{skuDeliverableId}", encodeURIComponent("" + skuDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuDeliverable(_response);
        });
    }

    protected processDeleteSkuDeliverable(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    updateSkuDeliverableSequence(skuId: string, sequences: { [key: string]: number; } | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/sku-deliverables/{skuId}/sequences";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sequences);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSkuDeliverableSequence(_response);
        });
    }

    protected processUpdateSkuDeliverableSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    accessSkuDeliverable(skuDeliverableId: string, cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/api/sku-deliverables/{skuDeliverableId}/access";
        if (skuDeliverableId === undefined || skuDeliverableId === null)
            throw new globalThis.Error("The parameter 'skuDeliverableId' must be defined.");
        url_ = url_.replace("{skuDeliverableId}", encodeURIComponent("" + skuDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccessSkuDeliverable(_response);
        });
    }

    protected processAccessSkuDeliverable(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }
}

export class ContentService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getContents(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfBaseContentItem> {
        let url_ = this.baseUrl + "/api/contents/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContents(_response);
        });
    }

    protected processGetContents(response: AxiosResponse): Promise<ListResponseOfBaseContentItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfBaseContentItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfBaseContentItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfBaseContentItem>(null as any);
    }

    getContentBlocks(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAdminContentItem> {
        let url_ = this.baseUrl + "/api/contents/content-blocks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentBlocks(_response);
        });
    }

    protected processGetContentBlocks(response: AxiosResponse): Promise<ListResponseOfAdminContentItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAdminContentItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAdminContentItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAdminContentItem>(null as any);
    }

    getContentById(id: string, cancelToken?: CancelToken): Promise<ResponseOfAdminContentItem> {
        let url_ = this.baseUrl + "/api/contents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentById(_response);
        });
    }

    protected processGetContentById(response: AxiosResponse): Promise<ResponseOfAdminContentItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAdminContentItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfAdminContentItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAdminContentItem>(null as any);
    }

    deleteContent(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/contents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContent(_response);
        });
    }

    protected processDeleteContent(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getContentByName(name: string, cancelToken?: CancelToken): Promise<ResponseOfAdminContentItem> {
        let url_ = this.baseUrl + "/api/contents/by-name/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentByName(_response);
        });
    }

    protected processGetContentByName(response: AxiosResponse): Promise<ResponseOfAdminContentItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAdminContentItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfAdminContentItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAdminContentItem>(null as any);
    }

    saveContentItem(content: SaveContentRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/contents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(content);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveContentItem(_response);
        });
    }

    protected processSaveContentItem(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getDescendantContentBlocks(request: AdminListRequestOfDescendantContentBlockFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfDescendantContentBlock> {
        let url_ = this.baseUrl + "/api/contents/descendant-content-blocks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDescendantContentBlocks(_response);
        });
    }

    protected processGetDescendantContentBlocks(response: AxiosResponse): Promise<ListResponseOfDescendantContentBlock> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfDescendantContentBlock.fromJS(resultData200);
            return Promise.resolve<ListResponseOfDescendantContentBlock>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfDescendantContentBlock>(null as any);
    }

    generateSvg(request: QrCodeRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/api/contents/qr-code/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSvg(_response);
        });
    }

    protected processGenerateSvg(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }
}

export class MenuService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMenuById(menuId: string, cancelToken?: CancelToken): Promise<ResponseOfMenu> {
        let url_ = this.baseUrl + "/api/menus/{menuId}";
        if (menuId === undefined || menuId === null)
            throw new globalThis.Error("The parameter 'menuId' must be defined.");
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuById(_response);
        });
    }

    protected processGetMenuById(response: AxiosResponse): Promise<ResponseOfMenu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfMenu.fromJS(resultData200);
            return Promise.resolve<ResponseOfMenu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfMenu>(null as any);
    }

    deleteMenu(menuId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/menus/{menuId}";
        if (menuId === undefined || menuId === null)
            throw new globalThis.Error("The parameter 'menuId' must be defined.");
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMenu(_response);
        });
    }

    protected processDeleteMenu(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getMenuUsage(menuId: string, cancelToken?: CancelToken): Promise<ResponseOfMenuUsage> {
        let url_ = this.baseUrl + "/api/menus/{menuId}/usage";
        if (menuId === undefined || menuId === null)
            throw new globalThis.Error("The parameter 'menuId' must be defined.");
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuUsage(_response);
        });
    }

    protected processGetMenuUsage(response: AxiosResponse): Promise<ResponseOfMenuUsage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfMenuUsage.fromJS(resultData200);
            return Promise.resolve<ResponseOfMenuUsage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfMenuUsage>(null as any);
    }

    getMenuTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAdminMenuType> {
        let url_ = this.baseUrl + "/api/menus/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuTypes(_response);
        });
    }

    protected processGetMenuTypes(response: AxiosResponse): Promise<ListResponseOfAdminMenuType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAdminMenuType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAdminMenuType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAdminMenuType>(null as any);
    }

    saveMenu(request: MenuRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/menus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMenu(_response);
        });
    }

    protected processSaveMenu(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getMenus(request: ListRequestOfMenuFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfMenu> {
        let url_ = this.baseUrl + "/api/menus/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenus(_response);
        });
    }

    protected processGetMenus(response: AxiosResponse): Promise<ListResponseOfMenu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMenu.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMenu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMenu>(null as any);
    }

    getAvailableMenus(request: AvailableMenuListRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfMenu> {
        let url_ = this.baseUrl + "/api/menus/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableMenus(_response);
        });
    }

    protected processGetAvailableMenus(response: AxiosResponse): Promise<ListResponseOfMenu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMenu.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMenu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMenu>(null as any);
    }

    getMenuItemById(menuItemId: string, cancelToken?: CancelToken): Promise<ResponseOfMenuItem> {
        let url_ = this.baseUrl + "/api/menus/menu-items/{menuItemId}";
        if (menuItemId === undefined || menuItemId === null)
            throw new globalThis.Error("The parameter 'menuItemId' must be defined.");
        url_ = url_.replace("{menuItemId}", encodeURIComponent("" + menuItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuItemById(_response);
        });
    }

    protected processGetMenuItemById(response: AxiosResponse): Promise<ResponseOfMenuItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfMenuItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfMenuItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfMenuItem>(null as any);
    }

    deleteMenuItem(menuItemId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/menus/menu-items/{menuItemId}";
        if (menuItemId === undefined || menuItemId === null)
            throw new globalThis.Error("The parameter 'menuItemId' must be defined.");
        url_ = url_.replace("{menuItemId}", encodeURIComponent("" + menuItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMenuItem(_response);
        });
    }

    protected processDeleteMenuItem(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveMenuItem(request: MenuItemRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/menus/menu-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMenuItem(_response);
        });
    }

    protected processSaveMenuItem(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getMenuItems(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfMenuItem> {
        let url_ = this.baseUrl + "/api/menus/menu-items/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuItems(_response);
        });
    }

    protected processGetMenuItems(response: AxiosResponse): Promise<ListResponseOfMenuItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMenuItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMenuItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMenuItem>(null as any);
    }

    getMenuItemTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/menus/menu-items/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuItemTypes(_response);
        });
    }

    protected processGetMenuItemTypes(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getMenuStructures(menuId: string, request: ListRequestOfMenuStructureFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfMenuStructure> {
        let url_ = this.baseUrl + "/api/admin/menus/{menuId}/structures/all";
        if (menuId === undefined || menuId === null)
            throw new globalThis.Error("The parameter 'menuId' must be defined.");
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuStructures(_response);
        });
    }

    protected processGetMenuStructures(response: AxiosResponse): Promise<ListResponseOfMenuStructure> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMenuStructure.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMenuStructure>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMenuStructure>(null as any);
    }

    getParentMenuStructureOptions(menuId: string, menuStructureId: string | null | undefined, request: ListRequestOfMenuStructureFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfMenuStructure> {
        let url_ = this.baseUrl + "/api/admin/menus/{menuId}/structures/parents?";
        if (menuId === undefined || menuId === null)
            throw new globalThis.Error("The parameter 'menuId' must be defined.");
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId));
        if (menuStructureId !== undefined && menuStructureId !== null)
            url_ += "menuStructureId=" + encodeURIComponent("" + menuStructureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParentMenuStructureOptions(_response);
        });
    }

    protected processGetParentMenuStructureOptions(response: AxiosResponse): Promise<ListResponseOfMenuStructure> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMenuStructure.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMenuStructure>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMenuStructure>(null as any);
    }

    getMenuStructureTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAdminMenuStructureType> {
        let url_ = this.baseUrl + "/api/admin/menus/structures/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuStructureTypes(_response);
        });
    }

    protected processGetMenuStructureTypes(response: AxiosResponse): Promise<ListResponseOfAdminMenuStructureType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAdminMenuStructureType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAdminMenuStructureType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAdminMenuStructureType>(null as any);
    }

    saveMenuStructure(menuId: string, request: MenuStructureRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/admin/menus/{menuId}/structures";
        if (menuId === undefined || menuId === null)
            throw new globalThis.Error("The parameter 'menuId' must be defined.");
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMenuStructure(_response);
        });
    }

    protected processSaveMenuStructure(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteMenuStructure(menuStructureId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/admin/menus/structures/{menuStructureId}";
        if (menuStructureId === undefined || menuStructureId === null)
            throw new globalThis.Error("The parameter 'menuStructureId' must be defined.");
        url_ = url_.replace("{menuStructureId}", encodeURIComponent("" + menuStructureId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMenuStructure(_response);
        });
    }

    protected processDeleteMenuStructure(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveMenuStructureSequence(menuId: string, request: MenuStructureSequenceRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/admin/menus/{menuId}/structures/update-sequence";
        if (menuId === undefined || menuId === null)
            throw new globalThis.Error("The parameter 'menuId' must be defined.");
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMenuStructureSequence(_response);
        });
    }

    protected processSaveMenuStructureSequence(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class OrganizationMenuService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrganizationMenus(organizationId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationMenu> {
        let url_ = this.baseUrl + "/api/organization-menus/{organizationId}/all";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationMenus(_response);
        });
    }

    protected processGetOrganizationMenus(response: AxiosResponse): Promise<ListResponseOfOrganizationMenu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationMenu.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationMenu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationMenu>(null as any);
    }

    assignMenu(request: OrganizationMenuRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/organization-menus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignMenu(_response);
        });
    }

    protected processAssignMenu(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    unassignMenu(organizationMenuId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organization-menus/{organizationMenuId}";
        if (organizationMenuId === undefined || organizationMenuId === null)
            throw new globalThis.Error("The parameter 'organizationMenuId' must be defined.");
        url_ = url_.replace("{organizationMenuId}", encodeURIComponent("" + organizationMenuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassignMenu(_response);
        });
    }

    protected processUnassignMenu(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class InflectionPointService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInflectionPoints(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfInflectionPoint> {
        let url_ = this.baseUrl + "/api/inflection-points/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInflectionPoints(_response);
        });
    }

    protected processGetInflectionPoints(response: AxiosResponse): Promise<ListResponseOfInflectionPoint> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfInflectionPoint.fromJS(resultData200);
            return Promise.resolve<ListResponseOfInflectionPoint>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfInflectionPoint>(null as any);
    }
}

export class WidgetService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getWidgets(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfWidget> {
        let url_ = this.baseUrl + "/api/widgets/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWidgets(_response);
        });
    }

    protected processGetWidgets(response: AxiosResponse): Promise<ListResponseOfWidget> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfWidget.fromJS(resultData200);
            return Promise.resolve<ListResponseOfWidget>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfWidget>(null as any);
    }
}

export class WizardService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getWizards(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfWizard> {
        let url_ = this.baseUrl + "/api/wizards/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWizards(_response);
        });
    }

    protected processGetWizards(response: AxiosResponse): Promise<ListResponseOfWizard> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfWizard.fromJS(resultData200);
            return Promise.resolve<ListResponseOfWizard>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfWizard>(null as any);
    }

    getWizard(wizardId: string, cancelToken?: CancelToken): Promise<ResponseOfWizard> {
        let url_ = this.baseUrl + "/api/wizards/{wizardId}";
        if (wizardId === undefined || wizardId === null)
            throw new globalThis.Error("The parameter 'wizardId' must be defined.");
        url_ = url_.replace("{wizardId}", encodeURIComponent("" + wizardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWizard(_response);
        });
    }

    protected processGetWizard(response: AxiosResponse): Promise<ResponseOfWizard> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfWizard.fromJS(resultData200);
            return Promise.resolve<ResponseOfWizard>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfWizard>(null as any);
    }

    deleteWizard(wizardId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/wizards/{wizardId}";
        if (wizardId === undefined || wizardId === null)
            throw new globalThis.Error("The parameter 'wizardId' must be defined.");
        url_ = url_.replace("{wizardId}", encodeURIComponent("" + wizardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWizard(_response);
        });
    }

    protected processDeleteWizard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveWizard(wizardSaveRequest: WizardSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/wizards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wizardSaveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWizard(_response);
        });
    }

    protected processSaveWizard(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class ConfigurationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEnvironment( cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnvironment(_response);
        });
    }

    protected processGetEnvironment(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }
}

export class AuthorityService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAuthorities(request: ListRequestOfAuthorityFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAuthorityItem> {
        let url_ = this.baseUrl + "/api/authorities/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorities(_response);
        });
    }

    protected processGetAuthorities(response: AxiosResponse): Promise<ListResponseOfAuthorityItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAuthorityItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAuthorityItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAuthorityItem>(null as any);
    }
}

export class AuthorityTypeService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAuthorityTypes(request: ListRequestOfAuthorityTypeAdminFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAuthorityTypeListItem> {
        let url_ = this.baseUrl + "/api/authority-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorityTypes(_response);
        });
    }

    protected processGetAuthorityTypes(response: AxiosResponse): Promise<ListResponseOfAuthorityTypeListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAuthorityTypeListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAuthorityTypeListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAuthorityTypeListItem>(null as any);
    }

    getAuthorityTypeById(authorityTypeId: string, cancelToken?: CancelToken): Promise<ResponseOfAuthorityTypeDetail> {
        let url_ = this.baseUrl + "/api/authority-types/{authorityTypeId}";
        if (authorityTypeId === undefined || authorityTypeId === null)
            throw new globalThis.Error("The parameter 'authorityTypeId' must be defined.");
        url_ = url_.replace("{authorityTypeId}", encodeURIComponent("" + authorityTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorityTypeById(_response);
        });
    }

    protected processGetAuthorityTypeById(response: AxiosResponse): Promise<ResponseOfAuthorityTypeDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAuthorityTypeDetail.fromJS(resultData200);
            return Promise.resolve<ResponseOfAuthorityTypeDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAuthorityTypeDetail>(null as any);
    }

    updateAuthorityType(authorityTypeId: string, request: AuthorityTypeRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/authority-types/{authorityTypeId}";
        if (authorityTypeId === undefined || authorityTypeId === null)
            throw new globalThis.Error("The parameter 'authorityTypeId' must be defined.");
        url_ = url_.replace("{authorityTypeId}", encodeURIComponent("" + authorityTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAuthorityType(_response);
        });
    }

    protected processUpdateAuthorityType(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class CertificateService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCertificate(certificateId: string, cancelToken?: CancelToken): Promise<ResponseOfCertificate> {
        let url_ = this.baseUrl + "/api/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new globalThis.Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificate(_response);
        });
    }

    protected processGetCertificate(response: AxiosResponse): Promise<ResponseOfCertificate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCertificate.fromJS(resultData200);
            return Promise.resolve<ResponseOfCertificate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCertificate>(null as any);
    }

    deleteCertificate(certificateId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new globalThis.Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCertificate(_response);
        });
    }

    protected processDeleteCertificate(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getCertificates(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCertificate> {
        let url_ = this.baseUrl + "/api/certificates/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificates(_response);
        });
    }

    protected processGetCertificates(response: AxiosResponse): Promise<ListResponseOfCertificate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCertificate.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCertificate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCertificate>(null as any);
    }

    saveCertificate(request: CertificateRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/certificates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCertificate(_response);
        });
    }

    protected processSaveCertificate(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    findCertificatesBySkuOrProduct(skuId: string, filter: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuCertificate> {
        let url_ = this.baseUrl + "/api/certificates/sku-certificate/{skuId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindCertificatesBySkuOrProduct(_response);
        });
    }

    protected processFindCertificatesBySkuOrProduct(response: AxiosResponse): Promise<ListResponseOfSkuCertificate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuCertificate.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuCertificate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuCertificate>(null as any);
    }

    getCertificateProducts(certificateId: string, request: ListRequestOfCertificateProductFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCertificateProductExtended> {
        let url_ = this.baseUrl + "/api/certificates/{certificateId}/products/all";
        if (certificateId === undefined || certificateId === null)
            throw new globalThis.Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateProducts(_response);
        });
    }

    protected processGetCertificateProducts(response: AxiosResponse): Promise<ListResponseOfCertificateProductExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCertificateProductExtended.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCertificateProductExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCertificateProductExtended>(null as any);
    }

    deleteCertificateProduct(certificateProductId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/certificates/products/{certificateProductId}";
        if (certificateProductId === undefined || certificateProductId === null)
            throw new globalThis.Error("The parameter 'certificateProductId' must be defined.");
        url_ = url_.replace("{certificateProductId}", encodeURIComponent("" + certificateProductId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCertificateProduct(_response);
        });
    }

    protected processDeleteCertificateProduct(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getCertificateProduct(certificateProductId: string, cancelToken?: CancelToken): Promise<ResponseOfCertificateProduct> {
        let url_ = this.baseUrl + "/api/certificates/products/{certificateProductId}";
        if (certificateProductId === undefined || certificateProductId === null)
            throw new globalThis.Error("The parameter 'certificateProductId' must be defined.");
        url_ = url_.replace("{certificateProductId}", encodeURIComponent("" + certificateProductId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateProduct(_response);
        });
    }

    protected processGetCertificateProduct(response: AxiosResponse): Promise<ResponseOfCertificateProduct> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCertificateProduct.fromJS(resultData200);
            return Promise.resolve<ResponseOfCertificateProduct>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCertificateProduct>(null as any);
    }

    saveCertificateProduct(certificateId: string, request: CertificateProductRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/certificates/{certificateId}/products";
        if (certificateId === undefined || certificateId === null)
            throw new globalThis.Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCertificateProduct(_response);
        });
    }

    protected processSaveCertificateProduct(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getCertificateSkus(certificateId: string, request: ListRequestOfCertificateSkuFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCertificateSkuExtended> {
        let url_ = this.baseUrl + "/api/certificates/{certificateId}/skus/all";
        if (certificateId === undefined || certificateId === null)
            throw new globalThis.Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateSkus(_response);
        });
    }

    protected processGetCertificateSkus(response: AxiosResponse): Promise<ListResponseOfCertificateSkuExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCertificateSkuExtended.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCertificateSkuExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCertificateSkuExtended>(null as any);
    }

    deleteCertificateSku(certificateSkuId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/certificates/skus/{certificateSkuId}";
        if (certificateSkuId === undefined || certificateSkuId === null)
            throw new globalThis.Error("The parameter 'certificateSkuId' must be defined.");
        url_ = url_.replace("{certificateSkuId}", encodeURIComponent("" + certificateSkuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCertificateSku(_response);
        });
    }

    protected processDeleteCertificateSku(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getCertificateSku(certificateSkuId: string, cancelToken?: CancelToken): Promise<ResponseOfCertificateSkuExtended> {
        let url_ = this.baseUrl + "/api/certificates/skus/{certificateSkuId}";
        if (certificateSkuId === undefined || certificateSkuId === null)
            throw new globalThis.Error("The parameter 'certificateSkuId' must be defined.");
        url_ = url_.replace("{certificateSkuId}", encodeURIComponent("" + certificateSkuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateSku(_response);
        });
    }

    protected processGetCertificateSku(response: AxiosResponse): Promise<ResponseOfCertificateSkuExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCertificateSkuExtended.fromJS(resultData200);
            return Promise.resolve<ResponseOfCertificateSkuExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCertificateSkuExtended>(null as any);
    }

    saveCertificateSku(certificateId: string, request: CertificateSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/certificates/{certificateId}/skus";
        if (certificateId === undefined || certificateId === null)
            throw new globalThis.Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCertificateSku(_response);
        });
    }

    protected processSaveCertificateSku(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getCertificateTemplates(request: AdminListRequestOfOrientationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCertificateTemplate> {
        let url_ = this.baseUrl + "/api/certificates/templates/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateTemplates(_response);
        });
    }

    protected processGetCertificateTemplates(response: AxiosResponse): Promise<ListResponseOfCertificateTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCertificateTemplate.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCertificateTemplate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCertificateTemplate>(null as any);
    }

    getCertificateTemplate(certificateTemplateId: string, cancelToken?: CancelToken): Promise<ResponseOfCertificateTemplate> {
        let url_ = this.baseUrl + "/api/certificates/templates/{certificateTemplateId}";
        if (certificateTemplateId === undefined || certificateTemplateId === null)
            throw new globalThis.Error("The parameter 'certificateTemplateId' must be defined.");
        url_ = url_.replace("{certificateTemplateId}", encodeURIComponent("" + certificateTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateTemplate(_response);
        });
    }

    protected processGetCertificateTemplate(response: AxiosResponse): Promise<ResponseOfCertificateTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCertificateTemplate.fromJS(resultData200);
            return Promise.resolve<ResponseOfCertificateTemplate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCertificateTemplate>(null as any);
    }

    deleteCertificateTemplate(certificateTemplateId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/certificates/templates/{certificateTemplateId}";
        if (certificateTemplateId === undefined || certificateTemplateId === null)
            throw new globalThis.Error("The parameter 'certificateTemplateId' must be defined.");
        url_ = url_.replace("{certificateTemplateId}", encodeURIComponent("" + certificateTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCertificateTemplate(_response);
        });
    }

    protected processDeleteCertificateTemplate(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveCertificateTemplate(certificateTemplateRequest: CertificateTemplateRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/certificates/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(certificateTemplateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCertificateTemplate(_response);
        });
    }

    protected processSaveCertificateTemplate(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    cloneCertificateTemplate(certificateTemplateId: string, cancelToken?: CancelToken): Promise<ResponseOfCertificateTemplate> {
        let url_ = this.baseUrl + "/api/certificates/templates/{certificateTemplateId}/clone";
        if (certificateTemplateId === undefined || certificateTemplateId === null)
            throw new globalThis.Error("The parameter 'certificateTemplateId' must be defined.");
        url_ = url_.replace("{certificateTemplateId}", encodeURIComponent("" + certificateTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneCertificateTemplate(_response);
        });
    }

    protected processCloneCertificateTemplate(response: AxiosResponse): Promise<ResponseOfCertificateTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCertificateTemplate.fromJS(resultData200);
            return Promise.resolve<ResponseOfCertificateTemplate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCertificateTemplate>(null as any);
    }

    getCertificateTemplatesOverride(certificateTemplatesOverrideId: string, cancelToken?: CancelToken): Promise<ResponseOfCertificateTemplatesOverrideExtended> {
        let url_ = this.baseUrl + "/api/certificates/templates/professions/{certificateTemplatesOverrideId}";
        if (certificateTemplatesOverrideId === undefined || certificateTemplatesOverrideId === null)
            throw new globalThis.Error("The parameter 'certificateTemplatesOverrideId' must be defined.");
        url_ = url_.replace("{certificateTemplatesOverrideId}", encodeURIComponent("" + certificateTemplatesOverrideId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateTemplatesOverride(_response);
        });
    }

    protected processGetCertificateTemplatesOverride(response: AxiosResponse): Promise<ResponseOfCertificateTemplatesOverrideExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCertificateTemplatesOverrideExtended.fromJS(resultData200);
            return Promise.resolve<ResponseOfCertificateTemplatesOverrideExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCertificateTemplatesOverrideExtended>(null as any);
    }

    getCertificateTemplatesOverrides(certificateTemplateId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCertificateTemplatesOverrideExtended> {
        let url_ = this.baseUrl + "/api/certificates/templates/{certificateTemplateId}/professions/all";
        if (certificateTemplateId === undefined || certificateTemplateId === null)
            throw new globalThis.Error("The parameter 'certificateTemplateId' must be defined.");
        url_ = url_.replace("{certificateTemplateId}", encodeURIComponent("" + certificateTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateTemplatesOverrides(_response);
        });
    }

    protected processGetCertificateTemplatesOverrides(response: AxiosResponse): Promise<ListResponseOfCertificateTemplatesOverrideExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCertificateTemplatesOverrideExtended.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCertificateTemplatesOverrideExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCertificateTemplatesOverrideExtended>(null as any);
    }

    saveCertificateTemplatesOverride(certificateTemplateId: string, request: CertificateTemplatesOverrideRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/certificates/templates/{certificateTemplateId}/professions";
        if (certificateTemplateId === undefined || certificateTemplateId === null)
            throw new globalThis.Error("The parameter 'certificateTemplateId' must be defined.");
        url_ = url_.replace("{certificateTemplateId}", encodeURIComponent("" + certificateTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCertificateTemplatesOverride(_response);
        });
    }

    protected processSaveCertificateTemplatesOverride(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteCertificateTemplatesOverride(certificateTemplatesOverrideId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/certificates/templates/professions/{CertificateTemplatesOverrideId}";
        if (certificateTemplatesOverrideId === undefined || certificateTemplatesOverrideId === null)
            throw new globalThis.Error("The parameter 'certificateTemplatesOverrideId' must be defined.");
        url_ = url_.replace("{CertificateTemplatesOverrideId}", encodeURIComponent("" + certificateTemplatesOverrideId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCertificateTemplatesOverride(_response);
        });
    }

    protected processDeleteCertificateTemplatesOverride(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getCertificateTheme(certificateThemeId: string, cancelToken?: CancelToken): Promise<ResponseOfCertificateTheme> {
        let url_ = this.baseUrl + "/api/certificates/themes/{certificateThemeId}";
        if (certificateThemeId === undefined || certificateThemeId === null)
            throw new globalThis.Error("The parameter 'certificateThemeId' must be defined.");
        url_ = url_.replace("{certificateThemeId}", encodeURIComponent("" + certificateThemeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateTheme(_response);
        });
    }

    protected processGetCertificateTheme(response: AxiosResponse): Promise<ResponseOfCertificateTheme> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCertificateTheme.fromJS(resultData200);
            return Promise.resolve<ResponseOfCertificateTheme>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCertificateTheme>(null as any);
    }

    deleteCertificateTheme(certificateThemeId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/certificates/themes/{certificateThemeId}";
        if (certificateThemeId === undefined || certificateThemeId === null)
            throw new globalThis.Error("The parameter 'certificateThemeId' must be defined.");
        url_ = url_.replace("{certificateThemeId}", encodeURIComponent("" + certificateThemeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCertificateTheme(_response);
        });
    }

    protected processDeleteCertificateTheme(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getCertificateThemes(request: AdminListRequestOfOrientationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCertificateTheme> {
        let url_ = this.baseUrl + "/api/certificates/themes/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateThemes(_response);
        });
    }

    protected processGetCertificateThemes(response: AxiosResponse): Promise<ListResponseOfCertificateTheme> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCertificateTheme.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCertificateTheme>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCertificateTheme>(null as any);
    }

    saveCertificateTheme(certificateThemeRequest: CertificateThemeRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/certificates/themes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(certificateThemeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCertificateTheme(_response);
        });
    }

    protected processSaveCertificateTheme(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class CertificateEntityResyncService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    resyncDesignations( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/certificate-resync/designations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResyncDesignations(_response);
        });
    }

    protected processResyncDesignations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resyncLocations( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/certificate-resync/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResyncLocations(_response);
        });
    }

    protected processResyncLocations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resyncLicensureBodies( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/certificate-resync/licensure-bodies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResyncLicensureBodies(_response);
        });
    }

    protected processResyncLicensureBodies(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CompletionService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    reprocess(request: ReprocessCompletionsRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/completions/reprocess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReprocess(_response);
        });
    }

    protected processReprocess(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class LicenseService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLicenses(request: ListRequestOfLicenseAdminFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfLicenseListItem> {
        let url_ = this.baseUrl + "/api/licenses/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenses(_response);
        });
    }

    protected processGetLicenses(response: AxiosResponse): Promise<ListResponseOfLicenseListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfLicenseListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfLicenseListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfLicenseListItem>(null as any);
    }

    getLicenseById(licenseId: string, cancelToken?: CancelToken): Promise<ResponseOfLicenseDetail> {
        let url_ = this.baseUrl + "/api/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseById(_response);
        });
    }

    protected processGetLicenseById(response: AxiosResponse): Promise<ResponseOfLicenseDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfLicenseDetail.fromJS(resultData200);
            return Promise.resolve<ResponseOfLicenseDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfLicenseDetail>(null as any);
    }

    getLicenseFilterOptions( cancelToken?: CancelToken): Promise<ResponseOfLicenseFilterOptions> {
        let url_ = this.baseUrl + "/api/licenses/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseFilterOptions(_response);
        });
    }

    protected processGetLicenseFilterOptions(response: AxiosResponse): Promise<ResponseOfLicenseFilterOptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfLicenseFilterOptions.fromJS(resultData200);
            return Promise.resolve<ResponseOfLicenseFilterOptions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfLicenseFilterOptions>(null as any);
    }

    getQuestionValidationRules( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/licenses/question-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionValidationRules(_response);
        });
    }

    protected processGetQuestionValidationRules(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getRegexValidations(request: ListRequestOfRegexValidationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRegexValidation> {
        let url_ = this.baseUrl + "/api/licenses/regex-validations/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegexValidations(_response);
        });
    }

    protected processGetRegexValidations(response: AxiosResponse): Promise<ListResponseOfRegexValidation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRegexValidation.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRegexValidation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRegexValidation>(null as any);
    }

    getRegexValidationFilterOptions( cancelToken?: CancelToken): Promise<ResponseOfRegexValidationFilterOptions> {
        let url_ = this.baseUrl + "/api/licenses/regex-validations/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegexValidationFilterOptions(_response);
        });
    }

    protected processGetRegexValidationFilterOptions(response: AxiosResponse): Promise<ResponseOfRegexValidationFilterOptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRegexValidationFilterOptions.fromJS(resultData200);
            return Promise.resolve<ResponseOfRegexValidationFilterOptions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRegexValidationFilterOptions>(null as any);
    }

    getRegexValidationCredentials(regexValidationId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRegexValidationCredential> {
        let url_ = this.baseUrl + "/api/licenses/regex-validations/{regexValidationId}/credentials";
        if (regexValidationId === undefined || regexValidationId === null)
            throw new globalThis.Error("The parameter 'regexValidationId' must be defined.");
        url_ = url_.replace("{regexValidationId}", encodeURIComponent("" + regexValidationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegexValidationCredentials(_response);
        });
    }

    protected processGetRegexValidationCredentials(response: AxiosResponse): Promise<ListResponseOfRegexValidationCredential> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRegexValidationCredential.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRegexValidationCredential>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRegexValidationCredential>(null as any);
    }

    saveRegexValidation(request: RegexValidationSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/licenses/regex-validations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRegexValidation(_response);
        });
    }

    protected processSaveRegexValidation(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveLicenseQuestion(licenseId: string, request: LicenseQuestionRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/licenses/{licenseId}/questions";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveLicenseQuestion(_response);
        });
    }

    protected processSaveLicenseQuestion(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteLicenseQuestion(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/licenses/questions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLicenseQuestion(_response);
        });
    }

    protected processDeleteLicenseQuestion(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class LicenseTrackerService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLicenseTrackerAvailability(licenseId: string, cancelToken?: CancelToken): Promise<ResponseOfLicenseTrackerAvailability> {
        let url_ = this.baseUrl + "/api/license-tracker/{licenseId}/availability";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseTrackerAvailability(_response);
        });
    }

    protected processGetLicenseTrackerAvailability(response: AxiosResponse): Promise<ResponseOfLicenseTrackerAvailability> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfLicenseTrackerAvailability.fromJS(resultData200);
            return Promise.resolve<ResponseOfLicenseTrackerAvailability>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfLicenseTrackerAvailability>(null as any);
    }

    setLicenseTrackerAvailability(request: SetLicenseTrackerAvailabilityRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/license-tracker/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetLicenseTrackerAvailability(_response);
        });
    }

    protected processSetLicenseTrackerAvailability(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class LicensureBodyService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLicensureBodies(request: ListRequestOfLicensureBodyAdminFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfLicensureBodyListItem> {
        let url_ = this.baseUrl + "/api/licensure-bodies/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicensureBodies(_response);
        });
    }

    protected processGetLicensureBodies(response: AxiosResponse): Promise<ListResponseOfLicensureBodyListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfLicensureBodyListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfLicensureBodyListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfLicensureBodyListItem>(null as any);
    }

    getLicensureBodyById(licensureBodyId: string, cancelToken?: CancelToken): Promise<ResponseOfLicensureBodyDetail> {
        let url_ = this.baseUrl + "/api/licensure-bodies/{licensureBodyId}";
        if (licensureBodyId === undefined || licensureBodyId === null)
            throw new globalThis.Error("The parameter 'licensureBodyId' must be defined.");
        url_ = url_.replace("{licensureBodyId}", encodeURIComponent("" + licensureBodyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicensureBodyById(_response);
        });
    }

    protected processGetLicensureBodyById(response: AxiosResponse): Promise<ResponseOfLicensureBodyDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfLicensureBodyDetail.fromJS(resultData200);
            return Promise.resolve<ResponseOfLicensureBodyDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfLicensureBodyDetail>(null as any);
    }

    updateLicensureBody(licensureBodyId: string, request: LicensureBodyRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/licensure-bodies/{licensureBodyId}";
        if (licensureBodyId === undefined || licensureBodyId === null)
            throw new globalThis.Error("The parameter 'licensureBodyId' must be defined.");
        url_ = url_.replace("{licensureBodyId}", encodeURIComponent("" + licensureBodyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLicensureBody(_response);
        });
    }

    protected processUpdateLicensureBody(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class ProfessionalInformationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProfessionalInformation(request: UserScopeRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfProfessionalInformationResponse> {
        let url_ = this.baseUrl + "/api/professional-information/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessionalInformation(_response);
        });
    }

    protected processGetProfessionalInformation(response: AxiosResponse): Promise<ResponseOfProfessionalInformationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfProfessionalInformationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfProfessionalInformationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfProfessionalInformationResponse>(null as any);
    }

    saveProfessionalInformation(request: SaveProfessionalInformationRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/professional-information/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProfessionalInformation(_response);
        });
    }

    protected processSaveProfessionalInformation(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class RequirementService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRequirementsByLicense(licenseId: string, request: ListRequestOfRequirementAdminFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRequirementListItem> {
        let url_ = this.baseUrl + "/api/requirements/by-license/{licenseId}/all";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequirementsByLicense(_response);
        });
    }

    protected processGetRequirementsByLicense(response: AxiosResponse): Promise<ListResponseOfRequirementListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRequirementListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRequirementListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRequirementListItem>(null as any);
    }

    getRequirementsBySet(requirementSetId: string, request: ListRequestOfRequirementAdminFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRequirementListItem> {
        let url_ = this.baseUrl + "/api/requirements/by-set/{requirementSetId}/all";
        if (requirementSetId === undefined || requirementSetId === null)
            throw new globalThis.Error("The parameter 'requirementSetId' must be defined.");
        url_ = url_.replace("{requirementSetId}", encodeURIComponent("" + requirementSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequirementsBySet(_response);
        });
    }

    protected processGetRequirementsBySet(response: AxiosResponse): Promise<ListResponseOfRequirementListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRequirementListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRequirementListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRequirementListItem>(null as any);
    }

    getRequirementById(id: string, cancelToken?: CancelToken): Promise<ResponseOfRequirementDetail> {
        let url_ = this.baseUrl + "/api/requirements/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequirementById(_response);
        });
    }

    protected processGetRequirementById(response: AxiosResponse): Promise<ResponseOfRequirementDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRequirementDetail.fromJS(resultData200);
            return Promise.resolve<ResponseOfRequirementDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRequirementDetail>(null as any);
    }

    deleteRequirement(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirements/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRequirement(_response);
        });
    }

    protected processDeleteRequirement(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getRequirementFilterOptions( cancelToken?: CancelToken): Promise<ResponseOfRequirementFilterOptions> {
        let url_ = this.baseUrl + "/api/requirements/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequirementFilterOptions(_response);
        });
    }

    protected processGetRequirementFilterOptions(response: AxiosResponse): Promise<ResponseOfRequirementFilterOptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRequirementFilterOptions.fromJS(resultData200);
            return Promise.resolve<ResponseOfRequirementFilterOptions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRequirementFilterOptions>(null as any);
    }

    getAuthoringOptions( cancelToken?: CancelToken): Promise<ResponseOfRequirementAuthoringOptions> {
        let url_ = this.baseUrl + "/api/requirements/authoring-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthoringOptions(_response);
        });
    }

    protected processGetAuthoringOptions(response: AxiosResponse): Promise<ResponseOfRequirementAuthoringOptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRequirementAuthoringOptions.fromJS(resultData200);
            return Promise.resolve<ResponseOfRequirementAuthoringOptions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRequirementAuthoringOptions>(null as any);
    }

    saveRequirement(request: RequirementRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequirement(_response);
        });
    }

    protected processSaveRequirement(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    moveRequirementUp(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirements/{id}/move-up";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveRequirementUp(_response);
        });
    }

    protected processMoveRequirementUp(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    moveRequirementDown(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirements/{id}/move-down";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveRequirementDown(_response);
        });
    }

    protected processMoveRequirementDown(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveRequirementConstraint(request: RequirementConstraintRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirements/constraints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequirementConstraint(_response);
        });
    }

    protected processSaveRequirementConstraint(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteRequirementConstraint(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirements/constraints/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRequirementConstraint(_response);
        });
    }

    protected processDeleteRequirementConstraint(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveApplicabilityCondition(request: RequirementApplicabilityConditionRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirements/applicability-conditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveApplicabilityCondition(_response);
        });
    }

    protected processSaveApplicabilityCondition(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteApplicabilityCondition(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirements/applicability-conditions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteApplicabilityCondition(_response);
        });
    }

    protected processDeleteApplicabilityCondition(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class RequirementSetService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRequirementSetById(id: string, cancelToken?: CancelToken): Promise<ResponseOfRequirementSetDetail> {
        let url_ = this.baseUrl + "/api/requirement-sets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequirementSetById(_response);
        });
    }

    protected processGetRequirementSetById(response: AxiosResponse): Promise<ResponseOfRequirementSetDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRequirementSetDetail.fromJS(resultData200);
            return Promise.resolve<ResponseOfRequirementSetDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRequirementSetDetail>(null as any);
    }

    getActiveRequirementSet(licenseId: string, cancelToken?: CancelToken): Promise<ResponseOfRequirementSetDetail> {
        let url_ = this.baseUrl + "/api/requirement-sets/active/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveRequirementSet(_response);
        });
    }

    protected processGetActiveRequirementSet(response: AxiosResponse): Promise<ResponseOfRequirementSetDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRequirementSetDetail.fromJS(resultData200);
            return Promise.resolve<ResponseOfRequirementSetDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRequirementSetDetail>(null as any);
    }

    getRequirementSetsByLicense(licenseId: string, cancelToken?: CancelToken): Promise<ListResponseOfRequirementSetListItem> {
        let url_ = this.baseUrl + "/api/requirement-sets/by-license/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequirementSetsByLicense(_response);
        });
    }

    protected processGetRequirementSetsByLicense(response: AxiosResponse): Promise<ListResponseOfRequirementSetListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRequirementSetListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRequirementSetListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRequirementSetListItem>(null as any);
    }

    saveRequirementSet(request: RequirementSetRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirement-sets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequirementSet(_response);
        });
    }

    protected processSaveRequirementSet(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    copyRequirementSet(request: RequirementSetCopyRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirement-sets/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyRequirementSet(_response);
        });
    }

    protected processCopyRequirementSet(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveCycleConfiguration(request: CycleConfigurationRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirement-sets/cycle-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCycleConfiguration(_response);
        });
    }

    protected processSaveCycleConfiguration(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveCarryoverRule(request: CarryoverRuleRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirement-sets/carryover-rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCarryoverRule(_response);
        });
    }

    protected processSaveCarryoverRule(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteCarryoverRule(requirementSetId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirement-sets/{requirementSetId}/carryover-rule";
        if (requirementSetId === undefined || requirementSetId === null)
            throw new globalThis.Error("The parameter 'requirementSetId' must be defined.");
        url_ = url_.replace("{requirementSetId}", encodeURIComponent("" + requirementSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCarryoverRule(_response);
        });
    }

    protected processDeleteCarryoverRule(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    submitRequirementSetForReview(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirement-sets/{id}/submit-for-review";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitRequirementSetForReview(_response);
        });
    }

    protected processSubmitRequirementSetForReview(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    approveRequirementSet(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirement-sets/{id}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveRequirementSet(_response);
        });
    }

    protected processApproveRequirementSet(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    returnRequirementSetToDraft(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirement-sets/{id}/return-to-draft";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReturnRequirementSetToDraft(_response);
        });
    }

    protected processReturnRequirementSetToDraft(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    archiveRequirementSet(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirement-sets/{id}/archive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveRequirementSet(_response);
        });
    }

    protected processArchiveRequirementSet(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    unarchiveRequirementSet(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirement-sets/{id}/unarchive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnarchiveRequirementSet(_response);
        });
    }

    protected processUnarchiveRequirementSet(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveRequirementNote(request: RequirementNoteRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/requirement-sets/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequirementNote(_response);
        });
    }

    protected processSaveRequirementNote(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteRequirementNote(id: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/requirement-sets/notes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRequirementNote(_response);
        });
    }

    protected processDeleteRequirementNote(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class SubmissionService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    previewManualSubmission(filter: ManualSubmissionFilter | null | undefined, cancelToken?: CancelToken): Promise<ManualSubmissionResultOfObject> {
        let url_ = this.baseUrl + "/api/submissions/manual/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewManualSubmission(_response);
        });
    }

    protected processPreviewManualSubmission(response: AxiosResponse): Promise<ManualSubmissionResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ManualSubmissionResultOfObject.fromJS(resultData200);
            return Promise.resolve<ManualSubmissionResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManualSubmissionResultOfObject>(null as any);
    }

    processManualSubmission(filter: ManualSubmissionFilter | null | undefined, cancelToken?: CancelToken): Promise<ManualSubmissionResultOfObject> {
        let url_ = this.baseUrl + "/api/submissions/manual/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessManualSubmission(_response);
        });
    }

    protected processProcessManualSubmission(response: AxiosResponse): Promise<ManualSubmissionResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ManualSubmissionResultOfObject.fromJS(resultData200);
            return Promise.resolve<ManualSubmissionResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManualSubmissionResultOfObject>(null as any);
    }

    getPreviouslyExportedProcessings(filter: ListRequestOfProcessingFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProcessingModel> {
        let url_ = this.baseUrl + "/api/submissions/manual/processing/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreviouslyExportedProcessings(_response);
        });
    }

    protected processGetPreviouslyExportedProcessings(response: AxiosResponse): Promise<ListResponseOfProcessingModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProcessingModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProcessingModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProcessingModel>(null as any);
    }

    uploadSubmissionStatusFile(processingId: string | undefined, fileContent: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/submissions/manual/processing/submission-status-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (processingId === null || processingId === undefined)
            throw new globalThis.Error("The parameter 'processingId' cannot be null.");
        else
            content_.append("ProcessingId", processingId.toString());
        if (fileContent !== null && fileContent !== undefined)
            content_.append("FileContent", fileContent.data, fileContent.fileName ? fileContent.fileName : "FileContent");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSubmissionStatusFile(_response);
        });
    }

    protected processUploadSubmissionStatusFile(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getProcessingReportFileUrl(processingId: string, cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/api/submissions/manual/processing/{processingId}/report-file-url";
        if (processingId === undefined || processingId === null)
            throw new globalThis.Error("The parameter 'processingId' must be defined.");
        url_ = url_.replace("{processingId}", encodeURIComponent("" + processingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessingReportFileUrl(_response);
        });
    }

    protected processGetProcessingReportFileUrl(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }

    getSubmissionRequests(request: ListRequestOfSubmissionRequestFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSubmissionRequestModel> {
        let url_ = this.baseUrl + "/api/submissions/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmissionRequests(_response);
        });
    }

    protected processGetSubmissionRequests(response: AxiosResponse): Promise<ListResponseOfSubmissionRequestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSubmissionRequestModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSubmissionRequestModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSubmissionRequestModel>(null as any);
    }

    reprocessUserSubmissions(request: ReprocessUserSubmissionsRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/submissions/reprocess-user-submissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReprocessUserSubmissions(_response);
        });
    }

    protected processReprocessUserSubmissions(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSubmissionsCourseTitles(request: CourseTitlesRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCourseTitleModel> {
        let url_ = this.baseUrl + "/api/submissions/course-titles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmissionsCourseTitles(_response);
        });
    }

    protected processGetSubmissionsCourseTitles(response: AxiosResponse): Promise<ListResponseOfCourseTitleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCourseTitleModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCourseTitleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCourseTitleModel>(null as any);
    }
}

export class UserCertificateService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserCertificate(userCertificateId: string, cancelToken?: CancelToken): Promise<ResponseOfUserCertificateModel> {
        let url_ = this.baseUrl + "/api/userCertificate/{userCertificateId}";
        if (userCertificateId === undefined || userCertificateId === null)
            throw new globalThis.Error("The parameter 'userCertificateId' must be defined.");
        url_ = url_.replace("{userCertificateId}", encodeURIComponent("" + userCertificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCertificate(_response);
        });
    }

    protected processGetUserCertificate(response: AxiosResponse): Promise<ResponseOfUserCertificateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfUserCertificateModel.fromJS(resultData200);
            return Promise.resolve<ResponseOfUserCertificateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfUserCertificateModel>(null as any);
    }

    getAllUserCertificates(request: ListRequestOfUserCertificatesFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfUserCertificateModel> {
        let url_ = this.baseUrl + "/api/userCertificate/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserCertificates(_response);
        });
    }

    protected processGetAllUserCertificates(response: AxiosResponse): Promise<ListResponseOfUserCertificateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserCertificateModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserCertificateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserCertificateModel>(null as any);
    }

    regenerateUserCertificates(request: RegenerateUserCertificatesRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/userCertificate/regenerate/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegenerateUserCertificates(_response);
        });
    }

    protected processRegenerateUserCertificates(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getUserCertificatesCourseTitles(request: CourseTitlesRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCourseTitleModel> {
        let url_ = this.baseUrl + "/api/userCertificate/course-titles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCertificatesCourseTitles(_response);
        });
    }

    protected processGetUserCertificatesCourseTitles(response: AxiosResponse): Promise<ListResponseOfCourseTitleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCourseTitleModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCourseTitleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCourseTitleModel>(null as any);
    }

    getDownloadUrl(request: UserCertificateDownloadRequest | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/userCertificate/download-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadUrl(_response);
        });
    }

    protected processGetDownloadUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UserProfileCredentialService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserCredentials(request: UserScopeRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProfileCredentialModel> {
        let url_ = this.baseUrl + "/api/user-profile-credential/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCredentials(_response);
        });
    }

    protected processGetUserCredentials(response: AxiosResponse): Promise<ListResponseOfProfileCredentialModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProfileCredentialModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProfileCredentialModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProfileCredentialModel>(null as any);
    }

    saveUserCredential(request: SaveUserCredentialRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/user-profile-credential/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUserCredential(_response);
        });
    }

    protected processSaveUserCredential(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteUserCredential(request: DeleteUserCredentialRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/user-profile-credential/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserCredential(_response);
        });
    }

    protected processDeleteUserCredential(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getAvailableDesignations(request: UserScopeRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAvailableDesignationModel> {
        let url_ = this.baseUrl + "/api/user-profile-credential/designations/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableDesignations(_response);
        });
    }

    protected processGetAvailableDesignations(response: AxiosResponse): Promise<ListResponseOfAvailableDesignationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAvailableDesignationModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAvailableDesignationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAvailableDesignationModel>(null as any);
    }

    getAvailableLocations(request: AvailableLocationRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCredentialLocationModel> {
        let url_ = this.baseUrl + "/api/user-profile-credential/locations/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableLocations(_response);
        });
    }

    protected processGetAvailableLocations(response: AxiosResponse): Promise<ListResponseOfCredentialLocationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCredentialLocationModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCredentialLocationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCredentialLocationModel>(null as any);
    }

    getAvailableLicensureBodies(request: AvailableLicensureBodiesRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCredentialLicensureBodyModel> {
        let url_ = this.baseUrl + "/api/user-profile-credential/licensure-bodies/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableLicensureBodies(_response);
        });
    }

    protected processGetAvailableLicensureBodies(response: AxiosResponse): Promise<ListResponseOfCredentialLicensureBodyModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCredentialLicensureBodyModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCredentialLicensureBodyModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCredentialLicensureBodyModel>(null as any);
    }

    getCredential(request: GetCredentialRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfCredentialModel> {
        let url_ = this.baseUrl + "/api/user-profile-credential/credential";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCredential(_response);
        });
    }

    protected processGetCredential(response: AxiosResponse): Promise<ResponseOfCredentialModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCredentialModel.fromJS(resultData200);
            return Promise.resolve<ResponseOfCredentialModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCredentialModel>(null as any);
    }
}

export class QualificationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getQualificationApprovals(qualificationId: string, request: GetQualificationApprovalsRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQualificationApproval> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/qualification-approvals/all";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationApprovals(_response);
        });
    }

    protected processGetQualificationApprovals(response: AxiosResponse): Promise<ListResponseOfQualificationApproval> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQualificationApproval.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQualificationApproval>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQualificationApproval>(null as any);
    }

    saveQualificationApproval(request: SaveQualificationApprovalRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/qualifications/qualification-approvals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveQualificationApproval(_response);
        });
    }

    protected processSaveQualificationApproval(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteQualificationApproval(qualificationApprovalId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/qualifications/qualification-approvals/{qualificationApprovalId}";
        if (qualificationApprovalId === undefined || qualificationApprovalId === null)
            throw new globalThis.Error("The parameter 'qualificationApprovalId' must be defined.");
        url_ = url_.replace("{qualificationApprovalId}", encodeURIComponent("" + qualificationApprovalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualificationApproval(_response);
        });
    }

    protected processDeleteQualificationApproval(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getMatchingQualificationApproval(qualificationId: string, request: GetMatchingQualificationApprovalRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfQualificationApproval> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/qualification-approvals";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMatchingQualificationApproval(_response);
        });
    }

    protected processGetMatchingQualificationApproval(response: AxiosResponse): Promise<ResponseOfQualificationApproval> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfQualificationApproval.fromJS(resultData200);
            return Promise.resolve<ResponseOfQualificationApproval>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfQualificationApproval>(null as any);
    }

    getQualifications(request: GetQualificationsRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQualification> {
        let url_ = this.baseUrl + "/api/qualifications/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualifications(_response);
        });
    }

    protected processGetQualifications(response: AxiosResponse): Promise<ListResponseOfQualification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQualification.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQualification>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQualification>(null as any);
    }

    getQualificationById(qualificationId: string, cancelToken?: CancelToken): Promise<ResponseOfQualification> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationById(_response);
        });
    }

    protected processGetQualificationById(response: AxiosResponse): Promise<ResponseOfQualification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfQualification.fromJS(resultData200);
            return Promise.resolve<ResponseOfQualification>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfQualification>(null as any);
    }

    deleteQualification(qualificationId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualification(_response);
        });
    }

    protected processDeleteQualification(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getAccreditationChain(qualificationId: string, cancelToken?: CancelToken): Promise<ResponseOfListOfAccreditationChainItem> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/accreditation-chain";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccreditationChain(_response);
        });
    }

    protected processGetAccreditationChain(response: AxiosResponse): Promise<ResponseOfListOfAccreditationChainItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfListOfAccreditationChainItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfListOfAccreditationChainItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfListOfAccreditationChainItem>(null as any);
    }

    getAccreditationChains(request: AccreditationChainRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAccreditationChainItem> {
        let url_ = this.baseUrl + "/api/qualifications/accreditation-chains";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccreditationChains(_response);
        });
    }

    protected processGetAccreditationChains(response: AxiosResponse): Promise<ListResponseOfAccreditationChainItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAccreditationChainItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAccreditationChainItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAccreditationChainItem>(null as any);
    }

    saveQualification(saveQualification: OrganizationQualificationRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/qualifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveQualification);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveQualification(_response);
        });
    }

    protected processSaveQualification(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getQualificationTypes( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/qualifications/types/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationTypes(_response);
        });
    }

    protected processGetQualificationTypes(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    validateNabpUan(uan: string | null | undefined, cancelToken?: CancelToken): Promise<ValidateResponse> {
        let url_ = this.baseUrl + "/api/qualifications/nabp/validate-uan?";
        if (uan !== undefined && uan !== null)
            url_ += "uan=" + encodeURIComponent("" + uan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateNabpUan(_response);
        });
    }

    protected processValidateNabpUan(response: AxiosResponse): Promise<ValidateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateResponse.fromJS(resultData200);
            return Promise.resolve<ValidateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateResponse>(null as any);
    }

    validateCourseNumber(request: ValidateCourseNumberRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfValidateCourseNumberResponse> {
        let url_ = this.baseUrl + "/api/qualifications/validate-course-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateCourseNumber(_response);
        });
    }

    protected processValidateCourseNumber(response: AxiosResponse): Promise<ResponseOfValidateCourseNumberResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfValidateCourseNumberResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfValidateCourseNumberResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfValidateCourseNumberResponse>(null as any);
    }

    getQualificationStatements(qualificationId: string, request: ListRequestOfQualificationStatementFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQualificationStatement> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/qualification-statements/all";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationStatements(_response);
        });
    }

    protected processGetQualificationStatements(response: AxiosResponse): Promise<ListResponseOfQualificationStatement> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQualificationStatement.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQualificationStatement>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQualificationStatement>(null as any);
    }

    getQualificationStatementById(qualificationStatementId: string, cancelToken?: CancelToken): Promise<ResponseOfQualificationStatement> {
        let url_ = this.baseUrl + "/api/qualifications/qualification-statements/{qualificationStatementId}";
        if (qualificationStatementId === undefined || qualificationStatementId === null)
            throw new globalThis.Error("The parameter 'qualificationStatementId' must be defined.");
        url_ = url_.replace("{qualificationStatementId}", encodeURIComponent("" + qualificationStatementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationStatementById(_response);
        });
    }

    protected processGetQualificationStatementById(response: AxiosResponse): Promise<ResponseOfQualificationStatement> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfQualificationStatement.fromJS(resultData200);
            return Promise.resolve<ResponseOfQualificationStatement>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfQualificationStatement>(null as any);
    }

    deleteQualificationStatement(qualificationId: string, qualificationStatementId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/qualification-statements/{qualificationStatementId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        if (qualificationStatementId === undefined || qualificationStatementId === null)
            throw new globalThis.Error("The parameter 'qualificationStatementId' must be defined.");
        url_ = url_.replace("{qualificationStatementId}", encodeURIComponent("" + qualificationStatementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualificationStatement(_response);
        });
    }

    protected processDeleteQualificationStatement(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveQualificationStatement(qualificationId: string, saveQualificationStatement: QualificationStatementRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/qualification-statements";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveQualificationStatement);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveQualificationStatement(_response);
        });
    }

    protected processSaveQualificationStatement(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveQualificationStatementSequence(qualificationId: string, saveQualificationStatementSequence: QualificationStatementSequenceRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/qualification-statements/sequence";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveQualificationStatementSequence);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveQualificationStatementSequence(_response);
        });
    }

    protected processSaveQualificationStatementSequence(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getQualificationStatementTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQualificationStatementType> {
        let url_ = this.baseUrl + "/api/qualifications/qualification-statements/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationStatementTypes(_response);
        });
    }

    protected processGetQualificationStatementTypes(response: AxiosResponse): Promise<ListResponseOfQualificationStatementType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQualificationStatementType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQualificationStatementType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQualificationStatementType>(null as any);
    }

    getQualificationStudyFields(qualificationId: string, request: ListRequestOfQualificationStudyFieldFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQualificationStudyField> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/study-fields/all";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationStudyFields(_response);
        });
    }

    protected processGetQualificationStudyFields(response: AxiosResponse): Promise<ListResponseOfQualificationStudyField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQualificationStudyField.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQualificationStudyField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQualificationStudyField>(null as any);
    }

    saveQualificationStudyField(qualificationId: string, saveRequest: QualificationStudyFieldSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/study-fields";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveQualificationStudyField(_response);
        });
    }

    protected processSaveQualificationStudyField(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteQualificationStudyField(qualificationId: string, studyFieldId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/qualifications/{qualificationId}/study-fields/{studyFieldId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        if (studyFieldId === undefined || studyFieldId === null)
            throw new globalThis.Error("The parameter 'studyFieldId' must be defined.");
        url_ = url_.replace("{studyFieldId}", encodeURIComponent("" + studyFieldId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualificationStudyField(_response);
        });
    }

    protected processDeleteQualificationStudyField(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class ResourceLibraryService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getResourceLibraries(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceLibrary> {
        let url_ = this.baseUrl + "/api/resource-libraries/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceLibraries(_response);
        });
    }

    protected processGetResourceLibraries(response: AxiosResponse): Promise<ListResponseOfResourceLibrary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceLibrary.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceLibrary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceLibrary>(null as any);
    }

    getResourceLibraryItems(resourceLibraryId: string, request: ListRequestOfResourceLibraryItemFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceLibraryItem> {
        let url_ = this.baseUrl + "/api/resource-libraries/{resourceLibraryId}/resource-library-items/all";
        if (resourceLibraryId === undefined || resourceLibraryId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryId' must be defined.");
        url_ = url_.replace("{resourceLibraryId}", encodeURIComponent("" + resourceLibraryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceLibraryItems(_response);
        });
    }

    protected processGetResourceLibraryItems(response: AxiosResponse): Promise<ListResponseOfResourceLibraryItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceLibraryItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceLibraryItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceLibraryItem>(null as any);
    }

    getResourceLibraryItemProfessions(resourceLibraryItemId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceLibraryItemProfession> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-items/{resourceLibraryItemId}/resource-library-item-professions/all";
        if (resourceLibraryItemId === undefined || resourceLibraryItemId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemId}", encodeURIComponent("" + resourceLibraryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceLibraryItemProfessions(_response);
        });
    }

    protected processGetResourceLibraryItemProfessions(response: AxiosResponse): Promise<ListResponseOfResourceLibraryItemProfession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceLibraryItemProfession.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceLibraryItemProfession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceLibraryItemProfession>(null as any);
    }

    getResourceLibraryItemTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceLibraryItemType> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-item-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceLibraryItemTypes(_response);
        });
    }

    protected processGetResourceLibraryItemTypes(response: AxiosResponse): Promise<ListResponseOfResourceLibraryItemType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceLibraryItemType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceLibraryItemType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceLibraryItemType>(null as any);
    }

    getResourceLibraryById(resourceLibraryId: string, cancelToken?: CancelToken): Promise<ResponseOfResourceLibraryDetail> {
        let url_ = this.baseUrl + "/api/resource-libraries/{resourceLibraryId}";
        if (resourceLibraryId === undefined || resourceLibraryId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryId' must be defined.");
        url_ = url_.replace("{resourceLibraryId}", encodeURIComponent("" + resourceLibraryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceLibraryById(_response);
        });
    }

    protected processGetResourceLibraryById(response: AxiosResponse): Promise<ResponseOfResourceLibraryDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfResourceLibraryDetail.fromJS(resultData200);
            return Promise.resolve<ResponseOfResourceLibraryDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfResourceLibraryDetail>(null as any);
    }

    deleteResourceLibrary(resourceLibraryId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/resource-libraries/{resourceLibraryId}";
        if (resourceLibraryId === undefined || resourceLibraryId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryId' must be defined.");
        url_ = url_.replace("{resourceLibraryId}", encodeURIComponent("" + resourceLibraryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteResourceLibrary(_response);
        });
    }

    protected processDeleteResourceLibrary(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getResourceLibraryItemById(resourceLibraryItemId: string, cancelToken?: CancelToken): Promise<ResponseOfResourceLibraryItem> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-items/{resourceLibraryItemId}";
        if (resourceLibraryItemId === undefined || resourceLibraryItemId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemId}", encodeURIComponent("" + resourceLibraryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceLibraryItemById(_response);
        });
    }

    protected processGetResourceLibraryItemById(response: AxiosResponse): Promise<ResponseOfResourceLibraryItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfResourceLibraryItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfResourceLibraryItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfResourceLibraryItem>(null as any);
    }

    deleteResourceLibraryItem(resourceLibraryItemId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-items/{resourceLibraryItemId}";
        if (resourceLibraryItemId === undefined || resourceLibraryItemId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemId}", encodeURIComponent("" + resourceLibraryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteResourceLibraryItem(_response);
        });
    }

    protected processDeleteResourceLibraryItem(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    deleteResourceLibraryItemProfession(resourceLibraryItemProfessionId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-item-professions/{resourceLibraryItemProfessionId}";
        if (resourceLibraryItemProfessionId === undefined || resourceLibraryItemProfessionId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemProfessionId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemProfessionId}", encodeURIComponent("" + resourceLibraryItemProfessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteResourceLibraryItemProfession(_response);
        });
    }

    protected processDeleteResourceLibraryItemProfession(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveResourceLibrary(saveResourceLibraryRequest: SaveResourceLibraryRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/resource-libraries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveResourceLibraryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveResourceLibrary(_response);
        });
    }

    protected processSaveResourceLibrary(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveResourceLibraryItem(resourceLibraryId: string, id: string | null | undefined, resourceLibraryTypeId: string | undefined, name: string | null | undefined, publicationDate: Date | undefined, description: string | null | undefined, sequence: number | undefined, file: FileParameter | null | undefined, fileName: string | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/resource-libraries/{resourceLibraryId}/resource-library-items";
        if (resourceLibraryId === undefined || resourceLibraryId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryId' must be defined.");
        url_ = url_.replace("{resourceLibraryId}", encodeURIComponent("" + resourceLibraryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (resourceLibraryTypeId === null || resourceLibraryTypeId === undefined)
            throw new globalThis.Error("The parameter 'resourceLibraryTypeId' cannot be null.");
        else
            content_.append("ResourceLibraryTypeId", resourceLibraryTypeId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (publicationDate === null || publicationDate === undefined)
            throw new globalThis.Error("The parameter 'publicationDate' cannot be null.");
        else
            content_.append("PublicationDate", publicationDate.toJSON());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (sequence === null || sequence === undefined)
            throw new globalThis.Error("The parameter 'sequence' cannot be null.");
        else
            content_.append("Sequence", sequence.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveResourceLibraryItem(_response);
        });
    }

    protected processSaveResourceLibraryItem(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveResourceLibraryItemProfession(resourceLibraryItemId: string, saveResourceLibraryItemProfessionRequest: SaveResourceLibraryItemProfessionRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-items/{resourceLibraryItemId}/resource-library-item-professions";
        if (resourceLibraryItemId === undefined || resourceLibraryItemId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemId}", encodeURIComponent("" + resourceLibraryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveResourceLibraryItemProfessionRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveResourceLibraryItemProfession(_response);
        });
    }

    protected processSaveResourceLibraryItemProfession(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getResourceLibraryItemTopicAttributes(resourceLibraryItemId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceLibraryItemAttribute> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-items/{resourceLibraryItemId}/resource-library-item-topic-attributes/all";
        if (resourceLibraryItemId === undefined || resourceLibraryItemId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemId}", encodeURIComponent("" + resourceLibraryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceLibraryItemTopicAttributes(_response);
        });
    }

    protected processGetResourceLibraryItemTopicAttributes(response: AxiosResponse): Promise<ListResponseOfResourceLibraryItemAttribute> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceLibraryItemAttribute.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceLibraryItemAttribute>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceLibraryItemAttribute>(null as any);
    }

    saveResourceLibraryItemTopicAttribute(resourceLibraryItemId: string, request: SaveResourceLibraryItemAttributeRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-items/{resourceLibraryItemId}/resource-library-item-topic-attributes";
        if (resourceLibraryItemId === undefined || resourceLibraryItemId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemId}", encodeURIComponent("" + resourceLibraryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveResourceLibraryItemTopicAttribute(_response);
        });
    }

    protected processSaveResourceLibraryItemTopicAttribute(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteResourceLibraryItemTopicAttribute(resourceLibraryItemAttributeId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/resource-libraries/resource-library-item-topic-attributes/{resourceLibraryItemAttributeId}";
        if (resourceLibraryItemAttributeId === undefined || resourceLibraryItemAttributeId === null)
            throw new globalThis.Error("The parameter 'resourceLibraryItemAttributeId' must be defined.");
        url_ = url_.replace("{resourceLibraryItemAttributeId}", encodeURIComponent("" + resourceLibraryItemAttributeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteResourceLibraryItemTopicAttribute(_response);
        });
    }

    protected processDeleteResourceLibraryItemTopicAttribute(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class SkuUserAgreementService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSkuUserAgreements(request: ListRequestOfSkuUserAgreementFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuUserAgreementInfo> {
        let url_ = this.baseUrl + "/api/sku-user-agreements/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuUserAgreements(_response);
        });
    }

    protected processGetSkuUserAgreements(response: AxiosResponse): Promise<ListResponseOfSkuUserAgreementInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuUserAgreementInfo.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuUserAgreementInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuUserAgreementInfo>(null as any);
    }

    getSkuUserAgreementById(skuUserAgreementId: string, cancelToken?: CancelToken): Promise<ResponseOfSkuUserAgreementInfo> {
        let url_ = this.baseUrl + "/api/sku-user-agreements/{skuUserAgreementId}";
        if (skuUserAgreementId === undefined || skuUserAgreementId === null)
            throw new globalThis.Error("The parameter 'skuUserAgreementId' must be defined.");
        url_ = url_.replace("{skuUserAgreementId}", encodeURIComponent("" + skuUserAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuUserAgreementById(_response);
        });
    }

    protected processGetSkuUserAgreementById(response: AxiosResponse): Promise<ResponseOfSkuUserAgreementInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkuUserAgreementInfo.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkuUserAgreementInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkuUserAgreementInfo>(null as any);
    }

    getSkuUserAgreementStatuses( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/sku-user-agreements/statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuUserAgreementStatuses(_response);
        });
    }

    protected processGetSkuUserAgreementStatuses(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getSkuUserAgreementAgreements( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/sku-user-agreements/agreements/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuUserAgreementAgreements(_response);
        });
    }

    protected processGetSkuUserAgreementAgreements(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    saveSkuUserAgreement(request: SkuUserAgreementSaveRequestExtended | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/sku-user-agreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuUserAgreement(_response);
        });
    }

    protected processSaveSkuUserAgreement(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    cancelSkuUserAgreement(request: CancelSkuUserAgreementRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/sku-user-agreements/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelSkuUserAgreement(_response);
        });
    }

    protected processCancelSkuUserAgreement(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    preview(fileId: string, cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/api/sku-user-agreements/{fileId}/preview";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }
}

export class StateService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStates(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfState> {
        let url_ = this.baseUrl + "/api/states/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStates(_response);
        });
    }

    protected processGetStates(response: AxiosResponse): Promise<ListResponseOfState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfState.fromJS(resultData200);
            return Promise.resolve<ListResponseOfState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfState>(null as any);
    }
}

export class WebinarService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getWebinars(request: ListRequestOfWebinarFilterExtended | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfWebinarExtended> {
        let url_ = this.baseUrl + "/api/webinars/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebinars(_response);
        });
    }

    protected processGetWebinars(response: AxiosResponse): Promise<ListResponseOfWebinarExtended> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfWebinarExtended.fromJS(resultData200);
            return Promise.resolve<ListResponseOfWebinarExtended>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfWebinarExtended>(null as any);
    }

    saveDeliveryMethodKey(skuId: string, skuDeliveryMethodKey: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/webinars/{skuId}/deliveryMethodKey?";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuDeliveryMethodKey !== undefined && skuDeliveryMethodKey !== null)
            url_ += "skuDeliveryMethodKey=" + encodeURIComponent("" + skuDeliveryMethodKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDeliveryMethodKey(_response);
        });
    }

    protected processSaveDeliveryMethodKey(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    bypassAttendanceForSku(request: BypassSkuAttendanceRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/webinars/bypassAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBypassAttendanceForSku(_response);
        });
    }

    protected processBypassAttendanceForSku(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    processAttendance(processAttendanceRequest: ProcessAttendanceRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/webinars/processAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processAttendanceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessAttendance(_response);
        });
    }

    protected processProcessAttendance(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class SkuService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSkuAttributesByType(skuId: string, request: ListRequestOfAttributeFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuAttributeByType> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/attributes/by-type/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuAttributesByType(_response);
        });
    }

    protected processGetSkuAttributesByType(response: AxiosResponse): Promise<ListResponseOfSkuAttributeByType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuAttributeByType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuAttributeByType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuAttributeByType>(null as any);
    }

    getSkuAttributes(skuId: string, request: ListRequestOfAttributeFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuAttribute> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/attributes/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuAttributes(_response);
        });
    }

    protected processGetSkuAttributes(response: AxiosResponse): Promise<ListResponseOfSkuAttribute> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuAttribute.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuAttribute>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuAttribute>(null as any);
    }

    saveSkuAttribute(skuId: string, skuAttributeRequest: SkuAttributeRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/attributes";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuAttributeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuAttribute(_response);
        });
    }

    protected processSaveSkuAttribute(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuAttribute(skuAttributeId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/attributes/{skuAttributeId}";
        if (skuAttributeId === undefined || skuAttributeId === null)
            throw new globalThis.Error("The parameter 'skuAttributeId' must be defined.");
        url_ = url_.replace("{skuAttributeId}", encodeURIComponent("" + skuAttributeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuAttribute(_response);
        });
    }

    protected processDeleteSkuAttribute(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    updateSkuAttributeSequence(skuId: string, skuAttributeSequenceRequest: SkuAttributeSequenceRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/attributes/update-sequence";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuAttributeSequenceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSkuAttributeSequence(_response);
        });
    }

    protected processUpdateSkuAttributeSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuAvailabilityById(skuAvailabilityId: string, cancelToken?: CancelToken): Promise<ResponseOfSkuAvailability> {
        let url_ = this.baseUrl + "/api/skus/sku-availabilities/{skuAvailabilityId}";
        if (skuAvailabilityId === undefined || skuAvailabilityId === null)
            throw new globalThis.Error("The parameter 'skuAvailabilityId' must be defined.");
        url_ = url_.replace("{skuAvailabilityId}", encodeURIComponent("" + skuAvailabilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuAvailabilityById(_response);
        });
    }

    protected processGetSkuAvailabilityById(response: AxiosResponse): Promise<ResponseOfSkuAvailability> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkuAvailability.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkuAvailability>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkuAvailability>(null as any);
    }

    getSkuAvailabilities(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuAvailability> {
        let url_ = this.baseUrl + "/api/skus/sku-availabilities/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuAvailabilities(_response);
        });
    }

    protected processGetSkuAvailabilities(response: AxiosResponse): Promise<ListResponseOfSkuAvailability> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuAvailability.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuAvailability>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuAvailability>(null as any);
    }

    getMembershipGatedAccessEnabled(request: MembershipGatedAccessEnabledRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfSettingCache> {
        let url_ = this.baseUrl + "/api/skus/membership-gated-access-enabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMembershipGatedAccessEnabled(_response);
        });
    }

    protected processGetMembershipGatedAccessEnabled(response: AxiosResponse): Promise<ResponseOfSettingCache> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSettingCache.fromJS(resultData200);
            return Promise.resolve<ResponseOfSettingCache>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSettingCache>(null as any);
    }

    saveSkuContentRule(skuId: string, request: SkuContentRuleRequestExtended | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuContentRule(_response);
        });
    }

    protected processSaveSkuContentRule(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getSkuContentRuleTypes( cancelToken?: CancelToken): Promise<ListResponseOfSkuContentRuleType> {
        let url_ = this.baseUrl + "/api/skus/content-rule-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContentRuleTypes(_response);
        });
    }

    protected processGetSkuContentRuleTypes(response: AxiosResponse): Promise<ListResponseOfSkuContentRuleType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentRuleType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentRuleType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentRuleType>(null as any);
    }

    getSkuContentRules(skuId: string, request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuContentRule> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContentRules(_response);
        });
    }

    protected processGetSkuContentRules(response: AxiosResponse): Promise<ListResponseOfSkuContentRule> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentRule.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentRule>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentRule>(null as any);
    }

    deleteSkuContentRule(skuId: string, skuContentRuleId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuContentRule(_response);
        });
    }

    protected processDeleteSkuContentRule(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    cloneSkuContentRule(skuId: string, skuContentRuleId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/clone";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneSkuContentRule(_response);
        });
    }

    protected processCloneSkuContentRule(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    updateSkuContentRulesSequence(skuId: string, request: UpdateRuleSequenceRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/update-sequence";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSkuContentRulesSequence(_response);
        });
    }

    protected processUpdateSkuContentRulesSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuContentRuleProducts(skuId: string, skuContentRuleId: string, request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuContentRuleProduct> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/products/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContentRuleProducts(_response);
        });
    }

    protected processGetSkuContentRuleProducts(response: AxiosResponse): Promise<ListResponseOfSkuContentRuleProduct> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentRuleProduct.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentRuleProduct>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentRuleProduct>(null as any);
    }

    getSkuContentRuleOrganizations(skuId: string, skuContentRuleId: string, request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuContentRuleOrganization> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/organizations/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContentRuleOrganizations(_response);
        });
    }

    protected processGetSkuContentRuleOrganizations(response: AxiosResponse): Promise<ListResponseOfSkuContentRuleOrganization> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentRuleOrganization.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentRuleOrganization>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentRuleOrganization>(null as any);
    }

    saveSkuContentRuleProduct(skuId: string, skuContentRuleId: string, saveSkuContentRuleProduct: SkuContentRuleProductRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/products";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveSkuContentRuleProduct);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuContentRuleProduct(_response);
        });
    }

    protected processSaveSkuContentRuleProduct(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveSkuContentRuleOrganization(skuId: string, skuContentRuleId: string, saveSkuContentRuleOrganization: SkuContentRuleOrganizationRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/organizations";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveSkuContentRuleOrganization);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuContentRuleOrganization(_response);
        });
    }

    protected processSaveSkuContentRuleOrganization(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    deleteSkuContentRuleProduct(skuId: string, skuContentRuleId: string, skuContentRuleProductId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/products/{skuContentRuleProductId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        if (skuContentRuleProductId === undefined || skuContentRuleProductId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleProductId' must be defined.");
        url_ = url_.replace("{skuContentRuleProductId}", encodeURIComponent("" + skuContentRuleProductId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuContentRuleProduct(_response);
        });
    }

    protected processDeleteSkuContentRuleProduct(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    deleteSkuContentRuleOrganization(skuId: string, skuContentRuleId: string, skuContentRuleOrganizationId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/organizations/{skuContentRuleOrganizationId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        if (skuContentRuleOrganizationId === undefined || skuContentRuleOrganizationId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleOrganizationId' must be defined.");
        url_ = url_.replace("{skuContentRuleOrganizationId}", encodeURIComponent("" + skuContentRuleOrganizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuContentRuleOrganization(_response);
        });
    }

    protected processDeleteSkuContentRuleOrganization(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    deleteSkuContentRuleSku(skuId: string, skuContentRuleId: string, skuContentRuleSkuId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/skus/{skuContentRuleSkuId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        if (skuContentRuleSkuId === undefined || skuContentRuleSkuId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleSkuId' must be defined.");
        url_ = url_.replace("{skuContentRuleSkuId}", encodeURIComponent("" + skuContentRuleSkuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuContentRuleSku(_response);
        });
    }

    protected processDeleteSkuContentRuleSku(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuContentRuleSkus(skuId: string, skuContentRuleId: string, request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuContentRuleSku> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/skus/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContentRuleSkus(_response);
        });
    }

    protected processGetSkuContentRuleSkus(response: AxiosResponse): Promise<ListResponseOfSkuContentRuleSku> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentRuleSku.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentRuleSku>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentRuleSku>(null as any);
    }

    saveSkuContentRuleSkus(skuId: string, skuContentRuleId: string, skuIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/skus";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuContentRuleSkus(_response);
        });
    }

    protected processSaveSkuContentRuleSkus(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveSkuContentRuleSku(skuId: string, skuContentRuleId: string, request: SkuContentRuleSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/sku";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuContentRuleSku(_response);
        });
    }

    protected processSaveSkuContentRuleSku(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getSkuContentRuleProfessions(skuId: string, skuContentRuleId: string, request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuContentRuleProfession> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/professions/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContentRuleProfessions(_response);
        });
    }

    protected processGetSkuContentRuleProfessions(response: AxiosResponse): Promise<ListResponseOfSkuContentRuleProfession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentRuleProfession.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentRuleProfession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentRuleProfession>(null as any);
    }

    saveSkuContentRuleProfessions(skuId: string, skuContentRuleId: string, professionIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/professions";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(professionIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuContentRuleProfessions(_response);
        });
    }

    protected processSaveSkuContentRuleProfessions(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuContentRuleTags(skuId: string, skuContentRuleId: string, request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuContentRuleTag> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/tags/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContentRuleTags(_response);
        });
    }

    protected processGetSkuContentRuleTags(response: AxiosResponse): Promise<ListResponseOfSkuContentRuleTag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentRuleTag.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentRuleTag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentRuleTag>(null as any);
    }

    getAvailableRuleTags(skuId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfTag> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/tags/available";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableRuleTags(_response);
        });
    }

    protected processGetAvailableRuleTags(response: AxiosResponse): Promise<ListResponseOfTag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTag.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTag>(null as any);
    }

    saveSkuContentRuleTags(skuId: string, skuContentRuleId: string, tagIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/content-rules/{skuContentRuleId}/tags";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (skuContentRuleId === undefined || skuContentRuleId === null)
            throw new globalThis.Error("The parameter 'skuContentRuleId' must be defined.");
        url_ = url_.replace("{skuContentRuleId}", encodeURIComponent("" + skuContentRuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuContentRuleTags(_response);
        });
    }

    protected processSaveSkuContentRuleTags(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getSkuContents(skuId: string, request: ListRequestOfSkuContentsFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuContentItem> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/contents/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuContents(_response);
        });
    }

    protected processGetSkuContents(response: AxiosResponse): Promise<ListResponseOfSkuContentItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuContentItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuContentItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuContentItem>(null as any);
    }

    getParentSkusOfChildSku(skuId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfParentSku> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/contents/parents";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParentSkusOfChildSku(_response);
        });
    }

    protected processGetParentSkusOfChildSku(response: AxiosResponse): Promise<ListResponseOfParentSku> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfParentSku.fromJS(resultData200);
            return Promise.resolve<ListResponseOfParentSku>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfParentSku>(null as any);
    }

    getSkus(request: GetSkusRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuListItem> {
        let url_ = this.baseUrl + "/api/skus/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkus(_response);
        });
    }

    protected processGetSkus(response: AxiosResponse): Promise<ListResponseOfSkuListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuListItem>(null as any);
    }

    saveSku(request: Skus | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSku(_response);
        });
    }

    protected processSaveSku(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getSkuById(skuId: string, cancelToken?: CancelToken): Promise<ResponseOfSkus> {
        let url_ = this.baseUrl + "/api/skus/{skuId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuById(_response);
        });
    }

    protected processGetSkuById(response: AxiosResponse): Promise<ResponseOfSkus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkus.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkus>(null as any);
    }

    cloneSku(skuId: string, cancelToken?: CancelToken): Promise<ResponseOfSkus> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/clone";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneSku(_response);
        });
    }

    protected processCloneSku(response: AxiosResponse): Promise<ResponseOfSkus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkus.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkus>(null as any);
    }

    generateSku(request: RequestOfGenerateSkuRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/api/skus/generate-sku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSku(_response);
        });
    }

    protected processGenerateSku(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }

    getProfessionById(id: string, cancelToken?: CancelToken): Promise<ResponseOfProfession> {
        let url_ = this.baseUrl + "/api/skus/professions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessionById(_response);
        });
    }

    protected processGetProfessionById(response: AxiosResponse): Promise<ResponseOfProfession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfProfession.fromJS(resultData200);
            return Promise.resolve<ResponseOfProfession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfProfession>(null as any);
    }

    getProfessions(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProfession> {
        let url_ = this.baseUrl + "/api/skus/professions/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessions(_response);
        });
    }

    protected processGetProfessions(response: AxiosResponse): Promise<ListResponseOfProfession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProfession.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProfession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProfession>(null as any);
    }

    getAdvancedPreparationById(advancedPreparationId: string, cancelToken?: CancelToken): Promise<ResponseOfAdvancedPreparation> {
        let url_ = this.baseUrl + "/api/skus/advanced-preparations/{advancedPreparationId}";
        if (advancedPreparationId === undefined || advancedPreparationId === null)
            throw new globalThis.Error("The parameter 'advancedPreparationId' must be defined.");
        url_ = url_.replace("{advancedPreparationId}", encodeURIComponent("" + advancedPreparationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvancedPreparationById(_response);
        });
    }

    protected processGetAdvancedPreparationById(response: AxiosResponse): Promise<ResponseOfAdvancedPreparation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAdvancedPreparation.fromJS(resultData200);
            return Promise.resolve<ResponseOfAdvancedPreparation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAdvancedPreparation>(null as any);
    }

    getTaxClasses(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfTaxClass> {
        let url_ = this.baseUrl + "/api/skus/tax-classes/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxClasses(_response);
        });
    }

    protected processGetTaxClasses(response: AxiosResponse): Promise<ListResponseOfTaxClass> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTaxClass.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTaxClass>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTaxClass>(null as any);
    }

    getAdvancedPreparations(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAdvancedPreparation> {
        let url_ = this.baseUrl + "/api/skus/advanced-preparations/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvancedPreparations(_response);
        });
    }

    protected processGetAdvancedPreparations(response: AxiosResponse): Promise<ListResponseOfAdvancedPreparation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAdvancedPreparation.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAdvancedPreparation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAdvancedPreparation>(null as any);
    }

    getDirectLinks(skuId: string, organizationId: string, cancelToken?: CancelToken): Promise<ListResponseOfDirectLink> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/direct-links/{organizationId}";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDirectLinks(_response);
        });
    }

    protected processGetDirectLinks(response: AxiosResponse): Promise<ListResponseOfDirectLink> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfDirectLink.fromJS(resultData200);
            return Promise.resolve<ListResponseOfDirectLink>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfDirectLink>(null as any);
    }

    getSkuPreviewPdf(request: SkuPreviewRequest | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/skus/preview-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuPreviewPdf(_response);
        });
    }

    protected processGetSkuPreviewPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSkuDeliveryMethods(skuId: string, cancelToken?: CancelToken): Promise<ListResponseOfSkuDeliverableInfo> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/deliveryMethods/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuDeliveryMethods(_response);
        });
    }

    protected processGetSkuDeliveryMethods(response: AxiosResponse): Promise<ListResponseOfSkuDeliverableInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuDeliverableInfo.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuDeliverableInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuDeliverableInfo>(null as any);
    }

    saveSkuDeliveryMethod(skuId: string, request: AdminSkuDeliverableRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/deliveryMethod";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuDeliveryMethod(_response);
        });
    }

    protected processSaveSkuDeliveryMethod(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuDeliveryMethod(skuDeliverableId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/deliveryMethod/{skuDeliverableId}";
        if (skuDeliverableId === undefined || skuDeliverableId === null)
            throw new globalThis.Error("The parameter 'skuDeliverableId' must be defined.");
        url_ = url_.replace("{skuDeliverableId}", encodeURIComponent("" + skuDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuDeliveryMethod(_response);
        });
    }

    protected processDeleteSkuDeliveryMethod(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getDeliveryMethods(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAdminDeliveryMethod> {
        let url_ = this.baseUrl + "/api/skus/delivery-methods/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryMethods(_response);
        });
    }

    protected processGetDeliveryMethods(response: AxiosResponse): Promise<ListResponseOfAdminDeliveryMethod> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAdminDeliveryMethod.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAdminDeliveryMethod>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAdminDeliveryMethod>(null as any);
    }

    updateSkuDeliveryMethodSequence(skuId: string, request: AdminSkuDeliverableRequest[] | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/delivery-methods/update-sequence";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSkuDeliveryMethodSequence(_response);
        });
    }

    protected processUpdateSkuDeliveryMethodSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuFormatById(skuFormatId: string, cancelToken?: CancelToken): Promise<ResponseOfSkuFormat> {
        let url_ = this.baseUrl + "/api/skus/sku-formats/{skuFormatId}";
        if (skuFormatId === undefined || skuFormatId === null)
            throw new globalThis.Error("The parameter 'skuFormatId' must be defined.");
        url_ = url_.replace("{skuFormatId}", encodeURIComponent("" + skuFormatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuFormatById(_response);
        });
    }

    protected processGetSkuFormatById(response: AxiosResponse): Promise<ResponseOfSkuFormat> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkuFormat.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkuFormat>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkuFormat>(null as any);
    }

    deleteSkuFormat(skuFormatId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/sku-formats/{skuFormatId}";
        if (skuFormatId === undefined || skuFormatId === null)
            throw new globalThis.Error("The parameter 'skuFormatId' must be defined.");
        url_ = url_.replace("{skuFormatId}", encodeURIComponent("" + skuFormatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuFormat(_response);
        });
    }

    protected processDeleteSkuFormat(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuFormats(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuFormat> {
        let url_ = this.baseUrl + "/api/skus/sku-formats/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuFormats(_response);
        });
    }

    protected processGetSkuFormats(response: AxiosResponse): Promise<ListResponseOfSkuFormat> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuFormat.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuFormat>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuFormat>(null as any);
    }

    saveSkuFormat(skuFormatSaveRequest: SkuFormatSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/sku-formats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuFormatSaveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuFormat(_response);
        });
    }

    protected processSaveSkuFormat(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getSkuKnowledgeLevels(skuId: string, request: ListRequestOfSkuKnowledgeLevelFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuKnowledgeLevel> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/knowledgeLevels/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuKnowledgeLevels(_response);
        });
    }

    protected processGetSkuKnowledgeLevels(response: AxiosResponse): Promise<ListResponseOfSkuKnowledgeLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuKnowledgeLevel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuKnowledgeLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuKnowledgeLevel>(null as any);
    }

    saveSkuKnowledgeLevel(skuId: string, skuKnowledgeLevelRequest: SkuKnowledgeLevelRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/knowledgeLevels";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuKnowledgeLevelRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuKnowledgeLevel(_response);
        });
    }

    protected processSaveSkuKnowledgeLevel(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuKnowledgeLevel(skuKnowledgeLevelId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/knowledgeLevels/{skuKnowledgeLevelId}";
        if (skuKnowledgeLevelId === undefined || skuKnowledgeLevelId === null)
            throw new globalThis.Error("The parameter 'skuKnowledgeLevelId' must be defined.");
        url_ = url_.replace("{skuKnowledgeLevelId}", encodeURIComponent("" + skuKnowledgeLevelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuKnowledgeLevel(_response);
        });
    }

    protected processDeleteSkuKnowledgeLevel(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getKnowledgeLevels(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfKnowledgeLevel> {
        let url_ = this.baseUrl + "/api/skus/knowledge-levels/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeLevels(_response);
        });
    }

    protected processGetKnowledgeLevels(response: AxiosResponse): Promise<ListResponseOfKnowledgeLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfKnowledgeLevel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfKnowledgeLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfKnowledgeLevel>(null as any);
    }

    saveSkuLearningLevel(skuId: string, skuLearningLevelRequest: SkuLearningLevelRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/learningLevels";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuLearningLevelRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuLearningLevel(_response);
        });
    }

    protected processSaveSkuLearningLevel(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getSkuLearningLevels(skuId: string, request: ListRequestOfSkuLearningLevelFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuLearningLevel> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/learningLevels/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuLearningLevels(_response);
        });
    }

    protected processGetSkuLearningLevels(response: AxiosResponse): Promise<ListResponseOfSkuLearningLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuLearningLevel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuLearningLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuLearningLevel>(null as any);
    }

    deleteSkuLearningLevel(skuLearningLevelId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/learningLevels/{skuLearningLevelId}";
        if (skuLearningLevelId === undefined || skuLearningLevelId === null)
            throw new globalThis.Error("The parameter 'skuLearningLevelId' must be defined.");
        url_ = url_.replace("{skuLearningLevelId}", encodeURIComponent("" + skuLearningLevelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuLearningLevel(_response);
        });
    }

    protected processDeleteSkuLearningLevel(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getLearningLevels(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfLearningLevel> {
        let url_ = this.baseUrl + "/api/skus/learning-levels/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLearningLevels(_response);
        });
    }

    protected processGetLearningLevels(response: AxiosResponse): Promise<ListResponseOfLearningLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfLearningLevel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfLearningLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfLearningLevel>(null as any);
    }

    getSkuLearningObjectives(skuId: string, request: ListRequestOfSkuLearningObjectiveFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuLearningObjective> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/learningObjectives/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuLearningObjectives(_response);
        });
    }

    protected processGetSkuLearningObjectives(response: AxiosResponse): Promise<ListResponseOfSkuLearningObjective> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuLearningObjective.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuLearningObjective>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuLearningObjective>(null as any);
    }

    saveSkuLearningObjective(skuId: string, skuLearningObjectiveRequest: SkuLearningObjectiveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/learningObjectives";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuLearningObjectiveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuLearningObjective(_response);
        });
    }

    protected processSaveSkuLearningObjective(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuLearningObjective(skuLearningObjectiveId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/skus/learningObjectives/{skuLearningObjectiveId}";
        if (skuLearningObjectiveId === undefined || skuLearningObjectiveId === null)
            throw new globalThis.Error("The parameter 'skuLearningObjectiveId' must be defined.");
        url_ = url_.replace("{skuLearningObjectiveId}", encodeURIComponent("" + skuLearningObjectiveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuLearningObjective(_response);
        });
    }

    protected processDeleteSkuLearningObjective(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSkuMajorTopics(skuId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuMajorTopic> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/majorTopics/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuMajorTopics(_response);
        });
    }

    protected processGetSkuMajorTopics(response: AxiosResponse): Promise<ListResponseOfSkuMajorTopic> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuMajorTopic.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuMajorTopic>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuMajorTopic>(null as any);
    }

    saveSkuMajorTopic(skuId: string, skuMajorTopicRequest: SkuMajorTopicRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/majorTopic";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuMajorTopicRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuMajorTopic(_response);
        });
    }

    protected processSaveSkuMajorTopic(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuMajorTopic(skuMajorTopicId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/majorTopic/{skuMajorTopicId}";
        if (skuMajorTopicId === undefined || skuMajorTopicId === null)
            throw new globalThis.Error("The parameter 'skuMajorTopicId' must be defined.");
        url_ = url_.replace("{skuMajorTopicId}", encodeURIComponent("" + skuMajorTopicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuMajorTopic(_response);
        });
    }

    protected processDeleteSkuMajorTopic(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuProgressionGates(skuId: string, request: ListRequestOfSkuProgressionGateFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuProgressionGate> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/progression-gates/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuProgressionGates(_response);
        });
    }

    protected processGetSkuProgressionGates(response: AxiosResponse): Promise<ListResponseOfSkuProgressionGate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuProgressionGate.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuProgressionGate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuProgressionGate>(null as any);
    }

    deleteSkuProgressionGate(skuProgressionGateId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/progression-gate/{skuProgressionGateId}";
        if (skuProgressionGateId === undefined || skuProgressionGateId === null)
            throw new globalThis.Error("The parameter 'skuProgressionGateId' must be defined.");
        url_ = url_.replace("{skuProgressionGateId}", encodeURIComponent("" + skuProgressionGateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuProgressionGate(_response);
        });
    }

    protected processDeleteSkuProgressionGate(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveSkuProgressionGate(skuProgressionGateTypeRequest: SkuProgressionGateRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/progression-gates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuProgressionGateTypeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuProgressionGate(_response);
        });
    }

    protected processSaveSkuProgressionGate(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getAccreditationBodiesGroupedViewEnabled(request: AccreditationBodiesGroupedViewEnabledRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfSettingCache> {
        let url_ = this.baseUrl + "/api/skus/qualifications/grouped-view-enabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccreditationBodiesGroupedViewEnabled(_response);
        });
    }

    protected processGetAccreditationBodiesGroupedViewEnabled(response: AxiosResponse): Promise<ResponseOfSettingCache> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSettingCache.fromJS(resultData200);
            return Promise.resolve<ResponseOfSettingCache>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSettingCache>(null as any);
    }

    previewBulkSaveSkuQualifications(skuId: string, skuQualificationRequest: SkuQualificationRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfSkuQualificationPreviewResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/qualifications/preview";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuQualificationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewBulkSaveSkuQualifications(_response);
        });
    }

    protected processPreviewBulkSaveSkuQualifications(response: AxiosResponse): Promise<ResponseOfSkuQualificationPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkuQualificationPreviewResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkuQualificationPreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkuQualificationPreviewResponse>(null as any);
    }

    saveSkuQualification(skuId: string, skuQualificationRequest: SkuQualificationRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/qualifications";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuQualificationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuQualification(_response);
        });
    }

    protected processSaveSkuQualification(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuQualification(skuQualificationId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/skus/qualifications/{skuQualificationId}";
        if (skuQualificationId === undefined || skuQualificationId === null)
            throw new globalThis.Error("The parameter 'skuQualificationId' must be defined.");
        url_ = url_.replace("{skuQualificationId}", encodeURIComponent("" + skuQualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuQualification(_response);
        });
    }

    protected processDeleteSkuQualification(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSkuQualifications(skuId: string, request: ListRequestOfSkuQualificationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuQualificationView> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/qualifications/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuQualifications(_response);
        });
    }

    protected processGetSkuQualifications(response: AxiosResponse): Promise<ListResponseOfSkuQualificationView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuQualificationView.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuQualificationView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuQualificationView>(null as any);
    }

    getSkuQualificationSubjectAreas(skuQualificationId: string, cancelToken?: CancelToken): Promise<ListResponseOfSkuQualificationSubjectArea> {
        let url_ = this.baseUrl + "/api/skus/qualifications/{skuQualificationId}/subject-areas";
        if (skuQualificationId === undefined || skuQualificationId === null)
            throw new globalThis.Error("The parameter 'skuQualificationId' must be defined.");
        url_ = url_.replace("{skuQualificationId}", encodeURIComponent("" + skuQualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuQualificationSubjectAreas(_response);
        });
    }

    protected processGetSkuQualificationSubjectAreas(response: AxiosResponse): Promise<ListResponseOfSkuQualificationSubjectArea> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuQualificationSubjectArea.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuQualificationSubjectArea>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuQualificationSubjectArea>(null as any);
    }

    saveSkuQualificationSubjectAreas(skuQualificationId: string, requests: SkuQualificationSubjectAreaRequest[] | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/qualifications/{skuQualificationId}/subject-areas";
        if (skuQualificationId === undefined || skuQualificationId === null)
            throw new globalThis.Error("The parameter 'skuQualificationId' must be defined.");
        url_ = url_.replace("{skuQualificationId}", encodeURIComponent("" + skuQualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requests);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuQualificationSubjectAreas(_response);
        });
    }

    protected processSaveSkuQualificationSubjectAreas(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSubjectAreaOptions(accreditorId: string, cancelToken?: CancelToken): Promise<ListResponseOfSubjectAreaOption> {
        let url_ = this.baseUrl + "/api/skus/accreditors/{accreditorId}/subject-area-options";
        if (accreditorId === undefined || accreditorId === null)
            throw new globalThis.Error("The parameter 'accreditorId' must be defined.");
        url_ = url_.replace("{accreditorId}", encodeURIComponent("" + accreditorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubjectAreaOptions(_response);
        });
    }

    protected processGetSubjectAreaOptions(response: AxiosResponse): Promise<ListResponseOfSubjectAreaOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSubjectAreaOption.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSubjectAreaOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSubjectAreaOption>(null as any);
    }

    getLicensureBodySubjectAreaOptions(professionId: string, cancelToken?: CancelToken): Promise<ListResponseOfLicensureBodySubjectAreaOption> {
        let url_ = this.baseUrl + "/api/skus/professions/{professionId}/licensure-body-subject-area-options";
        if (professionId === undefined || professionId === null)
            throw new globalThis.Error("The parameter 'professionId' must be defined.");
        url_ = url_.replace("{professionId}", encodeURIComponent("" + professionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicensureBodySubjectAreaOptions(_response);
        });
    }

    protected processGetLicensureBodySubjectAreaOptions(response: AxiosResponse): Promise<ListResponseOfLicensureBodySubjectAreaOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfLicensureBodySubjectAreaOption.fromJS(resultData200);
            return Promise.resolve<ListResponseOfLicensureBodySubjectAreaOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfLicensureBodySubjectAreaOption>(null as any);
    }

    getChildSkusRelated(request: ListRequestOfSkuRelationshipFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuRelationship> {
        let url_ = this.baseUrl + "/api/skus/sku-relationship/skus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChildSkusRelated(_response);
        });
    }

    protected processGetChildSkusRelated(response: AxiosResponse): Promise<ListResponseOfSkuRelationship> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuRelationship.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuRelationship>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuRelationship>(null as any);
    }

    deleteChildSkusRelated(skuRelationshipId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/sku-relationship/{skuRelationshipId}";
        if (skuRelationshipId === undefined || skuRelationshipId === null)
            throw new globalThis.Error("The parameter 'skuRelationshipId' must be defined.");
        url_ = url_.replace("{skuRelationshipId}", encodeURIComponent("" + skuRelationshipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteChildSkusRelated(_response);
        });
    }

    protected processDeleteChildSkusRelated(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    addChildSkusRelated(request: SkuRelationshipRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/sku-relationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddChildSkusRelated(_response);
        });
    }

    protected processAddChildSkusRelated(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSkuRelationshipTypes( cancelToken?: CancelToken): Promise<ListResponseOfSkuRelationshipType> {
        let url_ = this.baseUrl + "/api/skus/sku-relationship/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuRelationshipTypes(_response);
        });
    }

    protected processGetSkuRelationshipTypes(response: AxiosResponse): Promise<ListResponseOfSkuRelationshipType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuRelationshipType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuRelationshipType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuRelationshipType>(null as any);
    }

    saveSkuRelationshipSequence(skuId: string, request: SkuRelationshipSequenceRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/sku-relationship/skus/{skuId}/sequence";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuRelationshipSequence(_response);
        });
    }

    protected processSaveSkuRelationshipSequence(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getSkuResources(skuId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuResource> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/resources/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuResources(_response);
        });
    }

    protected processGetSkuResources(response: AxiosResponse): Promise<ListResponseOfSkuResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuResource.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuResource>(null as any);
    }

    saveSkuResource(skuId: string, skuResourceRequest: SkuResourceRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/resources";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuResourceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuResource(_response);
        });
    }

    protected processSaveSkuResource(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveSkuResourceSequence(skuId: string, skuResourceSequenceRequest: SkuResourceSequenceRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/resources/update-sequence";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuResourceSequenceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuResourceSequence(_response);
        });
    }

    protected processSaveSkuResourceSequence(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuResource(skuResourceId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/resources/{skuResourceId}";
        if (skuResourceId === undefined || skuResourceId === null)
            throw new globalThis.Error("The parameter 'skuResourceId' must be defined.");
        url_ = url_.replace("{skuResourceId}", encodeURIComponent("" + skuResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuResource(_response);
        });
    }

    protected processDeleteSkuResource(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getResourceTypes(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceType> {
        let url_ = this.baseUrl + "/api/skus/resource-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceTypes(_response);
        });
    }

    protected processGetResourceTypes(response: AxiosResponse): Promise<ListResponseOfResourceType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceType>(null as any);
    }

    getSkuStatusById(skuStatusId: string, cancelToken?: CancelToken): Promise<ResponseOfSkuStatus> {
        let url_ = this.baseUrl + "/api/skus/statuses/{skuStatusId}";
        if (skuStatusId === undefined || skuStatusId === null)
            throw new globalThis.Error("The parameter 'skuStatusId' must be defined.");
        url_ = url_.replace("{skuStatusId}", encodeURIComponent("" + skuStatusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuStatusById(_response);
        });
    }

    protected processGetSkuStatusById(response: AxiosResponse): Promise<ResponseOfSkuStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkuStatus.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkuStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkuStatus>(null as any);
    }

    getSkuStatuses(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuStatus> {
        let url_ = this.baseUrl + "/api/skus/statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuStatuses(_response);
        });
    }

    protected processGetSkuStatuses(response: AxiosResponse): Promise<ListResponseOfSkuStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuStatus>(null as any);
    }

    getSkuStudyFields(skuId: string, request: ListRequestOfSkuStudyFieldFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuStudyField> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/studyFields/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuStudyFields(_response);
        });
    }

    protected processGetSkuStudyFields(response: AxiosResponse): Promise<ListResponseOfSkuStudyField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuStudyField.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuStudyField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuStudyField>(null as any);
    }

    saveSkuStudyField(skuId: string, skuStudyFieldRequest: SkuStudyFieldRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/studyFields";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuStudyFieldRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuStudyField(_response);
        });
    }

    protected processSaveSkuStudyField(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuStudyField(skuStudyFieldId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/studyFields/{skuStudyFieldId}";
        if (skuStudyFieldId === undefined || skuStudyFieldId === null)
            throw new globalThis.Error("The parameter 'skuStudyFieldId' must be defined.");
        url_ = url_.replace("{skuStudyFieldId}", encodeURIComponent("" + skuStudyFieldId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuStudyField(_response);
        });
    }

    protected processDeleteSkuStudyField(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getStudyFields(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfStudyField> {
        let url_ = this.baseUrl + "/api/skus/study-fields/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyFields(_response);
        });
    }

    protected processGetStudyFields(response: AxiosResponse): Promise<ListResponseOfStudyField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfStudyField.fromJS(resultData200);
            return Promise.resolve<ListResponseOfStudyField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfStudyField>(null as any);
    }

    getSkuTags(skuId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSkuTag> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/tags/all";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuTags(_response);
        });
    }

    protected processGetSkuTags(response: AxiosResponse): Promise<ListResponseOfSkuTag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuTag.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuTag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuTag>(null as any);
    }

    searchTagSuggestions(skuId: string, request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfTag> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/tags/suggestions";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchTagSuggestions(_response);
        });
    }

    protected processSearchTagSuggestions(response: AxiosResponse): Promise<ListResponseOfTag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTag.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTag>(null as any);
    }

    getAvailableTags( cancelToken?: CancelToken): Promise<ListResponseOfTag> {
        let url_ = this.baseUrl + "/api/skus/tags/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableTags(_response);
        });
    }

    protected processGetAvailableTags(response: AxiosResponse): Promise<ListResponseOfTag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTag.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTag>(null as any);
    }

    getTagByCodeConstant(codeConstant: string, cancelToken?: CancelToken): Promise<ResponseOfTag> {
        let url_ = this.baseUrl + "/api/skus/tags/code/{codeConstant}";
        if (codeConstant === undefined || codeConstant === null)
            throw new globalThis.Error("The parameter 'codeConstant' must be defined.");
        url_ = url_.replace("{codeConstant}", encodeURIComponent("" + codeConstant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagByCodeConstant(_response);
        });
    }

    protected processGetTagByCodeConstant(response: AxiosResponse): Promise<ResponseOfTag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfTag.fromJS(resultData200);
            return Promise.resolve<ResponseOfTag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfTag>(null as any);
    }

    saveSkuTag(skuId: string, skuTagRequest: SkuTagRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/skus/{skuId}/tags";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuTagRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuTag(_response);
        });
    }

    protected processSaveSkuTag(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteSkuTag(skuTagId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/skus/tags/{skuTagId}";
        if (skuTagId === undefined || skuTagId === null)
            throw new globalThis.Error("The parameter 'skuTagId' must be defined.");
        url_ = url_.replace("{skuTagId}", encodeURIComponent("" + skuTagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSkuTag(_response);
        });
    }

    protected processDeleteSkuTag(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class SeriesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    saveModule(seriesId: string, request: SaveModule | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/series/{seriesId}/modules";
        if (seriesId === undefined || seriesId === null)
            throw new globalThis.Error("The parameter 'seriesId' must be defined.");
        url_ = url_.replace("{seriesId}", encodeURIComponent("" + seriesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveModule(_response);
        });
    }

    protected processSaveModule(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteModule(moduleId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/series/{moduleId}";
        if (moduleId === undefined || moduleId === null)
            throw new globalThis.Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModule(_response);
        });
    }

    protected processDeleteModule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateModulesSequence(seriesId: string, moduleIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/series/{seriesId}/modules/update-sequence";
        if (seriesId === undefined || seriesId === null)
            throw new globalThis.Error("The parameter 'seriesId' must be defined.");
        url_ = url_.replace("{seriesId}", encodeURIComponent("" + seriesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModulesSequence(_response);
        });
    }

    protected processUpdateModulesSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveRequirement(moduleId: string, request: SaveRequirement | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/series/modules/{moduleId}/requirements";
        if (moduleId === undefined || moduleId === null)
            throw new globalThis.Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequirement(_response);
        });
    }

    protected processSaveRequirement(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteRequirement(requirementId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/series/modules/requirements/{requirementId}";
        if (requirementId === undefined || requirementId === null)
            throw new globalThis.Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRequirement(_response);
        });
    }

    protected processDeleteRequirement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateRequirementsSequence(seriesId: string, requirementIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/series/{seriesId}/modules/requirements/update-sequence";
        if (seriesId === undefined || seriesId === null)
            throw new globalThis.Error("The parameter 'seriesId' must be defined.");
        url_ = url_.replace("{seriesId}", encodeURIComponent("" + seriesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requirementIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRequirementsSequence(_response);
        });
    }

    protected processUpdateRequirementsSequence(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getSeries(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSeriesItem> {
        let url_ = this.baseUrl + "/api/series/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSeries(_response);
        });
    }

    protected processGetSeries(response: AxiosResponse): Promise<ListResponseOfSeriesItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSeriesItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSeriesItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSeriesItem>(null as any);
    }

    getSeriesById(seriesId: string, cancelToken?: CancelToken): Promise<ResponseOfSeries> {
        let url_ = this.baseUrl + "/api/series/{seriesId}";
        if (seriesId === undefined || seriesId === null)
            throw new globalThis.Error("The parameter 'seriesId' must be defined.");
        url_ = url_.replace("{seriesId}", encodeURIComponent("" + seriesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSeriesById(_response);
        });
    }

    protected processGetSeriesById(response: AxiosResponse): Promise<ResponseOfSeries> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSeries.fromJS(resultData200);
            return Promise.resolve<ResponseOfSeries>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSeries>(null as any);
    }

    savePriorRequirementRequired(request: SavePriorRequirementRequiredRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/series/prior-requirement-required";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePriorRequirementRequired(_response);
        });
    }

    protected processSavePriorRequirementRequired(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class ResourceService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    saveResource(resourceRequest: ResourceRequestV2 | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/resources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resourceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveResource(_response);
        });
    }

    protected processSaveResource(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getResources(request: ListRequestOfResourceFilterV2 | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceV2ListItem> {
        let url_ = this.baseUrl + "/api/resources/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResources(_response);
        });
    }

    protected processGetResources(response: AxiosResponse): Promise<ListResponseOfResourceV2ListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceV2ListItem.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceV2ListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceV2ListItem>(null as any);
    }

    getResource(resourceId: string, cancelToken?: CancelToken): Promise<ResponseOfResourceV2> {
        let url_ = this.baseUrl + "/api/resources/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResource(_response);
        });
    }

    protected processGetResource(response: AxiosResponse): Promise<ResponseOfResourceV2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfResourceV2.fromJS(resultData200);
            return Promise.resolve<ResponseOfResourceV2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfResourceV2>(null as any);
    }

    deleteResource(resourceId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/resources/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteResource(_response);
        });
    }

    protected processDeleteResource(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    linkFacultyPortalUser(request: AdminLinkFacultyPortalUserRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveUserResponse> {
        let url_ = this.baseUrl + "/api/resources/link-faculty-portal-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkFacultyPortalUser(_response);
        });
    }

    protected processLinkFacultyPortalUser(response: AxiosResponse): Promise<SaveUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveUserResponse.fromJS(resultData200);
            return Promise.resolve<SaveUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveUserResponse>(null as any);
    }

    unlinkFacultyPortalUser(request: AdminUnlinkFacultyPortalUserRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/resources/unlink-faculty-portal-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkFacultyPortalUser(_response);
        });
    }

    protected processUnlinkFacultyPortalUser(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getResourceByOrganizationUserId(organizationUserId: string, cancelToken?: CancelToken): Promise<ResponseOfResourceV2> {
        let url_ = this.baseUrl + "/api/resources/by-organization-user/{organizationUserId}";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceByOrganizationUserId(_response);
        });
    }

    protected processGetResourceByOrganizationUserId(response: AxiosResponse): Promise<ResponseOfResourceV2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfResourceV2.fromJS(resultData200);
            return Promise.resolve<ResponseOfResourceV2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfResourceV2>(null as any);
    }

    hasPendingOrAcceptedAgreement(request: HasPendingOrAcceptedAgreementRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/resources/has-pending-or-accepted-agreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasPendingOrAcceptedAgreement(_response);
        });
    }

    protected processHasPendingOrAcceptedAgreement(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }
}

export class ProgressionGateService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProgressionGateTypes(request: ListRequestOfProgressionGateTypeFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProgressionGateType> {
        let url_ = this.baseUrl + "/api/course-progression/gate-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProgressionGateTypes(_response);
        });
    }

    protected processGetProgressionGateTypes(response: AxiosResponse): Promise<ListResponseOfProgressionGateType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProgressionGateType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProgressionGateType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProgressionGateType>(null as any);
    }
}

export class ProductService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProductsV2(request: AdminListRequestOfProductFilterV2 | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProduct> {
        let url_ = this.baseUrl + "/api/products/v2/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsV2(_response);
        });
    }

    protected processGetProductsV2(response: AxiosResponse): Promise<ListResponseOfProduct> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProduct.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProduct>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProduct>(null as any);
    }

    getProductById(productId: string, cancelToken?: CancelToken): Promise<ResponseOfProduct> {
        let url_ = this.baseUrl + "/api/products/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductById(_response);
        });
    }

    protected processGetProductById(response: AxiosResponse): Promise<ResponseOfProduct> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfProduct.fromJS(resultData200);
            return Promise.resolve<ResponseOfProduct>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfProduct>(null as any);
    }

    disableProduct(productId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/products/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableProduct(_response);
        });
    }

    protected processDisableProduct(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveProduct(product: SaveProduct | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProduct(_response);
        });
    }

    protected processSaveProduct(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getProductTypeById(productTypeId: string, cancelToken?: CancelToken): Promise<ResponseOfProductType> {
        let url_ = this.baseUrl + "/api/products/types/{productTypeId}";
        if (productTypeId === undefined || productTypeId === null)
            throw new globalThis.Error("The parameter 'productTypeId' must be defined.");
        url_ = url_.replace("{productTypeId}", encodeURIComponent("" + productTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductTypeById(_response);
        });
    }

    protected processGetProductTypeById(response: AxiosResponse): Promise<ResponseOfProductType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfProductType.fromJS(resultData200);
            return Promise.resolve<ResponseOfProductType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfProductType>(null as any);
    }

    getProductTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProductType> {
        let url_ = this.baseUrl + "/api/products/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductTypes(_response);
        });
    }

    protected processGetProductTypes(response: AxiosResponse): Promise<ListResponseOfProductType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProductType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProductType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProductType>(null as any);
    }

    getProductVersionById(productVersionId: string, cancelToken?: CancelToken): Promise<ResponseOfProductVersion> {
        let url_ = this.baseUrl + "/api/products/versions/{productVersionId}";
        if (productVersionId === undefined || productVersionId === null)
            throw new globalThis.Error("The parameter 'productVersionId' must be defined.");
        url_ = url_.replace("{productVersionId}", encodeURIComponent("" + productVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductVersionById(_response);
        });
    }

    protected processGetProductVersionById(response: AxiosResponse): Promise<ResponseOfProductVersion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfProductVersion.fromJS(resultData200);
            return Promise.resolve<ResponseOfProductVersion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfProductVersion>(null as any);
    }

    deleteProductVersion(productVersionId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/products/versions/{productVersionId}";
        if (productVersionId === undefined || productVersionId === null)
            throw new globalThis.Error("The parameter 'productVersionId' must be defined.");
        url_ = url_.replace("{productVersionId}", encodeURIComponent("" + productVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProductVersion(_response);
        });
    }

    protected processDeleteProductVersion(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getProductVersions(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProductVersion> {
        let url_ = this.baseUrl + "/api/products/versions/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductVersions(_response);
        });
    }

    protected processGetProductVersions(response: AxiosResponse): Promise<ListResponseOfProductVersion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProductVersion.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProductVersion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProductVersion>(null as any);
    }

    saveProductVersion(saveProductVersion: SaveProductVersion | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/products/versions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveProductVersion);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProductVersion(_response);
        });
    }

    protected processSaveProductVersion(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getProductYearById(productYearId: string, cancelToken?: CancelToken): Promise<ResponseOfProductYear> {
        let url_ = this.baseUrl + "/api/products/years/{productYearId}";
        if (productYearId === undefined || productYearId === null)
            throw new globalThis.Error("The parameter 'productYearId' must be defined.");
        url_ = url_.replace("{productYearId}", encodeURIComponent("" + productYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductYearById(_response);
        });
    }

    protected processGetProductYearById(response: AxiosResponse): Promise<ResponseOfProductYear> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfProductYear.fromJS(resultData200);
            return Promise.resolve<ResponseOfProductYear>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfProductYear>(null as any);
    }

    getProductYears(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfProductYear> {
        let url_ = this.baseUrl + "/api/products/years/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductYears(_response);
        });
    }

    protected processGetProductYears(response: AxiosResponse): Promise<ListResponseOfProductYear> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProductYear.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProductYear>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProductYear>(null as any);
    }
}

export class LocationTypeService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLocationTypes(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfLocationType> {
        let url_ = this.baseUrl + "/api/locations/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationTypes(_response);
        });
    }

    protected processGetLocationTypes(response: AxiosResponse): Promise<ListResponseOfLocationType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfLocationType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfLocationType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfLocationType>(null as any);
    }
}

export class CatalogService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCorporateEntityById(corporateEntityId: string, cancelToken?: CancelToken): Promise<ResponseOfCorporateEntity> {
        let url_ = this.baseUrl + "/api/catalogs/corporate-entities/{corporateEntityId}";
        if (corporateEntityId === undefined || corporateEntityId === null)
            throw new globalThis.Error("The parameter 'corporateEntityId' must be defined.");
        url_ = url_.replace("{corporateEntityId}", encodeURIComponent("" + corporateEntityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCorporateEntityById(_response);
        });
    }

    protected processGetCorporateEntityById(response: AxiosResponse): Promise<ResponseOfCorporateEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCorporateEntity.fromJS(resultData200);
            return Promise.resolve<ResponseOfCorporateEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCorporateEntity>(null as any);
    }

    getCorporateEntities(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCorporateEntity> {
        let url_ = this.baseUrl + "/api/catalogs/corporate-entities/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCorporateEntities(_response);
        });
    }

    protected processGetCorporateEntities(response: AxiosResponse): Promise<ListResponseOfCorporateEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCorporateEntity.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCorporateEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCorporateEntity>(null as any);
    }

    syncCatalogs( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/catalogs/sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncCatalogs(_response);
        });
    }

    protected processSyncCatalogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    buildCatalogs( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/catalogs/build";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildCatalogs(_response);
        });
    }

    protected processBuildCatalogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getQualifications(request: AdminListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQualification> {
        let url_ = this.baseUrl + "/api/catalogs/qualifications/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualifications(_response);
        });
    }

    protected processGetQualifications(response: AxiosResponse): Promise<ListResponseOfQualification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQualification.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQualification>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQualification>(null as any);
    }
}

export class AttributeService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAttributes(request: ListRequestOfAttributeFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAttribute> {
        let url_ = this.baseUrl + "/api/attributes/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttributes(_response);
        });
    }

    protected processGetAttributes(response: AxiosResponse): Promise<ListResponseOfAttribute> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAttribute.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAttribute>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAttribute>(null as any);
    }

    getAttributeById(attributeId: string, cancelToken?: CancelToken): Promise<ResponseOfAttribute> {
        let url_ = this.baseUrl + "/api/attributes/{attributeId}";
        if (attributeId === undefined || attributeId === null)
            throw new globalThis.Error("The parameter 'attributeId' must be defined.");
        url_ = url_.replace("{attributeId}", encodeURIComponent("" + attributeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttributeById(_response);
        });
    }

    protected processGetAttributeById(response: AxiosResponse): Promise<ResponseOfAttribute> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAttribute.fromJS(resultData200);
            return Promise.resolve<ResponseOfAttribute>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAttribute>(null as any);
    }

    deleteAttribute(attributeId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/attributes/{attributeId}";
        if (attributeId === undefined || attributeId === null)
            throw new globalThis.Error("The parameter 'attributeId' must be defined.");
        url_ = url_.replace("{attributeId}", encodeURIComponent("" + attributeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAttribute(_response);
        });
    }

    protected processDeleteAttribute(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    saveAttribute(saveAttributeRequest: SaveAttributeRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/attributes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveAttributeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAttribute(_response);
        });
    }

    protected processSaveAttribute(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getAttributeTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAttributeType> {
        let url_ = this.baseUrl + "/api/attributes/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttributeTypes(_response);
        });
    }

    protected processGetAttributeTypes(response: AxiosResponse): Promise<ListResponseOfAttributeType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAttributeType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAttributeType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAttributeType>(null as any);
    }

    getOrganizationAttributeTypes(request: OrganizationAttributeTypeRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationAttributeType> {
        let url_ = this.baseUrl + "/api/attributes/organization-attribute-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationAttributeTypes(_response);
        });
    }

    protected processGetOrganizationAttributeTypes(response: AxiosResponse): Promise<ListResponseOfOrganizationAttributeType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationAttributeType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationAttributeType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationAttributeType>(null as any);
    }
}

export class ClaimService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getClaims( cancelToken?: CancelToken): Promise<ListResponseOfClaim> {
        let url_ = this.baseUrl + "/api/claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClaims(_response);
        });
    }

    protected processGetClaims(response: AxiosResponse): Promise<ListResponseOfClaim> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfClaim.fromJS(resultData200);
            return Promise.resolve<ListResponseOfClaim>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfClaim>(null as any);
    }
}

export class RoleService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRoles(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRole> {
        let url_ = this.baseUrl + "/api/roles/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<ListResponseOfRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRole.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRole>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRole>(null as any);
    }

    getRole(roleId: string, cancelToken?: CancelToken): Promise<ResponseOfRoleDetails> {
        let url_ = this.baseUrl + "/api/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRole(_response);
        });
    }

    protected processGetRole(response: AxiosResponse): Promise<ResponseOfRoleDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRoleDetails.fromJS(resultData200);
            return Promise.resolve<ResponseOfRoleDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRoleDetails>(null as any);
    }

    saveRole(request: SaveRoleRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRole(_response);
        });
    }

    protected processSaveRole(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class TimeZoneService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTimeZones( cancelToken?: CancelToken): Promise<ListResponseOfTimeZone> {
        let url_ = this.baseUrl + "/api/time-zones/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeZones(_response);
        });
    }

    protected processGetTimeZones(response: AxiosResponse): Promise<ListResponseOfTimeZone> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTimeZone.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTimeZone>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTimeZone>(null as any);
    }
}

export class UserService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    deleteUsers(userIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUsers(_response);
        });
    }

    protected processDeleteUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveUser(saveUserRequest: SaveUserRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveUserRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUser(_response);
        });
    }

    protected processSaveUser(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    impersonateUser(model: CreateUserLoginRequest | null | undefined, cancelToken?: CancelToken): Promise<ImpersonationResponse> {
        let url_ = this.baseUrl + "/api/users/impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateUser(_response);
        });
    }

    protected processImpersonateUser(response: AxiosResponse): Promise<ImpersonationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpersonationResponse.fromJS(resultData200);
            return Promise.resolve<ImpersonationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpersonationResponse>(null as any);
    }

    createUserLoginUrl(model: CreateUserLoginRequest | null | undefined, cancelToken?: CancelToken): Promise<UserLoginUrlResponse> {
        let url_ = this.baseUrl + "/api/users/create-login-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserLoginUrl(_response);
        });
    }

    protected processCreateUserLoginUrl(response: AxiosResponse): Promise<UserLoginUrlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserLoginUrlResponse.fromJS(resultData200);
            return Promise.resolve<UserLoginUrlResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLoginUrlResponse>(null as any);
    }

    mergeUser(model: MergeUserRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/users/merge-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMergeUser(_response);
        });
    }

    protected processMergeUser(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    syncUsers(userIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/users/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncUsers(_response);
        });
    }

    protected processSyncUsers(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getUserCredentials(organizationUserId: string, cancelToken?: CancelToken): Promise<GetUserCredentialsResponse> {
        let url_ = this.baseUrl + "/api/users/{organizationUserId}/user-credentials";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCredentials(_response);
        });
    }

    protected processGetUserCredentials(response: AxiosResponse): Promise<GetUserCredentialsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserCredentialsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserCredentialsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserCredentialsResponse>(null as any);
    }
}

export class TestDataGenerationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    generateWebinar(request: GenerateWebinarRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/test-data-generation/generate-webinar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateWebinar(_response);
        });
    }

    protected processGenerateWebinar(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class ApplicationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAdminApplications(request: ListRequestOfAdminApplicationFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfApplication> {
        let url_ = this.baseUrl + "/api/applications/admin/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminApplications(_response);
        });
    }

    protected processGetAdminApplications(response: AxiosResponse): Promise<ListResponseOfApplication> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfApplication.fromJS(resultData200);
            return Promise.resolve<ListResponseOfApplication>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfApplication>(null as any);
    }

    getApplicationsByOrganizationUsers(request: ListRequestOfApplicationsByOrganizationUsersFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfApplication> {
        let url_ = this.baseUrl + "/api/applications/by-organization-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationsByOrganizationUsers(_response);
        });
    }

    protected processGetApplicationsByOrganizationUsers(response: AxiosResponse): Promise<ListResponseOfApplication> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfApplication.fromJS(resultData200);
            return Promise.resolve<ListResponseOfApplication>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfApplication>(null as any);
    }

    getApplication(applicationId: string, cancelToken?: CancelToken): Promise<ResponseOfApplication> {
        let url_ = this.baseUrl + "/api/applications/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplication(_response);
        });
    }

    protected processGetApplication(response: AxiosResponse): Promise<ResponseOfApplication> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfApplication.fromJS(resultData200);
            return Promise.resolve<ResponseOfApplication>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfApplication>(null as any);
    }
}

export class ApplicationInstanceSettingService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isPrintReferenceEnabled(request: PrintReferenceRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/application-instance-settings/is-print-reference-enabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsPrintReferenceEnabled(_response);
        });
    }

    protected processIsPrintReferenceEnabled(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }
}

export class TemplateService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTemplates(request: AdminListRequestOfTemplateFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfTemplateAdmin> {
        let url_ = this.baseUrl + "/api/templates/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplates(_response);
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<ListResponseOfTemplateAdmin> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTemplateAdmin.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTemplateAdmin>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTemplateAdmin>(null as any);
    }

    getTemplate(templateId: string, cancelToken?: CancelToken): Promise<ResponseOfTemplateAdmin> {
        let url_ = this.baseUrl + "/api/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplate(_response);
        });
    }

    protected processGetTemplate(response: AxiosResponse): Promise<ResponseOfTemplateAdmin> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfTemplateAdmin.fromJS(resultData200);
            return Promise.resolve<ResponseOfTemplateAdmin>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfTemplateAdmin>(null as any);
    }

    deleteTemplate(templateId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTemplate(_response);
        });
    }

    protected processDeleteTemplate(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getTemplatePublished(templateId: string, cancelToken?: CancelToken): Promise<ResponseOfTemplateAdmin> {
        let url_ = this.baseUrl + "/api/templates/{templateId}/published";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplatePublished(_response);
        });
    }

    protected processGetTemplatePublished(response: AxiosResponse): Promise<ResponseOfTemplateAdmin> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfTemplateAdmin.fromJS(resultData200);
            return Promise.resolve<ResponseOfTemplateAdmin>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfTemplateAdmin>(null as any);
    }

    saveTemplate(request: TemplateSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTemplate(_response);
        });
    }

    protected processSaveTemplate(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    saveTemplateVersion(request: TemplateVersionSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/templates/version";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTemplateVersion(_response);
        });
    }

    protected processSaveTemplateVersion(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    publishTemplateVersion(templateId: string, versionId: string, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/templates/{templateId}/version/{versionId}/publish";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishTemplateVersion(_response);
        });
    }

    protected processPublishTemplateVersion(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    discardTemplateVersion(versionId: string, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/templates/version/{versionId}/discard";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardTemplateVersion(_response);
        });
    }

    protected processDiscardTemplateVersion(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    getTemplateTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfTemplateTypeAdmin> {
        let url_ = this.baseUrl + "/api/templates/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateTypes(_response);
        });
    }

    protected processGetTemplateTypes(response: AxiosResponse): Promise<ListResponseOfTemplateTypeAdmin> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTemplateTypeAdmin.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTemplateTypeAdmin>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTemplateTypeAdmin>(null as any);
    }

    getEntityTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfTemplateEntityAdmin> {
        let url_ = this.baseUrl + "/api/templates/entity-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntityTypes(_response);
        });
    }

    protected processGetEntityTypes(response: AxiosResponse): Promise<ListResponseOfTemplateEntityAdmin> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfTemplateEntityAdmin.fromJS(resultData200);
            return Promise.resolve<ListResponseOfTemplateEntityAdmin>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfTemplateEntityAdmin>(null as any);
    }

    getCodeConstants(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCodeConstant> {
        let url_ = this.baseUrl + "/api/templates/code-constants/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodeConstants(_response);
        });
    }

    protected processGetCodeConstants(response: AxiosResponse): Promise<ListResponseOfCodeConstant> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCodeConstant.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCodeConstant>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCodeConstant>(null as any);
    }

    getPlaceholders(filter: AdminListRequestOfPlaceholderFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfPlaceholderAdmin> {
        let url_ = this.baseUrl + "/api/templates/placeholders/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaceholders(_response);
        });
    }

    protected processGetPlaceholders(response: AxiosResponse): Promise<ListResponseOfPlaceholderAdmin> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfPlaceholderAdmin.fromJS(resultData200);
            return Promise.resolve<ListResponseOfPlaceholderAdmin>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfPlaceholderAdmin>(null as any);
    }

    getTemplateByPlaceholderName(placeholderName: string, cancelToken?: CancelToken): Promise<ResponseOfTemplatesByPlaceholderName> {
        let url_ = this.baseUrl + "/api/templates/placeholders/{placeholderName}";
        if (placeholderName === undefined || placeholderName === null)
            throw new globalThis.Error("The parameter 'placeholderName' must be defined.");
        url_ = url_.replace("{placeholderName}", encodeURIComponent("" + placeholderName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateByPlaceholderName(_response);
        });
    }

    protected processGetTemplateByPlaceholderName(response: AxiosResponse): Promise<ResponseOfTemplatesByPlaceholderName> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfTemplatesByPlaceholderName.fromJS(resultData200);
            return Promise.resolve<ResponseOfTemplatesByPlaceholderName>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfTemplatesByPlaceholderName>(null as any);
    }

    getVersionPreview(versionId: string, organizationId: string | undefined, cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/api/templates/version/{versionId}/preview?";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersionPreview(_response);
        });
    }

    protected processGetVersionPreview(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }
}

export class PartnerService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPartners(filter: ListRequestOfOrganizationIdFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAdminPartner> {
        let url_ = this.baseUrl + "/api/partners/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartners(_response);
        });
    }

    protected processGetPartners(response: AxiosResponse): Promise<ListResponseOfAdminPartner> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAdminPartner.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAdminPartner>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAdminPartner>(null as any);
    }

    savePartner(request: PartnerSaveRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/partners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePartner(_response);
        });
    }

    protected processSavePartner(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }
}

export class RequestService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRequests(filter: ListRequestOfRequestFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRequest> {
        let url_ = this.baseUrl + "/api/request/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequests(_response);
        });
    }

    protected processGetRequests(response: AxiosResponse): Promise<ListResponseOfRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRequest.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRequest>(null as any);
    }

    getRequestStatuses(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRequestStatus> {
        let url_ = this.baseUrl + "/api/request/statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestStatuses(_response);
        });
    }

    protected processGetRequestStatuses(response: AxiosResponse): Promise<ListResponseOfRequestStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRequestStatus.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRequestStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRequestStatus>(null as any);
    }

    getRequestTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfRequestType> {
        let url_ = this.baseUrl + "/api/request/types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestTypes(_response);
        });
    }

    protected processGetRequestTypes(response: AxiosResponse): Promise<ListResponseOfRequestType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfRequestType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfRequestType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfRequestType>(null as any);
    }

    requestReprocess(request: ListRequestOfRequestReprocess | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/request/reprocess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestReprocess(_response);
        });
    }

    protected processRequestReprocess(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class UserCredentialService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserCredentials(organizationUserId: string, cancelToken?: CancelToken): Promise<GetUserCredentialsResponse> {
        let url_ = this.baseUrl + "/api/user-credentials/by-organization-user/{organizationUserId}";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCredentials(_response);
        });
    }

    protected processGetUserCredentials(response: AxiosResponse): Promise<GetUserCredentialsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserCredentialsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserCredentialsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserCredentialsResponse>(null as any);
    }

    saveUserCredentials(request: SaveUserCredentialsRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/user-credentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUserCredentials(_response);
        });
    }

    protected processSaveUserCredentials(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    deleteUserCredentials(request: DeleteUserCredentialsRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/user-credentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserCredentials(_response);
        });
    }

    protected processDeleteUserCredentials(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getUserCredentialTypes( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/user-credentials/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCredentialTypes(_response);
        });
    }

    protected processGetUserCredentialTypes(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }
}

export class AuthenticationV2Service {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    loginComplete(sessionId: string | undefined, cancelToken?: CancelToken): Promise<ResponseOfAuthenticationResponse> {
        let url_ = this.baseUrl + "/authentication/v2/logincomplete?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginComplete(_response);
        });
    }

    protected processLoginComplete(response: AxiosResponse): Promise<ResponseOfAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAuthenticationResponse>(null as any);
    }

    getAuthenticationResponse( cancelToken?: CancelToken): Promise<ResponseOfAuthenticationResponse> {
        let url_ = this.baseUrl + "/authentication/v2/authentication-response";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthenticationResponse(_response);
        });
    }

    protected processGetAuthenticationResponse(response: AxiosResponse): Promise<ResponseOfAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAuthenticationResponse>(null as any);
    }

    stopImpersonating( cancelToken?: CancelToken): Promise<ResponseOfRedirectUrl> {
        let url_ = this.baseUrl + "/authentication/v2/stop-impersonating";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopImpersonating(_response);
        });
    }

    protected processStopImpersonating(response: AxiosResponse): Promise<ResponseOfRedirectUrl> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRedirectUrl.fromJS(resultData200);
            return Promise.resolve<ResponseOfRedirectUrl>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRedirectUrl>(null as any);
    }

    isAuthenticated( cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/authentication/v2/is-authenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthenticated(_response);
        });
    }

    protected processIsAuthenticated(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    getAuthData( cancelToken?: CancelToken): Promise<AuthData> {
        let url_ = this.baseUrl + "/authentication/v2/auth-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthData(_response);
        });
    }

    protected processGetAuthData(response: AxiosResponse): Promise<AuthData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthData.fromJS(resultData200);
            return Promise.resolve<AuthData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthData>(null as any);
    }

    switchApplication( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/authentication/v2/switch-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchApplication(_response);
        });
    }

    protected processSwitchApplication(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TelemetryService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getConnectionString( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/telemetry/connection-string";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectionString(_response);
        });
    }

    protected processGetConnectionString(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ResponseOfListOfMediaItemAndString implements IResponseOfListOfMediaItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MediaItem[] | undefined;

    constructor(data?: IResponseOfListOfMediaItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MediaItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfMediaItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMediaItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfMediaItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MediaItem[] | undefined;
}

export class ResponseOfListOfMediaItem extends ResponseOfListOfMediaItemAndString implements IResponseOfListOfMediaItem {

    constructor(data?: IResponseOfListOfMediaItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfMediaItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMediaItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfMediaItem extends IResponseOfListOfMediaItemAndString {
}

export class ListResponseOfMediaItem extends ResponseOfListOfMediaItem implements IListResponseOfMediaItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfMediaItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfMediaItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfMediaItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfMediaItem extends IResponseOfListOfMediaItem {
    totalRecords?: number | undefined;
}

export enum ResponseCode {
    OK = "OK",
    UserDeleted = "UserDeleted",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    ValidationFailed = "ValidationFailed",
    NotFound = "NotFound",
    BusinessRuleFailed = "BusinessRuleFailed",
    AuthenticationExpired = "AuthenticationExpired",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    InternalServerError = "InternalServerError",
    ServiceUnavailable = "ServiceUnavailable",
}

export class MediaItem implements IMediaItem {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    alternativeText?: string | undefined;
    description?: string | undefined;
    fileUrl?: string | undefined;
    originalFileUrl?: string | undefined;
    fileSize?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    dimensions?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;

    constructor(data?: IMediaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.alternativeText = _data["alternativeText"];
            this.description = _data["description"];
            this.fileUrl = _data["fileUrl"];
            this.originalFileUrl = _data["originalFileUrl"];
            this.fileSize = _data["fileSize"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.dimensions = _data["dimensions"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): MediaItem {
        data = typeof data === 'object' ? data : {};
        let result = new MediaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["alternativeText"] = this.alternativeText;
        data["description"] = this.description;
        data["fileUrl"] = this.fileUrl;
        data["originalFileUrl"] = this.originalFileUrl;
        data["fileSize"] = this.fileSize;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["dimensions"] = this.dimensions;
        data["width"] = this.width;
        data["height"] = this.height;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IMediaItem {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    alternativeText?: string | undefined;
    description?: string | undefined;
    fileUrl?: string | undefined;
    originalFileUrl?: string | undefined;
    fileSize?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    dimensions?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
}

export class ListRequestOfContentTypeFilter implements IListRequestOfContentTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ContentTypeFilter | undefined;

    constructor(data?: IListRequestOfContentTypeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ContentTypeFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfContentTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfContentTypeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfContentTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ContentTypeFilter | undefined;
}

export class BaseFilter implements IBaseFilter {
    searchText?: string | undefined;
    includedIds?: string[] | undefined;
    excludedIds?: string[] | undefined;

    constructor(data?: IBaseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["includedIds"])) {
                this.includedIds = [] as any;
                for (let item of _data["includedIds"])
                    this.includedIds!.push(item);
            }
            if (Array.isArray(_data["excludedIds"])) {
                this.excludedIds = [] as any;
                for (let item of _data["excludedIds"])
                    this.excludedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BaseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BaseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        if (Array.isArray(this.includedIds)) {
            data["includedIds"] = [];
            for (let item of this.includedIds)
                data["includedIds"].push(item);
        }
        if (Array.isArray(this.excludedIds)) {
            data["excludedIds"] = [];
            for (let item of this.excludedIds)
                data["excludedIds"].push(item);
        }
        return data;
    }
}

export interface IBaseFilter {
    searchText?: string | undefined;
    includedIds?: string[] | undefined;
    excludedIds?: string[] | undefined;
}

export class ContentTypeFilter extends BaseFilter implements IContentTypeFilter {
    contentType?: string | undefined;

    constructor(data?: IContentTypeFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contentType = _data["contentType"];
        }
    }

    static override fromJS(data: any): ContentTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ContentTypeFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        super.toJSON(data);
        return data;
    }
}

export interface IContentTypeFilter extends IBaseFilter {
    contentType?: string | undefined;
}

export enum MediaItemSource {
    MediaLibrary = "MediaLibrary",
    Handouts = "Handouts",
    CourseVideo = "CourseVideo",
    ArticulateRise = "ArticulateRise",
    CoursePdf = "CoursePdf",
    InfographEd = "InfographEd",
    ISpring = "ISpring",
}

export class ResponseOfMediaItemAndString implements IResponseOfMediaItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MediaItem | undefined;

    constructor(data?: IResponseOfMediaItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? MediaItem.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfMediaItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMediaItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfMediaItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MediaItem | undefined;
}

export class ResponseOfMediaItem extends ResponseOfMediaItemAndString implements IResponseOfMediaItem {

    constructor(data?: IResponseOfMediaItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfMediaItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMediaItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfMediaItem extends IResponseOfMediaItemAndString {
}

export class SaveResponse implements ISaveResponse {
    responseCode?: ResponseCode;
    id?: string;
    responseReason?: string | undefined;

    constructor(data?: ISaveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.id = _data["id"];
            this.responseReason = _data["responseReason"];
        }
    }

    static fromJS(data: any): SaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["id"] = this.id;
        data["responseReason"] = this.responseReason;
        return data;
    }
}

export interface ISaveResponse {
    responseCode?: ResponseCode;
    id?: string;
    responseReason?: string | undefined;
}

export class MediaItemSaveRequest implements IMediaItemSaveRequest {
    id?: string | undefined;
    organizationId?: string;
    fileSize?: number;
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    initialFileUrl?: string | undefined;
    blobName?: string | undefined;
    contentType?: string | undefined;
    dimensions?: string | undefined;
    description?: string | undefined;
    alternativeText?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;

    constructor(data?: IMediaItemSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.fileSize = _data["fileSize"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.initialFileUrl = _data["initialFileUrl"];
            this.blobName = _data["blobName"];
            this.contentType = _data["contentType"];
            this.dimensions = _data["dimensions"];
            this.description = _data["description"];
            this.alternativeText = _data["alternativeText"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): MediaItemSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MediaItemSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["fileSize"] = this.fileSize;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["initialFileUrl"] = this.initialFileUrl;
        data["blobName"] = this.blobName;
        data["contentType"] = this.contentType;
        data["dimensions"] = this.dimensions;
        data["description"] = this.description;
        data["alternativeText"] = this.alternativeText;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IMediaItemSaveRequest {
    id?: string | undefined;
    organizationId?: string;
    fileSize?: number;
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    initialFileUrl?: string | undefined;
    blobName?: string | undefined;
    contentType?: string | undefined;
    dimensions?: string | undefined;
    description?: string | undefined;
    alternativeText?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
}

export class ResponseOfFileUploadUrlsAndString implements IResponseOfFileUploadUrlsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: FileUploadUrls | undefined;

    constructor(data?: IResponseOfFileUploadUrlsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? FileUploadUrls.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfFileUploadUrlsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfFileUploadUrlsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfFileUploadUrlsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: FileUploadUrls | undefined;
}

export class ResponseOfFileUploadUrls extends ResponseOfFileUploadUrlsAndString implements IResponseOfFileUploadUrls {

    constructor(data?: IResponseOfFileUploadUrls) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfFileUploadUrls {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfFileUploadUrls();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfFileUploadUrls extends IResponseOfFileUploadUrlsAndString {
}

export class FileUploadUrls implements IFileUploadUrls {
    uploadUrl?: string | undefined;
    assetUrl?: string | undefined;
    blobName?: string | undefined;

    constructor(data?: IFileUploadUrls) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadUrl = _data["uploadUrl"];
            this.assetUrl = _data["assetUrl"];
            this.blobName = _data["blobName"];
        }
    }

    static fromJS(data: any): FileUploadUrls {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadUrls();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadUrl"] = this.uploadUrl;
        data["assetUrl"] = this.assetUrl;
        data["blobName"] = this.blobName;
        return data;
    }
}

export interface IFileUploadUrls {
    uploadUrl?: string | undefined;
    assetUrl?: string | undefined;
    blobName?: string | undefined;
}

export class FileUploadRequest implements IFileUploadRequest {
    source?: MediaItemSource;
    fileName?: string | undefined;

    constructor(data?: IFileUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): FileUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IFileUploadRequest {
    source?: MediaItemSource;
    fileName?: string | undefined;
}

export class ResponseOfSettingCacheAndString implements IResponseOfSettingCacheAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingCache | undefined;

    constructor(data?: IResponseOfSettingCacheAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SettingCache.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSettingCacheAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSettingCacheAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSettingCacheAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingCache | undefined;
}

export class ResponseOfSettingCache extends ResponseOfSettingCacheAndString implements IResponseOfSettingCache {

    constructor(data?: IResponseOfSettingCache) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSettingCache {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSettingCache();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSettingCache extends IResponseOfSettingCacheAndString {
}

export class SettingCache implements ISettingCache {
    id?: string;
    settingValueId?: string | undefined;
    ancestorSettingValueId?: string | undefined;
    settingId?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    isOrganizationRoot?: boolean;
    settingTypeId?: string;
    name?: string | undefined;
    groupName?: string | undefined;
    typeName?: string | undefined;
    description?: string | undefined;
    codeConstant?: string | undefined;
    value?: string | undefined;
    settingGroupId?: string | undefined;
    inheritedOrganizationName?: string | undefined;
    applicationId?: string | undefined;
    settingOptions?: SettingOptionItem[] | undefined;

    constructor(data?: ISettingCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settingValueId = _data["settingValueId"];
            this.ancestorSettingValueId = _data["ancestorSettingValueId"];
            this.settingId = _data["settingId"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.isOrganizationRoot = _data["isOrganizationRoot"];
            this.settingTypeId = _data["settingTypeId"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            this.typeName = _data["typeName"];
            this.description = _data["description"];
            this.codeConstant = _data["codeConstant"];
            this.value = _data["value"];
            this.settingGroupId = _data["settingGroupId"];
            this.inheritedOrganizationName = _data["inheritedOrganizationName"];
            this.applicationId = _data["applicationId"];
            if (Array.isArray(_data["settingOptions"])) {
                this.settingOptions = [] as any;
                for (let item of _data["settingOptions"])
                    this.settingOptions!.push(SettingOptionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SettingCache {
        data = typeof data === 'object' ? data : {};
        let result = new SettingCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settingValueId"] = this.settingValueId;
        data["ancestorSettingValueId"] = this.ancestorSettingValueId;
        data["settingId"] = this.settingId;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["isOrganizationRoot"] = this.isOrganizationRoot;
        data["settingTypeId"] = this.settingTypeId;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["typeName"] = this.typeName;
        data["description"] = this.description;
        data["codeConstant"] = this.codeConstant;
        data["value"] = this.value;
        data["settingGroupId"] = this.settingGroupId;
        data["inheritedOrganizationName"] = this.inheritedOrganizationName;
        data["applicationId"] = this.applicationId;
        if (Array.isArray(this.settingOptions)) {
            data["settingOptions"] = [];
            for (let item of this.settingOptions)
                data["settingOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISettingCache {
    id?: string;
    settingValueId?: string | undefined;
    ancestorSettingValueId?: string | undefined;
    settingId?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    isOrganizationRoot?: boolean;
    settingTypeId?: string;
    name?: string | undefined;
    groupName?: string | undefined;
    typeName?: string | undefined;
    description?: string | undefined;
    codeConstant?: string | undefined;
    value?: string | undefined;
    settingGroupId?: string | undefined;
    inheritedOrganizationName?: string | undefined;
    applicationId?: string | undefined;
    settingOptions?: SettingOptionItem[] | undefined;
}

export class SettingOptionItem implements ISettingOptionItem {
    id?: string;
    value?: string | undefined;
    displayOrder?: number;

    constructor(data?: ISettingOptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): SettingOptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SettingOptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ISettingOptionItem {
    id?: string;
    value?: string | undefined;
    displayOrder?: number;
}

export class EmailThemeRequest implements IEmailThemeRequest {
    organizationId?: string;

    constructor(data?: IEmailThemeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): EmailThemeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailThemeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IEmailThemeRequest {
    organizationId?: string;
}

export class Response implements IResponse {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        return data;
    }
}

export interface IResponse {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
}

export class SaveEmailThemeRequest implements ISaveEmailThemeRequest {
    organizationId?: string;
    value?: string | undefined;

    constructor(data?: ISaveEmailThemeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SaveEmailThemeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEmailThemeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["value"] = this.value;
        return data;
    }
}

export interface ISaveEmailThemeRequest {
    organizationId?: string;
    value?: string | undefined;
}

export class ResponseOfListOfSettingListItemAndString implements IResponseOfListOfSettingListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingListItem[] | undefined;

    constructor(data?: IResponseOfListOfSettingListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SettingListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSettingListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSettingListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingListItem[] | undefined;
}

export class ResponseOfListOfSettingListItem extends ResponseOfListOfSettingListItemAndString implements IResponseOfListOfSettingListItem {

    constructor(data?: IResponseOfListOfSettingListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSettingListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSettingListItem extends IResponseOfListOfSettingListItemAndString {
}

export class ListResponseOfSettingListItem extends ResponseOfListOfSettingListItem implements IListResponseOfSettingListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSettingListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSettingListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSettingListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSettingListItem extends IResponseOfListOfSettingListItem {
    totalRecords?: number | undefined;
}

export class SettingListItem implements ISettingListItem {
    id?: string;
    settingId?: string;
    settingTypeId?: string;
    name?: string | undefined;
    groupName?: string | undefined;
    codeConstant?: string | undefined;
    value?: string | undefined;
    inheritedOrganizationName?: string | undefined;
    isOverridden?: boolean;

    constructor(data?: ISettingListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settingId = _data["settingId"];
            this.settingTypeId = _data["settingTypeId"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            this.codeConstant = _data["codeConstant"];
            this.value = _data["value"];
            this.inheritedOrganizationName = _data["inheritedOrganizationName"];
            this.isOverridden = _data["isOverridden"];
        }
    }

    static fromJS(data: any): SettingListItem {
        data = typeof data === 'object' ? data : {};
        let result = new SettingListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settingId"] = this.settingId;
        data["settingTypeId"] = this.settingTypeId;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["codeConstant"] = this.codeConstant;
        data["value"] = this.value;
        data["inheritedOrganizationName"] = this.inheritedOrganizationName;
        data["isOverridden"] = this.isOverridden;
        return data;
    }
}

export interface ISettingListItem {
    id?: string;
    settingId?: string;
    settingTypeId?: string;
    name?: string | undefined;
    groupName?: string | undefined;
    codeConstant?: string | undefined;
    value?: string | undefined;
    inheritedOrganizationName?: string | undefined;
    isOverridden?: boolean;
}

export class ListRequestOfSettingFilter implements IListRequestOfSettingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SettingFilter | undefined;

    constructor(data?: IListRequestOfSettingFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SettingFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSettingFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSettingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SettingFilter | undefined;
}

export class AdminListRequestOfSettingFilter extends ListRequestOfSettingFilter implements IAdminListRequestOfSettingFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfSettingFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfSettingFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfSettingFilter extends IListRequestOfSettingFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class SettingFilter extends BaseFilter implements ISettingFilter {
    typeId?: string | undefined;
    settingGroupId?: string | undefined;
    inheritance?: SettingInheritance | undefined;

    constructor(data?: ISettingFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeId = _data["typeId"];
            this.settingGroupId = _data["settingGroupId"];
            this.inheritance = _data["inheritance"];
        }
    }

    static override fromJS(data: any): SettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SettingFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["settingGroupId"] = this.settingGroupId;
        data["inheritance"] = this.inheritance;
        super.toJSON(data);
        return data;
    }
}

export interface ISettingFilter extends IBaseFilter {
    typeId?: string | undefined;
    settingGroupId?: string | undefined;
    inheritance?: SettingInheritance | undefined;
}

export enum SettingInheritance {
    Overridden = "Overridden",
    Inherited = "Inherited",
}

export class ResponseOfListOfSettingTypeAndString implements IResponseOfListOfSettingTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingType[] | undefined;

    constructor(data?: IResponseOfListOfSettingTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SettingType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSettingTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSettingTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingType[] | undefined;
}

export class ResponseOfListOfSettingType extends ResponseOfListOfSettingTypeAndString implements IResponseOfListOfSettingType {

    constructor(data?: IResponseOfListOfSettingType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSettingType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSettingType extends IResponseOfListOfSettingTypeAndString {
}

export class ListResponseOfSettingType extends ResponseOfListOfSettingType implements IListResponseOfSettingType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSettingType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSettingType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSettingType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSettingType extends IResponseOfListOfSettingType {
    totalRecords?: number | undefined;
}

export class SettingType implements ISettingType {
    id?: string;
    name?: string | undefined;

    constructor(data?: ISettingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SettingType {
        data = typeof data === 'object' ? data : {};
        let result = new SettingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISettingType {
    id?: string;
    name?: string | undefined;
}

export class ListRequestOfBaseFilter implements IListRequestOfBaseFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: BaseFilter | undefined;

    constructor(data?: IListRequestOfBaseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? BaseFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfBaseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfBaseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfBaseFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: BaseFilter | undefined;
}

export class AdminListRequestOfBaseFilter extends ListRequestOfBaseFilter implements IAdminListRequestOfBaseFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfBaseFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfBaseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfBaseFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfBaseFilter extends IListRequestOfBaseFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class ResponseOfListOfSettingGroupAndString implements IResponseOfListOfSettingGroupAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingGroup[] | undefined;

    constructor(data?: IResponseOfListOfSettingGroupAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SettingGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSettingGroupAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingGroupAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSettingGroupAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingGroup[] | undefined;
}

export class ResponseOfListOfSettingGroup extends ResponseOfListOfSettingGroupAndString implements IResponseOfListOfSettingGroup {

    constructor(data?: IResponseOfListOfSettingGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSettingGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSettingGroup extends IResponseOfListOfSettingGroupAndString {
}

export class ListResponseOfSettingGroup extends ResponseOfListOfSettingGroup implements IListResponseOfSettingGroup {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSettingGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSettingGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSettingGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSettingGroup extends IResponseOfListOfSettingGroup {
    totalRecords?: number | undefined;
}

export class SettingGroup implements ISettingGroup {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;

    constructor(data?: ISettingGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static fromJS(data: any): SettingGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SettingGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["codeConstant"] = this.codeConstant;
        return data;
    }
}

export interface ISettingGroup {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;
}

export class ResponseOfListOfDescendantSettingCacheAndString implements IResponseOfListOfDescendantSettingCacheAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DescendantSettingCache[] | undefined;

    constructor(data?: IResponseOfListOfDescendantSettingCacheAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DescendantSettingCache.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfDescendantSettingCacheAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDescendantSettingCacheAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfDescendantSettingCacheAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DescendantSettingCache[] | undefined;
}

export class ResponseOfListOfDescendantSettingCache extends ResponseOfListOfDescendantSettingCacheAndString implements IResponseOfListOfDescendantSettingCache {

    constructor(data?: IResponseOfListOfDescendantSettingCache) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfDescendantSettingCache {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDescendantSettingCache();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfDescendantSettingCache extends IResponseOfListOfDescendantSettingCacheAndString {
}

export class ListResponseOfDescendantSettingCache extends ResponseOfListOfDescendantSettingCache implements IListResponseOfDescendantSettingCache {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfDescendantSettingCache) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfDescendantSettingCache {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfDescendantSettingCache();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfDescendantSettingCache extends IResponseOfListOfDescendantSettingCache {
    totalRecords?: number | undefined;
}

export class DescendantSettingCache implements IDescendantSettingCache {
    organizationName?: string | undefined;
    value?: string | undefined;
    inheritedOrganizationName?: string | undefined;

    constructor(data?: IDescendantSettingCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.value = _data["value"];
            this.inheritedOrganizationName = _data["inheritedOrganizationName"];
        }
    }

    static fromJS(data: any): DescendantSettingCache {
        data = typeof data === 'object' ? data : {};
        let result = new DescendantSettingCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["value"] = this.value;
        data["inheritedOrganizationName"] = this.inheritedOrganizationName;
        return data;
    }
}

export interface IDescendantSettingCache {
    organizationName?: string | undefined;
    value?: string | undefined;
    inheritedOrganizationName?: string | undefined;
}

export class ListRequestOfDescendantSettingFilter implements IListRequestOfDescendantSettingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: DescendantSettingFilter | undefined;

    constructor(data?: IListRequestOfDescendantSettingFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? DescendantSettingFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfDescendantSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfDescendantSettingFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfDescendantSettingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: DescendantSettingFilter | undefined;
}

export class AdminListRequestOfDescendantSettingFilter extends ListRequestOfDescendantSettingFilter implements IAdminListRequestOfDescendantSettingFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfDescendantSettingFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfDescendantSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfDescendantSettingFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfDescendantSettingFilter extends IListRequestOfDescendantSettingFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class DescendantSettingFilter extends BaseFilter implements IDescendantSettingFilter {
    organizationId?: string;
    settingId?: string;

    constructor(data?: IDescendantSettingFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.settingId = _data["settingId"];
        }
    }

    static override fromJS(data: any): DescendantSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DescendantSettingFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["settingId"] = this.settingId;
        super.toJSON(data);
        return data;
    }
}

export interface IDescendantSettingFilter extends IBaseFilter {
    organizationId?: string;
    settingId?: string;
}

export class ResponseOfListOfSettingCacheAndString implements IResponseOfListOfSettingCacheAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingCache[] | undefined;

    constructor(data?: IResponseOfListOfSettingCacheAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SettingCache.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSettingCacheAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingCacheAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSettingCacheAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SettingCache[] | undefined;
}

export class ResponseOfListOfSettingCache extends ResponseOfListOfSettingCacheAndString implements IResponseOfListOfSettingCache {

    constructor(data?: IResponseOfListOfSettingCache) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSettingCache {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSettingCache();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSettingCache extends IResponseOfListOfSettingCacheAndString {
}

export class ListResponseOfSettingCache extends ResponseOfListOfSettingCache implements IListResponseOfSettingCache {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSettingCache) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSettingCache {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSettingCache();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSettingCache extends IResponseOfListOfSettingCache {
    totalRecords?: number | undefined;
}

export class SaveSettingValueRequest implements ISaveSettingValueRequest {
    id?: string | undefined;
    settingId!: string;
    applicationId?: string | undefined;
    value!: string;

    constructor(data?: ISaveSettingValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settingId = _data["settingId"];
            this.applicationId = _data["applicationId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SaveSettingValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSettingValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settingId"] = this.settingId;
        data["applicationId"] = this.applicationId;
        data["value"] = this.value;
        return data;
    }
}

export interface ISaveSettingValueRequest {
    id?: string | undefined;
    settingId: string;
    applicationId?: string | undefined;
    value: string;
}

export class SiteSettings implements ISiteSettings {
    theme!: SiteTheme | undefined;

    constructor(data?: ISiteSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"] ? SiteTheme.fromJS(_data["theme"]) : undefined as any;
        }
    }

    static fromJS(data: any): SiteSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined as any;
        return data;
    }
}

export interface ISiteSettings {
    theme: SiteTheme | undefined;
}

export class SiteTheme implements ISiteTheme {
    primaryColor?: ColorVariants | undefined;
    secondaryColor?: ColorVariants | undefined;
    tertiaryColor?: ColorVariants | undefined;
    backgroundColor?: ColorVariants | undefined;
    greenColor?: ColorVariants | undefined;
    redColor?: ColorVariants | undefined;
    grayColor?: ColorVariants | undefined;
    faviconUrl?: string | undefined;
    logoUrl?: string | undefined;
    logoAlternativeText?: string | undefined;
    externalHostUrl?: string | undefined;
    baseCssUrl?: string | undefined;

    constructor(data?: ISiteTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["primaryColor"] ? ColorVariants.fromJS(_data["primaryColor"]) : undefined as any;
            this.secondaryColor = _data["secondaryColor"] ? ColorVariants.fromJS(_data["secondaryColor"]) : undefined as any;
            this.tertiaryColor = _data["tertiaryColor"] ? ColorVariants.fromJS(_data["tertiaryColor"]) : undefined as any;
            this.backgroundColor = _data["backgroundColor"] ? ColorVariants.fromJS(_data["backgroundColor"]) : undefined as any;
            this.greenColor = _data["greenColor"] ? ColorVariants.fromJS(_data["greenColor"]) : undefined as any;
            this.redColor = _data["redColor"] ? ColorVariants.fromJS(_data["redColor"]) : undefined as any;
            this.grayColor = _data["grayColor"] ? ColorVariants.fromJS(_data["grayColor"]) : undefined as any;
            this.faviconUrl = _data["faviconUrl"];
            this.logoUrl = _data["logoUrl"];
            this.logoAlternativeText = _data["logoAlternativeText"];
            this.externalHostUrl = _data["externalHostUrl"];
            this.baseCssUrl = _data["baseCssUrl"];
        }
    }

    static fromJS(data: any): SiteTheme {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryColor"] = this.primaryColor ? this.primaryColor.toJSON() : undefined as any;
        data["secondaryColor"] = this.secondaryColor ? this.secondaryColor.toJSON() : undefined as any;
        data["tertiaryColor"] = this.tertiaryColor ? this.tertiaryColor.toJSON() : undefined as any;
        data["backgroundColor"] = this.backgroundColor ? this.backgroundColor.toJSON() : undefined as any;
        data["greenColor"] = this.greenColor ? this.greenColor.toJSON() : undefined as any;
        data["redColor"] = this.redColor ? this.redColor.toJSON() : undefined as any;
        data["grayColor"] = this.grayColor ? this.grayColor.toJSON() : undefined as any;
        data["faviconUrl"] = this.faviconUrl;
        data["logoUrl"] = this.logoUrl;
        data["logoAlternativeText"] = this.logoAlternativeText;
        data["externalHostUrl"] = this.externalHostUrl;
        data["baseCssUrl"] = this.baseCssUrl;
        return data;
    }
}

export interface ISiteTheme {
    primaryColor?: ColorVariants | undefined;
    secondaryColor?: ColorVariants | undefined;
    tertiaryColor?: ColorVariants | undefined;
    backgroundColor?: ColorVariants | undefined;
    greenColor?: ColorVariants | undefined;
    redColor?: ColorVariants | undefined;
    grayColor?: ColorVariants | undefined;
    faviconUrl?: string | undefined;
    logoUrl?: string | undefined;
    logoAlternativeText?: string | undefined;
    externalHostUrl?: string | undefined;
    baseCssUrl?: string | undefined;
}

export class ColorVariants implements IColorVariants {
    base?: string | undefined;
    light?: string | undefined;
    pale?: string | undefined;
    lighter?: string | undefined;
    lightPale?: string | undefined;
    ultraLight?: string | undefined;
    dark?: string | undefined;

    constructor(data?: IColorVariants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base = _data["base"];
            this.light = _data["light"];
            this.pale = _data["pale"];
            this.lighter = _data["lighter"];
            this.lightPale = _data["lightPale"];
            this.ultraLight = _data["ultraLight"];
            this.dark = _data["dark"];
        }
    }

    static fromJS(data: any): ColorVariants {
        data = typeof data === 'object' ? data : {};
        let result = new ColorVariants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base"] = this.base;
        data["light"] = this.light;
        data["pale"] = this.pale;
        data["lighter"] = this.lighter;
        data["lightPale"] = this.lightPale;
        data["ultraLight"] = this.ultraLight;
        data["dark"] = this.dark;
        return data;
    }
}

export interface IColorVariants {
    base?: string | undefined;
    light?: string | undefined;
    pale?: string | undefined;
    lighter?: string | undefined;
    lightPale?: string | undefined;
    ultraLight?: string | undefined;
    dark?: string | undefined;
}

export class ResponseOfListOfScormExportedFileAndString implements IResponseOfListOfScormExportedFileAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ScormExportedFile[] | undefined;

    constructor(data?: IResponseOfListOfScormExportedFileAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ScormExportedFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfScormExportedFileAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfScormExportedFileAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfScormExportedFileAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ScormExportedFile[] | undefined;
}

export class ResponseOfListOfScormExportedFile extends ResponseOfListOfScormExportedFileAndString implements IResponseOfListOfScormExportedFile {

    constructor(data?: IResponseOfListOfScormExportedFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfScormExportedFile {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfScormExportedFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfScormExportedFile extends IResponseOfListOfScormExportedFileAndString {
}

export class ListResponseOfScormExportedFile extends ResponseOfListOfScormExportedFile implements IListResponseOfScormExportedFile {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfScormExportedFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfScormExportedFile {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfScormExportedFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfScormExportedFile extends IResponseOfListOfScormExportedFile {
    totalRecords?: number | undefined;
}

export class ScormExportedFile implements IScormExportedFile {
    runFileId?: string;
    fileName?: string | undefined;
    tag?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    exportedOn?: Date;
    contentType?: string | undefined;
    status?: ScormExportFileDeliveryStatus;
    lastUploadError?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: IScormExportedFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runFileId = _data["runFileId"];
            this.fileName = _data["fileName"];
            this.tag = _data["tag"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.exportedOn = _data["exportedOn"] ? new Date(_data["exportedOn"].toString()) : undefined as any;
            this.contentType = _data["contentType"];
            this.status = _data["status"];
            this.lastUploadError = _data["lastUploadError"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScormExportedFile {
        data = typeof data === 'object' ? data : {};
        let result = new ScormExportedFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runFileId"] = this.runFileId;
        data["fileName"] = this.fileName;
        data["tag"] = this.tag;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["exportedOn"] = this.exportedOn ? this.exportedOn.toISOString() : undefined as any;
        data["contentType"] = this.contentType;
        data["status"] = this.status;
        data["lastUploadError"] = this.lastUploadError;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IScormExportedFile {
    runFileId?: string;
    fileName?: string | undefined;
    tag?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    exportedOn?: Date;
    contentType?: string | undefined;
    status?: ScormExportFileDeliveryStatus;
    lastUploadError?: string | undefined;
    updatedOn?: Date | undefined;
}

export enum ScormExportFileDeliveryStatus {
    Pending = "Pending",
    Uploaded = "Uploaded",
    Failed = "Failed",
}

export class ListRequestOfScormExportedFilesFilter implements IListRequestOfScormExportedFilesFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ScormExportedFilesFilter | undefined;

    constructor(data?: IListRequestOfScormExportedFilesFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ScormExportedFilesFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfScormExportedFilesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfScormExportedFilesFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfScormExportedFilesFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ScormExportedFilesFilter | undefined;
}

export class ScormExportedFilesFilter extends BaseFilter implements IScormExportedFilesFilter {
    tag?: string | undefined;
    status?: ScormExportFileDeliveryStatus | undefined;
    exportedFrom?: Date | undefined;
    exportedTo?: Date | undefined;

    constructor(data?: IScormExportedFilesFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"];
            this.status = _data["status"];
            this.exportedFrom = _data["exportedFrom"] ? new Date(_data["exportedFrom"].toString()) : undefined as any;
            this.exportedTo = _data["exportedTo"] ? new Date(_data["exportedTo"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): ScormExportedFilesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ScormExportedFilesFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["status"] = this.status;
        data["exportedFrom"] = this.exportedFrom ? this.exportedFrom.toISOString() : undefined as any;
        data["exportedTo"] = this.exportedTo ? this.exportedTo.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IScormExportedFilesFilter extends IBaseFilter {
    tag?: string | undefined;
    status?: ScormExportFileDeliveryStatus | undefined;
    exportedFrom?: Date | undefined;
    exportedTo?: Date | undefined;
}

export class ResponseOfListOfStringAndString implements IResponseOfListOfStringAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string[] | undefined;

    constructor(data?: IResponseOfListOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IResponseOfListOfStringAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string[] | undefined;
}

export class ResponseOfListOfString extends ResponseOfListOfStringAndString implements IResponseOfListOfString {

    constructor(data?: IResponseOfListOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfString extends IResponseOfListOfStringAndString {
}

export class ListResponseOfString extends ResponseOfListOfString implements IListResponseOfString {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfString extends IResponseOfListOfString {
    totalRecords?: number | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ScormExportedFilesDownloadRequest implements IScormExportedFilesDownloadRequest {
    runFileIds?: string[] | undefined;

    constructor(data?: IScormExportedFilesDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["runFileIds"])) {
                this.runFileIds = [] as any;
                for (let item of _data["runFileIds"])
                    this.runFileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ScormExportedFilesDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScormExportedFilesDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.runFileIds)) {
            data["runFileIds"] = [];
            for (let item of this.runFileIds)
                data["runFileIds"].push(item);
        }
        return data;
    }
}

export interface IScormExportedFilesDownloadRequest {
    runFileIds?: string[] | undefined;
}

export class ScormExportedFilesUploadResponse implements IScormExportedFilesUploadResponse {
    queuedRunFileIds?: string[] | undefined;

    constructor(data?: IScormExportedFilesUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["queuedRunFileIds"])) {
                this.queuedRunFileIds = [] as any;
                for (let item of _data["queuedRunFileIds"])
                    this.queuedRunFileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ScormExportedFilesUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScormExportedFilesUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queuedRunFileIds)) {
            data["queuedRunFileIds"] = [];
            for (let item of this.queuedRunFileIds)
                data["queuedRunFileIds"].push(item);
        }
        return data;
    }
}

export interface IScormExportedFilesUploadResponse {
    queuedRunFileIds?: string[] | undefined;
}

export class ScormExportedFilesUploadRequest implements IScormExportedFilesUploadRequest {
    runFileIds?: string[] | undefined;

    constructor(data?: IScormExportedFilesUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["runFileIds"])) {
                this.runFileIds = [] as any;
                for (let item of _data["runFileIds"])
                    this.runFileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ScormExportedFilesUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScormExportedFilesUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.runFileIds)) {
            data["runFileIds"] = [];
            for (let item of this.runFileIds)
                data["runFileIds"].push(item);
        }
        return data;
    }
}

export interface IScormExportedFilesUploadRequest {
    runFileIds?: string[] | undefined;
}

export class ResponseOfListOfScormMetadataRowAndString implements IResponseOfListOfScormMetadataRowAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ScormMetadataRow[] | undefined;

    constructor(data?: IResponseOfListOfScormMetadataRowAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ScormMetadataRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfScormMetadataRowAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfScormMetadataRowAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfScormMetadataRowAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ScormMetadataRow[] | undefined;
}

export class ResponseOfListOfScormMetadataRow extends ResponseOfListOfScormMetadataRowAndString implements IResponseOfListOfScormMetadataRow {

    constructor(data?: IResponseOfListOfScormMetadataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfScormMetadataRow {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfScormMetadataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfScormMetadataRow extends IResponseOfListOfScormMetadataRowAndString {
}

export class ListResponseOfScormMetadataRow extends ResponseOfListOfScormMetadataRow implements IListResponseOfScormMetadataRow {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfScormMetadataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfScormMetadataRow {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfScormMetadataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfScormMetadataRow extends IResponseOfListOfScormMetadataRow {
    totalRecords?: number | undefined;
}

export class ScormMetadataRow implements IScormMetadataRow {
    contentProviderUniqueId?: string | undefined;
    courseTitle?: string | undefined;
    fieldOfStudy?: string | undefined;
    courseDescription?: string | undefined;
    learningObjectives?: string | undefined;
    publicationRevisionDate?: Date | undefined;
    sessionStartDateTime?: Date | undefined;
    sessionEndDateTime?: Date | undefined;
    enrollmentEndDateTime?: Date | undefined;
    timezone?: string | undefined;
    length?: string | undefined;
    cpeCredits?: string | undefined;
    instructor?: string | undefined;
    courseLevel?: string | undefined;
    prerequisites?: string | undefined;
    advancedPreparation?: string | undefined;
    sponsorName?: string | undefined;
    programJurisdictions?: string | undefined;
    programJurisdictionIds?: string | undefined;
    deliveryMethod?: string | undefined;
    scormFileName?: string | undefined;
    surgentNasbaSponsorId?: string | undefined;
    qualifications?: string | undefined;
    irsCreditStartDate?: Date | undefined;
    irsCreditEndDate?: Date | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    courseVersion?: string | undefined;

    constructor(data?: IScormMetadataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentProviderUniqueId = _data["contentProviderUniqueId"];
            this.courseTitle = _data["courseTitle"];
            this.fieldOfStudy = _data["fieldOfStudy"];
            this.courseDescription = _data["courseDescription"];
            this.learningObjectives = _data["learningObjectives"];
            this.publicationRevisionDate = _data["publicationRevisionDate"] ? new Date(_data["publicationRevisionDate"].toString()) : undefined as any;
            this.sessionStartDateTime = _data["sessionStartDateTime"] ? new Date(_data["sessionStartDateTime"].toString()) : undefined as any;
            this.sessionEndDateTime = _data["sessionEndDateTime"] ? new Date(_data["sessionEndDateTime"].toString()) : undefined as any;
            this.enrollmentEndDateTime = _data["enrollmentEndDateTime"] ? new Date(_data["enrollmentEndDateTime"].toString()) : undefined as any;
            this.timezone = _data["timezone"];
            this.length = _data["length"];
            this.cpeCredits = _data["cpeCredits"];
            this.instructor = _data["instructor"];
            this.courseLevel = _data["courseLevel"];
            this.prerequisites = _data["prerequisites"];
            this.advancedPreparation = _data["advancedPreparation"];
            this.sponsorName = _data["sponsorName"];
            this.programJurisdictions = _data["programJurisdictions"];
            this.programJurisdictionIds = _data["programJurisdictionIds"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.scormFileName = _data["scormFileName"];
            this.surgentNasbaSponsorId = _data["surgentNasbaSponsorId"];
            this.qualifications = _data["qualifications"];
            this.irsCreditStartDate = _data["irsCreditStartDate"] ? new Date(_data["irsCreditStartDate"].toString()) : undefined as any;
            this.irsCreditEndDate = _data["irsCreditEndDate"] ? new Date(_data["irsCreditEndDate"].toString()) : undefined as any;
            this.imageUrl = _data["imageUrl"];
            this.price = _data["price"];
            this.courseVersion = _data["courseVersion"];
        }
    }

    static fromJS(data: any): ScormMetadataRow {
        data = typeof data === 'object' ? data : {};
        let result = new ScormMetadataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentProviderUniqueId"] = this.contentProviderUniqueId;
        data["courseTitle"] = this.courseTitle;
        data["fieldOfStudy"] = this.fieldOfStudy;
        data["courseDescription"] = this.courseDescription;
        data["learningObjectives"] = this.learningObjectives;
        data["publicationRevisionDate"] = this.publicationRevisionDate ? this.publicationRevisionDate.toISOString() : undefined as any;
        data["sessionStartDateTime"] = this.sessionStartDateTime ? this.sessionStartDateTime.toISOString() : undefined as any;
        data["sessionEndDateTime"] = this.sessionEndDateTime ? this.sessionEndDateTime.toISOString() : undefined as any;
        data["enrollmentEndDateTime"] = this.enrollmentEndDateTime ? this.enrollmentEndDateTime.toISOString() : undefined as any;
        data["timezone"] = this.timezone;
        data["length"] = this.length;
        data["cpeCredits"] = this.cpeCredits;
        data["instructor"] = this.instructor;
        data["courseLevel"] = this.courseLevel;
        data["prerequisites"] = this.prerequisites;
        data["advancedPreparation"] = this.advancedPreparation;
        data["sponsorName"] = this.sponsorName;
        data["programJurisdictions"] = this.programJurisdictions;
        data["programJurisdictionIds"] = this.programJurisdictionIds;
        data["deliveryMethod"] = this.deliveryMethod;
        data["scormFileName"] = this.scormFileName;
        data["surgentNasbaSponsorId"] = this.surgentNasbaSponsorId;
        data["qualifications"] = this.qualifications;
        data["irsCreditStartDate"] = this.irsCreditStartDate ? this.irsCreditStartDate.toISOString() : undefined as any;
        data["irsCreditEndDate"] = this.irsCreditEndDate ? this.irsCreditEndDate.toISOString() : undefined as any;
        data["imageUrl"] = this.imageUrl;
        data["price"] = this.price;
        data["courseVersion"] = this.courseVersion;
        return data;
    }
}

export interface IScormMetadataRow {
    contentProviderUniqueId?: string | undefined;
    courseTitle?: string | undefined;
    fieldOfStudy?: string | undefined;
    courseDescription?: string | undefined;
    learningObjectives?: string | undefined;
    publicationRevisionDate?: Date | undefined;
    sessionStartDateTime?: Date | undefined;
    sessionEndDateTime?: Date | undefined;
    enrollmentEndDateTime?: Date | undefined;
    timezone?: string | undefined;
    length?: string | undefined;
    cpeCredits?: string | undefined;
    instructor?: string | undefined;
    courseLevel?: string | undefined;
    prerequisites?: string | undefined;
    advancedPreparation?: string | undefined;
    sponsorName?: string | undefined;
    programJurisdictions?: string | undefined;
    programJurisdictionIds?: string | undefined;
    deliveryMethod?: string | undefined;
    scormFileName?: string | undefined;
    surgentNasbaSponsorId?: string | undefined;
    qualifications?: string | undefined;
    irsCreditStartDate?: Date | undefined;
    irsCreditEndDate?: Date | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    courseVersion?: string | undefined;
}

export class AccessLevelSaveRequest implements IAccessLevelSaveRequest {
    id?: string | undefined;
    organizationId?: string;
    skuId?: string;
    displayName?: string | undefined;
    sequence?: number;

    constructor(data?: IAccessLevelSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.skuId = _data["skuId"];
            this.displayName = _data["displayName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): AccessLevelSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLevelSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["skuId"] = this.skuId;
        data["displayName"] = this.displayName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IAccessLevelSaveRequest {
    id?: string | undefined;
    organizationId?: string;
    skuId?: string;
    displayName?: string | undefined;
    sequence?: number;
}

export class ResponseOfListOfAccessLevelModelAndString implements IResponseOfListOfAccessLevelModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AccessLevelModel[] | undefined;

    constructor(data?: IResponseOfListOfAccessLevelModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AccessLevelModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAccessLevelModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAccessLevelModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAccessLevelModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AccessLevelModel[] | undefined;
}

export class ResponseOfListOfAccessLevelModel extends ResponseOfListOfAccessLevelModelAndString implements IResponseOfListOfAccessLevelModel {

    constructor(data?: IResponseOfListOfAccessLevelModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAccessLevelModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAccessLevelModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAccessLevelModel extends IResponseOfListOfAccessLevelModelAndString {
}

export class ListResponseOfAccessLevelModel extends ResponseOfListOfAccessLevelModel implements IListResponseOfAccessLevelModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAccessLevelModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAccessLevelModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAccessLevelModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAccessLevelModel extends IResponseOfListOfAccessLevelModel {
    totalRecords?: number | undefined;
}

export class AccessLevel implements IAccessLevel {
    id!: string;
    skuId!: string;
    displayName?: string | undefined;
    sequence?: number;

    constructor(data?: IAccessLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.displayName = _data["displayName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): AccessLevel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["displayName"] = this.displayName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IAccessLevel {
    id: string;
    skuId: string;
    displayName?: string | undefined;
    sequence?: number;
}

export class AccessLevelModel extends AccessLevel implements IAccessLevelModel {
    sku?: string | undefined;
    skuTitle?: string | undefined;

    constructor(data?: IAccessLevelModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sku = _data["sku"];
            this.skuTitle = _data["skuTitle"];
        }
    }

    static override fromJS(data: any): AccessLevelModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLevelModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["skuTitle"] = this.skuTitle;
        super.toJSON(data);
        return data;
    }
}

export interface IAccessLevelModel extends IAccessLevel {
    sku?: string | undefined;
    skuTitle?: string | undefined;
}

export class AccessLevelListRequest extends ListRequestOfBaseFilter implements IAccessLevelListRequest {
    organizationId?: string;

    constructor(data?: IAccessLevelListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AccessLevelListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLevelListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAccessLevelListRequest extends IListRequestOfBaseFilter {
    organizationId?: string;
}

export class UpdateAccessLevelsSequenceRequest implements IUpdateAccessLevelsSequenceRequest {
    organizationId?: string;
    accessLevelIds!: string[];

    constructor(data?: IUpdateAccessLevelsSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.accessLevelIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["accessLevelIds"])) {
                this.accessLevelIds = [] as any;
                for (let item of _data["accessLevelIds"])
                    this.accessLevelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAccessLevelsSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessLevelsSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.accessLevelIds)) {
            data["accessLevelIds"] = [];
            for (let item of this.accessLevelIds)
                data["accessLevelIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateAccessLevelsSequenceRequest {
    organizationId?: string;
    accessLevelIds: string[];
}

export class ResponseOfListOfAttendanceRecordAndString implements IResponseOfListOfAttendanceRecordAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AttendanceRecord[] | undefined;

    constructor(data?: IResponseOfListOfAttendanceRecordAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AttendanceRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAttendanceRecordAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttendanceRecordAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAttendanceRecordAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AttendanceRecord[] | undefined;
}

export class ResponseOfListOfAttendanceRecord extends ResponseOfListOfAttendanceRecordAndString implements IResponseOfListOfAttendanceRecord {

    constructor(data?: IResponseOfListOfAttendanceRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAttendanceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttendanceRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAttendanceRecord extends IResponseOfListOfAttendanceRecordAndString {
}

export class ListResponseOfAttendanceRecord extends ResponseOfListOfAttendanceRecord implements IListResponseOfAttendanceRecord {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAttendanceRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAttendanceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAttendanceRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAttendanceRecord extends IResponseOfListOfAttendanceRecord {
    totalRecords?: number | undefined;
}

export class AttendanceRecord implements IAttendanceRecord {
    id!: string;
    userSkuId?: string;
    status?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    totalPresenceChecks?: number;
    presenceChecksAnswered?: number;
    timeInSession?: string;
    initialEntryTime?: Date;
    finalExitTime?: Date;
    presence?: number;

    constructor(data?: IAttendanceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userSkuId = _data["userSkuId"];
            this.status = _data["status"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.totalPresenceChecks = _data["totalPresenceChecks"];
            this.presenceChecksAnswered = _data["presenceChecksAnswered"];
            this.timeInSession = _data["timeInSession"];
            this.initialEntryTime = _data["initialEntryTime"] ? new Date(_data["initialEntryTime"].toString()) : undefined as any;
            this.finalExitTime = _data["finalExitTime"] ? new Date(_data["finalExitTime"].toString()) : undefined as any;
            this.presence = _data["presence"];
        }
    }

    static fromJS(data: any): AttendanceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userSkuId"] = this.userSkuId;
        data["status"] = this.status;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["totalPresenceChecks"] = this.totalPresenceChecks;
        data["presenceChecksAnswered"] = this.presenceChecksAnswered;
        data["timeInSession"] = this.timeInSession;
        data["initialEntryTime"] = this.initialEntryTime ? this.initialEntryTime.toISOString() : undefined as any;
        data["finalExitTime"] = this.finalExitTime ? this.finalExitTime.toISOString() : undefined as any;
        data["presence"] = this.presence;
        return data;
    }
}

export interface IAttendanceRecord {
    id: string;
    userSkuId?: string;
    status?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    totalPresenceChecks?: number;
    presenceChecksAnswered?: number;
    timeInSession?: string;
    initialEntryTime?: Date;
    finalExitTime?: Date;
    presence?: number;
}

export class ListRequestOfAttendanceRecordFilter implements IListRequestOfAttendanceRecordFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AttendanceRecordFilter | undefined;

    constructor(data?: IListRequestOfAttendanceRecordFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AttendanceRecordFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAttendanceRecordFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAttendanceRecordFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAttendanceRecordFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AttendanceRecordFilter | undefined;
}

export class AttendanceRecordFilter extends BaseFilter implements IAttendanceRecordFilter {
    skuId?: string | undefined;
    attendanceRecordStatusId?: string | undefined;

    constructor(data?: IAttendanceRecordFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuId = _data["skuId"];
            this.attendanceRecordStatusId = _data["attendanceRecordStatusId"];
        }
    }

    static override fromJS(data: any): AttendanceRecordFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceRecordFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["attendanceRecordStatusId"] = this.attendanceRecordStatusId;
        super.toJSON(data);
        return data;
    }
}

export interface IAttendanceRecordFilter extends IBaseFilter {
    skuId?: string | undefined;
    attendanceRecordStatusId?: string | undefined;
}

export class ListRequestOfAttendanceRecordFilterRequest implements IListRequestOfAttendanceRecordFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AttendanceRecordFilterRequest | undefined;

    constructor(data?: IListRequestOfAttendanceRecordFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AttendanceRecordFilterRequest.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAttendanceRecordFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAttendanceRecordFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAttendanceRecordFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AttendanceRecordFilterRequest | undefined;
}

export class AttendanceRecordFilterRequest implements IAttendanceRecordFilterRequest {
    attendanceRecordsDownloadUrl?: string | undefined;
    attendanceRecordStatusId?: string | undefined;

    constructor(data?: IAttendanceRecordFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceRecordsDownloadUrl = _data["attendanceRecordsDownloadUrl"];
            this.attendanceRecordStatusId = _data["attendanceRecordStatusId"];
        }
    }

    static fromJS(data: any): AttendanceRecordFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceRecordFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceRecordsDownloadUrl"] = this.attendanceRecordsDownloadUrl;
        data["attendanceRecordStatusId"] = this.attendanceRecordStatusId;
        return data;
    }
}

export interface IAttendanceRecordFilterRequest {
    attendanceRecordsDownloadUrl?: string | undefined;
    attendanceRecordStatusId?: string | undefined;
}

export class ResponseOfListOfIdNameModelAndString implements IResponseOfListOfIdNameModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: IdNameModel[] | undefined;

    constructor(data?: IResponseOfListOfIdNameModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfIdNameModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfIdNameModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfIdNameModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: IdNameModel[] | undefined;
}

export class ResponseOfListOfIdNameModel extends ResponseOfListOfIdNameModelAndString implements IResponseOfListOfIdNameModel {

    constructor(data?: IResponseOfListOfIdNameModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfIdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfIdNameModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfIdNameModel extends IResponseOfListOfIdNameModelAndString {
}

export class ListResponseOfIdNameModel extends ResponseOfListOfIdNameModel implements IListResponseOfIdNameModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfIdNameModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfIdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfIdNameModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfIdNameModel extends IResponseOfListOfIdNameModel {
    totalRecords?: number | undefined;
}

export class IdNameModel implements IIdNameModel {
    id!: string;
    name?: string | undefined;

    constructor(data?: IIdNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIdNameModel {
    id: string;
    name?: string | undefined;
}

export class UserEnrollmentRequest implements IUserEnrollmentRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;
    endDate?: Date | undefined;
    crmOrderName?: string | undefined;
    isTest?: boolean;

    constructor(data?: IUserEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.crmOrderName = _data["crmOrderName"];
            this.isTest = _data["isTest"];
        }
    }

    static fromJS(data: any): UserEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["crmOrderName"] = this.crmOrderName;
        data["isTest"] = this.isTest;
        return data;
    }
}

export interface IUserEnrollmentRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;
    endDate?: Date | undefined;
    crmOrderName?: string | undefined;
    isTest?: boolean;
}

export class BulkUserEnrollmentRequest implements IBulkUserEnrollmentRequest {
    rows!: BulkEnrollmentRow[];
    endDate?: Date | undefined;
    crmOrderName?: string | undefined;
    bypassSkuExpiration?: boolean;
    isTest?: boolean;

    constructor(data?: IBulkUserEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.rows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BulkEnrollmentRow.fromJS(item));
            }
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.crmOrderName = _data["crmOrderName"];
            this.bypassSkuExpiration = _data["bypassSkuExpiration"];
            this.isTest = _data["isTest"];
        }
    }

    static fromJS(data: any): BulkUserEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUserEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["crmOrderName"] = this.crmOrderName;
        data["bypassSkuExpiration"] = this.bypassSkuExpiration;
        data["isTest"] = this.isTest;
        return data;
    }
}

export interface IBulkUserEnrollmentRequest {
    rows: BulkEnrollmentRow[];
    endDate?: Date | undefined;
    crmOrderName?: string | undefined;
    bypassSkuExpiration?: boolean;
    isTest?: boolean;
}

export class BulkEnrollmentRow implements IBulkEnrollmentRow {
    userId?: string;
    organizationId?: string;
    skuId?: string;

    constructor(data?: IBulkEnrollmentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): BulkEnrollmentRow {
        data = typeof data === 'object' ? data : {};
        let result = new BulkEnrollmentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface IBulkEnrollmentRow {
    userId?: string;
    organizationId?: string;
    skuId?: string;
}

export class ResponseOfListOfResolvedUserAndString implements IResponseOfListOfResolvedUserAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResolvedUser[] | undefined;

    constructor(data?: IResponseOfListOfResolvedUserAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResolvedUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResolvedUserAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResolvedUserAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResolvedUserAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResolvedUser[] | undefined;
}

export class ResponseOfListOfResolvedUser extends ResponseOfListOfResolvedUserAndString implements IResponseOfListOfResolvedUser {

    constructor(data?: IResponseOfListOfResolvedUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResolvedUser {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResolvedUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResolvedUser extends IResponseOfListOfResolvedUserAndString {
}

export class ListResponseOfResolvedUser extends ResponseOfListOfResolvedUser implements IListResponseOfResolvedUser {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResolvedUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResolvedUser {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResolvedUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResolvedUser extends IResponseOfListOfResolvedUser {
    totalRecords?: number | undefined;
}

export class ResolvedUser implements IResolvedUser {
    email?: string | undefined;
    found?: boolean;
    userId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IResolvedUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.found = _data["found"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ResolvedUser {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["found"] = this.found;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IResolvedUser {
    email?: string | undefined;
    found?: boolean;
    userId?: string | undefined;
    organizationId?: string | undefined;
}

export class ResolveUsersByEmailsRequest implements IResolveUsersByEmailsRequest {
    organizationId?: string;
    emails!: string[];

    constructor(data?: IResolveUsersByEmailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.emails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): ResolveUsersByEmailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveUsersByEmailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IResolveUsersByEmailsRequest {
    organizationId?: string;
    emails: string[];
}

export class ResponseOfListOfRegistrationStatusAndString implements IResponseOfListOfRegistrationStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegistrationStatus[] | undefined;

    constructor(data?: IResponseOfListOfRegistrationStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RegistrationStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRegistrationStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRegistrationStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRegistrationStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegistrationStatus[] | undefined;
}

export class ResponseOfListOfRegistrationStatus extends ResponseOfListOfRegistrationStatusAndString implements IResponseOfListOfRegistrationStatus {

    constructor(data?: IResponseOfListOfRegistrationStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRegistrationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRegistrationStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRegistrationStatus extends IResponseOfListOfRegistrationStatusAndString {
}

export class ListResponseOfRegistrationStatus extends ResponseOfListOfRegistrationStatus implements IListResponseOfRegistrationStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRegistrationStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRegistrationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRegistrationStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRegistrationStatus extends IResponseOfListOfRegistrationStatus {
    totalRecords?: number | undefined;
}

export class RegistrationStatus implements IRegistrationStatus {
    userId?: string;
    skuId?: string;
    isExisting?: boolean;
    currentEndDate?: Date | undefined;

    constructor(data?: IRegistrationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.skuId = _data["skuId"];
            this.isExisting = _data["isExisting"];
            this.currentEndDate = _data["currentEndDate"] ? new Date(_data["currentEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RegistrationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["skuId"] = this.skuId;
        data["isExisting"] = this.isExisting;
        data["currentEndDate"] = this.currentEndDate ? this.currentEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IRegistrationStatus {
    userId?: string;
    skuId?: string;
    isExisting?: boolean;
    currentEndDate?: Date | undefined;
}

export class ListRequestOfRegistrationStateFilter implements IListRequestOfRegistrationStateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RegistrationStateFilter | undefined;

    constructor(data?: IListRequestOfRegistrationStateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? RegistrationStateFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfRegistrationStateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfRegistrationStateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfRegistrationStateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RegistrationStateFilter | undefined;
}

export class RegistrationStateFilter extends BaseFilter implements IRegistrationStateFilter {
    pairs!: RegistrationStatePair[];

    constructor(data?: IRegistrationStateFilter) {
        super(data);
        if (!data) {
            this.pairs = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pairs"])) {
                this.pairs = [] as any;
                for (let item of _data["pairs"])
                    this.pairs!.push(RegistrationStatePair.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RegistrationStateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStateFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairs)) {
            data["pairs"] = [];
            for (let item of this.pairs)
                data["pairs"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRegistrationStateFilter extends IBaseFilter {
    pairs: RegistrationStatePair[];
}

export class RegistrationStatePair implements IRegistrationStatePair {
    userId?: string;
    organizationId?: string;
    skuId?: string;

    constructor(data?: IRegistrationStatePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): RegistrationStatePair {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStatePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface IRegistrationStatePair {
    userId?: string;
    organizationId?: string;
    skuId?: string;
}

export class CertifyUserSkuRequest implements ICertifyUserSkuRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;
    userSkuId?: string;
    changeReason!: string;
    completionDate?: Date;
    creditsEarned?: number | undefined;

    constructor(data?: ICertifyUserSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.userSkuId = _data["userSkuId"];
            this.changeReason = _data["changeReason"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : undefined as any;
            this.creditsEarned = _data["creditsEarned"];
        }
    }

    static fromJS(data: any): CertifyUserSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertifyUserSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["userSkuId"] = this.userSkuId;
        data["changeReason"] = this.changeReason;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : undefined as any;
        data["creditsEarned"] = this.creditsEarned;
        return data;
    }
}

export interface ICertifyUserSkuRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;
    userSkuId?: string;
    changeReason: string;
    completionDate?: Date;
    creditsEarned?: number | undefined;
}

export class ResponseOfListOfUserSkuExtendedAndString implements IResponseOfListOfUserSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuExtended[] | undefined;

    constructor(data?: IResponseOfListOfUserSkuExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserSkuExtended.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfUserSkuExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfUserSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuExtended[] | undefined;
}

export class ResponseOfListOfUserSkuExtended extends ResponseOfListOfUserSkuExtendedAndString implements IResponseOfListOfUserSkuExtended {

    constructor(data?: IResponseOfListOfUserSkuExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfUserSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfUserSkuExtended extends IResponseOfListOfUserSkuExtendedAndString {
}

export class ListResponseOfUserSkuExtended extends ResponseOfListOfUserSkuExtended implements IListResponseOfUserSkuExtended {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfUserSkuExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfUserSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfUserSkuExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfUserSkuExtended extends IResponseOfListOfUserSkuExtended {
    totalRecords?: number | undefined;
}

export class UserSkuExtended implements IUserSkuExtended {
    id?: string;
    userId?: string;
    skuId?: string | undefined;
    parentUserSkuId?: string | undefined;
    sku?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    completedDate?: Date | undefined;
    hasChildren?: boolean;
    userSkuStateName?: string | undefined;
    title?: string | undefined;
    format?: string | undefined;
    skuAvailability?: string | undefined;
    isListedInCatalog?: boolean;
    isTrial?: boolean;
    isTest?: boolean;

    constructor(data?: IUserSkuExtended) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.skuId = _data["skuId"];
            this.parentUserSkuId = _data["parentUserSkuId"];
            this.sku = _data["sku"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined as any;
            this.hasChildren = _data["hasChildren"];
            this.userSkuStateName = _data["userSkuStateName"];
            this.title = _data["title"];
            this.format = _data["format"];
            this.skuAvailability = _data["skuAvailability"];
            this.isListedInCatalog = _data["isListedInCatalog"];
            this.isTrial = _data["isTrial"];
            this.isTest = _data["isTest"];
        }
    }

    static fromJS(data: any): UserSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new UserSkuExtended();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["skuId"] = this.skuId;
        data["parentUserSkuId"] = this.parentUserSkuId;
        data["sku"] = this.sku;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["hasChildren"] = this.hasChildren;
        data["userSkuStateName"] = this.userSkuStateName;
        data["title"] = this.title;
        data["format"] = this.format;
        data["skuAvailability"] = this.skuAvailability;
        data["isListedInCatalog"] = this.isListedInCatalog;
        data["isTrial"] = this.isTrial;
        data["isTest"] = this.isTest;
        return data;
    }
}

export interface IUserSkuExtended {
    id?: string;
    userId?: string;
    skuId?: string | undefined;
    parentUserSkuId?: string | undefined;
    sku?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    completedDate?: Date | undefined;
    hasChildren?: boolean;
    userSkuStateName?: string | undefined;
    title?: string | undefined;
    format?: string | undefined;
    skuAvailability?: string | undefined;
    isListedInCatalog?: boolean;
    isTrial?: boolean;
    isTest?: boolean;
}

export class ListRequestOfUserSkuFilter implements IListRequestOfUserSkuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: UserSkuFilter | undefined;

    constructor(data?: IListRequestOfUserSkuFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? UserSkuFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfUserSkuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfUserSkuFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfUserSkuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: UserSkuFilter | undefined;
}

export class AdminUserSkuRequest extends ListRequestOfUserSkuFilter implements IAdminUserSkuRequest {
    userId?: string;
    organizationId?: string;
    parentUserSkuId?: string | undefined;

    constructor(data?: IAdminUserSkuRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.parentUserSkuId = _data["parentUserSkuId"];
        }
    }

    static override fromJS(data: any): AdminUserSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserSkuRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["parentUserSkuId"] = this.parentUserSkuId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminUserSkuRequest extends IListRequestOfUserSkuFilter {
    userId?: string;
    organizationId?: string;
    parentUserSkuId?: string | undefined;
}

export class UserSkuFilter extends BaseFilter implements IUserSkuFilter {
    userSkuId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    includedSkuFormatIds?: string[] | undefined;
    includedSkuAvailabilityIds?: string[] | undefined;
    userSkuStateIds?: string[] | undefined;
    orderedProductTypeIds?: string[] | undefined;
    userChargebackFilter?: UserChargebackFilter | undefined;
    includeProductTypes?: ProductTypes[] | undefined;
    strictStateFiltering?: boolean;

    constructor(data?: IUserSkuFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userSkuId = _data["userSkuId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["includedSkuFormatIds"])) {
                this.includedSkuFormatIds = [] as any;
                for (let item of _data["includedSkuFormatIds"])
                    this.includedSkuFormatIds!.push(item);
            }
            if (Array.isArray(_data["includedSkuAvailabilityIds"])) {
                this.includedSkuAvailabilityIds = [] as any;
                for (let item of _data["includedSkuAvailabilityIds"])
                    this.includedSkuAvailabilityIds!.push(item);
            }
            if (Array.isArray(_data["userSkuStateIds"])) {
                this.userSkuStateIds = [] as any;
                for (let item of _data["userSkuStateIds"])
                    this.userSkuStateIds!.push(item);
            }
            if (Array.isArray(_data["orderedProductTypeIds"])) {
                this.orderedProductTypeIds = [] as any;
                for (let item of _data["orderedProductTypeIds"])
                    this.orderedProductTypeIds!.push(item);
            }
            this.userChargebackFilter = _data["userChargebackFilter"] ? UserChargebackFilter.fromJS(_data["userChargebackFilter"]) : undefined as any;
            if (Array.isArray(_data["includeProductTypes"])) {
                this.includeProductTypes = [] as any;
                for (let item of _data["includeProductTypes"])
                    this.includeProductTypes!.push(item);
            }
            this.strictStateFiltering = _data["strictStateFiltering"];
        }
    }

    static override fromJS(data: any): UserSkuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserSkuFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSkuId"] = this.userSkuId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.includedSkuFormatIds)) {
            data["includedSkuFormatIds"] = [];
            for (let item of this.includedSkuFormatIds)
                data["includedSkuFormatIds"].push(item);
        }
        if (Array.isArray(this.includedSkuAvailabilityIds)) {
            data["includedSkuAvailabilityIds"] = [];
            for (let item of this.includedSkuAvailabilityIds)
                data["includedSkuAvailabilityIds"].push(item);
        }
        if (Array.isArray(this.userSkuStateIds)) {
            data["userSkuStateIds"] = [];
            for (let item of this.userSkuStateIds)
                data["userSkuStateIds"].push(item);
        }
        if (Array.isArray(this.orderedProductTypeIds)) {
            data["orderedProductTypeIds"] = [];
            for (let item of this.orderedProductTypeIds)
                data["orderedProductTypeIds"].push(item);
        }
        data["userChargebackFilter"] = this.userChargebackFilter ? this.userChargebackFilter.toJSON() : undefined as any;
        if (Array.isArray(this.includeProductTypes)) {
            data["includeProductTypes"] = [];
            for (let item of this.includeProductTypes)
                data["includeProductTypes"].push(item);
        }
        data["strictStateFiltering"] = this.strictStateFiltering;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSkuFilter extends IBaseFilter {
    userSkuId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    includedSkuFormatIds?: string[] | undefined;
    includedSkuAvailabilityIds?: string[] | undefined;
    userSkuStateIds?: string[] | undefined;
    orderedProductTypeIds?: string[] | undefined;
    userChargebackFilter?: UserChargebackFilter | undefined;
    includeProductTypes?: ProductTypes[] | undefined;
    strictStateFiltering?: boolean;
}

export class UserChargebackFilter implements IUserChargebackFilter {
    renewalDate?: Date;

    constructor(data?: IUserChargebackFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserChargebackFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserChargebackFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserChargebackFilter {
    renewalDate?: Date;
}

export enum ProductTypes {
    SuperPackage = "SuperPackage",
    Product = "Product",
    Package = "Package",
    Series = "Series",
    Membership = "Membership",
    ThirdParty = "ThirdParty",
    ResourceLibrary = "ResourceLibrary",
    Unknown = "Unknown",
    Catalog = "Catalog",
}

export class ResponseOfUserSkuExtendedAndString implements IResponseOfUserSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuExtended | undefined;

    constructor(data?: IResponseOfUserSkuExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? UserSkuExtended.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfUserSkuExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfUserSkuExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfUserSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuExtended | undefined;
}

export class ResponseOfUserSkuExtended extends ResponseOfUserSkuExtendedAndString implements IResponseOfUserSkuExtended {

    constructor(data?: IResponseOfUserSkuExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfUserSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfUserSkuExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfUserSkuExtended extends IResponseOfUserSkuExtendedAndString {
}

export class ResponseOfGuidAndString implements IResponseOfGuidAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string;

    constructor(data?: IResponseOfGuidAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfGuidAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfGuidAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfGuidAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string;
}

export class ResponseOfGuid extends ResponseOfGuidAndString implements IResponseOfGuid {

    constructor(data?: IResponseOfGuid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfGuid extends IResponseOfGuidAndString {
}

export class DeleteUserSkuRequest implements IDeleteUserSkuRequest {
    changeReason!: string;
    userId?: string;
    organizationId?: string;
    userSkuId?: string;

    constructor(data?: IDeleteUserSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeReason = _data["changeReason"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.userSkuId = _data["userSkuId"];
        }
    }

    static fromJS(data: any): DeleteUserSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeReason"] = this.changeReason;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["userSkuId"] = this.userSkuId;
        return data;
    }
}

export interface IDeleteUserSkuRequest {
    changeReason: string;
    userId?: string;
    organizationId?: string;
    userSkuId?: string;
}

export class UserChargebackRequest implements IUserChargebackRequest {
    userId?: string;
    organizationId?: string;
    userSkuId!: string;
    renewalDate?: Date;

    constructor(data?: IUserChargebackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.userSkuId = _data["userSkuId"];
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserChargebackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserChargebackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["userSkuId"] = this.userSkuId;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserChargebackRequest {
    userId?: string;
    organizationId?: string;
    userSkuId: string;
    renewalDate?: Date;
}

export class ModifyEnrollmentRequest implements IModifyEnrollmentRequest {
    userSkuId!: string;
    userId?: string;
    changeReason!: string;
    organizationId?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IModifyEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSkuId = _data["userSkuId"];
            this.userId = _data["userId"];
            this.changeReason = _data["changeReason"];
            this.organizationId = _data["organizationId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ModifyEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSkuId"] = this.userSkuId;
        data["userId"] = this.userId;
        data["changeReason"] = this.changeReason;
        data["organizationId"] = this.organizationId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IModifyEnrollmentRequest {
    userSkuId: string;
    userId?: string;
    changeReason: string;
    organizationId?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class MarkAsAttendedRequest implements IMarkAsAttendedRequest {
    organizationId?: string;
    userSkuId!: string;
    userId!: string;
    changeReason!: string;

    constructor(data?: IMarkAsAttendedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.userSkuId = _data["userSkuId"];
            this.userId = _data["userId"];
            this.changeReason = _data["changeReason"];
        }
    }

    static fromJS(data: any): MarkAsAttendedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsAttendedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["userSkuId"] = this.userSkuId;
        data["userId"] = this.userId;
        data["changeReason"] = this.changeReason;
        return data;
    }
}

export interface IMarkAsAttendedRequest {
    organizationId?: string;
    userSkuId: string;
    userId: string;
    changeReason: string;
}

export class ResponseOfBooleanAndString implements IResponseOfBooleanAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: boolean;

    constructor(data?: IResponseOfBooleanAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfBooleanAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBooleanAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfBooleanAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: boolean;
}

export class ResponseOfBoolean extends ResponseOfBooleanAndString implements IResponseOfBoolean {

    constructor(data?: IResponseOfBoolean) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBoolean();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfBoolean extends IResponseOfBooleanAndString {
}

export class CanRegisterUserSkuRequest implements ICanRegisterUserSkuRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;

    constructor(data?: ICanRegisterUserSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): CanRegisterUserSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CanRegisterUserSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ICanRegisterUserSkuRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;
}

export class ResponseOfListOfSkuRegistrationAndString implements IResponseOfListOfSkuRegistrationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuRegistration[] | undefined;

    constructor(data?: IResponseOfListOfSkuRegistrationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuRegistration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuRegistrationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuRegistrationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuRegistrationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuRegistration[] | undefined;
}

export class ResponseOfListOfSkuRegistration extends ResponseOfListOfSkuRegistrationAndString implements IResponseOfListOfSkuRegistration {

    constructor(data?: IResponseOfListOfSkuRegistration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuRegistration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuRegistration extends IResponseOfListOfSkuRegistrationAndString {
}

export class ListResponseOfSkuRegistration extends ResponseOfListOfSkuRegistration implements IListResponseOfSkuRegistration {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuRegistration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuRegistration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuRegistration extends IResponseOfListOfSkuRegistration {
    totalRecords?: number | undefined;
}

export class SkuRegistration implements ISkuRegistration {
    userId?: string;
    skuId?: string;
    userSkuId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    status?: string | undefined;
    registrationDate?: Date | undefined;
    completionDate?: Date | undefined;

    constructor(data?: ISkuRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.skuId = _data["skuId"];
            this.userSkuId = _data["userSkuId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : undefined as any;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SkuRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new SkuRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["skuId"] = this.skuId;
        data["userSkuId"] = this.userSkuId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : undefined as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISkuRegistration {
    userId?: string;
    skuId?: string;
    userSkuId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    status?: string | undefined;
    registrationDate?: Date | undefined;
    completionDate?: Date | undefined;
}

export class ListRequestOfStateFilter implements IListRequestOfStateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: StateFilter | undefined;

    constructor(data?: IListRequestOfStateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? StateFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfStateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfStateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfStateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: StateFilter | undefined;
}

export class StateFilter extends BaseFilter implements IStateFilter {
    stateId?: string | undefined;

    constructor(data?: IStateFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stateId = _data["stateId"];
        }
    }

    static override fromJS(data: any): StateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new StateFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateId"] = this.stateId;
        super.toJSON(data);
        return data;
    }
}

export interface IStateFilter extends IBaseFilter {
    stateId?: string | undefined;
}

export class ListRequestOfStateFilterRequest implements IListRequestOfStateFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: StateFilterRequest | undefined;

    constructor(data?: IListRequestOfStateFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? StateFilterRequest.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfStateFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfStateFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfStateFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: StateFilterRequest | undefined;
}

export class StateFilterRequest implements IStateFilterRequest {
    skuRegistrationsDownloadUrl?: string | undefined;
    stateFilter?: StateFilter | undefined;

    constructor(data?: IStateFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuRegistrationsDownloadUrl = _data["skuRegistrationsDownloadUrl"];
            this.stateFilter = _data["stateFilter"] ? StateFilter.fromJS(_data["stateFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): StateFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StateFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuRegistrationsDownloadUrl"] = this.skuRegistrationsDownloadUrl;
        data["stateFilter"] = this.stateFilter ? this.stateFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IStateFilterRequest {
    skuRegistrationsDownloadUrl?: string | undefined;
    stateFilter?: StateFilter | undefined;
}

export class ResponseOfListOfUserSkuActivityAndString implements IResponseOfListOfUserSkuActivityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuActivity[] | undefined;

    constructor(data?: IResponseOfListOfUserSkuActivityAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserSkuActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfUserSkuActivityAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuActivityAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfUserSkuActivityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuActivity[] | undefined;
}

export class ResponseOfListOfUserSkuActivity extends ResponseOfListOfUserSkuActivityAndString implements IResponseOfListOfUserSkuActivity {

    constructor(data?: IResponseOfListOfUserSkuActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfUserSkuActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfUserSkuActivity extends IResponseOfListOfUserSkuActivityAndString {
}

export class ListResponseOfUserSkuActivity extends ResponseOfListOfUserSkuActivity implements IListResponseOfUserSkuActivity {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfUserSkuActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfUserSkuActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfUserSkuActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfUserSkuActivity extends IResponseOfListOfUserSkuActivity {
    totalRecords?: number | undefined;
}

export class UserSkuActivity implements IUserSkuActivity {
    id?: string;
    activityDate?: Date;
    activityTypeName?: string | undefined;
    activityEventName?: string | undefined;
    createdBy?: string | undefined;

    constructor(data?: IUserSkuActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityDate = _data["activityDate"] ? new Date(_data["activityDate"].toString()) : undefined as any;
            this.activityTypeName = _data["activityTypeName"];
            this.activityEventName = _data["activityEventName"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): UserSkuActivity {
        data = typeof data === 'object' ? data : {};
        let result = new UserSkuActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : undefined as any;
        data["activityTypeName"] = this.activityTypeName;
        data["activityEventName"] = this.activityEventName;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IUserSkuActivity {
    id?: string;
    activityDate?: Date;
    activityTypeName?: string | undefined;
    activityEventName?: string | undefined;
    createdBy?: string | undefined;
}

export class ListRequestOfUserSkuActivitiesFilter implements IListRequestOfUserSkuActivitiesFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: UserSkuActivitiesFilter | undefined;

    constructor(data?: IListRequestOfUserSkuActivitiesFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? UserSkuActivitiesFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfUserSkuActivitiesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfUserSkuActivitiesFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfUserSkuActivitiesFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: UserSkuActivitiesFilter | undefined;
}

export class UserSkuActivitiesFilter extends BaseFilter implements IUserSkuActivitiesFilter {
    userSkuId?: string;

    constructor(data?: IUserSkuActivitiesFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userSkuId = _data["userSkuId"];
        }
    }

    static override fromJS(data: any): UserSkuActivitiesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserSkuActivitiesFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSkuId"] = this.userSkuId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSkuActivitiesFilter extends IBaseFilter {
    userSkuId?: string;
}

export class ResponseOfListOfUserSkuAuditTimelineEntryAndString implements IResponseOfListOfUserSkuAuditTimelineEntryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuAuditTimelineEntry[] | undefined;

    constructor(data?: IResponseOfListOfUserSkuAuditTimelineEntryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserSkuAuditTimelineEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfUserSkuAuditTimelineEntryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuAuditTimelineEntryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfUserSkuAuditTimelineEntryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuAuditTimelineEntry[] | undefined;
}

export class ResponseOfListOfUserSkuAuditTimelineEntry extends ResponseOfListOfUserSkuAuditTimelineEntryAndString implements IResponseOfListOfUserSkuAuditTimelineEntry {

    constructor(data?: IResponseOfListOfUserSkuAuditTimelineEntry) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfUserSkuAuditTimelineEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuAuditTimelineEntry();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfUserSkuAuditTimelineEntry extends IResponseOfListOfUserSkuAuditTimelineEntryAndString {
}

export class ListResponseOfUserSkuAuditTimelineEntry extends ResponseOfListOfUserSkuAuditTimelineEntry implements IListResponseOfUserSkuAuditTimelineEntry {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfUserSkuAuditTimelineEntry) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfUserSkuAuditTimelineEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfUserSkuAuditTimelineEntry();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfUserSkuAuditTimelineEntry extends IResponseOfListOfUserSkuAuditTimelineEntry {
    totalRecords?: number | undefined;
}

export class UserSkuAuditTimelineEntry implements IUserSkuAuditTimelineEntry {
    id?: string;
    source?: TimelineSource;
    date?: Date;
    event?: string | undefined;
    actor?: TimelineActor | undefined;
    rows?: TimelineEntryRow[] | undefined;

    constructor(data?: IUserSkuAuditTimelineEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.source = _data["source"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.event = _data["event"];
            this.actor = _data["actor"] ? TimelineActor.fromJS(_data["actor"]) : undefined as any;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TimelineEntryRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSkuAuditTimelineEntry {
        data = typeof data === 'object' ? data : {};
        let result = new UserSkuAuditTimelineEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["source"] = this.source;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["event"] = this.event;
        data["actor"] = this.actor ? this.actor.toJSON() : undefined as any;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserSkuAuditTimelineEntry {
    id?: string;
    source?: TimelineSource;
    date?: Date;
    event?: string | undefined;
    actor?: TimelineActor | undefined;
    rows?: TimelineEntryRow[] | undefined;
}

export enum TimelineSource {
    UserSkuActivity = "UserSkuActivity",
    CompletionActivity = "CompletionActivity",
    AuditLog = "AuditLog",
}

export class TimelineActor implements ITimelineActor {
    kind?: ActorKind;
    displayName?: string | undefined;
    organizationUserId?: string | undefined;
    raw?: string | undefined;

    constructor(data?: ITimelineActor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.displayName = _data["displayName"];
            this.organizationUserId = _data["organizationUserId"];
            this.raw = _data["raw"];
        }
    }

    static fromJS(data: any): TimelineActor {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineActor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["displayName"] = this.displayName;
        data["organizationUserId"] = this.organizationUserId;
        data["raw"] = this.raw;
        return data;
    }
}

export interface ITimelineActor {
    kind?: ActorKind;
    displayName?: string | undefined;
    organizationUserId?: string | undefined;
    raw?: string | undefined;
}

export enum ActorKind {
    Unknown = "Unknown",
    User = "User",
    Admin = "Admin",
    Other = "Other",
}

export class TimelineEntryRow implements ITimelineEntryRow {
    name?: string | undefined;
    priorValue?: string | undefined;
    value?: string | undefined;

    constructor(data?: ITimelineEntryRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.priorValue = _data["priorValue"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TimelineEntryRow {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineEntryRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["priorValue"] = this.priorValue;
        data["value"] = this.value;
        return data;
    }
}

export interface ITimelineEntryRow {
    name?: string | undefined;
    priorValue?: string | undefined;
    value?: string | undefined;
}

export class ChangeParentUserSkuRequest implements IChangeParentUserSkuRequest {
    changeReason!: string;
    userId!: string;
    userSkuId!: string;
    parentUserSkuId!: string;
    organizationId!: string;

    constructor(data?: IChangeParentUserSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeReason = _data["changeReason"];
            this.userId = _data["userId"];
            this.userSkuId = _data["userSkuId"];
            this.parentUserSkuId = _data["parentUserSkuId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ChangeParentUserSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeParentUserSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeReason"] = this.changeReason;
        data["userId"] = this.userId;
        data["userSkuId"] = this.userSkuId;
        data["parentUserSkuId"] = this.parentUserSkuId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IChangeParentUserSkuRequest {
    changeReason: string;
    userId: string;
    userSkuId: string;
    parentUserSkuId: string;
    organizationId: string;
}

export class ResponseOfListOfUserSkuStateAndString implements IResponseOfListOfUserSkuStateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuState[] | undefined;

    constructor(data?: IResponseOfListOfUserSkuStateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserSkuState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfUserSkuStateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuStateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfUserSkuStateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserSkuState[] | undefined;
}

export class ResponseOfListOfUserSkuState extends ResponseOfListOfUserSkuStateAndString implements IResponseOfListOfUserSkuState {

    constructor(data?: IResponseOfListOfUserSkuState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfUserSkuState {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserSkuState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfUserSkuState extends IResponseOfListOfUserSkuStateAndString {
}

export class ListResponseOfUserSkuState extends ResponseOfListOfUserSkuState implements IListResponseOfUserSkuState {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfUserSkuState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfUserSkuState {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfUserSkuState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfUserSkuState extends IResponseOfListOfUserSkuState {
    totalRecords?: number | undefined;
}

export class UserSkuState implements IUserSkuState {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUserSkuState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UserSkuState {
        data = typeof data === 'object' ? data : {};
        let result = new UserSkuState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface IUserSkuState {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
}

export class RusticiScopeInfo implements IRusticiScopeInfo {
    kind?: RusticiDeactivationScopeKind;
    rejection?: RusticiScopeRejection;
    rejectionDetail?: string | undefined;
    organizationName?: string | undefined;
    contentControllerHost?: string | undefined;

    constructor(data?: IRusticiScopeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.rejection = _data["rejection"];
            this.rejectionDetail = _data["rejectionDetail"];
            this.organizationName = _data["organizationName"];
            this.contentControllerHost = _data["contentControllerHost"];
        }
    }

    static fromJS(data: any): RusticiScopeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RusticiScopeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["rejection"] = this.rejection;
        data["rejectionDetail"] = this.rejectionDetail;
        data["organizationName"] = this.organizationName;
        data["contentControllerHost"] = this.contentControllerHost;
        return data;
    }
}

export interface IRusticiScopeInfo {
    kind?: RusticiDeactivationScopeKind;
    rejection?: RusticiScopeRejection;
    rejectionDetail?: string | undefined;
    organizationName?: string | undefined;
    contentControllerHost?: string | undefined;
}

export enum RusticiDeactivationScopeKind {
    Rejected = "Rejected",
    Content = "Content",
    Account = "Account",
}

export enum RusticiScopeRejection {
    None = "None",
    OrganizationAboveScormRoot = "OrganizationAboveScormRoot",
    OrganizationNotLinkedToContentController = "OrganizationNotLinkedToContentController",
    ContentControllerAccountNotFound = "ContentControllerAccountNotFound",
    OrganizationHasAmbiguousContentControllerAccounts = "OrganizationHasAmbiguousContentControllerAccounts",
}

export class RusticiCourseSearchResult implements IRusticiCourseSearchResult {
    scope?: RusticiScopeInfo | undefined;
    courses?: Course[] | undefined;

    constructor(data?: IRusticiCourseSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"] ? RusticiScopeInfo.fromJS(_data["scope"]) : undefined as any;
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(Course.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RusticiCourseSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new RusticiCourseSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope ? this.scope.toJSON() : undefined as any;
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRusticiCourseSearchResult {
    scope?: RusticiScopeInfo | undefined;
    courses?: Course[] | undefined;
}

export class Course implements ICourse {
    id?: string | undefined;
    name?: string | undefined;
    enabled?: boolean;
    description?: string | undefined;
    location?: string | undefined;
    updated_date?: Date | undefined;

    constructor(data?: ICourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.description = _data["description"];
            this.location = _data["location"];
            this.updated_date = _data["updated_date"] ? new Date(_data["updated_date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Course {
        data = typeof data === 'object' ? data : {};
        let result = new Course();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["description"] = this.description;
        data["location"] = this.location;
        data["updated_date"] = this.updated_date ? this.updated_date.toISOString() : undefined as any;
        return data;
    }
}

export interface ICourse {
    id?: string | undefined;
    name?: string | undefined;
    enabled?: boolean;
    description?: string | undefined;
    location?: string | undefined;
    updated_date?: Date | undefined;
}

export class RusticiCourseSearchRequest implements IRusticiCourseSearchRequest {
    mode?: DeactivationMode;
    skus?: string[] | undefined;

    constructor(data?: IRusticiCourseSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            if (Array.isArray(_data["skus"])) {
                this.skus = [] as any;
                for (let item of _data["skus"])
                    this.skus!.push(item);
            }
        }
    }

    static fromJS(data: any): RusticiCourseSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RusticiCourseSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        if (Array.isArray(this.skus)) {
            data["skus"] = [];
            for (let item of this.skus)
                data["skus"].push(item);
        }
        return data;
    }
}

export interface IRusticiCourseSearchRequest {
    mode?: DeactivationMode;
    skus?: string[] | undefined;
}

export enum DeactivationMode {
    Custom = "Custom",
    SelfStudy = "SelfStudy",
    Webinars = "Webinars",
}

export class RusticiDeactivationSummary implements IRusticiDeactivationSummary {
    scope?: RusticiScopeInfo | undefined;
    succeeded?: number;
    failedCourseIds?: string[] | undefined;
    skippedCourseIds?: string[] | undefined;

    constructor(data?: IRusticiDeactivationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"] ? RusticiScopeInfo.fromJS(_data["scope"]) : undefined as any;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["failedCourseIds"])) {
                this.failedCourseIds = [] as any;
                for (let item of _data["failedCourseIds"])
                    this.failedCourseIds!.push(item);
            }
            if (Array.isArray(_data["skippedCourseIds"])) {
                this.skippedCourseIds = [] as any;
                for (let item of _data["skippedCourseIds"])
                    this.skippedCourseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RusticiDeactivationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new RusticiDeactivationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope ? this.scope.toJSON() : undefined as any;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.failedCourseIds)) {
            data["failedCourseIds"] = [];
            for (let item of this.failedCourseIds)
                data["failedCourseIds"].push(item);
        }
        if (Array.isArray(this.skippedCourseIds)) {
            data["skippedCourseIds"] = [];
            for (let item of this.skippedCourseIds)
                data["skippedCourseIds"].push(item);
        }
        return data;
    }
}

export interface IRusticiDeactivationSummary {
    scope?: RusticiScopeInfo | undefined;
    succeeded?: number;
    failedCourseIds?: string[] | undefined;
    skippedCourseIds?: string[] | undefined;
}

export class RusticiDeactivationRequest implements IRusticiDeactivationRequest {
    mode?: DeactivationMode;
    skus?: string[] | undefined;
    courseIds?: string[] | undefined;

    constructor(data?: IRusticiDeactivationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            if (Array.isArray(_data["skus"])) {
                this.skus = [] as any;
                for (let item of _data["skus"])
                    this.skus!.push(item);
            }
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RusticiDeactivationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RusticiDeactivationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        if (Array.isArray(this.skus)) {
            data["skus"] = [];
            for (let item of this.skus)
                data["skus"].push(item);
        }
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        return data;
    }
}

export interface IRusticiDeactivationRequest {
    mode?: DeactivationMode;
    skus?: string[] | undefined;
    courseIds?: string[] | undefined;
}

export class RusticiExportOrganization implements IRusticiExportOrganization {
    organizationId?: string;
    organizationName?: string | undefined;
    contentControllerAccountId?: string | undefined;
    isAvailableInContentController?: boolean;

    constructor(data?: IRusticiExportOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.contentControllerAccountId = _data["contentControllerAccountId"];
            this.isAvailableInContentController = _data["isAvailableInContentController"];
        }
    }

    static fromJS(data: any): RusticiExportOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new RusticiExportOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["contentControllerAccountId"] = this.contentControllerAccountId;
        data["isAvailableInContentController"] = this.isAvailableInContentController;
        return data;
    }
}

export interface IRusticiExportOrganization {
    organizationId?: string;
    organizationName?: string | undefined;
    contentControllerAccountId?: string | undefined;
    isAvailableInContentController?: boolean;
}

export class PreviewPdfRequest implements IPreviewPdfRequest {
    html?: string | undefined;
    isLandscape?: boolean;

    constructor(data?: IPreviewPdfRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.html = _data["html"];
            this.isLandscape = _data["isLandscape"];
        }
    }

    static fromJS(data: any): PreviewPdfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewPdfRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["html"] = this.html;
        data["isLandscape"] = this.isLandscape;
        return data;
    }
}

export interface IPreviewPdfRequest {
    html?: string | undefined;
    isLandscape?: boolean;
}

export class ResponseOfListOfAgreementStatusResponseAndString implements IResponseOfListOfAgreementStatusResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AgreementStatusResponse[] | undefined;

    constructor(data?: IResponseOfListOfAgreementStatusResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AgreementStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAgreementStatusResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAgreementStatusResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAgreementStatusResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AgreementStatusResponse[] | undefined;
}

export class ResponseOfListOfAgreementStatusResponse extends ResponseOfListOfAgreementStatusResponseAndString implements IResponseOfListOfAgreementStatusResponse {

    constructor(data?: IResponseOfListOfAgreementStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAgreementStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAgreementStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAgreementStatusResponse extends IResponseOfListOfAgreementStatusResponseAndString {
}

export class ListResponseOfAgreementStatusResponse extends ResponseOfListOfAgreementStatusResponse implements IListResponseOfAgreementStatusResponse {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAgreementStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAgreementStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAgreementStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAgreementStatusResponse extends IResponseOfListOfAgreementStatusResponse {
    totalRecords?: number | undefined;
}

export class AgreementStatusResponse implements IAgreementStatusResponse {
    id?: string;
    name?: string | undefined;

    constructor(data?: IAgreementStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AgreementStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAgreementStatusResponse {
    id?: string;
    name?: string | undefined;
}

export class AgreementRequest implements IAgreementRequest {
    id?: string | undefined;
    organizationId?: string;
    templateVersionId?: string;
    agreementStatusId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    manualReplacements?: string | undefined;
    statusDate?: Date;
    content?: string | undefined;

    constructor(data?: IAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.templateVersionId = _data["templateVersionId"];
            this.agreementStatusId = _data["agreementStatusId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.manualReplacements = _data["manualReplacements"];
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : undefined as any;
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["templateVersionId"] = this.templateVersionId;
        data["agreementStatusId"] = this.agreementStatusId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["manualReplacements"] = this.manualReplacements;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : undefined as any;
        data["content"] = this.content;
        return data;
    }
}

export interface IAgreementRequest {
    id?: string | undefined;
    organizationId?: string;
    templateVersionId?: string;
    agreementStatusId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    manualReplacements?: string | undefined;
    statusDate?: Date;
    content?: string | undefined;
}

export class AgreementContentRequest implements IAgreementContentRequest {
    templateVersionId?: string;
    content?: string | undefined;

    constructor(data?: IAgreementContentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateVersionId = _data["templateVersionId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AgreementContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateVersionId"] = this.templateVersionId;
        data["content"] = this.content;
        return data;
    }
}

export interface IAgreementContentRequest {
    templateVersionId?: string;
    content?: string | undefined;
}

export class ResponseOfAgreementResponseAndString implements IResponseOfAgreementResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AgreementResponse | undefined;

    constructor(data?: IResponseOfAgreementResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? AgreementResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAgreementResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAgreementResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAgreementResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AgreementResponse | undefined;
}

export class ResponseOfAgreementResponse extends ResponseOfAgreementResponseAndString implements IResponseOfAgreementResponse {

    constructor(data?: IResponseOfAgreementResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAgreementResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAgreementResponse extends IResponseOfAgreementResponseAndString {
}

export class AgreementResponse implements IAgreementResponse {
    id!: string;
    organizationId?: string;
    organizationName?: string | undefined;
    templateVersionId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    agreementStatusId?: string;
    agreementStatusName?: string | undefined;
    manualReplacements?: string | undefined;
    content?: string | undefined;

    constructor(data?: IAgreementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.templateVersionId = _data["templateVersionId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.agreementStatusId = _data["agreementStatusId"];
            this.agreementStatusName = _data["agreementStatusName"];
            this.manualReplacements = _data["manualReplacements"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["templateVersionId"] = this.templateVersionId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["agreementStatusId"] = this.agreementStatusId;
        data["agreementStatusName"] = this.agreementStatusName;
        data["manualReplacements"] = this.manualReplacements;
        data["content"] = this.content;
        return data;
    }
}

export interface IAgreementResponse {
    id: string;
    organizationId?: string;
    organizationName?: string | undefined;
    templateVersionId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    agreementStatusId?: string;
    agreementStatusName?: string | undefined;
    manualReplacements?: string | undefined;
    content?: string | undefined;
}

export class ResponseOfListOfAgreementResponseAndString implements IResponseOfListOfAgreementResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AgreementResponse[] | undefined;

    constructor(data?: IResponseOfListOfAgreementResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AgreementResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAgreementResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAgreementResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAgreementResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AgreementResponse[] | undefined;
}

export class ResponseOfListOfAgreementResponse extends ResponseOfListOfAgreementResponseAndString implements IResponseOfListOfAgreementResponse {

    constructor(data?: IResponseOfListOfAgreementResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAgreementResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAgreementResponse extends IResponseOfListOfAgreementResponseAndString {
}

export class ListResponseOfAgreementResponse extends ResponseOfListOfAgreementResponse implements IListResponseOfAgreementResponse {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAgreementResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAgreementResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAgreementResponse extends IResponseOfListOfAgreementResponse {
    totalRecords?: number | undefined;
}

export class ListRequestOfAgreementFilter implements IListRequestOfAgreementFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AgreementFilter | undefined;

    constructor(data?: IListRequestOfAgreementFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AgreementFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAgreementFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAgreementFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAgreementFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AgreementFilter | undefined;
}

export class AgreementFilter extends BaseFilter implements IAgreementFilter {
    agreementStatusIds?: string[] | undefined;

    constructor(data?: IAgreementFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["agreementStatusIds"])) {
                this.agreementStatusIds = [] as any;
                for (let item of _data["agreementStatusIds"])
                    this.agreementStatusIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): AgreementFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agreementStatusIds)) {
            data["agreementStatusIds"] = [];
            for (let item of this.agreementStatusIds)
                data["agreementStatusIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAgreementFilter extends IBaseFilter {
    agreementStatusIds?: string[] | undefined;
}

export class ResponseOfListOfPlaceholderAdminAndString implements IResponseOfListOfPlaceholderAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: PlaceholderAdmin[] | undefined;

    constructor(data?: IResponseOfListOfPlaceholderAdminAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlaceholderAdmin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfPlaceholderAdminAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfPlaceholderAdminAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfPlaceholderAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: PlaceholderAdmin[] | undefined;
}

export class ResponseOfListOfPlaceholderAdmin extends ResponseOfListOfPlaceholderAdminAndString implements IResponseOfListOfPlaceholderAdmin {

    constructor(data?: IResponseOfListOfPlaceholderAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfPlaceholderAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfPlaceholderAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfPlaceholderAdmin extends IResponseOfListOfPlaceholderAdminAndString {
}

export class ListResponseOfPlaceholderAdmin extends ResponseOfListOfPlaceholderAdmin implements IListResponseOfPlaceholderAdmin {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfPlaceholderAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfPlaceholderAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfPlaceholderAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfPlaceholderAdmin extends IResponseOfListOfPlaceholderAdmin {
    totalRecords?: number | undefined;
}

export class PlaceholderAdmin implements IPlaceholderAdmin {
    title?: string | undefined;
    description?: string | undefined;
    content?: string | undefined;

    constructor(data?: IPlaceholderAdmin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): PlaceholderAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceholderAdmin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["content"] = this.content;
        return data;
    }
}

export interface IPlaceholderAdmin {
    title?: string | undefined;
    description?: string | undefined;
    content?: string | undefined;
}

export class ListRequestOfPlaceholderFilter implements IListRequestOfPlaceholderFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: PlaceholderFilter | undefined;

    constructor(data?: IListRequestOfPlaceholderFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? PlaceholderFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfPlaceholderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfPlaceholderFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfPlaceholderFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: PlaceholderFilter | undefined;
}

export class AdminListRequestOfPlaceholderFilter extends ListRequestOfPlaceholderFilter implements IAdminListRequestOfPlaceholderFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfPlaceholderFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfPlaceholderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfPlaceholderFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfPlaceholderFilter extends IListRequestOfPlaceholderFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class PlaceholderFilter extends BaseFilter implements IPlaceholderFilter {
    templateTypeId?: string;
    templateEntityId?: string;

    constructor(data?: IPlaceholderFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateTypeId = _data["templateTypeId"];
            this.templateEntityId = _data["templateEntityId"];
        }
    }

    static override fromJS(data: any): PlaceholderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceholderFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateTypeId"] = this.templateTypeId;
        data["templateEntityId"] = this.templateEntityId;
        super.toJSON(data);
        return data;
    }
}

export interface IPlaceholderFilter extends IBaseFilter {
    templateTypeId?: string;
    templateEntityId?: string;
}

export class ResponseOfListOfApplicationUserAndString implements IResponseOfListOfApplicationUserAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ApplicationUser[] | undefined;

    constructor(data?: IResponseOfListOfApplicationUserAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ApplicationUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfApplicationUserAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfApplicationUserAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfApplicationUserAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ApplicationUser[] | undefined;
}

export class ResponseOfListOfApplicationUser extends ResponseOfListOfApplicationUserAndString implements IResponseOfListOfApplicationUser {

    constructor(data?: IResponseOfListOfApplicationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfApplicationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfApplicationUser extends IResponseOfListOfApplicationUserAndString {
}

export class ListResponseOfApplicationUser extends ResponseOfListOfApplicationUser implements IListResponseOfApplicationUser {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfApplicationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfApplicationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfApplicationUser extends IResponseOfListOfApplicationUser {
    totalRecords?: number | undefined;
}

export class ApplicationUser implements IApplicationUser {
    id!: string;
    applicationId!: string;
    organizationUserId!: string;
    userStatusTypeId!: string;
    applicationName!: string;
    userStatusTypeName!: string;
    applicationAllowGrantingUserAccess!: boolean;

    constructor(data?: IApplicationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.organizationUserId = _data["organizationUserId"];
            this.userStatusTypeId = _data["userStatusTypeId"];
            this.applicationName = _data["applicationName"];
            this.userStatusTypeName = _data["userStatusTypeName"];
            this.applicationAllowGrantingUserAccess = _data["applicationAllowGrantingUserAccess"];
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["organizationUserId"] = this.organizationUserId;
        data["userStatusTypeId"] = this.userStatusTypeId;
        data["applicationName"] = this.applicationName;
        data["userStatusTypeName"] = this.userStatusTypeName;
        data["applicationAllowGrantingUserAccess"] = this.applicationAllowGrantingUserAccess;
        return data;
    }
}

export interface IApplicationUser {
    id: string;
    applicationId: string;
    organizationUserId: string;
    userStatusTypeId: string;
    applicationName: string;
    userStatusTypeName: string;
    applicationAllowGrantingUserAccess: boolean;
}

export class ListRequestOfApplicationUserFilter implements IListRequestOfApplicationUserFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ApplicationUserFilter | undefined;

    constructor(data?: IListRequestOfApplicationUserFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ApplicationUserFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfApplicationUserFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfApplicationUserFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfApplicationUserFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ApplicationUserFilter | undefined;
}

export class ApplicationUserFilter extends BaseFilter implements IApplicationUserFilter {
    organizationUserId!: string;

    constructor(data?: IApplicationUserFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static override fromJS(data: any): ApplicationUserFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUserId"] = this.organizationUserId;
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUserFilter extends IBaseFilter {
    organizationUserId: string;
}

export class ResponseOfListOfOrganizationCatalogSkuAndString implements IResponseOfListOfOrganizationCatalogSkuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationCatalogSku[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationCatalogSkuAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationCatalogSku.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationCatalogSkuAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationCatalogSkuAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationCatalogSkuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationCatalogSku[] | undefined;
}

export class ResponseOfListOfOrganizationCatalogSku extends ResponseOfListOfOrganizationCatalogSkuAndString implements IResponseOfListOfOrganizationCatalogSku {

    constructor(data?: IResponseOfListOfOrganizationCatalogSku) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationCatalogSku {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationCatalogSku();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationCatalogSku extends IResponseOfListOfOrganizationCatalogSkuAndString {
}

export class ListResponseOfOrganizationCatalogSku extends ResponseOfListOfOrganizationCatalogSku implements IListResponseOfOrganizationCatalogSku {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationCatalogSku) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationCatalogSku {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationCatalogSku();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationCatalogSku extends IResponseOfListOfOrganizationCatalogSku {
    totalRecords?: number | undefined;
}

export class OrganizationCatalogSku implements IOrganizationCatalogSku {
    id!: string;
    skuId!: string;
    sku?: string | undefined;
    skuTitle?: string | undefined;
    organizationCatalogSkuType?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;

    constructor(data?: IOrganizationCatalogSku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.sku = _data["sku"];
            this.skuTitle = _data["skuTitle"];
            this.organizationCatalogSkuType = _data["organizationCatalogSkuType"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): OrganizationCatalogSku {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCatalogSku();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["sku"] = this.sku;
        data["skuTitle"] = this.skuTitle;
        data["organizationCatalogSkuType"] = this.organizationCatalogSkuType;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IOrganizationCatalogSku {
    id: string;
    skuId: string;
    sku?: string | undefined;
    skuTitle?: string | undefined;
    organizationCatalogSkuType?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
}

export class OrganizationCatalogSkuRequest extends ListRequestOfBaseFilter implements IOrganizationCatalogSkuRequest {
    organizationId?: string;

    constructor(data?: IOrganizationCatalogSkuRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): OrganizationCatalogSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCatalogSkuRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationCatalogSkuRequest extends IListRequestOfBaseFilter {
    organizationId?: string;
}

export class SaveOrganizationCatalogSkuRequest implements ISaveOrganizationCatalogSkuRequest {
    id?: string | undefined;
    organizationId?: string;
    skuId?: string;
    organizationCatalogSkuTypeId?: string;

    constructor(data?: ISaveOrganizationCatalogSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.skuId = _data["skuId"];
            this.organizationCatalogSkuTypeId = _data["organizationCatalogSkuTypeId"];
        }
    }

    static fromJS(data: any): SaveOrganizationCatalogSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveOrganizationCatalogSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["skuId"] = this.skuId;
        data["organizationCatalogSkuTypeId"] = this.organizationCatalogSkuTypeId;
        return data;
    }
}

export interface ISaveOrganizationCatalogSkuRequest {
    id?: string | undefined;
    organizationId?: string;
    skuId?: string;
    organizationCatalogSkuTypeId?: string;
}

export class ResponseOfListOfOrganizationCatalogSkuTypesAndString implements IResponseOfListOfOrganizationCatalogSkuTypesAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationCatalogSkuTypes[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationCatalogSkuTypesAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationCatalogSkuTypes.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationCatalogSkuTypesAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationCatalogSkuTypesAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationCatalogSkuTypesAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationCatalogSkuTypes[] | undefined;
}

export class ResponseOfListOfOrganizationCatalogSkuTypes extends ResponseOfListOfOrganizationCatalogSkuTypesAndString implements IResponseOfListOfOrganizationCatalogSkuTypes {

    constructor(data?: IResponseOfListOfOrganizationCatalogSkuTypes) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationCatalogSkuTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationCatalogSkuTypes();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationCatalogSkuTypes extends IResponseOfListOfOrganizationCatalogSkuTypesAndString {
}

export class ListResponseOfOrganizationCatalogSkuTypes extends ResponseOfListOfOrganizationCatalogSkuTypes implements IListResponseOfOrganizationCatalogSkuTypes {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationCatalogSkuTypes) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationCatalogSkuTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationCatalogSkuTypes();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationCatalogSkuTypes extends IResponseOfListOfOrganizationCatalogSkuTypes {
    totalRecords?: number | undefined;
}

export class OrganizationCatalogSkuTypes implements IOrganizationCatalogSkuTypes {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;

    constructor(data?: IOrganizationCatalogSkuTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static fromJS(data: any): OrganizationCatalogSkuTypes {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCatalogSkuTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["codeConstant"] = this.codeConstant;
        return data;
    }
}

export interface IOrganizationCatalogSkuTypes {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;
}

export class ResponseOfContractAndString implements IResponseOfContractAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Contract | undefined;

    constructor(data?: IResponseOfContractAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Contract.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfContractAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfContractAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfContractAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Contract | undefined;
}

export class ResponseOfContract extends ResponseOfContractAndString implements IResponseOfContract {

    constructor(data?: IResponseOfContract) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfContract {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfContract();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfContract extends IResponseOfContractAndString {
}

export class Contract implements IContract {
    id!: string;
    organizationId?: string;
    contractTypeId?: string;
    contractStatusId?: string;
    contractTypeName?: string | undefined;
    contractStatusName?: string | undefined;
    renewalDate?: Date;

    constructor(data?: IContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractStatusId = _data["contractStatusId"];
            this.contractTypeName = _data["contractTypeName"];
            this.contractStatusName = _data["contractStatusName"];
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["contractTypeId"] = this.contractTypeId;
        data["contractStatusId"] = this.contractStatusId;
        data["contractTypeName"] = this.contractTypeName;
        data["contractStatusName"] = this.contractStatusName;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IContract {
    id: string;
    organizationId?: string;
    contractTypeId?: string;
    contractStatusId?: string;
    contractTypeName?: string | undefined;
    contractStatusName?: string | undefined;
    renewalDate?: Date;
}

export class ResponseOfListOfContractAndString implements IResponseOfListOfContractAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Contract[] | undefined;

    constructor(data?: IResponseOfListOfContractAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Contract.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfContractAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfContractAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfContractAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Contract[] | undefined;
}

export class ResponseOfListOfContract extends ResponseOfListOfContractAndString implements IResponseOfListOfContract {

    constructor(data?: IResponseOfListOfContract) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfContract {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfContract();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfContract extends IResponseOfListOfContractAndString {
}

export class ListResponseOfContract extends ResponseOfListOfContract implements IListResponseOfContract {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfContract) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfContract {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfContract();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfContract extends IResponseOfListOfContract {
    totalRecords?: number | undefined;
}

export class ContractListRequest extends ListRequestOfBaseFilter implements IContractListRequest {
    organizationId?: string;

    constructor(data?: IContractListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): ContractListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContractListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IContractListRequest extends IListRequestOfBaseFilter {
    organizationId?: string;
}

export class SaveContractRequest implements ISaveContractRequest {
    id?: string | undefined;
    organizationId?: string;
    contractTypeId?: string;
    contractStatusId?: string;
    renewalDate?: Date;

    constructor(data?: ISaveContractRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractStatusId = _data["contractStatusId"];
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SaveContractRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveContractRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["contractTypeId"] = this.contractTypeId;
        data["contractStatusId"] = this.contractStatusId;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISaveContractRequest {
    id?: string | undefined;
    organizationId?: string;
    contractTypeId?: string;
    contractStatusId?: string;
    renewalDate?: Date;
}

export class ResponseOfListOfContractTypeAndString implements IResponseOfListOfContractTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ContractType[] | undefined;

    constructor(data?: IResponseOfListOfContractTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContractType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfContractTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfContractTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfContractTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ContractType[] | undefined;
}

export class ResponseOfListOfContractType extends ResponseOfListOfContractTypeAndString implements IResponseOfListOfContractType {

    constructor(data?: IResponseOfListOfContractType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfContractType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfContractType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfContractType extends IResponseOfListOfContractTypeAndString {
}

export class ListResponseOfContractType extends ResponseOfListOfContractType implements IListResponseOfContractType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfContractType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfContractType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfContractType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfContractType extends IResponseOfListOfContractType {
    totalRecords?: number | undefined;
}

export class ContractType implements IContractType {
    id!: string;
    name?: string | undefined;

    constructor(data?: IContractType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContractType {
        data = typeof data === 'object' ? data : {};
        let result = new ContractType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IContractType {
    id: string;
    name?: string | undefined;
}

export class ResponseOfListOfContractStatusAndString implements IResponseOfListOfContractStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ContractStatus[] | undefined;

    constructor(data?: IResponseOfListOfContractStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContractStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfContractStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfContractStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfContractStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ContractStatus[] | undefined;
}

export class ResponseOfListOfContractStatus extends ResponseOfListOfContractStatusAndString implements IResponseOfListOfContractStatus {

    constructor(data?: IResponseOfListOfContractStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfContractStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfContractStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfContractStatus extends IResponseOfListOfContractStatusAndString {
}

export class ListResponseOfContractStatus extends ResponseOfListOfContractStatus implements IListResponseOfContractStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfContractStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfContractStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfContractStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfContractStatus extends IResponseOfListOfContractStatus {
    totalRecords?: number | undefined;
}

export class ContractStatus implements IContractStatus {
    id!: string;
    name?: string | undefined;

    constructor(data?: IContractStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContractStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ContractStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IContractStatus {
    id: string;
    name?: string | undefined;
}

export class ResponseOfListOfOrganizationModelAndString implements IResponseOfListOfOrganizationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationModel[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationModel[] | undefined;
}

export class ResponseOfListOfOrganizationModel extends ResponseOfListOfOrganizationModelAndString implements IResponseOfListOfOrganizationModel {

    constructor(data?: IResponseOfListOfOrganizationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationModel extends IResponseOfListOfOrganizationModelAndString {
}

export class ListResponseOfOrganizationModel extends ResponseOfListOfOrganizationModel implements IListResponseOfOrganizationModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationModel extends IResponseOfListOfOrganizationModel {
    totalRecords?: number | undefined;
}

export class OrganizationModel implements IOrganizationModel {
    id!: string;
    name?: string | undefined;
    parentName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    organizationTypeId?: string;
    organizationStatusId?: string;
    organizationTypeName?: string | undefined;
    organizationStatusName?: string | undefined;

    constructor(data?: IOrganizationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentName = _data["parentName"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.organizationTypeId = _data["organizationTypeId"];
            this.organizationStatusId = _data["organizationStatusId"];
            this.organizationTypeName = _data["organizationTypeName"];
            this.organizationStatusName = _data["organizationStatusName"];
        }
    }

    static fromJS(data: any): OrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentName"] = this.parentName;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["organizationTypeId"] = this.organizationTypeId;
        data["organizationStatusId"] = this.organizationStatusId;
        data["organizationTypeName"] = this.organizationTypeName;
        data["organizationStatusName"] = this.organizationStatusName;
        return data;
    }
}

export interface IOrganizationModel {
    id: string;
    name?: string | undefined;
    parentName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    organizationTypeId?: string;
    organizationStatusId?: string;
    organizationTypeName?: string | undefined;
    organizationStatusName?: string | undefined;
}

export class ListRequestOfOrganizationFilter implements IListRequestOfOrganizationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationFilter | undefined;

    constructor(data?: IListRequestOfOrganizationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? OrganizationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfOrganizationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfOrganizationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfOrganizationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationFilter | undefined;
}

export class AdminListRequestOfOrganizationFilter extends ListRequestOfOrganizationFilter implements IAdminListRequestOfOrganizationFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfOrganizationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfOrganizationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfOrganizationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfOrganizationFilter extends IListRequestOfOrganizationFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class OrganizationFilter extends BaseFilter implements IOrganizationFilter {
    organizationTypeIds?: string[] | undefined;
    organizationStatusIds?: string[] | undefined;

    constructor(data?: IOrganizationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["organizationTypeIds"])) {
                this.organizationTypeIds = [] as any;
                for (let item of _data["organizationTypeIds"])
                    this.organizationTypeIds!.push(item);
            }
            if (Array.isArray(_data["organizationStatusIds"])) {
                this.organizationStatusIds = [] as any;
                for (let item of _data["organizationStatusIds"])
                    this.organizationStatusIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): OrganizationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationTypeIds)) {
            data["organizationTypeIds"] = [];
            for (let item of this.organizationTypeIds)
                data["organizationTypeIds"].push(item);
        }
        if (Array.isArray(this.organizationStatusIds)) {
            data["organizationStatusIds"] = [];
            for (let item of this.organizationStatusIds)
                data["organizationStatusIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationFilter extends IBaseFilter {
    organizationTypeIds?: string[] | undefined;
    organizationStatusIds?: string[] | undefined;
}

export class OrganizationAdminRequest implements IOrganizationAdminRequest {
    id?: string | undefined;
    firstName!: string;
    lastName!: string;
    email!: string;
    organizationId?: string;
    deactivateDescendantAdmins?: boolean;

    constructor(data?: IOrganizationAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.deactivateDescendantAdmins = _data["deactivateDescendantAdmins"];
        }
    }

    static fromJS(data: any): OrganizationAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["deactivateDescendantAdmins"] = this.deactivateDescendantAdmins;
        return data;
    }
}

export interface IOrganizationAdminRequest {
    id?: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    organizationId?: string;
    deactivateDescendantAdmins?: boolean;
}

export class ResponseOfOrganizationAdminConflictsAndString implements IResponseOfOrganizationAdminConflictsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationAdminConflicts | undefined;

    constructor(data?: IResponseOfOrganizationAdminConflictsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? OrganizationAdminConflicts.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfOrganizationAdminConflictsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationAdminConflictsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfOrganizationAdminConflictsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationAdminConflicts | undefined;
}

export class ResponseOfOrganizationAdminConflicts extends ResponseOfOrganizationAdminConflictsAndString implements IResponseOfOrganizationAdminConflicts {

    constructor(data?: IResponseOfOrganizationAdminConflicts) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfOrganizationAdminConflicts {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationAdminConflicts();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfOrganizationAdminConflicts extends IResponseOfOrganizationAdminConflictsAndString {
}

export class OrganizationAdminConflicts implements IOrganizationAdminConflicts {
    inheritedAdmin?: OrganizationAdminModel | undefined;
    descendantAdmins?: OrganizationAdminModel[] | undefined;

    constructor(data?: IOrganizationAdminConflicts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inheritedAdmin = _data["inheritedAdmin"] ? OrganizationAdminModel.fromJS(_data["inheritedAdmin"]) : undefined as any;
            if (Array.isArray(_data["descendantAdmins"])) {
                this.descendantAdmins = [] as any;
                for (let item of _data["descendantAdmins"])
                    this.descendantAdmins!.push(OrganizationAdminModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationAdminConflicts {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAdminConflicts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inheritedAdmin"] = this.inheritedAdmin ? this.inheritedAdmin.toJSON() : undefined as any;
        if (Array.isArray(this.descendantAdmins)) {
            data["descendantAdmins"] = [];
            for (let item of this.descendantAdmins)
                data["descendantAdmins"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationAdminConflicts {
    inheritedAdmin?: OrganizationAdminModel | undefined;
    descendantAdmins?: OrganizationAdminModel[] | undefined;
}

export class OrganizationAdminModel implements IOrganizationAdminModel {
    id!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;

    constructor(data?: IOrganizationAdminModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): OrganizationAdminModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAdminModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IOrganizationAdminModel {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
}

export class OrganizationAdminConflictsRequest implements IOrganizationAdminConflictsRequest {
    email!: string;
    organizationId?: string;

    constructor(data?: IOrganizationAdminConflictsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): OrganizationAdminConflictsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAdminConflictsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IOrganizationAdminConflictsRequest {
    email: string;
    organizationId?: string;
}

export class ResponseOfListOfOrganizationAdminModelAndString implements IResponseOfListOfOrganizationAdminModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationAdminModel[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationAdminModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationAdminModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationAdminModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationAdminModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationAdminModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationAdminModel[] | undefined;
}

export class ResponseOfListOfOrganizationAdminModel extends ResponseOfListOfOrganizationAdminModelAndString implements IResponseOfListOfOrganizationAdminModel {

    constructor(data?: IResponseOfListOfOrganizationAdminModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationAdminModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationAdminModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationAdminModel extends IResponseOfListOfOrganizationAdminModelAndString {
}

export class ListResponseOfOrganizationAdminModel extends ResponseOfListOfOrganizationAdminModel implements IListResponseOfOrganizationAdminModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationAdminModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationAdminModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationAdminModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationAdminModel extends IResponseOfListOfOrganizationAdminModel {
    totalRecords?: number | undefined;
}

export class OrganizationSaveRequest implements IOrganizationSaveRequest {
    id?: string | undefined;
    name!: string;
    displayName?: string | undefined;
    description?: string | undefined;
    accountId?: string | undefined;
    organizationTypeId?: string;
    organizationStatusId?: string;

    constructor(data?: IOrganizationSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.accountId = _data["accountId"];
            this.organizationTypeId = _data["organizationTypeId"];
            this.organizationStatusId = _data["organizationStatusId"];
        }
    }

    static fromJS(data: any): OrganizationSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["accountId"] = this.accountId;
        data["organizationTypeId"] = this.organizationTypeId;
        data["organizationStatusId"] = this.organizationStatusId;
        return data;
    }
}

export interface IOrganizationSaveRequest {
    id?: string | undefined;
    name: string;
    displayName?: string | undefined;
    description?: string | undefined;
    accountId?: string | undefined;
    organizationTypeId?: string;
    organizationStatusId?: string;
}

export class ResponseOfOrganizationDetailsAndString implements IResponseOfOrganizationDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationDetails | undefined;

    constructor(data?: IResponseOfOrganizationDetailsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? OrganizationDetails.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfOrganizationDetailsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationDetailsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfOrganizationDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationDetails | undefined;
}

export class ResponseOfOrganizationDetails extends ResponseOfOrganizationDetailsAndString implements IResponseOfOrganizationDetails {

    constructor(data?: IResponseOfOrganizationDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfOrganizationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfOrganizationDetails extends IResponseOfOrganizationDetailsAndString {
}

export class OrganizationDetails implements IOrganizationDetails {
    id!: string;
    parentId?: string;
    name!: string;
    displayName?: string | undefined;
    parentName?: string | undefined;
    description?: string | undefined;
    accountId?: string | undefined;
    organizationTypeId?: string;
    organizationStatusId?: string;
    organizationTypeName?: string | undefined;
    organizationStatusName?: string | undefined;

    constructor(data?: IOrganizationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.parentName = _data["parentName"];
            this.description = _data["description"];
            this.accountId = _data["accountId"];
            this.organizationTypeId = _data["organizationTypeId"];
            this.organizationStatusId = _data["organizationStatusId"];
            this.organizationTypeName = _data["organizationTypeName"];
            this.organizationStatusName = _data["organizationStatusName"];
        }
    }

    static fromJS(data: any): OrganizationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["parentName"] = this.parentName;
        data["description"] = this.description;
        data["accountId"] = this.accountId;
        data["organizationTypeId"] = this.organizationTypeId;
        data["organizationStatusId"] = this.organizationStatusId;
        data["organizationTypeName"] = this.organizationTypeName;
        data["organizationStatusName"] = this.organizationStatusName;
        return data;
    }
}

export interface IOrganizationDetails {
    id: string;
    parentId?: string;
    name: string;
    displayName?: string | undefined;
    parentName?: string | undefined;
    description?: string | undefined;
    accountId?: string | undefined;
    organizationTypeId?: string;
    organizationStatusId?: string;
    organizationTypeName?: string | undefined;
    organizationStatusName?: string | undefined;
}

export class OrganizationApplicationDomainSaveRequest implements IOrganizationApplicationDomainSaveRequest {
    id?: string | undefined;
    organizationApplicationId?: string | undefined;
    organizationId!: string;
    applicationId!: string;
    hostName!: string;
    environment!: string;
    isDefault!: boolean;

    constructor(data?: IOrganizationApplicationDomainSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationApplicationId = _data["organizationApplicationId"];
            this.organizationId = _data["organizationId"];
            this.applicationId = _data["applicationId"];
            this.hostName = _data["hostName"];
            this.environment = _data["environment"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): OrganizationApplicationDomainSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationApplicationDomainSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationApplicationId"] = this.organizationApplicationId;
        data["organizationId"] = this.organizationId;
        data["applicationId"] = this.applicationId;
        data["hostName"] = this.hostName;
        data["environment"] = this.environment;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IOrganizationApplicationDomainSaveRequest {
    id?: string | undefined;
    organizationApplicationId?: string | undefined;
    organizationId: string;
    applicationId: string;
    hostName: string;
    environment: string;
    isDefault: boolean;
}

export class ResponseOfListOfOrganizationApplicationDomainAndString implements IResponseOfListOfOrganizationApplicationDomainAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationApplicationDomain[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationApplicationDomainAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationApplicationDomain.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationApplicationDomainAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationApplicationDomainAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationApplicationDomainAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationApplicationDomain[] | undefined;
}

export class ResponseOfListOfOrganizationApplicationDomain extends ResponseOfListOfOrganizationApplicationDomainAndString implements IResponseOfListOfOrganizationApplicationDomain {

    constructor(data?: IResponseOfListOfOrganizationApplicationDomain) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationApplicationDomain {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationApplicationDomain();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationApplicationDomain extends IResponseOfListOfOrganizationApplicationDomainAndString {
}

export class ListResponseOfOrganizationApplicationDomain extends ResponseOfListOfOrganizationApplicationDomain implements IListResponseOfOrganizationApplicationDomain {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationApplicationDomain) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationApplicationDomain {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationApplicationDomain();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationApplicationDomain extends IResponseOfListOfOrganizationApplicationDomain {
    totalRecords?: number | undefined;
}

export class OrganizationApplicationDomain implements IOrganizationApplicationDomain {
    id!: string;
    organizationApplicationId!: string;
    organizationId!: string;
    applicationId!: string;
    applicationName!: string;
    hostName!: string;
    environment!: string;
    isDefault!: boolean;

    constructor(data?: IOrganizationApplicationDomain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationApplicationId = _data["organizationApplicationId"];
            this.organizationId = _data["organizationId"];
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.hostName = _data["hostName"];
            this.environment = _data["environment"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): OrganizationApplicationDomain {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationApplicationDomain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationApplicationId"] = this.organizationApplicationId;
        data["organizationId"] = this.organizationId;
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["hostName"] = this.hostName;
        data["environment"] = this.environment;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IOrganizationApplicationDomain {
    id: string;
    organizationApplicationId: string;
    organizationId: string;
    applicationId: string;
    applicationName: string;
    hostName: string;
    environment: string;
    isDefault: boolean;
}

export class ListRequestOfDomainFilter implements IListRequestOfDomainFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: DomainFilter | undefined;

    constructor(data?: IListRequestOfDomainFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? DomainFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfDomainFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfDomainFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfDomainFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: DomainFilter | undefined;
}

export class DomainFilter extends BaseFilter implements IDomainFilter {
    organizationId?: string | undefined;

    constructor(data?: IDomainFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): DomainFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DomainFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IDomainFilter extends IBaseFilter {
    organizationId?: string | undefined;
}

export class ResponseOfListOfOrganizationExternalReferenceModelAndString implements IResponseOfListOfOrganizationExternalReferenceModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationExternalReferenceModel[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationExternalReferenceModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationExternalReferenceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationExternalReferenceModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationExternalReferenceModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationExternalReferenceModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationExternalReferenceModel[] | undefined;
}

export class ResponseOfListOfOrganizationExternalReferenceModel extends ResponseOfListOfOrganizationExternalReferenceModelAndString implements IResponseOfListOfOrganizationExternalReferenceModel {

    constructor(data?: IResponseOfListOfOrganizationExternalReferenceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationExternalReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationExternalReferenceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationExternalReferenceModel extends IResponseOfListOfOrganizationExternalReferenceModelAndString {
}

export class ListResponseOfOrganizationExternalReferenceModel extends ResponseOfListOfOrganizationExternalReferenceModel implements IListResponseOfOrganizationExternalReferenceModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationExternalReferenceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationExternalReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationExternalReferenceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationExternalReferenceModel extends IResponseOfListOfOrganizationExternalReferenceModel {
    totalRecords?: number | undefined;
}

export class OrganizationExternalReferenceModel implements IOrganizationExternalReferenceModel {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    partnerName?: string | undefined;
    externalOrganizationId?: string | undefined;

    constructor(data?: IOrganizationExternalReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.partnerName = _data["partnerName"];
            this.externalOrganizationId = _data["externalOrganizationId"];
        }
    }

    static fromJS(data: any): OrganizationExternalReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationExternalReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["partnerName"] = this.partnerName;
        data["externalOrganizationId"] = this.externalOrganizationId;
        return data;
    }
}

export interface IOrganizationExternalReferenceModel {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    partnerName?: string | undefined;
    externalOrganizationId?: string | undefined;
}

export class ListRequestOfOrganizationExternalReferenceAdminFilter implements IListRequestOfOrganizationExternalReferenceAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationExternalReferenceAdminFilter | undefined;

    constructor(data?: IListRequestOfOrganizationExternalReferenceAdminFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? OrganizationExternalReferenceAdminFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfOrganizationExternalReferenceAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfOrganizationExternalReferenceAdminFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfOrganizationExternalReferenceAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationExternalReferenceAdminFilter | undefined;
}

export class OrganizationExternalReferenceAdminFilter extends BaseFilter implements IOrganizationExternalReferenceAdminFilter {
    organizationId?: string | undefined;

    constructor(data?: IOrganizationExternalReferenceAdminFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): OrganizationExternalReferenceAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationExternalReferenceAdminFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationExternalReferenceAdminFilter extends IBaseFilter {
    organizationId?: string | undefined;
}

export class OrganizationExternalReferenceSaveRequest implements IOrganizationExternalReferenceSaveRequest {
    id?: string | undefined;
    organizationId!: string;
    partnerName!: string;
    externalOrganizationId!: string;

    constructor(data?: IOrganizationExternalReferenceSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.partnerName = _data["partnerName"];
            this.externalOrganizationId = _data["externalOrganizationId"];
        }
    }

    static fromJS(data: any): OrganizationExternalReferenceSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationExternalReferenceSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["partnerName"] = this.partnerName;
        data["externalOrganizationId"] = this.externalOrganizationId;
        return data;
    }
}

export interface IOrganizationExternalReferenceSaveRequest {
    id?: string | undefined;
    organizationId: string;
    partnerName: string;
    externalOrganizationId: string;
}

export class ResponseOfListOfSkuProgressionGateAndString implements IResponseOfListOfSkuProgressionGateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuProgressionGate[] | undefined;

    constructor(data?: IResponseOfListOfSkuProgressionGateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuProgressionGate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuProgressionGateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuProgressionGateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuProgressionGateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuProgressionGate[] | undefined;
}

export class ResponseOfListOfSkuProgressionGate extends ResponseOfListOfSkuProgressionGateAndString implements IResponseOfListOfSkuProgressionGate {

    constructor(data?: IResponseOfListOfSkuProgressionGate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuProgressionGate {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuProgressionGate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuProgressionGate extends IResponseOfListOfSkuProgressionGateAndString {
}

export class ListResponseOfSkuProgressionGate extends ResponseOfListOfSkuProgressionGate implements IListResponseOfSkuProgressionGate {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuProgressionGate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuProgressionGate {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuProgressionGate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuProgressionGate extends IResponseOfListOfSkuProgressionGate {
    totalRecords?: number | undefined;
}

export class SkuProgressionGate implements ISkuProgressionGate {
    id?: string;
    skuId?: string | undefined;
    skuFormatId?: string | undefined;
    progressionGateTypeId?: string;
    organizationId?: string;
    skuFormatName?: string | undefined;
    progressionGateTypeName?: string | undefined;
    disabled?: boolean;
    gateType?: string | undefined;
    prompt?: string | undefined;
    label?: string | undefined;
    value?: string | undefined;
    errorMessage?: string | undefined;
    dialogueTitle?: string | undefined;

    constructor(data?: ISkuProgressionGate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.skuFormatId = _data["skuFormatId"];
            this.progressionGateTypeId = _data["progressionGateTypeId"];
            this.organizationId = _data["organizationId"];
            this.skuFormatName = _data["skuFormatName"];
            this.progressionGateTypeName = _data["progressionGateTypeName"];
            this.disabled = _data["disabled"];
            this.gateType = _data["gateType"];
            this.prompt = _data["prompt"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.errorMessage = _data["errorMessage"];
            this.dialogueTitle = _data["dialogueTitle"];
        }
    }

    static fromJS(data: any): SkuProgressionGate {
        data = typeof data === 'object' ? data : {};
        let result = new SkuProgressionGate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["skuFormatId"] = this.skuFormatId;
        data["progressionGateTypeId"] = this.progressionGateTypeId;
        data["organizationId"] = this.organizationId;
        data["skuFormatName"] = this.skuFormatName;
        data["progressionGateTypeName"] = this.progressionGateTypeName;
        data["disabled"] = this.disabled;
        data["gateType"] = this.gateType;
        data["prompt"] = this.prompt;
        data["label"] = this.label;
        data["value"] = this.value;
        data["errorMessage"] = this.errorMessage;
        data["dialogueTitle"] = this.dialogueTitle;
        return data;
    }
}

export interface ISkuProgressionGate {
    id?: string;
    skuId?: string | undefined;
    skuFormatId?: string | undefined;
    progressionGateTypeId?: string;
    organizationId?: string;
    skuFormatName?: string | undefined;
    progressionGateTypeName?: string | undefined;
    disabled?: boolean;
    gateType?: string | undefined;
    prompt?: string | undefined;
    label?: string | undefined;
    value?: string | undefined;
    errorMessage?: string | undefined;
    dialogueTitle?: string | undefined;
}

export class DefaultProgressionGateRequest extends ListRequestOfBaseFilter implements IDefaultProgressionGateRequest {
    organizationId?: string;

    constructor(data?: IDefaultProgressionGateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): DefaultProgressionGateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultProgressionGateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IDefaultProgressionGateRequest extends IListRequestOfBaseFilter {
    organizationId?: string;
}

export class SkuProgressionGateRequest implements ISkuProgressionGateRequest {
    id?: string | undefined;
    progressionGateTypeId!: string;
    organizationId!: string;
    skuFormatId?: string | undefined;
    skuId?: string | undefined;
    disabled?: boolean;
    promptMessage!: string;
    labelText!: string;
    value!: string;
    errorMessage!: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    dialogueTitle?: string | undefined;

    constructor(data?: ISkuProgressionGateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.progressionGateTypeId = _data["progressionGateTypeId"];
            this.organizationId = _data["organizationId"];
            this.skuFormatId = _data["skuFormatId"];
            this.skuId = _data["skuId"];
            this.disabled = _data["disabled"];
            this.promptMessage = _data["promptMessage"];
            this.labelText = _data["labelText"];
            this.value = _data["value"];
            this.errorMessage = _data["errorMessage"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.dialogueTitle = _data["dialogueTitle"];
        }
    }

    static fromJS(data: any): SkuProgressionGateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuProgressionGateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progressionGateTypeId"] = this.progressionGateTypeId;
        data["organizationId"] = this.organizationId;
        data["skuFormatId"] = this.skuFormatId;
        data["skuId"] = this.skuId;
        data["disabled"] = this.disabled;
        data["promptMessage"] = this.promptMessage;
        data["labelText"] = this.labelText;
        data["value"] = this.value;
        data["errorMessage"] = this.errorMessage;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["dialogueTitle"] = this.dialogueTitle;
        return data;
    }
}

export interface ISkuProgressionGateRequest {
    id?: string | undefined;
    progressionGateTypeId: string;
    organizationId: string;
    skuFormatId?: string | undefined;
    skuId?: string | undefined;
    disabled?: boolean;
    promptMessage: string;
    labelText: string;
    value: string;
    errorMessage: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    dialogueTitle?: string | undefined;
}

export class OrganizationUser implements IOrganizationUser {
    id!: string;
    organizationId!: string;
    userAccountId!: string;
    email!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userStatusTypeId!: string;
    deletedDate?: Date | undefined;

    constructor(data?: IOrganizationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.userAccountId = _data["userAccountId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userStatusTypeId = _data["userStatusTypeId"];
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OrganizationUser {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["userAccountId"] = this.userAccountId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userStatusTypeId"] = this.userStatusTypeId;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IOrganizationUser {
    id: string;
    organizationId: string;
    userAccountId: string;
    email: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userStatusTypeId: string;
    deletedDate?: Date | undefined;
}

export class OrganizationUserDetails extends OrganizationUser implements IOrganizationUserDetails {
    externalSourceId?: string | undefined;
    userStatusTypeName!: string;
    timeZone?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IOrganizationUserDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.externalSourceId = _data["externalSourceId"];
            this.userStatusTypeName = _data["userStatusTypeName"];
            this.timeZone = _data["timeZone"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static override fromJS(data: any): OrganizationUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSourceId"] = this.externalSourceId;
        data["userStatusTypeName"] = this.userStatusTypeName;
        data["timeZone"] = this.timeZone;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationUserDetails extends IOrganizationUser {
    externalSourceId?: string | undefined;
    userStatusTypeName: string;
    timeZone?: string | undefined;
    roles?: string[] | undefined;
}

export class ResponseOfListOfOrganizationUserListItemAndString implements IResponseOfListOfOrganizationUserListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationUserListItem[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationUserListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationUserListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationUserListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationUserListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationUserListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationUserListItem[] | undefined;
}

export class ResponseOfListOfOrganizationUserListItem extends ResponseOfListOfOrganizationUserListItemAndString implements IResponseOfListOfOrganizationUserListItem {

    constructor(data?: IResponseOfListOfOrganizationUserListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationUserListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationUserListItem extends IResponseOfListOfOrganizationUserListItemAndString {
}

export class ListResponseOfOrganizationUserListItem extends ResponseOfListOfOrganizationUserListItem implements IListResponseOfOrganizationUserListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationUserListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationUserListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationUserListItem extends IResponseOfListOfOrganizationUserListItem {
    totalRecords?: number | undefined;
}

export class OrganizationUserListItem extends OrganizationUser implements IOrganizationUserListItem {
    userStatusTypeName!: string;
    organizationName!: string;

    constructor(data?: IOrganizationUserListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userStatusTypeName = _data["userStatusTypeName"];
            this.organizationName = _data["organizationName"];
        }
    }

    static override fromJS(data: any): OrganizationUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userStatusTypeName"] = this.userStatusTypeName;
        data["organizationName"] = this.organizationName;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationUserListItem extends IOrganizationUser {
    userStatusTypeName: string;
    organizationName: string;
}

export class ListRequestOfSearchOrganizationUsersFilter implements IListRequestOfSearchOrganizationUsersFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SearchOrganizationUsersFilter | undefined;

    constructor(data?: IListRequestOfSearchOrganizationUsersFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SearchOrganizationUsersFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSearchOrganizationUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSearchOrganizationUsersFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSearchOrganizationUsersFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SearchOrganizationUsersFilter | undefined;
}

export class AdminListRequestOfSearchOrganizationUsersFilter extends ListRequestOfSearchOrganizationUsersFilter implements IAdminListRequestOfSearchOrganizationUsersFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfSearchOrganizationUsersFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfSearchOrganizationUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfSearchOrganizationUsersFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfSearchOrganizationUsersFilter extends IListRequestOfSearchOrganizationUsersFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class SearchOrganizationUsersFilter extends BaseFilter implements ISearchOrganizationUsersFilter {
    excludedUserAccountId?: string | undefined;
    mergeUserOrganizationId?: string | undefined;
    applicationId?: string | undefined;

    constructor(data?: ISearchOrganizationUsersFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.excludedUserAccountId = _data["excludedUserAccountId"];
            this.mergeUserOrganizationId = _data["mergeUserOrganizationId"];
            this.applicationId = _data["applicationId"];
        }
    }

    static override fromJS(data: any): SearchOrganizationUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrganizationUsersFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["excludedUserAccountId"] = this.excludedUserAccountId;
        data["mergeUserOrganizationId"] = this.mergeUserOrganizationId;
        data["applicationId"] = this.applicationId;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOrganizationUsersFilter extends IBaseFilter {
    excludedUserAccountId?: string | undefined;
    mergeUserOrganizationId?: string | undefined;
    applicationId?: string | undefined;
}

export class ResponseOfListOfDataToolDescriptorAndString implements IResponseOfListOfDataToolDescriptorAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DataToolDescriptor[] | undefined;

    constructor(data?: IResponseOfListOfDataToolDescriptorAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DataToolDescriptor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfDataToolDescriptorAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDataToolDescriptorAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfDataToolDescriptorAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DataToolDescriptor[] | undefined;
}

export class ResponseOfListOfDataToolDescriptor extends ResponseOfListOfDataToolDescriptorAndString implements IResponseOfListOfDataToolDescriptor {

    constructor(data?: IResponseOfListOfDataToolDescriptor) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfDataToolDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDataToolDescriptor();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfDataToolDescriptor extends IResponseOfListOfDataToolDescriptorAndString {
}

export class ListResponseOfDataToolDescriptor extends ResponseOfListOfDataToolDescriptor implements IListResponseOfDataToolDescriptor {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfDataToolDescriptor) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfDataToolDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfDataToolDescriptor();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfDataToolDescriptor extends IResponseOfListOfDataToolDescriptor {
    totalRecords?: number | undefined;
}

export class DataToolDescriptor implements IDataToolDescriptor {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IDataToolDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DataToolDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new DataToolDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IDataToolDescriptor {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class ResponseOfToolRunDtoAndString implements IResponseOfToolRunDtoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ToolRunDto | undefined;

    constructor(data?: IResponseOfToolRunDtoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ToolRunDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfToolRunDtoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfToolRunDtoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfToolRunDtoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ToolRunDto | undefined;
}

export class ResponseOfToolRunDto extends ResponseOfToolRunDtoAndString implements IResponseOfToolRunDto {

    constructor(data?: IResponseOfToolRunDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfToolRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfToolRunDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfToolRunDto extends IResponseOfToolRunDtoAndString {
}

export class ToolRunDto implements IToolRunDto {
    id?: string;
    toolKey?: string | undefined;
    hangfireJobId?: string | undefined;
    input?: string | undefined;
    status?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    completedOn?: Date | undefined;

    constructor(data?: IToolRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.toolKey = _data["toolKey"];
            this.hangfireJobId = _data["hangfireJobId"];
            this.input = _data["input"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ToolRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToolRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["toolKey"] = this.toolKey;
        data["hangfireJobId"] = this.hangfireJobId;
        data["input"] = this.input;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IToolRunDto {
    id?: string;
    toolKey?: string | undefined;
    hangfireJobId?: string | undefined;
    input?: string | undefined;
    status?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    completedOn?: Date | undefined;
}

export class RunToolRequest implements IRunToolRequest {
    input?: string | undefined;

    constructor(data?: IRunToolRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.input = _data["input"];
        }
    }

    static fromJS(data: any): RunToolRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RunToolRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input;
        return data;
    }
}

export interface IRunToolRequest {
    input?: string | undefined;
}

export class ResponseOfListOfToolRunDtoAndString implements IResponseOfListOfToolRunDtoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ToolRunDto[] | undefined;

    constructor(data?: IResponseOfListOfToolRunDtoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ToolRunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfToolRunDtoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfToolRunDtoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfToolRunDtoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ToolRunDto[] | undefined;
}

export class ResponseOfListOfToolRunDto extends ResponseOfListOfToolRunDtoAndString implements IResponseOfListOfToolRunDto {

    constructor(data?: IResponseOfListOfToolRunDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfToolRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfToolRunDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfToolRunDto extends IResponseOfListOfToolRunDtoAndString {
}

export class ListResponseOfToolRunDto extends ResponseOfListOfToolRunDto implements IListResponseOfToolRunDto {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfToolRunDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfToolRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfToolRunDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfToolRunDto extends IResponseOfListOfToolRunDto {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfToolLogDtoAndString implements IResponseOfListOfToolLogDtoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ToolLogDto[] | undefined;

    constructor(data?: IResponseOfListOfToolLogDtoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ToolLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfToolLogDtoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfToolLogDtoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfToolLogDtoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ToolLogDto[] | undefined;
}

export class ResponseOfListOfToolLogDto extends ResponseOfListOfToolLogDtoAndString implements IResponseOfListOfToolLogDto {

    constructor(data?: IResponseOfListOfToolLogDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfToolLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfToolLogDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfToolLogDto extends IResponseOfListOfToolLogDtoAndString {
}

export class ListResponseOfToolLogDto extends ResponseOfListOfToolLogDto implements IListResponseOfToolLogDto {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfToolLogDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfToolLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfToolLogDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfToolLogDto extends IResponseOfListOfToolLogDto {
    totalRecords?: number | undefined;
}

export class ToolLogDto implements IToolLogDto {
    id?: number;
    runId?: string;
    createdOn?: Date;
    message?: string | undefined;

    constructor(data?: IToolLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.runId = _data["runId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ToolLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToolLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["runId"] = this.runId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["message"] = this.message;
        return data;
    }
}

export interface IToolLogDto {
    id?: number;
    runId?: string;
    createdOn?: Date;
    message?: string | undefined;
}

export class ListRequestOfToolLogFilter implements IListRequestOfToolLogFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ToolLogFilter | undefined;

    constructor(data?: IListRequestOfToolLogFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ToolLogFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfToolLogFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfToolLogFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfToolLogFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ToolLogFilter | undefined;
}

export class ToolLogFilter extends BaseFilter implements IToolLogFilter {
    runId?: string;
    after?: number | undefined;

    constructor(data?: IToolLogFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.runId = _data["runId"];
            this.after = _data["after"];
        }
    }

    static override fromJS(data: any): ToolLogFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ToolLogFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId;
        data["after"] = this.after;
        super.toJSON(data);
        return data;
    }
}

export interface IToolLogFilter extends IBaseFilter {
    runId?: string;
    after?: number | undefined;
}

export class ResponseOfBugsDashboardAndString implements IResponseOfBugsDashboardAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: BugsDashboard | undefined;

    constructor(data?: IResponseOfBugsDashboardAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? BugsDashboard.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfBugsDashboardAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBugsDashboardAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfBugsDashboardAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: BugsDashboard | undefined;
}

export class ResponseOfBugsDashboard extends ResponseOfBugsDashboardAndString implements IResponseOfBugsDashboard {

    constructor(data?: IResponseOfBugsDashboard) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfBugsDashboard {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBugsDashboard();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfBugsDashboard extends IResponseOfBugsDashboardAndString {
}

export class BugsDashboard implements IBugsDashboard {
    year?: number;
    month?: number;
    monthLabel?: string;
    rows?: BugRow[];
    kpi?: BugKpi;
    categoryBreakdown?: CategoryBreakdownRow[];
    assignmentSummary?: DevAssignmentSummary;
    devRanking?: DevRankingRow[];
    availableCategories?: string[];

    constructor(data?: IBugsDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthLabel = _data["monthLabel"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BugRow.fromJS(item));
            }
            this.kpi = _data["kpi"] ? BugKpi.fromJS(_data["kpi"]) : undefined as any;
            if (Array.isArray(_data["categoryBreakdown"])) {
                this.categoryBreakdown = [] as any;
                for (let item of _data["categoryBreakdown"])
                    this.categoryBreakdown!.push(CategoryBreakdownRow.fromJS(item));
            }
            this.assignmentSummary = _data["assignmentSummary"] ? DevAssignmentSummary.fromJS(_data["assignmentSummary"]) : undefined as any;
            if (Array.isArray(_data["devRanking"])) {
                this.devRanking = [] as any;
                for (let item of _data["devRanking"])
                    this.devRanking!.push(DevRankingRow.fromJS(item));
            }
            if (Array.isArray(_data["availableCategories"])) {
                this.availableCategories = [] as any;
                for (let item of _data["availableCategories"])
                    this.availableCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): BugsDashboard {
        data = typeof data === 'object' ? data : {};
        let result = new BugsDashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthLabel"] = this.monthLabel;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        data["kpi"] = this.kpi ? this.kpi.toJSON() : undefined as any;
        if (Array.isArray(this.categoryBreakdown)) {
            data["categoryBreakdown"] = [];
            for (let item of this.categoryBreakdown)
                data["categoryBreakdown"].push(item ? item.toJSON() : undefined as any);
        }
        data["assignmentSummary"] = this.assignmentSummary ? this.assignmentSummary.toJSON() : undefined as any;
        if (Array.isArray(this.devRanking)) {
            data["devRanking"] = [];
            for (let item of this.devRanking)
                data["devRanking"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.availableCategories)) {
            data["availableCategories"] = [];
            for (let item of this.availableCategories)
                data["availableCategories"].push(item);
        }
        return data;
    }
}

export interface IBugsDashboard {
    year?: number;
    month?: number;
    monthLabel?: string;
    rows?: BugRow[];
    kpi?: BugKpi;
    categoryBreakdown?: CategoryBreakdownRow[];
    assignmentSummary?: DevAssignmentSummary;
    devRanking?: DevRankingRow[];
    availableCategories?: string[];
}

export class BugRow implements IBugRow {
    key?: string;
    summary?: string;
    status?: string;
    priority?: string;
    created?: Date | undefined;
    resolved?: Date | undefined;
    assignee?: string;
    ticketAssignee?: string;
    category?: string;
    jiraUrl?: string;

    constructor(data?: IBugRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.summary = _data["summary"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.resolved = _data["resolved"] ? new Date(_data["resolved"].toString()) : undefined as any;
            this.assignee = _data["assignee"];
            this.ticketAssignee = _data["ticketAssignee"];
            this.category = _data["category"];
            this.jiraUrl = _data["jiraUrl"];
        }
    }

    static fromJS(data: any): BugRow {
        data = typeof data === 'object' ? data : {};
        let result = new BugRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["summary"] = this.summary;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["resolved"] = this.resolved ? this.resolved.toISOString() : undefined as any;
        data["assignee"] = this.assignee;
        data["ticketAssignee"] = this.ticketAssignee;
        data["category"] = this.category;
        data["jiraUrl"] = this.jiraUrl;
        return data;
    }
}

export interface IBugRow {
    key?: string;
    summary?: string;
    status?: string;
    priority?: string;
    created?: Date | undefined;
    resolved?: Date | undefined;
    assignee?: string;
    ticketAssignee?: string;
    category?: string;
    jiraUrl?: string;
}

export class BugKpi implements IBugKpi {
    total?: number;
    done?: number;
    inProgress?: number;
    backlog?: number;
    criticalOpen?: number;
    resolutionPct?: number;
    totalDelta?: number;
    resolutionPctDelta?: number;
    inProgressDelta?: number;
    backlogDelta?: number;
    criticalOpenDelta?: number;

    constructor(data?: IBugKpi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.done = _data["done"];
            this.inProgress = _data["inProgress"];
            this.backlog = _data["backlog"];
            this.criticalOpen = _data["criticalOpen"];
            this.resolutionPct = _data["resolutionPct"];
            this.totalDelta = _data["totalDelta"];
            this.resolutionPctDelta = _data["resolutionPctDelta"];
            this.inProgressDelta = _data["inProgressDelta"];
            this.backlogDelta = _data["backlogDelta"];
            this.criticalOpenDelta = _data["criticalOpenDelta"];
        }
    }

    static fromJS(data: any): BugKpi {
        data = typeof data === 'object' ? data : {};
        let result = new BugKpi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["done"] = this.done;
        data["inProgress"] = this.inProgress;
        data["backlog"] = this.backlog;
        data["criticalOpen"] = this.criticalOpen;
        data["resolutionPct"] = this.resolutionPct;
        data["totalDelta"] = this.totalDelta;
        data["resolutionPctDelta"] = this.resolutionPctDelta;
        data["inProgressDelta"] = this.inProgressDelta;
        data["backlogDelta"] = this.backlogDelta;
        data["criticalOpenDelta"] = this.criticalOpenDelta;
        return data;
    }
}

export interface IBugKpi {
    total?: number;
    done?: number;
    inProgress?: number;
    backlog?: number;
    criticalOpen?: number;
    resolutionPct?: number;
    totalDelta?: number;
    resolutionPctDelta?: number;
    inProgressDelta?: number;
    backlogDelta?: number;
    criticalOpenDelta?: number;
}

export class CategoryBreakdownRow implements ICategoryBreakdownRow {
    category?: string;
    total?: number;
    done?: number;
    inProgress?: number;
    backlog?: number;
    resolutionPct?: number;

    constructor(data?: ICategoryBreakdownRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.total = _data["total"];
            this.done = _data["done"];
            this.inProgress = _data["inProgress"];
            this.backlog = _data["backlog"];
            this.resolutionPct = _data["resolutionPct"];
        }
    }

    static fromJS(data: any): CategoryBreakdownRow {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryBreakdownRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["total"] = this.total;
        data["done"] = this.done;
        data["inProgress"] = this.inProgress;
        data["backlog"] = this.backlog;
        data["resolutionPct"] = this.resolutionPct;
        return data;
    }
}

export interface ICategoryBreakdownRow {
    category?: string;
    total?: number;
    done?: number;
    inProgress?: number;
    backlog?: number;
    resolutionPct?: number;
}

export class DevAssignmentSummary implements IDevAssignmentSummary {
    devsWithBugs?: number;
    assignedToDev?: number;
    pendingAssignment?: number;
    noCodeChange?: number;

    constructor(data?: IDevAssignmentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.devsWithBugs = _data["devsWithBugs"];
            this.assignedToDev = _data["assignedToDev"];
            this.pendingAssignment = _data["pendingAssignment"];
            this.noCodeChange = _data["noCodeChange"];
        }
    }

    static fromJS(data: any): DevAssignmentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DevAssignmentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["devsWithBugs"] = this.devsWithBugs;
        data["assignedToDev"] = this.assignedToDev;
        data["pendingAssignment"] = this.pendingAssignment;
        data["noCodeChange"] = this.noCodeChange;
        return data;
    }
}

export interface IDevAssignmentSummary {
    devsWithBugs?: number;
    assignedToDev?: number;
    pendingAssignment?: number;
    noCodeChange?: number;
}

export class DevRankingRow implements IDevRankingRow {
    rank?: number;
    developer?: string;
    total?: number;
    done?: number;
    inProgress?: number;
    backlog?: number;
    open?: number;
    resolutionPct?: number;

    constructor(data?: IDevRankingRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.developer = _data["developer"];
            this.total = _data["total"];
            this.done = _data["done"];
            this.inProgress = _data["inProgress"];
            this.backlog = _data["backlog"];
            this.open = _data["open"];
            this.resolutionPct = _data["resolutionPct"];
        }
    }

    static fromJS(data: any): DevRankingRow {
        data = typeof data === 'object' ? data : {};
        let result = new DevRankingRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["developer"] = this.developer;
        data["total"] = this.total;
        data["done"] = this.done;
        data["inProgress"] = this.inProgress;
        data["backlog"] = this.backlog;
        data["open"] = this.open;
        data["resolutionPct"] = this.resolutionPct;
        return data;
    }
}

export interface IDevRankingRow {
    rank?: number;
    developer?: string;
    total?: number;
    done?: number;
    inProgress?: number;
    backlog?: number;
    open?: number;
    resolutionPct?: number;
}

export class ResponseOfBugsTrendAndString implements IResponseOfBugsTrendAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: BugsTrend | undefined;

    constructor(data?: IResponseOfBugsTrendAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? BugsTrend.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfBugsTrendAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBugsTrendAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfBugsTrendAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: BugsTrend | undefined;
}

export class ResponseOfBugsTrend extends ResponseOfBugsTrendAndString implements IResponseOfBugsTrend {

    constructor(data?: IResponseOfBugsTrend) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfBugsTrend {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBugsTrend();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfBugsTrend extends IResponseOfBugsTrendAndString {
}

export class BugsTrend implements IBugsTrend {
    months?: string[];
    rows?: TrendRow[];
    resolutionTrend?: ResolutionTrendPoint[];

    constructor(data?: IBugsTrend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TrendRow.fromJS(item));
            }
            if (Array.isArray(_data["resolutionTrend"])) {
                this.resolutionTrend = [] as any;
                for (let item of _data["resolutionTrend"])
                    this.resolutionTrend!.push(ResolutionTrendPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BugsTrend {
        data = typeof data === 'object' ? data : {};
        let result = new BugsTrend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resolutionTrend)) {
            data["resolutionTrend"] = [];
            for (let item of this.resolutionTrend)
                data["resolutionTrend"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBugsTrend {
    months?: string[];
    rows?: TrendRow[];
    resolutionTrend?: ResolutionTrendPoint[];
}

export class TrendRow implements ITrendRow {
    category?: string;
    countsByMonth?: { [key: string]: number; };
    delta?: number;
    pctChange?: number;
    trend?: string;
    isTotal?: boolean;

    constructor(data?: ITrendRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            if (_data["countsByMonth"]) {
                this.countsByMonth = {} as any;
                for (let key in _data["countsByMonth"]) {
                    if (_data["countsByMonth"].hasOwnProperty(key))
                        (this.countsByMonth as any)![key] = _data["countsByMonth"][key];
                }
            }
            this.delta = _data["delta"];
            this.pctChange = _data["pctChange"];
            this.trend = _data["trend"];
            this.isTotal = _data["isTotal"];
        }
    }

    static fromJS(data: any): TrendRow {
        data = typeof data === 'object' ? data : {};
        let result = new TrendRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        if (this.countsByMonth) {
            data["countsByMonth"] = {};
            for (let key in this.countsByMonth) {
                if (this.countsByMonth.hasOwnProperty(key))
                    (data["countsByMonth"] as any)[key] = (this.countsByMonth as any)[key];
            }
        }
        data["delta"] = this.delta;
        data["pctChange"] = this.pctChange;
        data["trend"] = this.trend;
        data["isTotal"] = this.isTotal;
        return data;
    }
}

export interface ITrendRow {
    category?: string;
    countsByMonth?: { [key: string]: number; };
    delta?: number;
    pctChange?: number;
    trend?: string;
    isTotal?: boolean;
}

export class ResolutionTrendPoint implements IResolutionTrendPoint {
    month?: string;
    category?: string;
    resolutionPct?: number;
    total?: number;
    done?: number;

    constructor(data?: IResolutionTrendPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.category = _data["category"];
            this.resolutionPct = _data["resolutionPct"];
            this.total = _data["total"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): ResolutionTrendPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ResolutionTrendPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["category"] = this.category;
        data["resolutionPct"] = this.resolutionPct;
        data["total"] = this.total;
        data["done"] = this.done;
        return data;
    }
}

export interface IResolutionTrendPoint {
    month?: string;
    category?: string;
    resolutionPct?: number;
    total?: number;
    done?: number;
}

export class ResponseOfIReadOnlyListOfAvailableMonthAndString implements IResponseOfIReadOnlyListOfAvailableMonthAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AvailableMonth[] | undefined;

    constructor(data?: IResponseOfIReadOnlyListOfAvailableMonthAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AvailableMonth.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfIReadOnlyListOfAvailableMonthAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIReadOnlyListOfAvailableMonthAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfIReadOnlyListOfAvailableMonthAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AvailableMonth[] | undefined;
}

export class ResponseOfIReadOnlyListOfAvailableMonth extends ResponseOfIReadOnlyListOfAvailableMonthAndString implements IResponseOfIReadOnlyListOfAvailableMonth {

    constructor(data?: IResponseOfIReadOnlyListOfAvailableMonth) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfIReadOnlyListOfAvailableMonth {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIReadOnlyListOfAvailableMonth();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfIReadOnlyListOfAvailableMonth extends IResponseOfIReadOnlyListOfAvailableMonthAndString {
}

export class AvailableMonth implements IAvailableMonth {
    year?: number;
    month?: number;
    label?: string;

    constructor(data?: IAvailableMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): AvailableMonth {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["label"] = this.label;
        return data;
    }
}

export interface IAvailableMonth {
    year?: number;
    month?: number;
    label?: string;
}

export class ResponseOfOpenPrsAndString implements IResponseOfOpenPrsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OpenPrs | undefined;

    constructor(data?: IResponseOfOpenPrsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? OpenPrs.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfOpenPrsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOpenPrsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfOpenPrsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OpenPrs | undefined;
}

export class ResponseOfOpenPrs extends ResponseOfOpenPrsAndString implements IResponseOfOpenPrs {

    constructor(data?: IResponseOfOpenPrs) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfOpenPrs {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOpenPrs();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfOpenPrs extends IResponseOfOpenPrsAndString {
}

export class OpenPrs implements IOpenPrs {
    entries?: PrEntry[];
    totalOpen?: number;
    red?: number;
    yellow?: number;
    green?: number;
    ready?: number;

    constructor(data?: IOpenPrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(PrEntry.fromJS(item));
            }
            this.totalOpen = _data["totalOpen"];
            this.red = _data["red"];
            this.yellow = _data["yellow"];
            this.green = _data["green"];
            this.ready = _data["ready"];
        }
    }

    static fromJS(data: any): OpenPrs {
        data = typeof data === 'object' ? data : {};
        let result = new OpenPrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalOpen"] = this.totalOpen;
        data["red"] = this.red;
        data["yellow"] = this.yellow;
        data["green"] = this.green;
        data["ready"] = this.ready;
        return data;
    }
}

export interface IOpenPrs {
    entries?: PrEntry[];
    totalOpen?: number;
    red?: number;
    yellow?: number;
    green?: number;
    ready?: number;
}

export class PrEntry implements IPrEntry {
    repo?: string;
    title?: string;
    author?: string;
    daysOpen?: number;
    link?: string;
    ticket?: string | undefined;
    approvedBy?: string[];
    approvals?: number;
    reviewersTotal?: number;
    ageGroup?: string;

    constructor(data?: IPrEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repo = _data["repo"];
            this.title = _data["title"];
            this.author = _data["author"];
            this.daysOpen = _data["daysOpen"];
            this.link = _data["link"];
            this.ticket = _data["ticket"];
            if (Array.isArray(_data["approvedBy"])) {
                this.approvedBy = [] as any;
                for (let item of _data["approvedBy"])
                    this.approvedBy!.push(item);
            }
            this.approvals = _data["approvals"];
            this.reviewersTotal = _data["reviewersTotal"];
            this.ageGroup = _data["ageGroup"];
        }
    }

    static fromJS(data: any): PrEntry {
        data = typeof data === 'object' ? data : {};
        let result = new PrEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repo"] = this.repo;
        data["title"] = this.title;
        data["author"] = this.author;
        data["daysOpen"] = this.daysOpen;
        data["link"] = this.link;
        data["ticket"] = this.ticket;
        if (Array.isArray(this.approvedBy)) {
            data["approvedBy"] = [];
            for (let item of this.approvedBy)
                data["approvedBy"].push(item);
        }
        data["approvals"] = this.approvals;
        data["reviewersTotal"] = this.reviewersTotal;
        data["ageGroup"] = this.ageGroup;
        return data;
    }
}

export interface IPrEntry {
    repo?: string;
    title?: string;
    author?: string;
    daysOpen?: number;
    link?: string;
    ticket?: string | undefined;
    approvedBy?: string[];
    approvals?: number;
    reviewersTotal?: number;
    ageGroup?: string;
}

export class ResponseOfReviewerRankingAndString implements IResponseOfReviewerRankingAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ReviewerRanking | undefined;

    constructor(data?: IResponseOfReviewerRankingAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ReviewerRanking.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfReviewerRankingAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfReviewerRankingAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfReviewerRankingAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ReviewerRanking | undefined;
}

export class ResponseOfReviewerRanking extends ResponseOfReviewerRankingAndString implements IResponseOfReviewerRanking {

    constructor(data?: IResponseOfReviewerRanking) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfReviewerRanking {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfReviewerRanking();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfReviewerRanking extends IResponseOfReviewerRankingAndString {
}

export class ReviewerRanking implements IReviewerRanking {
    ranking?: ReviewerRankRow[];
    totalKonePrs?: number;

    constructor(data?: IReviewerRanking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ranking"])) {
                this.ranking = [] as any;
                for (let item of _data["ranking"])
                    this.ranking!.push(ReviewerRankRow.fromJS(item));
            }
            this.totalKonePrs = _data["totalKonePrs"];
        }
    }

    static fromJS(data: any): ReviewerRanking {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewerRanking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ranking)) {
            data["ranking"] = [];
            for (let item of this.ranking)
                data["ranking"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalKonePrs"] = this.totalKonePrs;
        return data;
    }
}

export interface IReviewerRanking {
    ranking?: ReviewerRankRow[];
    totalKonePrs?: number;
}

export class ReviewerRankRow implements IReviewerRankRow {
    rank?: number;
    name?: string;
    approvals?: number;
    uniquePrs?: number;

    constructor(data?: IReviewerRankRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.name = _data["name"];
            this.approvals = _data["approvals"];
            this.uniquePrs = _data["uniquePrs"];
        }
    }

    static fromJS(data: any): ReviewerRankRow {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewerRankRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["name"] = this.name;
        data["approvals"] = this.approvals;
        data["uniquePrs"] = this.uniquePrs;
        return data;
    }
}

export interface IReviewerRankRow {
    rank?: number;
    name?: string;
    approvals?: number;
    uniquePrs?: number;
}

export class ResponseOfE2eRegressionTestResultsAndString implements IResponseOfE2eRegressionTestResultsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: E2eRegressionTestResults | undefined;

    constructor(data?: IResponseOfE2eRegressionTestResultsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? E2eRegressionTestResults.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfE2eRegressionTestResultsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfE2eRegressionTestResultsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfE2eRegressionTestResultsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: E2eRegressionTestResults | undefined;
}

export class ResponseOfE2eRegressionTestResults extends ResponseOfE2eRegressionTestResultsAndString implements IResponseOfE2eRegressionTestResults {

    constructor(data?: IResponseOfE2eRegressionTestResults) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfE2eRegressionTestResults {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfE2eRegressionTestResults();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfE2eRegressionTestResults extends IResponseOfE2eRegressionTestResultsAndString {
}

export class E2eRegressionTestResults implements IE2eRegressionTestResults {
    myPortal?: E2eTestRunResult[] | undefined;
    kAdmin?: E2eTestRunResult[] | undefined;
    facultyPortal?: E2eTestRunResult[] | undefined;
    organizationPortal?: E2eTestRunResult[] | undefined;

    constructor(data?: IE2eRegressionTestResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["myPortal"])) {
                this.myPortal = [] as any;
                for (let item of _data["myPortal"])
                    this.myPortal!.push(E2eTestRunResult.fromJS(item));
            }
            if (Array.isArray(_data["kAdmin"])) {
                this.kAdmin = [] as any;
                for (let item of _data["kAdmin"])
                    this.kAdmin!.push(E2eTestRunResult.fromJS(item));
            }
            if (Array.isArray(_data["facultyPortal"])) {
                this.facultyPortal = [] as any;
                for (let item of _data["facultyPortal"])
                    this.facultyPortal!.push(E2eTestRunResult.fromJS(item));
            }
            if (Array.isArray(_data["organizationPortal"])) {
                this.organizationPortal = [] as any;
                for (let item of _data["organizationPortal"])
                    this.organizationPortal!.push(E2eTestRunResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): E2eRegressionTestResults {
        data = typeof data === 'object' ? data : {};
        let result = new E2eRegressionTestResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.myPortal)) {
            data["myPortal"] = [];
            for (let item of this.myPortal)
                data["myPortal"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.kAdmin)) {
            data["kAdmin"] = [];
            for (let item of this.kAdmin)
                data["kAdmin"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.facultyPortal)) {
            data["facultyPortal"] = [];
            for (let item of this.facultyPortal)
                data["facultyPortal"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.organizationPortal)) {
            data["organizationPortal"] = [];
            for (let item of this.organizationPortal)
                data["organizationPortal"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IE2eRegressionTestResults {
    myPortal?: E2eTestRunResult[] | undefined;
    kAdmin?: E2eTestRunResult[] | undefined;
    facultyPortal?: E2eTestRunResult[] | undefined;
    organizationPortal?: E2eTestRunResult[] | undefined;
}

export class E2eTestRunResult implements IE2eTestRunResult {
    runId?: string | undefined;
    runDate?: Date;
    reportUrl?: string | undefined;
    passedTests?: number | undefined;
    failedTests?: number | undefined;
    flakyTests?: number | undefined;
    skippedTests?: number | undefined;
    suites?: E2eTestSuiteResult[] | undefined;

    constructor(data?: IE2eTestRunResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runId = _data["runId"];
            this.runDate = _data["runDate"] ? new Date(_data["runDate"].toString()) : undefined as any;
            this.reportUrl = _data["reportUrl"];
            this.passedTests = _data["passedTests"];
            this.failedTests = _data["failedTests"];
            this.flakyTests = _data["flakyTests"];
            this.skippedTests = _data["skippedTests"];
            if (Array.isArray(_data["suites"])) {
                this.suites = [] as any;
                for (let item of _data["suites"])
                    this.suites!.push(E2eTestSuiteResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): E2eTestRunResult {
        data = typeof data === 'object' ? data : {};
        let result = new E2eTestRunResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId;
        data["runDate"] = this.runDate ? this.runDate.toISOString() : undefined as any;
        data["reportUrl"] = this.reportUrl;
        data["passedTests"] = this.passedTests;
        data["failedTests"] = this.failedTests;
        data["flakyTests"] = this.flakyTests;
        data["skippedTests"] = this.skippedTests;
        if (Array.isArray(this.suites)) {
            data["suites"] = [];
            for (let item of this.suites)
                data["suites"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IE2eTestRunResult {
    runId?: string | undefined;
    runDate?: Date;
    reportUrl?: string | undefined;
    passedTests?: number | undefined;
    failedTests?: number | undefined;
    flakyTests?: number | undefined;
    skippedTests?: number | undefined;
    suites?: E2eTestSuiteResult[] | undefined;
}

export class E2eTestSuiteResult implements IE2eTestSuiteResult {
    title?: string | undefined;
    cases?: E2eTestCaseResult[] | undefined;

    constructor(data?: IE2eTestSuiteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(E2eTestCaseResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): E2eTestSuiteResult {
        data = typeof data === 'object' ? data : {};
        let result = new E2eTestSuiteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IE2eTestSuiteResult {
    title?: string | undefined;
    cases?: E2eTestCaseResult[] | undefined;
}

export class E2eTestCaseResult implements IE2eTestCaseResult {
    title?: string | undefined;
    koneTicket?: string | undefined;
    status?: string | undefined;
    durationMs?: number;
    retryCount?: number;
    error?: E2eTestErrorDetails | undefined;

    constructor(data?: IE2eTestCaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.koneTicket = _data["koneTicket"];
            this.status = _data["status"];
            this.durationMs = _data["durationMs"];
            this.retryCount = _data["retryCount"];
            this.error = _data["error"] ? E2eTestErrorDetails.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): E2eTestCaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new E2eTestCaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["koneTicket"] = this.koneTicket;
        data["status"] = this.status;
        data["durationMs"] = this.durationMs;
        data["retryCount"] = this.retryCount;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IE2eTestCaseResult {
    title?: string | undefined;
    koneTicket?: string | undefined;
    status?: string | undefined;
    durationMs?: number;
    retryCount?: number;
    error?: E2eTestErrorDetails | undefined;
}

export class E2eTestErrorDetails implements IE2eTestErrorDetails {
    summary?: string | undefined;
    details?: string | undefined;
    snippet?: string | undefined;

    constructor(data?: IE2eTestErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"];
            this.details = _data["details"];
            this.snippet = _data["snippet"];
        }
    }

    static fromJS(data: any): E2eTestErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new E2eTestErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["details"] = this.details;
        data["snippet"] = this.snippet;
        return data;
    }
}

export interface IE2eTestErrorDetails {
    summary?: string | undefined;
    details?: string | undefined;
    snippet?: string | undefined;
}

export class ResponseOfListOfMicroserviceStatusAndString implements IResponseOfListOfMicroserviceStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MicroserviceStatus[] | undefined;

    constructor(data?: IResponseOfListOfMicroserviceStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MicroserviceStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfMicroserviceStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMicroserviceStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfMicroserviceStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MicroserviceStatus[] | undefined;
}

export class ResponseOfListOfMicroserviceStatus extends ResponseOfListOfMicroserviceStatusAndString implements IResponseOfListOfMicroserviceStatus {

    constructor(data?: IResponseOfListOfMicroserviceStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfMicroserviceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMicroserviceStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfMicroserviceStatus extends IResponseOfListOfMicroserviceStatusAndString {
}

export class ListResponseOfMicroserviceStatus extends ResponseOfListOfMicroserviceStatus implements IListResponseOfMicroserviceStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfMicroserviceStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfMicroserviceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfMicroserviceStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfMicroserviceStatus extends IResponseOfListOfMicroserviceStatus {
    totalRecords?: number | undefined;
}

export class MicroserviceStatus implements IMicroserviceStatus {
    name?: string | undefined;
    url?: string | undefined;
    status?: string | undefined;
    details?: { [key: string]: any; } | undefined;

    constructor(data?: IMicroserviceStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.status = _data["status"];
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (this.details as any)![key] = _data["details"][key];
                }
            }
        }
    }

    static fromJS(data: any): MicroserviceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MicroserviceStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["status"] = this.status;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (data["details"] as any)[key] = (this.details as any)[key];
            }
        }
        return data;
    }
}

export interface IMicroserviceStatus {
    name?: string | undefined;
    url?: string | undefined;
    status?: string | undefined;
    details?: { [key: string]: any; } | undefined;
}

export class CacheFlushResult implements ICacheFlushResult {
    nodesFlushed?: number;
    nodesTotal?: number;
    failedEndpoints?: string[] | undefined;

    constructor(data?: ICacheFlushResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodesFlushed = _data["nodesFlushed"];
            this.nodesTotal = _data["nodesTotal"];
            if (Array.isArray(_data["failedEndpoints"])) {
                this.failedEndpoints = [] as any;
                for (let item of _data["failedEndpoints"])
                    this.failedEndpoints!.push(item);
            }
        }
    }

    static fromJS(data: any): CacheFlushResult {
        data = typeof data === 'object' ? data : {};
        let result = new CacheFlushResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodesFlushed"] = this.nodesFlushed;
        data["nodesTotal"] = this.nodesTotal;
        if (Array.isArray(this.failedEndpoints)) {
            data["failedEndpoints"] = [];
            for (let item of this.failedEndpoints)
                data["failedEndpoints"].push(item);
        }
        return data;
    }
}

export interface ICacheFlushResult {
    nodesFlushed?: number;
    nodesTotal?: number;
    failedEndpoints?: string[] | undefined;
}

export class ResponseOfListOfWebhookNotificationViewModelAndString implements IResponseOfListOfWebhookNotificationViewModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: WebhookNotificationViewModel[] | undefined;

    constructor(data?: IResponseOfListOfWebhookNotificationViewModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WebhookNotificationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfWebhookNotificationViewModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWebhookNotificationViewModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfWebhookNotificationViewModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: WebhookNotificationViewModel[] | undefined;
}

export class ResponseOfListOfWebhookNotificationViewModel extends ResponseOfListOfWebhookNotificationViewModelAndString implements IResponseOfListOfWebhookNotificationViewModel {

    constructor(data?: IResponseOfListOfWebhookNotificationViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfWebhookNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWebhookNotificationViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfWebhookNotificationViewModel extends IResponseOfListOfWebhookNotificationViewModelAndString {
}

export class ListResponseOfWebhookNotificationViewModel extends ResponseOfListOfWebhookNotificationViewModel implements IListResponseOfWebhookNotificationViewModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfWebhookNotificationViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfWebhookNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfWebhookNotificationViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfWebhookNotificationViewModel extends IResponseOfListOfWebhookNotificationViewModel {
    totalRecords?: number | undefined;
}

export class WebhookNotificationViewModel implements IWebhookNotificationViewModel {
    notificationId?: string | undefined;
    deliveryStatus?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    transactionId?: string | undefined;
    invoiceNumber?: string | undefined;
    amount?: number;
    subscriptionId?: string | undefined;

    constructor(data?: IWebhookNotificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.deliveryStatus = _data["deliveryStatus"];
            this.eventType = _data["eventType"];
            this.eventDate = _data["eventDate"];
            this.transactionId = _data["transactionId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.amount = _data["amount"];
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): WebhookNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookNotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["deliveryStatus"] = this.deliveryStatus;
        data["eventType"] = this.eventType;
        data["eventDate"] = this.eventDate;
        data["transactionId"] = this.transactionId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["amount"] = this.amount;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IWebhookNotificationViewModel {
    notificationId?: string | undefined;
    deliveryStatus?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    transactionId?: string | undefined;
    invoiceNumber?: string | undefined;
    amount?: number;
    subscriptionId?: string | undefined;
}

export class ListRequestOfWebhookFilter implements IListRequestOfWebhookFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: WebhookFilter | undefined;

    constructor(data?: IListRequestOfWebhookFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? WebhookFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfWebhookFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfWebhookFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfWebhookFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: WebhookFilter | undefined;
}

export class WebhookFilter implements IWebhookFilter {
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    hasSubscriptionId?: boolean;
    searchTerm?: string | undefined;

    constructor(data?: IWebhookFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.hasSubscriptionId = _data["hasSubscriptionId"];
            this.searchTerm = _data["searchTerm"];
        }
    }

    static fromJS(data: any): WebhookFilter {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["hasSubscriptionId"] = this.hasSubscriptionId;
        data["searchTerm"] = this.searchTerm;
        return data;
    }
}

export interface IWebhookFilter {
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    hasSubscriptionId?: boolean;
    searchTerm?: string | undefined;
}

export class ResponseOfListOfWebhookRepostResultAndString implements IResponseOfListOfWebhookRepostResultAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: WebhookRepostResult[] | undefined;

    constructor(data?: IResponseOfListOfWebhookRepostResultAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WebhookRepostResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfWebhookRepostResultAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWebhookRepostResultAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfWebhookRepostResultAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: WebhookRepostResult[] | undefined;
}

export class ResponseOfListOfWebhookRepostResult extends ResponseOfListOfWebhookRepostResultAndString implements IResponseOfListOfWebhookRepostResult {

    constructor(data?: IResponseOfListOfWebhookRepostResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfWebhookRepostResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWebhookRepostResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfWebhookRepostResult extends IResponseOfListOfWebhookRepostResultAndString {
}

export class WebhookRepostResult implements IWebhookRepostResult {
    notificationId?: string | undefined;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IWebhookRepostResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WebhookRepostResult {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookRepostResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IWebhookRepostResult {
    notificationId?: string | undefined;
    success?: boolean;
    message?: string | undefined;
}

export class WebhookRepostApiRequest implements IWebhookRepostApiRequest {
    notificationIds?: string[] | undefined;

    constructor(data?: IWebhookRepostApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationIds"])) {
                this.notificationIds = [] as any;
                for (let item of _data["notificationIds"])
                    this.notificationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): WebhookRepostApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookRepostApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationIds)) {
            data["notificationIds"] = [];
            for (let item of this.notificationIds)
                data["notificationIds"].push(item);
        }
        return data;
    }
}

export interface IWebhookRepostApiRequest {
    notificationIds?: string[] | undefined;
}

export class ResponseOfListOfEmailAndString implements IResponseOfListOfEmailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Email[] | undefined;

    constructor(data?: IResponseOfListOfEmailAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Email.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEmailAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEmailAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEmailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Email[] | undefined;
}

export class ResponseOfListOfEmail extends ResponseOfListOfEmailAndString implements IResponseOfListOfEmail {

    constructor(data?: IResponseOfListOfEmail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEmail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEmail extends IResponseOfListOfEmailAndString {
}

export class ListResponseOfEmail extends ResponseOfListOfEmail implements IListResponseOfEmail {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfEmail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfEmail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfEmail extends IResponseOfListOfEmail {
    totalRecords?: number | undefined;
}

export class Email implements IEmail {
    id?: string;
    emailTemplateId?: string | undefined;
    emailStatusTypeId?: string;
    emailProvider?: EmailProvider;
    applicationId?: string | undefined;
    application?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    emailTemplateName?: string | undefined;
    externalEmailId?: string | undefined;
    senderEmail?: string | undefined;
    senderName?: string | undefined;
    toEmails?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    dateReceived?: Date | undefined;
    parentEmailId?: string | undefined;
    groupId?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;
    replacementValues?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;

    constructor(data?: IEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.emailStatusTypeId = _data["emailStatusTypeId"];
            this.emailProvider = _data["emailProvider"];
            this.applicationId = _data["applicationId"];
            this.application = _data["application"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.emailTemplateName = _data["emailTemplateName"];
            this.externalEmailId = _data["externalEmailId"];
            this.senderEmail = _data["senderEmail"];
            this.senderName = _data["senderName"];
            this.toEmails = _data["toEmails"];
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : undefined as any;
            this.parentEmailId = _data["parentEmailId"];
            this.groupId = _data["groupId"];
            this.ccEmails = _data["ccEmails"];
            this.bccEmails = _data["bccEmails"];
            this.replacementValues = _data["replacementValues"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): Email {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailTemplateId"] = this.emailTemplateId;
        data["emailStatusTypeId"] = this.emailStatusTypeId;
        data["emailProvider"] = this.emailProvider;
        data["applicationId"] = this.applicationId;
        data["application"] = this.application;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["emailTemplateName"] = this.emailTemplateName;
        data["externalEmailId"] = this.externalEmailId;
        data["senderEmail"] = this.senderEmail;
        data["senderName"] = this.senderName;
        data["toEmails"] = this.toEmails;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : undefined as any;
        data["parentEmailId"] = this.parentEmailId;
        data["groupId"] = this.groupId;
        data["ccEmails"] = this.ccEmails;
        data["bccEmails"] = this.bccEmails;
        data["replacementValues"] = this.replacementValues;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IEmail {
    id?: string;
    emailTemplateId?: string | undefined;
    emailStatusTypeId?: string;
    emailProvider?: EmailProvider;
    applicationId?: string | undefined;
    application?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    emailTemplateName?: string | undefined;
    externalEmailId?: string | undefined;
    senderEmail?: string | undefined;
    senderName?: string | undefined;
    toEmails?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    dateReceived?: Date | undefined;
    parentEmailId?: string | undefined;
    groupId?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;
    replacementValues?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
}

export enum EmailProvider {
    SendGrid = "SendGrid",
    Hubspot = "Hubspot",
}

export class EmailResendRequest implements IEmailResendRequest {
    emailId?: string;
    organizationId?: string;

    constructor(data?: IEmailResendRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailId = _data["emailId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): EmailResendRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailResendRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailId"] = this.emailId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IEmailResendRequest {
    emailId?: string;
    organizationId?: string;
}

export class ResponseOfListOfEmailPreviewAndString implements IResponseOfListOfEmailPreviewAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EmailPreview[] | undefined;

    constructor(data?: IResponseOfListOfEmailPreviewAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EmailPreview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEmailPreviewAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEmailPreviewAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEmailPreviewAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EmailPreview[] | undefined;
}

export class ResponseOfListOfEmailPreview extends ResponseOfListOfEmailPreviewAndString implements IResponseOfListOfEmailPreview {

    constructor(data?: IResponseOfListOfEmailPreview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEmailPreview {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEmailPreview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEmailPreview extends IResponseOfListOfEmailPreviewAndString {
}

export class ListResponseOfEmailPreview extends ResponseOfListOfEmailPreview implements IListResponseOfEmailPreview {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfEmailPreview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfEmailPreview {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfEmailPreview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfEmailPreview extends IResponseOfListOfEmailPreview {
    totalRecords?: number | undefined;
}

export class EmailPreview implements IEmailPreview {
    id?: string;
    emailTemplateId?: string | undefined;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    emailTemplateName?: string | undefined;
    senderEmail?: string | undefined;
    toEmails?: string | undefined;
    emailProvider?: EmailProvider;
    createdOn?: Date;

    constructor(data?: IEmailPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.emailTemplateName = _data["emailTemplateName"];
            this.senderEmail = _data["senderEmail"];
            this.toEmails = _data["toEmails"];
            this.emailProvider = _data["emailProvider"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmailPreview {
        data = typeof data === 'object' ? data : {};
        let result = new EmailPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailTemplateId"] = this.emailTemplateId;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["emailTemplateName"] = this.emailTemplateName;
        data["senderEmail"] = this.senderEmail;
        data["toEmails"] = this.toEmails;
        data["emailProvider"] = this.emailProvider;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IEmailPreview {
    id?: string;
    emailTemplateId?: string | undefined;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    emailTemplateName?: string | undefined;
    senderEmail?: string | undefined;
    toEmails?: string | undefined;
    emailProvider?: EmailProvider;
    createdOn?: Date;
}

export class ListRequestOfEmailFilter implements IListRequestOfEmailFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: EmailFilter | undefined;

    constructor(data?: IListRequestOfEmailFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? EmailFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfEmailFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfEmailFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfEmailFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: EmailFilter | undefined;
}

export class EmailFilter extends BaseFilter implements IEmailFilter {
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    templateId?: string | undefined;

    constructor(data?: IEmailFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined as any;
            this.templateId = _data["templateId"];
        }
    }

    static override fromJS(data: any): EmailFilter {
        data = typeof data === 'object' ? data : {};
        let result = new EmailFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        data["templateId"] = this.templateId;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailFilter extends IBaseFilter {
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    templateId?: string | undefined;
}

export class ResponseOfListOfEmailTemplateModelAndString implements IResponseOfListOfEmailTemplateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EmailTemplateModel[] | undefined;

    constructor(data?: IResponseOfListOfEmailTemplateModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EmailTemplateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEmailTemplateModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEmailTemplateModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEmailTemplateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EmailTemplateModel[] | undefined;
}

export class ResponseOfListOfEmailTemplateModel extends ResponseOfListOfEmailTemplateModelAndString implements IResponseOfListOfEmailTemplateModel {

    constructor(data?: IResponseOfListOfEmailTemplateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEmailTemplateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEmailTemplateModel extends IResponseOfListOfEmailTemplateModelAndString {
}

export class ListResponseOfEmailTemplateModel extends ResponseOfListOfEmailTemplateModel implements IListResponseOfEmailTemplateModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfEmailTemplateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfEmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfEmailTemplateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfEmailTemplateModel extends IResponseOfListOfEmailTemplateModel {
    totalRecords?: number | undefined;
}

export class EmailTemplateModel implements IEmailTemplateModel {
    id?: string;
    name?: string | undefined;
    organizationId?: string;
    applicationId?: string | undefined;
    organizationName?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    senderEmail?: string | undefined;
    senderName?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;

    constructor(data?: IEmailTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.applicationId = _data["applicationId"];
            this.organizationName = _data["organizationName"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.senderEmail = _data["senderEmail"];
            this.senderName = _data["senderName"];
            this.ccEmails = _data["ccEmails"];
            this.bccEmails = _data["bccEmails"];
        }
    }

    static fromJS(data: any): EmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["applicationId"] = this.applicationId;
        data["organizationName"] = this.organizationName;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["senderEmail"] = this.senderEmail;
        data["senderName"] = this.senderName;
        data["ccEmails"] = this.ccEmails;
        data["bccEmails"] = this.bccEmails;
        return data;
    }
}

export interface IEmailTemplateModel {
    id?: string;
    name?: string | undefined;
    organizationId?: string;
    applicationId?: string | undefined;
    organizationName?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    senderEmail?: string | undefined;
    senderName?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;
}

export class ResponseOfEmailTemplateModelAndString implements IResponseOfEmailTemplateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EmailTemplateModel | undefined;

    constructor(data?: IResponseOfEmailTemplateModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? EmailTemplateModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfEmailTemplateModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEmailTemplateModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfEmailTemplateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EmailTemplateModel | undefined;
}

export class ResponseOfEmailTemplateModel extends ResponseOfEmailTemplateModelAndString implements IResponseOfEmailTemplateModel {

    constructor(data?: IResponseOfEmailTemplateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfEmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEmailTemplateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfEmailTemplateModel extends IResponseOfEmailTemplateModelAndString {
}

export class EmailTemplateRequest implements IEmailTemplateRequest {
    id?: string | undefined;
    name!: string;
    organizationId!: string;
    applicationId?: string | undefined;
    emailThemeId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    senderEmail?: string | undefined;
    senderName?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;

    constructor(data?: IEmailTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.applicationId = _data["applicationId"];
            this.emailThemeId = _data["emailThemeId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.senderEmail = _data["senderEmail"];
            this.senderName = _data["senderName"];
            this.ccEmails = _data["ccEmails"];
            this.bccEmails = _data["bccEmails"];
        }
    }

    static fromJS(data: any): EmailTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["applicationId"] = this.applicationId;
        data["emailThemeId"] = this.emailThemeId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["senderEmail"] = this.senderEmail;
        data["senderName"] = this.senderName;
        data["ccEmails"] = this.ccEmails;
        data["bccEmails"] = this.bccEmails;
        return data;
    }
}

export interface IEmailTemplateRequest {
    id?: string | undefined;
    name: string;
    organizationId: string;
    applicationId?: string | undefined;
    emailThemeId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    senderEmail?: string | undefined;
    senderName?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;
}

export class ResponseOfListOfNotificationConfigurationInfoAndString implements IResponseOfListOfNotificationConfigurationInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: NotificationConfigurationInfo[] | undefined;

    constructor(data?: IResponseOfListOfNotificationConfigurationInfoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationConfigurationInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfNotificationConfigurationInfoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfNotificationConfigurationInfoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfNotificationConfigurationInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: NotificationConfigurationInfo[] | undefined;
}

export class ResponseOfListOfNotificationConfigurationInfo extends ResponseOfListOfNotificationConfigurationInfoAndString implements IResponseOfListOfNotificationConfigurationInfo {

    constructor(data?: IResponseOfListOfNotificationConfigurationInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfNotificationConfigurationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfNotificationConfigurationInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfNotificationConfigurationInfo extends IResponseOfListOfNotificationConfigurationInfoAndString {
}

export class ListResponseOfNotificationConfigurationInfo extends ResponseOfListOfNotificationConfigurationInfo implements IListResponseOfNotificationConfigurationInfo {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfNotificationConfigurationInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfNotificationConfigurationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfNotificationConfigurationInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfNotificationConfigurationInfo extends IResponseOfListOfNotificationConfigurationInfo {
    totalRecords?: number | undefined;
}

export class NotificationConfigurationInfo implements INotificationConfigurationInfo {
    notificationJobRoutingId?: string;
    templateId?: string | undefined;
    triggerName?: string | undefined;
    triggerEventKey?: string | undefined;
    condition?: string | undefined;
    routingTypeId?: string;
    channel?: string | undefined;
    templateTitle?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: INotificationConfigurationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationJobRoutingId = _data["notificationJobRoutingId"];
            this.templateId = _data["templateId"];
            this.triggerName = _data["triggerName"];
            this.triggerEventKey = _data["triggerEventKey"];
            this.condition = _data["condition"];
            this.routingTypeId = _data["routingTypeId"];
            this.channel = _data["channel"];
            this.templateTitle = _data["templateTitle"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): NotificationConfigurationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationConfigurationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationJobRoutingId"] = this.notificationJobRoutingId;
        data["templateId"] = this.templateId;
        data["triggerName"] = this.triggerName;
        data["triggerEventKey"] = this.triggerEventKey;
        data["condition"] = this.condition;
        data["routingTypeId"] = this.routingTypeId;
        data["channel"] = this.channel;
        data["templateTitle"] = this.templateTitle;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface INotificationConfigurationInfo {
    notificationJobRoutingId?: string;
    templateId?: string | undefined;
    triggerName?: string | undefined;
    triggerEventKey?: string | undefined;
    condition?: string | undefined;
    routingTypeId?: string;
    channel?: string | undefined;
    templateTitle?: string | undefined;
    isEnabled?: boolean;
}

export class ListRequestOfNotificationConfigurationFilter implements IListRequestOfNotificationConfigurationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: NotificationConfigurationFilter | undefined;

    constructor(data?: IListRequestOfNotificationConfigurationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? NotificationConfigurationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfNotificationConfigurationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfNotificationConfigurationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfNotificationConfigurationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: NotificationConfigurationFilter | undefined;
}

export class NotificationConfigurationFilter extends BaseFilter implements INotificationConfigurationFilter {
    notificationRoutingTypeIds?: (string | undefined)[] | undefined;
    isEnabled?: boolean | undefined;

    constructor(data?: INotificationConfigurationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["notificationRoutingTypeIds"])) {
                this.notificationRoutingTypeIds = [] as any;
                for (let item of _data["notificationRoutingTypeIds"])
                    this.notificationRoutingTypeIds!.push(item);
            }
            this.isEnabled = _data["isEnabled"];
        }
    }

    static override fromJS(data: any): NotificationConfigurationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationConfigurationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationRoutingTypeIds)) {
            data["notificationRoutingTypeIds"] = [];
            for (let item of this.notificationRoutingTypeIds)
                data["notificationRoutingTypeIds"].push(item);
        }
        data["isEnabled"] = this.isEnabled;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationConfigurationFilter extends IBaseFilter {
    notificationRoutingTypeIds?: (string | undefined)[] | undefined;
    isEnabled?: boolean | undefined;
}

export class ResponseOfNotificationConfigurationModelAndString implements IResponseOfNotificationConfigurationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: NotificationConfigurationModel | undefined;

    constructor(data?: IResponseOfNotificationConfigurationModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? NotificationConfigurationModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfNotificationConfigurationModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfNotificationConfigurationModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfNotificationConfigurationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: NotificationConfigurationModel | undefined;
}

export class ResponseOfNotificationConfigurationModel extends ResponseOfNotificationConfigurationModelAndString implements IResponseOfNotificationConfigurationModel {

    constructor(data?: IResponseOfNotificationConfigurationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfNotificationConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfNotificationConfigurationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfNotificationConfigurationModel extends IResponseOfNotificationConfigurationModelAndString {
}

export class NotificationConfigurationModel implements INotificationConfigurationModel {
    notificationJobEventId?: string;
    notificationJobRoutingId?: string;
    applicationId?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    triggerName?: string | undefined;
    triggerEventKey?: string | undefined;
    condition?: string | undefined;
    routingTypeId?: string;
    channel?: string | undefined;
    isEnabled?: boolean;
    templateId?: string | undefined;
    templateName?: string | undefined;
    templateTitle?: string | undefined;
    body?: string | undefined;
    actionUrl?: string | undefined;
    actionLabel?: string | undefined;
    displayModeId?: number | undefined;
    displayModeName?: string | undefined;
    frequencyTypeId?: number | undefined;
    frequencyTypeName?: string | undefined;
    frequencyInterval?: number | undefined;
    intervalTypeId?: number | undefined;
    intervalTypeName?: string | undefined;
    dismissalTypeId?: number | undefined;
    dismissalTypeName?: string | undefined;
    validFrom?: Date | undefined;
    expiresOn?: Date | undefined;
    subject?: string | undefined;
    senderName?: string | undefined;
    senderEmail?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;

    constructor(data?: INotificationConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationJobEventId = _data["notificationJobEventId"];
            this.notificationJobRoutingId = _data["notificationJobRoutingId"];
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.triggerName = _data["triggerName"];
            this.triggerEventKey = _data["triggerEventKey"];
            this.condition = _data["condition"];
            this.routingTypeId = _data["routingTypeId"];
            this.channel = _data["channel"];
            this.isEnabled = _data["isEnabled"];
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            this.templateTitle = _data["templateTitle"];
            this.body = _data["body"];
            this.actionUrl = _data["actionUrl"];
            this.actionLabel = _data["actionLabel"];
            this.displayModeId = _data["displayModeId"];
            this.displayModeName = _data["displayModeName"];
            this.frequencyTypeId = _data["frequencyTypeId"];
            this.frequencyTypeName = _data["frequencyTypeName"];
            this.frequencyInterval = _data["frequencyInterval"];
            this.intervalTypeId = _data["intervalTypeId"];
            this.intervalTypeName = _data["intervalTypeName"];
            this.dismissalTypeId = _data["dismissalTypeId"];
            this.dismissalTypeName = _data["dismissalTypeName"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
            this.subject = _data["subject"];
            this.senderName = _data["senderName"];
            this.senderEmail = _data["senderEmail"];
            this.ccEmails = _data["ccEmails"];
            this.bccEmails = _data["bccEmails"];
        }
    }

    static fromJS(data: any): NotificationConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationJobEventId"] = this.notificationJobEventId;
        data["notificationJobRoutingId"] = this.notificationJobRoutingId;
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["triggerName"] = this.triggerName;
        data["triggerEventKey"] = this.triggerEventKey;
        data["condition"] = this.condition;
        data["routingTypeId"] = this.routingTypeId;
        data["channel"] = this.channel;
        data["isEnabled"] = this.isEnabled;
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        data["templateTitle"] = this.templateTitle;
        data["body"] = this.body;
        data["actionUrl"] = this.actionUrl;
        data["actionLabel"] = this.actionLabel;
        data["displayModeId"] = this.displayModeId;
        data["displayModeName"] = this.displayModeName;
        data["frequencyTypeId"] = this.frequencyTypeId;
        data["frequencyTypeName"] = this.frequencyTypeName;
        data["frequencyInterval"] = this.frequencyInterval;
        data["intervalTypeId"] = this.intervalTypeId;
        data["intervalTypeName"] = this.intervalTypeName;
        data["dismissalTypeId"] = this.dismissalTypeId;
        data["dismissalTypeName"] = this.dismissalTypeName;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["subject"] = this.subject;
        data["senderName"] = this.senderName;
        data["senderEmail"] = this.senderEmail;
        data["ccEmails"] = this.ccEmails;
        data["bccEmails"] = this.bccEmails;
        return data;
    }
}

export interface INotificationConfigurationModel {
    notificationJobEventId?: string;
    notificationJobRoutingId?: string;
    applicationId?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    triggerName?: string | undefined;
    triggerEventKey?: string | undefined;
    condition?: string | undefined;
    routingTypeId?: string;
    channel?: string | undefined;
    isEnabled?: boolean;
    templateId?: string | undefined;
    templateName?: string | undefined;
    templateTitle?: string | undefined;
    body?: string | undefined;
    actionUrl?: string | undefined;
    actionLabel?: string | undefined;
    displayModeId?: number | undefined;
    displayModeName?: string | undefined;
    frequencyTypeId?: number | undefined;
    frequencyTypeName?: string | undefined;
    frequencyInterval?: number | undefined;
    intervalTypeId?: number | undefined;
    intervalTypeName?: string | undefined;
    dismissalTypeId?: number | undefined;
    dismissalTypeName?: string | undefined;
    validFrom?: Date | undefined;
    expiresOn?: Date | undefined;
    subject?: string | undefined;
    senderName?: string | undefined;
    senderEmail?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;
}

export class NotificationConfigurationRequest implements INotificationConfigurationRequest {
    notificationJobRoutingId?: string | undefined;
    notificationJobEventId?: string;
    notificationRoutingTypeId?: string;
    isEnabled?: boolean;
    templateId?: string | undefined;
    applicationId?: string;
    organizationId?: string;
    condition?: string | undefined;
    templateName?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    actionUrl?: string | undefined;
    actionLabel?: string | undefined;
    displayModeId?: number | undefined;
    frequencyTypeId?: number | undefined;
    frequencyInterval?: number | undefined;
    intervalTypeId?: number | undefined;
    dismissalTypeId?: number | undefined;
    validFrom?: Date | undefined;
    expiresOn?: Date | undefined;
    subject?: string | undefined;
    senderName?: string | undefined;
    senderEmail?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;

    constructor(data?: INotificationConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationJobRoutingId = _data["notificationJobRoutingId"];
            this.notificationJobEventId = _data["notificationJobEventId"];
            this.notificationRoutingTypeId = _data["notificationRoutingTypeId"];
            this.isEnabled = _data["isEnabled"];
            this.templateId = _data["templateId"];
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
            this.condition = _data["condition"];
            this.templateName = _data["templateName"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.actionUrl = _data["actionUrl"];
            this.actionLabel = _data["actionLabel"];
            this.displayModeId = _data["displayModeId"];
            this.frequencyTypeId = _data["frequencyTypeId"];
            this.frequencyInterval = _data["frequencyInterval"];
            this.intervalTypeId = _data["intervalTypeId"];
            this.dismissalTypeId = _data["dismissalTypeId"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
            this.subject = _data["subject"];
            this.senderName = _data["senderName"];
            this.senderEmail = _data["senderEmail"];
            this.ccEmails = _data["ccEmails"];
            this.bccEmails = _data["bccEmails"];
        }
    }

    static fromJS(data: any): NotificationConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationJobRoutingId"] = this.notificationJobRoutingId;
        data["notificationJobEventId"] = this.notificationJobEventId;
        data["notificationRoutingTypeId"] = this.notificationRoutingTypeId;
        data["isEnabled"] = this.isEnabled;
        data["templateId"] = this.templateId;
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        data["condition"] = this.condition;
        data["templateName"] = this.templateName;
        data["title"] = this.title;
        data["body"] = this.body;
        data["actionUrl"] = this.actionUrl;
        data["actionLabel"] = this.actionLabel;
        data["displayModeId"] = this.displayModeId;
        data["frequencyTypeId"] = this.frequencyTypeId;
        data["frequencyInterval"] = this.frequencyInterval;
        data["intervalTypeId"] = this.intervalTypeId;
        data["dismissalTypeId"] = this.dismissalTypeId;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["subject"] = this.subject;
        data["senderName"] = this.senderName;
        data["senderEmail"] = this.senderEmail;
        data["ccEmails"] = this.ccEmails;
        data["bccEmails"] = this.bccEmails;
        return data;
    }
}

export interface INotificationConfigurationRequest {
    notificationJobRoutingId?: string | undefined;
    notificationJobEventId?: string;
    notificationRoutingTypeId?: string;
    isEnabled?: boolean;
    templateId?: string | undefined;
    applicationId?: string;
    organizationId?: string;
    condition?: string | undefined;
    templateName?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    actionUrl?: string | undefined;
    actionLabel?: string | undefined;
    displayModeId?: number | undefined;
    frequencyTypeId?: number | undefined;
    frequencyInterval?: number | undefined;
    intervalTypeId?: number | undefined;
    dismissalTypeId?: number | undefined;
    validFrom?: Date | undefined;
    expiresOn?: Date | undefined;
    subject?: string | undefined;
    senderName?: string | undefined;
    senderEmail?: string | undefined;
    ccEmails?: string | undefined;
    bccEmails?: string | undefined;
}

export class ResponseOfListOfNotificationConfigurationStatusAndString implements IResponseOfListOfNotificationConfigurationStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: NotificationConfigurationStatus[] | undefined;

    constructor(data?: IResponseOfListOfNotificationConfigurationStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationConfigurationStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfNotificationConfigurationStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfNotificationConfigurationStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfNotificationConfigurationStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: NotificationConfigurationStatus[] | undefined;
}

export class ResponseOfListOfNotificationConfigurationStatus extends ResponseOfListOfNotificationConfigurationStatusAndString implements IResponseOfListOfNotificationConfigurationStatus {

    constructor(data?: IResponseOfListOfNotificationConfigurationStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfNotificationConfigurationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfNotificationConfigurationStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfNotificationConfigurationStatus extends IResponseOfListOfNotificationConfigurationStatusAndString {
}

export class ListResponseOfNotificationConfigurationStatus extends ResponseOfListOfNotificationConfigurationStatus implements IListResponseOfNotificationConfigurationStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfNotificationConfigurationStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfNotificationConfigurationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfNotificationConfigurationStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfNotificationConfigurationStatus extends IResponseOfListOfNotificationConfigurationStatus {
    totalRecords?: number | undefined;
}

export abstract class NotificationConfigurationLookupBase implements INotificationConfigurationLookupBase {
    id?: number;
    name?: string | undefined;

    constructor(data?: INotificationConfigurationLookupBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NotificationConfigurationLookupBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'NotificationConfigurationLookupBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface INotificationConfigurationLookupBase {
    id?: number;
    name?: string | undefined;
}

export class NotificationConfigurationStatus extends NotificationConfigurationLookupBase implements INotificationConfigurationStatus {

    constructor(data?: INotificationConfigurationStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): NotificationConfigurationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationConfigurationStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INotificationConfigurationStatus extends INotificationConfigurationLookupBase {
}

export class ResponseOfListOfDisplayModeAndString implements IResponseOfListOfDisplayModeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DisplayMode[] | undefined;

    constructor(data?: IResponseOfListOfDisplayModeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DisplayMode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfDisplayModeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDisplayModeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfDisplayModeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DisplayMode[] | undefined;
}

export class ResponseOfListOfDisplayMode extends ResponseOfListOfDisplayModeAndString implements IResponseOfListOfDisplayMode {

    constructor(data?: IResponseOfListOfDisplayMode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfDisplayMode {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDisplayMode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfDisplayMode extends IResponseOfListOfDisplayModeAndString {
}

export class ListResponseOfDisplayMode extends ResponseOfListOfDisplayMode implements IListResponseOfDisplayMode {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfDisplayMode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfDisplayMode {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfDisplayMode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfDisplayMode extends IResponseOfListOfDisplayMode {
    totalRecords?: number | undefined;
}

export class DisplayMode extends NotificationConfigurationLookupBase implements IDisplayMode {

    constructor(data?: IDisplayMode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DisplayMode {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayMode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDisplayMode extends INotificationConfigurationLookupBase {
}

export class ResponseOfListOfFrequencyTypeAndString implements IResponseOfListOfFrequencyTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: FrequencyType[] | undefined;

    constructor(data?: IResponseOfListOfFrequencyTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FrequencyType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfFrequencyTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfFrequencyTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfFrequencyTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: FrequencyType[] | undefined;
}

export class ResponseOfListOfFrequencyType extends ResponseOfListOfFrequencyTypeAndString implements IResponseOfListOfFrequencyType {

    constructor(data?: IResponseOfListOfFrequencyType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfFrequencyType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfFrequencyType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfFrequencyType extends IResponseOfListOfFrequencyTypeAndString {
}

export class ListResponseOfFrequencyType extends ResponseOfListOfFrequencyType implements IListResponseOfFrequencyType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfFrequencyType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfFrequencyType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfFrequencyType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfFrequencyType extends IResponseOfListOfFrequencyType {
    totalRecords?: number | undefined;
}

export class FrequencyType extends NotificationConfigurationLookupBase implements IFrequencyType {

    constructor(data?: IFrequencyType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FrequencyType {
        data = typeof data === 'object' ? data : {};
        let result = new FrequencyType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFrequencyType extends INotificationConfigurationLookupBase {
}

export class ResponseOfListOfDismissalTypeAndString implements IResponseOfListOfDismissalTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DismissalType[] | undefined;

    constructor(data?: IResponseOfListOfDismissalTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DismissalType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfDismissalTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDismissalTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfDismissalTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DismissalType[] | undefined;
}

export class ResponseOfListOfDismissalType extends ResponseOfListOfDismissalTypeAndString implements IResponseOfListOfDismissalType {

    constructor(data?: IResponseOfListOfDismissalType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfDismissalType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDismissalType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfDismissalType extends IResponseOfListOfDismissalTypeAndString {
}

export class ListResponseOfDismissalType extends ResponseOfListOfDismissalType implements IListResponseOfDismissalType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfDismissalType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfDismissalType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfDismissalType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfDismissalType extends IResponseOfListOfDismissalType {
    totalRecords?: number | undefined;
}

export class DismissalType extends NotificationConfigurationLookupBase implements IDismissalType {

    constructor(data?: IDismissalType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DismissalType {
        data = typeof data === 'object' ? data : {};
        let result = new DismissalType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDismissalType extends INotificationConfigurationLookupBase {
}

export class ResponseOfListOfIntervalTypeAndString implements IResponseOfListOfIntervalTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: IntervalType[] | undefined;

    constructor(data?: IResponseOfListOfIntervalTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IntervalType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfIntervalTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfIntervalTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfIntervalTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: IntervalType[] | undefined;
}

export class ResponseOfListOfIntervalType extends ResponseOfListOfIntervalTypeAndString implements IResponseOfListOfIntervalType {

    constructor(data?: IResponseOfListOfIntervalType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfIntervalType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfIntervalType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfIntervalType extends IResponseOfListOfIntervalTypeAndString {
}

export class ListResponseOfIntervalType extends ResponseOfListOfIntervalType implements IListResponseOfIntervalType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfIntervalType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfIntervalType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfIntervalType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfIntervalType extends IResponseOfListOfIntervalType {
    totalRecords?: number | undefined;
}

export class IntervalType extends NotificationConfigurationLookupBase implements IIntervalType {

    constructor(data?: IIntervalType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): IntervalType {
        data = typeof data === 'object' ? data : {};
        let result = new IntervalType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIntervalType extends INotificationConfigurationLookupBase {
}

export class ResponseOfListOfAuditLogEntryAndString implements IResponseOfListOfAuditLogEntryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuditLogEntry[] | undefined;

    constructor(data?: IResponseOfListOfAuditLogEntryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AuditLogEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAuditLogEntryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAuditLogEntryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAuditLogEntryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuditLogEntry[] | undefined;
}

export class ResponseOfListOfAuditLogEntry extends ResponseOfListOfAuditLogEntryAndString implements IResponseOfListOfAuditLogEntry {

    constructor(data?: IResponseOfListOfAuditLogEntry) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAuditLogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAuditLogEntry();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAuditLogEntry extends IResponseOfListOfAuditLogEntryAndString {
}

export class ListResponseOfAuditLogEntry extends ResponseOfListOfAuditLogEntry implements IListResponseOfAuditLogEntry {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAuditLogEntry) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAuditLogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAuditLogEntry();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAuditLogEntry extends IResponseOfListOfAuditLogEntry {
    totalRecords?: number | undefined;
}

export class AuditLogEntry implements IAuditLogEntry {
    id?: string;
    logDate?: Date;
    user?: AuditLogUser | undefined;
    adminUser?: AuditLogUser | undefined;
    entityName?: string | undefined;
    eventTypeName?: string | undefined;
    auditLogEntryRows?: AuditLogEntryRow[] | undefined;

    constructor(data?: IAuditLogEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : undefined as any;
            this.user = _data["user"] ? AuditLogUser.fromJS(_data["user"]) : undefined as any;
            this.adminUser = _data["adminUser"] ? AuditLogUser.fromJS(_data["adminUser"]) : undefined as any;
            this.entityName = _data["entityName"];
            this.eventTypeName = _data["eventTypeName"];
            if (Array.isArray(_data["auditLogEntryRows"])) {
                this.auditLogEntryRows = [] as any;
                for (let item of _data["auditLogEntryRows"])
                    this.auditLogEntryRows!.push(AuditLogEntryRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["adminUser"] = this.adminUser ? this.adminUser.toJSON() : undefined as any;
        data["entityName"] = this.entityName;
        data["eventTypeName"] = this.eventTypeName;
        if (Array.isArray(this.auditLogEntryRows)) {
            data["auditLogEntryRows"] = [];
            for (let item of this.auditLogEntryRows)
                data["auditLogEntryRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAuditLogEntry {
    id?: string;
    logDate?: Date;
    user?: AuditLogUser | undefined;
    adminUser?: AuditLogUser | undefined;
    entityName?: string | undefined;
    eventTypeName?: string | undefined;
    auditLogEntryRows?: AuditLogEntryRow[] | undefined;
}

export class AuditLogUser implements IAuditLogUser {
    organizationUserId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IAuditLogUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUserId = _data["organizationUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): AuditLogUser {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUserId"] = this.organizationUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IAuditLogUser {
    organizationUserId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class AuditLogEntryRow implements IAuditLogEntryRow {
    name?: string | undefined;
    priorValue?: string | undefined;
    value?: string | undefined;

    constructor(data?: IAuditLogEntryRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.priorValue = _data["priorValue"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AuditLogEntryRow {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogEntryRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["priorValue"] = this.priorValue;
        data["value"] = this.value;
        return data;
    }
}

export interface IAuditLogEntryRow {
    name?: string | undefined;
    priorValue?: string | undefined;
    value?: string | undefined;
}

export class ListRequestOfAuditLogRequest implements IListRequestOfAuditLogRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AuditLogRequest | undefined;

    constructor(data?: IListRequestOfAuditLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AuditLogRequest.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAuditLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAuditLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAuditLogRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AuditLogRequest | undefined;
}

export class AuditLogRequest extends BaseFilter implements IAuditLogRequest {
    userId?: string | undefined;
    entityId?: string | undefined;
    entityName?: string | undefined;
    entityNames?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    eventTypeNames?: EventTypeName[] | undefined;

    constructor(data?: IAuditLogRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            if (Array.isArray(_data["entityNames"])) {
                this.entityNames = [] as any;
                for (let item of _data["entityNames"])
                    this.entityNames!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["eventTypeNames"])) {
                this.eventTypeNames = [] as any;
                for (let item of _data["eventTypeNames"])
                    this.eventTypeNames!.push(EventTypeName.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        if (Array.isArray(this.entityNames)) {
            data["entityNames"] = [];
            for (let item of this.entityNames)
                data["entityNames"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.eventTypeNames)) {
            data["eventTypeNames"] = [];
            for (let item of this.eventTypeNames)
                data["eventTypeNames"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogRequest extends IBaseFilter {
    userId?: string | undefined;
    entityId?: string | undefined;
    entityName?: string | undefined;
    entityNames?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    eventTypeNames?: EventTypeName[] | undefined;
}

export class EventTypeName implements IEventTypeName {
    name?: string | undefined;

    constructor(data?: IEventTypeName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EventTypeName {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IEventTypeName {
    name?: string | undefined;
}

export class ResponseOfListOfProcessAuditLogAndString implements IResponseOfListOfProcessAuditLogAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProcessAuditLog[] | undefined;

    constructor(data?: IResponseOfListOfProcessAuditLogAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProcessAuditLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProcessAuditLogAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProcessAuditLogAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProcessAuditLogAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProcessAuditLog[] | undefined;
}

export class ResponseOfListOfProcessAuditLog extends ResponseOfListOfProcessAuditLogAndString implements IResponseOfListOfProcessAuditLog {

    constructor(data?: IResponseOfListOfProcessAuditLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProcessAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProcessAuditLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProcessAuditLog extends IResponseOfListOfProcessAuditLogAndString {
}

export class ListResponseOfProcessAuditLog extends ResponseOfListOfProcessAuditLog implements IListResponseOfProcessAuditLog {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProcessAuditLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProcessAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProcessAuditLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProcessAuditLog extends IResponseOfListOfProcessAuditLog {
    totalRecords?: number | undefined;
}

export class ProcessAuditLog implements IProcessAuditLog {
    processTypeName?: string | undefined;
    processTypeId?: string;
    eventTypeName?: string | undefined;
    eventTypeId?: string;
    eventDate?: Date;
    data?: string | undefined;

    constructor(data?: IProcessAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processTypeName = _data["processTypeName"];
            this.processTypeId = _data["processTypeId"];
            this.eventTypeName = _data["eventTypeName"];
            this.eventTypeId = _data["eventTypeId"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : undefined as any;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ProcessAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processTypeName"] = this.processTypeName;
        data["processTypeId"] = this.processTypeId;
        data["eventTypeName"] = this.eventTypeName;
        data["eventTypeId"] = this.eventTypeId;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : undefined as any;
        data["data"] = this.data;
        return data;
    }
}

export interface IProcessAuditLog {
    processTypeName?: string | undefined;
    processTypeId?: string;
    eventTypeName?: string | undefined;
    eventTypeId?: string;
    eventDate?: Date;
    data?: string | undefined;
}

export class ListRequestOfProcessAuditLogFilter implements IListRequestOfProcessAuditLogFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProcessAuditLogFilter | undefined;

    constructor(data?: IListRequestOfProcessAuditLogFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ProcessAuditLogFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfProcessAuditLogFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfProcessAuditLogFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfProcessAuditLogFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProcessAuditLogFilter | undefined;
}

export class ProcessAuditLogFilter extends BaseFilter implements IProcessAuditLogFilter {
    processTypeId?: string;

    constructor(data?: IProcessAuditLogFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.processTypeId = _data["processTypeId"];
        }
    }

    static override fromJS(data: any): ProcessAuditLogFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuditLogFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processTypeId"] = this.processTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface IProcessAuditLogFilter extends IBaseFilter {
    processTypeId?: string;
}

export class ResponseOfEntryCheckResponseAndString implements IResponseOfEntryCheckResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EntryCheckResponse | undefined;

    constructor(data?: IResponseOfEntryCheckResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? EntryCheckResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfEntryCheckResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEntryCheckResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfEntryCheckResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EntryCheckResponse | undefined;
}

export class ResponseOfEntryCheckResponse extends ResponseOfEntryCheckResponseAndString implements IResponseOfEntryCheckResponse {

    constructor(data?: IResponseOfEntryCheckResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfEntryCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEntryCheckResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfEntryCheckResponse extends IResponseOfEntryCheckResponseAndString {
}

export class EntryCheckResponse implements IEntryCheckResponse {
    index?: number;
    result?: boolean;
    isEmpty?: boolean;
    required?: boolean;
    errors?: string[] | undefined;

    constructor(data?: IEntryCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.result = _data["result"];
            this.isEmpty = _data["isEmpty"];
            this.required = _data["required"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): EntryCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EntryCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["result"] = this.result;
        data["isEmpty"] = this.isEmpty;
        data["required"] = this.required;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IEntryCheckResponse {
    index?: number;
    result?: boolean;
    isEmpty?: boolean;
    required?: boolean;
    errors?: string[] | undefined;
}

export class EntryCheckRequest implements IEntryCheckRequest {
    index?: number;
    values?: string[] | undefined;
    required?: boolean;
    dataType?: ImportDataType;

    constructor(data?: IEntryCheckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.required = _data["required"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): EntryCheckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EntryCheckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["required"] = this.required;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IEntryCheckRequest {
    index?: number;
    values?: string[] | undefined;
    required?: boolean;
    dataType?: ImportDataType;
}

export enum ImportDataType {
    Guid = "Guid",
    String = "String",
    Integer = "Integer",
    Decimal = "Decimal",
    Date = "Date",
    Boolean = "Boolean",
}

export class ResponseOfListOfEntryCheckResponseAndString implements IResponseOfListOfEntryCheckResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EntryCheckResponse[] | undefined;

    constructor(data?: IResponseOfListOfEntryCheckResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EntryCheckResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEntryCheckResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEntryCheckResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEntryCheckResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EntryCheckResponse[] | undefined;
}

export class ResponseOfListOfEntryCheckResponse extends ResponseOfListOfEntryCheckResponseAndString implements IResponseOfListOfEntryCheckResponse {

    constructor(data?: IResponseOfListOfEntryCheckResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEntryCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEntryCheckResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEntryCheckResponse extends IResponseOfListOfEntryCheckResponseAndString {
}

export class ResponseOfListOfImportJobSummaryAndString implements IResponseOfListOfImportJobSummaryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobSummary[] | undefined;

    constructor(data?: IResponseOfListOfImportJobSummaryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportJobSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfImportJobSummaryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobSummaryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfImportJobSummaryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobSummary[] | undefined;
}

export class ResponseOfListOfImportJobSummary extends ResponseOfListOfImportJobSummaryAndString implements IResponseOfListOfImportJobSummary {

    constructor(data?: IResponseOfListOfImportJobSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfImportJobSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfImportJobSummary extends IResponseOfListOfImportJobSummaryAndString {
}

export class ListResponseOfImportJobSummary extends ResponseOfListOfImportJobSummary implements IListResponseOfImportJobSummary {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfImportJobSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfImportJobSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfImportJobSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfImportJobSummary extends IResponseOfListOfImportJobSummary {
    totalRecords?: number | undefined;
}

export class ImportJobSummary implements IImportJobSummary {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    jobTypeName?: string | undefined;
    createdOn?: string | undefined;
    jobName?: string | undefined;
    importJobSourceTypeName?: string | undefined;
    jobStatusName?: string | undefined;
    resultCounts?: ImportJobResultCounts | undefined;

    constructor(data?: IImportJobSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.jobTypeName = _data["jobTypeName"];
            this.createdOn = _data["createdOn"];
            this.jobName = _data["jobName"];
            this.importJobSourceTypeName = _data["importJobSourceTypeName"];
            this.jobStatusName = _data["jobStatusName"];
            this.resultCounts = _data["resultCounts"] ? ImportJobResultCounts.fromJS(_data["resultCounts"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportJobSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["jobTypeName"] = this.jobTypeName;
        data["createdOn"] = this.createdOn;
        data["jobName"] = this.jobName;
        data["importJobSourceTypeName"] = this.importJobSourceTypeName;
        data["jobStatusName"] = this.jobStatusName;
        data["resultCounts"] = this.resultCounts ? this.resultCounts.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportJobSummary {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    jobTypeName?: string | undefined;
    createdOn?: string | undefined;
    jobName?: string | undefined;
    importJobSourceTypeName?: string | undefined;
    jobStatusName?: string | undefined;
    resultCounts?: ImportJobResultCounts | undefined;
}

export class ImportJobResultCounts implements IImportJobResultCounts {
    total?: number;
    processed?: number;
    errored?: number;
    inProgress?: number;
    pending?: number;
    cancelled?: number;

    constructor(data?: IImportJobResultCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.processed = _data["processed"];
            this.errored = _data["errored"];
            this.inProgress = _data["inProgress"];
            this.pending = _data["pending"];
            this.cancelled = _data["cancelled"];
        }
    }

    static fromJS(data: any): ImportJobResultCounts {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobResultCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["processed"] = this.processed;
        data["errored"] = this.errored;
        data["inProgress"] = this.inProgress;
        data["pending"] = this.pending;
        data["cancelled"] = this.cancelled;
        return data;
    }
}

export interface IImportJobResultCounts {
    total?: number;
    processed?: number;
    errored?: number;
    inProgress?: number;
    pending?: number;
    cancelled?: number;
}

export class ListRequestOfJobSummaryFilter implements IListRequestOfJobSummaryFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: JobSummaryFilter | undefined;

    constructor(data?: IListRequestOfJobSummaryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? JobSummaryFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfJobSummaryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfJobSummaryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfJobSummaryFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: JobSummaryFilter | undefined;
}

export class AdminListRequestOfJobSummaryFilter extends ListRequestOfJobSummaryFilter implements IAdminListRequestOfJobSummaryFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfJobSummaryFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfJobSummaryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfJobSummaryFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfJobSummaryFilter extends IListRequestOfJobSummaryFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class JobSummaryFilter extends BaseFilter implements IJobSummaryFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobTypeId?: string | undefined;
    importSourceTypeId?: string | undefined;
    jobStatusId?: string | undefined;
    jobStatusIds?: string[] | undefined;

    constructor(data?: IJobSummaryFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.jobTypeId = _data["jobTypeId"];
            this.importSourceTypeId = _data["importSourceTypeId"];
            this.jobStatusId = _data["jobStatusId"];
            if (Array.isArray(_data["jobStatusIds"])) {
                this.jobStatusIds = [] as any;
                for (let item of _data["jobStatusIds"])
                    this.jobStatusIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): JobSummaryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new JobSummaryFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["jobTypeId"] = this.jobTypeId;
        data["importSourceTypeId"] = this.importSourceTypeId;
        data["jobStatusId"] = this.jobStatusId;
        if (Array.isArray(this.jobStatusIds)) {
            data["jobStatusIds"] = [];
            for (let item of this.jobStatusIds)
                data["jobStatusIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IJobSummaryFilter extends IBaseFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobTypeId?: string | undefined;
    importSourceTypeId?: string | undefined;
    jobStatusId?: string | undefined;
    jobStatusIds?: string[] | undefined;
}

export class ResponseOfImportJobSummaryAndString implements IResponseOfImportJobSummaryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobSummary | undefined;

    constructor(data?: IResponseOfImportJobSummaryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ImportJobSummary.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfImportJobSummaryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfImportJobSummaryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfImportJobSummaryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobSummary | undefined;
}

export class ResponseOfImportJobSummary extends ResponseOfImportJobSummaryAndString implements IResponseOfImportJobSummary {

    constructor(data?: IResponseOfImportJobSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfImportJobSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfImportJobSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfImportJobSummary extends IResponseOfImportJobSummaryAndString {
}

export class CreateFileJobRequestExtended implements ICreateFileJobRequestExtended {
    organizationId?: string;
    importJobTypeId?: string;

    constructor(data?: ICreateFileJobRequestExtended) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.importJobTypeId = _data["importJobTypeId"];
        }
    }

    static fromJS(data: any): CreateFileJobRequestExtended {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileJobRequestExtended();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["importJobTypeId"] = this.importJobTypeId;
        return data;
    }
}

export interface ICreateFileJobRequestExtended {
    organizationId?: string;
    importJobTypeId?: string;
}

export class ResponseOfFileProcessingSnapshotAndString implements IResponseOfFileProcessingSnapshotAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: FileProcessingSnapshot | undefined;

    constructor(data?: IResponseOfFileProcessingSnapshotAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? FileProcessingSnapshot.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfFileProcessingSnapshotAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfFileProcessingSnapshotAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfFileProcessingSnapshotAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: FileProcessingSnapshot | undefined;
}

export class ResponseOfFileProcessingSnapshot extends ResponseOfFileProcessingSnapshotAndString implements IResponseOfFileProcessingSnapshot {

    constructor(data?: IResponseOfFileProcessingSnapshot) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfFileProcessingSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfFileProcessingSnapshot();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfFileProcessingSnapshot extends IResponseOfFileProcessingSnapshotAndString {
}

export class FileProcessingSnapshot implements IFileProcessingSnapshot {
    totalRows?: number;
    processedRows?: number;
    progress?: number;

    constructor(data?: IFileProcessingSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            this.processedRows = _data["processedRows"];
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): FileProcessingSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new FileProcessingSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        data["processedRows"] = this.processedRows;
        data["progress"] = this.progress;
        return data;
    }
}

export interface IFileProcessingSnapshot {
    totalRows?: number;
    processedRows?: number;
    progress?: number;
}

export class ResponseOfListOfImportJobStatusAndString implements IResponseOfListOfImportJobStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobStatus[] | undefined;

    constructor(data?: IResponseOfListOfImportJobStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportJobStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfImportJobStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfImportJobStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobStatus[] | undefined;
}

export class ResponseOfListOfImportJobStatus extends ResponseOfListOfImportJobStatusAndString implements IResponseOfListOfImportJobStatus {

    constructor(data?: IResponseOfListOfImportJobStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfImportJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfImportJobStatus extends IResponseOfListOfImportJobStatusAndString {
}

export class ListResponseOfImportJobStatus extends ResponseOfListOfImportJobStatus implements IListResponseOfImportJobStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfImportJobStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfImportJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfImportJobStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfImportJobStatus extends IResponseOfListOfImportJobStatus {
    totalRecords?: number | undefined;
}

export class ImportJobStatus implements IImportJobStatus {
    id?: string;
    name?: string | undefined;

    constructor(data?: IImportJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ImportJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IImportJobStatus {
    id?: string;
    name?: string | undefined;
}

export class FileDataRequest implements IFileDataRequest {
    data?: string[][] | undefined;
    columnMappings?: FileColumnMapping[] | undefined;
    rowIndex?: number;

    constructor(data?: IFileDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            if (Array.isArray(_data["columnMappings"])) {
                this.columnMappings = [] as any;
                for (let item of _data["columnMappings"])
                    this.columnMappings!.push(FileColumnMapping.fromJS(item));
            }
            this.rowIndex = _data["rowIndex"];
        }
    }

    static fromJS(data: any): FileDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        if (Array.isArray(this.columnMappings)) {
            data["columnMappings"] = [];
            for (let item of this.columnMappings)
                data["columnMappings"].push(item ? item.toJSON() : undefined as any);
        }
        data["rowIndex"] = this.rowIndex;
        return data;
    }
}

export interface IFileDataRequest {
    data?: string[][] | undefined;
    columnMappings?: FileColumnMapping[] | undefined;
    rowIndex?: number;
}

export class FileColumnMapping implements IFileColumnMapping {
    importJobTypeFieldId?: string;
    importJobTypeId?: string;
    dataType?: ImportDataType;
    columnName?: string | undefined;
    columnIndex?: number;
    required?: boolean;

    constructor(data?: IFileColumnMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importJobTypeFieldId = _data["importJobTypeFieldId"];
            this.importJobTypeId = _data["importJobTypeId"];
            this.dataType = _data["dataType"];
            this.columnName = _data["columnName"];
            this.columnIndex = _data["columnIndex"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): FileColumnMapping {
        data = typeof data === 'object' ? data : {};
        let result = new FileColumnMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importJobTypeFieldId"] = this.importJobTypeFieldId;
        data["importJobTypeId"] = this.importJobTypeId;
        data["dataType"] = this.dataType;
        data["columnName"] = this.columnName;
        data["columnIndex"] = this.columnIndex;
        data["required"] = this.required;
        return data;
    }
}

export interface IFileColumnMapping {
    importJobTypeFieldId?: string;
    importJobTypeId?: string;
    dataType?: ImportDataType;
    columnName?: string | undefined;
    columnIndex?: number;
    required?: boolean;
}

export class ResponseOfListOfImportJobDataStatusAndString implements IResponseOfListOfImportJobDataStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobDataStatus[] | undefined;

    constructor(data?: IResponseOfListOfImportJobDataStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportJobDataStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfImportJobDataStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobDataStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfImportJobDataStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobDataStatus[] | undefined;
}

export class ResponseOfListOfImportJobDataStatus extends ResponseOfListOfImportJobDataStatusAndString implements IResponseOfListOfImportJobDataStatus {

    constructor(data?: IResponseOfListOfImportJobDataStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfImportJobDataStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobDataStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfImportJobDataStatus extends IResponseOfListOfImportJobDataStatusAndString {
}

export class ListResponseOfImportJobDataStatus extends ResponseOfListOfImportJobDataStatus implements IListResponseOfImportJobDataStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfImportJobDataStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfImportJobDataStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfImportJobDataStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfImportJobDataStatus extends IResponseOfListOfImportJobDataStatus {
    totalRecords?: number | undefined;
}

export class ImportJobDataStatus implements IImportJobDataStatus {
    id?: string;
    name?: string | undefined;
    sequence?: number;

    constructor(data?: IImportJobDataStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): ImportJobDataStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobDataStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IImportJobDataStatus {
    id?: string;
    name?: string | undefined;
    sequence?: number;
}

export class ResponseOfListOfJobDataSummaryAndString implements IResponseOfListOfJobDataSummaryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: JobDataSummary[] | undefined;

    constructor(data?: IResponseOfListOfJobDataSummaryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(JobDataSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfJobDataSummaryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfJobDataSummaryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfJobDataSummaryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: JobDataSummary[] | undefined;
}

export class ResponseOfListOfJobDataSummary extends ResponseOfListOfJobDataSummaryAndString implements IResponseOfListOfJobDataSummary {

    constructor(data?: IResponseOfListOfJobDataSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfJobDataSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfJobDataSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfJobDataSummary extends IResponseOfListOfJobDataSummaryAndString {
}

export class ListResponseOfJobDataSummary extends ResponseOfListOfJobDataSummary implements IListResponseOfJobDataSummary {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfJobDataSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfJobDataSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfJobDataSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfJobDataSummary extends IResponseOfListOfJobDataSummary {
    totalRecords?: number | undefined;
}

export class JobDataSummary implements IJobDataSummary {
    id?: string | undefined;
    jobId?: string;
    jobDataStatusId?: string;
    jobDataTypeId?: string | undefined;
    jobDataStatus?: string | undefined;
    jobDataType?: string | undefined;
    rowNumber?: number;
    message?: string | undefined;
    details?: string[] | undefined;

    constructor(data?: IJobDataSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobId = _data["jobId"];
            this.jobDataStatusId = _data["jobDataStatusId"];
            this.jobDataTypeId = _data["jobDataTypeId"];
            this.jobDataStatus = _data["jobDataStatus"];
            this.jobDataType = _data["jobDataType"];
            this.rowNumber = _data["rowNumber"];
            this.message = _data["message"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(item);
            }
        }
    }

    static fromJS(data: any): JobDataSummary {
        data = typeof data === 'object' ? data : {};
        let result = new JobDataSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobId"] = this.jobId;
        data["jobDataStatusId"] = this.jobDataStatusId;
        data["jobDataTypeId"] = this.jobDataTypeId;
        data["jobDataStatus"] = this.jobDataStatus;
        data["jobDataType"] = this.jobDataType;
        data["rowNumber"] = this.rowNumber;
        data["message"] = this.message;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item);
        }
        return data;
    }
}

export interface IJobDataSummary {
    id?: string | undefined;
    jobId?: string;
    jobDataStatusId?: string;
    jobDataTypeId?: string | undefined;
    jobDataStatus?: string | undefined;
    jobDataType?: string | undefined;
    rowNumber?: number;
    message?: string | undefined;
    details?: string[] | undefined;
}

export class ListRequestOfJobDataSummaryFilter implements IListRequestOfJobDataSummaryFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: JobDataSummaryFilter | undefined;

    constructor(data?: IListRequestOfJobDataSummaryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? JobDataSummaryFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfJobDataSummaryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfJobDataSummaryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfJobDataSummaryFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: JobDataSummaryFilter | undefined;
}

export class JobDataSummaryFilter extends BaseFilter implements IJobDataSummaryFilter {
    jobDataStatusId?: string | undefined;
    excludeProcessed?: boolean;

    constructor(data?: IJobDataSummaryFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobDataStatusId = _data["jobDataStatusId"];
            this.excludeProcessed = _data["excludeProcessed"];
        }
    }

    static override fromJS(data: any): JobDataSummaryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new JobDataSummaryFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobDataStatusId"] = this.jobDataStatusId;
        data["excludeProcessed"] = this.excludeProcessed;
        super.toJSON(data);
        return data;
    }
}

export interface IJobDataSummaryFilter extends IBaseFilter {
    jobDataStatusId?: string | undefined;
    excludeProcessed?: boolean;
}

export class ResponseOfImportJobGraphAndString implements IResponseOfImportJobGraphAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobGraph | undefined;

    constructor(data?: IResponseOfImportJobGraphAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ImportJobGraph.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfImportJobGraphAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfImportJobGraphAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfImportJobGraphAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobGraph | undefined;
}

export class ResponseOfImportJobGraph extends ResponseOfImportJobGraphAndString implements IResponseOfImportJobGraph {

    constructor(data?: IResponseOfImportJobGraph) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfImportJobGraph {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfImportJobGraph();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfImportJobGraph extends IResponseOfImportJobGraphAndString {
}

export class ImportJobGraph implements IImportJobGraph {
    totalEntities?: number;
    truncated?: boolean;
    nodes?: ImportEntityNode[] | undefined;

    constructor(data?: IImportJobGraph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEntities = _data["totalEntities"];
            this.truncated = _data["truncated"];
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(ImportEntityNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportJobGraph {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobGraph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEntities"] = this.totalEntities;
        data["truncated"] = this.truncated;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportJobGraph {
    totalEntities?: number;
    truncated?: boolean;
    nodes?: ImportEntityNode[] | undefined;
}

export class ImportEntityNode implements IImportEntityNode {
    nodeId?: string;
    detailId?: string;
    parentId?: string | undefined;
    level?: number;
    isRoot?: boolean;
    jobDataTypeId?: string;
    jobDataType?: string | undefined;
    jobDataStatusId?: string;
    jobDataStatus?: string | undefined;
    displayName?: string | undefined;
    generatedId?: string | undefined;
    message?: string | undefined;
    retriesCount?: number | undefined;
    isShared?: boolean;
    isReference?: boolean;
    referencedBySkuDetailIds?: string[] | undefined;

    constructor(data?: IImportEntityNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            this.detailId = _data["detailId"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.isRoot = _data["isRoot"];
            this.jobDataTypeId = _data["jobDataTypeId"];
            this.jobDataType = _data["jobDataType"];
            this.jobDataStatusId = _data["jobDataStatusId"];
            this.jobDataStatus = _data["jobDataStatus"];
            this.displayName = _data["displayName"];
            this.generatedId = _data["generatedId"];
            this.message = _data["message"];
            this.retriesCount = _data["retriesCount"];
            this.isShared = _data["isShared"];
            this.isReference = _data["isReference"];
            if (Array.isArray(_data["referencedBySkuDetailIds"])) {
                this.referencedBySkuDetailIds = [] as any;
                for (let item of _data["referencedBySkuDetailIds"])
                    this.referencedBySkuDetailIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportEntityNode {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEntityNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["detailId"] = this.detailId;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["isRoot"] = this.isRoot;
        data["jobDataTypeId"] = this.jobDataTypeId;
        data["jobDataType"] = this.jobDataType;
        data["jobDataStatusId"] = this.jobDataStatusId;
        data["jobDataStatus"] = this.jobDataStatus;
        data["displayName"] = this.displayName;
        data["generatedId"] = this.generatedId;
        data["message"] = this.message;
        data["retriesCount"] = this.retriesCount;
        data["isShared"] = this.isShared;
        data["isReference"] = this.isReference;
        if (Array.isArray(this.referencedBySkuDetailIds)) {
            data["referencedBySkuDetailIds"] = [];
            for (let item of this.referencedBySkuDetailIds)
                data["referencedBySkuDetailIds"].push(item);
        }
        return data;
    }
}

export interface IImportEntityNode {
    nodeId?: string;
    detailId?: string;
    parentId?: string | undefined;
    level?: number;
    isRoot?: boolean;
    jobDataTypeId?: string;
    jobDataType?: string | undefined;
    jobDataStatusId?: string;
    jobDataStatus?: string | undefined;
    displayName?: string | undefined;
    generatedId?: string | undefined;
    message?: string | undefined;
    retriesCount?: number | undefined;
    isShared?: boolean;
    isReference?: boolean;
    referencedBySkuDetailIds?: string[] | undefined;
}

export class ResponseOfListOfImportJobTypeAndString implements IResponseOfListOfImportJobTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobType[] | undefined;

    constructor(data?: IResponseOfListOfImportJobTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportJobType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfImportJobTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfImportJobTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobType[] | undefined;
}

export class ResponseOfListOfImportJobType extends ResponseOfListOfImportJobTypeAndString implements IResponseOfListOfImportJobType {

    constructor(data?: IResponseOfListOfImportJobType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfImportJobType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfImportJobType extends IResponseOfListOfImportJobTypeAndString {
}

export class ListResponseOfImportJobType extends ResponseOfListOfImportJobType implements IListResponseOfImportJobType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfImportJobType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfImportJobType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfImportJobType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfImportJobType extends IResponseOfListOfImportJobType {
    totalRecords?: number | undefined;
}

export class ImportJobType implements IImportJobType {
    id?: string;
    stuffId?: string;
    enumValue?: string | undefined;
    name?: string | undefined;

    constructor(data?: IImportJobType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stuffId = _data["stuffId"];
            this.enumValue = _data["enumValue"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ImportJobType {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stuffId"] = this.stuffId;
        data["enumValue"] = this.enumValue;
        data["name"] = this.name;
        return data;
    }
}

export interface IImportJobType {
    id?: string;
    stuffId?: string;
    enumValue?: string | undefined;
    name?: string | undefined;
}

export class ListRequestOfJobTypeFilter implements IListRequestOfJobTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: JobTypeFilter | undefined;

    constructor(data?: IListRequestOfJobTypeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? JobTypeFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfJobTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfJobTypeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfJobTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: JobTypeFilter | undefined;
}

export class JobTypeFilter extends BaseFilter implements IJobTypeFilter {
    onlyCsvConfigured?: boolean;

    constructor(data?: IJobTypeFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.onlyCsvConfigured = _data["onlyCsvConfigured"];
        }
    }

    static override fromJS(data: any): JobTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new JobTypeFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlyCsvConfigured"] = this.onlyCsvConfigured;
        super.toJSON(data);
        return data;
    }
}

export interface IJobTypeFilter extends IBaseFilter {
    onlyCsvConfigured?: boolean;
}

export class ResponseOfListOfImportJobTypeFieldAndString implements IResponseOfListOfImportJobTypeFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobTypeField[] | undefined;

    constructor(data?: IResponseOfListOfImportJobTypeFieldAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportJobTypeField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfImportJobTypeFieldAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobTypeFieldAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfImportJobTypeFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ImportJobTypeField[] | undefined;
}

export class ResponseOfListOfImportJobTypeField extends ResponseOfListOfImportJobTypeFieldAndString implements IResponseOfListOfImportJobTypeField {

    constructor(data?: IResponseOfListOfImportJobTypeField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfImportJobTypeField {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfImportJobTypeField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfImportJobTypeField extends IResponseOfListOfImportJobTypeFieldAndString {
}

export class ListResponseOfImportJobTypeField extends ResponseOfListOfImportJobTypeField implements IListResponseOfImportJobTypeField {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfImportJobTypeField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfImportJobTypeField {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfImportJobTypeField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfImportJobTypeField extends IResponseOfListOfImportJobTypeField {
    totalRecords?: number | undefined;
}

export class ImportJobTypeField implements IImportJobTypeField {
    id?: string;
    importJobTypeId?: string;
    fieldName?: string | undefined;
    required?: boolean;
    requiredIfFieldsMissing?: string[] | undefined;
    dataType?: ImportDataType;
    dataTypeDescription?: string | undefined;
    groupName?: string | undefined;

    constructor(data?: IImportJobTypeField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.importJobTypeId = _data["importJobTypeId"];
            this.fieldName = _data["fieldName"];
            this.required = _data["required"];
            if (Array.isArray(_data["requiredIfFieldsMissing"])) {
                this.requiredIfFieldsMissing = [] as any;
                for (let item of _data["requiredIfFieldsMissing"])
                    this.requiredIfFieldsMissing!.push(item);
            }
            this.dataType = _data["dataType"];
            this.dataTypeDescription = _data["dataTypeDescription"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): ImportJobTypeField {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobTypeField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["importJobTypeId"] = this.importJobTypeId;
        data["fieldName"] = this.fieldName;
        data["required"] = this.required;
        if (Array.isArray(this.requiredIfFieldsMissing)) {
            data["requiredIfFieldsMissing"] = [];
            for (let item of this.requiredIfFieldsMissing)
                data["requiredIfFieldsMissing"].push(item);
        }
        data["dataType"] = this.dataType;
        data["dataTypeDescription"] = this.dataTypeDescription;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface IImportJobTypeField {
    id?: string;
    importJobTypeId?: string;
    fieldName?: string | undefined;
    required?: boolean;
    requiredIfFieldsMissing?: string[] | undefined;
    dataType?: ImportDataType;
    dataTypeDescription?: string | undefined;
    groupName?: string | undefined;
}

export class ResponseOfListOfQuestionAndString implements IResponseOfListOfQuestionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Question[] | undefined;

    constructor(data?: IResponseOfListOfQuestionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfQuestionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQuestionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfQuestionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Question[] | undefined;
}

export class ResponseOfListOfQuestion extends ResponseOfListOfQuestionAndString implements IResponseOfListOfQuestion {

    constructor(data?: IResponseOfListOfQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfQuestion extends IResponseOfListOfQuestionAndString {
}

export class ListResponseOfQuestion extends ResponseOfListOfQuestion implements IListResponseOfQuestion {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfQuestion extends IResponseOfListOfQuestion {
    totalRecords?: number | undefined;
}

export class Question implements IQuestion {
    id?: string | undefined;
    organizationId?: string | undefined;
    value!: string;
    sequence?: number;
    questionType?: QuestionType | undefined;
    evaluationQuestionAnswers?: EvaluationQuestionAnswer[] | undefined;
    correctAnswersLetters?: string | undefined;
    required?: boolean;
    hasConfidenceLevels?: boolean;
    ratingSetting?: RatingSetting | undefined;
    createdOn?: Date;
    evaluationQuestionsCount?: number | undefined;
    questionFeedbackId?: string | undefined;
    questionFeedback?: string | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.value = _data["value"];
            this.sequence = _data["sequence"];
            this.questionType = _data["questionType"] ? QuestionType.fromJS(_data["questionType"]) : undefined as any;
            if (Array.isArray(_data["evaluationQuestionAnswers"])) {
                this.evaluationQuestionAnswers = [] as any;
                for (let item of _data["evaluationQuestionAnswers"])
                    this.evaluationQuestionAnswers!.push(EvaluationQuestionAnswer.fromJS(item));
            }
            this.correctAnswersLetters = _data["correctAnswersLetters"];
            this.required = _data["required"];
            this.hasConfidenceLevels = _data["hasConfidenceLevels"];
            this.ratingSetting = _data["ratingSetting"] ? RatingSetting.fromJS(_data["ratingSetting"]) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.evaluationQuestionsCount = _data["evaluationQuestionsCount"];
            this.questionFeedbackId = _data["questionFeedbackId"];
            this.questionFeedback = _data["questionFeedback"];
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["value"] = this.value;
        data["sequence"] = this.sequence;
        data["questionType"] = this.questionType ? this.questionType.toJSON() : undefined as any;
        if (Array.isArray(this.evaluationQuestionAnswers)) {
            data["evaluationQuestionAnswers"] = [];
            for (let item of this.evaluationQuestionAnswers)
                data["evaluationQuestionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["correctAnswersLetters"] = this.correctAnswersLetters;
        data["required"] = this.required;
        data["hasConfidenceLevels"] = this.hasConfidenceLevels;
        data["ratingSetting"] = this.ratingSetting ? this.ratingSetting.toJSON() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["evaluationQuestionsCount"] = this.evaluationQuestionsCount;
        data["questionFeedbackId"] = this.questionFeedbackId;
        data["questionFeedback"] = this.questionFeedback;
        return data;
    }
}

export interface IQuestion {
    id?: string | undefined;
    organizationId?: string | undefined;
    value: string;
    sequence?: number;
    questionType?: QuestionType | undefined;
    evaluationQuestionAnswers?: EvaluationQuestionAnswer[] | undefined;
    correctAnswersLetters?: string | undefined;
    required?: boolean;
    hasConfidenceLevels?: boolean;
    ratingSetting?: RatingSetting | undefined;
    createdOn?: Date;
    evaluationQuestionsCount?: number | undefined;
    questionFeedbackId?: string | undefined;
    questionFeedback?: string | undefined;
}

export class QuestionType implements IQuestionType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    gradingType?: QuestionGradingType;

    constructor(data?: IQuestionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.gradingType = _data["gradingType"];
        }
    }

    static fromJS(data: any): QuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["gradingType"] = this.gradingType;
        return data;
    }
}

export interface IQuestionType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    gradingType?: QuestionGradingType;
}

export enum QuestionGradingType {
    NotEligible = "NotEligible",
    Automatic = "Automatic",
    Manual = "Manual",
}

export class EvaluationQuestionAnswer implements IEvaluationQuestionAnswer {
    id?: string | undefined;
    value?: string | undefined;
    sequence?: number;
    isAnswer?: boolean;
    caseSensitive?: boolean;
    externalSourceId?: string | undefined;

    constructor(data?: IEvaluationQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.sequence = _data["sequence"];
            this.isAnswer = _data["isAnswer"];
            this.caseSensitive = _data["caseSensitive"];
            this.externalSourceId = _data["externalSourceId"];
        }
    }

    static fromJS(data: any): EvaluationQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["sequence"] = this.sequence;
        data["isAnswer"] = this.isAnswer;
        data["caseSensitive"] = this.caseSensitive;
        data["externalSourceId"] = this.externalSourceId;
        return data;
    }
}

export interface IEvaluationQuestionAnswer {
    id?: string | undefined;
    value?: string | undefined;
    sequence?: number;
    isAnswer?: boolean;
    caseSensitive?: boolean;
    externalSourceId?: string | undefined;
}

export class RatingSetting implements IRatingSetting {
    id?: string | undefined;
    name?: string | undefined;
    minValueText?: string | undefined;
    maxValueText?: string | undefined;
    optionCount?: number;

    constructor(data?: IRatingSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.minValueText = _data["minValueText"];
            this.maxValueText = _data["maxValueText"];
            this.optionCount = _data["optionCount"];
        }
    }

    static fromJS(data: any): RatingSetting {
        data = typeof data === 'object' ? data : {};
        let result = new RatingSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["minValueText"] = this.minValueText;
        data["maxValueText"] = this.maxValueText;
        data["optionCount"] = this.optionCount;
        return data;
    }
}

export interface IRatingSetting {
    id?: string | undefined;
    name?: string | undefined;
    minValueText?: string | undefined;
    maxValueText?: string | undefined;
    optionCount?: number;
}

export class ListRequestOfQuestionFilter implements IListRequestOfQuestionFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QuestionFilter | undefined;

    constructor(data?: IListRequestOfQuestionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? QuestionFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfQuestionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfQuestionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfQuestionFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QuestionFilter | undefined;
}

export class AdminListRequestOfQuestionFilter extends ListRequestOfQuestionFilter implements IAdminListRequestOfQuestionFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfQuestionFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfQuestionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfQuestionFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfQuestionFilter extends IListRequestOfQuestionFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class QuestionFilter extends BaseFilter implements IQuestionFilter {
    ratingSettingId?: string | undefined;
    questionTypeId?: string | undefined;

    constructor(data?: IQuestionFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ratingSettingId = _data["ratingSettingId"];
            this.questionTypeId = _data["questionTypeId"];
        }
    }

    static override fromJS(data: any): QuestionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ratingSettingId"] = this.ratingSettingId;
        data["questionTypeId"] = this.questionTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface IQuestionFilter extends IBaseFilter {
    ratingSettingId?: string | undefined;
    questionTypeId?: string | undefined;
}

export class ResponseOfListOfQuestionTypeAndString implements IResponseOfListOfQuestionTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QuestionType[] | undefined;

    constructor(data?: IResponseOfListOfQuestionTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfQuestionTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQuestionTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfQuestionTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QuestionType[] | undefined;
}

export class ResponseOfListOfQuestionType extends ResponseOfListOfQuestionTypeAndString implements IResponseOfListOfQuestionType {

    constructor(data?: IResponseOfListOfQuestionType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfQuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQuestionType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfQuestionType extends IResponseOfListOfQuestionTypeAndString {
}

export class ListResponseOfQuestionType extends ResponseOfListOfQuestionType implements IListResponseOfQuestionType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfQuestionType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfQuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQuestionType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfQuestionType extends IResponseOfListOfQuestionType {
    totalRecords?: number | undefined;
}

export class ListRequestOfQuestionTypeFilter implements IListRequestOfQuestionTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QuestionTypeFilter | undefined;

    constructor(data?: IListRequestOfQuestionTypeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? QuestionTypeFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfQuestionTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfQuestionTypeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfQuestionTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QuestionTypeFilter | undefined;
}

export class AdminListRequestOfQuestionTypeFilter extends ListRequestOfQuestionTypeFilter implements IAdminListRequestOfQuestionTypeFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfQuestionTypeFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfQuestionTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfQuestionTypeFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfQuestionTypeFilter extends IListRequestOfQuestionTypeFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class QuestionTypeFilter extends BaseFilter implements IQuestionTypeFilter {

    constructor(data?: IQuestionTypeFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QuestionTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTypeFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQuestionTypeFilter extends IBaseFilter {
}

export class ResponseOfQuestionAndString implements IResponseOfQuestionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Question | undefined;

    constructor(data?: IResponseOfQuestionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Question.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfQuestionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQuestionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfQuestionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Question | undefined;
}

export class ResponseOfQuestion extends ResponseOfQuestionAndString implements IResponseOfQuestion {

    constructor(data?: IResponseOfQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfQuestion extends IResponseOfQuestionAndString {
}

export class SaveQuestion implements ISaveQuestion {
    id?: string | undefined;
    organizationId!: string;
    value!: string;
    required?: boolean;
    sequence?: number;
    hasConfidenceLevels?: boolean;
    externalSourceId?: string | undefined;
    deletedDate?: Date | undefined;
    questionTypeId!: string;
    ratingSettingId?: string | undefined;
    answers?: EvaluationQuestionAnswer[] | undefined;
    questionFeedbackId?: string | undefined;
    questionFeedback?: string | undefined;

    constructor(data?: ISaveQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.value = _data["value"];
            this.required = _data["required"];
            this.sequence = _data["sequence"];
            this.hasConfidenceLevels = _data["hasConfidenceLevels"];
            this.externalSourceId = _data["externalSourceId"];
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : undefined as any;
            this.questionTypeId = _data["questionTypeId"];
            this.ratingSettingId = _data["ratingSettingId"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(EvaluationQuestionAnswer.fromJS(item));
            }
            this.questionFeedbackId = _data["questionFeedbackId"];
            this.questionFeedback = _data["questionFeedback"];
        }
    }

    static fromJS(data: any): SaveQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SaveQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["value"] = this.value;
        data["required"] = this.required;
        data["sequence"] = this.sequence;
        data["hasConfidenceLevels"] = this.hasConfidenceLevels;
        data["externalSourceId"] = this.externalSourceId;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : undefined as any;
        data["questionTypeId"] = this.questionTypeId;
        data["ratingSettingId"] = this.ratingSettingId;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["questionFeedbackId"] = this.questionFeedbackId;
        data["questionFeedback"] = this.questionFeedback;
        return data;
    }
}

export interface ISaveQuestion {
    id?: string | undefined;
    organizationId: string;
    value: string;
    required?: boolean;
    sequence?: number;
    hasConfidenceLevels?: boolean;
    externalSourceId?: string | undefined;
    deletedDate?: Date | undefined;
    questionTypeId: string;
    ratingSettingId?: string | undefined;
    answers?: EvaluationQuestionAnswer[] | undefined;
    questionFeedbackId?: string | undefined;
    questionFeedback?: string | undefined;
}

export class ResponseOfListOfGuidAndString implements IResponseOfListOfGuidAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string[] | undefined;

    constructor(data?: IResponseOfListOfGuidAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfGuidAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfGuidAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IResponseOfListOfGuidAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string[] | undefined;
}

export class ResponseOfListOfGuid extends ResponseOfListOfGuidAndString implements IResponseOfListOfGuid {

    constructor(data?: IResponseOfListOfGuid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfGuid extends IResponseOfListOfGuidAndString {
}

export class ListResponseOfGuid extends ResponseOfListOfGuid implements IListResponseOfGuid {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfGuid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfGuid extends IResponseOfListOfGuid {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfRatingSettingAndString implements IResponseOfListOfRatingSettingAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RatingSetting[] | undefined;

    constructor(data?: IResponseOfListOfRatingSettingAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RatingSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRatingSettingAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRatingSettingAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRatingSettingAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RatingSetting[] | undefined;
}

export class ResponseOfListOfRatingSetting extends ResponseOfListOfRatingSettingAndString implements IResponseOfListOfRatingSetting {

    constructor(data?: IResponseOfListOfRatingSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRatingSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRatingSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRatingSetting extends IResponseOfListOfRatingSettingAndString {
}

export class ListResponseOfRatingSetting extends ResponseOfListOfRatingSetting implements IListResponseOfRatingSetting {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRatingSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRatingSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRatingSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRatingSetting extends IResponseOfListOfRatingSetting {
    totalRecords?: number | undefined;
}

export class ListRequestOfRatingSettingFilter implements IListRequestOfRatingSettingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RatingSettingFilter | undefined;

    constructor(data?: IListRequestOfRatingSettingFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? RatingSettingFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfRatingSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfRatingSettingFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfRatingSettingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RatingSettingFilter | undefined;
}

export class AdminListRequestOfRatingSettingFilter extends ListRequestOfRatingSettingFilter implements IAdminListRequestOfRatingSettingFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfRatingSettingFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfRatingSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfRatingSettingFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfRatingSettingFilter extends IListRequestOfRatingSettingFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class RatingSettingFilter extends BaseFilter implements IRatingSettingFilter {

    constructor(data?: IRatingSettingFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RatingSettingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RatingSettingFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRatingSettingFilter extends IBaseFilter {
}

export class ResponseOfRatingSettingAndString implements IResponseOfRatingSettingAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RatingSetting | undefined;

    constructor(data?: IResponseOfRatingSettingAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RatingSetting.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRatingSettingAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRatingSettingAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRatingSettingAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RatingSetting | undefined;
}

export class ResponseOfRatingSetting extends ResponseOfRatingSettingAndString implements IResponseOfRatingSetting {

    constructor(data?: IResponseOfRatingSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRatingSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRatingSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRatingSetting extends IResponseOfRatingSettingAndString {
}

export class ResponseOfListOfEvaluationAndString implements IResponseOfListOfEvaluationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Evaluation[] | undefined;

    constructor(data?: IResponseOfListOfEvaluationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Evaluation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEvaluationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEvaluationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEvaluationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Evaluation[] | undefined;
}

export class ResponseOfListOfEvaluation extends ResponseOfListOfEvaluationAndString implements IResponseOfListOfEvaluation {

    constructor(data?: IResponseOfListOfEvaluation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEvaluation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEvaluation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEvaluation extends IResponseOfListOfEvaluationAndString {
}

export class ListResponseOfEvaluation extends ResponseOfListOfEvaluation implements IListResponseOfEvaluation {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfEvaluation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfEvaluation {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfEvaluation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfEvaluation extends IResponseOfListOfEvaluation {
    totalRecords?: number | undefined;
}

export class Evaluation implements IEvaluation {
    id?: string | undefined;
    name!: string;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    skuId?: string | undefined;
    evaluationTypeId?: string;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    attemptsAllowed?: number | undefined;
    passingScore?: number | undefined;
    daysAfterCourse?: number | undefined;
    evaluationType?: EvaluationType | undefined;
    evaluationQuestions?: EvaluationQuestion[] | undefined;
    isActive?: boolean;
    enablePrintReference?: boolean | undefined;
    hasConfidenceLevels?: boolean;
    organizationName?: string | undefined;
    skuAvailabilityId?: string | undefined;

    constructor(data?: IEvaluation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.skuId = _data["skuId"];
            this.evaluationTypeId = _data["evaluationTypeId"];
            this.productTypeId = _data["productTypeId"];
            this.productId = _data["productId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
            this.attemptsAllowed = _data["attemptsAllowed"];
            this.passingScore = _data["passingScore"];
            this.daysAfterCourse = _data["daysAfterCourse"];
            this.evaluationType = _data["evaluationType"] ? EvaluationType.fromJS(_data["evaluationType"]) : undefined as any;
            if (Array.isArray(_data["evaluationQuestions"])) {
                this.evaluationQuestions = [] as any;
                for (let item of _data["evaluationQuestions"])
                    this.evaluationQuestions!.push(EvaluationQuestion.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.enablePrintReference = _data["enablePrintReference"];
            this.hasConfidenceLevels = _data["hasConfidenceLevels"];
            this.organizationName = _data["organizationName"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
        }
    }

    static fromJS(data: any): Evaluation {
        data = typeof data === 'object' ? data : {};
        let result = new Evaluation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["skuId"] = this.skuId;
        data["evaluationTypeId"] = this.evaluationTypeId;
        data["productTypeId"] = this.productTypeId;
        data["productId"] = this.productId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        data["attemptsAllowed"] = this.attemptsAllowed;
        data["passingScore"] = this.passingScore;
        data["daysAfterCourse"] = this.daysAfterCourse;
        data["evaluationType"] = this.evaluationType ? this.evaluationType.toJSON() : undefined as any;
        if (Array.isArray(this.evaluationQuestions)) {
            data["evaluationQuestions"] = [];
            for (let item of this.evaluationQuestions)
                data["evaluationQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        data["isActive"] = this.isActive;
        data["enablePrintReference"] = this.enablePrintReference;
        data["hasConfidenceLevels"] = this.hasConfidenceLevels;
        data["organizationName"] = this.organizationName;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        return data;
    }
}

export interface IEvaluation {
    id?: string | undefined;
    name: string;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    skuId?: string | undefined;
    evaluationTypeId?: string;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    attemptsAllowed?: number | undefined;
    passingScore?: number | undefined;
    daysAfterCourse?: number | undefined;
    evaluationType?: EvaluationType | undefined;
    evaluationQuestions?: EvaluationQuestion[] | undefined;
    isActive?: boolean;
    enablePrintReference?: boolean | undefined;
    hasConfidenceLevels?: boolean;
    organizationName?: string | undefined;
    skuAvailabilityId?: string | undefined;
}

export class EvaluationType implements IEvaluationType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IEvaluationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EvaluationType {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IEvaluationType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
}

export class EvaluationQuestion implements IEvaluationQuestion {
    id?: string | undefined;
    question?: Question | undefined;

    constructor(data?: IEvaluationQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.question = _data["question"] ? Question.fromJS(_data["question"]) : undefined as any;
        }
    }

    static fromJS(data: any): EvaluationQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["question"] = this.question ? this.question.toJSON() : undefined as any;
        return data;
    }
}

export interface IEvaluationQuestion {
    id?: string | undefined;
    question?: Question | undefined;
}

export class ListRequestOfEvaluationFilter implements IListRequestOfEvaluationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: EvaluationFilter | undefined;

    constructor(data?: IListRequestOfEvaluationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? EvaluationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfEvaluationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfEvaluationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfEvaluationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: EvaluationFilter | undefined;
}

export class AdminListRequestOfEvaluationFilter extends ListRequestOfEvaluationFilter implements IAdminListRequestOfEvaluationFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfEvaluationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfEvaluationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfEvaluationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfEvaluationFilter extends IListRequestOfEvaluationFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class EvaluationFilter extends BaseFilter implements IEvaluationFilter {
    evaluationTypeId?: string | undefined;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IEvaluationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.evaluationTypeId = _data["evaluationTypeId"];
            this.productTypeId = _data["productTypeId"];
            this.productId = _data["productId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): EvaluationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationTypeId"] = this.evaluationTypeId;
        data["productTypeId"] = this.productTypeId;
        data["productId"] = this.productId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface IEvaluationFilter extends IBaseFilter {
    evaluationTypeId?: string | undefined;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    isActive?: boolean | undefined;
}

export class ResponseOfEvaluationAndString implements IResponseOfEvaluationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Evaluation | undefined;

    constructor(data?: IResponseOfEvaluationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Evaluation.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfEvaluationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEvaluationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfEvaluationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Evaluation | undefined;
}

export class ResponseOfEvaluation extends ResponseOfEvaluationAndString implements IResponseOfEvaluation {

    constructor(data?: IResponseOfEvaluation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfEvaluation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEvaluation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfEvaluation extends IResponseOfEvaluationAndString {
}

export class ResponseOfIdNameModelAndString implements IResponseOfIdNameModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: IdNameModel | undefined;

    constructor(data?: IResponseOfIdNameModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? IdNameModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfIdNameModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIdNameModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfIdNameModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: IdNameModel | undefined;
}

export class ResponseOfIdNameModel extends ResponseOfIdNameModelAndString implements IResponseOfIdNameModel {

    constructor(data?: IResponseOfIdNameModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfIdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIdNameModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfIdNameModel extends IResponseOfIdNameModelAndString {
}

export class SaveEvaluationRequest implements ISaveEvaluationRequest {
    id?: string | undefined;
    name!: string;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    skuId?: string | undefined;
    evaluationTypeId?: string;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    attemptsAllowed?: number | undefined;
    passingScore?: number | undefined;
    daysAfterCourse?: number | undefined;
    questionIds?: string[] | undefined;
    isActive?: boolean;
    enablePrintReference?: boolean | undefined;
    hasConfidenceLevels?: boolean;
    externalSourceId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    evaluationQuestions?: SaveEvaluationQuestion[] | undefined;

    constructor(data?: ISaveEvaluationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.skuId = _data["skuId"];
            this.evaluationTypeId = _data["evaluationTypeId"];
            this.productTypeId = _data["productTypeId"];
            this.productId = _data["productId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
            this.attemptsAllowed = _data["attemptsAllowed"];
            this.passingScore = _data["passingScore"];
            this.daysAfterCourse = _data["daysAfterCourse"];
            if (Array.isArray(_data["questionIds"])) {
                this.questionIds = [] as any;
                for (let item of _data["questionIds"])
                    this.questionIds!.push(item);
            }
            this.isActive = _data["isActive"];
            this.enablePrintReference = _data["enablePrintReference"];
            this.hasConfidenceLevels = _data["hasConfidenceLevels"];
            this.externalSourceId = _data["externalSourceId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            if (Array.isArray(_data["evaluationQuestions"])) {
                this.evaluationQuestions = [] as any;
                for (let item of _data["evaluationQuestions"])
                    this.evaluationQuestions!.push(SaveEvaluationQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveEvaluationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEvaluationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["skuId"] = this.skuId;
        data["evaluationTypeId"] = this.evaluationTypeId;
        data["productTypeId"] = this.productTypeId;
        data["productId"] = this.productId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        data["attemptsAllowed"] = this.attemptsAllowed;
        data["passingScore"] = this.passingScore;
        data["daysAfterCourse"] = this.daysAfterCourse;
        if (Array.isArray(this.questionIds)) {
            data["questionIds"] = [];
            for (let item of this.questionIds)
                data["questionIds"].push(item);
        }
        data["isActive"] = this.isActive;
        data["enablePrintReference"] = this.enablePrintReference;
        data["hasConfidenceLevels"] = this.hasConfidenceLevels;
        data["externalSourceId"] = this.externalSourceId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        if (Array.isArray(this.evaluationQuestions)) {
            data["evaluationQuestions"] = [];
            for (let item of this.evaluationQuestions)
                data["evaluationQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveEvaluationRequest {
    id?: string | undefined;
    name: string;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    skuId?: string | undefined;
    evaluationTypeId?: string;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    attemptsAllowed?: number | undefined;
    passingScore?: number | undefined;
    daysAfterCourse?: number | undefined;
    questionIds?: string[] | undefined;
    isActive?: boolean;
    enablePrintReference?: boolean | undefined;
    hasConfidenceLevels?: boolean;
    externalSourceId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    evaluationQuestions?: SaveEvaluationQuestion[] | undefined;
}

export class SaveEvaluationQuestion implements ISaveEvaluationQuestion {
    id?: string | undefined;
    questionId?: string;
    sequence?: number;
    deletedDate?: Date | undefined;

    constructor(data?: ISaveEvaluationQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.sequence = _data["sequence"];
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SaveEvaluationQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEvaluationQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["sequence"] = this.sequence;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISaveEvaluationQuestion {
    id?: string | undefined;
    questionId?: string;
    sequence?: number;
    deletedDate?: Date | undefined;
}

export class ResponseOfListOfEvaluationTypeAndString implements IResponseOfListOfEvaluationTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EvaluationType[] | undefined;

    constructor(data?: IResponseOfListOfEvaluationTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EvaluationType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEvaluationTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEvaluationTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEvaluationTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EvaluationType[] | undefined;
}

export class ResponseOfListOfEvaluationType extends ResponseOfListOfEvaluationTypeAndString implements IResponseOfListOfEvaluationType {

    constructor(data?: IResponseOfListOfEvaluationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEvaluationType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEvaluationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEvaluationType extends IResponseOfListOfEvaluationTypeAndString {
}

export class ListResponseOfEvaluationType extends ResponseOfListOfEvaluationType implements IListResponseOfEvaluationType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfEvaluationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfEvaluationType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfEvaluationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfEvaluationType extends IResponseOfListOfEvaluationType {
    totalRecords?: number | undefined;
}

export class ResponseOfEvaluationTypeAndString implements IResponseOfEvaluationTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EvaluationType | undefined;

    constructor(data?: IResponseOfEvaluationTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? EvaluationType.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfEvaluationTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEvaluationTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfEvaluationTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: EvaluationType | undefined;
}

export class ResponseOfEvaluationType extends ResponseOfEvaluationTypeAndString implements IResponseOfEvaluationType {

    constructor(data?: IResponseOfEvaluationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfEvaluationType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfEvaluationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfEvaluationType extends IResponseOfEvaluationTypeAndString {
}

export class ResponseOfListOfSkuEvaluationAndString implements IResponseOfListOfSkuEvaluationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuEvaluation[] | undefined;

    constructor(data?: IResponseOfListOfSkuEvaluationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuEvaluation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuEvaluationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuEvaluationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuEvaluationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuEvaluation[] | undefined;
}

export class ResponseOfListOfSkuEvaluation extends ResponseOfListOfSkuEvaluationAndString implements IResponseOfListOfSkuEvaluation {

    constructor(data?: IResponseOfListOfSkuEvaluation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuEvaluation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuEvaluation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuEvaluation extends IResponseOfListOfSkuEvaluationAndString {
}

export class ListResponseOfSkuEvaluation extends ResponseOfListOfSkuEvaluation implements IListResponseOfSkuEvaluation {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuEvaluation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuEvaluation {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuEvaluation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuEvaluation extends IResponseOfListOfSkuEvaluation {
    totalRecords?: number | undefined;
}

export class SkuEvaluation implements ISkuEvaluation {
    evaluationId?: string;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isDirectSkuAssociation?: boolean;
    organizationId?: string;
    organizationName?: string | undefined;

    constructor(data?: ISkuEvaluation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evaluationId = _data["evaluationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.isDirectSkuAssociation = _data["isDirectSkuAssociation"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): SkuEvaluation {
        data = typeof data === 'object' ? data : {};
        let result = new SkuEvaluation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationId"] = this.evaluationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["isDirectSkuAssociation"] = this.isDirectSkuAssociation;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface ISkuEvaluation {
    evaluationId?: string;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isDirectSkuAssociation?: boolean;
    organizationId?: string;
    organizationName?: string | undefined;
}

export class ResponseOfListOfManualGradingUserExamAndString implements IResponseOfListOfManualGradingUserExamAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ManualGradingUserExam[] | undefined;

    constructor(data?: IResponseOfListOfManualGradingUserExamAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ManualGradingUserExam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfManualGradingUserExamAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfManualGradingUserExamAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfManualGradingUserExamAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ManualGradingUserExam[] | undefined;
}

export class ResponseOfListOfManualGradingUserExam extends ResponseOfListOfManualGradingUserExamAndString implements IResponseOfListOfManualGradingUserExam {

    constructor(data?: IResponseOfListOfManualGradingUserExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfManualGradingUserExam {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfManualGradingUserExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfManualGradingUserExam extends IResponseOfListOfManualGradingUserExamAndString {
}

export class ListResponseOfManualGradingUserExam extends ResponseOfListOfManualGradingUserExam implements IListResponseOfManualGradingUserExam {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfManualGradingUserExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfManualGradingUserExam {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfManualGradingUserExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfManualGradingUserExam extends IResponseOfListOfManualGradingUserExam {
    totalRecords?: number | undefined;
}

export class ManualGradingUserExam implements IManualGradingUserExam {
    id!: string;
    name?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IManualGradingUserExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ManualGradingUserExam {
        data = typeof data === 'object' ? data : {};
        let result = new ManualGradingUserExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["email"] = this.email;
        return data;
    }
}

export interface IManualGradingUserExam {
    id: string;
    name?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
}

export class ResponseOfManualGradingUserExamDetailsAndString implements IResponseOfManualGradingUserExamDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ManualGradingUserExamDetails | undefined;

    constructor(data?: IResponseOfManualGradingUserExamDetailsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ManualGradingUserExamDetails.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfManualGradingUserExamDetailsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfManualGradingUserExamDetailsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfManualGradingUserExamDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ManualGradingUserExamDetails | undefined;
}

export class ResponseOfManualGradingUserExamDetails extends ResponseOfManualGradingUserExamDetailsAndString implements IResponseOfManualGradingUserExamDetails {

    constructor(data?: IResponseOfManualGradingUserExamDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfManualGradingUserExamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfManualGradingUserExamDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfManualGradingUserExamDetails extends IResponseOfManualGradingUserExamDetailsAndString {
}

export class ManualGradingExam implements IManualGradingExam {
    id?: string;
    name?: string | undefined;
    userId?: string;

    constructor(data?: IManualGradingExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ManualGradingExam {
        data = typeof data === 'object' ? data : {};
        let result = new ManualGradingExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IManualGradingExam {
    id?: string;
    name?: string | undefined;
    userId?: string;
}

export class ManualGradingExamDetails extends ManualGradingExam implements IManualGradingExamDetails {
    skuId?: string;
    userSkuId?: string;
    startDateTime?: Date;
    userAnswers?: ManualGradingUserAnswer[] | undefined;

    constructor(data?: IManualGradingExamDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuId = _data["skuId"];
            this.userSkuId = _data["userSkuId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            if (Array.isArray(_data["userAnswers"])) {
                this.userAnswers = [] as any;
                for (let item of _data["userAnswers"])
                    this.userAnswers!.push(ManualGradingUserAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ManualGradingExamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ManualGradingExamDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["userSkuId"] = this.userSkuId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        if (Array.isArray(this.userAnswers)) {
            data["userAnswers"] = [];
            for (let item of this.userAnswers)
                data["userAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IManualGradingExamDetails extends IManualGradingExam {
    skuId?: string;
    userSkuId?: string;
    startDateTime?: Date;
    userAnswers?: ManualGradingUserAnswer[] | undefined;
}

export class ManualGradingUserExamDetails extends ManualGradingExamDetails implements IManualGradingUserExamDetails {
    courseTitle?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    organizationId?: string;

    constructor(data?: IManualGradingUserExamDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.courseTitle = _data["courseTitle"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): ManualGradingUserExamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ManualGradingUserExamDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseTitle"] = this.courseTitle;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IManualGradingUserExamDetails extends IManualGradingExamDetails {
    courseTitle?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    organizationId?: string;
}

export class ManualGradingUserAnswer implements IManualGradingUserAnswer {
    id?: string;
    questionTypeId?: string;
    question?: string | undefined;
    expectedAnswer?: string | undefined;
    userAnswer?: string | undefined;
    fileUrl?: string | undefined;
    fileName?: string | undefined;
    sequence?: number;

    constructor(data?: IManualGradingUserAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionTypeId = _data["questionTypeId"];
            this.question = _data["question"];
            this.expectedAnswer = _data["expectedAnswer"];
            this.userAnswer = _data["userAnswer"];
            this.fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): ManualGradingUserAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ManualGradingUserAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionTypeId"] = this.questionTypeId;
        data["question"] = this.question;
        data["expectedAnswer"] = this.expectedAnswer;
        data["userAnswer"] = this.userAnswer;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IManualGradingUserAnswer {
    id?: string;
    questionTypeId?: string;
    question?: string | undefined;
    expectedAnswer?: string | undefined;
    userAnswer?: string | undefined;
    fileUrl?: string | undefined;
    fileName?: string | undefined;
    sequence?: number;
}

export class SubmitExamResponse implements ISubmitExamResponse {
    examId?: string;
    isGradingPending?: boolean;
    score?: number;
    passed?: boolean;
    availableAttempts?: number | undefined;
    wrongAnswers?: EvaluationQuestionAnswer2[] | undefined;

    constructor(data?: ISubmitExamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.isGradingPending = _data["isGradingPending"];
            this.score = _data["score"];
            this.passed = _data["passed"];
            this.availableAttempts = _data["availableAttempts"];
            if (Array.isArray(_data["wrongAnswers"])) {
                this.wrongAnswers = [] as any;
                for (let item of _data["wrongAnswers"])
                    this.wrongAnswers!.push(EvaluationQuestionAnswer2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitExamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitExamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["isGradingPending"] = this.isGradingPending;
        data["score"] = this.score;
        data["passed"] = this.passed;
        data["availableAttempts"] = this.availableAttempts;
        if (Array.isArray(this.wrongAnswers)) {
            data["wrongAnswers"] = [];
            for (let item of this.wrongAnswers)
                data["wrongAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubmitExamResponse {
    examId?: string;
    isGradingPending?: boolean;
    score?: number;
    passed?: boolean;
    availableAttempts?: number | undefined;
    wrongAnswers?: EvaluationQuestionAnswer2[] | undefined;
}

export class EvaluationQuestionAnswer2 implements IEvaluationQuestionAnswer2 {
    id?: string | undefined;
    sequence?: number;
    isAnswer?: boolean;
    value?: string | undefined;
    questionId?: string | undefined;
    externalSourceId?: string | undefined;
    evaluationQuestionId?: string | undefined;
    isSelectedAnswer?: boolean;

    constructor(data?: IEvaluationQuestionAnswer2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequence = _data["sequence"];
            this.isAnswer = _data["isAnswer"];
            this.value = _data["value"];
            this.questionId = _data["questionId"];
            this.externalSourceId = _data["externalSourceId"];
            this.evaluationQuestionId = _data["evaluationQuestionId"];
            this.isSelectedAnswer = _data["isSelectedAnswer"];
        }
    }

    static fromJS(data: any): EvaluationQuestionAnswer2 {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationQuestionAnswer2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequence"] = this.sequence;
        data["isAnswer"] = this.isAnswer;
        data["value"] = this.value;
        data["questionId"] = this.questionId;
        data["externalSourceId"] = this.externalSourceId;
        data["evaluationQuestionId"] = this.evaluationQuestionId;
        data["isSelectedAnswer"] = this.isSelectedAnswer;
        return data;
    }
}

export interface IEvaluationQuestionAnswer2 {
    id?: string | undefined;
    sequence?: number;
    isAnswer?: boolean;
    value?: string | undefined;
    questionId?: string | undefined;
    externalSourceId?: string | undefined;
    evaluationQuestionId?: string | undefined;
    isSelectedAnswer?: boolean;
}

export class UserScopeRequest implements IUserScopeRequest {
    userId!: string;
    organizationId!: string;

    constructor(data?: IUserScopeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): UserScopeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserScopeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IUserScopeRequest {
    userId: string;
    organizationId: string;
}

export class SubmitManualGradingExamRequest extends UserScopeRequest implements ISubmitManualGradingExamRequest {
    answerGrades?: UserAnswerGrade[] | undefined;

    constructor(data?: ISubmitManualGradingExamRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["answerGrades"])) {
                this.answerGrades = [] as any;
                for (let item of _data["answerGrades"])
                    this.answerGrades!.push(UserAnswerGrade.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SubmitManualGradingExamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitManualGradingExamRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answerGrades)) {
            data["answerGrades"] = [];
            for (let item of this.answerGrades)
                data["answerGrades"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitManualGradingExamRequest extends IUserScopeRequest {
    answerGrades?: UserAnswerGrade[] | undefined;
}

export class UserAnswerGrade implements IUserAnswerGrade {
    id?: string;
    isCorrect?: boolean;
    feedback?: string | undefined;

    constructor(data?: IUserAnswerGrade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCorrect = _data["isCorrect"];
            this.feedback = _data["feedback"];
        }
    }

    static fromJS(data: any): UserAnswerGrade {
        data = typeof data === 'object' ? data : {};
        let result = new UserAnswerGrade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCorrect"] = this.isCorrect;
        data["feedback"] = this.feedback;
        return data;
    }
}

export interface IUserAnswerGrade {
    id?: string;
    isCorrect?: boolean;
    feedback?: string | undefined;
}

export class ResponseOfListOfExamAttemptAndString implements IResponseOfListOfExamAttemptAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ExamAttempt[] | undefined;

    constructor(data?: IResponseOfListOfExamAttemptAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExamAttempt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfExamAttemptAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfExamAttemptAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfExamAttemptAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ExamAttempt[] | undefined;
}

export class ResponseOfListOfExamAttempt extends ResponseOfListOfExamAttemptAndString implements IResponseOfListOfExamAttempt {

    constructor(data?: IResponseOfListOfExamAttempt) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfExamAttempt {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfExamAttempt();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfExamAttempt extends IResponseOfListOfExamAttemptAndString {
}

export class ListResponseOfExamAttempt extends ResponseOfListOfExamAttempt implements IListResponseOfExamAttempt {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfExamAttempt) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfExamAttempt {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfExamAttempt();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfExamAttempt extends IResponseOfListOfExamAttempt {
    totalRecords?: number | undefined;
}

export class ExamAttempt implements IExamAttempt {
    id!: string;
    userSkuId?: string;
    examId?: string;
    startDateTime?: Date;
    endDateTime?: Date | undefined;
    score?: number | undefined;
    examPassed?: boolean | undefined;
    status?: string | undefined;
    userEvaluationStatusId?: string;

    constructor(data?: IExamAttempt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userSkuId = _data["userSkuId"];
            this.examId = _data["examId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.score = _data["score"];
            this.examPassed = _data["examPassed"];
            this.status = _data["status"];
            this.userEvaluationStatusId = _data["userEvaluationStatusId"];
        }
    }

    static fromJS(data: any): ExamAttempt {
        data = typeof data === 'object' ? data : {};
        let result = new ExamAttempt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userSkuId"] = this.userSkuId;
        data["examId"] = this.examId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["score"] = this.score;
        data["examPassed"] = this.examPassed;
        data["status"] = this.status;
        data["userEvaluationStatusId"] = this.userEvaluationStatusId;
        return data;
    }
}

export interface IExamAttempt {
    id: string;
    userSkuId?: string;
    examId?: string;
    startDateTime?: Date;
    endDateTime?: Date | undefined;
    score?: number | undefined;
    examPassed?: boolean | undefined;
    status?: string | undefined;
    userEvaluationStatusId?: string;
}

export class ListRequestOfExamAttemptFilter implements IListRequestOfExamAttemptFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ExamAttemptFilter | undefined;

    constructor(data?: IListRequestOfExamAttemptFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ExamAttemptFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfExamAttemptFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfExamAttemptFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfExamAttemptFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ExamAttemptFilter | undefined;
}

export class ExamAttemptFilter extends BaseFilter implements IExamAttemptFilter {
    userSkuId?: string;

    constructor(data?: IExamAttemptFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userSkuId = _data["userSkuId"];
        }
    }

    static override fromJS(data: any): ExamAttemptFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ExamAttemptFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSkuId"] = this.userSkuId;
        super.toJSON(data);
        return data;
    }
}

export interface IExamAttemptFilter extends IBaseFilter {
    userSkuId?: string;
}

export class ResponseOfExamAttemptDetailsAndString implements IResponseOfExamAttemptDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ExamAttemptDetails | undefined;

    constructor(data?: IResponseOfExamAttemptDetailsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ExamAttemptDetails.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfExamAttemptDetailsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfExamAttemptDetailsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfExamAttemptDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ExamAttemptDetails | undefined;
}

export class ResponseOfExamAttemptDetails extends ResponseOfExamAttemptDetailsAndString implements IResponseOfExamAttemptDetails {

    constructor(data?: IResponseOfExamAttemptDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfExamAttemptDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfExamAttemptDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfExamAttemptDetails extends IResponseOfExamAttemptDetailsAndString {
}

export class ExamAttemptDetails implements IExamAttemptDetails {
    examName?: string | undefined;
    attemptDate?: Date | undefined;
    score?: number;
    passingScore?: number;
    questions?: ExamAttemptQuestion[] | undefined;

    constructor(data?: IExamAttemptDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examName = _data["examName"];
            this.attemptDate = _data["attemptDate"] ? new Date(_data["attemptDate"].toString()) : undefined as any;
            this.score = _data["score"];
            this.passingScore = _data["passingScore"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ExamAttemptQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamAttemptDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamAttemptDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examName"] = this.examName;
        data["attemptDate"] = this.attemptDate ? this.attemptDate.toISOString() : undefined as any;
        data["score"] = this.score;
        data["passingScore"] = this.passingScore;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamAttemptDetails {
    examName?: string | undefined;
    attemptDate?: Date | undefined;
    score?: number;
    passingScore?: number;
    questions?: ExamAttemptQuestion[] | undefined;
}

export class ExamAttemptQuestion implements IExamAttemptQuestion {
    id?: string;
    title?: string | undefined;
    sequence?: number;
    questionType?: QuestionType | undefined;
    scored?: boolean | undefined;
    answers?: ExamAttemptQuestionAnswer[] | undefined;
    userAnswers?: ExamAttemptQuestionAnswer[] | undefined;

    constructor(data?: IExamAttemptQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.sequence = _data["sequence"];
            this.questionType = _data["questionType"] ? QuestionType.fromJS(_data["questionType"]) : undefined as any;
            this.scored = _data["scored"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ExamAttemptQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["userAnswers"])) {
                this.userAnswers = [] as any;
                for (let item of _data["userAnswers"])
                    this.userAnswers!.push(ExamAttemptQuestionAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamAttemptQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ExamAttemptQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["sequence"] = this.sequence;
        data["questionType"] = this.questionType ? this.questionType.toJSON() : undefined as any;
        data["scored"] = this.scored;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userAnswers)) {
            data["userAnswers"] = [];
            for (let item of this.userAnswers)
                data["userAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamAttemptQuestion {
    id?: string;
    title?: string | undefined;
    sequence?: number;
    questionType?: QuestionType | undefined;
    scored?: boolean | undefined;
    answers?: ExamAttemptQuestionAnswer[] | undefined;
    userAnswers?: ExamAttemptQuestionAnswer[] | undefined;
}

export class ExamAttemptQuestionAnswer implements IExamAttemptQuestionAnswer {
    id?: string | undefined;
    sequence?: number;
    value?: string | undefined;
    isAnswer?: boolean | undefined;
    evaluationQuestionId?: string;
    userEvaluationQuestionScore?: number | undefined;

    constructor(data?: IExamAttemptQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequence = _data["sequence"];
            this.value = _data["value"];
            this.isAnswer = _data["isAnswer"];
            this.evaluationQuestionId = _data["evaluationQuestionId"];
            this.userEvaluationQuestionScore = _data["userEvaluationQuestionScore"];
        }
    }

    static fromJS(data: any): ExamAttemptQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ExamAttemptQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequence"] = this.sequence;
        data["value"] = this.value;
        data["isAnswer"] = this.isAnswer;
        data["evaluationQuestionId"] = this.evaluationQuestionId;
        data["userEvaluationQuestionScore"] = this.userEvaluationQuestionScore;
        return data;
    }
}

export interface IExamAttemptQuestionAnswer {
    id?: string | undefined;
    sequence?: number;
    value?: string | undefined;
    isAnswer?: boolean | undefined;
    evaluationQuestionId?: string;
    userEvaluationQuestionScore?: number | undefined;
}

export class ResponseOfExamAndString implements IResponseOfExamAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Exam | undefined;

    constructor(data?: IResponseOfExamAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Exam.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfExamAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfExamAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfExamAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Exam | undefined;
}

export class ResponseOfExam extends ResponseOfExamAndString implements IResponseOfExam {

    constructor(data?: IResponseOfExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfExam {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfExam extends IResponseOfExamAndString {
}

export abstract class BaseEvaluation implements IBaseEvaluation {
    id?: string | undefined;
    name!: string;
    description?: string | undefined;
    value?: string | undefined;
    questions?: Question2[] | undefined;
    organizationId?: string;
    skuId?: string | undefined;
    hasConfidenceLevels?: boolean;
    evaluationTypeId?: string;

    constructor(data?: IBaseEvaluation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question2.fromJS(item));
            }
            this.organizationId = _data["organizationId"];
            this.skuId = _data["skuId"];
            this.hasConfidenceLevels = _data["hasConfidenceLevels"];
            this.evaluationTypeId = _data["evaluationTypeId"];
        }
    }

    static fromJS(data: any): BaseEvaluation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEvaluation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        data["organizationId"] = this.organizationId;
        data["skuId"] = this.skuId;
        data["hasConfidenceLevels"] = this.hasConfidenceLevels;
        data["evaluationTypeId"] = this.evaluationTypeId;
        return data;
    }
}

export interface IBaseEvaluation {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    value?: string | undefined;
    questions?: Question2[] | undefined;
    organizationId?: string;
    skuId?: string | undefined;
    hasConfidenceLevels?: boolean;
    evaluationTypeId?: string;
}

export class Exam extends BaseEvaluation implements IExam {
    updatedBy?: string | undefined;
    attemptsAllowed?: number | undefined;
    passingScore?: number | undefined;
    userSkuId?: string;
    examId?: string;
    startDateTime?: Date;
    endDateTime?: Date | undefined;
    isAlreadySubmitted?: boolean;
    isMaxAttemptsReached?: boolean;
    availableAttempts?: number | undefined;
    enablePrintReference?: boolean | undefined;

    constructor(data?: IExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updatedBy = _data["updatedBy"];
            this.attemptsAllowed = _data["attemptsAllowed"];
            this.passingScore = _data["passingScore"];
            this.userSkuId = _data["userSkuId"];
            this.examId = _data["examId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.isAlreadySubmitted = _data["isAlreadySubmitted"];
            this.isMaxAttemptsReached = _data["isMaxAttemptsReached"];
            this.availableAttempts = _data["availableAttempts"];
            this.enablePrintReference = _data["enablePrintReference"];
        }
    }

    static override fromJS(data: any): Exam {
        data = typeof data === 'object' ? data : {};
        let result = new Exam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedBy"] = this.updatedBy;
        data["attemptsAllowed"] = this.attemptsAllowed;
        data["passingScore"] = this.passingScore;
        data["userSkuId"] = this.userSkuId;
        data["examId"] = this.examId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["isAlreadySubmitted"] = this.isAlreadySubmitted;
        data["isMaxAttemptsReached"] = this.isMaxAttemptsReached;
        data["availableAttempts"] = this.availableAttempts;
        data["enablePrintReference"] = this.enablePrintReference;
        super.toJSON(data);
        return data;
    }
}

export interface IExam extends IBaseEvaluation {
    updatedBy?: string | undefined;
    attemptsAllowed?: number | undefined;
    passingScore?: number | undefined;
    userSkuId?: string;
    examId?: string;
    startDateTime?: Date;
    endDateTime?: Date | undefined;
    isAlreadySubmitted?: boolean;
    isMaxAttemptsReached?: boolean;
    availableAttempts?: number | undefined;
    enablePrintReference?: boolean | undefined;
}

export class Question2 implements IQuestion2 {
    id?: string | undefined;
    value!: string;
    answerId?: string | undefined;
    answerText?: string | undefined;
    confidenceLevelAnswerId?: string | undefined;
    required?: boolean;
    sequence?: number;
    deleted?: boolean;
    hasConfidenceLevels?: boolean;
    createdOn?: Date;
    questionType?: QuestionType2 | undefined;
    questionTypeId?: string;
    ratingSetting?: RatingSetting2 | undefined;
    answers?: EvaluationQuestionAnswer2[] | undefined;
    evaluationQuestionsCount?: number | undefined;
    confidenceLevelAnswers?: ConfidenceLevelAnswer[] | undefined;
    objectiveQuestions?: ObjectiveQuestion[] | undefined;
    correctAnswersLetters?: string | undefined;
    externalSourceId?: string | undefined;
    questionId?: string | undefined;
    questionFeedback?: string | undefined;

    constructor(data?: IQuestion2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.answerId = _data["answerId"];
            this.answerText = _data["answerText"];
            this.confidenceLevelAnswerId = _data["confidenceLevelAnswerId"];
            this.required = _data["required"];
            this.sequence = _data["sequence"];
            this.deleted = _data["deleted"];
            this.hasConfidenceLevels = _data["hasConfidenceLevels"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.questionType = _data["questionType"] ? QuestionType2.fromJS(_data["questionType"]) : undefined as any;
            this.questionTypeId = _data["questionTypeId"];
            this.ratingSetting = _data["ratingSetting"] ? RatingSetting2.fromJS(_data["ratingSetting"]) : undefined as any;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(EvaluationQuestionAnswer2.fromJS(item));
            }
            this.evaluationQuestionsCount = _data["evaluationQuestionsCount"];
            if (Array.isArray(_data["confidenceLevelAnswers"])) {
                this.confidenceLevelAnswers = [] as any;
                for (let item of _data["confidenceLevelAnswers"])
                    this.confidenceLevelAnswers!.push(ConfidenceLevelAnswer.fromJS(item));
            }
            if (Array.isArray(_data["objectiveQuestions"])) {
                this.objectiveQuestions = [] as any;
                for (let item of _data["objectiveQuestions"])
                    this.objectiveQuestions!.push(ObjectiveQuestion.fromJS(item));
            }
            this.correctAnswersLetters = _data["correctAnswersLetters"];
            this.externalSourceId = _data["externalSourceId"];
            this.questionId = _data["questionId"];
            this.questionFeedback = _data["questionFeedback"];
        }
    }

    static fromJS(data: any): Question2 {
        data = typeof data === 'object' ? data : {};
        let result = new Question2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["answerId"] = this.answerId;
        data["answerText"] = this.answerText;
        data["confidenceLevelAnswerId"] = this.confidenceLevelAnswerId;
        data["required"] = this.required;
        data["sequence"] = this.sequence;
        data["deleted"] = this.deleted;
        data["hasConfidenceLevels"] = this.hasConfidenceLevels;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["questionType"] = this.questionType ? this.questionType.toJSON() : undefined as any;
        data["questionTypeId"] = this.questionTypeId;
        data["ratingSetting"] = this.ratingSetting ? this.ratingSetting.toJSON() : undefined as any;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["evaluationQuestionsCount"] = this.evaluationQuestionsCount;
        if (Array.isArray(this.confidenceLevelAnswers)) {
            data["confidenceLevelAnswers"] = [];
            for (let item of this.confidenceLevelAnswers)
                data["confidenceLevelAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.objectiveQuestions)) {
            data["objectiveQuestions"] = [];
            for (let item of this.objectiveQuestions)
                data["objectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        data["correctAnswersLetters"] = this.correctAnswersLetters;
        data["externalSourceId"] = this.externalSourceId;
        data["questionId"] = this.questionId;
        data["questionFeedback"] = this.questionFeedback;
        return data;
    }
}

export interface IQuestion2 {
    id?: string | undefined;
    value: string;
    answerId?: string | undefined;
    answerText?: string | undefined;
    confidenceLevelAnswerId?: string | undefined;
    required?: boolean;
    sequence?: number;
    deleted?: boolean;
    hasConfidenceLevels?: boolean;
    createdOn?: Date;
    questionType?: QuestionType2 | undefined;
    questionTypeId?: string;
    ratingSetting?: RatingSetting2 | undefined;
    answers?: EvaluationQuestionAnswer2[] | undefined;
    evaluationQuestionsCount?: number | undefined;
    confidenceLevelAnswers?: ConfidenceLevelAnswer[] | undefined;
    objectiveQuestions?: ObjectiveQuestion[] | undefined;
    correctAnswersLetters?: string | undefined;
    externalSourceId?: string | undefined;
    questionId?: string | undefined;
    questionFeedback?: string | undefined;
}

export class QuestionType2 implements IQuestionType2 {
    id?: string | undefined;
    name!: string;
    value?: string | undefined;
    description?: string | undefined;
    gradingType?: QuestionGradingType;
    fileType?: FileType | undefined;

    constructor(data?: IQuestionType2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.gradingType = _data["gradingType"];
            this.fileType = _data["fileType"] ? FileType.fromJS(_data["fileType"]) : undefined as any;
        }
    }

    static fromJS(data: any): QuestionType2 {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionType2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["gradingType"] = this.gradingType;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : undefined as any;
        return data;
    }
}

export interface IQuestionType2 {
    id?: string | undefined;
    name: string;
    value?: string | undefined;
    description?: string | undefined;
    gradingType?: QuestionGradingType;
    fileType?: FileType | undefined;
}

export class FileType implements IFileType {
    acceptedFileExtensions?: string | undefined;
    maxFileSizeMb?: number;

    constructor(data?: IFileType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acceptedFileExtensions = _data["acceptedFileExtensions"];
            this.maxFileSizeMb = _data["maxFileSizeMb"];
        }
    }

    static fromJS(data: any): FileType {
        data = typeof data === 'object' ? data : {};
        let result = new FileType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptedFileExtensions"] = this.acceptedFileExtensions;
        data["maxFileSizeMb"] = this.maxFileSizeMb;
        return data;
    }
}

export interface IFileType {
    acceptedFileExtensions?: string | undefined;
    maxFileSizeMb?: number;
}

export class RatingSetting2 implements IRatingSetting2 {
    id?: string | undefined;
    name?: string | undefined;
    minValueText?: string | undefined;
    maxValueText?: string | undefined;
    optionCount?: number;

    constructor(data?: IRatingSetting2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.minValueText = _data["minValueText"];
            this.maxValueText = _data["maxValueText"];
            this.optionCount = _data["optionCount"];
        }
    }

    static fromJS(data: any): RatingSetting2 {
        data = typeof data === 'object' ? data : {};
        let result = new RatingSetting2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["minValueText"] = this.minValueText;
        data["maxValueText"] = this.maxValueText;
        data["optionCount"] = this.optionCount;
        return data;
    }
}

export interface IRatingSetting2 {
    id?: string | undefined;
    name?: string | undefined;
    minValueText?: string | undefined;
    maxValueText?: string | undefined;
    optionCount?: number;
}

export class ConfidenceLevelAnswer implements IConfidenceLevelAnswer {
    id?: string;
    name?: string | undefined;
    sequence?: number;

    constructor(data?: IConfidenceLevelAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): ConfidenceLevelAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ConfidenceLevelAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IConfidenceLevelAnswer {
    id?: string;
    name?: string | undefined;
    sequence?: number;
}

export class ObjectiveQuestion implements IObjectiveQuestion {
    professionId?: string;

    constructor(data?: IObjectiveQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): ObjectiveQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface IObjectiveQuestion {
    professionId?: string;
}

export class ActiveExamRequest implements IActiveExamRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;

    constructor(data?: IActiveExamRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ActiveExamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveExamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IActiveExamRequest {
    skuId?: string;
    userId?: string;
    organizationId?: string;
}

export class InvalidateExamAttemptRequest implements IInvalidateExamAttemptRequest {
    userId?: string;
    organizationId?: string;
    userEvaluationId?: string;

    constructor(data?: IInvalidateExamAttemptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.userEvaluationId = _data["userEvaluationId"];
        }
    }

    static fromJS(data: any): InvalidateExamAttemptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvalidateExamAttemptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["userEvaluationId"] = this.userEvaluationId;
        return data;
    }
}

export interface IInvalidateExamAttemptRequest {
    userId?: string;
    organizationId?: string;
    userEvaluationId?: string;
}

export class ResponseOfListOfProductDeliverableInfoAndString implements IResponseOfListOfProductDeliverableInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductDeliverableInfo[] | undefined;

    constructor(data?: IResponseOfListOfProductDeliverableInfoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductDeliverableInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProductDeliverableInfoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductDeliverableInfoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProductDeliverableInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductDeliverableInfo[] | undefined;
}

export class ResponseOfListOfProductDeliverableInfo extends ResponseOfListOfProductDeliverableInfoAndString implements IResponseOfListOfProductDeliverableInfo {

    constructor(data?: IResponseOfListOfProductDeliverableInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProductDeliverableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductDeliverableInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProductDeliverableInfo extends IResponseOfListOfProductDeliverableInfoAndString {
}

export class ListResponseOfProductDeliverableInfo extends ResponseOfListOfProductDeliverableInfo implements IListResponseOfProductDeliverableInfo {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProductDeliverableInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProductDeliverableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProductDeliverableInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProductDeliverableInfo extends IResponseOfListOfProductDeliverableInfo {
    totalRecords?: number | undefined;
}

export class BaseDeliverableInfo implements IBaseDeliverableInfo {
    deliverableId?: string;
    deliveryMethodName?: string | undefined;
    deliveryMethodId?: string;
    deliverableTypeId?: string;
    sequence?: number;
    displayText?: string | undefined;
    description?: string | undefined;
    settingValues?: DeliveryMethodSettingValue[] | undefined;

    constructor(data?: IBaseDeliverableInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliverableId = _data["deliverableId"];
            this.deliveryMethodName = _data["deliveryMethodName"];
            this.deliveryMethodId = _data["deliveryMethodId"];
            this.deliverableTypeId = _data["deliverableTypeId"];
            this.sequence = _data["sequence"];
            this.displayText = _data["displayText"];
            this.description = _data["description"];
            if (Array.isArray(_data["settingValues"])) {
                this.settingValues = [] as any;
                for (let item of _data["settingValues"])
                    this.settingValues!.push(DeliveryMethodSettingValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseDeliverableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BaseDeliverableInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliverableId"] = this.deliverableId;
        data["deliveryMethodName"] = this.deliveryMethodName;
        data["deliveryMethodId"] = this.deliveryMethodId;
        data["deliverableTypeId"] = this.deliverableTypeId;
        data["sequence"] = this.sequence;
        data["displayText"] = this.displayText;
        data["description"] = this.description;
        if (Array.isArray(this.settingValues)) {
            data["settingValues"] = [];
            for (let item of this.settingValues)
                data["settingValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBaseDeliverableInfo {
    deliverableId?: string;
    deliveryMethodName?: string | undefined;
    deliveryMethodId?: string;
    deliverableTypeId?: string;
    sequence?: number;
    displayText?: string | undefined;
    description?: string | undefined;
    settingValues?: DeliveryMethodSettingValue[] | undefined;
}

export class ProductDeliverableInfo extends BaseDeliverableInfo implements IProductDeliverableInfo {
    id?: string;
    productId?: string;

    constructor(data?: IProductDeliverableInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
        }
    }

    static override fromJS(data: any): ProductDeliverableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDeliverableInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        super.toJSON(data);
        return data;
    }
}

export interface IProductDeliverableInfo extends IBaseDeliverableInfo {
    id?: string;
    productId?: string;
}

export class DeliveryMethodSettingValue implements IDeliveryMethodSettingValue {
    id?: string | undefined;
    applicationId?: string | undefined;
    organizationId?: string | undefined;
    value?: string | undefined;
    setting?: DeliveryMethodSetting | undefined;

    constructor(data?: IDeliveryMethodSettingValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
            this.value = _data["value"];
            this.setting = _data["setting"] ? DeliveryMethodSetting.fromJS(_data["setting"]) : undefined as any;
        }
    }

    static fromJS(data: any): DeliveryMethodSettingValue {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryMethodSettingValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        data["value"] = this.value;
        data["setting"] = this.setting ? this.setting.toJSON() : undefined as any;
        return data;
    }
}

export interface IDeliveryMethodSettingValue {
    id?: string | undefined;
    applicationId?: string | undefined;
    organizationId?: string | undefined;
    value?: string | undefined;
    setting?: DeliveryMethodSetting | undefined;
}

export class DeliveryMethodSetting implements IDeliveryMethodSetting {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;
    overridable?: boolean;
    typeId?: string | undefined;
    dataTypeName?: string | undefined;
    dataTypeId?: string;
    sequence?: number;

    constructor(data?: IDeliveryMethodSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.codeConstant = _data["codeConstant"];
            this.overridable = _data["overridable"];
            this.typeId = _data["typeId"];
            this.dataTypeName = _data["dataTypeName"];
            this.dataTypeId = _data["dataTypeId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): DeliveryMethodSetting {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryMethodSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["codeConstant"] = this.codeConstant;
        data["overridable"] = this.overridable;
        data["typeId"] = this.typeId;
        data["dataTypeName"] = this.dataTypeName;
        data["dataTypeId"] = this.dataTypeId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IDeliveryMethodSetting {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;
    overridable?: boolean;
    typeId?: string | undefined;
    dataTypeName?: string | undefined;
    dataTypeId?: string;
    sequence?: number;
}

export class ListRequestOfProductDeliverableFilter implements IListRequestOfProductDeliverableFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProductDeliverableFilter | undefined;

    constructor(data?: IListRequestOfProductDeliverableFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ProductDeliverableFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfProductDeliverableFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfProductDeliverableFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfProductDeliverableFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProductDeliverableFilter | undefined;
}

export class ProductDeliverableFilter extends BaseFilter implements IProductDeliverableFilter {
    deliveryMethods?: DeliveryMethod[] | undefined;
    deliverableTypeIds?: string[] | undefined;

    constructor(data?: IProductDeliverableFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["deliveryMethods"])) {
                this.deliveryMethods = [] as any;
                for (let item of _data["deliveryMethods"])
                    this.deliveryMethods!.push(item);
            }
            if (Array.isArray(_data["deliverableTypeIds"])) {
                this.deliverableTypeIds = [] as any;
                for (let item of _data["deliverableTypeIds"])
                    this.deliverableTypeIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): ProductDeliverableFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDeliverableFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deliveryMethods)) {
            data["deliveryMethods"] = [];
            for (let item of this.deliveryMethods)
                data["deliveryMethods"].push(item);
        }
        if (Array.isArray(this.deliverableTypeIds)) {
            data["deliverableTypeIds"] = [];
            for (let item of this.deliverableTypeIds)
                data["deliverableTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProductDeliverableFilter extends IBaseFilter {
    deliveryMethods?: DeliveryMethod[] | undefined;
    deliverableTypeIds?: string[] | undefined;
}

export enum DeliveryMethod {
    Url = "Url",
    ArcheMedX = "ArcheMedX",
    Zoom = "Zoom",
    HandoutFile = "HandoutFile",
    Video = "Video",
    ArticulateRise = "ArticulateRise",
    Pdf = "Pdf",
    ThreePlayMedia = "ThreePlayMedia",
    InfographEd = "InfographEd",
    ISpring = "ISpring",
    Vimeo = "Vimeo",
    Page = "Page",
    Blubrry = "Blubrry",
    INXPO = "INXPO",
    Copient = "Copient",
    AnatomyTv = "AnatomyTv",
}

export class SaveProductDeliverableRequest implements ISaveProductDeliverableRequest {
    id?: string | undefined;
    productId!: string;
    deliverableId!: string;
    sequence?: number;

    constructor(data?: ISaveProductDeliverableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.deliverableId = _data["deliverableId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): SaveProductDeliverableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductDeliverableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["deliverableId"] = this.deliverableId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface ISaveProductDeliverableRequest {
    id?: string | undefined;
    productId: string;
    deliverableId: string;
    sequence?: number;
}

export class ResponseOfListOfSkuDeliverableInfoAndString implements IResponseOfListOfSkuDeliverableInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuDeliverableInfo[] | undefined;

    constructor(data?: IResponseOfListOfSkuDeliverableInfoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuDeliverableInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuDeliverableInfoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuDeliverableInfoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuDeliverableInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuDeliverableInfo[] | undefined;
}

export class ResponseOfListOfSkuDeliverableInfo extends ResponseOfListOfSkuDeliverableInfoAndString implements IResponseOfListOfSkuDeliverableInfo {

    constructor(data?: IResponseOfListOfSkuDeliverableInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuDeliverableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuDeliverableInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuDeliverableInfo extends IResponseOfListOfSkuDeliverableInfoAndString {
}

export class ListResponseOfSkuDeliverableInfo extends ResponseOfListOfSkuDeliverableInfo implements IListResponseOfSkuDeliverableInfo {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuDeliverableInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuDeliverableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuDeliverableInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuDeliverableInfo extends IResponseOfListOfSkuDeliverableInfo {
    totalRecords?: number | undefined;
}

export class SkuDeliverableInfo extends BaseDeliverableInfo implements ISkuDeliverableInfo {
    skuDeliverableId?: string;
    skuId?: string;
    externalSourceId?: string | undefined;
    deliveryMethodCapabilities?: DeliveryMethodCapabilities | undefined;

    constructor(data?: ISkuDeliverableInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuDeliverableId = _data["skuDeliverableId"];
            this.skuId = _data["skuId"];
            this.externalSourceId = _data["externalSourceId"];
            this.deliveryMethodCapabilities = _data["deliveryMethodCapabilities"] ? DeliveryMethodCapabilities.fromJS(_data["deliveryMethodCapabilities"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SkuDeliverableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SkuDeliverableInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuDeliverableId"] = this.skuDeliverableId;
        data["skuId"] = this.skuId;
        data["externalSourceId"] = this.externalSourceId;
        data["deliveryMethodCapabilities"] = this.deliveryMethodCapabilities ? this.deliveryMethodCapabilities.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuDeliverableInfo extends IBaseDeliverableInfo {
    skuDeliverableId?: string;
    skuId?: string;
    externalSourceId?: string | undefined;
    deliveryMethodCapabilities?: DeliveryMethodCapabilities | undefined;
}

export class DeliveryMethodCapabilities implements IDeliveryMethodCapabilities {
    isLiveEvent?: boolean;
    requiresAttendanceProcessing?: boolean;
    requiresLobbyPage?: boolean;
    supportsPreEvaluation?: boolean;
    supportsPostEvaluation?: boolean;

    constructor(data?: IDeliveryMethodCapabilities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLiveEvent = _data["isLiveEvent"];
            this.requiresAttendanceProcessing = _data["requiresAttendanceProcessing"];
            this.requiresLobbyPage = _data["requiresLobbyPage"];
            this.supportsPreEvaluation = _data["supportsPreEvaluation"];
            this.supportsPostEvaluation = _data["supportsPostEvaluation"];
        }
    }

    static fromJS(data: any): DeliveryMethodCapabilities {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryMethodCapabilities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLiveEvent"] = this.isLiveEvent;
        data["requiresAttendanceProcessing"] = this.requiresAttendanceProcessing;
        data["requiresLobbyPage"] = this.requiresLobbyPage;
        data["supportsPreEvaluation"] = this.supportsPreEvaluation;
        data["supportsPostEvaluation"] = this.supportsPostEvaluation;
        return data;
    }
}

export interface IDeliveryMethodCapabilities {
    isLiveEvent?: boolean;
    requiresAttendanceProcessing?: boolean;
    requiresLobbyPage?: boolean;
    supportsPreEvaluation?: boolean;
    supportsPostEvaluation?: boolean;
}

export class ListRequestOfSkuDeliverableFilter implements IListRequestOfSkuDeliverableFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuDeliverableFilter | undefined;

    constructor(data?: IListRequestOfSkuDeliverableFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuDeliverableFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuDeliverableFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuDeliverableFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuDeliverableFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuDeliverableFilter | undefined;
}

export class SkuDeliverableFilter extends BaseFilter implements ISkuDeliverableFilter {
    deliveryMethodIds?: string[] | undefined;
    deliverableTypeIds?: string[] | undefined;

    constructor(data?: ISkuDeliverableFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["deliveryMethodIds"])) {
                this.deliveryMethodIds = [] as any;
                for (let item of _data["deliveryMethodIds"])
                    this.deliveryMethodIds!.push(item);
            }
            if (Array.isArray(_data["deliverableTypeIds"])) {
                this.deliverableTypeIds = [] as any;
                for (let item of _data["deliverableTypeIds"])
                    this.deliverableTypeIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): SkuDeliverableFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuDeliverableFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deliveryMethodIds)) {
            data["deliveryMethodIds"] = [];
            for (let item of this.deliveryMethodIds)
                data["deliveryMethodIds"].push(item);
        }
        if (Array.isArray(this.deliverableTypeIds)) {
            data["deliverableTypeIds"] = [];
            for (let item of this.deliverableTypeIds)
                data["deliverableTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISkuDeliverableFilter extends IBaseFilter {
    deliveryMethodIds?: string[] | undefined;
    deliverableTypeIds?: string[] | undefined;
}

export class SaveSkuDeliverableRequest implements ISaveSkuDeliverableRequest {
    id?: string | undefined;
    skuId!: string;
    deliverableId!: string;
    sequence?: number;
    externalSourceId?: string | undefined;

    constructor(data?: ISaveSkuDeliverableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.deliverableId = _data["deliverableId"];
            this.sequence = _data["sequence"];
            this.externalSourceId = _data["externalSourceId"];
        }
    }

    static fromJS(data: any): SaveSkuDeliverableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSkuDeliverableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["deliverableId"] = this.deliverableId;
        data["sequence"] = this.sequence;
        data["externalSourceId"] = this.externalSourceId;
        return data;
    }
}

export interface ISaveSkuDeliverableRequest {
    id?: string | undefined;
    skuId: string;
    deliverableId: string;
    sequence?: number;
    externalSourceId?: string | undefined;
}

export class ResponseOfStringAndString implements IResponseOfStringAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string | undefined;

    constructor(data?: IResponseOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfStringAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: string | undefined;
}

export class ResponseOfString extends ResponseOfStringAndString implements IResponseOfString {

    constructor(data?: IResponseOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfString extends IResponseOfStringAndString {
}

export class ResponseOfListOfBaseContentItemAndString implements IResponseOfListOfBaseContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: BaseContentItem[] | undefined;

    constructor(data?: IResponseOfListOfBaseContentItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BaseContentItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfBaseContentItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfBaseContentItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfBaseContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: BaseContentItem[] | undefined;
}

export class ResponseOfListOfBaseContentItem extends ResponseOfListOfBaseContentItemAndString implements IResponseOfListOfBaseContentItem {

    constructor(data?: IResponseOfListOfBaseContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfBaseContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfBaseContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfBaseContentItem extends IResponseOfListOfBaseContentItemAndString {
}

export class ListResponseOfBaseContentItem extends ResponseOfListOfBaseContentItem implements IListResponseOfBaseContentItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfBaseContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfBaseContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfBaseContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfBaseContentItem extends IResponseOfListOfBaseContentItem {
    totalRecords?: number | undefined;
}

export class BaseContentItem implements IBaseContentItem {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IBaseContentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BaseContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new BaseContentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IBaseContentItem {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
}

export class ResponseOfListOfAdminContentItemAndString implements IResponseOfListOfAdminContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminContentItem[] | undefined;

    constructor(data?: IResponseOfListOfAdminContentItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdminContentItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAdminContentItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminContentItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAdminContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminContentItem[] | undefined;
}

export class ResponseOfListOfAdminContentItem extends ResponseOfListOfAdminContentItemAndString implements IResponseOfListOfAdminContentItem {

    constructor(data?: IResponseOfListOfAdminContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAdminContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAdminContentItem extends IResponseOfListOfAdminContentItemAndString {
}

export class ListResponseOfAdminContentItem extends ResponseOfListOfAdminContentItem implements IListResponseOfAdminContentItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAdminContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAdminContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAdminContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAdminContentItem extends IResponseOfListOfAdminContentItem {
    totalRecords?: number | undefined;
}

export class AdminContentItem extends BaseContentItem implements IAdminContentItem {
    applicationId?: string;
    applicationName?: string | undefined;
    description?: string | undefined;
    inheritedOrganizationName?: string | undefined;

    constructor(data?: IAdminContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.description = _data["description"];
            this.inheritedOrganizationName = _data["inheritedOrganizationName"];
        }
    }

    static override fromJS(data: any): AdminContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new AdminContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["description"] = this.description;
        data["inheritedOrganizationName"] = this.inheritedOrganizationName;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminContentItem extends IBaseContentItem {
    applicationId?: string;
    applicationName?: string | undefined;
    description?: string | undefined;
    inheritedOrganizationName?: string | undefined;
}

export class ResponseOfAdminContentItemAndString implements IResponseOfAdminContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminContentItem | undefined;

    constructor(data?: IResponseOfAdminContentItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? AdminContentItem.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAdminContentItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAdminContentItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAdminContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminContentItem | undefined;
}

export class ResponseOfAdminContentItem extends ResponseOfAdminContentItemAndString implements IResponseOfAdminContentItem {

    constructor(data?: IResponseOfAdminContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAdminContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAdminContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAdminContentItem extends IResponseOfAdminContentItemAndString {
}

export class SaveContentRequest implements ISaveContentRequest {
    id?: string | undefined;
    name!: string;
    description?: string | undefined;
    organizationId!: string;
    value!: string;
    contentType?: ContentType;

    constructor(data?: ISaveContentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.value = _data["value"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): SaveContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["value"] = this.value;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface ISaveContentRequest {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    organizationId: string;
    value: string;
    contentType?: ContentType;
}

export enum ContentType {
    PlainText = "PlainText",
    EmbededBase64Image = "EmbededBase64Image",
    Html = "Html",
}

export class ResponseOfListOfDescendantContentBlockAndString implements IResponseOfListOfDescendantContentBlockAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DescendantContentBlock[] | undefined;

    constructor(data?: IResponseOfListOfDescendantContentBlockAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DescendantContentBlock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfDescendantContentBlockAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDescendantContentBlockAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfDescendantContentBlockAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DescendantContentBlock[] | undefined;
}

export class ResponseOfListOfDescendantContentBlock extends ResponseOfListOfDescendantContentBlockAndString implements IResponseOfListOfDescendantContentBlock {

    constructor(data?: IResponseOfListOfDescendantContentBlock) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfDescendantContentBlock {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDescendantContentBlock();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfDescendantContentBlock extends IResponseOfListOfDescendantContentBlockAndString {
}

export class ListResponseOfDescendantContentBlock extends ResponseOfListOfDescendantContentBlock implements IListResponseOfDescendantContentBlock {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfDescendantContentBlock) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfDescendantContentBlock {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfDescendantContentBlock();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfDescendantContentBlock extends IResponseOfListOfDescendantContentBlock {
    totalRecords?: number | undefined;
}

export class DescendantContentBlock implements IDescendantContentBlock {
    organizationName?: string | undefined;
    value?: string | undefined;
    inheritedOrganizationName?: string | undefined;

    constructor(data?: IDescendantContentBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.value = _data["value"];
            this.inheritedOrganizationName = _data["inheritedOrganizationName"];
        }
    }

    static fromJS(data: any): DescendantContentBlock {
        data = typeof data === 'object' ? data : {};
        let result = new DescendantContentBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["value"] = this.value;
        data["inheritedOrganizationName"] = this.inheritedOrganizationName;
        return data;
    }
}

export interface IDescendantContentBlock {
    organizationName?: string | undefined;
    value?: string | undefined;
    inheritedOrganizationName?: string | undefined;
}

export class ListRequestOfDescendantContentBlockFilter implements IListRequestOfDescendantContentBlockFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: DescendantContentBlockFilter | undefined;

    constructor(data?: IListRequestOfDescendantContentBlockFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? DescendantContentBlockFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfDescendantContentBlockFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfDescendantContentBlockFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfDescendantContentBlockFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: DescendantContentBlockFilter | undefined;
}

export class AdminListRequestOfDescendantContentBlockFilter extends ListRequestOfDescendantContentBlockFilter implements IAdminListRequestOfDescendantContentBlockFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfDescendantContentBlockFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfDescendantContentBlockFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfDescendantContentBlockFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfDescendantContentBlockFilter extends IListRequestOfDescendantContentBlockFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class DescendantContentBlockFilter extends BaseFilter implements IDescendantContentBlockFilter {
    contentBlockName?: string | undefined;

    constructor(data?: IDescendantContentBlockFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contentBlockName = _data["contentBlockName"];
        }
    }

    static override fromJS(data: any): DescendantContentBlockFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DescendantContentBlockFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentBlockName"] = this.contentBlockName;
        super.toJSON(data);
        return data;
    }
}

export interface IDescendantContentBlockFilter extends IBaseFilter {
    contentBlockName?: string | undefined;
}

export class QrCodeRequest implements IQrCodeRequest {
    data?: string | undefined;

    constructor(data?: IQrCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): QrCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QrCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IQrCodeRequest {
    data?: string | undefined;
}

export class ResponseOfMenuAndString implements IResponseOfMenuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Menu | undefined;

    constructor(data?: IResponseOfMenuAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Menu.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfMenuAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMenuAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfMenuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Menu | undefined;
}

export class ResponseOfMenu extends ResponseOfMenuAndString implements IResponseOfMenu {

    constructor(data?: IResponseOfMenu) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMenu();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfMenu extends IResponseOfMenuAndString {
}

export class Menu implements IMenu {
    id?: string;
    organizationId!: string;
    organizationName?: string | undefined;
    name!: string;
    description?: string | undefined;
    menuTypeId!: string;
    menuType?: string | undefined;

    constructor(data?: IMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.menuTypeId = _data["menuTypeId"];
            this.menuType = _data["menuType"];
        }
    }

    static fromJS(data: any): Menu {
        data = typeof data === 'object' ? data : {};
        let result = new Menu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["menuTypeId"] = this.menuTypeId;
        data["menuType"] = this.menuType;
        return data;
    }
}

export interface IMenu {
    id?: string;
    organizationId: string;
    organizationName?: string | undefined;
    name: string;
    description?: string | undefined;
    menuTypeId: string;
    menuType?: string | undefined;
}

export class ResponseOfMenuUsageAndString implements IResponseOfMenuUsageAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuUsage | undefined;

    constructor(data?: IResponseOfMenuUsageAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? MenuUsage.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfMenuUsageAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMenuUsageAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfMenuUsageAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuUsage | undefined;
}

export class ResponseOfMenuUsage extends ResponseOfMenuUsageAndString implements IResponseOfMenuUsage {

    constructor(data?: IResponseOfMenuUsage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfMenuUsage {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMenuUsage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfMenuUsage extends IResponseOfMenuUsageAndString {
}

export class MenuUsage implements IMenuUsage {
    assignedOrganizationCount?: number;
    assignedOrganizationNames?: string[] | undefined;

    constructor(data?: IMenuUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedOrganizationCount = _data["assignedOrganizationCount"];
            if (Array.isArray(_data["assignedOrganizationNames"])) {
                this.assignedOrganizationNames = [] as any;
                for (let item of _data["assignedOrganizationNames"])
                    this.assignedOrganizationNames!.push(item);
            }
        }
    }

    static fromJS(data: any): MenuUsage {
        data = typeof data === 'object' ? data : {};
        let result = new MenuUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedOrganizationCount"] = this.assignedOrganizationCount;
        if (Array.isArray(this.assignedOrganizationNames)) {
            data["assignedOrganizationNames"] = [];
            for (let item of this.assignedOrganizationNames)
                data["assignedOrganizationNames"].push(item);
        }
        return data;
    }
}

export interface IMenuUsage {
    assignedOrganizationCount?: number;
    assignedOrganizationNames?: string[] | undefined;
}

export class ResponseOfListOfAdminMenuTypeAndString implements IResponseOfListOfAdminMenuTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminMenuType[] | undefined;

    constructor(data?: IResponseOfListOfAdminMenuTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdminMenuType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAdminMenuTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminMenuTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAdminMenuTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminMenuType[] | undefined;
}

export class ResponseOfListOfAdminMenuType extends ResponseOfListOfAdminMenuTypeAndString implements IResponseOfListOfAdminMenuType {

    constructor(data?: IResponseOfListOfAdminMenuType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAdminMenuType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminMenuType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAdminMenuType extends IResponseOfListOfAdminMenuTypeAndString {
}

export class ListResponseOfAdminMenuType extends ResponseOfListOfAdminMenuType implements IListResponseOfAdminMenuType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAdminMenuType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAdminMenuType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAdminMenuType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAdminMenuType extends IResponseOfListOfAdminMenuType {
    totalRecords?: number | undefined;
}

export class AdminMenuType implements IAdminMenuType {
    id?: string;
    name?: string | undefined;
    enumValue?: MenuType;

    constructor(data?: IAdminMenuType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enumValue = _data["enumValue"];
        }
    }

    static fromJS(data: any): AdminMenuType {
        data = typeof data === 'object' ? data : {};
        let result = new AdminMenuType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enumValue"] = this.enumValue;
        return data;
    }
}

export interface IAdminMenuType {
    id?: string;
    name?: string | undefined;
    enumValue?: MenuType;
}

export enum MenuType {
    Left = "Left",
    Top = "Top",
    Profile = "Profile",
    Right = "Right",
}

export class MenuRequest implements IMenuRequest {
    id?: string | undefined;
    organizationId?: string;
    name?: string | undefined;
    description?: string | undefined;
    menuTypeId?: string;

    constructor(data?: IMenuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.menuTypeId = _data["menuTypeId"];
        }
    }

    static fromJS(data: any): MenuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MenuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["menuTypeId"] = this.menuTypeId;
        return data;
    }
}

export interface IMenuRequest {
    id?: string | undefined;
    organizationId?: string;
    name?: string | undefined;
    description?: string | undefined;
    menuTypeId?: string;
}

export class ResponseOfListOfMenuAndString implements IResponseOfListOfMenuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Menu[] | undefined;

    constructor(data?: IResponseOfListOfMenuAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Menu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfMenuAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMenuAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfMenuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Menu[] | undefined;
}

export class ResponseOfListOfMenu extends ResponseOfListOfMenuAndString implements IResponseOfListOfMenu {

    constructor(data?: IResponseOfListOfMenu) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMenu();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfMenu extends IResponseOfListOfMenuAndString {
}

export class ListResponseOfMenu extends ResponseOfListOfMenu implements IListResponseOfMenu {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfMenu) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfMenu();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfMenu extends IResponseOfListOfMenu {
    totalRecords?: number | undefined;
}

export class ListRequestOfMenuFilter implements IListRequestOfMenuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: MenuFilter | undefined;

    constructor(data?: IListRequestOfMenuFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? MenuFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfMenuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfMenuFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfMenuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: MenuFilter | undefined;
}

export class MenuFilter extends BaseFilter implements IMenuFilter {
    menuTypeId?: string | undefined;

    constructor(data?: IMenuFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.menuTypeId = _data["menuTypeId"];
        }
    }

    static override fromJS(data: any): MenuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MenuFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuTypeId"] = this.menuTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface IMenuFilter extends IBaseFilter {
    menuTypeId?: string | undefined;
}

export class AvailableMenuListRequest extends ListRequestOfMenuFilter implements IAvailableMenuListRequest {
    organizationId?: string;

    constructor(data?: IAvailableMenuListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AvailableMenuListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableMenuListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAvailableMenuListRequest extends IListRequestOfMenuFilter {
    organizationId?: string;
}

export class ResponseOfMenuItemAndString implements IResponseOfMenuItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuItem | undefined;

    constructor(data?: IResponseOfMenuItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? MenuItem.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfMenuItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMenuItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfMenuItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuItem | undefined;
}

export class ResponseOfMenuItem extends ResponseOfMenuItemAndString implements IResponseOfMenuItem {

    constructor(data?: IResponseOfMenuItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfMenuItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfMenuItem extends IResponseOfMenuItemAndString {
}

export class MenuItem implements IMenuItem {
    id?: string;
    name!: string;
    toolTip?: string | undefined;
    description?: string | undefined;
    url!: string;
    claim!: string;
    icon!: string;
    menuItemTypeId?: string;
    menuItemTypeName?: string | undefined;
    menuItemValues?: { [key: string]: string; } | undefined;

    constructor(data?: IMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.toolTip = _data["toolTip"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.claim = _data["claim"];
            this.icon = _data["icon"];
            this.menuItemTypeId = _data["menuItemTypeId"];
            this.menuItemTypeName = _data["menuItemTypeName"];
            if (_data["menuItemValues"]) {
                this.menuItemValues = {} as any;
                for (let key in _data["menuItemValues"]) {
                    if (_data["menuItemValues"].hasOwnProperty(key))
                        (this.menuItemValues as any)![key] = _data["menuItemValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): MenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["toolTip"] = this.toolTip;
        data["description"] = this.description;
        data["url"] = this.url;
        data["claim"] = this.claim;
        data["icon"] = this.icon;
        data["menuItemTypeId"] = this.menuItemTypeId;
        data["menuItemTypeName"] = this.menuItemTypeName;
        if (this.menuItemValues) {
            data["menuItemValues"] = {};
            for (let key in this.menuItemValues) {
                if (this.menuItemValues.hasOwnProperty(key))
                    (data["menuItemValues"] as any)[key] = (this.menuItemValues as any)[key];
            }
        }
        return data;
    }
}

export interface IMenuItem {
    id?: string;
    name: string;
    toolTip?: string | undefined;
    description?: string | undefined;
    url: string;
    claim: string;
    icon: string;
    menuItemTypeId?: string;
    menuItemTypeName?: string | undefined;
    menuItemValues?: { [key: string]: string; } | undefined;
}

export class MenuItemRequest implements IMenuItemRequest {
    id?: string | undefined;
    name!: string;
    toolTip?: string | undefined;
    description?: string | undefined;
    url!: string;
    claim?: string | undefined;
    icon?: string | undefined;
    menuItemTypeId?: string;
    menuItemValues?: { [key: string]: string; } | undefined;

    constructor(data?: IMenuItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.toolTip = _data["toolTip"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.claim = _data["claim"];
            this.icon = _data["icon"];
            this.menuItemTypeId = _data["menuItemTypeId"];
            if (_data["menuItemValues"]) {
                this.menuItemValues = {} as any;
                for (let key in _data["menuItemValues"]) {
                    if (_data["menuItemValues"].hasOwnProperty(key))
                        (this.menuItemValues as any)![key] = _data["menuItemValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): MenuItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["toolTip"] = this.toolTip;
        data["description"] = this.description;
        data["url"] = this.url;
        data["claim"] = this.claim;
        data["icon"] = this.icon;
        data["menuItemTypeId"] = this.menuItemTypeId;
        if (this.menuItemValues) {
            data["menuItemValues"] = {};
            for (let key in this.menuItemValues) {
                if (this.menuItemValues.hasOwnProperty(key))
                    (data["menuItemValues"] as any)[key] = (this.menuItemValues as any)[key];
            }
        }
        return data;
    }
}

export interface IMenuItemRequest {
    id?: string | undefined;
    name: string;
    toolTip?: string | undefined;
    description?: string | undefined;
    url: string;
    claim?: string | undefined;
    icon?: string | undefined;
    menuItemTypeId?: string;
    menuItemValues?: { [key: string]: string; } | undefined;
}

export class ResponseOfListOfMenuItemAndString implements IResponseOfListOfMenuItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuItem[] | undefined;

    constructor(data?: IResponseOfListOfMenuItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfMenuItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMenuItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfMenuItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuItem[] | undefined;
}

export class ResponseOfListOfMenuItem extends ResponseOfListOfMenuItemAndString implements IResponseOfListOfMenuItem {

    constructor(data?: IResponseOfListOfMenuItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMenuItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfMenuItem extends IResponseOfListOfMenuItemAndString {
}

export class ListResponseOfMenuItem extends ResponseOfListOfMenuItem implements IListResponseOfMenuItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfMenuItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfMenuItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfMenuItem extends IResponseOfListOfMenuItem {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfMenuStructureAndString implements IResponseOfListOfMenuStructureAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuStructure[] | undefined;

    constructor(data?: IResponseOfListOfMenuStructureAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MenuStructure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfMenuStructureAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMenuStructureAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfMenuStructureAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: MenuStructure[] | undefined;
}

export class ResponseOfListOfMenuStructure extends ResponseOfListOfMenuStructureAndString implements IResponseOfListOfMenuStructure {

    constructor(data?: IResponseOfListOfMenuStructure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfMenuStructure {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfMenuStructure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfMenuStructure extends IResponseOfListOfMenuStructureAndString {
}

export class ListResponseOfMenuStructure extends ResponseOfListOfMenuStructure implements IListResponseOfMenuStructure {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfMenuStructure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfMenuStructure {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfMenuStructure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfMenuStructure extends IResponseOfListOfMenuStructure {
    totalRecords?: number | undefined;
}

export class MenuStructure implements IMenuStructure {
    id?: string;
    menuId!: string;
    menuItemId!: string;
    menuStructureTypeId!: string;
    parentMenuStructureId?: string | undefined;
    name?: string | undefined;
    toolTip?: string | undefined;
    sequence!: number;
    menuStructureType?: string | undefined;
    menuItem?: string | undefined;
    parentMenuStructure?: string | undefined;

    constructor(data?: IMenuStructure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.menuId = _data["menuId"];
            this.menuItemId = _data["menuItemId"];
            this.menuStructureTypeId = _data["menuStructureTypeId"];
            this.parentMenuStructureId = _data["parentMenuStructureId"];
            this.name = _data["name"];
            this.toolTip = _data["toolTip"];
            this.sequence = _data["sequence"];
            this.menuStructureType = _data["menuStructureType"];
            this.menuItem = _data["menuItem"];
            this.parentMenuStructure = _data["parentMenuStructure"];
        }
    }

    static fromJS(data: any): MenuStructure {
        data = typeof data === 'object' ? data : {};
        let result = new MenuStructure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuId"] = this.menuId;
        data["menuItemId"] = this.menuItemId;
        data["menuStructureTypeId"] = this.menuStructureTypeId;
        data["parentMenuStructureId"] = this.parentMenuStructureId;
        data["name"] = this.name;
        data["toolTip"] = this.toolTip;
        data["sequence"] = this.sequence;
        data["menuStructureType"] = this.menuStructureType;
        data["menuItem"] = this.menuItem;
        data["parentMenuStructure"] = this.parentMenuStructure;
        return data;
    }
}

export interface IMenuStructure {
    id?: string;
    menuId: string;
    menuItemId: string;
    menuStructureTypeId: string;
    parentMenuStructureId?: string | undefined;
    name?: string | undefined;
    toolTip?: string | undefined;
    sequence: number;
    menuStructureType?: string | undefined;
    menuItem?: string | undefined;
    parentMenuStructure?: string | undefined;
}

export class ListRequestOfMenuStructureFilter implements IListRequestOfMenuStructureFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: MenuStructureFilter | undefined;

    constructor(data?: IListRequestOfMenuStructureFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? MenuStructureFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfMenuStructureFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfMenuStructureFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfMenuStructureFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: MenuStructureFilter | undefined;
}

export class MenuStructureFilter extends BaseFilter implements IMenuStructureFilter {
    menuStructureTypeId?: string | undefined;

    constructor(data?: IMenuStructureFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.menuStructureTypeId = _data["menuStructureTypeId"];
        }
    }

    static override fromJS(data: any): MenuStructureFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MenuStructureFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuStructureTypeId"] = this.menuStructureTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface IMenuStructureFilter extends IBaseFilter {
    menuStructureTypeId?: string | undefined;
}

export class ResponseOfListOfAdminMenuStructureTypeAndString implements IResponseOfListOfAdminMenuStructureTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminMenuStructureType[] | undefined;

    constructor(data?: IResponseOfListOfAdminMenuStructureTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdminMenuStructureType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAdminMenuStructureTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminMenuStructureTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAdminMenuStructureTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminMenuStructureType[] | undefined;
}

export class ResponseOfListOfAdminMenuStructureType extends ResponseOfListOfAdminMenuStructureTypeAndString implements IResponseOfListOfAdminMenuStructureType {

    constructor(data?: IResponseOfListOfAdminMenuStructureType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAdminMenuStructureType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminMenuStructureType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAdminMenuStructureType extends IResponseOfListOfAdminMenuStructureTypeAndString {
}

export class ListResponseOfAdminMenuStructureType extends ResponseOfListOfAdminMenuStructureType implements IListResponseOfAdminMenuStructureType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAdminMenuStructureType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAdminMenuStructureType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAdminMenuStructureType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAdminMenuStructureType extends IResponseOfListOfAdminMenuStructureType {
    totalRecords?: number | undefined;
}

export class AdminMenuStructureType implements IAdminMenuStructureType {
    id?: string;
    name?: string | undefined;
    enumValue?: MenuStructureType;

    constructor(data?: IAdminMenuStructureType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enumValue = _data["enumValue"];
        }
    }

    static fromJS(data: any): AdminMenuStructureType {
        data = typeof data === 'object' ? data : {};
        let result = new AdminMenuStructureType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enumValue"] = this.enumValue;
        return data;
    }
}

export interface IAdminMenuStructureType {
    id?: string;
    name?: string | undefined;
    enumValue?: MenuStructureType;
}

export enum MenuStructureType {
    MenuItem = "MenuItem",
    Separator = "Separator",
    GroupHeader = "GroupHeader",
}

export class MenuStructureRequest implements IMenuStructureRequest {
    id?: string | undefined;
    menuId?: string;
    menuItemId!: string;
    menuStructureTypeId!: string;
    parentMenuStructureId?: string | undefined;
    name?: string | undefined;
    toolTip?: string | undefined;
    sequence!: number;

    constructor(data?: IMenuStructureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.menuId = _data["menuId"];
            this.menuItemId = _data["menuItemId"];
            this.menuStructureTypeId = _data["menuStructureTypeId"];
            this.parentMenuStructureId = _data["parentMenuStructureId"];
            this.name = _data["name"];
            this.toolTip = _data["toolTip"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): MenuStructureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MenuStructureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuId"] = this.menuId;
        data["menuItemId"] = this.menuItemId;
        data["menuStructureTypeId"] = this.menuStructureTypeId;
        data["parentMenuStructureId"] = this.parentMenuStructureId;
        data["name"] = this.name;
        data["toolTip"] = this.toolTip;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IMenuStructureRequest {
    id?: string | undefined;
    menuId?: string;
    menuItemId: string;
    menuStructureTypeId: string;
    parentMenuStructureId?: string | undefined;
    name?: string | undefined;
    toolTip?: string | undefined;
    sequence: number;
}

export class MenuStructureSequenceRequest implements IMenuStructureSequenceRequest {
    menuStructureId?: string;
    sequence?: number;

    constructor(data?: IMenuStructureSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menuStructureId = _data["menuStructureId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): MenuStructureSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MenuStructureSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuStructureId"] = this.menuStructureId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IMenuStructureSequenceRequest {
    menuStructureId?: string;
    sequence?: number;
}

export class ResponseOfListOfOrganizationMenuAndString implements IResponseOfListOfOrganizationMenuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationMenu[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationMenuAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationMenu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationMenuAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationMenuAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationMenuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationMenu[] | undefined;
}

export class ResponseOfListOfOrganizationMenu extends ResponseOfListOfOrganizationMenuAndString implements IResponseOfListOfOrganizationMenu {

    constructor(data?: IResponseOfListOfOrganizationMenu) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationMenu();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationMenu extends IResponseOfListOfOrganizationMenuAndString {
}

export class ListResponseOfOrganizationMenu extends ResponseOfListOfOrganizationMenu implements IListResponseOfOrganizationMenu {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationMenu) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationMenu();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationMenu extends IResponseOfListOfOrganizationMenu {
    totalRecords?: number | undefined;
}

export class OrganizationMenu implements IOrganizationMenu {
    id?: string;
    menuId?: string;
    menuName?: string | undefined;
    menuDescription?: string | undefined;
    menuTypeId?: string;
    menuType?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;

    constructor(data?: IOrganizationMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.menuId = _data["menuId"];
            this.menuName = _data["menuName"];
            this.menuDescription = _data["menuDescription"];
            this.menuTypeId = _data["menuTypeId"];
            this.menuType = _data["menuType"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): OrganizationMenu {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuId"] = this.menuId;
        data["menuName"] = this.menuName;
        data["menuDescription"] = this.menuDescription;
        data["menuTypeId"] = this.menuTypeId;
        data["menuType"] = this.menuType;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IOrganizationMenu {
    id?: string;
    menuId?: string;
    menuName?: string | undefined;
    menuDescription?: string | undefined;
    menuTypeId?: string;
    menuType?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
}

export class OrganizationMenuRequest implements IOrganizationMenuRequest {
    id?: string | undefined;
    organizationId?: string;
    menuId?: string;

    constructor(data?: IOrganizationMenuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.menuId = _data["menuId"];
        }
    }

    static fromJS(data: any): OrganizationMenuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMenuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["menuId"] = this.menuId;
        return data;
    }
}

export interface IOrganizationMenuRequest {
    id?: string | undefined;
    organizationId?: string;
    menuId?: string;
}

export class ResponseOfListOfInflectionPointAndString implements IResponseOfListOfInflectionPointAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: InflectionPoint[] | undefined;

    constructor(data?: IResponseOfListOfInflectionPointAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InflectionPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfInflectionPointAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfInflectionPointAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfInflectionPointAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: InflectionPoint[] | undefined;
}

export class ResponseOfListOfInflectionPoint extends ResponseOfListOfInflectionPointAndString implements IResponseOfListOfInflectionPoint {

    constructor(data?: IResponseOfListOfInflectionPoint) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfInflectionPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfInflectionPoint();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfInflectionPoint extends IResponseOfListOfInflectionPointAndString {
}

export class ListResponseOfInflectionPoint extends ResponseOfListOfInflectionPoint implements IListResponseOfInflectionPoint {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfInflectionPoint) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfInflectionPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfInflectionPoint();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfInflectionPoint extends IResponseOfListOfInflectionPoint {
    totalRecords?: number | undefined;
}

export class InflectionPoint implements IInflectionPoint {
    id!: string;
    name!: string;
    codeConstant!: string;
    wizards?: Wizard[] | undefined;

    constructor(data?: IInflectionPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.codeConstant = _data["codeConstant"];
            if (Array.isArray(_data["wizards"])) {
                this.wizards = [] as any;
                for (let item of _data["wizards"])
                    this.wizards!.push(Wizard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InflectionPoint {
        data = typeof data === 'object' ? data : {};
        let result = new InflectionPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["codeConstant"] = this.codeConstant;
        if (Array.isArray(this.wizards)) {
            data["wizards"] = [];
            for (let item of this.wizards)
                data["wizards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInflectionPoint {
    id: string;
    name: string;
    codeConstant: string;
    wizards?: Wizard[] | undefined;
}

export class Wizard implements IWizard {
    id!: string;
    inflectionPoint!: InflectionPoint;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    name!: string;
    header!: string;
    footer!: string;
    isActive!: boolean;
    widgets?: Widget[] | undefined;

    constructor(data?: IWizard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inflectionPoint = new InflectionPoint();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inflectionPoint = _data["inflectionPoint"] ? InflectionPoint.fromJS(_data["inflectionPoint"]) : new InflectionPoint();
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.name = _data["name"];
            this.header = _data["header"];
            this.footer = _data["footer"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Wizard {
        data = typeof data === 'object' ? data : {};
        let result = new Wizard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inflectionPoint"] = this.inflectionPoint ? this.inflectionPoint.toJSON() : undefined as any;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["name"] = this.name;
        data["header"] = this.header;
        data["footer"] = this.footer;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWizard {
    id: string;
    inflectionPoint: InflectionPoint;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    name: string;
    header: string;
    footer: string;
    isActive: boolean;
    widgets?: Widget[] | undefined;
}

export class Widget implements IWidget {
    id!: string;
    name!: string;
    codeConstant!: string;
    sequence!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.codeConstant = _data["codeConstant"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["codeConstant"] = this.codeConstant;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IWidget {
    id: string;
    name: string;
    codeConstant: string;
    sequence: number;
}

export class ResponseOfListOfWidgetAndString implements IResponseOfListOfWidgetAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Widget[] | undefined;

    constructor(data?: IResponseOfListOfWidgetAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfWidgetAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWidgetAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfWidgetAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Widget[] | undefined;
}

export class ResponseOfListOfWidget extends ResponseOfListOfWidgetAndString implements IResponseOfListOfWidget {

    constructor(data?: IResponseOfListOfWidget) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfWidget {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWidget();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfWidget extends IResponseOfListOfWidgetAndString {
}

export class ListResponseOfWidget extends ResponseOfListOfWidget implements IListResponseOfWidget {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfWidget) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfWidget {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfWidget();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfWidget extends IResponseOfListOfWidget {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfWizardAndString implements IResponseOfListOfWizardAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Wizard[] | undefined;

    constructor(data?: IResponseOfListOfWizardAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Wizard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfWizardAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWizardAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfWizardAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Wizard[] | undefined;
}

export class ResponseOfListOfWizard extends ResponseOfListOfWizardAndString implements IResponseOfListOfWizard {

    constructor(data?: IResponseOfListOfWizard) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfWizard {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWizard();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfWizard extends IResponseOfListOfWizardAndString {
}

export class ListResponseOfWizard extends ResponseOfListOfWizard implements IListResponseOfWizard {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfWizard) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfWizard {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfWizard();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfWizard extends IResponseOfListOfWizard {
    totalRecords?: number | undefined;
}

export class ResponseOfWizardAndString implements IResponseOfWizardAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Wizard | undefined;

    constructor(data?: IResponseOfWizardAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Wizard.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfWizardAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfWizardAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfWizardAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Wizard | undefined;
}

export class ResponseOfWizard extends ResponseOfWizardAndString implements IResponseOfWizard {

    constructor(data?: IResponseOfWizard) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfWizard {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfWizard();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfWizard extends IResponseOfWizardAndString {
}

export class WizardSaveRequest implements IWizardSaveRequest {
    id?: string | undefined;
    inflectionPointId?: string;
    organizationId?: string;
    name!: string;
    isActive!: boolean;
    header!: string;
    footer!: string;
    widgets!: WizardWidget[];

    constructor(data?: IWizardSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.widgets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inflectionPointId = _data["inflectionPointId"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.header = _data["header"];
            this.footer = _data["footer"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(WizardWidget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WizardSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WizardSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inflectionPointId"] = this.inflectionPointId;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["header"] = this.header;
        data["footer"] = this.footer;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWizardSaveRequest {
    id?: string | undefined;
    inflectionPointId?: string;
    organizationId?: string;
    name: string;
    isActive: boolean;
    header: string;
    footer: string;
    widgets: WizardWidget[];
}

export class WizardWidget implements IWizardWidget {
    widgetId!: string;
    sequence!: number;

    constructor(data?: IWizardWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): WizardWidget {
        data = typeof data === 'object' ? data : {};
        let result = new WizardWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IWizardWidget {
    widgetId: string;
    sequence: number;
}

export class ResponseOfListOfAuthorityItemAndString implements IResponseOfListOfAuthorityItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthorityItem[] | undefined;

    constructor(data?: IResponseOfListOfAuthorityItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AuthorityItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAuthorityItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAuthorityItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAuthorityItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthorityItem[] | undefined;
}

export class ResponseOfListOfAuthorityItem extends ResponseOfListOfAuthorityItemAndString implements IResponseOfListOfAuthorityItem {

    constructor(data?: IResponseOfListOfAuthorityItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAuthorityItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAuthorityItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAuthorityItem extends IResponseOfListOfAuthorityItemAndString {
}

export class ListResponseOfAuthorityItem extends ResponseOfListOfAuthorityItem implements IListResponseOfAuthorityItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAuthorityItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAuthorityItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAuthorityItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAuthorityItem extends IResponseOfListOfAuthorityItem {
    totalRecords?: number | undefined;
}

export class AuthorityItem implements IAuthorityItem {
    id?: string;
    authorityTypeName?: string | undefined;

    constructor(data?: IAuthorityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authorityTypeName = _data["authorityTypeName"];
        }
    }

    static fromJS(data: any): AuthorityItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authorityTypeName"] = this.authorityTypeName;
        return data;
    }
}

export interface IAuthorityItem {
    id?: string;
    authorityTypeName?: string | undefined;
}

export class ListRequestOfAuthorityFilter implements IListRequestOfAuthorityFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AuthorityFilter | undefined;

    constructor(data?: IListRequestOfAuthorityFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AuthorityFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAuthorityFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAuthorityFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAuthorityFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AuthorityFilter | undefined;
}

export class AuthorityFilter extends BaseFilter implements IAuthorityFilter {
    manualSubmissionSettingValue?: boolean | undefined;

    constructor(data?: IAuthorityFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manualSubmissionSettingValue = _data["manualSubmissionSettingValue"];
        }
    }

    static override fromJS(data: any): AuthorityFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manualSubmissionSettingValue"] = this.manualSubmissionSettingValue;
        super.toJSON(data);
        return data;
    }
}

export interface IAuthorityFilter extends IBaseFilter {
    manualSubmissionSettingValue?: boolean | undefined;
}

export class ResponseOfListOfAuthorityTypeListItemAndString implements IResponseOfListOfAuthorityTypeListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthorityTypeListItem[] | undefined;

    constructor(data?: IResponseOfListOfAuthorityTypeListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AuthorityTypeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAuthorityTypeListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAuthorityTypeListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAuthorityTypeListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthorityTypeListItem[] | undefined;
}

export class ResponseOfListOfAuthorityTypeListItem extends ResponseOfListOfAuthorityTypeListItemAndString implements IResponseOfListOfAuthorityTypeListItem {

    constructor(data?: IResponseOfListOfAuthorityTypeListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAuthorityTypeListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAuthorityTypeListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAuthorityTypeListItem extends IResponseOfListOfAuthorityTypeListItemAndString {
}

export class ListResponseOfAuthorityTypeListItem extends ResponseOfListOfAuthorityTypeListItem implements IListResponseOfAuthorityTypeListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAuthorityTypeListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAuthorityTypeListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAuthorityTypeListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAuthorityTypeListItem extends IResponseOfListOfAuthorityTypeListItem {
    totalRecords?: number | undefined;
}

export class AuthorityTypeListItem implements IAuthorityTypeListItem {
    id?: string;
    name?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    submissionCutOffDays?: number;

    constructor(data?: IAuthorityTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isUploadSubmissionStatusAvailable = _data["isUploadSubmissionStatusAvailable"];
            this.submissionCutOffDays = _data["submissionCutOffDays"];
        }
    }

    static fromJS(data: any): AuthorityTypeListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isUploadSubmissionStatusAvailable"] = this.isUploadSubmissionStatusAvailable;
        data["submissionCutOffDays"] = this.submissionCutOffDays;
        return data;
    }
}

export interface IAuthorityTypeListItem {
    id?: string;
    name?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    submissionCutOffDays?: number;
}

export class ListRequestOfAuthorityTypeAdminFilter implements IListRequestOfAuthorityTypeAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AuthorityTypeAdminFilter | undefined;

    constructor(data?: IListRequestOfAuthorityTypeAdminFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AuthorityTypeAdminFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAuthorityTypeAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAuthorityTypeAdminFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAuthorityTypeAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AuthorityTypeAdminFilter | undefined;
}

export class AuthorityTypeAdminFilter extends BaseFilter implements IAuthorityTypeAdminFilter {

    constructor(data?: IAuthorityTypeAdminFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AuthorityTypeAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityTypeAdminFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAuthorityTypeAdminFilter extends IBaseFilter {
}

export class ResponseOfAuthorityTypeDetailAndString implements IResponseOfAuthorityTypeDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthorityTypeDetail | undefined;

    constructor(data?: IResponseOfAuthorityTypeDetailAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? AuthorityTypeDetail.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAuthorityTypeDetailAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthorityTypeDetailAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAuthorityTypeDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthorityTypeDetail | undefined;
}

export class ResponseOfAuthorityTypeDetail extends ResponseOfAuthorityTypeDetailAndString implements IResponseOfAuthorityTypeDetail {

    constructor(data?: IResponseOfAuthorityTypeDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAuthorityTypeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthorityTypeDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAuthorityTypeDetail extends IResponseOfAuthorityTypeDetailAndString {
}

export class AuthorityTypeDetail implements IAuthorityTypeDetail {
    id?: string;
    name?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    submissionCutOffDays?: number;
    accreditationChain?: AccreditationChainItem[] | undefined;

    constructor(data?: IAuthorityTypeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isUploadSubmissionStatusAvailable = _data["isUploadSubmissionStatusAvailable"];
            this.submissionCutOffDays = _data["submissionCutOffDays"];
            if (Array.isArray(_data["accreditationChain"])) {
                this.accreditationChain = [] as any;
                for (let item of _data["accreditationChain"])
                    this.accreditationChain!.push(AccreditationChainItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorityTypeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityTypeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isUploadSubmissionStatusAvailable"] = this.isUploadSubmissionStatusAvailable;
        data["submissionCutOffDays"] = this.submissionCutOffDays;
        if (Array.isArray(this.accreditationChain)) {
            data["accreditationChain"] = [];
            for (let item of this.accreditationChain)
                data["accreditationChain"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAuthorityTypeDetail {
    id?: string;
    name?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    submissionCutOffDays?: number;
    accreditationChain?: AccreditationChainItem[] | undefined;
}

export class AccreditationChainItem implements IAccreditationChainItem {
    licensureBodyId?: string;
    licensureBodyName?: string | undefined;
    licensureBodyAcronym?: string | undefined;
    accreditationBodyId?: string | undefined;
    accreditationBodyName?: string | undefined;
    accreditationBodyAcronym?: string | undefined;
    submissionAuthorityId?: string | undefined;
    submissionAuthorityName?: string | undefined;
    professionIds?: string[] | undefined;

    constructor(data?: IAccreditationChainItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensureBodyId = _data["licensureBodyId"];
            this.licensureBodyName = _data["licensureBodyName"];
            this.licensureBodyAcronym = _data["licensureBodyAcronym"];
            this.accreditationBodyId = _data["accreditationBodyId"];
            this.accreditationBodyName = _data["accreditationBodyName"];
            this.accreditationBodyAcronym = _data["accreditationBodyAcronym"];
            this.submissionAuthorityId = _data["submissionAuthorityId"];
            this.submissionAuthorityName = _data["submissionAuthorityName"];
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AccreditationChainItem {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditationChainItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensureBodyId"] = this.licensureBodyId;
        data["licensureBodyName"] = this.licensureBodyName;
        data["licensureBodyAcronym"] = this.licensureBodyAcronym;
        data["accreditationBodyId"] = this.accreditationBodyId;
        data["accreditationBodyName"] = this.accreditationBodyName;
        data["accreditationBodyAcronym"] = this.accreditationBodyAcronym;
        data["submissionAuthorityId"] = this.submissionAuthorityId;
        data["submissionAuthorityName"] = this.submissionAuthorityName;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        return data;
    }
}

export interface IAccreditationChainItem {
    licensureBodyId?: string;
    licensureBodyName?: string | undefined;
    licensureBodyAcronym?: string | undefined;
    accreditationBodyId?: string | undefined;
    accreditationBodyName?: string | undefined;
    accreditationBodyAcronym?: string | undefined;
    submissionAuthorityId?: string | undefined;
    submissionAuthorityName?: string | undefined;
    professionIds?: string[] | undefined;
}

export class AuthorityTypeRequest implements IAuthorityTypeRequest {
    id?: string | undefined;
    name?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    submissionCutOffDays?: number;

    constructor(data?: IAuthorityTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isUploadSubmissionStatusAvailable = _data["isUploadSubmissionStatusAvailable"];
            this.submissionCutOffDays = _data["submissionCutOffDays"];
        }
    }

    static fromJS(data: any): AuthorityTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isUploadSubmissionStatusAvailable"] = this.isUploadSubmissionStatusAvailable;
        data["submissionCutOffDays"] = this.submissionCutOffDays;
        return data;
    }
}

export interface IAuthorityTypeRequest {
    id?: string | undefined;
    name?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    submissionCutOffDays?: number;
}

export class ResponseOfCertificateAndString implements IResponseOfCertificateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Certificate | undefined;

    constructor(data?: IResponseOfCertificateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Certificate.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCertificateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCertificateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Certificate | undefined;
}

export class ResponseOfCertificate extends ResponseOfCertificateAndString implements IResponseOfCertificate {

    constructor(data?: IResponseOfCertificate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCertificate extends IResponseOfCertificateAndString {
}

export class Certificate implements ICertificate {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    certificateTemplateId?: string | undefined;
    certificateThemeId?: string | undefined;

    constructor(data?: ICertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.certificateTemplateId = _data["certificateTemplateId"];
            this.certificateThemeId = _data["certificateThemeId"];
        }
    }

    static fromJS(data: any): Certificate {
        data = typeof data === 'object' ? data : {};
        let result = new Certificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["certificateTemplateId"] = this.certificateTemplateId;
        data["certificateThemeId"] = this.certificateThemeId;
        return data;
    }
}

export interface ICertificate {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    certificateTemplateId?: string | undefined;
    certificateThemeId?: string | undefined;
}

export class ResponseOfListOfCertificateAndString implements IResponseOfListOfCertificateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Certificate[] | undefined;

    constructor(data?: IResponseOfListOfCertificateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Certificate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCertificateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCertificateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Certificate[] | undefined;
}

export class ResponseOfListOfCertificate extends ResponseOfListOfCertificateAndString implements IResponseOfListOfCertificate {

    constructor(data?: IResponseOfListOfCertificate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCertificate extends IResponseOfListOfCertificateAndString {
}

export class ListResponseOfCertificate extends ResponseOfListOfCertificate implements IListResponseOfCertificate {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCertificate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCertificate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCertificate extends IResponseOfListOfCertificate {
    totalRecords?: number | undefined;
}

export class CertificateRequest implements ICertificateRequest {
    id?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    certificateTemplateId?: string | undefined;
    certificateThemeId?: string | undefined;

    constructor(data?: ICertificateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.certificateTemplateId = _data["certificateTemplateId"];
            this.certificateThemeId = _data["certificateThemeId"];
        }
    }

    static fromJS(data: any): CertificateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["certificateTemplateId"] = this.certificateTemplateId;
        data["certificateThemeId"] = this.certificateThemeId;
        return data;
    }
}

export interface ICertificateRequest {
    id?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    certificateTemplateId?: string | undefined;
    certificateThemeId?: string | undefined;
}

export class ResponseOfListOfSkuCertificateAndString implements IResponseOfListOfSkuCertificateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuCertificate[] | undefined;

    constructor(data?: IResponseOfListOfSkuCertificateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuCertificate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuCertificateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuCertificateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuCertificateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuCertificate[] | undefined;
}

export class ResponseOfListOfSkuCertificate extends ResponseOfListOfSkuCertificateAndString implements IResponseOfListOfSkuCertificate {

    constructor(data?: IResponseOfListOfSkuCertificate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuCertificate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuCertificate extends IResponseOfListOfSkuCertificateAndString {
}

export class ListResponseOfSkuCertificate extends ResponseOfListOfSkuCertificate implements IListResponseOfSkuCertificate {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuCertificate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuCertificate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuCertificate extends IResponseOfListOfSkuCertificate {
    totalRecords?: number | undefined;
}

export class SkuCertificate implements ISkuCertificate {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    foundBySku?: boolean;

    constructor(data?: ISkuCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.foundBySku = _data["foundBySku"];
        }
    }

    static fromJS(data: any): SkuCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new SkuCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["foundBySku"] = this.foundBySku;
        return data;
    }
}

export interface ISkuCertificate {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    foundBySku?: boolean;
}

export class ResponseOfListOfCertificateProductExtendedAndString implements IResponseOfListOfCertificateProductExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateProductExtended[] | undefined;

    constructor(data?: IResponseOfListOfCertificateProductExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CertificateProductExtended.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCertificateProductExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateProductExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCertificateProductExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateProductExtended[] | undefined;
}

export class ResponseOfListOfCertificateProductExtended extends ResponseOfListOfCertificateProductExtendedAndString implements IResponseOfListOfCertificateProductExtended {

    constructor(data?: IResponseOfListOfCertificateProductExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCertificateProductExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateProductExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCertificateProductExtended extends IResponseOfListOfCertificateProductExtendedAndString {
}

export class ListResponseOfCertificateProductExtended extends ResponseOfListOfCertificateProductExtended implements IListResponseOfCertificateProductExtended {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCertificateProductExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCertificateProductExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCertificateProductExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCertificateProductExtended extends IResponseOfListOfCertificateProductExtended {
    totalRecords?: number | undefined;
}

export class CertificateProduct implements ICertificateProduct {
    id?: string;
    certificateId?: string;
    productId?: string | undefined;
    productTypeId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;

    constructor(data?: ICertificateProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.certificateId = _data["certificateId"];
            this.productId = _data["productId"];
            this.productTypeId = _data["productTypeId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
        }
    }

    static fromJS(data: any): CertificateProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["certificateId"] = this.certificateId;
        data["productId"] = this.productId;
        data["productTypeId"] = this.productTypeId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        return data;
    }
}

export interface ICertificateProduct {
    id?: string;
    certificateId?: string;
    productId?: string | undefined;
    productTypeId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
}

export class CertificateProductExtended extends CertificateProduct implements ICertificateProductExtended {
    product?: string | undefined;
    productType?: string | undefined;
    skuAvailability?: string | undefined;
    productVersion?: string | undefined;
    productYear?: string | undefined;

    constructor(data?: ICertificateProductExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.product = _data["product"];
            this.productType = _data["productType"];
            this.skuAvailability = _data["skuAvailability"];
            this.productVersion = _data["productVersion"];
            this.productYear = _data["productYear"];
        }
    }

    static override fromJS(data: any): CertificateProductExtended {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateProductExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["productType"] = this.productType;
        data["skuAvailability"] = this.skuAvailability;
        data["productVersion"] = this.productVersion;
        data["productYear"] = this.productYear;
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateProductExtended extends ICertificateProduct {
    product?: string | undefined;
    productType?: string | undefined;
    skuAvailability?: string | undefined;
    productVersion?: string | undefined;
    productYear?: string | undefined;
}

export class ListRequestOfCertificateProductFilter implements IListRequestOfCertificateProductFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: CertificateProductFilter | undefined;

    constructor(data?: IListRequestOfCertificateProductFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? CertificateProductFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfCertificateProductFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfCertificateProductFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfCertificateProductFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: CertificateProductFilter | undefined;
}

export class CertificateProductFilter extends BaseFilter implements ICertificateProductFilter {
    productId?: string | undefined;
    productTypeId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;

    constructor(data?: ICertificateProductFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productId = _data["productId"];
            this.productTypeId = _data["productTypeId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
        }
    }

    static override fromJS(data: any): CertificateProductFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateProductFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productTypeId"] = this.productTypeId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateProductFilter extends IBaseFilter {
    productId?: string | undefined;
    productTypeId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
}

export class ResponseOfCertificateProductAndString implements IResponseOfCertificateProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateProduct | undefined;

    constructor(data?: IResponseOfCertificateProductAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CertificateProduct.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCertificateProductAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateProductAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCertificateProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateProduct | undefined;
}

export class ResponseOfCertificateProduct extends ResponseOfCertificateProductAndString implements IResponseOfCertificateProduct {

    constructor(data?: IResponseOfCertificateProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCertificateProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCertificateProduct extends IResponseOfCertificateProductAndString {
}

export class CertificateProductRequest implements ICertificateProductRequest {
    id?: string | undefined;
    productId?: string | undefined;
    productTypeId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;

    constructor(data?: ICertificateProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productTypeId = _data["productTypeId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
        }
    }

    static fromJS(data: any): CertificateProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productTypeId"] = this.productTypeId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        return data;
    }
}

export interface ICertificateProductRequest {
    id?: string | undefined;
    productId?: string | undefined;
    productTypeId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
}

export class ResponseOfListOfCertificateSkuExtendedAndString implements IResponseOfListOfCertificateSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateSkuExtended[] | undefined;

    constructor(data?: IResponseOfListOfCertificateSkuExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CertificateSkuExtended.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCertificateSkuExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateSkuExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCertificateSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateSkuExtended[] | undefined;
}

export class ResponseOfListOfCertificateSkuExtended extends ResponseOfListOfCertificateSkuExtendedAndString implements IResponseOfListOfCertificateSkuExtended {

    constructor(data?: IResponseOfListOfCertificateSkuExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCertificateSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateSkuExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCertificateSkuExtended extends IResponseOfListOfCertificateSkuExtendedAndString {
}

export class ListResponseOfCertificateSkuExtended extends ResponseOfListOfCertificateSkuExtended implements IListResponseOfCertificateSkuExtended {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCertificateSkuExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCertificateSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCertificateSkuExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCertificateSkuExtended extends IResponseOfListOfCertificateSkuExtended {
    totalRecords?: number | undefined;
}

export class CertificateSku implements ICertificateSku {
    id?: string;
    certificateId?: string;
    skuId?: string;

    constructor(data?: ICertificateSku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.certificateId = _data["certificateId"];
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): CertificateSku {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateSku();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["certificateId"] = this.certificateId;
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface ICertificateSku {
    id?: string;
    certificateId?: string;
    skuId?: string;
}

export class CertificateSkuExtended extends CertificateSku implements ICertificateSkuExtended {
    sku?: string | undefined;

    constructor(data?: ICertificateSkuExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sku = _data["sku"];
        }
    }

    static override fromJS(data: any): CertificateSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateSkuExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateSkuExtended extends ICertificateSku {
    sku?: string | undefined;
}

export class ListRequestOfCertificateSkuFilter implements IListRequestOfCertificateSkuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: CertificateSkuFilter | undefined;

    constructor(data?: IListRequestOfCertificateSkuFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? CertificateSkuFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfCertificateSkuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfCertificateSkuFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfCertificateSkuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: CertificateSkuFilter | undefined;
}

export class CertificateSkuFilter extends BaseFilter implements ICertificateSkuFilter {
    skuId?: string | undefined;

    constructor(data?: ICertificateSkuFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuId = _data["skuId"];
        }
    }

    static override fromJS(data: any): CertificateSkuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateSkuFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateSkuFilter extends IBaseFilter {
    skuId?: string | undefined;
}

export class ResponseOfCertificateSkuExtendedAndString implements IResponseOfCertificateSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateSkuExtended | undefined;

    constructor(data?: IResponseOfCertificateSkuExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CertificateSkuExtended.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCertificateSkuExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateSkuExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCertificateSkuExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateSkuExtended | undefined;
}

export class ResponseOfCertificateSkuExtended extends ResponseOfCertificateSkuExtendedAndString implements IResponseOfCertificateSkuExtended {

    constructor(data?: IResponseOfCertificateSkuExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCertificateSkuExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateSkuExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCertificateSkuExtended extends IResponseOfCertificateSkuExtendedAndString {
}

export class CertificateSkuRequest implements ICertificateSkuRequest {
    id?: string | undefined;
    skuId?: string;

    constructor(data?: ICertificateSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): CertificateSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface ICertificateSkuRequest {
    id?: string | undefined;
    skuId?: string;
}

export class ResponseOfListOfCertificateTemplateAndString implements IResponseOfListOfCertificateTemplateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplate[] | undefined;

    constructor(data?: IResponseOfListOfCertificateTemplateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CertificateTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCertificateTemplateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateTemplateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCertificateTemplateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplate[] | undefined;
}

export class ResponseOfListOfCertificateTemplate extends ResponseOfListOfCertificateTemplateAndString implements IResponseOfListOfCertificateTemplate {

    constructor(data?: IResponseOfListOfCertificateTemplate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCertificateTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateTemplate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCertificateTemplate extends IResponseOfListOfCertificateTemplateAndString {
}

export class ListResponseOfCertificateTemplate extends ResponseOfListOfCertificateTemplate implements IListResponseOfCertificateTemplate {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCertificateTemplate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCertificateTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCertificateTemplate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCertificateTemplate extends IResponseOfListOfCertificateTemplate {
    totalRecords?: number | undefined;
}

export class CertificateTemplate implements ICertificateTemplate {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    templateHtml?: string | undefined;
    unaccredited?: string | undefined;
    isLandscape?: boolean;
    organizationId?: string;
    organizationName?: string | undefined;

    constructor(data?: ICertificateTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.templateHtml = _data["templateHtml"];
            this.unaccredited = _data["unaccredited"];
            this.isLandscape = _data["isLandscape"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): CertificateTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["templateHtml"] = this.templateHtml;
        data["unaccredited"] = this.unaccredited;
        data["isLandscape"] = this.isLandscape;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface ICertificateTemplate {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    templateHtml?: string | undefined;
    unaccredited?: string | undefined;
    isLandscape?: boolean;
    organizationId?: string;
    organizationName?: string | undefined;
}

export class ListRequestOfOrientationFilter implements IListRequestOfOrientationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrientationFilter | undefined;

    constructor(data?: IListRequestOfOrientationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? OrientationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfOrientationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfOrientationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfOrientationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrientationFilter | undefined;
}

export class AdminListRequestOfOrientationFilter extends ListRequestOfOrientationFilter implements IAdminListRequestOfOrientationFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfOrientationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfOrientationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfOrientationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfOrientationFilter extends IListRequestOfOrientationFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class OrientationFilter extends BaseFilter implements IOrientationFilter {
    isLandscape?: boolean | undefined;

    constructor(data?: IOrientationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isLandscape = _data["isLandscape"];
        }
    }

    static override fromJS(data: any): OrientationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OrientationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLandscape"] = this.isLandscape;
        super.toJSON(data);
        return data;
    }
}

export interface IOrientationFilter extends IBaseFilter {
    isLandscape?: boolean | undefined;
}

export class ResponseOfCertificateTemplateAndString implements IResponseOfCertificateTemplateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplate | undefined;

    constructor(data?: IResponseOfCertificateTemplateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CertificateTemplate.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCertificateTemplateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateTemplateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCertificateTemplateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplate | undefined;
}

export class ResponseOfCertificateTemplate extends ResponseOfCertificateTemplateAndString implements IResponseOfCertificateTemplate {

    constructor(data?: IResponseOfCertificateTemplate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCertificateTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateTemplate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCertificateTemplate extends IResponseOfCertificateTemplateAndString {
}

export class CertificateTemplateRequest implements ICertificateTemplateRequest {
    id?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    templateHtml?: string | undefined;
    pdfOptimizedTemplateHtml?: string | undefined;
    unaccredited?: string | undefined;
    isLandscape?: boolean;
    organizationId?: string;

    constructor(data?: ICertificateTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.templateHtml = _data["templateHtml"];
            this.pdfOptimizedTemplateHtml = _data["pdfOptimizedTemplateHtml"];
            this.unaccredited = _data["unaccredited"];
            this.isLandscape = _data["isLandscape"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): CertificateTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["templateHtml"] = this.templateHtml;
        data["pdfOptimizedTemplateHtml"] = this.pdfOptimizedTemplateHtml;
        data["unaccredited"] = this.unaccredited;
        data["isLandscape"] = this.isLandscape;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ICertificateTemplateRequest {
    id?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    templateHtml?: string | undefined;
    pdfOptimizedTemplateHtml?: string | undefined;
    unaccredited?: string | undefined;
    isLandscape?: boolean;
    organizationId?: string;
}

export class ResponseOfCertificateTemplatesOverrideExtendedAndString implements IResponseOfCertificateTemplatesOverrideExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplatesOverrideExtended | undefined;

    constructor(data?: IResponseOfCertificateTemplatesOverrideExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CertificateTemplatesOverrideExtended.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCertificateTemplatesOverrideExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateTemplatesOverrideExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCertificateTemplatesOverrideExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplatesOverrideExtended | undefined;
}

export class ResponseOfCertificateTemplatesOverrideExtended extends ResponseOfCertificateTemplatesOverrideExtendedAndString implements IResponseOfCertificateTemplatesOverrideExtended {

    constructor(data?: IResponseOfCertificateTemplatesOverrideExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCertificateTemplatesOverrideExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateTemplatesOverrideExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCertificateTemplatesOverrideExtended extends IResponseOfCertificateTemplatesOverrideExtendedAndString {
}

export class CertificateTemplatesOverride implements ICertificateTemplatesOverride {
    id?: string;
    professionId?: string | undefined;
    certificateTemplateId?: string;
    templateHtmlOverride?: string | undefined;

    constructor(data?: ICertificateTemplatesOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionId = _data["professionId"];
            this.certificateTemplateId = _data["certificateTemplateId"];
            this.templateHtmlOverride = _data["templateHtmlOverride"];
        }
    }

    static fromJS(data: any): CertificateTemplatesOverride {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTemplatesOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionId"] = this.professionId;
        data["certificateTemplateId"] = this.certificateTemplateId;
        data["templateHtmlOverride"] = this.templateHtmlOverride;
        return data;
    }
}

export interface ICertificateTemplatesOverride {
    id?: string;
    professionId?: string | undefined;
    certificateTemplateId?: string;
    templateHtmlOverride?: string | undefined;
}

export class CertificateTemplatesOverrideExtended extends CertificateTemplatesOverride implements ICertificateTemplatesOverrideExtended {
    profession?: string | undefined;
    isLandscape?: boolean;
    isCertificateOfCompletion?: boolean;

    constructor(data?: ICertificateTemplatesOverrideExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profession = _data["profession"];
            this.isLandscape = _data["isLandscape"];
            this.isCertificateOfCompletion = _data["isCertificateOfCompletion"];
        }
    }

    static override fromJS(data: any): CertificateTemplatesOverrideExtended {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTemplatesOverrideExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profession"] = this.profession;
        data["isLandscape"] = this.isLandscape;
        data["isCertificateOfCompletion"] = this.isCertificateOfCompletion;
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateTemplatesOverrideExtended extends ICertificateTemplatesOverride {
    profession?: string | undefined;
    isLandscape?: boolean;
    isCertificateOfCompletion?: boolean;
}

export class ResponseOfListOfCertificateTemplatesOverrideExtendedAndString implements IResponseOfListOfCertificateTemplatesOverrideExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplatesOverrideExtended[] | undefined;

    constructor(data?: IResponseOfListOfCertificateTemplatesOverrideExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CertificateTemplatesOverrideExtended.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCertificateTemplatesOverrideExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateTemplatesOverrideExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCertificateTemplatesOverrideExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTemplatesOverrideExtended[] | undefined;
}

export class ResponseOfListOfCertificateTemplatesOverrideExtended extends ResponseOfListOfCertificateTemplatesOverrideExtendedAndString implements IResponseOfListOfCertificateTemplatesOverrideExtended {

    constructor(data?: IResponseOfListOfCertificateTemplatesOverrideExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCertificateTemplatesOverrideExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateTemplatesOverrideExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCertificateTemplatesOverrideExtended extends IResponseOfListOfCertificateTemplatesOverrideExtendedAndString {
}

export class ListResponseOfCertificateTemplatesOverrideExtended extends ResponseOfListOfCertificateTemplatesOverrideExtended implements IListResponseOfCertificateTemplatesOverrideExtended {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCertificateTemplatesOverrideExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCertificateTemplatesOverrideExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCertificateTemplatesOverrideExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCertificateTemplatesOverrideExtended extends IResponseOfListOfCertificateTemplatesOverrideExtended {
    totalRecords?: number | undefined;
}

export class CertificateTemplatesOverrideRequest implements ICertificateTemplatesOverrideRequest {
    id?: string | undefined;
    professionId?: string | undefined;
    certificateTemplateId?: string;
    templateHtmlOverride?: string | undefined;
    pdfOptimizedTemplateHtmlOverride?: string | undefined;

    constructor(data?: ICertificateTemplatesOverrideRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionId = _data["professionId"];
            this.certificateTemplateId = _data["certificateTemplateId"];
            this.templateHtmlOverride = _data["templateHtmlOverride"];
            this.pdfOptimizedTemplateHtmlOverride = _data["pdfOptimizedTemplateHtmlOverride"];
        }
    }

    static fromJS(data: any): CertificateTemplatesOverrideRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTemplatesOverrideRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionId"] = this.professionId;
        data["certificateTemplateId"] = this.certificateTemplateId;
        data["templateHtmlOverride"] = this.templateHtmlOverride;
        data["pdfOptimizedTemplateHtmlOverride"] = this.pdfOptimizedTemplateHtmlOverride;
        return data;
    }
}

export interface ICertificateTemplatesOverrideRequest {
    id?: string | undefined;
    professionId?: string | undefined;
    certificateTemplateId?: string;
    templateHtmlOverride?: string | undefined;
    pdfOptimizedTemplateHtmlOverride?: string | undefined;
}

export class ResponseOfCertificateThemeAndString implements IResponseOfCertificateThemeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTheme | undefined;

    constructor(data?: IResponseOfCertificateThemeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CertificateTheme.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCertificateThemeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateThemeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCertificateThemeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTheme | undefined;
}

export class ResponseOfCertificateTheme extends ResponseOfCertificateThemeAndString implements IResponseOfCertificateTheme {

    constructor(data?: IResponseOfCertificateTheme) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCertificateTheme {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCertificateTheme();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCertificateTheme extends IResponseOfCertificateThemeAndString {
}

export class CertificateTheme implements ICertificateTheme {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    isLandscape?: boolean;
    themeHtml?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;

    constructor(data?: ICertificateTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.isLandscape = _data["isLandscape"];
            this.themeHtml = _data["themeHtml"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): CertificateTheme {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["isLandscape"] = this.isLandscape;
        data["themeHtml"] = this.themeHtml;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface ICertificateTheme {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    isLandscape?: boolean;
    themeHtml?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
}

export class ResponseOfListOfCertificateThemeAndString implements IResponseOfListOfCertificateThemeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTheme[] | undefined;

    constructor(data?: IResponseOfListOfCertificateThemeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CertificateTheme.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCertificateThemeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateThemeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCertificateThemeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CertificateTheme[] | undefined;
}

export class ResponseOfListOfCertificateTheme extends ResponseOfListOfCertificateThemeAndString implements IResponseOfListOfCertificateTheme {

    constructor(data?: IResponseOfListOfCertificateTheme) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCertificateTheme {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCertificateTheme();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCertificateTheme extends IResponseOfListOfCertificateThemeAndString {
}

export class ListResponseOfCertificateTheme extends ResponseOfListOfCertificateTheme implements IListResponseOfCertificateTheme {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCertificateTheme) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCertificateTheme {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCertificateTheme();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCertificateTheme extends IResponseOfListOfCertificateTheme {
    totalRecords?: number | undefined;
}

export class CertificateThemeRequest implements ICertificateThemeRequest {
    id?: string | undefined;
    name!: string;
    value!: string;
    description?: string | undefined;
    isLandscape?: boolean;
    themeHtml?: string | undefined;
    pdfOptimizedThemeHtml?: string | undefined;
    organizationId?: string;

    constructor(data?: ICertificateThemeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.isLandscape = _data["isLandscape"];
            this.themeHtml = _data["themeHtml"];
            this.pdfOptimizedThemeHtml = _data["pdfOptimizedThemeHtml"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): CertificateThemeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateThemeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["isLandscape"] = this.isLandscape;
        data["themeHtml"] = this.themeHtml;
        data["pdfOptimizedThemeHtml"] = this.pdfOptimizedThemeHtml;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ICertificateThemeRequest {
    id?: string | undefined;
    name: string;
    value: string;
    description?: string | undefined;
    isLandscape?: boolean;
    themeHtml?: string | undefined;
    pdfOptimizedThemeHtml?: string | undefined;
    organizationId?: string;
}

export class ReprocessCompletionsRequest implements IReprocessCompletionsRequest {
    userDeliverablesCompletionIds!: string[];
    changeReason!: string;
    sendEmails?: boolean;
    deleteSubmissions?: boolean;
    deleteUserCertificates?: boolean;

    constructor(data?: IReprocessCompletionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userDeliverablesCompletionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userDeliverablesCompletionIds"])) {
                this.userDeliverablesCompletionIds = [] as any;
                for (let item of _data["userDeliverablesCompletionIds"])
                    this.userDeliverablesCompletionIds!.push(item);
            }
            this.changeReason = _data["changeReason"];
            this.sendEmails = _data["sendEmails"];
            this.deleteSubmissions = _data["deleteSubmissions"];
            this.deleteUserCertificates = _data["deleteUserCertificates"];
        }
    }

    static fromJS(data: any): ReprocessCompletionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReprocessCompletionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userDeliverablesCompletionIds)) {
            data["userDeliverablesCompletionIds"] = [];
            for (let item of this.userDeliverablesCompletionIds)
                data["userDeliverablesCompletionIds"].push(item);
        }
        data["changeReason"] = this.changeReason;
        data["sendEmails"] = this.sendEmails;
        data["deleteSubmissions"] = this.deleteSubmissions;
        data["deleteUserCertificates"] = this.deleteUserCertificates;
        return data;
    }
}

export interface IReprocessCompletionsRequest {
    userDeliverablesCompletionIds: string[];
    changeReason: string;
    sendEmails?: boolean;
    deleteSubmissions?: boolean;
    deleteUserCertificates?: boolean;
}

export class ResponseOfListOfLicenseListItemAndString implements IResponseOfListOfLicenseListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseListItem[] | undefined;

    constructor(data?: IResponseOfListOfLicenseListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LicenseListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfLicenseListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLicenseListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfLicenseListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseListItem[] | undefined;
}

export class ResponseOfListOfLicenseListItem extends ResponseOfListOfLicenseListItemAndString implements IResponseOfListOfLicenseListItem {

    constructor(data?: IResponseOfListOfLicenseListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfLicenseListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLicenseListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfLicenseListItem extends IResponseOfListOfLicenseListItemAndString {
}

export class ListResponseOfLicenseListItem extends ResponseOfListOfLicenseListItem implements IListResponseOfLicenseListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfLicenseListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfLicenseListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfLicenseListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfLicenseListItem extends IResponseOfListOfLicenseListItem {
    totalRecords?: number | undefined;
}

export class LicenseListItem implements ILicenseListItem {
    id?: string;
    displayName?: string | undefined;
    designationName?: string | undefined;
    designationAcronym?: string | undefined;
    professions?: string[] | undefined;
    locationName?: string | undefined;
    licensureBodyName?: string | undefined;
    licensureBodyAcronym?: string | undefined;
    qualificationId?: string | undefined;
    accreditationBodyName?: string | undefined;
    accreditationBodyAcronym?: string | undefined;
    submissionAuthorityName?: string | undefined;
    sequence?: number | undefined;
    isAlwaysShown?: boolean | undefined;

    constructor(data?: ILicenseListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.designationName = _data["designationName"];
            this.designationAcronym = _data["designationAcronym"];
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(item);
            }
            this.locationName = _data["locationName"];
            this.licensureBodyName = _data["licensureBodyName"];
            this.licensureBodyAcronym = _data["licensureBodyAcronym"];
            this.qualificationId = _data["qualificationId"];
            this.accreditationBodyName = _data["accreditationBodyName"];
            this.accreditationBodyAcronym = _data["accreditationBodyAcronym"];
            this.submissionAuthorityName = _data["submissionAuthorityName"];
            this.sequence = _data["sequence"];
            this.isAlwaysShown = _data["isAlwaysShown"];
        }
    }

    static fromJS(data: any): LicenseListItem {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["designationName"] = this.designationName;
        data["designationAcronym"] = this.designationAcronym;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item);
        }
        data["locationName"] = this.locationName;
        data["licensureBodyName"] = this.licensureBodyName;
        data["licensureBodyAcronym"] = this.licensureBodyAcronym;
        data["qualificationId"] = this.qualificationId;
        data["accreditationBodyName"] = this.accreditationBodyName;
        data["accreditationBodyAcronym"] = this.accreditationBodyAcronym;
        data["submissionAuthorityName"] = this.submissionAuthorityName;
        data["sequence"] = this.sequence;
        data["isAlwaysShown"] = this.isAlwaysShown;
        return data;
    }
}

export interface ILicenseListItem {
    id?: string;
    displayName?: string | undefined;
    designationName?: string | undefined;
    designationAcronym?: string | undefined;
    professions?: string[] | undefined;
    locationName?: string | undefined;
    licensureBodyName?: string | undefined;
    licensureBodyAcronym?: string | undefined;
    qualificationId?: string | undefined;
    accreditationBodyName?: string | undefined;
    accreditationBodyAcronym?: string | undefined;
    submissionAuthorityName?: string | undefined;
    sequence?: number | undefined;
    isAlwaysShown?: boolean | undefined;
}

export class ListRequestOfLicenseAdminFilter implements IListRequestOfLicenseAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: LicenseAdminFilter | undefined;

    constructor(data?: IListRequestOfLicenseAdminFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? LicenseAdminFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfLicenseAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfLicenseAdminFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfLicenseAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: LicenseAdminFilter | undefined;
}

export class LicenseAdminFilter extends BaseFilter implements ILicenseAdminFilter {
    designationIds?: string[] | undefined;
    professionIds?: string[] | undefined;
    locationIds?: string[] | undefined;
    licensureBodyIds?: string[] | undefined;

    constructor(data?: ILicenseAdminFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["designationIds"])) {
                this.designationIds = [] as any;
                for (let item of _data["designationIds"])
                    this.designationIds!.push(item);
            }
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["licensureBodyIds"])) {
                this.licensureBodyIds = [] as any;
                for (let item of _data["licensureBodyIds"])
                    this.licensureBodyIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): LicenseAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseAdminFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.designationIds)) {
            data["designationIds"] = [];
            for (let item of this.designationIds)
                data["designationIds"].push(item);
        }
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.licensureBodyIds)) {
            data["licensureBodyIds"] = [];
            for (let item of this.licensureBodyIds)
                data["licensureBodyIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILicenseAdminFilter extends IBaseFilter {
    designationIds?: string[] | undefined;
    professionIds?: string[] | undefined;
    locationIds?: string[] | undefined;
    licensureBodyIds?: string[] | undefined;
}

export class ResponseOfLicenseDetailAndString implements IResponseOfLicenseDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseDetail | undefined;

    constructor(data?: IResponseOfLicenseDetailAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? LicenseDetail.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfLicenseDetailAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicenseDetailAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfLicenseDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseDetail | undefined;
}

export class ResponseOfLicenseDetail extends ResponseOfLicenseDetailAndString implements IResponseOfLicenseDetail {

    constructor(data?: IResponseOfLicenseDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfLicenseDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicenseDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfLicenseDetail extends IResponseOfLicenseDetailAndString {
}

export class LicenseDetail implements ILicenseDetail {
    id?: string;
    displayName?: string | undefined;
    designationName?: string | undefined;
    designationAcronym?: string | undefined;
    professions?: string[] | undefined;
    locationName?: string | undefined;
    locationTypeName?: string | undefined;
    licensureBodyName?: string | undefined;
    licensureBodyAcronym?: string | undefined;
    qualificationId?: string | undefined;
    accreditationBodyName?: string | undefined;
    accreditationBodyAcronym?: string | undefined;
    submissionAuthorityName?: string | undefined;
    sequence?: number | undefined;
    isAlwaysShown?: boolean | undefined;
    questions?: LicenseQuestionDetail[] | undefined;

    constructor(data?: ILicenseDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.designationName = _data["designationName"];
            this.designationAcronym = _data["designationAcronym"];
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(item);
            }
            this.locationName = _data["locationName"];
            this.locationTypeName = _data["locationTypeName"];
            this.licensureBodyName = _data["licensureBodyName"];
            this.licensureBodyAcronym = _data["licensureBodyAcronym"];
            this.qualificationId = _data["qualificationId"];
            this.accreditationBodyName = _data["accreditationBodyName"];
            this.accreditationBodyAcronym = _data["accreditationBodyAcronym"];
            this.submissionAuthorityName = _data["submissionAuthorityName"];
            this.sequence = _data["sequence"];
            this.isAlwaysShown = _data["isAlwaysShown"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(LicenseQuestionDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseDetail {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["designationName"] = this.designationName;
        data["designationAcronym"] = this.designationAcronym;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item);
        }
        data["locationName"] = this.locationName;
        data["locationTypeName"] = this.locationTypeName;
        data["licensureBodyName"] = this.licensureBodyName;
        data["licensureBodyAcronym"] = this.licensureBodyAcronym;
        data["qualificationId"] = this.qualificationId;
        data["accreditationBodyName"] = this.accreditationBodyName;
        data["accreditationBodyAcronym"] = this.accreditationBodyAcronym;
        data["submissionAuthorityName"] = this.submissionAuthorityName;
        data["sequence"] = this.sequence;
        data["isAlwaysShown"] = this.isAlwaysShown;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseDetail {
    id?: string;
    displayName?: string | undefined;
    designationName?: string | undefined;
    designationAcronym?: string | undefined;
    professions?: string[] | undefined;
    locationName?: string | undefined;
    locationTypeName?: string | undefined;
    licensureBodyName?: string | undefined;
    licensureBodyAcronym?: string | undefined;
    qualificationId?: string | undefined;
    accreditationBodyName?: string | undefined;
    accreditationBodyAcronym?: string | undefined;
    submissionAuthorityName?: string | undefined;
    sequence?: number | undefined;
    isAlwaysShown?: boolean | undefined;
    questions?: LicenseQuestionDetail[] | undefined;
}

export class LicenseQuestionDetail implements ILicenseQuestionDetail {
    id?: string;
    licenseQuestionId?: string;
    organizationLicenseQuestionId?: string | undefined;
    sequence?: number;
    question?: string | undefined;
    type?: string | undefined;
    required?: boolean;
    defaultValue?: string | undefined;
    questionValidationRuleId?: string | undefined;
    validationRuleName?: string | undefined;
    validationRuleRegex?: string | undefined;
    inheritedFrom?: string | undefined;

    constructor(data?: ILicenseQuestionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseQuestionId = _data["licenseQuestionId"];
            this.organizationLicenseQuestionId = _data["organizationLicenseQuestionId"];
            this.sequence = _data["sequence"];
            this.question = _data["question"];
            this.type = _data["type"];
            this.required = _data["required"];
            this.defaultValue = _data["defaultValue"];
            this.questionValidationRuleId = _data["questionValidationRuleId"];
            this.validationRuleName = _data["validationRuleName"];
            this.validationRuleRegex = _data["validationRuleRegex"];
            this.inheritedFrom = _data["inheritedFrom"];
        }
    }

    static fromJS(data: any): LicenseQuestionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseQuestionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseQuestionId"] = this.licenseQuestionId;
        data["organizationLicenseQuestionId"] = this.organizationLicenseQuestionId;
        data["sequence"] = this.sequence;
        data["question"] = this.question;
        data["type"] = this.type;
        data["required"] = this.required;
        data["defaultValue"] = this.defaultValue;
        data["questionValidationRuleId"] = this.questionValidationRuleId;
        data["validationRuleName"] = this.validationRuleName;
        data["validationRuleRegex"] = this.validationRuleRegex;
        data["inheritedFrom"] = this.inheritedFrom;
        return data;
    }
}

export interface ILicenseQuestionDetail {
    id?: string;
    licenseQuestionId?: string;
    organizationLicenseQuestionId?: string | undefined;
    sequence?: number;
    question?: string | undefined;
    type?: string | undefined;
    required?: boolean;
    defaultValue?: string | undefined;
    questionValidationRuleId?: string | undefined;
    validationRuleName?: string | undefined;
    validationRuleRegex?: string | undefined;
    inheritedFrom?: string | undefined;
}

export class ResponseOfLicenseFilterOptionsAndString implements IResponseOfLicenseFilterOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseFilterOptions | undefined;

    constructor(data?: IResponseOfLicenseFilterOptionsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? LicenseFilterOptions.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfLicenseFilterOptionsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicenseFilterOptionsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfLicenseFilterOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseFilterOptions | undefined;
}

export class ResponseOfLicenseFilterOptions extends ResponseOfLicenseFilterOptionsAndString implements IResponseOfLicenseFilterOptions {

    constructor(data?: IResponseOfLicenseFilterOptions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfLicenseFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicenseFilterOptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfLicenseFilterOptions extends IResponseOfLicenseFilterOptionsAndString {
}

export class LicenseFilterOptions implements ILicenseFilterOptions {
    designations?: IdNameModel[] | undefined;
    locations?: IdNameModel[] | undefined;
    licensureBodies?: IdNameModel[] | undefined;

    constructor(data?: ILicenseFilterOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["designations"])) {
                this.designations = [] as any;
                for (let item of _data["designations"])
                    this.designations!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["licensureBodies"])) {
                this.licensureBodies = [] as any;
                for (let item of _data["licensureBodies"])
                    this.licensureBodies!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseFilterOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.designations)) {
            data["designations"] = [];
            for (let item of this.designations)
                data["designations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.licensureBodies)) {
            data["licensureBodies"] = [];
            for (let item of this.licensureBodies)
                data["licensureBodies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseFilterOptions {
    designations?: IdNameModel[] | undefined;
    locations?: IdNameModel[] | undefined;
    licensureBodies?: IdNameModel[] | undefined;
}

export class ResponseOfListOfRegexValidationAndString implements IResponseOfListOfRegexValidationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegexValidation[] | undefined;

    constructor(data?: IResponseOfListOfRegexValidationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RegexValidation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRegexValidationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRegexValidationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRegexValidationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegexValidation[] | undefined;
}

export class ResponseOfListOfRegexValidation extends ResponseOfListOfRegexValidationAndString implements IResponseOfListOfRegexValidation {

    constructor(data?: IResponseOfListOfRegexValidation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRegexValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRegexValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRegexValidation extends IResponseOfListOfRegexValidationAndString {
}

export class ListResponseOfRegexValidation extends ResponseOfListOfRegexValidation implements IListResponseOfRegexValidation {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRegexValidation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRegexValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRegexValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRegexValidation extends IResponseOfListOfRegexValidation {
    totalRecords?: number | undefined;
}

export class RegexValidation implements IRegexValidation {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    message?: string | undefined;
    credentialCount?: number;

    constructor(data?: IRegexValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.message = _data["message"];
            this.credentialCount = _data["credentialCount"];
        }
    }

    static fromJS(data: any): RegexValidation {
        data = typeof data === 'object' ? data : {};
        let result = new RegexValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["message"] = this.message;
        data["credentialCount"] = this.credentialCount;
        return data;
    }
}

export interface IRegexValidation {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    message?: string | undefined;
    credentialCount?: number;
}

export class ListRequestOfRegexValidationFilter implements IListRequestOfRegexValidationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RegexValidationFilter | undefined;

    constructor(data?: IListRequestOfRegexValidationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? RegexValidationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfRegexValidationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfRegexValidationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfRegexValidationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RegexValidationFilter | undefined;
}

export class RegexValidationFilter extends BaseFilter implements IRegexValidationFilter {
    locationIds?: string[] | undefined;
    professionIds?: string[] | undefined;
    credentialIds?: string[] | undefined;

    constructor(data?: IRegexValidationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            if (Array.isArray(_data["credentialIds"])) {
                this.credentialIds = [] as any;
                for (let item of _data["credentialIds"])
                    this.credentialIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): RegexValidationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RegexValidationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        if (Array.isArray(this.credentialIds)) {
            data["credentialIds"] = [];
            for (let item of this.credentialIds)
                data["credentialIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRegexValidationFilter extends IBaseFilter {
    locationIds?: string[] | undefined;
    professionIds?: string[] | undefined;
    credentialIds?: string[] | undefined;
}

export class ResponseOfRegexValidationFilterOptionsAndString implements IResponseOfRegexValidationFilterOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegexValidationFilterOptions | undefined;

    constructor(data?: IResponseOfRegexValidationFilterOptionsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RegexValidationFilterOptions.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRegexValidationFilterOptionsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRegexValidationFilterOptionsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRegexValidationFilterOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegexValidationFilterOptions | undefined;
}

export class ResponseOfRegexValidationFilterOptions extends ResponseOfRegexValidationFilterOptionsAndString implements IResponseOfRegexValidationFilterOptions {

    constructor(data?: IResponseOfRegexValidationFilterOptions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRegexValidationFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRegexValidationFilterOptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRegexValidationFilterOptions extends IResponseOfRegexValidationFilterOptionsAndString {
}

export class RegexValidationFilterOptions implements IRegexValidationFilterOptions {
    locations?: IdNameModel[] | undefined;
    professions?: IdNameModel[] | undefined;
    credentials?: IdNameModel[] | undefined;

    constructor(data?: IRegexValidationFilterOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["credentials"])) {
                this.credentials = [] as any;
                for (let item of _data["credentials"])
                    this.credentials!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegexValidationFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new RegexValidationFilterOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.credentials)) {
            data["credentials"] = [];
            for (let item of this.credentials)
                data["credentials"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegexValidationFilterOptions {
    locations?: IdNameModel[] | undefined;
    professions?: IdNameModel[] | undefined;
    credentials?: IdNameModel[] | undefined;
}

export class ResponseOfListOfRegexValidationCredentialAndString implements IResponseOfListOfRegexValidationCredentialAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegexValidationCredential[] | undefined;

    constructor(data?: IResponseOfListOfRegexValidationCredentialAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RegexValidationCredential.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRegexValidationCredentialAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRegexValidationCredentialAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRegexValidationCredentialAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RegexValidationCredential[] | undefined;
}

export class ResponseOfListOfRegexValidationCredential extends ResponseOfListOfRegexValidationCredentialAndString implements IResponseOfListOfRegexValidationCredential {

    constructor(data?: IResponseOfListOfRegexValidationCredential) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRegexValidationCredential {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRegexValidationCredential();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRegexValidationCredential extends IResponseOfListOfRegexValidationCredentialAndString {
}

export class ListResponseOfRegexValidationCredential extends ResponseOfListOfRegexValidationCredential implements IListResponseOfRegexValidationCredential {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRegexValidationCredential) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRegexValidationCredential {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRegexValidationCredential();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRegexValidationCredential extends IResponseOfListOfRegexValidationCredential {
    totalRecords?: number | undefined;
}

export class RegexValidationCredential implements IRegexValidationCredential {
    id?: string;
    displayName?: string | undefined;
    appliedByDefault?: boolean;
    organizationsUsingThisValidationCount?: number;
    organizationsSkippingThisValidationCount?: number;

    constructor(data?: IRegexValidationCredential) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.appliedByDefault = _data["appliedByDefault"];
            this.organizationsUsingThisValidationCount = _data["organizationsUsingThisValidationCount"];
            this.organizationsSkippingThisValidationCount = _data["organizationsSkippingThisValidationCount"];
        }
    }

    static fromJS(data: any): RegexValidationCredential {
        data = typeof data === 'object' ? data : {};
        let result = new RegexValidationCredential();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["appliedByDefault"] = this.appliedByDefault;
        data["organizationsUsingThisValidationCount"] = this.organizationsUsingThisValidationCount;
        data["organizationsSkippingThisValidationCount"] = this.organizationsSkippingThisValidationCount;
        return data;
    }
}

export interface IRegexValidationCredential {
    id?: string;
    displayName?: string | undefined;
    appliedByDefault?: boolean;
    organizationsUsingThisValidationCount?: number;
    organizationsSkippingThisValidationCount?: number;
}

export class RegexValidationSaveRequest implements IRegexValidationSaveRequest {
    id?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    message?: string | undefined;

    constructor(data?: IRegexValidationSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RegexValidationSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegexValidationSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["message"] = this.message;
        return data;
    }
}

export interface IRegexValidationSaveRequest {
    id?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    message?: string | undefined;
}

export class LicenseQuestionRequest implements ILicenseQuestionRequest {
    id?: string | undefined;
    licenseQuestionId?: string | undefined;
    questionValidationRuleId?: string | undefined;
    value?: string | undefined;
    required?: boolean;
    sequence?: number;

    constructor(data?: ILicenseQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseQuestionId = _data["licenseQuestionId"];
            this.questionValidationRuleId = _data["questionValidationRuleId"];
            this.value = _data["value"];
            this.required = _data["required"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): LicenseQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseQuestionId"] = this.licenseQuestionId;
        data["questionValidationRuleId"] = this.questionValidationRuleId;
        data["value"] = this.value;
        data["required"] = this.required;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface ILicenseQuestionRequest {
    id?: string | undefined;
    licenseQuestionId?: string | undefined;
    questionValidationRuleId?: string | undefined;
    value?: string | undefined;
    required?: boolean;
    sequence?: number;
}

export class ResponseOfLicenseTrackerAvailabilityAndString implements IResponseOfLicenseTrackerAvailabilityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseTrackerAvailability | undefined;

    constructor(data?: IResponseOfLicenseTrackerAvailabilityAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? LicenseTrackerAvailability.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfLicenseTrackerAvailabilityAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicenseTrackerAvailabilityAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfLicenseTrackerAvailabilityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicenseTrackerAvailability | undefined;
}

export class ResponseOfLicenseTrackerAvailability extends ResponseOfLicenseTrackerAvailabilityAndString implements IResponseOfLicenseTrackerAvailability {

    constructor(data?: IResponseOfLicenseTrackerAvailability) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfLicenseTrackerAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicenseTrackerAvailability();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfLicenseTrackerAvailability extends IResponseOfLicenseTrackerAvailabilityAndString {
}

export class LicenseTrackerAvailability implements ILicenseTrackerAvailability {
    licenseId?: string;
    hasGoverningRequirementSet?: boolean;
    organizations?: LicenseTrackerAvailabilityItem[] | undefined;

    constructor(data?: ILicenseTrackerAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.hasGoverningRequirementSet = _data["hasGoverningRequirementSet"];
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(LicenseTrackerAvailabilityItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseTrackerAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseTrackerAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["hasGoverningRequirementSet"] = this.hasGoverningRequirementSet;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseTrackerAvailability {
    licenseId?: string;
    hasGoverningRequirementSet?: boolean;
    organizations?: LicenseTrackerAvailabilityItem[] | undefined;
}

export class LicenseTrackerAvailabilityItem implements ILicenseTrackerAvailabilityItem {
    organizationId?: string;
    organizationName?: string | undefined;
    status?: OrganizationLicenseTrackerLicenseStatusEnum;
    setBy?: string | undefined;
    setOn?: Date | undefined;

    constructor(data?: ILicenseTrackerAvailabilityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.status = _data["status"];
            this.setBy = _data["setBy"];
            this.setOn = _data["setOn"] ? new Date(_data["setOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LicenseTrackerAvailabilityItem {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseTrackerAvailabilityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["status"] = this.status;
        data["setBy"] = this.setBy;
        data["setOn"] = this.setOn ? this.setOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ILicenseTrackerAvailabilityItem {
    organizationId?: string;
    organizationName?: string | undefined;
    status?: OrganizationLicenseTrackerLicenseStatusEnum;
    setBy?: string | undefined;
    setOn?: Date | undefined;
}

export enum OrganizationLicenseTrackerLicenseStatusEnum {
    Released = "Released",
    ComingSoon = "ComingSoon",
    NotPlanned = "NotPlanned",
}

export class SetLicenseTrackerAvailabilityRequest implements ISetLicenseTrackerAvailabilityRequest {
    organizationId?: string;
    licenseId?: string;
    status?: OrganizationLicenseTrackerLicenseStatusEnum;

    constructor(data?: ISetLicenseTrackerAvailabilityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.licenseId = _data["licenseId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SetLicenseTrackerAvailabilityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLicenseTrackerAvailabilityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["licenseId"] = this.licenseId;
        data["status"] = this.status;
        return data;
    }
}

export interface ISetLicenseTrackerAvailabilityRequest {
    organizationId?: string;
    licenseId?: string;
    status?: OrganizationLicenseTrackerLicenseStatusEnum;
}

export class ResponseOfListOfLicensureBodyListItemAndString implements IResponseOfListOfLicensureBodyListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicensureBodyListItem[] | undefined;

    constructor(data?: IResponseOfListOfLicensureBodyListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LicensureBodyListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfLicensureBodyListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLicensureBodyListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfLicensureBodyListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicensureBodyListItem[] | undefined;
}

export class ResponseOfListOfLicensureBodyListItem extends ResponseOfListOfLicensureBodyListItemAndString implements IResponseOfListOfLicensureBodyListItem {

    constructor(data?: IResponseOfListOfLicensureBodyListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfLicensureBodyListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLicensureBodyListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfLicensureBodyListItem extends IResponseOfListOfLicensureBodyListItemAndString {
}

export class ListResponseOfLicensureBodyListItem extends ResponseOfListOfLicensureBodyListItem implements IListResponseOfLicensureBodyListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfLicensureBodyListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfLicensureBodyListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfLicensureBodyListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfLicensureBodyListItem extends IResponseOfListOfLicensureBodyListItem {
    totalRecords?: number | undefined;
}

export class LicensureBodyListItem implements ILicensureBodyListItem {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;
    submissionAuthorityName?: string | undefined;

    constructor(data?: ILicensureBodyListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.acronym = _data["acronym"];
            this.submissionAuthorityName = _data["submissionAuthorityName"];
        }
    }

    static fromJS(data: any): LicensureBodyListItem {
        data = typeof data === 'object' ? data : {};
        let result = new LicensureBodyListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["acronym"] = this.acronym;
        data["submissionAuthorityName"] = this.submissionAuthorityName;
        return data;
    }
}

export interface ILicensureBodyListItem {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;
    submissionAuthorityName?: string | undefined;
}

export class ListRequestOfLicensureBodyAdminFilter implements IListRequestOfLicensureBodyAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: LicensureBodyAdminFilter | undefined;

    constructor(data?: IListRequestOfLicensureBodyAdminFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? LicensureBodyAdminFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfLicensureBodyAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfLicensureBodyAdminFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfLicensureBodyAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: LicensureBodyAdminFilter | undefined;
}

export class LicensureBodyAdminFilter extends BaseFilter implements ILicensureBodyAdminFilter {
    submissionAuthorityTypeIds?: string[] | undefined;

    constructor(data?: ILicensureBodyAdminFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["submissionAuthorityTypeIds"])) {
                this.submissionAuthorityTypeIds = [] as any;
                for (let item of _data["submissionAuthorityTypeIds"])
                    this.submissionAuthorityTypeIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): LicensureBodyAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new LicensureBodyAdminFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.submissionAuthorityTypeIds)) {
            data["submissionAuthorityTypeIds"] = [];
            for (let item of this.submissionAuthorityTypeIds)
                data["submissionAuthorityTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILicensureBodyAdminFilter extends IBaseFilter {
    submissionAuthorityTypeIds?: string[] | undefined;
}

export class ResponseOfLicensureBodyDetailAndString implements IResponseOfLicensureBodyDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicensureBodyDetail | undefined;

    constructor(data?: IResponseOfLicensureBodyDetailAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? LicensureBodyDetail.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfLicensureBodyDetailAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicensureBodyDetailAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfLicensureBodyDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicensureBodyDetail | undefined;
}

export class ResponseOfLicensureBodyDetail extends ResponseOfLicensureBodyDetailAndString implements IResponseOfLicensureBodyDetail {

    constructor(data?: IResponseOfLicensureBodyDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfLicensureBodyDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLicensureBodyDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfLicensureBodyDetail extends IResponseOfLicensureBodyDetailAndString {
}

export class LicensureBodyDetail implements ILicensureBodyDetail {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;
    description?: string | undefined;
    accreditationChain?: AccreditationChainItem[] | undefined;

    constructor(data?: ILicensureBodyDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.acronym = _data["acronym"];
            this.description = _data["description"];
            if (Array.isArray(_data["accreditationChain"])) {
                this.accreditationChain = [] as any;
                for (let item of _data["accreditationChain"])
                    this.accreditationChain!.push(AccreditationChainItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicensureBodyDetail {
        data = typeof data === 'object' ? data : {};
        let result = new LicensureBodyDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["acronym"] = this.acronym;
        data["description"] = this.description;
        if (Array.isArray(this.accreditationChain)) {
            data["accreditationChain"] = [];
            for (let item of this.accreditationChain)
                data["accreditationChain"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicensureBodyDetail {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;
    description?: string | undefined;
    accreditationChain?: AccreditationChainItem[] | undefined;
}

export class LicensureBodyRequest implements ILicensureBodyRequest {
    id?: string | undefined;
    name?: string | undefined;
    acronym?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILicensureBodyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.acronym = _data["acronym"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LicensureBodyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LicensureBodyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["acronym"] = this.acronym;
        data["description"] = this.description;
        return data;
    }
}

export interface ILicensureBodyRequest {
    id?: string | undefined;
    name?: string | undefined;
    acronym?: string | undefined;
    description?: string | undefined;
}

export class ResponseOfProfessionalInformationResponseAndString implements IResponseOfProfessionalInformationResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProfessionalInformationResponse | undefined;

    constructor(data?: IResponseOfProfessionalInformationResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ProfessionalInformationResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfProfessionalInformationResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProfessionalInformationResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfProfessionalInformationResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProfessionalInformationResponse | undefined;
}

export class ResponseOfProfessionalInformationResponse extends ResponseOfProfessionalInformationResponseAndString implements IResponseOfProfessionalInformationResponse {

    constructor(data?: IResponseOfProfessionalInformationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfProfessionalInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProfessionalInformationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfProfessionalInformationResponse extends IResponseOfProfessionalInformationResponseAndString {
}

export class ProfessionalInformationResponse implements IProfessionalInformationResponse {
    organizationUserId?: string;
    questionSets?: QuestionSet[] | undefined;

    constructor(data?: IProfessionalInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUserId = _data["organizationUserId"];
            if (Array.isArray(_data["questionSets"])) {
                this.questionSets = [] as any;
                for (let item of _data["questionSets"])
                    this.questionSets!.push(QuestionSet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionalInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUserId"] = this.organizationUserId;
        if (Array.isArray(this.questionSets)) {
            data["questionSets"] = [];
            for (let item of this.questionSets)
                data["questionSets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfessionalInformationResponse {
    organizationUserId?: string;
    questionSets?: QuestionSet[] | undefined;
}

export class QuestionSet implements IQuestionSet {
    id?: string;
    headingText?: string | undefined;
    questions?: DemographicQuestion[] | undefined;

    constructor(data?: IQuestionSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.headingText = _data["headingText"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(DemographicQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionSet {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["headingText"] = this.headingText;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionSet {
    id?: string;
    headingText?: string | undefined;
    questions?: DemographicQuestion[] | undefined;
}

export class DemographicQuestion implements IDemographicQuestion {
    id?: string;
    questionId?: string;
    value!: string;
    sequence?: number;
    type?: QuestionTypeEnum;
    response?: string | undefined;
    responseId?: string | undefined;
    responseArray?: string[] | undefined;
    userResponse?: string | undefined;
    userResponseId?: string | undefined;
    userResponseArray?: string[] | undefined;
    isRequired?: boolean;
    isLocked?: boolean;
    codeConstant?: string | undefined;
    autocompleteToken?: string | undefined;
    validationRule?: ValidationRule | undefined;
    choices?: Choice[] | undefined;

    constructor(data?: IDemographicQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.value = _data["value"];
            this.sequence = _data["sequence"];
            this.type = _data["type"];
            this.response = _data["response"];
            this.responseId = _data["responseId"];
            if (Array.isArray(_data["responseArray"])) {
                this.responseArray = [] as any;
                for (let item of _data["responseArray"])
                    this.responseArray!.push(item);
            }
            this.userResponse = _data["userResponse"];
            this.userResponseId = _data["userResponseId"];
            if (Array.isArray(_data["userResponseArray"])) {
                this.userResponseArray = [] as any;
                for (let item of _data["userResponseArray"])
                    this.userResponseArray!.push(item);
            }
            this.isRequired = _data["isRequired"];
            this.isLocked = _data["isLocked"];
            this.codeConstant = _data["codeConstant"];
            this.autocompleteToken = _data["autocompleteToken"];
            this.validationRule = _data["validationRule"] ? ValidationRule.fromJS(_data["validationRule"]) : undefined as any;
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(Choice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DemographicQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new DemographicQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["value"] = this.value;
        data["sequence"] = this.sequence;
        data["type"] = this.type;
        data["response"] = this.response;
        data["responseId"] = this.responseId;
        if (Array.isArray(this.responseArray)) {
            data["responseArray"] = [];
            for (let item of this.responseArray)
                data["responseArray"].push(item);
        }
        data["userResponse"] = this.userResponse;
        data["userResponseId"] = this.userResponseId;
        if (Array.isArray(this.userResponseArray)) {
            data["userResponseArray"] = [];
            for (let item of this.userResponseArray)
                data["userResponseArray"].push(item);
        }
        data["isRequired"] = this.isRequired;
        data["isLocked"] = this.isLocked;
        data["codeConstant"] = this.codeConstant;
        data["autocompleteToken"] = this.autocompleteToken;
        data["validationRule"] = this.validationRule ? this.validationRule.toJSON() : undefined as any;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDemographicQuestion {
    id?: string;
    questionId?: string;
    value: string;
    sequence?: number;
    type?: QuestionTypeEnum;
    response?: string | undefined;
    responseId?: string | undefined;
    responseArray?: string[] | undefined;
    userResponse?: string | undefined;
    userResponseId?: string | undefined;
    userResponseArray?: string[] | undefined;
    isRequired?: boolean;
    isLocked?: boolean;
    codeConstant?: string | undefined;
    autocompleteToken?: string | undefined;
    validationRule?: ValidationRule | undefined;
    choices?: Choice[] | undefined;
}

export enum QuestionTypeEnum {
    SingleLineTextInput = "SingleLineTextInput",
    MultiLineTextInput = "MultiLineTextInput",
    SingleSelect = "SingleSelect",
    MultiSelect = "MultiSelect",
    CheckboxList = "CheckboxList",
    TwoOptionsRadioButton = "TwoOptionsRadioButton",
    LookupQuestion = "LookupQuestion",
    Date = "Date",
    CreatableSingleSelect = "CreatableSingleSelect",
    CreatableMultiSelect = "CreatableMultiSelect",
    ConsentCheckbox = "ConsentCheckbox",
}

export class ValidationRule implements IValidationRule {
    value?: string | undefined;
    message?: string | undefined;
    questionValidationTypeId?: string | undefined;

    constructor(data?: IValidationRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.message = _data["message"];
            this.questionValidationTypeId = _data["questionValidationTypeId"];
        }
    }

    static fromJS(data: any): ValidationRule {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["message"] = this.message;
        data["questionValidationTypeId"] = this.questionValidationTypeId;
        return data;
    }
}

export interface IValidationRule {
    value?: string | undefined;
    message?: string | undefined;
    questionValidationTypeId?: string | undefined;
}

export class Choice implements IChoice {
    id?: string;
    value?: string | undefined;
    sequence?: number;

    constructor(data?: IChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): Choice {
        data = typeof data === 'object' ? data : {};
        let result = new Choice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IChoice {
    id?: string;
    value?: string | undefined;
    sequence?: number;
}

export class SaveProfessionalInformationRequest extends UserScopeRequest implements ISaveProfessionalInformationRequest {
    professionalInformation?: ProfessionalInformationSaveRequest | undefined;

    constructor(data?: ISaveProfessionalInformationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.professionalInformation = _data["professionalInformation"] ? ProfessionalInformationSaveRequest.fromJS(_data["professionalInformation"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SaveProfessionalInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProfessionalInformationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalInformation"] = this.professionalInformation ? this.professionalInformation.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveProfessionalInformationRequest extends IUserScopeRequest {
    professionalInformation?: ProfessionalInformationSaveRequest | undefined;
}

export class ProfessionalInformationSaveRequest implements IProfessionalInformationSaveRequest {
    questions?: QuestionSaveRequest[] | undefined;

    constructor(data?: IProfessionalInformationSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionSaveRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionalInformationSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalInformationSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfessionalInformationSaveRequest {
    questions?: QuestionSaveRequest[] | undefined;
}

export class QuestionSaveRequest implements IQuestionSaveRequest {
    id?: string;
    questionId?: string;
    type?: QuestionTypeEnum;
    userResponse?: string | undefined;
    userResponseId?: string | undefined;
    userResponseArray?: string[] | undefined;
    choices?: ChoiceSaveRequest[] | undefined;

    constructor(data?: IQuestionSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.type = _data["type"];
            this.userResponse = _data["userResponse"];
            this.userResponseId = _data["userResponseId"];
            if (Array.isArray(_data["userResponseArray"])) {
                this.userResponseArray = [] as any;
                for (let item of _data["userResponseArray"])
                    this.userResponseArray!.push(item);
            }
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ChoiceSaveRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["type"] = this.type;
        data["userResponse"] = this.userResponse;
        data["userResponseId"] = this.userResponseId;
        if (Array.isArray(this.userResponseArray)) {
            data["userResponseArray"] = [];
            for (let item of this.userResponseArray)
                data["userResponseArray"].push(item);
        }
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionSaveRequest {
    id?: string;
    questionId?: string;
    type?: QuestionTypeEnum;
    userResponse?: string | undefined;
    userResponseId?: string | undefined;
    userResponseArray?: string[] | undefined;
    choices?: ChoiceSaveRequest[] | undefined;
}

export class ChoiceSaveRequest implements IChoiceSaveRequest {
    id?: string;
    value?: string | undefined;

    constructor(data?: IChoiceSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ChoiceSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IChoiceSaveRequest {
    id?: string;
    value?: string | undefined;
}

export class ResponseOfListOfRequirementListItemAndString implements IResponseOfListOfRequirementListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementListItem[] | undefined;

    constructor(data?: IResponseOfListOfRequirementListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequirementListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRequirementListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequirementListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRequirementListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementListItem[] | undefined;
}

export class ResponseOfListOfRequirementListItem extends ResponseOfListOfRequirementListItemAndString implements IResponseOfListOfRequirementListItem {

    constructor(data?: IResponseOfListOfRequirementListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRequirementListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequirementListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRequirementListItem extends IResponseOfListOfRequirementListItemAndString {
}

export class ListResponseOfRequirementListItem extends ResponseOfListOfRequirementListItem implements IListResponseOfRequirementListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRequirementListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRequirementListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRequirementListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRequirementListItem extends IResponseOfListOfRequirementListItem {
    totalRecords?: number | undefined;
}

export class RequirementListItem implements IRequirementListItem {
    id?: string;
    requirementSetId?: string;
    name?: string | undefined;
    ruleTypeName?: string | undefined;
    measureTypeName?: string | undefined;
    amount?: number;
    recurrenceTypeName?: string | undefined;
    recurrenceIntervalCycles?: number | undefined;
    isAdditive?: boolean;
    sortOrder?: number;
    constraintsSummary?: string | undefined;

    constructor(data?: IRequirementListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementSetId = _data["requirementSetId"];
            this.name = _data["name"];
            this.ruleTypeName = _data["ruleTypeName"];
            this.measureTypeName = _data["measureTypeName"];
            this.amount = _data["amount"];
            this.recurrenceTypeName = _data["recurrenceTypeName"];
            this.recurrenceIntervalCycles = _data["recurrenceIntervalCycles"];
            this.isAdditive = _data["isAdditive"];
            this.sortOrder = _data["sortOrder"];
            this.constraintsSummary = _data["constraintsSummary"];
        }
    }

    static fromJS(data: any): RequirementListItem {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementSetId"] = this.requirementSetId;
        data["name"] = this.name;
        data["ruleTypeName"] = this.ruleTypeName;
        data["measureTypeName"] = this.measureTypeName;
        data["amount"] = this.amount;
        data["recurrenceTypeName"] = this.recurrenceTypeName;
        data["recurrenceIntervalCycles"] = this.recurrenceIntervalCycles;
        data["isAdditive"] = this.isAdditive;
        data["sortOrder"] = this.sortOrder;
        data["constraintsSummary"] = this.constraintsSummary;
        return data;
    }
}

export interface IRequirementListItem {
    id?: string;
    requirementSetId?: string;
    name?: string | undefined;
    ruleTypeName?: string | undefined;
    measureTypeName?: string | undefined;
    amount?: number;
    recurrenceTypeName?: string | undefined;
    recurrenceIntervalCycles?: number | undefined;
    isAdditive?: boolean;
    sortOrder?: number;
    constraintsSummary?: string | undefined;
}

export class ListRequestOfRequirementAdminFilter implements IListRequestOfRequirementAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RequirementAdminFilter | undefined;

    constructor(data?: IListRequestOfRequirementAdminFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? RequirementAdminFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfRequirementAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfRequirementAdminFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfRequirementAdminFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RequirementAdminFilter | undefined;
}

export class RequirementAdminFilter extends BaseFilter implements IRequirementAdminFilter {
    ruleTypeId?: string | undefined;

    constructor(data?: IRequirementAdminFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruleTypeId = _data["ruleTypeId"];
        }
    }

    static override fromJS(data: any): RequirementAdminFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementAdminFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleTypeId"] = this.ruleTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface IRequirementAdminFilter extends IBaseFilter {
    ruleTypeId?: string | undefined;
}

export class ResponseOfRequirementDetailAndString implements IResponseOfRequirementDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementDetail | undefined;

    constructor(data?: IResponseOfRequirementDetailAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RequirementDetail.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRequirementDetailAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementDetailAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRequirementDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementDetail | undefined;
}

export class ResponseOfRequirementDetail extends ResponseOfRequirementDetailAndString implements IResponseOfRequirementDetail {

    constructor(data?: IResponseOfRequirementDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRequirementDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRequirementDetail extends IResponseOfRequirementDetailAndString {
}

export class RequirementDetail implements IRequirementDetail {
    id?: string;
    requirementSetId?: string;
    requirementSetName?: string | undefined;
    licenseId?: string;
    licenseDisplayName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    ruleTypeId?: string;
    ruleTypeName?: string | undefined;
    measureTypeId?: string;
    measureTypeName?: string | undefined;
    amount?: number;
    isPerEarnPeriod?: boolean;
    isAdditive?: boolean;
    recurrenceTypeId?: string;
    recurrenceTypeName?: string | undefined;
    recurrenceIntervalCycles?: number | undefined;
    effectiveStartDate?: Date | undefined;
    effectiveEndDate?: Date | undefined;
    sortOrder?: number;
    constraints?: RequirementConstraintDetail[] | undefined;
    applicabilityConditions?: RequirementApplicabilityConditionDetail[] | undefined;
    notes?: RequirementNoteDetail[] | undefined;

    constructor(data?: IRequirementDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementSetId = _data["requirementSetId"];
            this.requirementSetName = _data["requirementSetName"];
            this.licenseId = _data["licenseId"];
            this.licenseDisplayName = _data["licenseDisplayName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ruleTypeId = _data["ruleTypeId"];
            this.ruleTypeName = _data["ruleTypeName"];
            this.measureTypeId = _data["measureTypeId"];
            this.measureTypeName = _data["measureTypeName"];
            this.amount = _data["amount"];
            this.isPerEarnPeriod = _data["isPerEarnPeriod"];
            this.isAdditive = _data["isAdditive"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.recurrenceTypeName = _data["recurrenceTypeName"];
            this.recurrenceIntervalCycles = _data["recurrenceIntervalCycles"];
            this.effectiveStartDate = _data["effectiveStartDate"] ? new Date(_data["effectiveStartDate"].toString()) : undefined as any;
            this.effectiveEndDate = _data["effectiveEndDate"] ? new Date(_data["effectiveEndDate"].toString()) : undefined as any;
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["constraints"])) {
                this.constraints = [] as any;
                for (let item of _data["constraints"])
                    this.constraints!.push(RequirementConstraintDetail.fromJS(item));
            }
            if (Array.isArray(_data["applicabilityConditions"])) {
                this.applicabilityConditions = [] as any;
                for (let item of _data["applicabilityConditions"])
                    this.applicabilityConditions!.push(RequirementApplicabilityConditionDetail.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(RequirementNoteDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequirementDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementSetId"] = this.requirementSetId;
        data["requirementSetName"] = this.requirementSetName;
        data["licenseId"] = this.licenseId;
        data["licenseDisplayName"] = this.licenseDisplayName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ruleTypeId"] = this.ruleTypeId;
        data["ruleTypeName"] = this.ruleTypeName;
        data["measureTypeId"] = this.measureTypeId;
        data["measureTypeName"] = this.measureTypeName;
        data["amount"] = this.amount;
        data["isPerEarnPeriod"] = this.isPerEarnPeriod;
        data["isAdditive"] = this.isAdditive;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["recurrenceTypeName"] = this.recurrenceTypeName;
        data["recurrenceIntervalCycles"] = this.recurrenceIntervalCycles;
        data["effectiveStartDate"] = this.effectiveStartDate ? formatDate(this.effectiveStartDate) : undefined as any;
        data["effectiveEndDate"] = this.effectiveEndDate ? formatDate(this.effectiveEndDate) : undefined as any;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.constraints)) {
            data["constraints"] = [];
            for (let item of this.constraints)
                data["constraints"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.applicabilityConditions)) {
            data["applicabilityConditions"] = [];
            for (let item of this.applicabilityConditions)
                data["applicabilityConditions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRequirementDetail {
    id?: string;
    requirementSetId?: string;
    requirementSetName?: string | undefined;
    licenseId?: string;
    licenseDisplayName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    ruleTypeId?: string;
    ruleTypeName?: string | undefined;
    measureTypeId?: string;
    measureTypeName?: string | undefined;
    amount?: number;
    isPerEarnPeriod?: boolean;
    isAdditive?: boolean;
    recurrenceTypeId?: string;
    recurrenceTypeName?: string | undefined;
    recurrenceIntervalCycles?: number | undefined;
    effectiveStartDate?: Date | undefined;
    effectiveEndDate?: Date | undefined;
    sortOrder?: number;
    constraints?: RequirementConstraintDetail[] | undefined;
    applicabilityConditions?: RequirementApplicabilityConditionDetail[] | undefined;
    notes?: RequirementNoteDetail[] | undefined;
}

export class RequirementConstraintDetail implements IRequirementConstraintDetail {
    id?: string;
    constraintTypeId?: string;
    constraintTypeName?: string | undefined;
    topicCategoryId?: string | undefined;
    topicCategoryName?: string | undefined;
    formatTypeId?: string | undefined;
    formatTypeName?: string | undefined;
    accreditorId?: string | undefined;
    accreditorName?: string | undefined;
    audienceDesignator?: string | undefined;
    logicalGroup?: number;

    constructor(data?: IRequirementConstraintDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.constraintTypeId = _data["constraintTypeId"];
            this.constraintTypeName = _data["constraintTypeName"];
            this.topicCategoryId = _data["topicCategoryId"];
            this.topicCategoryName = _data["topicCategoryName"];
            this.formatTypeId = _data["formatTypeId"];
            this.formatTypeName = _data["formatTypeName"];
            this.accreditorId = _data["accreditorId"];
            this.accreditorName = _data["accreditorName"];
            this.audienceDesignator = _data["audienceDesignator"];
            this.logicalGroup = _data["logicalGroup"];
        }
    }

    static fromJS(data: any): RequirementConstraintDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementConstraintDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["constraintTypeId"] = this.constraintTypeId;
        data["constraintTypeName"] = this.constraintTypeName;
        data["topicCategoryId"] = this.topicCategoryId;
        data["topicCategoryName"] = this.topicCategoryName;
        data["formatTypeId"] = this.formatTypeId;
        data["formatTypeName"] = this.formatTypeName;
        data["accreditorId"] = this.accreditorId;
        data["accreditorName"] = this.accreditorName;
        data["audienceDesignator"] = this.audienceDesignator;
        data["logicalGroup"] = this.logicalGroup;
        return data;
    }
}

export interface IRequirementConstraintDetail {
    id?: string;
    constraintTypeId?: string;
    constraintTypeName?: string | undefined;
    topicCategoryId?: string | undefined;
    topicCategoryName?: string | undefined;
    formatTypeId?: string | undefined;
    formatTypeName?: string | undefined;
    accreditorId?: string | undefined;
    accreditorName?: string | undefined;
    audienceDesignator?: string | undefined;
    logicalGroup?: number;
}

export class RequirementApplicabilityConditionDetail implements IRequirementApplicabilityConditionDetail {
    id?: string;
    conditionTypeId?: string;
    conditionTypeName?: string | undefined;
    operatorTypeId?: string;
    operatorTypeName?: string | undefined;
    referenceValue?: string | undefined;
    rangeEndValue?: string | undefined;

    constructor(data?: IRequirementApplicabilityConditionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionTypeId = _data["conditionTypeId"];
            this.conditionTypeName = _data["conditionTypeName"];
            this.operatorTypeId = _data["operatorTypeId"];
            this.operatorTypeName = _data["operatorTypeName"];
            this.referenceValue = _data["referenceValue"];
            this.rangeEndValue = _data["rangeEndValue"];
        }
    }

    static fromJS(data: any): RequirementApplicabilityConditionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementApplicabilityConditionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionTypeId"] = this.conditionTypeId;
        data["conditionTypeName"] = this.conditionTypeName;
        data["operatorTypeId"] = this.operatorTypeId;
        data["operatorTypeName"] = this.operatorTypeName;
        data["referenceValue"] = this.referenceValue;
        data["rangeEndValue"] = this.rangeEndValue;
        return data;
    }
}

export interface IRequirementApplicabilityConditionDetail {
    id?: string;
    conditionTypeId?: string;
    conditionTypeName?: string | undefined;
    operatorTypeId?: string;
    operatorTypeName?: string | undefined;
    referenceValue?: string | undefined;
    rangeEndValue?: string | undefined;
}

export class RequirementNoteDetail implements IRequirementNoteDetail {
    id?: string;
    requirementSetId?: string;
    requirementId?: string | undefined;
    noteTypeId?: string;
    noteTypeName?: string | undefined;
    noteTypeEnumValue?: number;
    title?: string | undefined;
    content?: string | undefined;
    sortOrder?: number;

    constructor(data?: IRequirementNoteDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementSetId = _data["requirementSetId"];
            this.requirementId = _data["requirementId"];
            this.noteTypeId = _data["noteTypeId"];
            this.noteTypeName = _data["noteTypeName"];
            this.noteTypeEnumValue = _data["noteTypeEnumValue"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): RequirementNoteDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementNoteDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementSetId"] = this.requirementSetId;
        data["requirementId"] = this.requirementId;
        data["noteTypeId"] = this.noteTypeId;
        data["noteTypeName"] = this.noteTypeName;
        data["noteTypeEnumValue"] = this.noteTypeEnumValue;
        data["title"] = this.title;
        data["content"] = this.content;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IRequirementNoteDetail {
    id?: string;
    requirementSetId?: string;
    requirementId?: string | undefined;
    noteTypeId?: string;
    noteTypeName?: string | undefined;
    noteTypeEnumValue?: number;
    title?: string | undefined;
    content?: string | undefined;
    sortOrder?: number;
}

export class ResponseOfRequirementFilterOptionsAndString implements IResponseOfRequirementFilterOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementFilterOptions | undefined;

    constructor(data?: IResponseOfRequirementFilterOptionsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RequirementFilterOptions.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRequirementFilterOptionsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementFilterOptionsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRequirementFilterOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementFilterOptions | undefined;
}

export class ResponseOfRequirementFilterOptions extends ResponseOfRequirementFilterOptionsAndString implements IResponseOfRequirementFilterOptions {

    constructor(data?: IResponseOfRequirementFilterOptions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRequirementFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementFilterOptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRequirementFilterOptions extends IResponseOfRequirementFilterOptionsAndString {
}

export class RequirementFilterOptions implements IRequirementFilterOptions {
    ruleTypes?: IdNameModel[] | undefined;

    constructor(data?: IRequirementFilterOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ruleTypes"])) {
                this.ruleTypes = [] as any;
                for (let item of _data["ruleTypes"])
                    this.ruleTypes!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequirementFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementFilterOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ruleTypes)) {
            data["ruleTypes"] = [];
            for (let item of this.ruleTypes)
                data["ruleTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRequirementFilterOptions {
    ruleTypes?: IdNameModel[] | undefined;
}

export class ResponseOfRequirementAuthoringOptionsAndString implements IResponseOfRequirementAuthoringOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementAuthoringOptions | undefined;

    constructor(data?: IResponseOfRequirementAuthoringOptionsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RequirementAuthoringOptions.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRequirementAuthoringOptionsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementAuthoringOptionsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRequirementAuthoringOptionsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementAuthoringOptions | undefined;
}

export class ResponseOfRequirementAuthoringOptions extends ResponseOfRequirementAuthoringOptionsAndString implements IResponseOfRequirementAuthoringOptions {

    constructor(data?: IResponseOfRequirementAuthoringOptions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRequirementAuthoringOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementAuthoringOptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRequirementAuthoringOptions extends IResponseOfRequirementAuthoringOptionsAndString {
}

export class RequirementAuthoringOptions implements IRequirementAuthoringOptions {
    ruleTypes?: IdNameModel[] | undefined;
    measureTypes?: IdNameModel[] | undefined;
    topicCategories?: IdNameModel[] | undefined;
    formatTypes?: IdNameModel[] | undefined;
    conditionTypes?: IdNameModel[] | undefined;
    cycleTypes?: IdNameModel[] | undefined;
    accreditors?: IdNameModel[] | undefined;
    recurrenceTypes?: LookupOption[] | undefined;
    constraintTypes?: LookupOption[] | undefined;
    operatorTypes?: LookupOption[] | undefined;
    dateSchemeTypes?: LookupOption[] | undefined;
    noteTypes?: LookupOption[] | undefined;

    constructor(data?: IRequirementAuthoringOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ruleTypes"])) {
                this.ruleTypes = [] as any;
                for (let item of _data["ruleTypes"])
                    this.ruleTypes!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["measureTypes"])) {
                this.measureTypes = [] as any;
                for (let item of _data["measureTypes"])
                    this.measureTypes!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["topicCategories"])) {
                this.topicCategories = [] as any;
                for (let item of _data["topicCategories"])
                    this.topicCategories!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["formatTypes"])) {
                this.formatTypes = [] as any;
                for (let item of _data["formatTypes"])
                    this.formatTypes!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["conditionTypes"])) {
                this.conditionTypes = [] as any;
                for (let item of _data["conditionTypes"])
                    this.conditionTypes!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["cycleTypes"])) {
                this.cycleTypes = [] as any;
                for (let item of _data["cycleTypes"])
                    this.cycleTypes!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["accreditors"])) {
                this.accreditors = [] as any;
                for (let item of _data["accreditors"])
                    this.accreditors!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["recurrenceTypes"])) {
                this.recurrenceTypes = [] as any;
                for (let item of _data["recurrenceTypes"])
                    this.recurrenceTypes!.push(LookupOption.fromJS(item));
            }
            if (Array.isArray(_data["constraintTypes"])) {
                this.constraintTypes = [] as any;
                for (let item of _data["constraintTypes"])
                    this.constraintTypes!.push(LookupOption.fromJS(item));
            }
            if (Array.isArray(_data["operatorTypes"])) {
                this.operatorTypes = [] as any;
                for (let item of _data["operatorTypes"])
                    this.operatorTypes!.push(LookupOption.fromJS(item));
            }
            if (Array.isArray(_data["dateSchemeTypes"])) {
                this.dateSchemeTypes = [] as any;
                for (let item of _data["dateSchemeTypes"])
                    this.dateSchemeTypes!.push(LookupOption.fromJS(item));
            }
            if (Array.isArray(_data["noteTypes"])) {
                this.noteTypes = [] as any;
                for (let item of _data["noteTypes"])
                    this.noteTypes!.push(LookupOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequirementAuthoringOptions {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementAuthoringOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ruleTypes)) {
            data["ruleTypes"] = [];
            for (let item of this.ruleTypes)
                data["ruleTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measureTypes)) {
            data["measureTypes"] = [];
            for (let item of this.measureTypes)
                data["measureTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topicCategories)) {
            data["topicCategories"] = [];
            for (let item of this.topicCategories)
                data["topicCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formatTypes)) {
            data["formatTypes"] = [];
            for (let item of this.formatTypes)
                data["formatTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.conditionTypes)) {
            data["conditionTypes"] = [];
            for (let item of this.conditionTypes)
                data["conditionTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cycleTypes)) {
            data["cycleTypes"] = [];
            for (let item of this.cycleTypes)
                data["cycleTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accreditors)) {
            data["accreditors"] = [];
            for (let item of this.accreditors)
                data["accreditors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.recurrenceTypes)) {
            data["recurrenceTypes"] = [];
            for (let item of this.recurrenceTypes)
                data["recurrenceTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.constraintTypes)) {
            data["constraintTypes"] = [];
            for (let item of this.constraintTypes)
                data["constraintTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operatorTypes)) {
            data["operatorTypes"] = [];
            for (let item of this.operatorTypes)
                data["operatorTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dateSchemeTypes)) {
            data["dateSchemeTypes"] = [];
            for (let item of this.dateSchemeTypes)
                data["dateSchemeTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.noteTypes)) {
            data["noteTypes"] = [];
            for (let item of this.noteTypes)
                data["noteTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRequirementAuthoringOptions {
    ruleTypes?: IdNameModel[] | undefined;
    measureTypes?: IdNameModel[] | undefined;
    topicCategories?: IdNameModel[] | undefined;
    formatTypes?: IdNameModel[] | undefined;
    conditionTypes?: IdNameModel[] | undefined;
    cycleTypes?: IdNameModel[] | undefined;
    accreditors?: IdNameModel[] | undefined;
    recurrenceTypes?: LookupOption[] | undefined;
    constraintTypes?: LookupOption[] | undefined;
    operatorTypes?: LookupOption[] | undefined;
    dateSchemeTypes?: LookupOption[] | undefined;
    noteTypes?: LookupOption[] | undefined;
}

export class LookupOption implements ILookupOption {
    id?: string;
    name?: string | undefined;
    enumValue?: number;

    constructor(data?: ILookupOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enumValue = _data["enumValue"];
        }
    }

    static fromJS(data: any): LookupOption {
        data = typeof data === 'object' ? data : {};
        let result = new LookupOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enumValue"] = this.enumValue;
        return data;
    }
}

export interface ILookupOption {
    id?: string;
    name?: string | undefined;
    enumValue?: number;
}

export class RequirementRequest implements IRequirementRequest {
    id?: string | undefined;
    requirementSetId?: string;
    name?: string | undefined;
    description?: string | undefined;
    ruleTypeId?: string;
    measureTypeId?: string;
    amount?: number;
    isPerEarnPeriod?: boolean;
    isAdditive?: boolean;
    recurrenceTypeId?: string;
    recurrenceIntervalCycles?: number | undefined;
    effectiveStartDate?: Date | undefined;
    effectiveEndDate?: Date | undefined;

    constructor(data?: IRequirementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementSetId = _data["requirementSetId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ruleTypeId = _data["ruleTypeId"];
            this.measureTypeId = _data["measureTypeId"];
            this.amount = _data["amount"];
            this.isPerEarnPeriod = _data["isPerEarnPeriod"];
            this.isAdditive = _data["isAdditive"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.recurrenceIntervalCycles = _data["recurrenceIntervalCycles"];
            this.effectiveStartDate = _data["effectiveStartDate"] ? new Date(_data["effectiveStartDate"].toString()) : undefined as any;
            this.effectiveEndDate = _data["effectiveEndDate"] ? new Date(_data["effectiveEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RequirementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementSetId"] = this.requirementSetId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ruleTypeId"] = this.ruleTypeId;
        data["measureTypeId"] = this.measureTypeId;
        data["amount"] = this.amount;
        data["isPerEarnPeriod"] = this.isPerEarnPeriod;
        data["isAdditive"] = this.isAdditive;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["recurrenceIntervalCycles"] = this.recurrenceIntervalCycles;
        data["effectiveStartDate"] = this.effectiveStartDate ? formatDate(this.effectiveStartDate) : undefined as any;
        data["effectiveEndDate"] = this.effectiveEndDate ? formatDate(this.effectiveEndDate) : undefined as any;
        return data;
    }
}

export interface IRequirementRequest {
    id?: string | undefined;
    requirementSetId?: string;
    name?: string | undefined;
    description?: string | undefined;
    ruleTypeId?: string;
    measureTypeId?: string;
    amount?: number;
    isPerEarnPeriod?: boolean;
    isAdditive?: boolean;
    recurrenceTypeId?: string;
    recurrenceIntervalCycles?: number | undefined;
    effectiveStartDate?: Date | undefined;
    effectiveEndDate?: Date | undefined;
}

export class RequirementConstraintRequest implements IRequirementConstraintRequest {
    id?: string | undefined;
    requirementId?: string;
    constraintTypeId?: string;
    topicCategoryId?: string | undefined;
    formatTypeId?: string | undefined;
    accreditorId?: string | undefined;
    audienceDesignator?: string | undefined;
    logicalGroup?: number;

    constructor(data?: IRequirementConstraintRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementId = _data["requirementId"];
            this.constraintTypeId = _data["constraintTypeId"];
            this.topicCategoryId = _data["topicCategoryId"];
            this.formatTypeId = _data["formatTypeId"];
            this.accreditorId = _data["accreditorId"];
            this.audienceDesignator = _data["audienceDesignator"];
            this.logicalGroup = _data["logicalGroup"];
        }
    }

    static fromJS(data: any): RequirementConstraintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementConstraintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementId"] = this.requirementId;
        data["constraintTypeId"] = this.constraintTypeId;
        data["topicCategoryId"] = this.topicCategoryId;
        data["formatTypeId"] = this.formatTypeId;
        data["accreditorId"] = this.accreditorId;
        data["audienceDesignator"] = this.audienceDesignator;
        data["logicalGroup"] = this.logicalGroup;
        return data;
    }
}

export interface IRequirementConstraintRequest {
    id?: string | undefined;
    requirementId?: string;
    constraintTypeId?: string;
    topicCategoryId?: string | undefined;
    formatTypeId?: string | undefined;
    accreditorId?: string | undefined;
    audienceDesignator?: string | undefined;
    logicalGroup?: number;
}

export class RequirementApplicabilityConditionRequest implements IRequirementApplicabilityConditionRequest {
    id?: string | undefined;
    requirementId?: string;
    conditionTypeId?: string;
    operatorTypeId?: string;
    referenceValue?: string | undefined;
    rangeEndValue?: string | undefined;

    constructor(data?: IRequirementApplicabilityConditionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementId = _data["requirementId"];
            this.conditionTypeId = _data["conditionTypeId"];
            this.operatorTypeId = _data["operatorTypeId"];
            this.referenceValue = _data["referenceValue"];
            this.rangeEndValue = _data["rangeEndValue"];
        }
    }

    static fromJS(data: any): RequirementApplicabilityConditionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementApplicabilityConditionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementId"] = this.requirementId;
        data["conditionTypeId"] = this.conditionTypeId;
        data["operatorTypeId"] = this.operatorTypeId;
        data["referenceValue"] = this.referenceValue;
        data["rangeEndValue"] = this.rangeEndValue;
        return data;
    }
}

export interface IRequirementApplicabilityConditionRequest {
    id?: string | undefined;
    requirementId?: string;
    conditionTypeId?: string;
    operatorTypeId?: string;
    referenceValue?: string | undefined;
    rangeEndValue?: string | undefined;
}

export class ResponseOfRequirementSetDetailAndString implements IResponseOfRequirementSetDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementSetDetail | undefined;

    constructor(data?: IResponseOfRequirementSetDetailAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RequirementSetDetail.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRequirementSetDetailAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementSetDetailAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRequirementSetDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementSetDetail | undefined;
}

export class ResponseOfRequirementSetDetail extends ResponseOfRequirementSetDetailAndString implements IResponseOfRequirementSetDetail {

    constructor(data?: IResponseOfRequirementSetDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRequirementSetDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRequirementSetDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRequirementSetDetail extends IResponseOfRequirementSetDetailAndString {
}

export class RequirementSetDetail implements IRequirementSetDetail {
    id?: string;
    licenseId?: string;
    licenseDisplayName?: string | undefined;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    statusId?: string;
    statusName?: string | undefined;
    statusEnumValue?: number;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    isActive?: boolean;
    carryoverAllowed?: boolean;
    carryoverRule?: CarryoverRuleDetail | undefined;
    cycleConfiguration?: CycleConfigurationDetail | undefined;
    creditConfiguration?: LicenseCreditConfigurationDetail | undefined;
    accreditors?: string[] | undefined;
    allowedTransitions?: RequirementSetTransitionOption[] | undefined;
    description?: string | undefined;
    notes?: RequirementNoteDetail[] | undefined;

    constructor(data?: IRequirementSetDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseId = _data["licenseId"];
            this.licenseDisplayName = _data["licenseDisplayName"];
            this.name = _data["name"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.statusEnumValue = _data["statusEnumValue"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.carryoverAllowed = _data["carryoverAllowed"];
            this.carryoverRule = _data["carryoverRule"] ? CarryoverRuleDetail.fromJS(_data["carryoverRule"]) : undefined as any;
            this.cycleConfiguration = _data["cycleConfiguration"] ? CycleConfigurationDetail.fromJS(_data["cycleConfiguration"]) : undefined as any;
            this.creditConfiguration = _data["creditConfiguration"] ? LicenseCreditConfigurationDetail.fromJS(_data["creditConfiguration"]) : undefined as any;
            if (Array.isArray(_data["accreditors"])) {
                this.accreditors = [] as any;
                for (let item of _data["accreditors"])
                    this.accreditors!.push(item);
            }
            if (Array.isArray(_data["allowedTransitions"])) {
                this.allowedTransitions = [] as any;
                for (let item of _data["allowedTransitions"])
                    this.allowedTransitions!.push(RequirementSetTransitionOption.fromJS(item));
            }
            this.description = _data["description"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(RequirementNoteDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequirementSetDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementSetDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseId"] = this.licenseId;
        data["licenseDisplayName"] = this.licenseDisplayName;
        data["name"] = this.name;
        data["effectiveDate"] = this.effectiveDate ? formatDate(this.effectiveDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["statusEnumValue"] = this.statusEnumValue;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["carryoverAllowed"] = this.carryoverAllowed;
        data["carryoverRule"] = this.carryoverRule ? this.carryoverRule.toJSON() : undefined as any;
        data["cycleConfiguration"] = this.cycleConfiguration ? this.cycleConfiguration.toJSON() : undefined as any;
        data["creditConfiguration"] = this.creditConfiguration ? this.creditConfiguration.toJSON() : undefined as any;
        if (Array.isArray(this.accreditors)) {
            data["accreditors"] = [];
            for (let item of this.accreditors)
                data["accreditors"].push(item);
        }
        if (Array.isArray(this.allowedTransitions)) {
            data["allowedTransitions"] = [];
            for (let item of this.allowedTransitions)
                data["allowedTransitions"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRequirementSetDetail {
    id?: string;
    licenseId?: string;
    licenseDisplayName?: string | undefined;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    statusId?: string;
    statusName?: string | undefined;
    statusEnumValue?: number;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    isActive?: boolean;
    carryoverAllowed?: boolean;
    carryoverRule?: CarryoverRuleDetail | undefined;
    cycleConfiguration?: CycleConfigurationDetail | undefined;
    creditConfiguration?: LicenseCreditConfigurationDetail | undefined;
    accreditors?: string[] | undefined;
    allowedTransitions?: RequirementSetTransitionOption[] | undefined;
    description?: string | undefined;
    notes?: RequirementNoteDetail[] | undefined;
}

export class CarryoverRuleDetail implements ICarryoverRuleDetail {
    maxHours?: number | undefined;
    earnWindowMonths?: number | undefined;
    maxPeriodsForward?: number | undefined;
    appliesToTopicRequirements?: boolean;

    constructor(data?: ICarryoverRuleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxHours = _data["maxHours"];
            this.earnWindowMonths = _data["earnWindowMonths"];
            this.maxPeriodsForward = _data["maxPeriodsForward"];
            this.appliesToTopicRequirements = _data["appliesToTopicRequirements"];
        }
    }

    static fromJS(data: any): CarryoverRuleDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CarryoverRuleDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxHours"] = this.maxHours;
        data["earnWindowMonths"] = this.earnWindowMonths;
        data["maxPeriodsForward"] = this.maxPeriodsForward;
        data["appliesToTopicRequirements"] = this.appliesToTopicRequirements;
        return data;
    }
}

export interface ICarryoverRuleDetail {
    maxHours?: number | undefined;
    earnWindowMonths?: number | undefined;
    maxPeriodsForward?: number | undefined;
    appliesToTopicRequirements?: boolean;
}

export class CycleConfigurationDetail implements ICycleConfigurationDetail {
    cycleLengthMonths?: number;
    cycleTypeId?: string;
    cycleTypeName?: string | undefined;
    dateSchemeTypeId?: string;
    dateSchemeTypeName?: string | undefined;
    fixedMonth?: number | undefined;
    fixedDay?: number | undefined;
    oddEvenYear?: number | undefined;
    earnPeriodsPerReportPeriod?: number;
    gracePeriodDays?: number;

    constructor(data?: ICycleConfigurationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycleLengthMonths = _data["cycleLengthMonths"];
            this.cycleTypeId = _data["cycleTypeId"];
            this.cycleTypeName = _data["cycleTypeName"];
            this.dateSchemeTypeId = _data["dateSchemeTypeId"];
            this.dateSchemeTypeName = _data["dateSchemeTypeName"];
            this.fixedMonth = _data["fixedMonth"];
            this.fixedDay = _data["fixedDay"];
            this.oddEvenYear = _data["oddEvenYear"];
            this.earnPeriodsPerReportPeriod = _data["earnPeriodsPerReportPeriod"];
            this.gracePeriodDays = _data["gracePeriodDays"];
        }
    }

    static fromJS(data: any): CycleConfigurationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CycleConfigurationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleLengthMonths"] = this.cycleLengthMonths;
        data["cycleTypeId"] = this.cycleTypeId;
        data["cycleTypeName"] = this.cycleTypeName;
        data["dateSchemeTypeId"] = this.dateSchemeTypeId;
        data["dateSchemeTypeName"] = this.dateSchemeTypeName;
        data["fixedMonth"] = this.fixedMonth;
        data["fixedDay"] = this.fixedDay;
        data["oddEvenYear"] = this.oddEvenYear;
        data["earnPeriodsPerReportPeriod"] = this.earnPeriodsPerReportPeriod;
        data["gracePeriodDays"] = this.gracePeriodDays;
        return data;
    }
}

export interface ICycleConfigurationDetail {
    cycleLengthMonths?: number;
    cycleTypeId?: string;
    cycleTypeName?: string | undefined;
    dateSchemeTypeId?: string;
    dateSchemeTypeName?: string | undefined;
    fixedMonth?: number | undefined;
    fixedDay?: number | undefined;
    oddEvenYear?: number | undefined;
    earnPeriodsPerReportPeriod?: number;
    gracePeriodDays?: number;
}

export class LicenseCreditConfigurationDetail implements ILicenseCreditConfigurationDetail {
    creditUnitMinutes?: number;
    minCreditIncrement?: number;
    roundingDirectionTypeName?: string | undefined;
    sameCourseCycleRepeatAllowed?: boolean;
    documentationRetentionYears?: number | undefined;

    constructor(data?: ILicenseCreditConfigurationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditUnitMinutes = _data["creditUnitMinutes"];
            this.minCreditIncrement = _data["minCreditIncrement"];
            this.roundingDirectionTypeName = _data["roundingDirectionTypeName"];
            this.sameCourseCycleRepeatAllowed = _data["sameCourseCycleRepeatAllowed"];
            this.documentationRetentionYears = _data["documentationRetentionYears"];
        }
    }

    static fromJS(data: any): LicenseCreditConfigurationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseCreditConfigurationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditUnitMinutes"] = this.creditUnitMinutes;
        data["minCreditIncrement"] = this.minCreditIncrement;
        data["roundingDirectionTypeName"] = this.roundingDirectionTypeName;
        data["sameCourseCycleRepeatAllowed"] = this.sameCourseCycleRepeatAllowed;
        data["documentationRetentionYears"] = this.documentationRetentionYears;
        return data;
    }
}

export interface ILicenseCreditConfigurationDetail {
    creditUnitMinutes?: number;
    minCreditIncrement?: number;
    roundingDirectionTypeName?: string | undefined;
    sameCourseCycleRepeatAllowed?: boolean;
    documentationRetentionYears?: number | undefined;
}

export class RequirementSetTransitionOption implements IRequirementSetTransitionOption {
    action?: RequirementSetAction;
    isEnabled?: boolean;
    hint?: string | undefined;

    constructor(data?: IRequirementSetTransitionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.isEnabled = _data["isEnabled"];
            this.hint = _data["hint"];
        }
    }

    static fromJS(data: any): RequirementSetTransitionOption {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementSetTransitionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["isEnabled"] = this.isEnabled;
        data["hint"] = this.hint;
        return data;
    }
}

export interface IRequirementSetTransitionOption {
    action?: RequirementSetAction;
    isEnabled?: boolean;
    hint?: string | undefined;
}

export enum RequirementSetAction {
    SubmitForReview = "SubmitForReview",
    Approve = "Approve",
    ReturnToDraft = "ReturnToDraft",
    Archive = "Archive",
    Unarchive = "Unarchive",
}

export class ResponseOfListOfRequirementSetListItemAndString implements IResponseOfListOfRequirementSetListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementSetListItem[] | undefined;

    constructor(data?: IResponseOfListOfRequirementSetListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequirementSetListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRequirementSetListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequirementSetListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRequirementSetListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequirementSetListItem[] | undefined;
}

export class ResponseOfListOfRequirementSetListItem extends ResponseOfListOfRequirementSetListItemAndString implements IResponseOfListOfRequirementSetListItem {

    constructor(data?: IResponseOfListOfRequirementSetListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRequirementSetListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequirementSetListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRequirementSetListItem extends IResponseOfListOfRequirementSetListItemAndString {
}

export class ListResponseOfRequirementSetListItem extends ResponseOfListOfRequirementSetListItem implements IListResponseOfRequirementSetListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRequirementSetListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRequirementSetListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRequirementSetListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRequirementSetListItem extends IResponseOfListOfRequirementSetListItem {
    totalRecords?: number | undefined;
}

export class RequirementSetListItem implements IRequirementSetListItem {
    id?: string;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    statusName?: string | undefined;
    statusEnumValue?: number;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;

    constructor(data?: IRequirementSetListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.statusName = _data["statusName"];
            this.statusEnumValue = _data["statusEnumValue"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RequirementSetListItem {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementSetListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["effectiveDate"] = this.effectiveDate ? formatDate(this.effectiveDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["statusName"] = this.statusName;
        data["statusEnumValue"] = this.statusEnumValue;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IRequirementSetListItem {
    id?: string;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    statusName?: string | undefined;
    statusEnumValue?: number;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
}

export class RequirementSetRequest implements IRequirementSetRequest {
    id?: string | undefined;
    licenseId?: string;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    description?: string | undefined;

    constructor(data?: IRequirementSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseId = _data["licenseId"];
            this.name = _data["name"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RequirementSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseId"] = this.licenseId;
        data["name"] = this.name;
        data["effectiveDate"] = this.effectiveDate ? formatDate(this.effectiveDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["description"] = this.description;
        return data;
    }
}

export interface IRequirementSetRequest {
    id?: string | undefined;
    licenseId?: string;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    description?: string | undefined;
}

export class RequirementSetCopyRequest implements IRequirementSetCopyRequest {
    licenseId?: string;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    sourceRequirementSetId?: string | undefined;

    constructor(data?: IRequirementSetCopyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.name = _data["name"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.sourceRequirementSetId = _data["sourceRequirementSetId"];
        }
    }

    static fromJS(data: any): RequirementSetCopyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementSetCopyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["name"] = this.name;
        data["effectiveDate"] = this.effectiveDate ? formatDate(this.effectiveDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["sourceRequirementSetId"] = this.sourceRequirementSetId;
        return data;
    }
}

export interface IRequirementSetCopyRequest {
    licenseId?: string;
    name?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
    sourceRequirementSetId?: string | undefined;
}

export class CycleConfigurationRequest implements ICycleConfigurationRequest {
    id?: string | undefined;
    requirementSetId?: string;
    cycleLengthMonths?: number;
    cycleTypeId?: string;
    dateSchemeTypeId?: string;
    fixedMonth?: number | undefined;
    fixedDay?: number | undefined;
    oddEvenYear?: number | undefined;
    earnPeriodsPerReportPeriod?: number;
    gracePeriodDays?: number;

    constructor(data?: ICycleConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementSetId = _data["requirementSetId"];
            this.cycleLengthMonths = _data["cycleLengthMonths"];
            this.cycleTypeId = _data["cycleTypeId"];
            this.dateSchemeTypeId = _data["dateSchemeTypeId"];
            this.fixedMonth = _data["fixedMonth"];
            this.fixedDay = _data["fixedDay"];
            this.oddEvenYear = _data["oddEvenYear"];
            this.earnPeriodsPerReportPeriod = _data["earnPeriodsPerReportPeriod"];
            this.gracePeriodDays = _data["gracePeriodDays"];
        }
    }

    static fromJS(data: any): CycleConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CycleConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementSetId"] = this.requirementSetId;
        data["cycleLengthMonths"] = this.cycleLengthMonths;
        data["cycleTypeId"] = this.cycleTypeId;
        data["dateSchemeTypeId"] = this.dateSchemeTypeId;
        data["fixedMonth"] = this.fixedMonth;
        data["fixedDay"] = this.fixedDay;
        data["oddEvenYear"] = this.oddEvenYear;
        data["earnPeriodsPerReportPeriod"] = this.earnPeriodsPerReportPeriod;
        data["gracePeriodDays"] = this.gracePeriodDays;
        return data;
    }
}

export interface ICycleConfigurationRequest {
    id?: string | undefined;
    requirementSetId?: string;
    cycleLengthMonths?: number;
    cycleTypeId?: string;
    dateSchemeTypeId?: string;
    fixedMonth?: number | undefined;
    fixedDay?: number | undefined;
    oddEvenYear?: number | undefined;
    earnPeriodsPerReportPeriod?: number;
    gracePeriodDays?: number;
}

export class CarryoverRuleRequest implements ICarryoverRuleRequest {
    id?: string | undefined;
    requirementSetId?: string;
    maxHours?: number | undefined;
    earnWindowMonths?: number | undefined;
    maxPeriodsForward?: number | undefined;
    appliesToTopicRequirements?: boolean;

    constructor(data?: ICarryoverRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementSetId = _data["requirementSetId"];
            this.maxHours = _data["maxHours"];
            this.earnWindowMonths = _data["earnWindowMonths"];
            this.maxPeriodsForward = _data["maxPeriodsForward"];
            this.appliesToTopicRequirements = _data["appliesToTopicRequirements"];
        }
    }

    static fromJS(data: any): CarryoverRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CarryoverRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementSetId"] = this.requirementSetId;
        data["maxHours"] = this.maxHours;
        data["earnWindowMonths"] = this.earnWindowMonths;
        data["maxPeriodsForward"] = this.maxPeriodsForward;
        data["appliesToTopicRequirements"] = this.appliesToTopicRequirements;
        return data;
    }
}

export interface ICarryoverRuleRequest {
    id?: string | undefined;
    requirementSetId?: string;
    maxHours?: number | undefined;
    earnWindowMonths?: number | undefined;
    maxPeriodsForward?: number | undefined;
    appliesToTopicRequirements?: boolean;
}

export class RequirementNoteRequest implements IRequirementNoteRequest {
    id?: string | undefined;
    requirementSetId?: string;
    requirementId?: string | undefined;
    noteTypeId?: string;
    title?: string | undefined;
    content?: string | undefined;

    constructor(data?: IRequirementNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requirementSetId = _data["requirementSetId"];
            this.requirementId = _data["requirementId"];
            this.noteTypeId = _data["noteTypeId"];
            this.title = _data["title"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): RequirementNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requirementSetId"] = this.requirementSetId;
        data["requirementId"] = this.requirementId;
        data["noteTypeId"] = this.noteTypeId;
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    }
}

export interface IRequirementNoteRequest {
    id?: string | undefined;
    requirementSetId?: string;
    requirementId?: string | undefined;
    noteTypeId?: string;
    title?: string | undefined;
    content?: string | undefined;
}

export class ManualSubmissionResultOfObject implements IManualSubmissionResultOfObject {
    authorityTypeId?: string;
    fileType?: ManualSubmissionFileType;
    items?: any[] | undefined;
    reportFileUrl?: string | undefined;

    constructor(data?: IManualSubmissionResultOfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorityTypeId = _data["authorityTypeId"];
            this.fileType = _data["fileType"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.reportFileUrl = _data["reportFileUrl"];
        }
    }

    static fromJS(data: any): ManualSubmissionResultOfObject {
        data = typeof data === 'object' ? data : {};
        let result = new ManualSubmissionResultOfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorityTypeId"] = this.authorityTypeId;
        data["fileType"] = this.fileType;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["reportFileUrl"] = this.reportFileUrl;
        return data;
    }
}

export interface IManualSubmissionResultOfObject {
    authorityTypeId?: string;
    fileType?: ManualSubmissionFileType;
    items?: any[] | undefined;
    reportFileUrl?: string | undefined;
}

export enum ManualSubmissionFileType {
    Csv = "Csv",
    Xlsx = "Xlsx",
}

export class ManualSubmissionFilter implements IManualSubmissionFilter {
    organizationId?: string;
    authorityId?: string;
    startDate?: Date;
    endDate?: Date;
    includeSubmitted?: boolean;
    removeInternalUsers?: boolean;

    constructor(data?: IManualSubmissionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.authorityId = _data["authorityId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.includeSubmitted = _data["includeSubmitted"];
            this.removeInternalUsers = _data["removeInternalUsers"];
        }
    }

    static fromJS(data: any): ManualSubmissionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ManualSubmissionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["authorityId"] = this.authorityId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["includeSubmitted"] = this.includeSubmitted;
        data["removeInternalUsers"] = this.removeInternalUsers;
        return data;
    }
}

export interface IManualSubmissionFilter {
    organizationId?: string;
    authorityId?: string;
    startDate?: Date;
    endDate?: Date;
    includeSubmitted?: boolean;
    removeInternalUsers?: boolean;
}

export class ResponseOfListOfProcessingModelAndString implements IResponseOfListOfProcessingModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProcessingModel[] | undefined;

    constructor(data?: IResponseOfListOfProcessingModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProcessingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProcessingModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProcessingModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProcessingModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProcessingModel[] | undefined;
}

export class ResponseOfListOfProcessingModel extends ResponseOfListOfProcessingModelAndString implements IResponseOfListOfProcessingModel {

    constructor(data?: IResponseOfListOfProcessingModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProcessingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProcessingModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProcessingModel extends IResponseOfListOfProcessingModelAndString {
}

export class ListResponseOfProcessingModel extends ResponseOfListOfProcessingModel implements IListResponseOfProcessingModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProcessingModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProcessingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProcessingModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProcessingModel extends IResponseOfListOfProcessingModel {
    totalRecords?: number | undefined;
}

export class ProcessingModel implements IProcessingModel {
    id!: string;
    processDate?: Date;
    certificateStartDate?: Date | undefined;
    certificateEndDate?: Date | undefined;
    authorityName?: string | undefined;
    organizationName?: string | undefined;
    statusName?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    uploadingSubmissionStatusFileType?: ManualSubmissionFileType;

    constructor(data?: IProcessingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processDate = _data["processDate"] ? new Date(_data["processDate"].toString()) : undefined as any;
            this.certificateStartDate = _data["certificateStartDate"] ? new Date(_data["certificateStartDate"].toString()) : undefined as any;
            this.certificateEndDate = _data["certificateEndDate"] ? new Date(_data["certificateEndDate"].toString()) : undefined as any;
            this.authorityName = _data["authorityName"];
            this.organizationName = _data["organizationName"];
            this.statusName = _data["statusName"];
            this.isUploadSubmissionStatusAvailable = _data["isUploadSubmissionStatusAvailable"];
            this.uploadingSubmissionStatusFileType = _data["uploadingSubmissionStatusFileType"];
        }
    }

    static fromJS(data: any): ProcessingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processDate"] = this.processDate ? this.processDate.toISOString() : undefined as any;
        data["certificateStartDate"] = this.certificateStartDate ? this.certificateStartDate.toISOString() : undefined as any;
        data["certificateEndDate"] = this.certificateEndDate ? this.certificateEndDate.toISOString() : undefined as any;
        data["authorityName"] = this.authorityName;
        data["organizationName"] = this.organizationName;
        data["statusName"] = this.statusName;
        data["isUploadSubmissionStatusAvailable"] = this.isUploadSubmissionStatusAvailable;
        data["uploadingSubmissionStatusFileType"] = this.uploadingSubmissionStatusFileType;
        return data;
    }
}

export interface IProcessingModel {
    id: string;
    processDate?: Date;
    certificateStartDate?: Date | undefined;
    certificateEndDate?: Date | undefined;
    authorityName?: string | undefined;
    organizationName?: string | undefined;
    statusName?: string | undefined;
    isUploadSubmissionStatusAvailable?: boolean;
    uploadingSubmissionStatusFileType?: ManualSubmissionFileType;
}

export class ListRequestOfProcessingFilter implements IListRequestOfProcessingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProcessingFilter | undefined;

    constructor(data?: IListRequestOfProcessingFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ProcessingFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfProcessingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfProcessingFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfProcessingFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProcessingFilter | undefined;
}

export class ProcessingFilter extends BaseFilter implements IProcessingFilter {
    authorityId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IProcessingFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authorityId = _data["authorityId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): ProcessingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorityId"] = this.authorityId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IProcessingFilter extends IBaseFilter {
    authorityId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ResponseOfListOfSubmissionRequestModelAndString implements IResponseOfListOfSubmissionRequestModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SubmissionRequestModel[] | undefined;

    constructor(data?: IResponseOfListOfSubmissionRequestModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SubmissionRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSubmissionRequestModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSubmissionRequestModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSubmissionRequestModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SubmissionRequestModel[] | undefined;
}

export class ResponseOfListOfSubmissionRequestModel extends ResponseOfListOfSubmissionRequestModelAndString implements IResponseOfListOfSubmissionRequestModel {

    constructor(data?: IResponseOfListOfSubmissionRequestModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSubmissionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSubmissionRequestModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSubmissionRequestModel extends IResponseOfListOfSubmissionRequestModelAndString {
}

export class ListResponseOfSubmissionRequestModel extends ResponseOfListOfSubmissionRequestModel implements IListResponseOfSubmissionRequestModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSubmissionRequestModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSubmissionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSubmissionRequestModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSubmissionRequestModel extends IResponseOfListOfSubmissionRequestModel {
    totalRecords?: number | undefined;
}

export class SubmissionRequestModel implements ISubmissionRequestModel {
    id!: string;
    courseTitle?: string | undefined;
    dateOfParticipation?: Date;
    createdOn?: Date;
    courseNumber?: string | undefined;
    authorityName?: string | undefined;
    licenseNumber?: string | undefined;
    licenseState?: string | undefined;
    professionId?: string | undefined;
    professionName?: string | undefined;
    statusName?: string | undefined;
    responseObject?: string | undefined;
    requestObject?: string | undefined;

    constructor(data?: ISubmissionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseTitle = _data["courseTitle"];
            this.dateOfParticipation = _data["dateOfParticipation"] ? new Date(_data["dateOfParticipation"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.courseNumber = _data["courseNumber"];
            this.authorityName = _data["authorityName"];
            this.licenseNumber = _data["licenseNumber"];
            this.licenseState = _data["licenseState"];
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.statusName = _data["statusName"];
            this.responseObject = _data["responseObject"];
            this.requestObject = _data["requestObject"];
        }
    }

    static fromJS(data: any): SubmissionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseTitle"] = this.courseTitle;
        data["dateOfParticipation"] = this.dateOfParticipation ? this.dateOfParticipation.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["courseNumber"] = this.courseNumber;
        data["authorityName"] = this.authorityName;
        data["licenseNumber"] = this.licenseNumber;
        data["licenseState"] = this.licenseState;
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["statusName"] = this.statusName;
        data["responseObject"] = this.responseObject;
        data["requestObject"] = this.requestObject;
        return data;
    }
}

export interface ISubmissionRequestModel {
    id: string;
    courseTitle?: string | undefined;
    dateOfParticipation?: Date;
    createdOn?: Date;
    courseNumber?: string | undefined;
    authorityName?: string | undefined;
    licenseNumber?: string | undefined;
    licenseState?: string | undefined;
    professionId?: string | undefined;
    professionName?: string | undefined;
    statusName?: string | undefined;
    responseObject?: string | undefined;
    requestObject?: string | undefined;
}

export class ListRequestOfSubmissionRequestFilter implements IListRequestOfSubmissionRequestFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SubmissionRequestFilter | undefined;

    constructor(data?: IListRequestOfSubmissionRequestFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SubmissionRequestFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSubmissionRequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSubmissionRequestFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSubmissionRequestFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SubmissionRequestFilter | undefined;
}

export class SubmissionRequestFilter extends BaseFilter implements ISubmissionRequestFilter {
    userId?: string | undefined;
    submissionDateFrom?: Date | undefined;
    submissionDateTo?: Date | undefined;

    constructor(data?: ISubmissionRequestFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.submissionDateFrom = _data["submissionDateFrom"] ? new Date(_data["submissionDateFrom"].toString()) : undefined as any;
            this.submissionDateTo = _data["submissionDateTo"] ? new Date(_data["submissionDateTo"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): SubmissionRequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionRequestFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["submissionDateFrom"] = this.submissionDateFrom ? this.submissionDateFrom.toISOString() : undefined as any;
        data["submissionDateTo"] = this.submissionDateTo ? this.submissionDateTo.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISubmissionRequestFilter extends IBaseFilter {
    userId?: string | undefined;
    submissionDateFrom?: Date | undefined;
    submissionDateTo?: Date | undefined;
}

export class ReprocessUserSubmissionsRequest extends UserScopeRequest implements IReprocessUserSubmissionsRequest {

    constructor(data?: IReprocessUserSubmissionsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReprocessUserSubmissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReprocessUserSubmissionsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReprocessUserSubmissionsRequest extends IUserScopeRequest {
}

export class ResponseOfListOfCourseTitleModelAndString implements IResponseOfListOfCourseTitleModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CourseTitleModel[] | undefined;

    constructor(data?: IResponseOfListOfCourseTitleModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CourseTitleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCourseTitleModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCourseTitleModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCourseTitleModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CourseTitleModel[] | undefined;
}

export class ResponseOfListOfCourseTitleModel extends ResponseOfListOfCourseTitleModelAndString implements IResponseOfListOfCourseTitleModel {

    constructor(data?: IResponseOfListOfCourseTitleModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCourseTitleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCourseTitleModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCourseTitleModel extends IResponseOfListOfCourseTitleModelAndString {
}

export class ListResponseOfCourseTitleModel extends ResponseOfListOfCourseTitleModel implements IListResponseOfCourseTitleModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCourseTitleModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCourseTitleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCourseTitleModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCourseTitleModel extends IResponseOfListOfCourseTitleModel {
    totalRecords?: number | undefined;
}

export class CourseTitleModel implements ICourseTitleModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICourseTitleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CourseTitleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CourseTitleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICourseTitleModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class CourseTitlesRequest extends ListRequestOfBaseFilter implements ICourseTitlesRequest {
    userId?: string;
    organizationId?: string;

    constructor(data?: ICourseTitlesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): CourseTitlesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CourseTitlesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface ICourseTitlesRequest extends IListRequestOfBaseFilter {
    userId?: string;
    organizationId?: string;
}

export class ResponseOfUserCertificateModelAndString implements IResponseOfUserCertificateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserCertificateModel | undefined;

    constructor(data?: IResponseOfUserCertificateModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? UserCertificateModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfUserCertificateModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfUserCertificateModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfUserCertificateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserCertificateModel | undefined;
}

export class ResponseOfUserCertificateModel extends ResponseOfUserCertificateModelAndString implements IResponseOfUserCertificateModel {

    constructor(data?: IResponseOfUserCertificateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfUserCertificateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfUserCertificateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfUserCertificateModel extends IResponseOfUserCertificateModelAndString {
}

export class UserCertificateModel implements IUserCertificateModel {
    organizationId?: string;
    userId?: string;
    userCertificateId?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    skuId?: string;
    skuName?: string | undefined;
    userSkuId?: string;
    professionId?: string | undefined;
    professionName?: string | undefined;
    qualificationName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    courseTitle?: string | undefined;
    creditsAwarded?: number;
    completionDate?: Date;
    qualificationId?: string | undefined;
    submissionEligibilityType?: SubmissionEligibilityTypeEnum;
    migrationSkuId?: string | undefined;
    externalSourceId?: string | undefined;

    constructor(data?: IUserCertificateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.userCertificateId = _data["userCertificateId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.skuId = _data["skuId"];
            this.skuName = _data["skuName"];
            this.userSkuId = _data["userSkuId"];
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.qualificationName = _data["qualificationName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.courseTitle = _data["courseTitle"];
            this.creditsAwarded = _data["creditsAwarded"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : undefined as any;
            this.qualificationId = _data["qualificationId"];
            this.submissionEligibilityType = _data["submissionEligibilityType"];
            this.migrationSkuId = _data["migrationSkuId"];
            this.externalSourceId = _data["externalSourceId"];
        }
    }

    static fromJS(data: any): UserCertificateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["userCertificateId"] = this.userCertificateId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["skuId"] = this.skuId;
        data["skuName"] = this.skuName;
        data["userSkuId"] = this.userSkuId;
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["qualificationName"] = this.qualificationName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["courseTitle"] = this.courseTitle;
        data["creditsAwarded"] = this.creditsAwarded;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : undefined as any;
        data["qualificationId"] = this.qualificationId;
        data["submissionEligibilityType"] = this.submissionEligibilityType;
        data["migrationSkuId"] = this.migrationSkuId;
        data["externalSourceId"] = this.externalSourceId;
        return data;
    }
}

export interface IUserCertificateModel {
    organizationId?: string;
    userId?: string;
    userCertificateId?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    skuId?: string;
    skuName?: string | undefined;
    userSkuId?: string;
    professionId?: string | undefined;
    professionName?: string | undefined;
    qualificationName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    courseTitle?: string | undefined;
    creditsAwarded?: number;
    completionDate?: Date;
    qualificationId?: string | undefined;
    submissionEligibilityType?: SubmissionEligibilityTypeEnum;
    migrationSkuId?: string | undefined;
    externalSourceId?: string | undefined;
}

export enum SubmissionEligibilityTypeEnum {
    Eligible = "Eligible",
    OutsideAccreditor = "OutsideAccreditor",
    MergedAccreditor = "MergedAccreditor",
    NotEligible = "NotEligible",
}

export class ResponseOfListOfUserCertificateModelAndString implements IResponseOfListOfUserCertificateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserCertificateModel[] | undefined;

    constructor(data?: IResponseOfListOfUserCertificateModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserCertificateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfUserCertificateModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserCertificateModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfUserCertificateModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: UserCertificateModel[] | undefined;
}

export class ResponseOfListOfUserCertificateModel extends ResponseOfListOfUserCertificateModelAndString implements IResponseOfListOfUserCertificateModel {

    constructor(data?: IResponseOfListOfUserCertificateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfUserCertificateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserCertificateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfUserCertificateModel extends IResponseOfListOfUserCertificateModelAndString {
}

export class ListResponseOfUserCertificateModel extends ResponseOfListOfUserCertificateModel implements IListResponseOfUserCertificateModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfUserCertificateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfUserCertificateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfUserCertificateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfUserCertificateModel extends IResponseOfListOfUserCertificateModel {
    totalRecords?: number | undefined;
}

export class ListRequestOfUserCertificatesFilter implements IListRequestOfUserCertificatesFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: UserCertificatesFilter | undefined;

    constructor(data?: IListRequestOfUserCertificatesFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? UserCertificatesFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfUserCertificatesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfUserCertificatesFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfUserCertificatesFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: UserCertificatesFilter | undefined;
}

export class UserCertificatesFilter extends BaseFilter implements IUserCertificatesFilter {
    userId?: string;
    userSkuId?: string | undefined;
    issueDateFrom?: Date | undefined;
    issueDateTo?: Date | undefined;

    constructor(data?: IUserCertificatesFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.userSkuId = _data["userSkuId"];
            this.issueDateFrom = _data["issueDateFrom"] ? new Date(_data["issueDateFrom"].toString()) : undefined as any;
            this.issueDateTo = _data["issueDateTo"] ? new Date(_data["issueDateTo"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): UserCertificatesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificatesFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userSkuId"] = this.userSkuId;
        data["issueDateFrom"] = this.issueDateFrom ? this.issueDateFrom.toISOString() : undefined as any;
        data["issueDateTo"] = this.issueDateTo ? this.issueDateTo.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUserCertificatesFilter extends IBaseFilter {
    userId?: string;
    userSkuId?: string | undefined;
    issueDateFrom?: Date | undefined;
    issueDateTo?: Date | undefined;
}

export class RegenerateUserCertificatesRequest implements IRegenerateUserCertificatesRequest {
    userId!: string;

    constructor(data?: IRegenerateUserCertificatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RegenerateUserCertificatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegenerateUserCertificatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IRegenerateUserCertificatesRequest {
    userId: string;
}

export class UserCertificateDownloadRequest implements IUserCertificateDownloadRequest {
    userCertificateId!: string;
    organizationId?: string;
    userId!: string;

    constructor(data?: IUserCertificateDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCertificateId = _data["userCertificateId"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserCertificateDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificateDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCertificateId"] = this.userCertificateId;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserCertificateDownloadRequest {
    userCertificateId: string;
    organizationId?: string;
    userId: string;
}

export class ResponseOfListOfProfileCredentialModelAndString implements IResponseOfListOfProfileCredentialModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProfileCredentialModel[] | undefined;

    constructor(data?: IResponseOfListOfProfileCredentialModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProfileCredentialModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProfileCredentialModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProfileCredentialModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProfileCredentialModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProfileCredentialModel[] | undefined;
}

export class ResponseOfListOfProfileCredentialModel extends ResponseOfListOfProfileCredentialModelAndString implements IResponseOfListOfProfileCredentialModel {

    constructor(data?: IResponseOfListOfProfileCredentialModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProfileCredentialModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProfileCredentialModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProfileCredentialModel extends IResponseOfListOfProfileCredentialModelAndString {
}

export class ListResponseOfProfileCredentialModel extends ResponseOfListOfProfileCredentialModel implements IListResponseOfProfileCredentialModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProfileCredentialModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProfileCredentialModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProfileCredentialModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProfileCredentialModel extends IResponseOfListOfProfileCredentialModel {
    totalRecords?: number | undefined;
}

export class ProfileCredentialModel implements IProfileCredentialModel {
    designation?: CredentialDesignationModel | undefined;
    licenseId?: string | undefined;
    location?: CredentialLocationModel | undefined;
    licensureBody?: CredentialLicensureBodyModel | undefined;
    isNational?: boolean;
    questions?: UserCredentialQuestionModel[] | undefined;
    notes?: CredentialNoteModel[] | undefined;
    isSupportedByMembership?: boolean;

    constructor(data?: IProfileCredentialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designation = _data["designation"] ? CredentialDesignationModel.fromJS(_data["designation"]) : undefined as any;
            this.licenseId = _data["licenseId"];
            this.location = _data["location"] ? CredentialLocationModel.fromJS(_data["location"]) : undefined as any;
            this.licensureBody = _data["licensureBody"] ? CredentialLicensureBodyModel.fromJS(_data["licensureBody"]) : undefined as any;
            this.isNational = _data["isNational"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(UserCredentialQuestionModel.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(CredentialNoteModel.fromJS(item));
            }
            this.isSupportedByMembership = _data["isSupportedByMembership"];
        }
    }

    static fromJS(data: any): ProfileCredentialModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCredentialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designation"] = this.designation ? this.designation.toJSON() : undefined as any;
        data["licenseId"] = this.licenseId;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["licensureBody"] = this.licensureBody ? this.licensureBody.toJSON() : undefined as any;
        data["isNational"] = this.isNational;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSupportedByMembership"] = this.isSupportedByMembership;
        return data;
    }
}

export interface IProfileCredentialModel {
    designation?: CredentialDesignationModel | undefined;
    licenseId?: string | undefined;
    location?: CredentialLocationModel | undefined;
    licensureBody?: CredentialLicensureBodyModel | undefined;
    isNational?: boolean;
    questions?: UserCredentialQuestionModel[] | undefined;
    notes?: CredentialNoteModel[] | undefined;
    isSupportedByMembership?: boolean;
}

export class CredentialDesignationModel implements ICredentialDesignationModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: ICredentialDesignationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CredentialDesignationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialDesignationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICredentialDesignationModel {
    id?: string;
    name?: string | undefined;
}

export class CredentialLocationModel implements ICredentialLocationModel {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;
    parentLocationId?: string | undefined;
    parentLocationName?: string | undefined;

    constructor(data?: ICredentialLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.acronym = _data["acronym"];
            this.parentLocationId = _data["parentLocationId"];
            this.parentLocationName = _data["parentLocationName"];
        }
    }

    static fromJS(data: any): CredentialLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["acronym"] = this.acronym;
        data["parentLocationId"] = this.parentLocationId;
        data["parentLocationName"] = this.parentLocationName;
        return data;
    }
}

export interface ICredentialLocationModel {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;
    parentLocationId?: string | undefined;
    parentLocationName?: string | undefined;
}

export class CredentialLicensureBodyModel implements ICredentialLicensureBodyModel {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;

    constructor(data?: ICredentialLicensureBodyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.acronym = _data["acronym"];
        }
    }

    static fromJS(data: any): CredentialLicensureBodyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialLicensureBodyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["acronym"] = this.acronym;
        return data;
    }
}

export interface ICredentialLicensureBodyModel {
    id?: string;
    name?: string | undefined;
    acronym?: string | undefined;
}

export class UserCredentialQuestionModel implements IUserCredentialQuestionModel {
    id?: string;
    value?: string | undefined;
    userResponse?: string | undefined;
    type?: QuestionTypeEnum;
    isLocked?: boolean;
    codeConstant?: string | undefined;

    constructor(data?: IUserCredentialQuestionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.userResponse = _data["userResponse"];
            this.type = _data["type"];
            this.isLocked = _data["isLocked"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static fromJS(data: any): UserCredentialQuestionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCredentialQuestionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["userResponse"] = this.userResponse;
        data["type"] = this.type;
        data["isLocked"] = this.isLocked;
        data["codeConstant"] = this.codeConstant;
        return data;
    }
}

export interface IUserCredentialQuestionModel {
    id?: string;
    value?: string | undefined;
    userResponse?: string | undefined;
    type?: QuestionTypeEnum;
    isLocked?: boolean;
    codeConstant?: string | undefined;
}

export class CredentialNoteModel implements ICredentialNoteModel {
    id?: string;
    note?: string | undefined;

    constructor(data?: ICredentialNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CredentialNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }
}

export interface ICredentialNoteModel {
    id?: string;
    note?: string | undefined;
}

export class SaveUserCredentialRequest extends UserScopeRequest implements ISaveUserCredentialRequest {
    credential!: UserCredentialSaveRequest;

    constructor(data?: ISaveUserCredentialRequest) {
        super(data);
        if (!data) {
            this.credential = new UserCredentialSaveRequest();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.credential = _data["credential"] ? UserCredentialSaveRequest.fromJS(_data["credential"]) : new UserCredentialSaveRequest();
        }
    }

    static override fromJS(data: any): SaveUserCredentialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserCredentialRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["credential"] = this.credential ? this.credential.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveUserCredentialRequest extends IUserScopeRequest {
    credential: UserCredentialSaveRequest;
}

export class UserCredentialSaveRequest implements IUserCredentialSaveRequest {
    designationId?: string;
    locationId?: string | undefined;
    licensureBodyId?: string | undefined;
    answers?: UserCredentialAnswerSaveModel[] | undefined;

    constructor(data?: IUserCredentialSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designationId = _data["designationId"];
            this.locationId = _data["locationId"];
            this.licensureBodyId = _data["licensureBodyId"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(UserCredentialAnswerSaveModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserCredentialSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserCredentialSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationId"] = this.designationId;
        data["locationId"] = this.locationId;
        data["licensureBodyId"] = this.licensureBodyId;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserCredentialSaveRequest {
    designationId?: string;
    locationId?: string | undefined;
    licensureBodyId?: string | undefined;
    answers?: UserCredentialAnswerSaveModel[] | undefined;
}

export class UserCredentialAnswerSaveModel implements IUserCredentialAnswerSaveModel {
    questionId?: string;
    value?: string | undefined;
    answerId?: string | undefined;

    constructor(data?: IUserCredentialAnswerSaveModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.value = _data["value"];
            this.answerId = _data["answerId"];
        }
    }

    static fromJS(data: any): UserCredentialAnswerSaveModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCredentialAnswerSaveModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["value"] = this.value;
        data["answerId"] = this.answerId;
        return data;
    }
}

export interface IUserCredentialAnswerSaveModel {
    questionId?: string;
    value?: string | undefined;
    answerId?: string | undefined;
}

export class DeleteUserCredentialRequest extends UserScopeRequest implements IDeleteUserCredentialRequest {
    designationId!: string;
    licenseId?: string | undefined;

    constructor(data?: IDeleteUserCredentialRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.designationId = _data["designationId"];
            this.licenseId = _data["licenseId"];
        }
    }

    static override fromJS(data: any): DeleteUserCredentialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserCredentialRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationId"] = this.designationId;
        data["licenseId"] = this.licenseId;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteUserCredentialRequest extends IUserScopeRequest {
    designationId: string;
    licenseId?: string | undefined;
}

export class ResponseOfListOfAvailableDesignationModelAndString implements IResponseOfListOfAvailableDesignationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AvailableDesignationModel[] | undefined;

    constructor(data?: IResponseOfListOfAvailableDesignationModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AvailableDesignationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAvailableDesignationModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAvailableDesignationModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAvailableDesignationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AvailableDesignationModel[] | undefined;
}

export class ResponseOfListOfAvailableDesignationModel extends ResponseOfListOfAvailableDesignationModelAndString implements IResponseOfListOfAvailableDesignationModel {

    constructor(data?: IResponseOfListOfAvailableDesignationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAvailableDesignationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAvailableDesignationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAvailableDesignationModel extends IResponseOfListOfAvailableDesignationModelAndString {
}

export class ListResponseOfAvailableDesignationModel extends ResponseOfListOfAvailableDesignationModel implements IListResponseOfAvailableDesignationModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAvailableDesignationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAvailableDesignationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAvailableDesignationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAvailableDesignationModel extends IResponseOfListOfAvailableDesignationModel {
    totalRecords?: number | undefined;
}

export class AvailableDesignationModel implements IAvailableDesignationModel {
    id?: string;
    name?: string | undefined;
    isDesignationInUse?: boolean;
    requiresChildLicense?: boolean;
    isSupportedByMembership?: boolean;

    constructor(data?: IAvailableDesignationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDesignationInUse = _data["isDesignationInUse"];
            this.requiresChildLicense = _data["requiresChildLicense"];
            this.isSupportedByMembership = _data["isSupportedByMembership"];
        }
    }

    static fromJS(data: any): AvailableDesignationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableDesignationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDesignationInUse"] = this.isDesignationInUse;
        data["requiresChildLicense"] = this.requiresChildLicense;
        data["isSupportedByMembership"] = this.isSupportedByMembership;
        return data;
    }
}

export interface IAvailableDesignationModel {
    id?: string;
    name?: string | undefined;
    isDesignationInUse?: boolean;
    requiresChildLicense?: boolean;
    isSupportedByMembership?: boolean;
}

export class ResponseOfListOfCredentialLocationModelAndString implements IResponseOfListOfCredentialLocationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CredentialLocationModel[] | undefined;

    constructor(data?: IResponseOfListOfCredentialLocationModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CredentialLocationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCredentialLocationModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCredentialLocationModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCredentialLocationModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CredentialLocationModel[] | undefined;
}

export class ResponseOfListOfCredentialLocationModel extends ResponseOfListOfCredentialLocationModelAndString implements IResponseOfListOfCredentialLocationModel {

    constructor(data?: IResponseOfListOfCredentialLocationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCredentialLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCredentialLocationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCredentialLocationModel extends IResponseOfListOfCredentialLocationModelAndString {
}

export class ListResponseOfCredentialLocationModel extends ResponseOfListOfCredentialLocationModel implements IListResponseOfCredentialLocationModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCredentialLocationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCredentialLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCredentialLocationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCredentialLocationModel extends IResponseOfListOfCredentialLocationModel {
    totalRecords?: number | undefined;
}

export class AvailableLocationRequest2 implements IAvailableLocationRequest2 {
    designationId?: string;
    parentLocationId?: string | undefined;

    constructor(data?: IAvailableLocationRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designationId = _data["designationId"];
            this.parentLocationId = _data["parentLocationId"];
        }
    }

    static fromJS(data: any): AvailableLocationRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableLocationRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationId"] = this.designationId;
        data["parentLocationId"] = this.parentLocationId;
        return data;
    }
}

export interface IAvailableLocationRequest2 {
    designationId?: string;
    parentLocationId?: string | undefined;
}

export class AvailableLocationRequest extends AvailableLocationRequest2 implements IAvailableLocationRequest {
    userId!: string;
    organizationId!: string;

    constructor(data?: IAvailableLocationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AvailableLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableLocationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAvailableLocationRequest extends IAvailableLocationRequest2 {
    userId: string;
    organizationId: string;
}

export class ResponseOfListOfCredentialLicensureBodyModelAndString implements IResponseOfListOfCredentialLicensureBodyModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CredentialLicensureBodyModel[] | undefined;

    constructor(data?: IResponseOfListOfCredentialLicensureBodyModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CredentialLicensureBodyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCredentialLicensureBodyModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCredentialLicensureBodyModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCredentialLicensureBodyModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CredentialLicensureBodyModel[] | undefined;
}

export class ResponseOfListOfCredentialLicensureBodyModel extends ResponseOfListOfCredentialLicensureBodyModelAndString implements IResponseOfListOfCredentialLicensureBodyModel {

    constructor(data?: IResponseOfListOfCredentialLicensureBodyModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCredentialLicensureBodyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCredentialLicensureBodyModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCredentialLicensureBodyModel extends IResponseOfListOfCredentialLicensureBodyModelAndString {
}

export class ListResponseOfCredentialLicensureBodyModel extends ResponseOfListOfCredentialLicensureBodyModel implements IListResponseOfCredentialLicensureBodyModel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCredentialLicensureBodyModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCredentialLicensureBodyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCredentialLicensureBodyModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCredentialLicensureBodyModel extends IResponseOfListOfCredentialLicensureBodyModel {
    totalRecords?: number | undefined;
}

export class AvailableLicensureBodiesRequest extends UserScopeRequest implements IAvailableLicensureBodiesRequest {
    designationId!: string;
    locationId!: string;

    constructor(data?: IAvailableLicensureBodiesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.designationId = _data["designationId"];
            this.locationId = _data["locationId"];
        }
    }

    static override fromJS(data: any): AvailableLicensureBodiesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableLicensureBodiesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationId"] = this.designationId;
        data["locationId"] = this.locationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAvailableLicensureBodiesRequest extends IUserScopeRequest {
    designationId: string;
    locationId: string;
}

export class ResponseOfCredentialModelAndString implements IResponseOfCredentialModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CredentialModel | undefined;

    constructor(data?: IResponseOfCredentialModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CredentialModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCredentialModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCredentialModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCredentialModelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CredentialModel | undefined;
}

export class ResponseOfCredentialModel extends ResponseOfCredentialModelAndString implements IResponseOfCredentialModel {

    constructor(data?: IResponseOfCredentialModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCredentialModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCredentialModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCredentialModel extends IResponseOfCredentialModelAndString {
}

export class CredentialModel implements ICredentialModel {
    designation?: CredentialDesignationModel | undefined;
    licenseId?: string | undefined;
    location?: CredentialLocationModel | undefined;
    licensureBody?: CredentialLicensureBodyModel | undefined;
    isNational?: boolean;
    questions?: CredentialQuestionModel[] | undefined;
    notes?: CredentialNoteModel[] | undefined;

    constructor(data?: ICredentialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designation = _data["designation"] ? CredentialDesignationModel.fromJS(_data["designation"]) : undefined as any;
            this.licenseId = _data["licenseId"];
            this.location = _data["location"] ? CredentialLocationModel.fromJS(_data["location"]) : undefined as any;
            this.licensureBody = _data["licensureBody"] ? CredentialLicensureBodyModel.fromJS(_data["licensureBody"]) : undefined as any;
            this.isNational = _data["isNational"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(CredentialQuestionModel.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(CredentialNoteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CredentialModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designation"] = this.designation ? this.designation.toJSON() : undefined as any;
        data["licenseId"] = this.licenseId;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["licensureBody"] = this.licensureBody ? this.licensureBody.toJSON() : undefined as any;
        data["isNational"] = this.isNational;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICredentialModel {
    designation?: CredentialDesignationModel | undefined;
    licenseId?: string | undefined;
    location?: CredentialLocationModel | undefined;
    licensureBody?: CredentialLicensureBodyModel | undefined;
    isNational?: boolean;
    questions?: CredentialQuestionModel[] | undefined;
    notes?: CredentialNoteModel[] | undefined;
}

export class CredentialQuestionModel implements ICredentialQuestionModel {
    id?: string;
    isRequired?: boolean;
    value?: string | undefined;
    type?: QuestionTypeEnum;
    questionValidationRule?: CredentialQuestionValidationRuleModel | undefined;
    userResponse?: string | undefined;
    userResponseId?: string | undefined;
    choices?: CredentialQuestionChoiceModel[] | undefined;
    isLocked?: boolean;
    codeConstant?: string | undefined;

    constructor(data?: ICredentialQuestionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isRequired = _data["isRequired"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.questionValidationRule = _data["questionValidationRule"] ? CredentialQuestionValidationRuleModel.fromJS(_data["questionValidationRule"]) : undefined as any;
            this.userResponse = _data["userResponse"];
            this.userResponseId = _data["userResponseId"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(CredentialQuestionChoiceModel.fromJS(item));
            }
            this.isLocked = _data["isLocked"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static fromJS(data: any): CredentialQuestionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialQuestionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isRequired"] = this.isRequired;
        data["value"] = this.value;
        data["type"] = this.type;
        data["questionValidationRule"] = this.questionValidationRule ? this.questionValidationRule.toJSON() : undefined as any;
        data["userResponse"] = this.userResponse;
        data["userResponseId"] = this.userResponseId;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item ? item.toJSON() : undefined as any);
        }
        data["isLocked"] = this.isLocked;
        data["codeConstant"] = this.codeConstant;
        return data;
    }
}

export interface ICredentialQuestionModel {
    id?: string;
    isRequired?: boolean;
    value?: string | undefined;
    type?: QuestionTypeEnum;
    questionValidationRule?: CredentialQuestionValidationRuleModel | undefined;
    userResponse?: string | undefined;
    userResponseId?: string | undefined;
    choices?: CredentialQuestionChoiceModel[] | undefined;
    isLocked?: boolean;
    codeConstant?: string | undefined;
}

export class CredentialQuestionValidationRuleModel implements ICredentialQuestionValidationRuleModel {
    value?: string | undefined;
    message?: string | undefined;

    constructor(data?: ICredentialQuestionValidationRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CredentialQuestionValidationRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialQuestionValidationRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["message"] = this.message;
        return data;
    }
}

export interface ICredentialQuestionValidationRuleModel {
    value?: string | undefined;
    message?: string | undefined;
}

export class CredentialQuestionChoiceModel implements ICredentialQuestionChoiceModel {
    id?: string;
    value?: string | undefined;

    constructor(data?: ICredentialQuestionChoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CredentialQuestionChoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialQuestionChoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface ICredentialQuestionChoiceModel {
    id?: string;
    value?: string | undefined;
}

export class GetCredentialRequest extends UserScopeRequest implements IGetCredentialRequest {
    designationId!: string;
    locationId!: string;
    licensureBodyId?: string | undefined;

    constructor(data?: IGetCredentialRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.designationId = _data["designationId"];
            this.locationId = _data["locationId"];
            this.licensureBodyId = _data["licensureBodyId"];
        }
    }

    static override fromJS(data: any): GetCredentialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCredentialRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationId"] = this.designationId;
        data["locationId"] = this.locationId;
        data["licensureBodyId"] = this.licensureBodyId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCredentialRequest extends IUserScopeRequest {
    designationId: string;
    locationId: string;
    licensureBodyId?: string | undefined;
}

export class ResponseOfListOfQualificationApprovalAndString implements IResponseOfListOfQualificationApprovalAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationApproval[] | undefined;

    constructor(data?: IResponseOfListOfQualificationApprovalAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QualificationApproval.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfQualificationApprovalAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationApprovalAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfQualificationApprovalAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationApproval[] | undefined;
}

export class ResponseOfListOfQualificationApproval extends ResponseOfListOfQualificationApprovalAndString implements IResponseOfListOfQualificationApproval {

    constructor(data?: IResponseOfListOfQualificationApproval) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfQualificationApproval {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationApproval();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfQualificationApproval extends IResponseOfListOfQualificationApprovalAndString {
}

export class ListResponseOfQualificationApproval extends ResponseOfListOfQualificationApproval implements IListResponseOfQualificationApproval {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfQualificationApproval) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfQualificationApproval {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQualificationApproval();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfQualificationApproval extends IResponseOfListOfQualificationApproval {
    totalRecords?: number | undefined;
}

export class QualificationApproval implements IQualificationApproval {
    id!: string;
    qualificationId?: string;
    professionName?: string | undefined;
    professionId?: string | undefined;
    stateName?: string | undefined;
    stateId?: string | undefined;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;
    organizationId?: string | undefined;
    organizationName?: string | undefined;

    constructor(data?: IQualificationApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationId = _data["qualificationId"];
            this.professionName = _data["professionName"];
            this.professionId = _data["professionId"];
            this.stateName = _data["stateName"];
            this.stateId = _data["stateId"];
            this.partialCreditIncrement = _data["partialCreditIncrement"];
            this.minimumCredit = _data["minimumCredit"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): QualificationApproval {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationId"] = this.qualificationId;
        data["professionName"] = this.professionName;
        data["professionId"] = this.professionId;
        data["stateName"] = this.stateName;
        data["stateId"] = this.stateId;
        data["partialCreditIncrement"] = this.partialCreditIncrement;
        data["minimumCredit"] = this.minimumCredit;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IQualificationApproval {
    id: string;
    qualificationId?: string;
    professionName?: string | undefined;
    professionId?: string | undefined;
    stateName?: string | undefined;
    stateId?: string | undefined;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
}

export class GetQualificationApprovalsRequest extends ListRequestOfBaseFilter implements IGetQualificationApprovalsRequest {
    organizationId?: string;

    constructor(data?: IGetQualificationApprovalsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): GetQualificationApprovalsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualificationApprovalsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetQualificationApprovalsRequest extends IListRequestOfBaseFilter {
    organizationId?: string;
}

export class SaveQualificationApprovalRequest implements ISaveQualificationApprovalRequest {
    id?: string | undefined;
    qualificationId?: string;
    professionId?: string | undefined;
    stateId?: string | undefined;
    organizationId?: string;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;

    constructor(data?: ISaveQualificationApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationId = _data["qualificationId"];
            this.professionId = _data["professionId"];
            this.stateId = _data["stateId"];
            this.organizationId = _data["organizationId"];
            this.partialCreditIncrement = _data["partialCreditIncrement"];
            this.minimumCredit = _data["minimumCredit"];
        }
    }

    static fromJS(data: any): SaveQualificationApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveQualificationApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationId"] = this.qualificationId;
        data["professionId"] = this.professionId;
        data["stateId"] = this.stateId;
        data["organizationId"] = this.organizationId;
        data["partialCreditIncrement"] = this.partialCreditIncrement;
        data["minimumCredit"] = this.minimumCredit;
        return data;
    }
}

export interface ISaveQualificationApprovalRequest {
    id?: string | undefined;
    qualificationId?: string;
    professionId?: string | undefined;
    stateId?: string | undefined;
    organizationId?: string;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;
}

export class ResponseOfQualificationApprovalAndString implements IResponseOfQualificationApprovalAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationApproval | undefined;

    constructor(data?: IResponseOfQualificationApprovalAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? QualificationApproval.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfQualificationApprovalAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQualificationApprovalAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfQualificationApprovalAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationApproval | undefined;
}

export class ResponseOfQualificationApproval extends ResponseOfQualificationApprovalAndString implements IResponseOfQualificationApproval {

    constructor(data?: IResponseOfQualificationApproval) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfQualificationApproval {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQualificationApproval();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfQualificationApproval extends IResponseOfQualificationApprovalAndString {
}

export class GetMatchingQualificationApprovalRequest implements IGetMatchingQualificationApprovalRequest {
    professionId?: string | undefined;
    stateId?: string | undefined;
    organizationId?: string;

    constructor(data?: IGetMatchingQualificationApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.stateId = _data["stateId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetMatchingQualificationApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMatchingQualificationApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["stateId"] = this.stateId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetMatchingQualificationApprovalRequest {
    professionId?: string | undefined;
    stateId?: string | undefined;
    organizationId?: string;
}

export class ResponseOfListOfQualificationAndString implements IResponseOfListOfQualificationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Qualification[] | undefined;

    constructor(data?: IResponseOfListOfQualificationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Qualification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfQualificationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfQualificationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Qualification[] | undefined;
}

export class ResponseOfListOfQualification extends ResponseOfListOfQualificationAndString implements IResponseOfListOfQualification {

    constructor(data?: IResponseOfListOfQualification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfQualification extends IResponseOfListOfQualificationAndString {
}

export class ListResponseOfQualification extends ResponseOfListOfQualification implements IListResponseOfQualification {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfQualification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQualification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfQualification extends IResponseOfListOfQualification {
    totalRecords?: number | undefined;
}

export class Qualification implements IQualification {
    id!: string;
    organizationQualificationId?: string | undefined;
    value?: string | undefined;
    acronym?: string | undefined;
    displayValue?: string | undefined;
    displayOrder?: number | undefined;
    formattedValue?: string | undefined;
    qualificationTypeName?: string | undefined;
    qualificationTypeId?: string;
    createdByCrm?: boolean;
    qualificationStatementIds?: string[] | undefined;
    isLockable?: boolean;

    constructor(data?: IQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationQualificationId = _data["organizationQualificationId"];
            this.value = _data["value"];
            this.acronym = _data["acronym"];
            this.displayValue = _data["displayValue"];
            this.displayOrder = _data["displayOrder"];
            this.formattedValue = _data["formattedValue"];
            this.qualificationTypeName = _data["qualificationTypeName"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.createdByCrm = _data["createdByCrm"];
            if (Array.isArray(_data["qualificationStatementIds"])) {
                this.qualificationStatementIds = [] as any;
                for (let item of _data["qualificationStatementIds"])
                    this.qualificationStatementIds!.push(item);
            }
            this.isLockable = _data["isLockable"];
        }
    }

    static fromJS(data: any): Qualification {
        data = typeof data === 'object' ? data : {};
        let result = new Qualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationQualificationId"] = this.organizationQualificationId;
        data["value"] = this.value;
        data["acronym"] = this.acronym;
        data["displayValue"] = this.displayValue;
        data["displayOrder"] = this.displayOrder;
        data["formattedValue"] = this.formattedValue;
        data["qualificationTypeName"] = this.qualificationTypeName;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["createdByCrm"] = this.createdByCrm;
        if (Array.isArray(this.qualificationStatementIds)) {
            data["qualificationStatementIds"] = [];
            for (let item of this.qualificationStatementIds)
                data["qualificationStatementIds"].push(item);
        }
        data["isLockable"] = this.isLockable;
        return data;
    }
}

export interface IQualification {
    id: string;
    organizationQualificationId?: string | undefined;
    value?: string | undefined;
    acronym?: string | undefined;
    displayValue?: string | undefined;
    displayOrder?: number | undefined;
    formattedValue?: string | undefined;
    qualificationTypeName?: string | undefined;
    qualificationTypeId?: string;
    createdByCrm?: boolean;
    qualificationStatementIds?: string[] | undefined;
    isLockable?: boolean;
}

export class ListRequestOfQualificationFilter implements IListRequestOfQualificationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QualificationFilter | undefined;

    constructor(data?: IListRequestOfQualificationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? QualificationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfQualificationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfQualificationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfQualificationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QualificationFilter | undefined;
}

export class GetQualificationsRequest extends ListRequestOfQualificationFilter implements IGetQualificationsRequest {
    organizationId?: string;

    constructor(data?: IGetQualificationsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): GetQualificationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualificationsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetQualificationsRequest extends IListRequestOfQualificationFilter {
    organizationId?: string;
}

export class QualificationFilter extends BaseFilter implements IQualificationFilter {
    useBaseTable?: boolean | undefined;

    constructor(data?: IQualificationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.useBaseTable = _data["useBaseTable"];
        }
    }

    static override fromJS(data: any): QualificationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useBaseTable"] = this.useBaseTable;
        super.toJSON(data);
        return data;
    }
}

export interface IQualificationFilter extends IBaseFilter {
    useBaseTable?: boolean | undefined;
}

export class ResponseOfQualificationAndString implements IResponseOfQualificationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Qualification | undefined;

    constructor(data?: IResponseOfQualificationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Qualification.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfQualificationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQualificationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfQualificationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Qualification | undefined;
}

export class ResponseOfQualification extends ResponseOfQualificationAndString implements IResponseOfQualification {

    constructor(data?: IResponseOfQualification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQualification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfQualification extends IResponseOfQualificationAndString {
}

export class ResponseOfListOfAccreditationChainItemAndString implements IResponseOfListOfAccreditationChainItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AccreditationChainItem[] | undefined;

    constructor(data?: IResponseOfListOfAccreditationChainItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AccreditationChainItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAccreditationChainItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAccreditationChainItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAccreditationChainItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AccreditationChainItem[] | undefined;
}

export class ResponseOfListOfAccreditationChainItem extends ResponseOfListOfAccreditationChainItemAndString implements IResponseOfListOfAccreditationChainItem {

    constructor(data?: IResponseOfListOfAccreditationChainItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAccreditationChainItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAccreditationChainItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAccreditationChainItem extends IResponseOfListOfAccreditationChainItemAndString {
}

export class ListResponseOfAccreditationChainItem extends ResponseOfListOfAccreditationChainItem implements IListResponseOfAccreditationChainItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAccreditationChainItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAccreditationChainItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAccreditationChainItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAccreditationChainItem extends IResponseOfListOfAccreditationChainItem {
    totalRecords?: number | undefined;
}

export class AccreditationChainRequest implements IAccreditationChainRequest {
    qualificationIds?: string[] | undefined;

    constructor(data?: IAccreditationChainRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["qualificationIds"])) {
                this.qualificationIds = [] as any;
                for (let item of _data["qualificationIds"])
                    this.qualificationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AccreditationChainRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditationChainRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.qualificationIds)) {
            data["qualificationIds"] = [];
            for (let item of this.qualificationIds)
                data["qualificationIds"].push(item);
        }
        return data;
    }
}

export interface IAccreditationChainRequest {
    qualificationIds?: string[] | undefined;
}

export class OrganizationQualificationRequest implements IOrganizationQualificationRequest {
    id?: string | undefined;
    qualificationId?: string | undefined;
    organizationId?: string;
    value?: string | undefined;
    acronym?: string | undefined;
    displayValue?: string | undefined;
    displayOrder?: number | undefined;
    externalSourceId?: string | undefined;
    qualificationTypeId?: string;
    qualificationStatementIds?: string[] | undefined;

    constructor(data?: IOrganizationQualificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationId = _data["qualificationId"];
            this.organizationId = _data["organizationId"];
            this.value = _data["value"];
            this.acronym = _data["acronym"];
            this.displayValue = _data["displayValue"];
            this.displayOrder = _data["displayOrder"];
            this.externalSourceId = _data["externalSourceId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            if (Array.isArray(_data["qualificationStatementIds"])) {
                this.qualificationStatementIds = [] as any;
                for (let item of _data["qualificationStatementIds"])
                    this.qualificationStatementIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationQualificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationQualificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationId"] = this.qualificationId;
        data["organizationId"] = this.organizationId;
        data["value"] = this.value;
        data["acronym"] = this.acronym;
        data["displayValue"] = this.displayValue;
        data["displayOrder"] = this.displayOrder;
        data["externalSourceId"] = this.externalSourceId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        if (Array.isArray(this.qualificationStatementIds)) {
            data["qualificationStatementIds"] = [];
            for (let item of this.qualificationStatementIds)
                data["qualificationStatementIds"].push(item);
        }
        return data;
    }
}

export interface IOrganizationQualificationRequest {
    id?: string | undefined;
    qualificationId?: string | undefined;
    organizationId?: string;
    value?: string | undefined;
    acronym?: string | undefined;
    displayValue?: string | undefined;
    displayOrder?: number | undefined;
    externalSourceId?: string | undefined;
    qualificationTypeId?: string;
    qualificationStatementIds?: string[] | undefined;
}

export class ValidateResponse implements IValidateResponse {
    uan?: string | undefined;
    isValid?: boolean;
    title?: string | undefined;
    releaseDate?: Date | undefined;
    expirationDate?: Date | undefined;
    contactHours?: number | undefined;
    creditHours?: number | undefined;
    courseSetting?: string | undefined;
    liveDates?: ValidateLiveDateResponse[] | undefined;
    errorNumber?: number;
    errorMessage?: string | undefined;

    constructor(data?: IValidateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uan = _data["uan"];
            this.isValid = _data["isValid"];
            this.title = _data["title"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.contactHours = _data["contactHours"];
            this.creditHours = _data["creditHours"];
            this.courseSetting = _data["courseSetting"];
            if (Array.isArray(_data["liveDates"])) {
                this.liveDates = [] as any;
                for (let item of _data["liveDates"])
                    this.liveDates!.push(ValidateLiveDateResponse.fromJS(item));
            }
            this.errorNumber = _data["errorNumber"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ValidateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uan"] = this.uan;
        data["isValid"] = this.isValid;
        data["title"] = this.title;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["contactHours"] = this.contactHours;
        data["creditHours"] = this.creditHours;
        data["courseSetting"] = this.courseSetting;
        if (Array.isArray(this.liveDates)) {
            data["liveDates"] = [];
            for (let item of this.liveDates)
                data["liveDates"].push(item ? item.toJSON() : undefined as any);
        }
        data["errorNumber"] = this.errorNumber;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IValidateResponse {
    uan?: string | undefined;
    isValid?: boolean;
    title?: string | undefined;
    releaseDate?: Date | undefined;
    expirationDate?: Date | undefined;
    contactHours?: number | undefined;
    creditHours?: number | undefined;
    courseSetting?: string | undefined;
    liveDates?: ValidateLiveDateResponse[] | undefined;
    errorNumber?: number;
    errorMessage?: string | undefined;
}

export class ValidateLiveDateResponse implements IValidateLiveDateResponse {
    liveDate?: Date | undefined;
    location?: string | undefined;
    format?: string | undefined;

    constructor(data?: IValidateLiveDateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liveDate = _data["liveDate"] ? new Date(_data["liveDate"].toString()) : undefined as any;
            this.location = _data["location"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): ValidateLiveDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateLiveDateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liveDate"] = this.liveDate ? this.liveDate.toISOString() : undefined as any;
        data["location"] = this.location;
        data["format"] = this.format;
        return data;
    }
}

export interface IValidateLiveDateResponse {
    liveDate?: Date | undefined;
    location?: string | undefined;
    format?: string | undefined;
}

export class ResponseOfValidateCourseNumberResponseAndString implements IResponseOfValidateCourseNumberResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ValidateCourseNumberResponse | undefined;

    constructor(data?: IResponseOfValidateCourseNumberResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ValidateCourseNumberResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfValidateCourseNumberResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfValidateCourseNumberResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfValidateCourseNumberResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ValidateCourseNumberResponse | undefined;
}

export class ResponseOfValidateCourseNumberResponse extends ResponseOfValidateCourseNumberResponseAndString implements IResponseOfValidateCourseNumberResponse {

    constructor(data?: IResponseOfValidateCourseNumberResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfValidateCourseNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfValidateCourseNumberResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfValidateCourseNumberResponse extends IResponseOfValidateCourseNumberResponseAndString {
}

export class ValidateCourseNumberResponse implements IValidateCourseNumberResponse {
    hasConflict?: boolean;
    existingSkuCourseNumbers?: SkuCourseNumbers[] | undefined;

    constructor(data?: IValidateCourseNumberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasConflict = _data["hasConflict"];
            if (Array.isArray(_data["existingSkuCourseNumbers"])) {
                this.existingSkuCourseNumbers = [] as any;
                for (let item of _data["existingSkuCourseNumbers"])
                    this.existingSkuCourseNumbers!.push(SkuCourseNumbers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateCourseNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCourseNumberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasConflict"] = this.hasConflict;
        if (Array.isArray(this.existingSkuCourseNumbers)) {
            data["existingSkuCourseNumbers"] = [];
            for (let item of this.existingSkuCourseNumbers)
                data["existingSkuCourseNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidateCourseNumberResponse {
    hasConflict?: boolean;
    existingSkuCourseNumbers?: SkuCourseNumbers[] | undefined;
}

export class SkuCourseNumbers implements ISkuCourseNumbers {
    sku?: string | undefined;
    courseNumbers?: string[] | undefined;

    constructor(data?: ISkuCourseNumbers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            if (Array.isArray(_data["courseNumbers"])) {
                this.courseNumbers = [] as any;
                for (let item of _data["courseNumbers"])
                    this.courseNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): SkuCourseNumbers {
        data = typeof data === 'object' ? data : {};
        let result = new SkuCourseNumbers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        if (Array.isArray(this.courseNumbers)) {
            data["courseNumbers"] = [];
            for (let item of this.courseNumbers)
                data["courseNumbers"].push(item);
        }
        return data;
    }
}

export interface ISkuCourseNumbers {
    sku?: string | undefined;
    courseNumbers?: string[] | undefined;
}

export class ValidateCourseNumberRequest implements IValidateCourseNumberRequest {
    productId!: string;
    qualificationId!: string;
    professionId?: string | undefined;
    skuAvailabilityId!: string;
    courseNumber!: string;
    skuId?: string | undefined;

    constructor(data?: IValidateCourseNumberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.qualificationId = _data["qualificationId"];
            this.professionId = _data["professionId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.courseNumber = _data["courseNumber"];
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): ValidateCourseNumberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCourseNumberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["qualificationId"] = this.qualificationId;
        data["professionId"] = this.professionId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["courseNumber"] = this.courseNumber;
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface IValidateCourseNumberRequest {
    productId: string;
    qualificationId: string;
    professionId?: string | undefined;
    skuAvailabilityId: string;
    courseNumber: string;
    skuId?: string | undefined;
}

export class ResponseOfListOfQualificationStatementAndString implements IResponseOfListOfQualificationStatementAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStatement[] | undefined;

    constructor(data?: IResponseOfListOfQualificationStatementAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QualificationStatement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfQualificationStatementAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationStatementAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfQualificationStatementAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStatement[] | undefined;
}

export class ResponseOfListOfQualificationStatement extends ResponseOfListOfQualificationStatementAndString implements IResponseOfListOfQualificationStatement {

    constructor(data?: IResponseOfListOfQualificationStatement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfQualificationStatement {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationStatement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfQualificationStatement extends IResponseOfListOfQualificationStatementAndString {
}

export class ListResponseOfQualificationStatement extends ResponseOfListOfQualificationStatement implements IListResponseOfQualificationStatement {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfQualificationStatement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfQualificationStatement {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQualificationStatement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfQualificationStatement extends IResponseOfListOfQualificationStatement {
    totalRecords?: number | undefined;
}

export class QualificationStatement implements IQualificationStatement {
    id!: string;
    qualificationStatementTypeName?: string | undefined;
    qualificationStatementTypeId?: string;
    contentName?: string | undefined;
    profession?: Profession | undefined;
    professionDisplayValue?: string | undefined;
    sequence?: number;

    constructor(data?: IQualificationStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationStatementTypeName = _data["qualificationStatementTypeName"];
            this.qualificationStatementTypeId = _data["qualificationStatementTypeId"];
            this.contentName = _data["contentName"];
            this.profession = _data["profession"] ? Profession.fromJS(_data["profession"]) : undefined as any;
            this.professionDisplayValue = _data["professionDisplayValue"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): QualificationStatement {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationStatementTypeName"] = this.qualificationStatementTypeName;
        data["qualificationStatementTypeId"] = this.qualificationStatementTypeId;
        data["contentName"] = this.contentName;
        data["profession"] = this.profession ? this.profession.toJSON() : undefined as any;
        data["professionDisplayValue"] = this.professionDisplayValue;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IQualificationStatement {
    id: string;
    qualificationStatementTypeName?: string | undefined;
    qualificationStatementTypeId?: string;
    contentName?: string | undefined;
    profession?: Profession | undefined;
    professionDisplayValue?: string | undefined;
    sequence?: number;
}

export class Profession implements IProfession {
    id?: string;
    name?: string | undefined;

    constructor(data?: IProfession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Profession {
        data = typeof data === 'object' ? data : {};
        let result = new Profession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProfession {
    id?: string;
    name?: string | undefined;
}

export class ListRequestOfQualificationStatementFilter implements IListRequestOfQualificationStatementFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QualificationStatementFilter | undefined;

    constructor(data?: IListRequestOfQualificationStatementFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? QualificationStatementFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfQualificationStatementFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfQualificationStatementFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfQualificationStatementFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QualificationStatementFilter | undefined;
}

export class QualificationStatementFilter extends BaseFilter implements IQualificationStatementFilter {

    constructor(data?: IQualificationStatementFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualificationStatementFilter {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStatementFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualificationStatementFilter extends IBaseFilter {
}

export class ResponseOfQualificationStatementAndString implements IResponseOfQualificationStatementAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStatement | undefined;

    constructor(data?: IResponseOfQualificationStatementAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? QualificationStatement.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfQualificationStatementAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQualificationStatementAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfQualificationStatementAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStatement | undefined;
}

export class ResponseOfQualificationStatement extends ResponseOfQualificationStatementAndString implements IResponseOfQualificationStatement {

    constructor(data?: IResponseOfQualificationStatement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfQualificationStatement {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQualificationStatement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfQualificationStatement extends IResponseOfQualificationStatementAndString {
}

export class QualificationStatementRequest implements IQualificationStatementRequest {
    id?: string | undefined;
    qualificationStatementTypeId?: string;
    professionId?: string | undefined;
    contentName?: string | undefined;
    sequence?: number;

    constructor(data?: IQualificationStatementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationStatementTypeId = _data["qualificationStatementTypeId"];
            this.professionId = _data["professionId"];
            this.contentName = _data["contentName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): QualificationStatementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStatementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationStatementTypeId"] = this.qualificationStatementTypeId;
        data["professionId"] = this.professionId;
        data["contentName"] = this.contentName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IQualificationStatementRequest {
    id?: string | undefined;
    qualificationStatementTypeId?: string;
    professionId?: string | undefined;
    contentName?: string | undefined;
    sequence?: number;
}

export class QualificationStatementSequenceRequest implements IQualificationStatementSequenceRequest {
    qualificationStatementId?: string;
    sequence?: number;

    constructor(data?: IQualificationStatementSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationStatementId = _data["qualificationStatementId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): QualificationStatementSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStatementSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationStatementId"] = this.qualificationStatementId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IQualificationStatementSequenceRequest {
    qualificationStatementId?: string;
    sequence?: number;
}

export class ResponseOfListOfQualificationStatementTypeAndString implements IResponseOfListOfQualificationStatementTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStatementType[] | undefined;

    constructor(data?: IResponseOfListOfQualificationStatementTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QualificationStatementType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfQualificationStatementTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationStatementTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfQualificationStatementTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStatementType[] | undefined;
}

export class ResponseOfListOfQualificationStatementType extends ResponseOfListOfQualificationStatementTypeAndString implements IResponseOfListOfQualificationStatementType {

    constructor(data?: IResponseOfListOfQualificationStatementType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfQualificationStatementType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationStatementType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfQualificationStatementType extends IResponseOfListOfQualificationStatementTypeAndString {
}

export class ListResponseOfQualificationStatementType extends ResponseOfListOfQualificationStatementType implements IListResponseOfQualificationStatementType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfQualificationStatementType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfQualificationStatementType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQualificationStatementType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfQualificationStatementType extends IResponseOfListOfQualificationStatementType {
    totalRecords?: number | undefined;
}

export class QualificationStatementType implements IQualificationStatementType {
    id!: string;
    name?: string | undefined;

    constructor(data?: IQualificationStatementType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): QualificationStatementType {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStatementType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IQualificationStatementType {
    id: string;
    name?: string | undefined;
}

export class ResponseOfListOfQualificationStudyFieldAndString implements IResponseOfListOfQualificationStudyFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStudyField[] | undefined;

    constructor(data?: IResponseOfListOfQualificationStudyFieldAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QualificationStudyField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfQualificationStudyFieldAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationStudyFieldAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfQualificationStudyFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: QualificationStudyField[] | undefined;
}

export class ResponseOfListOfQualificationStudyField extends ResponseOfListOfQualificationStudyFieldAndString implements IResponseOfListOfQualificationStudyField {

    constructor(data?: IResponseOfListOfQualificationStudyField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfQualificationStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfQualificationStudyField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfQualificationStudyField extends IResponseOfListOfQualificationStudyFieldAndString {
}

export class ListResponseOfQualificationStudyField extends ResponseOfListOfQualificationStudyField implements IListResponseOfQualificationStudyField {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfQualificationStudyField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfQualificationStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQualificationStudyField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfQualificationStudyField extends IResponseOfListOfQualificationStudyField {
    totalRecords?: number | undefined;
}

export class QualificationStudyField implements IQualificationStudyField {
    id!: string;
    studyFieldId?: string;
    studyFieldName?: string | undefined;
    submitValidationRequired?: boolean;

    constructor(data?: IQualificationStudyField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyFieldId = _data["studyFieldId"];
            this.studyFieldName = _data["studyFieldName"];
            this.submitValidationRequired = _data["submitValidationRequired"];
        }
    }

    static fromJS(data: any): QualificationStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStudyField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyFieldId"] = this.studyFieldId;
        data["studyFieldName"] = this.studyFieldName;
        data["submitValidationRequired"] = this.submitValidationRequired;
        return data;
    }
}

export interface IQualificationStudyField {
    id: string;
    studyFieldId?: string;
    studyFieldName?: string | undefined;
    submitValidationRequired?: boolean;
}

export class ListRequestOfQualificationStudyFieldFilter implements IListRequestOfQualificationStudyFieldFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QualificationStudyFieldFilter | undefined;

    constructor(data?: IListRequestOfQualificationStudyFieldFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? QualificationStudyFieldFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfQualificationStudyFieldFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfQualificationStudyFieldFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfQualificationStudyFieldFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: QualificationStudyFieldFilter | undefined;
}

export class QualificationStudyFieldFilter extends BaseFilter implements IQualificationStudyFieldFilter {
    qualificationId?: string | undefined;

    constructor(data?: IQualificationStudyFieldFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualificationId = _data["qualificationId"];
        }
    }

    static override fromJS(data: any): QualificationStudyFieldFilter {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStudyFieldFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        super.toJSON(data);
        return data;
    }
}

export interface IQualificationStudyFieldFilter extends IBaseFilter {
    qualificationId?: string | undefined;
}

export class QualificationStudyFieldSaveRequest implements IQualificationStudyFieldSaveRequest {
    studyFieldId!: string;
    submitValidationRequired?: boolean;

    constructor(data?: IQualificationStudyFieldSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyFieldId = _data["studyFieldId"];
            this.submitValidationRequired = _data["submitValidationRequired"];
        }
    }

    static fromJS(data: any): QualificationStudyFieldSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationStudyFieldSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyFieldId"] = this.studyFieldId;
        data["submitValidationRequired"] = this.submitValidationRequired;
        return data;
    }
}

export interface IQualificationStudyFieldSaveRequest {
    studyFieldId: string;
    submitValidationRequired?: boolean;
}

export class ResponseOfListOfResourceLibraryAndString implements IResponseOfListOfResourceLibraryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibrary[] | undefined;

    constructor(data?: IResponseOfListOfResourceLibraryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceLibrary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceLibraryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibrary[] | undefined;
}

export class ResponseOfListOfResourceLibrary extends ResponseOfListOfResourceLibraryAndString implements IResponseOfListOfResourceLibrary {

    constructor(data?: IResponseOfListOfResourceLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceLibrary extends IResponseOfListOfResourceLibraryAndString {
}

export class ListResponseOfResourceLibrary extends ResponseOfListOfResourceLibrary implements IListResponseOfResourceLibrary {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResourceLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceLibrary extends IResponseOfListOfResourceLibrary {
    totalRecords?: number | undefined;
}

export class ResourceLibrary implements IResourceLibrary {
    id!: string;
    name!: string;
    organizationId!: string;
    organizationName?: string | undefined;

    constructor(data?: IResourceLibrary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): ResourceLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibrary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IResourceLibrary {
    id: string;
    name: string;
    organizationId: string;
    organizationName?: string | undefined;
}

export class ResponseOfListOfResourceLibraryItemAndString implements IResponseOfListOfResourceLibraryItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItem[] | undefined;

    constructor(data?: IResponseOfListOfResourceLibraryItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceLibraryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceLibraryItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItem[] | undefined;
}

export class ResponseOfListOfResourceLibraryItem extends ResponseOfListOfResourceLibraryItemAndString implements IResponseOfListOfResourceLibraryItem {

    constructor(data?: IResponseOfListOfResourceLibraryItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceLibraryItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItem extends IResponseOfListOfResourceLibraryItemAndString {
}

export class ListResponseOfResourceLibraryItem extends ResponseOfListOfResourceLibraryItem implements IListResponseOfResourceLibraryItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResourceLibraryItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceLibraryItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceLibraryItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceLibraryItem extends IResponseOfListOfResourceLibraryItem {
    totalRecords?: number | undefined;
}

export class ResourceLibraryItem implements IResourceLibraryItem {
    id!: string;
    name!: string;
    fileName!: string;
    publicationDate!: Date;
    description?: string | undefined;
    sequence!: number;
    resourceLibraryTypeId!: string;
    resourceLibraryTypeName!: string;
    contentUrl?: string | undefined;
    resourceLibraryId?: string;

    constructor(data?: IResourceLibraryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileName = _data["fileName"];
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.sequence = _data["sequence"];
            this.resourceLibraryTypeId = _data["resourceLibraryTypeId"];
            this.resourceLibraryTypeName = _data["resourceLibraryTypeName"];
            this.contentUrl = _data["contentUrl"];
            this.resourceLibraryId = _data["resourceLibraryId"];
        }
    }

    static fromJS(data: any): ResourceLibraryItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["sequence"] = this.sequence;
        data["resourceLibraryTypeId"] = this.resourceLibraryTypeId;
        data["resourceLibraryTypeName"] = this.resourceLibraryTypeName;
        data["contentUrl"] = this.contentUrl;
        data["resourceLibraryId"] = this.resourceLibraryId;
        return data;
    }
}

export interface IResourceLibraryItem {
    id: string;
    name: string;
    fileName: string;
    publicationDate: Date;
    description?: string | undefined;
    sequence: number;
    resourceLibraryTypeId: string;
    resourceLibraryTypeName: string;
    contentUrl?: string | undefined;
    resourceLibraryId?: string;
}

export class ListRequestOfResourceLibraryItemFilter implements IListRequestOfResourceLibraryItemFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ResourceLibraryItemFilter | undefined;

    constructor(data?: IListRequestOfResourceLibraryItemFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ResourceLibraryItemFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfResourceLibraryItemFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfResourceLibraryItemFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfResourceLibraryItemFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ResourceLibraryItemFilter | undefined;
}

export class ResourceLibraryItemFilter extends BaseFilter implements IResourceLibraryItemFilter {
    resourceLibraryTypeId?: string | undefined;
    publicationDateFrom?: Date | undefined;
    publicationDateTo?: Date | undefined;

    constructor(data?: IResourceLibraryItemFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.resourceLibraryTypeId = _data["resourceLibraryTypeId"];
            this.publicationDateFrom = _data["publicationDateFrom"] ? new Date(_data["publicationDateFrom"].toString()) : undefined as any;
            this.publicationDateTo = _data["publicationDateTo"] ? new Date(_data["publicationDateTo"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): ResourceLibraryItemFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryItemFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceLibraryTypeId"] = this.resourceLibraryTypeId;
        data["publicationDateFrom"] = this.publicationDateFrom ? this.publicationDateFrom.toISOString() : undefined as any;
        data["publicationDateTo"] = this.publicationDateTo ? this.publicationDateTo.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResourceLibraryItemFilter extends IBaseFilter {
    resourceLibraryTypeId?: string | undefined;
    publicationDateFrom?: Date | undefined;
    publicationDateTo?: Date | undefined;
}

export class ResponseOfListOfResourceLibraryItemProfessionAndString implements IResponseOfListOfResourceLibraryItemProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItemProfession[] | undefined;

    constructor(data?: IResponseOfListOfResourceLibraryItemProfessionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceLibraryItemProfession.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceLibraryItemProfessionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItemProfessionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItemProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItemProfession[] | undefined;
}

export class ResponseOfListOfResourceLibraryItemProfession extends ResponseOfListOfResourceLibraryItemProfessionAndString implements IResponseOfListOfResourceLibraryItemProfession {

    constructor(data?: IResponseOfListOfResourceLibraryItemProfession) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceLibraryItemProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItemProfession();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItemProfession extends IResponseOfListOfResourceLibraryItemProfessionAndString {
}

export class ListResponseOfResourceLibraryItemProfession extends ResponseOfListOfResourceLibraryItemProfession implements IListResponseOfResourceLibraryItemProfession {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResourceLibraryItemProfession) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceLibraryItemProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceLibraryItemProfession();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceLibraryItemProfession extends IResponseOfListOfResourceLibraryItemProfession {
    totalRecords?: number | undefined;
}

export class ResourceLibraryItemProfession implements IResourceLibraryItemProfession {
    id!: string;
    professionId!: string;
    professionName!: string;

    constructor(data?: IResourceLibraryItemProfession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
        }
    }

    static fromJS(data: any): ResourceLibraryItemProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryItemProfession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        return data;
    }
}

export interface IResourceLibraryItemProfession {
    id: string;
    professionId: string;
    professionName: string;
}

export class ResponseOfListOfResourceLibraryItemTypeAndString implements IResponseOfListOfResourceLibraryItemTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItemType[] | undefined;

    constructor(data?: IResponseOfListOfResourceLibraryItemTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceLibraryItemType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceLibraryItemTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItemTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItemTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItemType[] | undefined;
}

export class ResponseOfListOfResourceLibraryItemType extends ResponseOfListOfResourceLibraryItemTypeAndString implements IResponseOfListOfResourceLibraryItemType {

    constructor(data?: IResponseOfListOfResourceLibraryItemType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceLibraryItemType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItemType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItemType extends IResponseOfListOfResourceLibraryItemTypeAndString {
}

export class ListResponseOfResourceLibraryItemType extends ResponseOfListOfResourceLibraryItemType implements IListResponseOfResourceLibraryItemType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResourceLibraryItemType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceLibraryItemType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceLibraryItemType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceLibraryItemType extends IResponseOfListOfResourceLibraryItemType {
    totalRecords?: number | undefined;
}

export class ResourceLibraryItemType implements IResourceLibraryItemType {
    id!: string;
    name!: string;

    constructor(data?: IResourceLibraryItemType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ResourceLibraryItemType {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryItemType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IResourceLibraryItemType {
    id: string;
    name: string;
}

export class ResponseOfResourceLibraryDetailAndString implements IResponseOfResourceLibraryDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryDetail | undefined;

    constructor(data?: IResponseOfResourceLibraryDetailAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ResourceLibraryDetail.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfResourceLibraryDetailAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfResourceLibraryDetailAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfResourceLibraryDetailAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryDetail | undefined;
}

export class ResponseOfResourceLibraryDetail extends ResponseOfResourceLibraryDetailAndString implements IResponseOfResourceLibraryDetail {

    constructor(data?: IResponseOfResourceLibraryDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfResourceLibraryDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfResourceLibraryDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfResourceLibraryDetail extends IResponseOfResourceLibraryDetailAndString {
}

export class ResourceLibraryDetail extends ResourceLibrary implements IResourceLibraryDetail {
    description?: string | undefined;
    libraryPath!: string;
    contentName?: string | undefined;

    constructor(data?: IResourceLibraryDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.libraryPath = _data["libraryPath"];
            this.contentName = _data["contentName"];
        }
    }

    static override fromJS(data: any): ResourceLibraryDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["libraryPath"] = this.libraryPath;
        data["contentName"] = this.contentName;
        super.toJSON(data);
        return data;
    }
}

export interface IResourceLibraryDetail extends IResourceLibrary {
    description?: string | undefined;
    libraryPath: string;
    contentName?: string | undefined;
}

export class ResponseOfResourceLibraryItemAndString implements IResponseOfResourceLibraryItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItem | undefined;

    constructor(data?: IResponseOfResourceLibraryItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ResourceLibraryItem.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfResourceLibraryItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfResourceLibraryItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfResourceLibraryItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItem | undefined;
}

export class ResponseOfResourceLibraryItem extends ResponseOfResourceLibraryItemAndString implements IResponseOfResourceLibraryItem {

    constructor(data?: IResponseOfResourceLibraryItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfResourceLibraryItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfResourceLibraryItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfResourceLibraryItem extends IResponseOfResourceLibraryItemAndString {
}

export class SaveResourceLibraryRequest implements ISaveResourceLibraryRequest {
    id?: string | undefined;
    name!: string;
    description?: string | undefined;
    libraryPath!: string;
    contentName?: string | undefined;
    organizationId!: string;

    constructor(data?: ISaveResourceLibraryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.libraryPath = _data["libraryPath"];
            this.contentName = _data["contentName"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): SaveResourceLibraryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResourceLibraryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["libraryPath"] = this.libraryPath;
        data["contentName"] = this.contentName;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ISaveResourceLibraryRequest {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    libraryPath: string;
    contentName?: string | undefined;
    organizationId: string;
}

export class SaveResourceLibraryItemProfessionRequest implements ISaveResourceLibraryItemProfessionRequest {
    id?: string | undefined;
    professionId!: string;

    constructor(data?: ISaveResourceLibraryItemProfessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): SaveResourceLibraryItemProfessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResourceLibraryItemProfessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ISaveResourceLibraryItemProfessionRequest {
    id?: string | undefined;
    professionId: string;
}

export class ResponseOfListOfResourceLibraryItemAttributeAndString implements IResponseOfListOfResourceLibraryItemAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItemAttribute[] | undefined;

    constructor(data?: IResponseOfListOfResourceLibraryItemAttributeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceLibraryItemAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceLibraryItemAttributeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItemAttributeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItemAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceLibraryItemAttribute[] | undefined;
}

export class ResponseOfListOfResourceLibraryItemAttribute extends ResponseOfListOfResourceLibraryItemAttributeAndString implements IResponseOfListOfResourceLibraryItemAttribute {

    constructor(data?: IResponseOfListOfResourceLibraryItemAttribute) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceLibraryItemAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceLibraryItemAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceLibraryItemAttribute extends IResponseOfListOfResourceLibraryItemAttributeAndString {
}

export class ListResponseOfResourceLibraryItemAttribute extends ResponseOfListOfResourceLibraryItemAttribute implements IListResponseOfResourceLibraryItemAttribute {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResourceLibraryItemAttribute) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceLibraryItemAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceLibraryItemAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceLibraryItemAttribute extends IResponseOfListOfResourceLibraryItemAttribute {
    totalRecords?: number | undefined;
}

export class ResourceLibraryItemAttribute implements IResourceLibraryItemAttribute {
    id!: string;
    attributeId!: string;
    attributeValue!: string;
    attributeDisplayText?: string | undefined;
    attributeTypeCodeConstant?: string | undefined;
    organizationAttributeTypeDisplayName?: string | undefined;

    constructor(data?: IResourceLibraryItemAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeId = _data["attributeId"];
            this.attributeValue = _data["attributeValue"];
            this.attributeDisplayText = _data["attributeDisplayText"];
            this.attributeTypeCodeConstant = _data["attributeTypeCodeConstant"];
            this.organizationAttributeTypeDisplayName = _data["organizationAttributeTypeDisplayName"];
        }
    }

    static fromJS(data: any): ResourceLibraryItemAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryItemAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeId"] = this.attributeId;
        data["attributeValue"] = this.attributeValue;
        data["attributeDisplayText"] = this.attributeDisplayText;
        data["attributeTypeCodeConstant"] = this.attributeTypeCodeConstant;
        data["organizationAttributeTypeDisplayName"] = this.organizationAttributeTypeDisplayName;
        return data;
    }
}

export interface IResourceLibraryItemAttribute {
    id: string;
    attributeId: string;
    attributeValue: string;
    attributeDisplayText?: string | undefined;
    attributeTypeCodeConstant?: string | undefined;
    organizationAttributeTypeDisplayName?: string | undefined;
}

export class SaveResourceLibraryItemAttributeRequest implements ISaveResourceLibraryItemAttributeRequest {
    id?: string | undefined;
    attributeId!: string;

    constructor(data?: ISaveResourceLibraryItemAttributeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeId = _data["attributeId"];
        }
    }

    static fromJS(data: any): SaveResourceLibraryItemAttributeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResourceLibraryItemAttributeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeId"] = this.attributeId;
        return data;
    }
}

export interface ISaveResourceLibraryItemAttributeRequest {
    id?: string | undefined;
    attributeId: string;
}

export class ResponseOfListOfSkuUserAgreementInfoAndString implements IResponseOfListOfSkuUserAgreementInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuUserAgreementInfo[] | undefined;

    constructor(data?: IResponseOfListOfSkuUserAgreementInfoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuUserAgreementInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuUserAgreementInfoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuUserAgreementInfoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuUserAgreementInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuUserAgreementInfo[] | undefined;
}

export class ResponseOfListOfSkuUserAgreementInfo extends ResponseOfListOfSkuUserAgreementInfoAndString implements IResponseOfListOfSkuUserAgreementInfo {

    constructor(data?: IResponseOfListOfSkuUserAgreementInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuUserAgreementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuUserAgreementInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuUserAgreementInfo extends IResponseOfListOfSkuUserAgreementInfoAndString {
}

export class ListResponseOfSkuUserAgreementInfo extends ResponseOfListOfSkuUserAgreementInfo implements IListResponseOfSkuUserAgreementInfo {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuUserAgreementInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuUserAgreementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuUserAgreementInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuUserAgreementInfo extends IResponseOfListOfSkuUserAgreementInfo {
    totalRecords?: number | undefined;
}

export class SkuUserAgreementInfo implements ISkuUserAgreementInfo {
    id!: string;
    skuId?: string;
    organizationUserId?: string;
    sku?: string | undefined;
    skuTitle?: string | undefined;
    skuAvailabilityName?: string | undefined;
    userName?: string | undefined;
    resourceTypeNames?: string | undefined;
    agreementId?: string;
    agreementName?: string | undefined;
    dueDate?: Date;
    statusId?: string;
    statusName?: string | undefined;
    skuUserAgreementValues?: SkuUserAgreementValue[] | undefined;

    constructor(data?: ISkuUserAgreementInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.organizationUserId = _data["organizationUserId"];
            this.sku = _data["sku"];
            this.skuTitle = _data["skuTitle"];
            this.skuAvailabilityName = _data["skuAvailabilityName"];
            this.userName = _data["userName"];
            this.resourceTypeNames = _data["resourceTypeNames"];
            this.agreementId = _data["agreementId"];
            this.agreementName = _data["agreementName"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            if (Array.isArray(_data["skuUserAgreementValues"])) {
                this.skuUserAgreementValues = [] as any;
                for (let item of _data["skuUserAgreementValues"])
                    this.skuUserAgreementValues!.push(SkuUserAgreementValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuUserAgreementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["organizationUserId"] = this.organizationUserId;
        data["sku"] = this.sku;
        data["skuTitle"] = this.skuTitle;
        data["skuAvailabilityName"] = this.skuAvailabilityName;
        data["userName"] = this.userName;
        data["resourceTypeNames"] = this.resourceTypeNames;
        data["agreementId"] = this.agreementId;
        data["agreementName"] = this.agreementName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        if (Array.isArray(this.skuUserAgreementValues)) {
            data["skuUserAgreementValues"] = [];
            for (let item of this.skuUserAgreementValues)
                data["skuUserAgreementValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuUserAgreementInfo {
    id: string;
    skuId?: string;
    organizationUserId?: string;
    sku?: string | undefined;
    skuTitle?: string | undefined;
    skuAvailabilityName?: string | undefined;
    userName?: string | undefined;
    resourceTypeNames?: string | undefined;
    agreementId?: string;
    agreementName?: string | undefined;
    dueDate?: Date;
    statusId?: string;
    statusName?: string | undefined;
    skuUserAgreementValues?: SkuUserAgreementValue[] | undefined;
}

export class SkuUserAgreementValue implements ISkuUserAgreementValue {
    id?: string | undefined;
    skuUserAgreementId?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISkuUserAgreementValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuUserAgreementId = _data["skuUserAgreementId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SkuUserAgreementValue {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuUserAgreementId"] = this.skuUserAgreementId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

export interface ISkuUserAgreementValue {
    id?: string | undefined;
    skuUserAgreementId?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: string | undefined;
}

export class ListRequestOfSkuUserAgreementFilter implements IListRequestOfSkuUserAgreementFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuUserAgreementFilter | undefined;

    constructor(data?: IListRequestOfSkuUserAgreementFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuUserAgreementFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuUserAgreementFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuUserAgreementFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuUserAgreementFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuUserAgreementFilter | undefined;
}

export class SkuUserAgreementFilter extends BaseFilter implements ISkuUserAgreementFilter {
    skuId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    organizationUserId?: string | undefined;
    resourceTypeIds?: string[] | undefined;
    agreementId?: string | undefined;
    dueDateFrom?: Date | undefined;
    dueDateTo?: Date | undefined;
    statusIds?: string[] | undefined;

    constructor(data?: ISkuUserAgreementFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuId = _data["skuId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.organizationUserId = _data["organizationUserId"];
            if (Array.isArray(_data["resourceTypeIds"])) {
                this.resourceTypeIds = [] as any;
                for (let item of _data["resourceTypeIds"])
                    this.resourceTypeIds!.push(item);
            }
            this.agreementId = _data["agreementId"];
            this.dueDateFrom = _data["dueDateFrom"] ? new Date(_data["dueDateFrom"].toString()) : undefined as any;
            this.dueDateTo = _data["dueDateTo"] ? new Date(_data["dueDateTo"].toString()) : undefined as any;
            if (Array.isArray(_data["statusIds"])) {
                this.statusIds = [] as any;
                for (let item of _data["statusIds"])
                    this.statusIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): SkuUserAgreementFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["organizationUserId"] = this.organizationUserId;
        if (Array.isArray(this.resourceTypeIds)) {
            data["resourceTypeIds"] = [];
            for (let item of this.resourceTypeIds)
                data["resourceTypeIds"].push(item);
        }
        data["agreementId"] = this.agreementId;
        data["dueDateFrom"] = this.dueDateFrom ? this.dueDateFrom.toISOString() : undefined as any;
        data["dueDateTo"] = this.dueDateTo ? this.dueDateTo.toISOString() : undefined as any;
        if (Array.isArray(this.statusIds)) {
            data["statusIds"] = [];
            for (let item of this.statusIds)
                data["statusIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISkuUserAgreementFilter extends IBaseFilter {
    skuId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    organizationUserId?: string | undefined;
    resourceTypeIds?: string[] | undefined;
    agreementId?: string | undefined;
    dueDateFrom?: Date | undefined;
    dueDateTo?: Date | undefined;
    statusIds?: string[] | undefined;
}

export class ResponseOfSkuUserAgreementInfoAndString implements IResponseOfSkuUserAgreementInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuUserAgreementInfo | undefined;

    constructor(data?: IResponseOfSkuUserAgreementInfoAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SkuUserAgreementInfo.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSkuUserAgreementInfoAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuUserAgreementInfoAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSkuUserAgreementInfoAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuUserAgreementInfo | undefined;
}

export class ResponseOfSkuUserAgreementInfo extends ResponseOfSkuUserAgreementInfoAndString implements IResponseOfSkuUserAgreementInfo {

    constructor(data?: IResponseOfSkuUserAgreementInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSkuUserAgreementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuUserAgreementInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSkuUserAgreementInfo extends IResponseOfSkuUserAgreementInfoAndString {
}

export class SkuUserAgreementSaveRequest implements ISkuUserAgreementSaveRequest {
    id?: string | undefined;
    skuId?: string;
    organizationUserId?: string;
    agreementId?: string;
    dueDate?: Date;
    html?: string | undefined;
    agreementName?: string | undefined;
    skuUserAgreementValues?: SkuUserAgreementValue[] | undefined;

    constructor(data?: ISkuUserAgreementSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.organizationUserId = _data["organizationUserId"];
            this.agreementId = _data["agreementId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.html = _data["html"];
            this.agreementName = _data["agreementName"];
            if (Array.isArray(_data["skuUserAgreementValues"])) {
                this.skuUserAgreementValues = [] as any;
                for (let item of _data["skuUserAgreementValues"])
                    this.skuUserAgreementValues!.push(SkuUserAgreementValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuUserAgreementSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["organizationUserId"] = this.organizationUserId;
        data["agreementId"] = this.agreementId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["html"] = this.html;
        data["agreementName"] = this.agreementName;
        if (Array.isArray(this.skuUserAgreementValues)) {
            data["skuUserAgreementValues"] = [];
            for (let item of this.skuUserAgreementValues)
                data["skuUserAgreementValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuUserAgreementSaveRequest {
    id?: string | undefined;
    skuId?: string;
    organizationUserId?: string;
    agreementId?: string;
    dueDate?: Date;
    html?: string | undefined;
    agreementName?: string | undefined;
    skuUserAgreementValues?: SkuUserAgreementValue[] | undefined;
}

export class SkuUserAgreementSaveRequestExtended extends SkuUserAgreementSaveRequest implements ISkuUserAgreementSaveRequestExtended {
    userId?: string;
    organizationId?: string;

    constructor(data?: ISkuUserAgreementSaveRequestExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): SkuUserAgreementSaveRequestExtended {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementSaveRequestExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuUserAgreementSaveRequestExtended extends ISkuUserAgreementSaveRequest {
    userId?: string;
    organizationId?: string;
}

export class CancelSkuUserAgreementRequest implements ICancelSkuUserAgreementRequest {
    skuUserAgreementId?: string;
    changeReason!: string;

    constructor(data?: ICancelSkuUserAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuUserAgreementId = _data["skuUserAgreementId"];
            this.changeReason = _data["changeReason"];
        }
    }

    static fromJS(data: any): CancelSkuUserAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSkuUserAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuUserAgreementId"] = this.skuUserAgreementId;
        data["changeReason"] = this.changeReason;
        return data;
    }
}

export interface ICancelSkuUserAgreementRequest {
    skuUserAgreementId?: string;
    changeReason: string;
}

export class ResponseOfListOfStateAndString implements IResponseOfListOfStateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: State[] | undefined;

    constructor(data?: IResponseOfListOfStateAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(State.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfStateAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfStateAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfStateAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: State[] | undefined;
}

export class ResponseOfListOfState extends ResponseOfListOfStateAndString implements IResponseOfListOfState {

    constructor(data?: IResponseOfListOfState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfState {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfState extends IResponseOfListOfStateAndString {
}

export class ListResponseOfState extends ResponseOfListOfState implements IListResponseOfState {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfState {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfState extends IResponseOfListOfState {
    totalRecords?: number | undefined;
}

export class State implements IState {
    id?: string;
    stateName?: string | undefined;
    name?: string | undefined;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateName = _data["stateName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateName"] = this.stateName;
        data["name"] = this.name;
        return data;
    }
}

export interface IState {
    id?: string;
    stateName?: string | undefined;
    name?: string | undefined;
}

export class ResponseOfListOfWebinarExtendedAndString implements IResponseOfListOfWebinarExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: WebinarExtended[] | undefined;

    constructor(data?: IResponseOfListOfWebinarExtendedAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WebinarExtended.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfWebinarExtendedAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWebinarExtendedAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfWebinarExtendedAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: WebinarExtended[] | undefined;
}

export class ResponseOfListOfWebinarExtended extends ResponseOfListOfWebinarExtendedAndString implements IResponseOfListOfWebinarExtended {

    constructor(data?: IResponseOfListOfWebinarExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfWebinarExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfWebinarExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfWebinarExtended extends IResponseOfListOfWebinarExtendedAndString {
}

export class ListResponseOfWebinarExtended extends ResponseOfListOfWebinarExtended implements IListResponseOfWebinarExtended {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfWebinarExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfWebinarExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfWebinarExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfWebinarExtended extends IResponseOfListOfWebinarExtended {
    totalRecords?: number | undefined;
}

export class Webinar implements IWebinar {
    id!: string;
    title?: string | undefined;
    sku?: string | undefined;
    eventStartDate?: Date | undefined;
    eventEndDate?: Date | undefined;
    organizationId!: string;
    organizationName?: string | undefined;
    skuId?: string;

    constructor(data?: IWebinar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.sku = _data["sku"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): Webinar {
        data = typeof data === 'object' ? data : {};
        let result = new Webinar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["sku"] = this.sku;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface IWebinar {
    id: string;
    title?: string | undefined;
    sku?: string | undefined;
    eventStartDate?: Date | undefined;
    eventEndDate?: Date | undefined;
    organizationId: string;
    organizationName?: string | undefined;
    skuId?: string;
}

export class WebinarExtended extends Webinar implements IWebinarExtended {
    registrationCount?: number;
    attendanceRecordCount?: number;
    eventStartDateTime?: string | undefined;
    eventEndDateTime?: string | undefined;
    attendanceProcessingCompleted?: boolean;
    eventClosed?: boolean;
    timeToEnableProcessAttendance?: number;
    skuDeliveryMethodKey?: string | undefined;
    skuDeliverableId?: string | undefined;

    constructor(data?: IWebinarExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.registrationCount = _data["registrationCount"];
            this.attendanceRecordCount = _data["attendanceRecordCount"];
            this.eventStartDateTime = _data["eventStartDateTime"];
            this.eventEndDateTime = _data["eventEndDateTime"];
            this.attendanceProcessingCompleted = _data["attendanceProcessingCompleted"];
            this.eventClosed = _data["eventClosed"];
            this.timeToEnableProcessAttendance = _data["timeToEnableProcessAttendance"];
            this.skuDeliveryMethodKey = _data["skuDeliveryMethodKey"];
            this.skuDeliverableId = _data["skuDeliverableId"];
        }
    }

    static override fromJS(data: any): WebinarExtended {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationCount"] = this.registrationCount;
        data["attendanceRecordCount"] = this.attendanceRecordCount;
        data["eventStartDateTime"] = this.eventStartDateTime;
        data["eventEndDateTime"] = this.eventEndDateTime;
        data["attendanceProcessingCompleted"] = this.attendanceProcessingCompleted;
        data["eventClosed"] = this.eventClosed;
        data["timeToEnableProcessAttendance"] = this.timeToEnableProcessAttendance;
        data["skuDeliveryMethodKey"] = this.skuDeliveryMethodKey;
        data["skuDeliverableId"] = this.skuDeliverableId;
        super.toJSON(data);
        return data;
    }
}

export interface IWebinarExtended extends IWebinar {
    registrationCount?: number;
    attendanceRecordCount?: number;
    eventStartDateTime?: string | undefined;
    eventEndDateTime?: string | undefined;
    attendanceProcessingCompleted?: boolean;
    eventClosed?: boolean;
    timeToEnableProcessAttendance?: number;
    skuDeliveryMethodKey?: string | undefined;
    skuDeliverableId?: string | undefined;
}

export class ListRequestOfWebinarFilterExtended implements IListRequestOfWebinarFilterExtended {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: WebinarFilterExtended | undefined;

    constructor(data?: IListRequestOfWebinarFilterExtended) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? WebinarFilterExtended.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfWebinarFilterExtended {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfWebinarFilterExtended();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfWebinarFilterExtended {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: WebinarFilterExtended | undefined;
}

export class WebinarFilterExtended extends BaseFilter implements IWebinarFilterExtended {
    startDateString?: string | undefined;
    endDateString?: string | undefined;

    constructor(data?: IWebinarFilterExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDateString = _data["startDateString"];
            this.endDateString = _data["endDateString"];
        }
    }

    static override fromJS(data: any): WebinarFilterExtended {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarFilterExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateString"] = this.startDateString;
        data["endDateString"] = this.endDateString;
        super.toJSON(data);
        return data;
    }
}

export interface IWebinarFilterExtended extends IBaseFilter {
    startDateString?: string | undefined;
    endDateString?: string | undefined;
}

export class BypassSkuAttendanceRequest implements IBypassSkuAttendanceRequest {
    skuId?: string;
    changeReason?: string | undefined;

    constructor(data?: IBypassSkuAttendanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.changeReason = _data["changeReason"];
        }
    }

    static fromJS(data: any): BypassSkuAttendanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BypassSkuAttendanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["changeReason"] = this.changeReason;
        return data;
    }
}

export interface IBypassSkuAttendanceRequest {
    skuId?: string;
    changeReason?: string | undefined;
}

export class ProcessAttendanceRequest implements IProcessAttendanceRequest {
    skuId!: string;
    organizationId!: string;

    constructor(data?: IProcessAttendanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ProcessAttendanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAttendanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IProcessAttendanceRequest {
    skuId: string;
    organizationId: string;
}

export class ResponseOfListOfSkuAttributeByTypeAndString implements IResponseOfListOfSkuAttributeByTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAttributeByType[] | undefined;

    constructor(data?: IResponseOfListOfSkuAttributeByTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuAttributeByType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuAttributeByTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuAttributeByTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuAttributeByTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAttributeByType[] | undefined;
}

export class ResponseOfListOfSkuAttributeByType extends ResponseOfListOfSkuAttributeByTypeAndString implements IResponseOfListOfSkuAttributeByType {

    constructor(data?: IResponseOfListOfSkuAttributeByType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuAttributeByType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuAttributeByType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuAttributeByType extends IResponseOfListOfSkuAttributeByTypeAndString {
}

export class ListResponseOfSkuAttributeByType extends ResponseOfListOfSkuAttributeByType implements IListResponseOfSkuAttributeByType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuAttributeByType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuAttributeByType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuAttributeByType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuAttributeByType extends IResponseOfListOfSkuAttributeByType {
    totalRecords?: number | undefined;
}

export class SkuAttributeByType implements ISkuAttributeByType {
    skuId?: string;
    type?: string | undefined;
    organizationAttributeTypeId?: string;
    attributeDisplayTypeId?: string;
    allowDates?: boolean;
    attributes?: SkuAttributeExtended[] | undefined;

    constructor(data?: ISkuAttributeByType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.type = _data["type"];
            this.organizationAttributeTypeId = _data["organizationAttributeTypeId"];
            this.attributeDisplayTypeId = _data["attributeDisplayTypeId"];
            this.allowDates = _data["allowDates"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(SkuAttributeExtended.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuAttributeByType {
        data = typeof data === 'object' ? data : {};
        let result = new SkuAttributeByType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["type"] = this.type;
        data["organizationAttributeTypeId"] = this.organizationAttributeTypeId;
        data["attributeDisplayTypeId"] = this.attributeDisplayTypeId;
        data["allowDates"] = this.allowDates;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuAttributeByType {
    skuId?: string;
    type?: string | undefined;
    organizationAttributeTypeId?: string;
    attributeDisplayTypeId?: string;
    allowDates?: boolean;
    attributes?: SkuAttributeExtended[] | undefined;
}

export class Attribute implements IAttribute {
    id?: string;
    attributeTypeId?: string;
    attributeTypeName?: string | undefined;
    organizationAttributeType?: OrganizationAttributeType | undefined;
    value?: string | undefined;
    attributeTypeCodeConstant?: string | undefined;
    displayText?: string | undefined;
    sequence?: number;
    attributeMetaValues?: AttributeMetaValue[] | undefined;

    constructor(data?: IAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeTypeId = _data["attributeTypeId"];
            this.attributeTypeName = _data["attributeTypeName"];
            this.organizationAttributeType = _data["organizationAttributeType"] ? OrganizationAttributeType.fromJS(_data["organizationAttributeType"]) : undefined as any;
            this.value = _data["value"];
            this.attributeTypeCodeConstant = _data["attributeTypeCodeConstant"];
            this.displayText = _data["displayText"];
            this.sequence = _data["sequence"];
            if (Array.isArray(_data["attributeMetaValues"])) {
                this.attributeMetaValues = [] as any;
                for (let item of _data["attributeMetaValues"])
                    this.attributeMetaValues!.push(AttributeMetaValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Attribute {
        data = typeof data === 'object' ? data : {};
        let result = new Attribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeTypeId"] = this.attributeTypeId;
        data["attributeTypeName"] = this.attributeTypeName;
        data["organizationAttributeType"] = this.organizationAttributeType ? this.organizationAttributeType.toJSON() : undefined as any;
        data["value"] = this.value;
        data["attributeTypeCodeConstant"] = this.attributeTypeCodeConstant;
        data["displayText"] = this.displayText;
        data["sequence"] = this.sequence;
        if (Array.isArray(this.attributeMetaValues)) {
            data["attributeMetaValues"] = [];
            for (let item of this.attributeMetaValues)
                data["attributeMetaValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAttribute {
    id?: string;
    attributeTypeId?: string;
    attributeTypeName?: string | undefined;
    organizationAttributeType?: OrganizationAttributeType | undefined;
    value?: string | undefined;
    attributeTypeCodeConstant?: string | undefined;
    displayText?: string | undefined;
    sequence?: number;
    attributeMetaValues?: AttributeMetaValue[] | undefined;
}

export class SkuAttributeExtended extends Attribute implements ISkuAttributeExtended {
    id?: string;
    attributeId?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allowDates?: boolean;
    skuAttributeMetaValues?: AttributeMetaValue[] | undefined;

    constructor(data?: ISkuAttributeExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.attributeId = _data["attributeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.allowDates = _data["allowDates"];
            if (Array.isArray(_data["skuAttributeMetaValues"])) {
                this.skuAttributeMetaValues = [] as any;
                for (let item of _data["skuAttributeMetaValues"])
                    this.skuAttributeMetaValues!.push(AttributeMetaValue.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SkuAttributeExtended {
        data = typeof data === 'object' ? data : {};
        let result = new SkuAttributeExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeId"] = this.attributeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["allowDates"] = this.allowDates;
        if (Array.isArray(this.skuAttributeMetaValues)) {
            data["skuAttributeMetaValues"] = [];
            for (let item of this.skuAttributeMetaValues)
                data["skuAttributeMetaValues"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISkuAttributeExtended extends IAttribute {
    id?: string;
    attributeId?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allowDates?: boolean;
    skuAttributeMetaValues?: AttributeMetaValue[] | undefined;
}

export class AttributeMetaValue implements IAttributeMetaValue {
    id?: string | undefined;
    attributeId?: string;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IAttributeMetaValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeId = _data["attributeId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AttributeMetaValue {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeMetaValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeId"] = this.attributeId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IAttributeMetaValue {
    id?: string | undefined;
    attributeId?: string;
    name?: string | undefined;
    value?: string | undefined;
}

export class OrganizationAttributeType implements IOrganizationAttributeType {
    id?: string;
    attributeType?: AttributeType | undefined;
    attributeTypeId?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    displayName?: string | undefined;
    value?: string | undefined;
    isFilter?: boolean;
    filterSequence?: number;
    sequence?: number;

    constructor(data?: IOrganizationAttributeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeType = _data["attributeType"] ? AttributeType.fromJS(_data["attributeType"]) : undefined as any;
            this.attributeTypeId = _data["attributeTypeId"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.displayName = _data["displayName"];
            this.value = _data["value"];
            this.isFilter = _data["isFilter"];
            this.filterSequence = _data["filterSequence"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): OrganizationAttributeType {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAttributeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : undefined as any;
        data["attributeTypeId"] = this.attributeTypeId;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["isFilter"] = this.isFilter;
        data["filterSequence"] = this.filterSequence;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IOrganizationAttributeType {
    id?: string;
    attributeType?: AttributeType | undefined;
    attributeTypeId?: string;
    organizationId?: string;
    organizationName?: string | undefined;
    displayName?: string | undefined;
    value?: string | undefined;
    isFilter?: boolean;
    filterSequence?: number;
    sequence?: number;
}

export class AttributeType implements IAttributeType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    isRequired?: boolean;
    sequence?: number;
    allowMany?: boolean;
    isReusable?: boolean;
    codeConstant?: string | undefined;
    definition?: string | undefined;
    allowInlineInserts?: boolean;
    displayTypeName?: string | undefined;
    displayTypeId?: string;
    isAttributeManagementAvailable?: boolean;
    allowDates?: boolean;
    hasDisplayText?: boolean;
    hasSequence?: boolean;

    constructor(data?: IAttributeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.isRequired = _data["isRequired"];
            this.sequence = _data["sequence"];
            this.allowMany = _data["allowMany"];
            this.isReusable = _data["isReusable"];
            this.codeConstant = _data["codeConstant"];
            this.definition = _data["definition"];
            this.allowInlineInserts = _data["allowInlineInserts"];
            this.displayTypeName = _data["displayTypeName"];
            this.displayTypeId = _data["displayTypeId"];
            this.isAttributeManagementAvailable = _data["isAttributeManagementAvailable"];
            this.allowDates = _data["allowDates"];
            this.hasDisplayText = _data["hasDisplayText"];
            this.hasSequence = _data["hasSequence"];
        }
    }

    static fromJS(data: any): AttributeType {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["isRequired"] = this.isRequired;
        data["sequence"] = this.sequence;
        data["allowMany"] = this.allowMany;
        data["isReusable"] = this.isReusable;
        data["codeConstant"] = this.codeConstant;
        data["definition"] = this.definition;
        data["allowInlineInserts"] = this.allowInlineInserts;
        data["displayTypeName"] = this.displayTypeName;
        data["displayTypeId"] = this.displayTypeId;
        data["isAttributeManagementAvailable"] = this.isAttributeManagementAvailable;
        data["allowDates"] = this.allowDates;
        data["hasDisplayText"] = this.hasDisplayText;
        data["hasSequence"] = this.hasSequence;
        return data;
    }
}

export interface IAttributeType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    isRequired?: boolean;
    sequence?: number;
    allowMany?: boolean;
    isReusable?: boolean;
    codeConstant?: string | undefined;
    definition?: string | undefined;
    allowInlineInserts?: boolean;
    displayTypeName?: string | undefined;
    displayTypeId?: string;
    isAttributeManagementAvailable?: boolean;
    allowDates?: boolean;
    hasDisplayText?: boolean;
    hasSequence?: boolean;
}

export class ListRequestOfAttributeFilter implements IListRequestOfAttributeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AttributeFilter | undefined;

    constructor(data?: IListRequestOfAttributeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AttributeFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAttributeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAttributeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAttributeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AttributeFilter | undefined;
}

export class AttributeFilter extends BaseFilter implements IAttributeFilter {
    organizationAttributeTypeId?: string | undefined;
    codeConstant?: string | undefined;

    constructor(data?: IAttributeFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationAttributeTypeId = _data["organizationAttributeTypeId"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static override fromJS(data: any): AttributeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationAttributeTypeId"] = this.organizationAttributeTypeId;
        data["codeConstant"] = this.codeConstant;
        super.toJSON(data);
        return data;
    }
}

export interface IAttributeFilter extends IBaseFilter {
    organizationAttributeTypeId?: string | undefined;
    codeConstant?: string | undefined;
}

export class ResponseOfListOfSkuAttributeAndString implements IResponseOfListOfSkuAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAttribute[] | undefined;

    constructor(data?: IResponseOfListOfSkuAttributeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuAttributeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuAttributeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAttribute[] | undefined;
}

export class ResponseOfListOfSkuAttribute extends ResponseOfListOfSkuAttributeAndString implements IResponseOfListOfSkuAttribute {

    constructor(data?: IResponseOfListOfSkuAttribute) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuAttribute extends IResponseOfListOfSkuAttributeAndString {
}

export class ListResponseOfSkuAttribute extends ResponseOfListOfSkuAttribute implements IListResponseOfSkuAttribute {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuAttribute) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuAttribute extends IResponseOfListOfSkuAttribute {
    totalRecords?: number | undefined;
}

export class SkuAttribute implements ISkuAttribute {
    id?: string;
    skuId?: string;
    sequence?: number;
    attribute?: Attribute | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allowDates?: boolean;
    skuAttributeMetaValues?: AttributeMetaValue[] | undefined;

    constructor(data?: ISkuAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.sequence = _data["sequence"];
            this.attribute = _data["attribute"] ? Attribute.fromJS(_data["attribute"]) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.allowDates = _data["allowDates"];
            if (Array.isArray(_data["skuAttributeMetaValues"])) {
                this.skuAttributeMetaValues = [] as any;
                for (let item of _data["skuAttributeMetaValues"])
                    this.skuAttributeMetaValues!.push(AttributeMetaValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new SkuAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["sequence"] = this.sequence;
        data["attribute"] = this.attribute ? this.attribute.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["allowDates"] = this.allowDates;
        if (Array.isArray(this.skuAttributeMetaValues)) {
            data["skuAttributeMetaValues"] = [];
            for (let item of this.skuAttributeMetaValues)
                data["skuAttributeMetaValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuAttribute {
    id?: string;
    skuId?: string;
    sequence?: number;
    attribute?: Attribute | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allowDates?: boolean;
    skuAttributeMetaValues?: AttributeMetaValue[] | undefined;
}

export class SkuAttributeRequest implements ISkuAttributeRequest {
    id?: string | undefined;
    attributeId?: string | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    organizationAttributeTypeId?: string;
    sequence?: number;
    attributeMetaValues?: AttributeMetaValue[] | undefined;
    skuAttributeMetaValues?: AttributeMetaValue[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ISkuAttributeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeId = _data["attributeId"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.organizationAttributeTypeId = _data["organizationAttributeTypeId"];
            this.sequence = _data["sequence"];
            if (Array.isArray(_data["attributeMetaValues"])) {
                this.attributeMetaValues = [] as any;
                for (let item of _data["attributeMetaValues"])
                    this.attributeMetaValues!.push(AttributeMetaValue.fromJS(item));
            }
            if (Array.isArray(_data["skuAttributeMetaValues"])) {
                this.skuAttributeMetaValues = [] as any;
                for (let item of _data["skuAttributeMetaValues"])
                    this.skuAttributeMetaValues!.push(AttributeMetaValue.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SkuAttributeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuAttributeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeId"] = this.attributeId;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["organizationAttributeTypeId"] = this.organizationAttributeTypeId;
        data["sequence"] = this.sequence;
        if (Array.isArray(this.attributeMetaValues)) {
            data["attributeMetaValues"] = [];
            for (let item of this.attributeMetaValues)
                data["attributeMetaValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.skuAttributeMetaValues)) {
            data["skuAttributeMetaValues"] = [];
            for (let item of this.skuAttributeMetaValues)
                data["skuAttributeMetaValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISkuAttributeRequest {
    id?: string | undefined;
    attributeId?: string | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    organizationAttributeTypeId?: string;
    sequence?: number;
    attributeMetaValues?: AttributeMetaValue[] | undefined;
    skuAttributeMetaValues?: AttributeMetaValue[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class SkuAttributeSequenceRequest implements ISkuAttributeSequenceRequest {
    attributeTypeId!: string;
    skuAttributeId!: string;
    sequence?: number;

    constructor(data?: ISkuAttributeSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeTypeId = _data["attributeTypeId"];
            this.skuAttributeId = _data["skuAttributeId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): SkuAttributeSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuAttributeSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeTypeId"] = this.attributeTypeId;
        data["skuAttributeId"] = this.skuAttributeId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface ISkuAttributeSequenceRequest {
    attributeTypeId: string;
    skuAttributeId: string;
    sequence?: number;
}

export class ResponseOfSkuAvailabilityAndString implements IResponseOfSkuAvailabilityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAvailability | undefined;

    constructor(data?: IResponseOfSkuAvailabilityAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SkuAvailability.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSkuAvailabilityAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuAvailabilityAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSkuAvailabilityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAvailability | undefined;
}

export class ResponseOfSkuAvailability extends ResponseOfSkuAvailabilityAndString implements IResponseOfSkuAvailability {

    constructor(data?: IResponseOfSkuAvailability) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSkuAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuAvailability();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSkuAvailability extends IResponseOfSkuAvailabilityAndString {
}

export class SkuAvailability implements ISkuAvailability {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;

    constructor(data?: ISkuAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static fromJS(data: any): SkuAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new SkuAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["codeConstant"] = this.codeConstant;
        return data;
    }
}

export interface ISkuAvailability {
    id?: string;
    name?: string | undefined;
    codeConstant?: string | undefined;
}

export class ResponseOfListOfSkuAvailabilityAndString implements IResponseOfListOfSkuAvailabilityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAvailability[] | undefined;

    constructor(data?: IResponseOfListOfSkuAvailabilityAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuAvailability.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuAvailabilityAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuAvailabilityAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuAvailabilityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuAvailability[] | undefined;
}

export class ResponseOfListOfSkuAvailability extends ResponseOfListOfSkuAvailabilityAndString implements IResponseOfListOfSkuAvailability {

    constructor(data?: IResponseOfListOfSkuAvailability) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuAvailability();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuAvailability extends IResponseOfListOfSkuAvailabilityAndString {
}

export class ListResponseOfSkuAvailability extends ResponseOfListOfSkuAvailability implements IListResponseOfSkuAvailability {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuAvailability) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuAvailability();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuAvailability extends IResponseOfListOfSkuAvailability {
    totalRecords?: number | undefined;
}

export class MembershipGatedAccessEnabledRequest implements IMembershipGatedAccessEnabledRequest {
    organizationId?: string;

    constructor(data?: IMembershipGatedAccessEnabledRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): MembershipGatedAccessEnabledRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipGatedAccessEnabledRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IMembershipGatedAccessEnabledRequest {
    organizationId?: string;
}

export class SkuContentRuleRequest implements ISkuContentRuleRequest {
    id?: string | undefined;
    skuId?: string;
    name!: string;
    sequence?: number | undefined;
    excludeFilter!: boolean;
    skuContentRuleTypeId!: string;
    skuAccessTypeId?: string | undefined;

    constructor(data?: ISkuContentRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
            this.excludeFilter = _data["excludeFilter"];
            this.skuContentRuleTypeId = _data["skuContentRuleTypeId"];
            this.skuAccessTypeId = _data["skuAccessTypeId"];
        }
    }

    static fromJS(data: any): SkuContentRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["excludeFilter"] = this.excludeFilter;
        data["skuContentRuleTypeId"] = this.skuContentRuleTypeId;
        data["skuAccessTypeId"] = this.skuAccessTypeId;
        return data;
    }
}

export interface ISkuContentRuleRequest {
    id?: string | undefined;
    skuId?: string;
    name: string;
    sequence?: number | undefined;
    excludeFilter: boolean;
    skuContentRuleTypeId: string;
    skuAccessTypeId?: string | undefined;
}

export class SkuContentRuleRequestExtended extends SkuContentRuleRequest implements ISkuContentRuleRequestExtended {
    organizationId?: string;

    constructor(data?: ISkuContentRuleRequestExtended) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): SkuContentRuleRequestExtended {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleRequestExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuContentRuleRequestExtended extends ISkuContentRuleRequest {
    organizationId?: string;
}

export class ResponseOfListOfSkuContentRuleTypeAndString implements IResponseOfListOfSkuContentRuleTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleType[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentRuleTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentRuleType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentRuleTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleType[] | undefined;
}

export class ResponseOfListOfSkuContentRuleType extends ResponseOfListOfSkuContentRuleTypeAndString implements IResponseOfListOfSkuContentRuleType {

    constructor(data?: IResponseOfListOfSkuContentRuleType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentRuleType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleType extends IResponseOfListOfSkuContentRuleTypeAndString {
}

export class ListResponseOfSkuContentRuleType extends ResponseOfListOfSkuContentRuleType implements IListResponseOfSkuContentRuleType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentRuleType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentRuleType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentRuleType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentRuleType extends IResponseOfListOfSkuContentRuleType {
    totalRecords?: number | undefined;
}

export class SkuContentRuleType implements ISkuContentRuleType {
    id!: string;
    name!: string;

    constructor(data?: ISkuContentRuleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SkuContentRuleType {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISkuContentRuleType {
    id: string;
    name: string;
}

export class ResponseOfListOfSkuContentRuleAndString implements IResponseOfListOfSkuContentRuleAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRule[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentRuleAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentRuleAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRule[] | undefined;
}

export class ResponseOfListOfSkuContentRule extends ResponseOfListOfSkuContentRuleAndString implements IResponseOfListOfSkuContentRule {

    constructor(data?: IResponseOfListOfSkuContentRule) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentRule {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRule();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentRule extends IResponseOfListOfSkuContentRuleAndString {
}

export class ListResponseOfSkuContentRule extends ResponseOfListOfSkuContentRule implements IListResponseOfSkuContentRule {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentRule) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentRule {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentRule();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentRule extends IResponseOfListOfSkuContentRule {
    totalRecords?: number | undefined;
}

export class SkuContentRule implements ISkuContentRule {
    id!: string;
    skuId!: string;
    name!: string;
    sequence!: number;
    excludeFilter!: boolean;
    skuAccessTypeId?: string | undefined;
    accessTypeName?: string | undefined;
    ruleType?: SkuContentRuleType | undefined;

    constructor(data?: ISkuContentRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
            this.excludeFilter = _data["excludeFilter"];
            this.skuAccessTypeId = _data["skuAccessTypeId"];
            this.accessTypeName = _data["accessTypeName"];
            this.ruleType = _data["ruleType"] ? SkuContentRuleType.fromJS(_data["ruleType"]) : undefined as any;
        }
    }

    static fromJS(data: any): SkuContentRule {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["excludeFilter"] = this.excludeFilter;
        data["skuAccessTypeId"] = this.skuAccessTypeId;
        data["accessTypeName"] = this.accessTypeName;
        data["ruleType"] = this.ruleType ? this.ruleType.toJSON() : undefined as any;
        return data;
    }
}

export interface ISkuContentRule {
    id: string;
    skuId: string;
    name: string;
    sequence: number;
    excludeFilter: boolean;
    skuAccessTypeId?: string | undefined;
    accessTypeName?: string | undefined;
    ruleType?: SkuContentRuleType | undefined;
}

export class UpdateRuleSequenceRequest implements IUpdateRuleSequenceRequest {
    contentRuleIds!: string[];

    constructor(data?: IUpdateRuleSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.contentRuleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contentRuleIds"])) {
                this.contentRuleIds = [] as any;
                for (let item of _data["contentRuleIds"])
                    this.contentRuleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRuleSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRuleSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contentRuleIds)) {
            data["contentRuleIds"] = [];
            for (let item of this.contentRuleIds)
                data["contentRuleIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateRuleSequenceRequest {
    contentRuleIds: string[];
}

export class ResponseOfListOfSkuContentRuleProductAndString implements IResponseOfListOfSkuContentRuleProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleProduct[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentRuleProductAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentRuleProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentRuleProductAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleProductAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleProduct[] | undefined;
}

export class ResponseOfListOfSkuContentRuleProduct extends ResponseOfListOfSkuContentRuleProductAndString implements IResponseOfListOfSkuContentRuleProduct {

    constructor(data?: IResponseOfListOfSkuContentRuleProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentRuleProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleProduct extends IResponseOfListOfSkuContentRuleProductAndString {
}

export class ListResponseOfSkuContentRuleProduct extends ResponseOfListOfSkuContentRuleProduct implements IListResponseOfSkuContentRuleProduct {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentRuleProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentRuleProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentRuleProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentRuleProduct extends IResponseOfListOfSkuContentRuleProduct {
    totalRecords?: number | undefined;
}

export class SkuContentRuleProduct implements ISkuContentRuleProduct {
    id?: string;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    corporateEntityId?: string | undefined;
    skuStatusId?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    productTypeName?: string | undefined;
    productName?: string | undefined;
    productYearName?: string | undefined;
    productVersionName?: string | undefined;
    skuFormatName?: string | undefined;
    skuAvailabilityName?: string | undefined;
    corporateEntityName?: string | undefined;
    skuStatusName?: string | undefined;

    constructor(data?: ISkuContentRuleProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productTypeId = _data["productTypeId"];
            this.productId = _data["productId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
            this.skuFormatId = _data["skuFormatId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.corporateEntityId = _data["corporateEntityId"];
            this.skuStatusId = _data["skuStatusId"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            this.productTypeName = _data["productTypeName"];
            this.productName = _data["productName"];
            this.productYearName = _data["productYearName"];
            this.productVersionName = _data["productVersionName"];
            this.skuFormatName = _data["skuFormatName"];
            this.skuAvailabilityName = _data["skuAvailabilityName"];
            this.corporateEntityName = _data["corporateEntityName"];
            this.skuStatusName = _data["skuStatusName"];
        }
    }

    static fromJS(data: any): SkuContentRuleProduct {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productTypeId"] = this.productTypeId;
        data["productId"] = this.productId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        data["skuFormatId"] = this.skuFormatId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["corporateEntityId"] = this.corporateEntityId;
        data["skuStatusId"] = this.skuStatusId;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["productTypeName"] = this.productTypeName;
        data["productName"] = this.productName;
        data["productYearName"] = this.productYearName;
        data["productVersionName"] = this.productVersionName;
        data["skuFormatName"] = this.skuFormatName;
        data["skuAvailabilityName"] = this.skuAvailabilityName;
        data["corporateEntityName"] = this.corporateEntityName;
        data["skuStatusName"] = this.skuStatusName;
        return data;
    }
}

export interface ISkuContentRuleProduct {
    id?: string;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    corporateEntityId?: string | undefined;
    skuStatusId?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    productTypeName?: string | undefined;
    productName?: string | undefined;
    productYearName?: string | undefined;
    productVersionName?: string | undefined;
    skuFormatName?: string | undefined;
    skuAvailabilityName?: string | undefined;
    corporateEntityName?: string | undefined;
    skuStatusName?: string | undefined;
}

export class ResponseOfListOfSkuContentRuleOrganizationAndString implements IResponseOfListOfSkuContentRuleOrganizationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleOrganization[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentRuleOrganizationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentRuleOrganization.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentRuleOrganizationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleOrganizationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleOrganizationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleOrganization[] | undefined;
}

export class ResponseOfListOfSkuContentRuleOrganization extends ResponseOfListOfSkuContentRuleOrganizationAndString implements IResponseOfListOfSkuContentRuleOrganization {

    constructor(data?: IResponseOfListOfSkuContentRuleOrganization) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentRuleOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleOrganization();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleOrganization extends IResponseOfListOfSkuContentRuleOrganizationAndString {
}

export class ListResponseOfSkuContentRuleOrganization extends ResponseOfListOfSkuContentRuleOrganization implements IListResponseOfSkuContentRuleOrganization {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentRuleOrganization) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentRuleOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentRuleOrganization();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentRuleOrganization extends IResponseOfListOfSkuContentRuleOrganization {
    totalRecords?: number | undefined;
}

export class SkuContentRuleOrganization implements ISkuContentRuleOrganization {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;

    constructor(data?: ISkuContentRuleOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): SkuContentRuleOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface ISkuContentRuleOrganization {
    id?: string;
    organizationId?: string;
    organizationName?: string | undefined;
}

export class SkuContentRuleProductRequest implements ISkuContentRuleProductRequest {
    id?: string | undefined;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    corporateEntityId?: string | undefined;
    skuStatusId?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;

    constructor(data?: ISkuContentRuleProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productTypeId = _data["productTypeId"];
            this.productId = _data["productId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
            this.skuFormatId = _data["skuFormatId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.corporateEntityId = _data["corporateEntityId"];
            this.skuStatusId = _data["skuStatusId"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
        }
    }

    static fromJS(data: any): SkuContentRuleProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productTypeId"] = this.productTypeId;
        data["productId"] = this.productId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        data["skuFormatId"] = this.skuFormatId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["corporateEntityId"] = this.corporateEntityId;
        data["skuStatusId"] = this.skuStatusId;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        return data;
    }
}

export interface ISkuContentRuleProductRequest {
    id?: string | undefined;
    productTypeId?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    corporateEntityId?: string | undefined;
    skuStatusId?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
}

export class SkuContentRuleOrganizationRequest implements ISkuContentRuleOrganizationRequest {
    id?: string | undefined;
    organizationId?: string;

    constructor(data?: ISkuContentRuleOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): SkuContentRuleOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ISkuContentRuleOrganizationRequest {
    id?: string | undefined;
    organizationId?: string;
}

export class ResponseOfListOfSkuContentRuleSkuAndString implements IResponseOfListOfSkuContentRuleSkuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleSku[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentRuleSkuAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentRuleSku.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentRuleSkuAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleSkuAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleSkuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleSku[] | undefined;
}

export class ResponseOfListOfSkuContentRuleSku extends ResponseOfListOfSkuContentRuleSkuAndString implements IResponseOfListOfSkuContentRuleSku {

    constructor(data?: IResponseOfListOfSkuContentRuleSku) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentRuleSku {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleSku();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleSku extends IResponseOfListOfSkuContentRuleSkuAndString {
}

export class ListResponseOfSkuContentRuleSku extends ResponseOfListOfSkuContentRuleSku implements IListResponseOfSkuContentRuleSku {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentRuleSku) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentRuleSku {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentRuleSku();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentRuleSku extends IResponseOfListOfSkuContentRuleSku {
    totalRecords?: number | undefined;
}

export class SkuContentRuleSku implements ISkuContentRuleSku {
    id?: string;
    skuId?: string;
    sku?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ISkuContentRuleSku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.sku = _data["sku"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SkuContentRuleSku {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleSku();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["sku"] = this.sku;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ISkuContentRuleSku {
    id?: string;
    skuId?: string;
    sku?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
}

export class SkuContentRuleSkuRequest implements ISkuContentRuleSkuRequest {
    id?: string | undefined;
    skuId?: string;

    constructor(data?: ISkuContentRuleSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): SkuContentRuleSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface ISkuContentRuleSkuRequest {
    id?: string | undefined;
    skuId?: string;
}

export class ResponseOfListOfSkuContentRuleProfessionAndString implements IResponseOfListOfSkuContentRuleProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleProfession[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentRuleProfessionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentRuleProfession.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentRuleProfessionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleProfessionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleProfession[] | undefined;
}

export class ResponseOfListOfSkuContentRuleProfession extends ResponseOfListOfSkuContentRuleProfessionAndString implements IResponseOfListOfSkuContentRuleProfession {

    constructor(data?: IResponseOfListOfSkuContentRuleProfession) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentRuleProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleProfession();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleProfession extends IResponseOfListOfSkuContentRuleProfessionAndString {
}

export class ListResponseOfSkuContentRuleProfession extends ResponseOfListOfSkuContentRuleProfession implements IListResponseOfSkuContentRuleProfession {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentRuleProfession) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentRuleProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentRuleProfession();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentRuleProfession extends IResponseOfListOfSkuContentRuleProfession {
    totalRecords?: number | undefined;
}

export class SkuContentRuleProfession implements ISkuContentRuleProfession {
    id?: string;
    professionId?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISkuContentRuleProfession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionId = _data["professionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SkuContentRuleProfession {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleProfession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionId"] = this.professionId;
        data["name"] = this.name;
        return data;
    }
}

export interface ISkuContentRuleProfession {
    id?: string;
    professionId?: string | undefined;
    name?: string | undefined;
}

export class ResponseOfListOfSkuContentRuleTagAndString implements IResponseOfListOfSkuContentRuleTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleTag[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentRuleTagAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentRuleTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentRuleTagAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleTagAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentRuleTag[] | undefined;
}

export class ResponseOfListOfSkuContentRuleTag extends ResponseOfListOfSkuContentRuleTagAndString implements IResponseOfListOfSkuContentRuleTag {

    constructor(data?: IResponseOfListOfSkuContentRuleTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentRuleTag {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentRuleTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentRuleTag extends IResponseOfListOfSkuContentRuleTagAndString {
}

export class ListResponseOfSkuContentRuleTag extends ResponseOfListOfSkuContentRuleTag implements IListResponseOfSkuContentRuleTag {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentRuleTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentRuleTag {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentRuleTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentRuleTag extends IResponseOfListOfSkuContentRuleTag {
    totalRecords?: number | undefined;
}

export class SkuContentRuleTag implements ISkuContentRuleTag {
    id?: string;
    tagId?: string;
    name?: string | undefined;

    constructor(data?: ISkuContentRuleTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagId = _data["tagId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SkuContentRuleTag {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentRuleTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagId"] = this.tagId;
        data["name"] = this.name;
        return data;
    }
}

export interface ISkuContentRuleTag {
    id?: string;
    tagId?: string;
    name?: string | undefined;
}

export class ResponseOfListOfTagAndString implements IResponseOfListOfTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Tag[] | undefined;

    constructor(data?: IResponseOfListOfTagAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Tag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfTagAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTagAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Tag[] | undefined;
}

export class ResponseOfListOfTag extends ResponseOfListOfTagAndString implements IResponseOfListOfTag {

    constructor(data?: IResponseOfListOfTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfTag {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfTag extends IResponseOfListOfTagAndString {
}

export class ListResponseOfTag extends ResponseOfListOfTag implements IListResponseOfTag {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfTag {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfTag extends IResponseOfListOfTag {
    totalRecords?: number | undefined;
}

export class Tag implements ITag {
    id?: string;
    name?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITag {
    id?: string;
    name?: string | undefined;
}

export class ResponseOfListOfSkuContentItemAndString implements IResponseOfListOfSkuContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentItem[] | undefined;

    constructor(data?: IResponseOfListOfSkuContentItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuContentItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuContentItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuContentItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuContentItem[] | undefined;
}

export class ResponseOfListOfSkuContentItem extends ResponseOfListOfSkuContentItemAndString implements IResponseOfListOfSkuContentItem {

    constructor(data?: IResponseOfListOfSkuContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuContentItem extends IResponseOfListOfSkuContentItemAndString {
}

export class ListResponseOfSkuContentItem extends ResponseOfListOfSkuContentItem implements IListResponseOfSkuContentItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuContentItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuContentItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuContentItem extends IResponseOfListOfSkuContentItem {
    totalRecords?: number | undefined;
}

export class SkuContentItem implements ISkuContentItem {
    id!: string;
    parentSkuId!: string;
    skuId!: string;
    productId?: string;
    ownerOrganizationId?: string;
    sku!: string;
    productName?: string | undefined;
    ownerOrganizationName?: string | undefined;
    price?: number | undefined;
    accessTypeName?: string | undefined;

    constructor(data?: ISkuContentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentSkuId = _data["parentSkuId"];
            this.skuId = _data["skuId"];
            this.productId = _data["productId"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.sku = _data["sku"];
            this.productName = _data["productName"];
            this.ownerOrganizationName = _data["ownerOrganizationName"];
            this.price = _data["price"];
            this.accessTypeName = _data["accessTypeName"];
        }
    }

    static fromJS(data: any): SkuContentItem {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentSkuId"] = this.parentSkuId;
        data["skuId"] = this.skuId;
        data["productId"] = this.productId;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["sku"] = this.sku;
        data["productName"] = this.productName;
        data["ownerOrganizationName"] = this.ownerOrganizationName;
        data["price"] = this.price;
        data["accessTypeName"] = this.accessTypeName;
        return data;
    }
}

export interface ISkuContentItem {
    id: string;
    parentSkuId: string;
    skuId: string;
    productId?: string;
    ownerOrganizationId?: string;
    sku: string;
    productName?: string | undefined;
    ownerOrganizationName?: string | undefined;
    price?: number | undefined;
    accessTypeName?: string | undefined;
}

export class ListRequestOfSkuContentsFilter implements IListRequestOfSkuContentsFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuContentsFilter | undefined;

    constructor(data?: IListRequestOfSkuContentsFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuContentsFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuContentsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuContentsFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuContentsFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuContentsFilter | undefined;
}

export class SkuContentsFilter extends BaseFilter implements ISkuContentsFilter {
    ownerOrganizationId?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;

    constructor(data?: ISkuContentsFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
        }
    }

    static override fromJS(data: any): SkuContentsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuContentsFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuContentsFilter extends IBaseFilter {
    ownerOrganizationId?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
}

export class ResponseOfListOfParentSkuAndString implements IResponseOfListOfParentSkuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ParentSku[] | undefined;

    constructor(data?: IResponseOfListOfParentSkuAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ParentSku.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfParentSkuAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfParentSkuAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfParentSkuAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ParentSku[] | undefined;
}

export class ResponseOfListOfParentSku extends ResponseOfListOfParentSkuAndString implements IResponseOfListOfParentSku {

    constructor(data?: IResponseOfListOfParentSku) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfParentSku {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfParentSku();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfParentSku extends IResponseOfListOfParentSkuAndString {
}

export class ListResponseOfParentSku extends ResponseOfListOfParentSku implements IListResponseOfParentSku {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfParentSku) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfParentSku {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfParentSku();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfParentSku extends IResponseOfListOfParentSku {
    totalRecords?: number | undefined;
}

export class ParentSku implements IParentSku {
    skuId?: string;
    sku?: string | undefined;
    title?: string | undefined;

    constructor(data?: IParentSku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.sku = _data["sku"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ParentSku {
        data = typeof data === 'object' ? data : {};
        let result = new ParentSku();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["sku"] = this.sku;
        data["title"] = this.title;
        return data;
    }
}

export interface IParentSku {
    skuId?: string;
    sku?: string | undefined;
    title?: string | undefined;
}

export class ResponseOfListOfSkuListItemAndString implements IResponseOfListOfSkuListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuListItem[] | undefined;

    constructor(data?: IResponseOfListOfSkuListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuListItem[] | undefined;
}

export class ResponseOfListOfSkuListItem extends ResponseOfListOfSkuListItemAndString implements IResponseOfListOfSkuListItem {

    constructor(data?: IResponseOfListOfSkuListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuListItem extends IResponseOfListOfSkuListItemAndString {
}

export class ListResponseOfSkuListItem extends ResponseOfListOfSkuListItem implements IListResponseOfSkuListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuListItem extends IResponseOfListOfSkuListItem {
    totalRecords?: number | undefined;
}

export class SkuListItem implements ISkuListItem {
    id!: string;
    title?: string | undefined;
    description?: string | undefined;
    sku?: string | undefined;
    skuFormatId?: string | undefined;
    skuStatusId?: string;
    skuFormat?: SkuFormat | undefined;
    productAvailabilityId?: string | undefined;
    skuAvailabilityName?: string | undefined;
    externalSourceId?: string | undefined;
    skuUserAgreements?: SkuUserAgreementInfo[] | undefined;
    isSkuUserAgreementPending?: boolean;
    isSkuUserAgreementAccepted?: boolean;
    organizationUserId?: string | undefined;

    constructor(data?: ISkuListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.skuFormatId = _data["skuFormatId"];
            this.skuStatusId = _data["skuStatusId"];
            this.skuFormat = _data["skuFormat"] ? SkuFormat.fromJS(_data["skuFormat"]) : undefined as any;
            this.productAvailabilityId = _data["productAvailabilityId"];
            this.skuAvailabilityName = _data["skuAvailabilityName"];
            this.externalSourceId = _data["externalSourceId"];
            if (Array.isArray(_data["skuUserAgreements"])) {
                this.skuUserAgreements = [] as any;
                for (let item of _data["skuUserAgreements"])
                    this.skuUserAgreements!.push(SkuUserAgreementInfo.fromJS(item));
            }
            this.isSkuUserAgreementPending = _data["isSkuUserAgreementPending"];
            this.isSkuUserAgreementAccepted = _data["isSkuUserAgreementAccepted"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static fromJS(data: any): SkuListItem {
        data = typeof data === 'object' ? data : {};
        let result = new SkuListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["skuFormatId"] = this.skuFormatId;
        data["skuStatusId"] = this.skuStatusId;
        data["skuFormat"] = this.skuFormat ? this.skuFormat.toJSON() : undefined as any;
        data["productAvailabilityId"] = this.productAvailabilityId;
        data["skuAvailabilityName"] = this.skuAvailabilityName;
        data["externalSourceId"] = this.externalSourceId;
        if (Array.isArray(this.skuUserAgreements)) {
            data["skuUserAgreements"] = [];
            for (let item of this.skuUserAgreements)
                data["skuUserAgreements"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSkuUserAgreementPending"] = this.isSkuUserAgreementPending;
        data["isSkuUserAgreementAccepted"] = this.isSkuUserAgreementAccepted;
        data["organizationUserId"] = this.organizationUserId;
        return data;
    }
}

export interface ISkuListItem {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    sku?: string | undefined;
    skuFormatId?: string | undefined;
    skuStatusId?: string;
    skuFormat?: SkuFormat | undefined;
    productAvailabilityId?: string | undefined;
    skuAvailabilityName?: string | undefined;
    externalSourceId?: string | undefined;
    skuUserAgreements?: SkuUserAgreementInfo[] | undefined;
    isSkuUserAgreementPending?: boolean;
    isSkuUserAgreementAccepted?: boolean;
    organizationUserId?: string | undefined;
}

export class BaseModel implements IBaseModel {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface IBaseModel {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
}

export class SkuFormat extends BaseModel implements ISkuFormat {
    acronym?: string | undefined;

    constructor(data?: ISkuFormat) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.acronym = _data["acronym"];
        }
    }

    static override fromJS(data: any): SkuFormat {
        data = typeof data === 'object' ? data : {};
        let result = new SkuFormat();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acronym"] = this.acronym;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuFormat extends IBaseModel {
    acronym?: string | undefined;
}

export class ListRequestOfSkuFilter implements IListRequestOfSkuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuFilter | undefined;

    constructor(data?: IListRequestOfSkuFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuFilter | undefined;
}

export class GetSkusRequest extends ListRequestOfSkuFilter implements IGetSkusRequest {
    organizationId?: string;

    constructor(data?: IGetSkusRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): GetSkusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkusRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSkusRequest extends IListRequestOfSkuFilter {
    organizationId?: string;
}

export class SkuFilter extends BaseFilter implements ISkuFilter {
    productTypeId?: string | undefined;
    skuFormatIds?: string[] | undefined;
    skuAvailabilityIds?: string[] | undefined;
    productIds?: string[] | undefined;
    productYearId?: string | undefined;
    skuStatusIds?: string[] | undefined;
    productVersionIds?: string[] | undefined;
    qualificationIds?: string[] | undefined;
    approvalStatus?: SkuApprovalStatus | undefined;
    resourceId?: string | undefined;
    professionIds?: string[] | undefined;
    tagIds?: string[] | undefined;
    title?: string | undefined;
    sku?: string | undefined;
    skuCodes?: string[] | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    minCredits?: number | undefined;
    maxCredits?: number | undefined;
    eventStartDate?: Date | undefined;
    eventEndDate?: Date | undefined;
    releaseDateFrom?: Date | undefined;
    releaseDateTo?: Date | undefined;
    offlineDateFrom?: Date | undefined;
    offlineDateTo?: Date | undefined;
    creditSubmissionExpirationDateFrom?: Date | undefined;
    creditSubmissionExpirationDateTo?: Date | undefined;
    expirationDateFrom?: Date | undefined;
    expirationDateTo?: Date | undefined;
    hasSkuContents?: boolean;

    constructor(data?: ISkuFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productTypeId = _data["productTypeId"];
            if (Array.isArray(_data["skuFormatIds"])) {
                this.skuFormatIds = [] as any;
                for (let item of _data["skuFormatIds"])
                    this.skuFormatIds!.push(item);
            }
            if (Array.isArray(_data["skuAvailabilityIds"])) {
                this.skuAvailabilityIds = [] as any;
                for (let item of _data["skuAvailabilityIds"])
                    this.skuAvailabilityIds!.push(item);
            }
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
            this.productYearId = _data["productYearId"];
            if (Array.isArray(_data["skuStatusIds"])) {
                this.skuStatusIds = [] as any;
                for (let item of _data["skuStatusIds"])
                    this.skuStatusIds!.push(item);
            }
            if (Array.isArray(_data["productVersionIds"])) {
                this.productVersionIds = [] as any;
                for (let item of _data["productVersionIds"])
                    this.productVersionIds!.push(item);
            }
            if (Array.isArray(_data["qualificationIds"])) {
                this.qualificationIds = [] as any;
                for (let item of _data["qualificationIds"])
                    this.qualificationIds!.push(item);
            }
            this.approvalStatus = _data["approvalStatus"];
            this.resourceId = _data["resourceId"];
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.title = _data["title"];
            this.sku = _data["sku"];
            if (Array.isArray(_data["skuCodes"])) {
                this.skuCodes = [] as any;
                for (let item of _data["skuCodes"])
                    this.skuCodes!.push(item);
            }
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            this.minCredits = _data["minCredits"];
            this.maxCredits = _data["maxCredits"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            this.releaseDateFrom = _data["releaseDateFrom"] ? new Date(_data["releaseDateFrom"].toString()) : undefined as any;
            this.releaseDateTo = _data["releaseDateTo"] ? new Date(_data["releaseDateTo"].toString()) : undefined as any;
            this.offlineDateFrom = _data["offlineDateFrom"] ? new Date(_data["offlineDateFrom"].toString()) : undefined as any;
            this.offlineDateTo = _data["offlineDateTo"] ? new Date(_data["offlineDateTo"].toString()) : undefined as any;
            this.creditSubmissionExpirationDateFrom = _data["creditSubmissionExpirationDateFrom"] ? new Date(_data["creditSubmissionExpirationDateFrom"].toString()) : undefined as any;
            this.creditSubmissionExpirationDateTo = _data["creditSubmissionExpirationDateTo"] ? new Date(_data["creditSubmissionExpirationDateTo"].toString()) : undefined as any;
            this.expirationDateFrom = _data["expirationDateFrom"] ? new Date(_data["expirationDateFrom"].toString()) : undefined as any;
            this.expirationDateTo = _data["expirationDateTo"] ? new Date(_data["expirationDateTo"].toString()) : undefined as any;
            this.hasSkuContents = _data["hasSkuContents"];
        }
    }

    static override fromJS(data: any): SkuFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productTypeId"] = this.productTypeId;
        if (Array.isArray(this.skuFormatIds)) {
            data["skuFormatIds"] = [];
            for (let item of this.skuFormatIds)
                data["skuFormatIds"].push(item);
        }
        if (Array.isArray(this.skuAvailabilityIds)) {
            data["skuAvailabilityIds"] = [];
            for (let item of this.skuAvailabilityIds)
                data["skuAvailabilityIds"].push(item);
        }
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        data["productYearId"] = this.productYearId;
        if (Array.isArray(this.skuStatusIds)) {
            data["skuStatusIds"] = [];
            for (let item of this.skuStatusIds)
                data["skuStatusIds"].push(item);
        }
        if (Array.isArray(this.productVersionIds)) {
            data["productVersionIds"] = [];
            for (let item of this.productVersionIds)
                data["productVersionIds"].push(item);
        }
        if (Array.isArray(this.qualificationIds)) {
            data["qualificationIds"] = [];
            for (let item of this.qualificationIds)
                data["qualificationIds"].push(item);
        }
        data["approvalStatus"] = this.approvalStatus;
        data["resourceId"] = this.resourceId;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["title"] = this.title;
        data["sku"] = this.sku;
        if (Array.isArray(this.skuCodes)) {
            data["skuCodes"] = [];
            for (let item of this.skuCodes)
                data["skuCodes"].push(item);
        }
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["minCredits"] = this.minCredits;
        data["maxCredits"] = this.maxCredits;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        data["releaseDateFrom"] = this.releaseDateFrom ? this.releaseDateFrom.toISOString() : undefined as any;
        data["releaseDateTo"] = this.releaseDateTo ? this.releaseDateTo.toISOString() : undefined as any;
        data["offlineDateFrom"] = this.offlineDateFrom ? this.offlineDateFrom.toISOString() : undefined as any;
        data["offlineDateTo"] = this.offlineDateTo ? this.offlineDateTo.toISOString() : undefined as any;
        data["creditSubmissionExpirationDateFrom"] = this.creditSubmissionExpirationDateFrom ? this.creditSubmissionExpirationDateFrom.toISOString() : undefined as any;
        data["creditSubmissionExpirationDateTo"] = this.creditSubmissionExpirationDateTo ? this.creditSubmissionExpirationDateTo.toISOString() : undefined as any;
        data["expirationDateFrom"] = this.expirationDateFrom ? this.expirationDateFrom.toISOString() : undefined as any;
        data["expirationDateTo"] = this.expirationDateTo ? this.expirationDateTo.toISOString() : undefined as any;
        data["hasSkuContents"] = this.hasSkuContents;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuFilter extends IBaseFilter {
    productTypeId?: string | undefined;
    skuFormatIds?: string[] | undefined;
    skuAvailabilityIds?: string[] | undefined;
    productIds?: string[] | undefined;
    productYearId?: string | undefined;
    skuStatusIds?: string[] | undefined;
    productVersionIds?: string[] | undefined;
    qualificationIds?: string[] | undefined;
    approvalStatus?: SkuApprovalStatus | undefined;
    resourceId?: string | undefined;
    professionIds?: string[] | undefined;
    tagIds?: string[] | undefined;
    title?: string | undefined;
    sku?: string | undefined;
    skuCodes?: string[] | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    minCredits?: number | undefined;
    maxCredits?: number | undefined;
    eventStartDate?: Date | undefined;
    eventEndDate?: Date | undefined;
    releaseDateFrom?: Date | undefined;
    releaseDateTo?: Date | undefined;
    offlineDateFrom?: Date | undefined;
    offlineDateTo?: Date | undefined;
    creditSubmissionExpirationDateFrom?: Date | undefined;
    creditSubmissionExpirationDateTo?: Date | undefined;
    expirationDateFrom?: Date | undefined;
    expirationDateTo?: Date | undefined;
    hasSkuContents?: boolean;
}

export enum SkuApprovalStatus {
    ActiveApproval = "ActiveApproval",
    ExpiredApproval = "ExpiredApproval",
    FutureApproval = "FutureApproval",
}

export class Skus implements ISkus {
    id?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productYear?: string | undefined;
    productVersionId?: string | undefined;
    productVersion?: string | undefined;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    skuStatusId?: string;
    taxClassId?: string | undefined;
    sequence?: number | undefined;
    sku?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    memberPrice?: number | undefined;
    creditLimit?: number | undefined;
    credits?: number | undefined;
    eventStartDate?: Date | undefined;
    eventEndDate?: Date | undefined;
    offlineDate?: Date | undefined;
    releaseDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;
    expirationDate?: Date | undefined;
    hasChild?: boolean;
    corporateEntityId?: string | undefined;
    ownerOrganizationId?: string;
    latestVersionSkuId?: string | undefined;
    advancePreparationId?: string | undefined;
    externalSourceId?: string | undefined;
    productTypeId?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;

    constructor(data?: ISkus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productYearId = _data["productYearId"];
            this.productYear = _data["productYear"];
            this.productVersionId = _data["productVersionId"];
            this.productVersion = _data["productVersion"];
            this.skuFormatId = _data["skuFormatId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.skuStatusId = _data["skuStatusId"];
            this.taxClassId = _data["taxClassId"];
            this.sequence = _data["sequence"];
            this.sku = _data["sku"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.memberPrice = _data["memberPrice"];
            this.creditLimit = _data["creditLimit"];
            this.credits = _data["credits"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            this.offlineDate = _data["offlineDate"] ? new Date(_data["offlineDate"].toString()) : undefined as any;
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.creditSubmissionExpirationDate = _data["creditSubmissionExpirationDate"] ? new Date(_data["creditSubmissionExpirationDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.hasChild = _data["hasChild"];
            this.corporateEntityId = _data["corporateEntityId"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.latestVersionSkuId = _data["latestVersionSkuId"];
            this.advancePreparationId = _data["advancePreparationId"];
            this.externalSourceId = _data["externalSourceId"];
            this.productTypeId = _data["productTypeId"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): Skus {
        data = typeof data === 'object' ? data : {};
        let result = new Skus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productYearId"] = this.productYearId;
        data["productYear"] = this.productYear;
        data["productVersionId"] = this.productVersionId;
        data["productVersion"] = this.productVersion;
        data["skuFormatId"] = this.skuFormatId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["skuStatusId"] = this.skuStatusId;
        data["taxClassId"] = this.taxClassId;
        data["sequence"] = this.sequence;
        data["sku"] = this.sku;
        data["title"] = this.title;
        data["description"] = this.description;
        data["price"] = this.price;
        data["memberPrice"] = this.memberPrice;
        data["creditLimit"] = this.creditLimit;
        data["credits"] = this.credits;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        data["offlineDate"] = this.offlineDate ? this.offlineDate.toISOString() : undefined as any;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["creditSubmissionExpirationDate"] = this.creditSubmissionExpirationDate ? this.creditSubmissionExpirationDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["hasChild"] = this.hasChild;
        data["corporateEntityId"] = this.corporateEntityId;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["latestVersionSkuId"] = this.latestVersionSkuId;
        data["advancePreparationId"] = this.advancePreparationId;
        data["externalSourceId"] = this.externalSourceId;
        data["productTypeId"] = this.productTypeId;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface ISkus {
    id?: string | undefined;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productYear?: string | undefined;
    productVersionId?: string | undefined;
    productVersion?: string | undefined;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    skuStatusId?: string;
    taxClassId?: string | undefined;
    sequence?: number | undefined;
    sku?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    memberPrice?: number | undefined;
    creditLimit?: number | undefined;
    credits?: number | undefined;
    eventStartDate?: Date | undefined;
    eventEndDate?: Date | undefined;
    offlineDate?: Date | undefined;
    releaseDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;
    expirationDate?: Date | undefined;
    hasChild?: boolean;
    corporateEntityId?: string | undefined;
    ownerOrganizationId?: string;
    latestVersionSkuId?: string | undefined;
    advancePreparationId?: string | undefined;
    externalSourceId?: string | undefined;
    productTypeId?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
}

export class ResponseOfSkusAndString implements IResponseOfSkusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Skus | undefined;

    constructor(data?: IResponseOfSkusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Skus.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSkusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSkusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Skus | undefined;
}

export class ResponseOfSkus extends ResponseOfSkusAndString implements IResponseOfSkus {

    constructor(data?: IResponseOfSkus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSkus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSkus extends IResponseOfSkusAndString {
}

export class RequestOfGenerateSkuRequest implements IRequestOfGenerateSkuRequest {
    parameters?: GenerateSkuRequest | undefined;

    constructor(data?: IRequestOfGenerateSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameters = _data["parameters"] ? GenerateSkuRequest.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): RequestOfGenerateSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestOfGenerateSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IRequestOfGenerateSkuRequest {
    parameters?: GenerateSkuRequest | undefined;
}

export class GenerateSkuRequest implements IGenerateSkuRequest {
    skuFormatId?: string;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    sequence?: number | undefined;
    eventEndDate?: Date | undefined;

    constructor(data?: IGenerateSkuRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuFormatId = _data["skuFormatId"];
            this.productId = _data["productId"];
            this.productYearId = _data["productYearId"];
            this.productVersionId = _data["productVersionId"];
            this.sequence = _data["sequence"];
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GenerateSkuRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateSkuRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuFormatId"] = this.skuFormatId;
        data["productId"] = this.productId;
        data["productYearId"] = this.productYearId;
        data["productVersionId"] = this.productVersionId;
        data["sequence"] = this.sequence;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IGenerateSkuRequest {
    skuFormatId?: string;
    productId?: string | undefined;
    productYearId?: string | undefined;
    productVersionId?: string | undefined;
    sequence?: number | undefined;
    eventEndDate?: Date | undefined;
}

export class ResponseOfProfessionAndString implements IResponseOfProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Profession | undefined;

    constructor(data?: IResponseOfProfessionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Profession.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfProfessionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProfessionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Profession | undefined;
}

export class ResponseOfProfession extends ResponseOfProfessionAndString implements IResponseOfProfession {

    constructor(data?: IResponseOfProfession) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProfession();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfProfession extends IResponseOfProfessionAndString {
}

export class ResponseOfListOfProfessionAndString implements IResponseOfListOfProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Profession[] | undefined;

    constructor(data?: IResponseOfListOfProfessionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Profession.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProfessionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProfessionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProfessionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Profession[] | undefined;
}

export class ResponseOfListOfProfession extends ResponseOfListOfProfessionAndString implements IResponseOfListOfProfession {

    constructor(data?: IResponseOfListOfProfession) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProfession();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProfession extends IResponseOfListOfProfessionAndString {
}

export class ListResponseOfProfession extends ResponseOfListOfProfession implements IListResponseOfProfession {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProfession) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProfession {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProfession();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProfession extends IResponseOfListOfProfession {
    totalRecords?: number | undefined;
}

export class ResponseOfAdvancedPreparationAndString implements IResponseOfAdvancedPreparationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdvancedPreparation | undefined;

    constructor(data?: IResponseOfAdvancedPreparationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? AdvancedPreparation.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAdvancedPreparationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAdvancedPreparationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAdvancedPreparationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdvancedPreparation | undefined;
}

export class ResponseOfAdvancedPreparation extends ResponseOfAdvancedPreparationAndString implements IResponseOfAdvancedPreparation {

    constructor(data?: IResponseOfAdvancedPreparation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAdvancedPreparation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAdvancedPreparation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAdvancedPreparation extends IResponseOfAdvancedPreparationAndString {
}

export class AdvancedPreparation implements IAdvancedPreparation {
    id?: string;
    value?: string | undefined;

    constructor(data?: IAdvancedPreparation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AdvancedPreparation {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedPreparation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IAdvancedPreparation {
    id?: string;
    value?: string | undefined;
}

export class ResponseOfListOfTaxClassAndString implements IResponseOfListOfTaxClassAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TaxClass[] | undefined;

    constructor(data?: IResponseOfListOfTaxClassAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaxClass.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfTaxClassAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTaxClassAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfTaxClassAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TaxClass[] | undefined;
}

export class ResponseOfListOfTaxClass extends ResponseOfListOfTaxClassAndString implements IResponseOfListOfTaxClass {

    constructor(data?: IResponseOfListOfTaxClass) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfTaxClass {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTaxClass();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfTaxClass extends IResponseOfListOfTaxClassAndString {
}

export class ListResponseOfTaxClass extends ResponseOfListOfTaxClass implements IListResponseOfTaxClass {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfTaxClass) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfTaxClass {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfTaxClass();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfTaxClass extends IResponseOfListOfTaxClass {
    totalRecords?: number | undefined;
}

export class TaxClass extends BaseModel implements ITaxClass {

    constructor(data?: ITaxClass) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TaxClass {
        data = typeof data === 'object' ? data : {};
        let result = new TaxClass();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITaxClass extends IBaseModel {
}

export class ResponseOfListOfAdvancedPreparationAndString implements IResponseOfListOfAdvancedPreparationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdvancedPreparation[] | undefined;

    constructor(data?: IResponseOfListOfAdvancedPreparationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdvancedPreparation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAdvancedPreparationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdvancedPreparationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAdvancedPreparationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdvancedPreparation[] | undefined;
}

export class ResponseOfListOfAdvancedPreparation extends ResponseOfListOfAdvancedPreparationAndString implements IResponseOfListOfAdvancedPreparation {

    constructor(data?: IResponseOfListOfAdvancedPreparation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAdvancedPreparation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdvancedPreparation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAdvancedPreparation extends IResponseOfListOfAdvancedPreparationAndString {
}

export class ListResponseOfAdvancedPreparation extends ResponseOfListOfAdvancedPreparation implements IListResponseOfAdvancedPreparation {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAdvancedPreparation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAdvancedPreparation {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAdvancedPreparation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAdvancedPreparation extends IResponseOfListOfAdvancedPreparation {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfDirectLinkAndString implements IResponseOfListOfDirectLinkAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DirectLink[] | undefined;

    constructor(data?: IResponseOfListOfDirectLinkAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DirectLink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfDirectLinkAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDirectLinkAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfDirectLinkAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: DirectLink[] | undefined;
}

export class ResponseOfListOfDirectLink extends ResponseOfListOfDirectLinkAndString implements IResponseOfListOfDirectLink {

    constructor(data?: IResponseOfListOfDirectLink) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfDirectLink {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfDirectLink();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfDirectLink extends IResponseOfListOfDirectLinkAndString {
}

export class ListResponseOfDirectLink extends ResponseOfListOfDirectLink implements IListResponseOfDirectLink {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfDirectLink) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfDirectLink {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfDirectLink();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfDirectLink extends IResponseOfListOfDirectLink {
    totalRecords?: number | undefined;
}

export class DirectLink implements IDirectLink {
    name!: string;
    url!: string;
    info?: string | undefined;

    constructor(data?: IDirectLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): DirectLink {
        data = typeof data === 'object' ? data : {};
        let result = new DirectLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["info"] = this.info;
        return data;
    }
}

export interface IDirectLink {
    name: string;
    url: string;
    info?: string | undefined;
}

export class SkuPreviewRequest implements ISkuPreviewRequest {
    skuId?: string;
    organizationId?: string;
    timeZone?: string | undefined;

    constructor(data?: ISkuPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.organizationId = _data["organizationId"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): SkuPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["organizationId"] = this.organizationId;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface ISkuPreviewRequest {
    skuId?: string;
    organizationId?: string;
    timeZone?: string | undefined;
}

export class AdminSkuDeliverableRequest implements IAdminSkuDeliverableRequest {
    id?: string | undefined;
    applicationId?: string | undefined;
    organizationId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    deliverableId?: string | undefined;
    deliveryMethodId?: string;
    sequence?: number;
    deliverableTypeId?: string;
    externalSourceId?: string | undefined;
    settingValues?: DeliveryMethodSettingValue[] | undefined;

    constructor(data?: IAdminSkuDeliverableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.deliverableId = _data["deliverableId"];
            this.deliveryMethodId = _data["deliveryMethodId"];
            this.sequence = _data["sequence"];
            this.deliverableTypeId = _data["deliverableTypeId"];
            this.externalSourceId = _data["externalSourceId"];
            if (Array.isArray(_data["settingValues"])) {
                this.settingValues = [] as any;
                for (let item of _data["settingValues"])
                    this.settingValues!.push(DeliveryMethodSettingValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminSkuDeliverableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSkuDeliverableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["deliverableId"] = this.deliverableId;
        data["deliveryMethodId"] = this.deliveryMethodId;
        data["sequence"] = this.sequence;
        data["deliverableTypeId"] = this.deliverableTypeId;
        data["externalSourceId"] = this.externalSourceId;
        if (Array.isArray(this.settingValues)) {
            data["settingValues"] = [];
            for (let item of this.settingValues)
                data["settingValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminSkuDeliverableRequest {
    id?: string | undefined;
    applicationId?: string | undefined;
    organizationId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    deliverableId?: string | undefined;
    deliveryMethodId?: string;
    sequence?: number;
    deliverableTypeId?: string;
    externalSourceId?: string | undefined;
    settingValues?: DeliveryMethodSettingValue[] | undefined;
}

export class ResponseOfListOfAdminDeliveryMethodAndString implements IResponseOfListOfAdminDeliveryMethodAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminDeliveryMethod[] | undefined;

    constructor(data?: IResponseOfListOfAdminDeliveryMethodAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdminDeliveryMethod.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAdminDeliveryMethodAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminDeliveryMethodAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAdminDeliveryMethodAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminDeliveryMethod[] | undefined;
}

export class ResponseOfListOfAdminDeliveryMethod extends ResponseOfListOfAdminDeliveryMethodAndString implements IResponseOfListOfAdminDeliveryMethod {

    constructor(data?: IResponseOfListOfAdminDeliveryMethod) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAdminDeliveryMethod {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminDeliveryMethod();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAdminDeliveryMethod extends IResponseOfListOfAdminDeliveryMethodAndString {
}

export class ListResponseOfAdminDeliveryMethod extends ResponseOfListOfAdminDeliveryMethod implements IListResponseOfAdminDeliveryMethod {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAdminDeliveryMethod) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAdminDeliveryMethod {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAdminDeliveryMethod();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAdminDeliveryMethod extends IResponseOfListOfAdminDeliveryMethod {
    totalRecords?: number | undefined;
}

export class AdminDeliveryMethod implements IAdminDeliveryMethod {
    id?: string | undefined;
    enumValue?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    settings?: DeliveryMethodSetting[] | undefined;

    constructor(data?: IAdminDeliveryMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enumValue = _data["enumValue"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(DeliveryMethodSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminDeliveryMethod {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDeliveryMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enumValue"] = this.enumValue;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminDeliveryMethod {
    id?: string | undefined;
    enumValue?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    settings?: DeliveryMethodSetting[] | undefined;
}

export class ResponseOfSkuFormatAndString implements IResponseOfSkuFormatAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuFormat | undefined;

    constructor(data?: IResponseOfSkuFormatAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SkuFormat.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSkuFormatAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuFormatAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSkuFormatAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuFormat | undefined;
}

export class ResponseOfSkuFormat extends ResponseOfSkuFormatAndString implements IResponseOfSkuFormat {

    constructor(data?: IResponseOfSkuFormat) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSkuFormat {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuFormat();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSkuFormat extends IResponseOfSkuFormatAndString {
}

export class ResponseOfListOfSkuFormatAndString implements IResponseOfListOfSkuFormatAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuFormat[] | undefined;

    constructor(data?: IResponseOfListOfSkuFormatAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuFormat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuFormatAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuFormatAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuFormatAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuFormat[] | undefined;
}

export class ResponseOfListOfSkuFormat extends ResponseOfListOfSkuFormatAndString implements IResponseOfListOfSkuFormat {

    constructor(data?: IResponseOfListOfSkuFormat) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuFormat {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuFormat();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuFormat extends IResponseOfListOfSkuFormatAndString {
}

export class ListResponseOfSkuFormat extends ResponseOfListOfSkuFormat implements IListResponseOfSkuFormat {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuFormat) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuFormat {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuFormat();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuFormat extends IResponseOfListOfSkuFormat {
    totalRecords?: number | undefined;
}

export class SkuFormatSaveRequest implements ISkuFormatSaveRequest {
    id?: string | undefined;
    acronym!: string;
    name!: string;
    description?: string | undefined;

    constructor(data?: ISkuFormatSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.acronym = _data["acronym"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SkuFormatSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuFormatSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["acronym"] = this.acronym;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ISkuFormatSaveRequest {
    id?: string | undefined;
    acronym: string;
    name: string;
    description?: string | undefined;
}

export class ResponseOfListOfSkuKnowledgeLevelAndString implements IResponseOfListOfSkuKnowledgeLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuKnowledgeLevel[] | undefined;

    constructor(data?: IResponseOfListOfSkuKnowledgeLevelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuKnowledgeLevel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuKnowledgeLevelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuKnowledgeLevelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuKnowledgeLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuKnowledgeLevel[] | undefined;
}

export class ResponseOfListOfSkuKnowledgeLevel extends ResponseOfListOfSkuKnowledgeLevelAndString implements IResponseOfListOfSkuKnowledgeLevel {

    constructor(data?: IResponseOfListOfSkuKnowledgeLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuKnowledgeLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuKnowledgeLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuKnowledgeLevel extends IResponseOfListOfSkuKnowledgeLevelAndString {
}

export class ListResponseOfSkuKnowledgeLevel extends ResponseOfListOfSkuKnowledgeLevel implements IListResponseOfSkuKnowledgeLevel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuKnowledgeLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuKnowledgeLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuKnowledgeLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuKnowledgeLevel extends IResponseOfListOfSkuKnowledgeLevel {
    totalRecords?: number | undefined;
}

export class SkuKnowledgeLevel implements ISkuKnowledgeLevel {
    id?: string;
    skuId?: string;
    knowledgeLevel?: KnowledgeLevel | undefined;
    profession?: Profession | undefined;

    constructor(data?: ISkuKnowledgeLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.knowledgeLevel = _data["knowledgeLevel"] ? KnowledgeLevel.fromJS(_data["knowledgeLevel"]) : undefined as any;
            this.profession = _data["profession"] ? Profession.fromJS(_data["profession"]) : undefined as any;
        }
    }

    static fromJS(data: any): SkuKnowledgeLevel {
        data = typeof data === 'object' ? data : {};
        let result = new SkuKnowledgeLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["knowledgeLevel"] = this.knowledgeLevel ? this.knowledgeLevel.toJSON() : undefined as any;
        data["profession"] = this.profession ? this.profession.toJSON() : undefined as any;
        return data;
    }
}

export interface ISkuKnowledgeLevel {
    id?: string;
    skuId?: string;
    knowledgeLevel?: KnowledgeLevel | undefined;
    profession?: Profession | undefined;
}

export class KnowledgeLevel extends BaseModel implements IKnowledgeLevel {
    objectTypeName?: string | undefined;
    displayOrder?: number | undefined;

    constructor(data?: IKnowledgeLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.objectTypeName = _data["objectTypeName"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static override fromJS(data: any): KnowledgeLevel {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectTypeName"] = this.objectTypeName;
        data["displayOrder"] = this.displayOrder;
        super.toJSON(data);
        return data;
    }
}

export interface IKnowledgeLevel extends IBaseModel {
    objectTypeName?: string | undefined;
    displayOrder?: number | undefined;
}

export class ListRequestOfSkuKnowledgeLevelFilter implements IListRequestOfSkuKnowledgeLevelFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuKnowledgeLevelFilter | undefined;

    constructor(data?: IListRequestOfSkuKnowledgeLevelFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuKnowledgeLevelFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuKnowledgeLevelFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuKnowledgeLevelFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuKnowledgeLevelFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuKnowledgeLevelFilter | undefined;
}

export class SkuKnowledgeLevelFilter extends BaseFilter implements ISkuKnowledgeLevelFilter {
    knowledgeLevelId?: string | undefined;

    constructor(data?: ISkuKnowledgeLevelFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.knowledgeLevelId = _data["knowledgeLevelId"];
        }
    }

    static override fromJS(data: any): SkuKnowledgeLevelFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuKnowledgeLevelFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeLevelId"] = this.knowledgeLevelId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuKnowledgeLevelFilter extends IBaseFilter {
    knowledgeLevelId?: string | undefined;
}

export class SkuKnowledgeLevelRequest implements ISkuKnowledgeLevelRequest {
    id?: string | undefined;
    knowledgeLevelId!: string;
    professionId?: string | undefined;

    constructor(data?: ISkuKnowledgeLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.knowledgeLevelId = _data["knowledgeLevelId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): SkuKnowledgeLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuKnowledgeLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["knowledgeLevelId"] = this.knowledgeLevelId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ISkuKnowledgeLevelRequest {
    id?: string | undefined;
    knowledgeLevelId: string;
    professionId?: string | undefined;
}

export class ResponseOfListOfKnowledgeLevelAndString implements IResponseOfListOfKnowledgeLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: KnowledgeLevel[] | undefined;

    constructor(data?: IResponseOfListOfKnowledgeLevelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KnowledgeLevel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfKnowledgeLevelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfKnowledgeLevelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfKnowledgeLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: KnowledgeLevel[] | undefined;
}

export class ResponseOfListOfKnowledgeLevel extends ResponseOfListOfKnowledgeLevelAndString implements IResponseOfListOfKnowledgeLevel {

    constructor(data?: IResponseOfListOfKnowledgeLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfKnowledgeLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfKnowledgeLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfKnowledgeLevel extends IResponseOfListOfKnowledgeLevelAndString {
}

export class ListResponseOfKnowledgeLevel extends ResponseOfListOfKnowledgeLevel implements IListResponseOfKnowledgeLevel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfKnowledgeLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfKnowledgeLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfKnowledgeLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfKnowledgeLevel extends IResponseOfListOfKnowledgeLevel {
    totalRecords?: number | undefined;
}

export class SkuLearningLevelRequest implements ISkuLearningLevelRequest {
    id?: string | undefined;
    learningLevelId?: string;

    constructor(data?: ISkuLearningLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.learningLevelId = _data["learningLevelId"];
        }
    }

    static fromJS(data: any): SkuLearningLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuLearningLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["learningLevelId"] = this.learningLevelId;
        return data;
    }
}

export interface ISkuLearningLevelRequest {
    id?: string | undefined;
    learningLevelId?: string;
}

export class ResponseOfListOfSkuLearningLevelAndString implements IResponseOfListOfSkuLearningLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuLearningLevel[] | undefined;

    constructor(data?: IResponseOfListOfSkuLearningLevelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuLearningLevel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuLearningLevelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuLearningLevelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuLearningLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuLearningLevel[] | undefined;
}

export class ResponseOfListOfSkuLearningLevel extends ResponseOfListOfSkuLearningLevelAndString implements IResponseOfListOfSkuLearningLevel {

    constructor(data?: IResponseOfListOfSkuLearningLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuLearningLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuLearningLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuLearningLevel extends IResponseOfListOfSkuLearningLevelAndString {
}

export class ListResponseOfSkuLearningLevel extends ResponseOfListOfSkuLearningLevel implements IListResponseOfSkuLearningLevel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuLearningLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuLearningLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuLearningLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuLearningLevel extends IResponseOfListOfSkuLearningLevel {
    totalRecords?: number | undefined;
}

export class SkuLearningLevel implements ISkuLearningLevel {
    id!: string;
    skuId!: string;
    learningLevelId?: string | undefined;
    learningLevel?: LearningLevel | undefined;

    constructor(data?: ISkuLearningLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.learningLevelId = _data["learningLevelId"];
            this.learningLevel = _data["learningLevel"] ? LearningLevel.fromJS(_data["learningLevel"]) : undefined as any;
        }
    }

    static fromJS(data: any): SkuLearningLevel {
        data = typeof data === 'object' ? data : {};
        let result = new SkuLearningLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["learningLevelId"] = this.learningLevelId;
        data["learningLevel"] = this.learningLevel ? this.learningLevel.toJSON() : undefined as any;
        return data;
    }
}

export interface ISkuLearningLevel {
    id: string;
    skuId: string;
    learningLevelId?: string | undefined;
    learningLevel?: LearningLevel | undefined;
}

export class LearningLevel extends BaseModel implements ILearningLevel {

    constructor(data?: ILearningLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LearningLevel {
        data = typeof data === 'object' ? data : {};
        let result = new LearningLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILearningLevel extends IBaseModel {
}

export class ListRequestOfSkuLearningLevelFilter implements IListRequestOfSkuLearningLevelFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuLearningLevelFilter | undefined;

    constructor(data?: IListRequestOfSkuLearningLevelFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuLearningLevelFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuLearningLevelFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuLearningLevelFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuLearningLevelFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuLearningLevelFilter | undefined;
}

export class SkuLearningLevelFilter extends BaseFilter implements ISkuLearningLevelFilter {
    learningLevelId?: string | undefined;

    constructor(data?: ISkuLearningLevelFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.learningLevelId = _data["learningLevelId"];
        }
    }

    static override fromJS(data: any): SkuLearningLevelFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuLearningLevelFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learningLevelId"] = this.learningLevelId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuLearningLevelFilter extends IBaseFilter {
    learningLevelId?: string | undefined;
}

export class ResponseOfListOfLearningLevelAndString implements IResponseOfListOfLearningLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LearningLevel[] | undefined;

    constructor(data?: IResponseOfListOfLearningLevelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LearningLevel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfLearningLevelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLearningLevelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfLearningLevelAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LearningLevel[] | undefined;
}

export class ResponseOfListOfLearningLevel extends ResponseOfListOfLearningLevelAndString implements IResponseOfListOfLearningLevel {

    constructor(data?: IResponseOfListOfLearningLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfLearningLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLearningLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfLearningLevel extends IResponseOfListOfLearningLevelAndString {
}

export class ListResponseOfLearningLevel extends ResponseOfListOfLearningLevel implements IListResponseOfLearningLevel {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfLearningLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfLearningLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfLearningLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfLearningLevel extends IResponseOfListOfLearningLevel {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfSkuLearningObjectiveAndString implements IResponseOfListOfSkuLearningObjectiveAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuLearningObjective[] | undefined;

    constructor(data?: IResponseOfListOfSkuLearningObjectiveAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuLearningObjective.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuLearningObjectiveAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuLearningObjectiveAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuLearningObjectiveAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuLearningObjective[] | undefined;
}

export class ResponseOfListOfSkuLearningObjective extends ResponseOfListOfSkuLearningObjectiveAndString implements IResponseOfListOfSkuLearningObjective {

    constructor(data?: IResponseOfListOfSkuLearningObjective) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuLearningObjective {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuLearningObjective();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuLearningObjective extends IResponseOfListOfSkuLearningObjectiveAndString {
}

export class ListResponseOfSkuLearningObjective extends ResponseOfListOfSkuLearningObjective implements IListResponseOfSkuLearningObjective {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuLearningObjective) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuLearningObjective {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuLearningObjective();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuLearningObjective extends IResponseOfListOfSkuLearningObjective {
    totalRecords?: number | undefined;
}

export class SkuLearningObjective implements ISkuLearningObjective {
    id?: string;
    skuId?: string;
    professionId?: string | undefined;
    learningObjective?: LearningObjective | undefined;

    constructor(data?: ISkuLearningObjective) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.professionId = _data["professionId"];
            this.learningObjective = _data["learningObjective"] ? LearningObjective.fromJS(_data["learningObjective"]) : undefined as any;
        }
    }

    static fromJS(data: any): SkuLearningObjective {
        data = typeof data === 'object' ? data : {};
        let result = new SkuLearningObjective();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["professionId"] = this.professionId;
        data["learningObjective"] = this.learningObjective ? this.learningObjective.toJSON() : undefined as any;
        return data;
    }
}

export interface ISkuLearningObjective {
    id?: string;
    skuId?: string;
    professionId?: string | undefined;
    learningObjective?: LearningObjective | undefined;
}

export class LearningObjective implements ILearningObjective {
    description?: string | undefined;
    externalId?: number | undefined;
    courseIdVersion?: string | undefined;
    professionId?: string | undefined;
    externalSourceId?: string | undefined;

    constructor(data?: ILearningObjective) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.externalId = _data["externalId"];
            this.courseIdVersion = _data["courseIdVersion"];
            this.professionId = _data["professionId"];
            this.externalSourceId = _data["externalSourceId"];
        }
    }

    static fromJS(data: any): LearningObjective {
        data = typeof data === 'object' ? data : {};
        let result = new LearningObjective();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["externalId"] = this.externalId;
        data["courseIdVersion"] = this.courseIdVersion;
        data["professionId"] = this.professionId;
        data["externalSourceId"] = this.externalSourceId;
        return data;
    }
}

export interface ILearningObjective {
    description?: string | undefined;
    externalId?: number | undefined;
    courseIdVersion?: string | undefined;
    professionId?: string | undefined;
    externalSourceId?: string | undefined;
}

export class ListRequestOfSkuLearningObjectiveFilter implements IListRequestOfSkuLearningObjectiveFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuLearningObjectiveFilter | undefined;

    constructor(data?: IListRequestOfSkuLearningObjectiveFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuLearningObjectiveFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuLearningObjectiveFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuLearningObjectiveFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuLearningObjectiveFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuLearningObjectiveFilter | undefined;
}

export class SkuLearningObjectiveFilter extends BaseFilter implements ISkuLearningObjectiveFilter {
    professionId?: string | undefined;
    learningObjectiveId?: string | undefined;

    constructor(data?: ISkuLearningObjectiveFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.professionId = _data["professionId"];
            this.learningObjectiveId = _data["learningObjectiveId"];
        }
    }

    static override fromJS(data: any): SkuLearningObjectiveFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuLearningObjectiveFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["learningObjectiveId"] = this.learningObjectiveId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuLearningObjectiveFilter extends IBaseFilter {
    professionId?: string | undefined;
    learningObjectiveId?: string | undefined;
}

export class SkuLearningObjectiveRequest implements ISkuLearningObjectiveRequest {
    id?: string | undefined;
    learningObjectiveId?: string | undefined;
    professionId?: string | undefined;
    description?: string | undefined;

    constructor(data?: ISkuLearningObjectiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.learningObjectiveId = _data["learningObjectiveId"];
            this.professionId = _data["professionId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SkuLearningObjectiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuLearningObjectiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["learningObjectiveId"] = this.learningObjectiveId;
        data["professionId"] = this.professionId;
        data["description"] = this.description;
        return data;
    }
}

export interface ISkuLearningObjectiveRequest {
    id?: string | undefined;
    learningObjectiveId?: string | undefined;
    professionId?: string | undefined;
    description?: string | undefined;
}

export class ResponseOfListOfSkuMajorTopicAndString implements IResponseOfListOfSkuMajorTopicAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuMajorTopic[] | undefined;

    constructor(data?: IResponseOfListOfSkuMajorTopicAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuMajorTopic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuMajorTopicAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuMajorTopicAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuMajorTopicAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuMajorTopic[] | undefined;
}

export class ResponseOfListOfSkuMajorTopic extends ResponseOfListOfSkuMajorTopicAndString implements IResponseOfListOfSkuMajorTopic {

    constructor(data?: IResponseOfListOfSkuMajorTopic) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuMajorTopic {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuMajorTopic();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuMajorTopic extends IResponseOfListOfSkuMajorTopicAndString {
}

export class ListResponseOfSkuMajorTopic extends ResponseOfListOfSkuMajorTopic implements IListResponseOfSkuMajorTopic {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuMajorTopic) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuMajorTopic {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuMajorTopic();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuMajorTopic extends IResponseOfListOfSkuMajorTopic {
    totalRecords?: number | undefined;
}

export class SkuMajorTopic implements ISkuMajorTopic {
    id?: string;
    skuId?: string;
    professionId?: string | undefined;
    majorTopic?: MajorTopic | undefined;

    constructor(data?: ISkuMajorTopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.professionId = _data["professionId"];
            this.majorTopic = _data["majorTopic"] ? MajorTopic.fromJS(_data["majorTopic"]) : undefined as any;
        }
    }

    static fromJS(data: any): SkuMajorTopic {
        data = typeof data === 'object' ? data : {};
        let result = new SkuMajorTopic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["professionId"] = this.professionId;
        data["majorTopic"] = this.majorTopic ? this.majorTopic.toJSON() : undefined as any;
        return data;
    }
}

export interface ISkuMajorTopic {
    id?: string;
    skuId?: string;
    professionId?: string | undefined;
    majorTopic?: MajorTopic | undefined;
}

export class MajorTopic implements IMajorTopic {
    id?: string;
    description?: string | undefined;
    externalId?: number | undefined;
    courseIdVersion?: string | undefined;

    constructor(data?: IMajorTopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.externalId = _data["externalId"];
            this.courseIdVersion = _data["courseIdVersion"];
        }
    }

    static fromJS(data: any): MajorTopic {
        data = typeof data === 'object' ? data : {};
        let result = new MajorTopic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["externalId"] = this.externalId;
        data["courseIdVersion"] = this.courseIdVersion;
        return data;
    }
}

export interface IMajorTopic {
    id?: string;
    description?: string | undefined;
    externalId?: number | undefined;
    courseIdVersion?: string | undefined;
}

export class SkuMajorTopicRequest implements ISkuMajorTopicRequest {
    majorTopicId?: string | undefined;
    majorTopicDescription?: string | undefined;
    professionId?: string | undefined;
    id?: string | undefined;

    constructor(data?: ISkuMajorTopicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.majorTopicId = _data["majorTopicId"];
            this.majorTopicDescription = _data["majorTopicDescription"];
            this.professionId = _data["professionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SkuMajorTopicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuMajorTopicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["majorTopicId"] = this.majorTopicId;
        data["majorTopicDescription"] = this.majorTopicDescription;
        data["professionId"] = this.professionId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISkuMajorTopicRequest {
    majorTopicId?: string | undefined;
    majorTopicDescription?: string | undefined;
    professionId?: string | undefined;
    id?: string | undefined;
}

export class ListRequestOfSkuProgressionGateFilter implements IListRequestOfSkuProgressionGateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuProgressionGateFilter | undefined;

    constructor(data?: IListRequestOfSkuProgressionGateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuProgressionGateFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuProgressionGateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuProgressionGateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuProgressionGateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuProgressionGateFilter | undefined;
}

export class SkuProgressionGateFilter extends BaseFilter implements ISkuProgressionGateFilter {
    progressionGateTypeId?: string | undefined;

    constructor(data?: ISkuProgressionGateFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.progressionGateTypeId = _data["progressionGateTypeId"];
        }
    }

    static override fromJS(data: any): SkuProgressionGateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuProgressionGateFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progressionGateTypeId"] = this.progressionGateTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuProgressionGateFilter extends IBaseFilter {
    progressionGateTypeId?: string | undefined;
}

export class AccreditationBodiesGroupedViewEnabledRequest implements IAccreditationBodiesGroupedViewEnabledRequest {
    organizationId?: string;

    constructor(data?: IAccreditationBodiesGroupedViewEnabledRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): AccreditationBodiesGroupedViewEnabledRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditationBodiesGroupedViewEnabledRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IAccreditationBodiesGroupedViewEnabledRequest {
    organizationId?: string;
}

export class ResponseOfSkuQualificationPreviewResponseAndString implements IResponseOfSkuQualificationPreviewResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuQualificationPreviewResponse | undefined;

    constructor(data?: IResponseOfSkuQualificationPreviewResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SkuQualificationPreviewResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSkuQualificationPreviewResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuQualificationPreviewResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSkuQualificationPreviewResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuQualificationPreviewResponse | undefined;
}

export class ResponseOfSkuQualificationPreviewResponse extends ResponseOfSkuQualificationPreviewResponseAndString implements IResponseOfSkuQualificationPreviewResponse {

    constructor(data?: IResponseOfSkuQualificationPreviewResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSkuQualificationPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuQualificationPreviewResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSkuQualificationPreviewResponse extends IResponseOfSkuQualificationPreviewResponseAndString {
}

export class SkuQualificationPreviewResponse implements ISkuQualificationPreviewResponse {
    existingQualifications?: SkuQualificationPreviewItem[] | undefined;
    totalNew?: number;
    totalExisting?: number;

    constructor(data?: ISkuQualificationPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["existingQualifications"])) {
                this.existingQualifications = [] as any;
                for (let item of _data["existingQualifications"])
                    this.existingQualifications!.push(SkuQualificationPreviewItem.fromJS(item));
            }
            this.totalNew = _data["totalNew"];
            this.totalExisting = _data["totalExisting"];
        }
    }

    static fromJS(data: any): SkuQualificationPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.existingQualifications)) {
            data["existingQualifications"] = [];
            for (let item of this.existingQualifications)
                data["existingQualifications"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNew"] = this.totalNew;
        data["totalExisting"] = this.totalExisting;
        return data;
    }
}

export interface ISkuQualificationPreviewResponse {
    existingQualifications?: SkuQualificationPreviewItem[] | undefined;
    totalNew?: number;
    totalExisting?: number;
}

export class SkuQualificationPreviewItem implements ISkuQualificationPreviewItem {
    qualificationName?: string | undefined;
    professionName?: string | undefined;
    stateName?: string | undefined;
    releaseDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;

    constructor(data?: ISkuQualificationPreviewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationName = _data["qualificationName"];
            this.professionName = _data["professionName"];
            this.stateName = _data["stateName"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.creditSubmissionExpirationDate = _data["creditSubmissionExpirationDate"] ? new Date(_data["creditSubmissionExpirationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SkuQualificationPreviewItem {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationPreviewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationName"] = this.qualificationName;
        data["professionName"] = this.professionName;
        data["stateName"] = this.stateName;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["creditSubmissionExpirationDate"] = this.creditSubmissionExpirationDate ? this.creditSubmissionExpirationDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISkuQualificationPreviewItem {
    qualificationName?: string | undefined;
    professionName?: string | undefined;
    stateName?: string | undefined;
    releaseDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;
}

export class SkuQualificationRequest implements ISkuQualificationRequest {
    id?: string | undefined;
    qualificationId!: string;
    professionId?: string | undefined;
    stateId?: string | undefined;
    stateIds?: string[] | undefined;
    useQualificationApprovals?: boolean;
    duplicateHandling?: DuplicateHandlingMode;
    courseNumber?: string | undefined;
    approvalCode?: string | undefined;
    approvalDate?: Date | undefined;
    releaseDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;
    childSkuQualificationIds?: string[] | undefined;
    credits?: number | undefined;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;
    notes?: string | undefined;
    subjectAreas?: SkuQualificationSubjectAreaRequest[] | undefined;

    constructor(data?: ISkuQualificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationId = _data["qualificationId"];
            this.professionId = _data["professionId"];
            this.stateId = _data["stateId"];
            if (Array.isArray(_data["stateIds"])) {
                this.stateIds = [] as any;
                for (let item of _data["stateIds"])
                    this.stateIds!.push(item);
            }
            this.useQualificationApprovals = _data["useQualificationApprovals"];
            this.duplicateHandling = _data["duplicateHandling"];
            this.courseNumber = _data["courseNumber"];
            this.approvalCode = _data["approvalCode"];
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : undefined as any;
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.creditSubmissionExpirationDate = _data["creditSubmissionExpirationDate"] ? new Date(_data["creditSubmissionExpirationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["childSkuQualificationIds"])) {
                this.childSkuQualificationIds = [] as any;
                for (let item of _data["childSkuQualificationIds"])
                    this.childSkuQualificationIds!.push(item);
            }
            this.credits = _data["credits"];
            this.partialCreditIncrement = _data["partialCreditIncrement"];
            this.minimumCredit = _data["minimumCredit"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["subjectAreas"])) {
                this.subjectAreas = [] as any;
                for (let item of _data["subjectAreas"])
                    this.subjectAreas!.push(SkuQualificationSubjectAreaRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuQualificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationId"] = this.qualificationId;
        data["professionId"] = this.professionId;
        data["stateId"] = this.stateId;
        if (Array.isArray(this.stateIds)) {
            data["stateIds"] = [];
            for (let item of this.stateIds)
                data["stateIds"].push(item);
        }
        data["useQualificationApprovals"] = this.useQualificationApprovals;
        data["duplicateHandling"] = this.duplicateHandling;
        data["courseNumber"] = this.courseNumber;
        data["approvalCode"] = this.approvalCode;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : undefined as any;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["creditSubmissionExpirationDate"] = this.creditSubmissionExpirationDate ? this.creditSubmissionExpirationDate.toISOString() : undefined as any;
        if (Array.isArray(this.childSkuQualificationIds)) {
            data["childSkuQualificationIds"] = [];
            for (let item of this.childSkuQualificationIds)
                data["childSkuQualificationIds"].push(item);
        }
        data["credits"] = this.credits;
        data["partialCreditIncrement"] = this.partialCreditIncrement;
        data["minimumCredit"] = this.minimumCredit;
        data["notes"] = this.notes;
        if (Array.isArray(this.subjectAreas)) {
            data["subjectAreas"] = [];
            for (let item of this.subjectAreas)
                data["subjectAreas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuQualificationRequest {
    id?: string | undefined;
    qualificationId: string;
    professionId?: string | undefined;
    stateId?: string | undefined;
    stateIds?: string[] | undefined;
    useQualificationApprovals?: boolean;
    duplicateHandling?: DuplicateHandlingMode;
    courseNumber?: string | undefined;
    approvalCode?: string | undefined;
    approvalDate?: Date | undefined;
    releaseDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;
    childSkuQualificationIds?: string[] | undefined;
    credits?: number | undefined;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;
    notes?: string | undefined;
    subjectAreas?: SkuQualificationSubjectAreaRequest[] | undefined;
}

export enum DuplicateHandlingMode {
    UpdateExisting = "UpdateExisting",
    SkipExisting = "SkipExisting",
}

export class SkuQualificationSubjectAreaRequest implements ISkuQualificationSubjectAreaRequest {
    id?: string | undefined;
    subjectAreaId!: string;
    credits?: number;
    overrides?: SkuQualificationSubjectAreaOverrideRequest[] | undefined;

    constructor(data?: ISkuQualificationSubjectAreaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subjectAreaId = _data["subjectAreaId"];
            this.credits = _data["credits"];
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(SkuQualificationSubjectAreaOverrideRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuQualificationSubjectAreaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationSubjectAreaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subjectAreaId"] = this.subjectAreaId;
        data["credits"] = this.credits;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuQualificationSubjectAreaRequest {
    id?: string | undefined;
    subjectAreaId: string;
    credits?: number;
    overrides?: SkuQualificationSubjectAreaOverrideRequest[] | undefined;
}

export class SkuQualificationSubjectAreaOverrideRequest implements ISkuQualificationSubjectAreaOverrideRequest {
    licensureBodyId!: string;
    subjectAreaId!: string;
    credits?: number | undefined;

    constructor(data?: ISkuQualificationSubjectAreaOverrideRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensureBodyId = _data["licensureBodyId"];
            this.subjectAreaId = _data["subjectAreaId"];
            this.credits = _data["credits"];
        }
    }

    static fromJS(data: any): SkuQualificationSubjectAreaOverrideRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationSubjectAreaOverrideRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensureBodyId"] = this.licensureBodyId;
        data["subjectAreaId"] = this.subjectAreaId;
        data["credits"] = this.credits;
        return data;
    }
}

export interface ISkuQualificationSubjectAreaOverrideRequest {
    licensureBodyId: string;
    subjectAreaId: string;
    credits?: number | undefined;
}

export class ResponseOfListOfSkuQualificationViewAndString implements IResponseOfListOfSkuQualificationViewAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuQualificationView[] | undefined;

    constructor(data?: IResponseOfListOfSkuQualificationViewAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuQualificationView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuQualificationViewAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuQualificationViewAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuQualificationViewAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuQualificationView[] | undefined;
}

export class ResponseOfListOfSkuQualificationView extends ResponseOfListOfSkuQualificationViewAndString implements IResponseOfListOfSkuQualificationView {

    constructor(data?: IResponseOfListOfSkuQualificationView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuQualificationView {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuQualificationView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuQualificationView extends IResponseOfListOfSkuQualificationViewAndString {
}

export class ListResponseOfSkuQualificationView extends ResponseOfListOfSkuQualificationView implements IListResponseOfSkuQualificationView {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuQualificationView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuQualificationView {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuQualificationView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuQualificationView extends IResponseOfListOfSkuQualificationView {
    totalRecords?: number | undefined;
}

export class SkuQualification implements ISkuQualification {
    id?: string;
    skuId?: string;
    qualification?: Qualification | undefined;
    profession?: Profession | undefined;
    courseNumber?: string | undefined;
    approvalCode?: string | undefined;
    approvalDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;
    stateId?: string | undefined;
    stateName?: string | undefined;
    releaseDate?: Date | undefined;
    credits?: number | undefined;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;
    notes?: string | undefined;
    verificationStatus?: VerificationStatus | undefined;
    verificationMessage?: string | undefined;
    immutable?: boolean;

    constructor(data?: ISkuQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : undefined as any;
            this.profession = _data["profession"] ? Profession.fromJS(_data["profession"]) : undefined as any;
            this.courseNumber = _data["courseNumber"];
            this.approvalCode = _data["approvalCode"];
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : undefined as any;
            this.creditSubmissionExpirationDate = _data["creditSubmissionExpirationDate"] ? new Date(_data["creditSubmissionExpirationDate"].toString()) : undefined as any;
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.credits = _data["credits"];
            this.partialCreditIncrement = _data["partialCreditIncrement"];
            this.minimumCredit = _data["minimumCredit"];
            this.notes = _data["notes"];
            this.verificationStatus = _data["verificationStatus"] ? VerificationStatus.fromJS(_data["verificationStatus"]) : undefined as any;
            this.verificationMessage = _data["verificationMessage"];
            this.immutable = _data["immutable"];
        }
    }

    static fromJS(data: any): SkuQualification {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : undefined as any;
        data["profession"] = this.profession ? this.profession.toJSON() : undefined as any;
        data["courseNumber"] = this.courseNumber;
        data["approvalCode"] = this.approvalCode;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : undefined as any;
        data["creditSubmissionExpirationDate"] = this.creditSubmissionExpirationDate ? this.creditSubmissionExpirationDate.toISOString() : undefined as any;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["credits"] = this.credits;
        data["partialCreditIncrement"] = this.partialCreditIncrement;
        data["minimumCredit"] = this.minimumCredit;
        data["notes"] = this.notes;
        data["verificationStatus"] = this.verificationStatus ? this.verificationStatus.toJSON() : undefined as any;
        data["verificationMessage"] = this.verificationMessage;
        data["immutable"] = this.immutable;
        return data;
    }
}

export interface ISkuQualification {
    id?: string;
    skuId?: string;
    qualification?: Qualification | undefined;
    profession?: Profession | undefined;
    courseNumber?: string | undefined;
    approvalCode?: string | undefined;
    approvalDate?: Date | undefined;
    creditSubmissionExpirationDate?: Date | undefined;
    stateId?: string | undefined;
    stateName?: string | undefined;
    releaseDate?: Date | undefined;
    credits?: number | undefined;
    partialCreditIncrement?: number | undefined;
    minimumCredit?: number | undefined;
    notes?: string | undefined;
    verificationStatus?: VerificationStatus | undefined;
    verificationMessage?: string | undefined;
    immutable?: boolean;
}

export class SkuQualificationView extends SkuQualification implements ISkuQualificationView {
    accreditationChain?: AccreditationChainItem[] | undefined;

    constructor(data?: ISkuQualificationView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accreditationChain"])) {
                this.accreditationChain = [] as any;
                for (let item of _data["accreditationChain"])
                    this.accreditationChain!.push(AccreditationChainItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SkuQualificationView {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accreditationChain)) {
            data["accreditationChain"] = [];
            for (let item of this.accreditationChain)
                data["accreditationChain"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISkuQualificationView extends ISkuQualification {
    accreditationChain?: AccreditationChainItem[] | undefined;
}

export class VerificationStatus implements IVerificationStatus {
    id?: string;
    name?: string | undefined;

    constructor(data?: IVerificationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VerificationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVerificationStatus {
    id?: string;
    name?: string | undefined;
}

export class ListRequestOfSkuQualificationFilter implements IListRequestOfSkuQualificationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuQualificationFilter | undefined;

    constructor(data?: IListRequestOfSkuQualificationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuQualificationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuQualificationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuQualificationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuQualificationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuQualificationFilter | undefined;
}

export class SkuQualificationFilter extends BaseFilter implements ISkuQualificationFilter {
    qualificationId?: string | undefined;
    qualificationTypeIds?: string[] | undefined;
    professionId?: string | undefined;
    stateId?: string | undefined;
    creditSubmissionExpirationDateFrom?: Date | undefined;
    creditSubmissionExpirationDateTo?: Date | undefined;

    constructor(data?: ISkuQualificationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            if (Array.isArray(_data["qualificationTypeIds"])) {
                this.qualificationTypeIds = [] as any;
                for (let item of _data["qualificationTypeIds"])
                    this.qualificationTypeIds!.push(item);
            }
            this.professionId = _data["professionId"];
            this.stateId = _data["stateId"];
            this.creditSubmissionExpirationDateFrom = _data["creditSubmissionExpirationDateFrom"] ? new Date(_data["creditSubmissionExpirationDateFrom"].toString()) : undefined as any;
            this.creditSubmissionExpirationDateTo = _data["creditSubmissionExpirationDateTo"] ? new Date(_data["creditSubmissionExpirationDateTo"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): SkuQualificationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        if (Array.isArray(this.qualificationTypeIds)) {
            data["qualificationTypeIds"] = [];
            for (let item of this.qualificationTypeIds)
                data["qualificationTypeIds"].push(item);
        }
        data["professionId"] = this.professionId;
        data["stateId"] = this.stateId;
        data["creditSubmissionExpirationDateFrom"] = this.creditSubmissionExpirationDateFrom ? this.creditSubmissionExpirationDateFrom.toISOString() : undefined as any;
        data["creditSubmissionExpirationDateTo"] = this.creditSubmissionExpirationDateTo ? this.creditSubmissionExpirationDateTo.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuQualificationFilter extends IBaseFilter {
    qualificationId?: string | undefined;
    qualificationTypeIds?: string[] | undefined;
    professionId?: string | undefined;
    stateId?: string | undefined;
    creditSubmissionExpirationDateFrom?: Date | undefined;
    creditSubmissionExpirationDateTo?: Date | undefined;
}

export class ResponseOfListOfSkuQualificationSubjectAreaAndString implements IResponseOfListOfSkuQualificationSubjectAreaAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuQualificationSubjectArea[] | undefined;

    constructor(data?: IResponseOfListOfSkuQualificationSubjectAreaAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuQualificationSubjectArea.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuQualificationSubjectAreaAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuQualificationSubjectAreaAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuQualificationSubjectAreaAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuQualificationSubjectArea[] | undefined;
}

export class ResponseOfListOfSkuQualificationSubjectArea extends ResponseOfListOfSkuQualificationSubjectAreaAndString implements IResponseOfListOfSkuQualificationSubjectArea {

    constructor(data?: IResponseOfListOfSkuQualificationSubjectArea) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuQualificationSubjectArea {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuQualificationSubjectArea();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuQualificationSubjectArea extends IResponseOfListOfSkuQualificationSubjectAreaAndString {
}

export class ListResponseOfSkuQualificationSubjectArea extends ResponseOfListOfSkuQualificationSubjectArea implements IListResponseOfSkuQualificationSubjectArea {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuQualificationSubjectArea) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuQualificationSubjectArea {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuQualificationSubjectArea();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuQualificationSubjectArea extends IResponseOfListOfSkuQualificationSubjectArea {
    totalRecords?: number | undefined;
}

export class SkuQualificationSubjectArea implements ISkuQualificationSubjectArea {
    id?: string;
    skuQualificationId?: string;
    subjectAreaId?: string;
    subjectAreaName?: string | undefined;
    accreditorLabel?: string | undefined;
    credits?: number;
    overrides?: SkuQualificationSubjectAreaOverride[] | undefined;

    constructor(data?: ISkuQualificationSubjectArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuQualificationId = _data["skuQualificationId"];
            this.subjectAreaId = _data["subjectAreaId"];
            this.subjectAreaName = _data["subjectAreaName"];
            this.accreditorLabel = _data["accreditorLabel"];
            this.credits = _data["credits"];
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(SkuQualificationSubjectAreaOverride.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuQualificationSubjectArea {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationSubjectArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuQualificationId"] = this.skuQualificationId;
        data["subjectAreaId"] = this.subjectAreaId;
        data["subjectAreaName"] = this.subjectAreaName;
        data["accreditorLabel"] = this.accreditorLabel;
        data["credits"] = this.credits;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuQualificationSubjectArea {
    id?: string;
    skuQualificationId?: string;
    subjectAreaId?: string;
    subjectAreaName?: string | undefined;
    accreditorLabel?: string | undefined;
    credits?: number;
    overrides?: SkuQualificationSubjectAreaOverride[] | undefined;
}

export class SkuQualificationSubjectAreaOverride implements ISkuQualificationSubjectAreaOverride {
    licensureBodyId?: string;
    subjectAreaId?: string;
    subjectAreaName?: string | undefined;
    boardLabel?: string | undefined;
    credits?: number | undefined;

    constructor(data?: ISkuQualificationSubjectAreaOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensureBodyId = _data["licensureBodyId"];
            this.subjectAreaId = _data["subjectAreaId"];
            this.subjectAreaName = _data["subjectAreaName"];
            this.boardLabel = _data["boardLabel"];
            this.credits = _data["credits"];
        }
    }

    static fromJS(data: any): SkuQualificationSubjectAreaOverride {
        data = typeof data === 'object' ? data : {};
        let result = new SkuQualificationSubjectAreaOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensureBodyId"] = this.licensureBodyId;
        data["subjectAreaId"] = this.subjectAreaId;
        data["subjectAreaName"] = this.subjectAreaName;
        data["boardLabel"] = this.boardLabel;
        data["credits"] = this.credits;
        return data;
    }
}

export interface ISkuQualificationSubjectAreaOverride {
    licensureBodyId?: string;
    subjectAreaId?: string;
    subjectAreaName?: string | undefined;
    boardLabel?: string | undefined;
    credits?: number | undefined;
}

export class ResponseOfListOfSubjectAreaOptionAndString implements IResponseOfListOfSubjectAreaOptionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SubjectAreaOption[] | undefined;

    constructor(data?: IResponseOfListOfSubjectAreaOptionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SubjectAreaOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSubjectAreaOptionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSubjectAreaOptionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSubjectAreaOptionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SubjectAreaOption[] | undefined;
}

export class ResponseOfListOfSubjectAreaOption extends ResponseOfListOfSubjectAreaOptionAndString implements IResponseOfListOfSubjectAreaOption {

    constructor(data?: IResponseOfListOfSubjectAreaOption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSubjectAreaOption {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSubjectAreaOption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSubjectAreaOption extends IResponseOfListOfSubjectAreaOptionAndString {
}

export class ListResponseOfSubjectAreaOption extends ResponseOfListOfSubjectAreaOption implements IListResponseOfSubjectAreaOption {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSubjectAreaOption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSubjectAreaOption {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSubjectAreaOption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSubjectAreaOption extends IResponseOfListOfSubjectAreaOption {
    totalRecords?: number | undefined;
}

export class SubjectAreaOption implements ISubjectAreaOption {
    subjectAreaId?: string;
    name?: string | undefined;
    accreditorLabel?: string | undefined;

    constructor(data?: ISubjectAreaOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectAreaId = _data["subjectAreaId"];
            this.name = _data["name"];
            this.accreditorLabel = _data["accreditorLabel"];
        }
    }

    static fromJS(data: any): SubjectAreaOption {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectAreaOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectAreaId"] = this.subjectAreaId;
        data["name"] = this.name;
        data["accreditorLabel"] = this.accreditorLabel;
        return data;
    }
}

export interface ISubjectAreaOption {
    subjectAreaId?: string;
    name?: string | undefined;
    accreditorLabel?: string | undefined;
}

export class ResponseOfListOfLicensureBodySubjectAreaOptionAndString implements IResponseOfListOfLicensureBodySubjectAreaOptionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicensureBodySubjectAreaOption[] | undefined;

    constructor(data?: IResponseOfListOfLicensureBodySubjectAreaOptionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LicensureBodySubjectAreaOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfLicensureBodySubjectAreaOptionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLicensureBodySubjectAreaOptionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfLicensureBodySubjectAreaOptionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LicensureBodySubjectAreaOption[] | undefined;
}

export class ResponseOfListOfLicensureBodySubjectAreaOption extends ResponseOfListOfLicensureBodySubjectAreaOptionAndString implements IResponseOfListOfLicensureBodySubjectAreaOption {

    constructor(data?: IResponseOfListOfLicensureBodySubjectAreaOption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfLicensureBodySubjectAreaOption {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLicensureBodySubjectAreaOption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfLicensureBodySubjectAreaOption extends IResponseOfListOfLicensureBodySubjectAreaOptionAndString {
}

export class ListResponseOfLicensureBodySubjectAreaOption extends ResponseOfListOfLicensureBodySubjectAreaOption implements IListResponseOfLicensureBodySubjectAreaOption {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfLicensureBodySubjectAreaOption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfLicensureBodySubjectAreaOption {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfLicensureBodySubjectAreaOption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfLicensureBodySubjectAreaOption extends IResponseOfListOfLicensureBodySubjectAreaOption {
    totalRecords?: number | undefined;
}

export class LicensureBodySubjectAreaOption implements ILicensureBodySubjectAreaOption {
    licensureBodyId?: string;
    subjectAreaId?: string;
    name?: string | undefined;
    boardLabel?: string | undefined;

    constructor(data?: ILicensureBodySubjectAreaOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensureBodyId = _data["licensureBodyId"];
            this.subjectAreaId = _data["subjectAreaId"];
            this.name = _data["name"];
            this.boardLabel = _data["boardLabel"];
        }
    }

    static fromJS(data: any): LicensureBodySubjectAreaOption {
        data = typeof data === 'object' ? data : {};
        let result = new LicensureBodySubjectAreaOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensureBodyId"] = this.licensureBodyId;
        data["subjectAreaId"] = this.subjectAreaId;
        data["name"] = this.name;
        data["boardLabel"] = this.boardLabel;
        return data;
    }
}

export interface ILicensureBodySubjectAreaOption {
    licensureBodyId?: string;
    subjectAreaId?: string;
    name?: string | undefined;
    boardLabel?: string | undefined;
}

export class ResponseOfListOfSkuRelationshipAndString implements IResponseOfListOfSkuRelationshipAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuRelationship[] | undefined;

    constructor(data?: IResponseOfListOfSkuRelationshipAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuRelationship.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuRelationshipAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuRelationshipAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuRelationshipAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuRelationship[] | undefined;
}

export class ResponseOfListOfSkuRelationship extends ResponseOfListOfSkuRelationshipAndString implements IResponseOfListOfSkuRelationship {

    constructor(data?: IResponseOfListOfSkuRelationship) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuRelationship {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuRelationship();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuRelationship extends IResponseOfListOfSkuRelationshipAndString {
}

export class ListResponseOfSkuRelationship extends ResponseOfListOfSkuRelationship implements IListResponseOfSkuRelationship {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuRelationship) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuRelationship {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuRelationship();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuRelationship extends IResponseOfListOfSkuRelationship {
    totalRecords?: number | undefined;
}

export class SkuRelationship implements ISkuRelationship {
    id!: string;
    parentSkuId!: string;
    childSkuId!: string;
    name?: string | undefined;
    title?: string | undefined;
    skuRelationshipTypeId!: string;
    skuRelationshipTypeName?: string | undefined;
    sequence?: number;
    isBidirectional?: boolean;

    constructor(data?: ISkuRelationship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentSkuId = _data["parentSkuId"];
            this.childSkuId = _data["childSkuId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.skuRelationshipTypeId = _data["skuRelationshipTypeId"];
            this.skuRelationshipTypeName = _data["skuRelationshipTypeName"];
            this.sequence = _data["sequence"];
            this.isBidirectional = _data["isBidirectional"];
        }
    }

    static fromJS(data: any): SkuRelationship {
        data = typeof data === 'object' ? data : {};
        let result = new SkuRelationship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentSkuId"] = this.parentSkuId;
        data["childSkuId"] = this.childSkuId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["skuRelationshipTypeId"] = this.skuRelationshipTypeId;
        data["skuRelationshipTypeName"] = this.skuRelationshipTypeName;
        data["sequence"] = this.sequence;
        data["isBidirectional"] = this.isBidirectional;
        return data;
    }
}

export interface ISkuRelationship {
    id: string;
    parentSkuId: string;
    childSkuId: string;
    name?: string | undefined;
    title?: string | undefined;
    skuRelationshipTypeId: string;
    skuRelationshipTypeName?: string | undefined;
    sequence?: number;
    isBidirectional?: boolean;
}

export class ListRequestOfSkuRelationshipFilter implements IListRequestOfSkuRelationshipFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuRelationshipFilter | undefined;

    constructor(data?: IListRequestOfSkuRelationshipFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuRelationshipFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuRelationshipFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuRelationshipFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuRelationshipFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuRelationshipFilter | undefined;
}

export class SkuRelationshipFilter extends BaseFilter implements ISkuRelationshipFilter {
    skuId?: string;
    skuRelationshipTypeId?: string;

    constructor(data?: ISkuRelationshipFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuId = _data["skuId"];
            this.skuRelationshipTypeId = _data["skuRelationshipTypeId"];
        }
    }

    static override fromJS(data: any): SkuRelationshipFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuRelationshipFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["skuRelationshipTypeId"] = this.skuRelationshipTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuRelationshipFilter extends IBaseFilter {
    skuId?: string;
    skuRelationshipTypeId?: string;
}

export class SkuRelationshipRequest implements ISkuRelationshipRequest {
    parentSkuId?: string;
    childSkuId?: string;
    skuRelationshipTypeId!: string;

    constructor(data?: ISkuRelationshipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentSkuId = _data["parentSkuId"];
            this.childSkuId = _data["childSkuId"];
            this.skuRelationshipTypeId = _data["skuRelationshipTypeId"];
        }
    }

    static fromJS(data: any): SkuRelationshipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuRelationshipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentSkuId"] = this.parentSkuId;
        data["childSkuId"] = this.childSkuId;
        data["skuRelationshipTypeId"] = this.skuRelationshipTypeId;
        return data;
    }
}

export interface ISkuRelationshipRequest {
    parentSkuId?: string;
    childSkuId?: string;
    skuRelationshipTypeId: string;
}

export class ResponseOfListOfSkuRelationshipTypeAndString implements IResponseOfListOfSkuRelationshipTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuRelationshipType[] | undefined;

    constructor(data?: IResponseOfListOfSkuRelationshipTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuRelationshipType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuRelationshipTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuRelationshipTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuRelationshipTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuRelationshipType[] | undefined;
}

export class ResponseOfListOfSkuRelationshipType extends ResponseOfListOfSkuRelationshipTypeAndString implements IResponseOfListOfSkuRelationshipType {

    constructor(data?: IResponseOfListOfSkuRelationshipType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuRelationshipType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuRelationshipType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuRelationshipType extends IResponseOfListOfSkuRelationshipTypeAndString {
}

export class ListResponseOfSkuRelationshipType extends ResponseOfListOfSkuRelationshipType implements IListResponseOfSkuRelationshipType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuRelationshipType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuRelationshipType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuRelationshipType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuRelationshipType extends IResponseOfListOfSkuRelationshipType {
    totalRecords?: number | undefined;
}

export class SkuRelationshipType implements ISkuRelationshipType {
    id?: string;
    name?: string | undefined;
    isBidirectional?: boolean;

    constructor(data?: ISkuRelationshipType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isBidirectional = _data["isBidirectional"];
        }
    }

    static fromJS(data: any): SkuRelationshipType {
        data = typeof data === 'object' ? data : {};
        let result = new SkuRelationshipType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isBidirectional"] = this.isBidirectional;
        return data;
    }
}

export interface ISkuRelationshipType {
    id?: string;
    name?: string | undefined;
    isBidirectional?: boolean;
}

export class SkuRelationshipSequenceRequest implements ISkuRelationshipSequenceRequest {
    skuRelationshipId?: string;
    skuRelationshipTypeId?: string;
    sequence?: number;

    constructor(data?: ISkuRelationshipSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuRelationshipId = _data["skuRelationshipId"];
            this.skuRelationshipTypeId = _data["skuRelationshipTypeId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): SkuRelationshipSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuRelationshipSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuRelationshipId"] = this.skuRelationshipId;
        data["skuRelationshipTypeId"] = this.skuRelationshipTypeId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface ISkuRelationshipSequenceRequest {
    skuRelationshipId?: string;
    skuRelationshipTypeId?: string;
    sequence?: number;
}

export class ResponseOfListOfSkuResourceAndString implements IResponseOfListOfSkuResourceAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuResource[] | undefined;

    constructor(data?: IResponseOfListOfSkuResourceAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuResourceAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuResourceAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuResourceAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuResource[] | undefined;
}

export class ResponseOfListOfSkuResource extends ResponseOfListOfSkuResourceAndString implements IResponseOfListOfSkuResource {

    constructor(data?: IResponseOfListOfSkuResource) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuResource {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuResource();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuResource extends IResponseOfListOfSkuResourceAndString {
}

export class ListResponseOfSkuResource extends ResponseOfListOfSkuResource implements IListResponseOfSkuResource {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuResource) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuResource {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuResource();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuResource extends IResponseOfListOfSkuResource {
    totalRecords?: number | undefined;
}

export class SkuResource implements ISkuResource {
    id?: string;
    skuId?: string;
    resource?: Resource | undefined;
    resourceType?: ResourceType | undefined;
    sequence?: number;
    skuUserAgreements?: SkuUserAgreementInfo[] | undefined;
    isSkuUserAgreementPending?: boolean;
    isSkuUserAgreementAccepted?: boolean;
    hasOrganizationUserId?: boolean;

    constructor(data?: ISkuResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.resource = _data["resource"] ? Resource.fromJS(_data["resource"]) : undefined as any;
            this.resourceType = _data["resourceType"] ? ResourceType.fromJS(_data["resourceType"]) : undefined as any;
            this.sequence = _data["sequence"];
            if (Array.isArray(_data["skuUserAgreements"])) {
                this.skuUserAgreements = [] as any;
                for (let item of _data["skuUserAgreements"])
                    this.skuUserAgreements!.push(SkuUserAgreementInfo.fromJS(item));
            }
            this.isSkuUserAgreementPending = _data["isSkuUserAgreementPending"];
            this.isSkuUserAgreementAccepted = _data["isSkuUserAgreementAccepted"];
            this.hasOrganizationUserId = _data["hasOrganizationUserId"];
        }
    }

    static fromJS(data: any): SkuResource {
        data = typeof data === 'object' ? data : {};
        let result = new SkuResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["resource"] = this.resource ? this.resource.toJSON() : undefined as any;
        data["resourceType"] = this.resourceType ? this.resourceType.toJSON() : undefined as any;
        data["sequence"] = this.sequence;
        if (Array.isArray(this.skuUserAgreements)) {
            data["skuUserAgreements"] = [];
            for (let item of this.skuUserAgreements)
                data["skuUserAgreements"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSkuUserAgreementPending"] = this.isSkuUserAgreementPending;
        data["isSkuUserAgreementAccepted"] = this.isSkuUserAgreementAccepted;
        data["hasOrganizationUserId"] = this.hasOrganizationUserId;
        return data;
    }
}

export interface ISkuResource {
    id?: string;
    skuId?: string;
    resource?: Resource | undefined;
    resourceType?: ResourceType | undefined;
    sequence?: number;
    skuUserAgreements?: SkuUserAgreementInfo[] | undefined;
    isSkuUserAgreementPending?: boolean;
    isSkuUserAgreementAccepted?: boolean;
    hasOrganizationUserId?: boolean;
}

export class Resource implements IResource {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    organizationUserId?: string | undefined;

    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["organizationUserId"] = this.organizationUserId;
        return data;
    }
}

export interface IResource {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    organizationUserId?: string | undefined;
}

export class ResourceType implements IResourceType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IResourceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ResourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IResourceType {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
}

export class SkuResourceRequest implements ISkuResourceRequest {
    resourceId!: string;
    resourceTypeId!: string;

    constructor(data?: ISkuResourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.resourceTypeId = _data["resourceTypeId"];
        }
    }

    static fromJS(data: any): SkuResourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuResourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["resourceTypeId"] = this.resourceTypeId;
        return data;
    }
}

export interface ISkuResourceRequest {
    resourceId: string;
    resourceTypeId: string;
}

export class SkuResourceSequenceRequest implements ISkuResourceSequenceRequest {
    skuResourceId?: string;
    sequence?: number;

    constructor(data?: ISkuResourceSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuResourceId = _data["skuResourceId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): SkuResourceSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuResourceSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuResourceId"] = this.skuResourceId;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface ISkuResourceSequenceRequest {
    skuResourceId?: string;
    sequence?: number;
}

export class ResponseOfListOfResourceTypeAndString implements IResponseOfListOfResourceTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceType[] | undefined;

    constructor(data?: IResponseOfListOfResourceTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceType[] | undefined;
}

export class ResponseOfListOfResourceType extends ResponseOfListOfResourceTypeAndString implements IResponseOfListOfResourceType {

    constructor(data?: IResponseOfListOfResourceType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceType extends IResponseOfListOfResourceTypeAndString {
}

export class ListResponseOfResourceType extends ResponseOfListOfResourceType implements IListResponseOfResourceType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResourceType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceType extends IResponseOfListOfResourceType {
    totalRecords?: number | undefined;
}

export class ResponseOfSkuStatusAndString implements IResponseOfSkuStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuStatus | undefined;

    constructor(data?: IResponseOfSkuStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SkuStatus.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSkuStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSkuStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuStatus | undefined;
}

export class ResponseOfSkuStatus extends ResponseOfSkuStatusAndString implements IResponseOfSkuStatus {

    constructor(data?: IResponseOfSkuStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSkuStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSkuStatus extends IResponseOfSkuStatusAndString {
}

export class SkuStatus implements ISkuStatus {
    id?: string;
    name?: string | undefined;
    displayOrder?: number;

    constructor(data?: ISkuStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): SkuStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SkuStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ISkuStatus {
    id?: string;
    name?: string | undefined;
    displayOrder?: number;
}

export class ResponseOfListOfSkuStatusAndString implements IResponseOfListOfSkuStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuStatus[] | undefined;

    constructor(data?: IResponseOfListOfSkuStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuStatus[] | undefined;
}

export class ResponseOfListOfSkuStatus extends ResponseOfListOfSkuStatusAndString implements IResponseOfListOfSkuStatus {

    constructor(data?: IResponseOfListOfSkuStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuStatus extends IResponseOfListOfSkuStatusAndString {
}

export class ListResponseOfSkuStatus extends ResponseOfListOfSkuStatus implements IListResponseOfSkuStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuStatus extends IResponseOfListOfSkuStatus {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfSkuStudyFieldAndString implements IResponseOfListOfSkuStudyFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuStudyField[] | undefined;

    constructor(data?: IResponseOfListOfSkuStudyFieldAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuStudyField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuStudyFieldAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuStudyFieldAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuStudyFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuStudyField[] | undefined;
}

export class ResponseOfListOfSkuStudyField extends ResponseOfListOfSkuStudyFieldAndString implements IResponseOfListOfSkuStudyField {

    constructor(data?: IResponseOfListOfSkuStudyField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuStudyField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuStudyField extends IResponseOfListOfSkuStudyFieldAndString {
}

export class ListResponseOfSkuStudyField extends ResponseOfListOfSkuStudyField implements IListResponseOfSkuStudyField {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuStudyField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuStudyField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuStudyField extends IResponseOfListOfSkuStudyField {
    totalRecords?: number | undefined;
}

export class SkuStudyField implements ISkuStudyField {
    id?: string;
    skuId?: string;
    credits?: number | undefined;
    studyField?: StudyField | undefined;

    constructor(data?: ISkuStudyField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.credits = _data["credits"];
            this.studyField = _data["studyField"] ? StudyField.fromJS(_data["studyField"]) : undefined as any;
        }
    }

    static fromJS(data: any): SkuStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new SkuStudyField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["credits"] = this.credits;
        data["studyField"] = this.studyField ? this.studyField.toJSON() : undefined as any;
        return data;
    }
}

export interface ISkuStudyField {
    id?: string;
    skuId?: string;
    credits?: number | undefined;
    studyField?: StudyField | undefined;
}

export class StudyField implements IStudyField {
    id?: string;
    name?: string | undefined;
    migrationSourceId?: string | undefined;
    externalSourceId?: string | undefined;
    qualificationIds?: string[] | undefined;

    constructor(data?: IStudyField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.migrationSourceId = _data["migrationSourceId"];
            this.externalSourceId = _data["externalSourceId"];
            if (Array.isArray(_data["qualificationIds"])) {
                this.qualificationIds = [] as any;
                for (let item of _data["qualificationIds"])
                    this.qualificationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyField {
        data = typeof data === 'object' ? data : {};
        let result = new StudyField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["migrationSourceId"] = this.migrationSourceId;
        data["externalSourceId"] = this.externalSourceId;
        if (Array.isArray(this.qualificationIds)) {
            data["qualificationIds"] = [];
            for (let item of this.qualificationIds)
                data["qualificationIds"].push(item);
        }
        return data;
    }
}

export interface IStudyField {
    id?: string;
    name?: string | undefined;
    migrationSourceId?: string | undefined;
    externalSourceId?: string | undefined;
    qualificationIds?: string[] | undefined;
}

export class ListRequestOfSkuStudyFieldFilter implements IListRequestOfSkuStudyFieldFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuStudyFieldFilter | undefined;

    constructor(data?: IListRequestOfSkuStudyFieldFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? SkuStudyFieldFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfSkuStudyFieldFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfSkuStudyFieldFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfSkuStudyFieldFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: SkuStudyFieldFilter | undefined;
}

export class SkuStudyFieldFilter extends BaseFilter implements ISkuStudyFieldFilter {
    studyFieldId?: string | undefined;

    constructor(data?: ISkuStudyFieldFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyFieldId = _data["studyFieldId"];
        }
    }

    static override fromJS(data: any): SkuStudyFieldFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SkuStudyFieldFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyFieldId"] = this.studyFieldId;
        super.toJSON(data);
        return data;
    }
}

export interface ISkuStudyFieldFilter extends IBaseFilter {
    studyFieldId?: string | undefined;
}

export class SkuStudyFieldRequest implements ISkuStudyFieldRequest {
    credits?: number | undefined;
    studyFieldId?: string;
    id?: string | undefined;

    constructor(data?: ISkuStudyFieldRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.credits = _data["credits"];
            this.studyFieldId = _data["studyFieldId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SkuStudyFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuStudyFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["credits"] = this.credits;
        data["studyFieldId"] = this.studyFieldId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISkuStudyFieldRequest {
    credits?: number | undefined;
    studyFieldId?: string;
    id?: string | undefined;
}

export class ResponseOfListOfStudyFieldAndString implements IResponseOfListOfStudyFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: StudyField[] | undefined;

    constructor(data?: IResponseOfListOfStudyFieldAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudyField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfStudyFieldAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfStudyFieldAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfStudyFieldAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: StudyField[] | undefined;
}

export class ResponseOfListOfStudyField extends ResponseOfListOfStudyFieldAndString implements IResponseOfListOfStudyField {

    constructor(data?: IResponseOfListOfStudyField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfStudyField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfStudyField extends IResponseOfListOfStudyFieldAndString {
}

export class ListResponseOfStudyField extends ResponseOfListOfStudyField implements IListResponseOfStudyField {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfStudyField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfStudyField {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfStudyField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfStudyField extends IResponseOfListOfStudyField {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfSkuTagAndString implements IResponseOfListOfSkuTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuTag[] | undefined;

    constructor(data?: IResponseOfListOfSkuTagAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuTagAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuTagAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SkuTag[] | undefined;
}

export class ResponseOfListOfSkuTag extends ResponseOfListOfSkuTagAndString implements IResponseOfListOfSkuTag {

    constructor(data?: IResponseOfListOfSkuTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuTag {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuTag extends IResponseOfListOfSkuTagAndString {
}

export class ListResponseOfSkuTag extends ResponseOfListOfSkuTag implements IListResponseOfSkuTag {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSkuTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuTag {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuTag extends IResponseOfListOfSkuTag {
    totalRecords?: number | undefined;
}

export class SkuTag implements ISkuTag {
    id?: string;
    skuId?: string;
    tag?: Tag | undefined;

    constructor(data?: ISkuTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : undefined as any;
        }
    }

    static fromJS(data: any): SkuTag {
        data = typeof data === 'object' ? data : {};
        let result = new SkuTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        return data;
    }
}

export interface ISkuTag {
    id?: string;
    skuId?: string;
    tag?: Tag | undefined;
}

export class ResponseOfTagAndString implements IResponseOfTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Tag | undefined;

    constructor(data?: IResponseOfTagAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Tag.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfTagAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfTagAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfTagAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Tag | undefined;
}

export class ResponseOfTag extends ResponseOfTagAndString implements IResponseOfTag {

    constructor(data?: IResponseOfTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfTag {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfTag extends IResponseOfTagAndString {
}

export class SkuTagRequest implements ISkuTagRequest {
    name!: string;

    constructor(data?: ISkuTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SkuTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISkuTagRequest {
    name: string;
}

export class SaveModule implements ISaveModule {
    id?: string | undefined;
    name!: string;
    quantity?: number | undefined;

    constructor(data?: ISaveModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): SaveModule {
        data = typeof data === 'object' ? data : {};
        let result = new SaveModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ISaveModule {
    id?: string | undefined;
    name: string;
    quantity?: number | undefined;
}

export class SaveRequirement implements ISaveRequirement {
    id?: string | undefined;
    productId!: string;
    skuFormatId?: string | undefined;

    constructor(data?: ISaveRequirement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.skuFormatId = _data["skuFormatId"];
        }
    }

    static fromJS(data: any): SaveRequirement {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRequirement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["skuFormatId"] = this.skuFormatId;
        return data;
    }
}

export interface ISaveRequirement {
    id?: string | undefined;
    productId: string;
    skuFormatId?: string | undefined;
}

export class ResponseOfListOfSeriesItemAndString implements IResponseOfListOfSeriesItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SeriesItem[] | undefined;

    constructor(data?: IResponseOfListOfSeriesItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SeriesItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSeriesItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSeriesItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSeriesItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SeriesItem[] | undefined;
}

export class ResponseOfListOfSeriesItem extends ResponseOfListOfSeriesItemAndString implements IResponseOfListOfSeriesItem {

    constructor(data?: IResponseOfListOfSeriesItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSeriesItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSeriesItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSeriesItem extends IResponseOfListOfSeriesItemAndString {
}

export class ListResponseOfSeriesItem extends ResponseOfListOfSeriesItem implements IListResponseOfSeriesItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfSeriesItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSeriesItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSeriesItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSeriesItem extends IResponseOfListOfSeriesItem {
    totalRecords?: number | undefined;
}

export class SeriesItem implements ISeriesItem {
    id!: string;
    sku!: string;
    seriesTitle!: string;
    description?: string | undefined;
    priorRequirementRequired?: boolean;
    ownerOrganizationId?: string;

    constructor(data?: ISeriesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sku = _data["sku"];
            this.seriesTitle = _data["seriesTitle"];
            this.description = _data["description"];
            this.priorRequirementRequired = _data["priorRequirementRequired"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
        }
    }

    static fromJS(data: any): SeriesItem {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sku"] = this.sku;
        data["seriesTitle"] = this.seriesTitle;
        data["description"] = this.description;
        data["priorRequirementRequired"] = this.priorRequirementRequired;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        return data;
    }
}

export interface ISeriesItem {
    id: string;
    sku: string;
    seriesTitle: string;
    description?: string | undefined;
    priorRequirementRequired?: boolean;
    ownerOrganizationId?: string;
}

export class ResponseOfSeriesAndString implements IResponseOfSeriesAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Series | undefined;

    constructor(data?: IResponseOfSeriesAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Series.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSeriesAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSeriesAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSeriesAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Series | undefined;
}

export class ResponseOfSeries extends ResponseOfSeriesAndString implements IResponseOfSeries {

    constructor(data?: IResponseOfSeries) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSeries {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSeries();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSeries extends IResponseOfSeriesAndString {
}

export class Series extends SeriesItem implements ISeries {
    modules?: Module[] | undefined;

    constructor(data?: ISeries) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Series {
        data = typeof data === 'object' ? data : {};
        let result = new Series();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISeries extends ISeriesItem {
    modules?: Module[] | undefined;
}

export class Module implements IModule {
    id!: string;
    seriesId!: string;
    name!: string;
    sequence?: number | undefined;
    quantity?: number | undefined;
    requirements?: Requirement[] | undefined;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seriesId = _data["seriesId"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements!.push(Requirement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seriesId"] = this.seriesId;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModule {
    id: string;
    seriesId: string;
    name: string;
    sequence?: number | undefined;
    quantity?: number | undefined;
    requirements?: Requirement[] | undefined;
}

export class Requirement implements IRequirement {
    id!: string;
    moduleId!: string;
    productId!: string;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productName!: string;
    skuFormatName?: string | undefined;
    skuAvailabilityName?: string | undefined;
    sequence?: number | undefined;

    constructor(data?: IRequirement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moduleId = _data["moduleId"];
            this.productId = _data["productId"];
            this.skuFormatId = _data["skuFormatId"];
            this.skuAvailabilityId = _data["skuAvailabilityId"];
            this.productName = _data["productName"];
            this.skuFormatName = _data["skuFormatName"];
            this.skuAvailabilityName = _data["skuAvailabilityName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): Requirement {
        data = typeof data === 'object' ? data : {};
        let result = new Requirement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moduleId"] = this.moduleId;
        data["productId"] = this.productId;
        data["skuFormatId"] = this.skuFormatId;
        data["skuAvailabilityId"] = this.skuAvailabilityId;
        data["productName"] = this.productName;
        data["skuFormatName"] = this.skuFormatName;
        data["skuAvailabilityName"] = this.skuAvailabilityName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IRequirement {
    id: string;
    moduleId: string;
    productId: string;
    skuFormatId?: string | undefined;
    skuAvailabilityId?: string | undefined;
    productName: string;
    skuFormatName?: string | undefined;
    skuAvailabilityName?: string | undefined;
    sequence?: number | undefined;
}

export class SavePriorRequirementRequiredRequest implements ISavePriorRequirementRequiredRequest {
    seriesId?: string;
    priorRequirementRequired?: boolean;

    constructor(data?: ISavePriorRequirementRequiredRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.priorRequirementRequired = _data["priorRequirementRequired"];
        }
    }

    static fromJS(data: any): SavePriorRequirementRequiredRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePriorRequirementRequiredRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["priorRequirementRequired"] = this.priorRequirementRequired;
        return data;
    }
}

export interface ISavePriorRequirementRequiredRequest {
    seriesId?: string;
    priorRequirementRequired?: boolean;
}

export class ResourceRequestV2 implements IResourceRequestV2 {
    id?: string | undefined;
    name!: string;
    value!: string;
    bio?: string | undefined;
    prefix?: string | undefined;
    summary?: string | undefined;
    mediaLibraryItemId?: string | undefined;
    crmEmail?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IResourceRequestV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.bio = _data["bio"];
            this.prefix = _data["prefix"];
            this.summary = _data["summary"];
            this.mediaLibraryItemId = _data["mediaLibraryItemId"];
            this.crmEmail = _data["crmEmail"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ResourceRequestV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceRequestV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["bio"] = this.bio;
        data["prefix"] = this.prefix;
        data["summary"] = this.summary;
        data["mediaLibraryItemId"] = this.mediaLibraryItemId;
        data["crmEmail"] = this.crmEmail;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IResourceRequestV2 {
    id?: string | undefined;
    name: string;
    value: string;
    bio?: string | undefined;
    prefix?: string | undefined;
    summary?: string | undefined;
    mediaLibraryItemId?: string | undefined;
    crmEmail?: string | undefined;
    organizationId?: string | undefined;
}

export class ResponseOfListOfResourceV2ListItemAndString implements IResponseOfListOfResourceV2ListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceV2ListItem[] | undefined;

    constructor(data?: IResponseOfListOfResourceV2ListItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceV2ListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceV2ListItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceV2ListItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceV2ListItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceV2ListItem[] | undefined;
}

export class ResponseOfListOfResourceV2ListItem extends ResponseOfListOfResourceV2ListItemAndString implements IResponseOfListOfResourceV2ListItem {

    constructor(data?: IResponseOfListOfResourceV2ListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceV2ListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceV2ListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceV2ListItem extends IResponseOfListOfResourceV2ListItemAndString {
}

export class ListResponseOfResourceV2ListItem extends ResponseOfListOfResourceV2ListItem implements IListResponseOfResourceV2ListItem {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfResourceV2ListItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceV2ListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceV2ListItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceV2ListItem extends IResponseOfListOfResourceV2ListItem {
    totalRecords?: number | undefined;
}

export class ResourceV2ListItem implements IResourceV2ListItem {
    id!: string;
    name?: string | undefined;
    prefix?: string | undefined;
    organizationName?: string | undefined;
    organizationId?: string;
    organizationUserId?: string | undefined;

    constructor(data?: IResourceV2ListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            this.organizationName = _data["organizationName"];
            this.organizationId = _data["organizationId"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static fromJS(data: any): ResourceV2ListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceV2ListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["organizationName"] = this.organizationName;
        data["organizationId"] = this.organizationId;
        data["organizationUserId"] = this.organizationUserId;
        return data;
    }
}

export interface IResourceV2ListItem {
    id: string;
    name?: string | undefined;
    prefix?: string | undefined;
    organizationName?: string | undefined;
    organizationId?: string;
    organizationUserId?: string | undefined;
}

export class ListRequestOfResourceFilterV2 implements IListRequestOfResourceFilterV2 {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ResourceFilterV2 | undefined;

    constructor(data?: IListRequestOfResourceFilterV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ResourceFilterV2.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfResourceFilterV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfResourceFilterV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfResourceFilterV2 {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ResourceFilterV2 | undefined;
}

export class ResourceFilterV2 extends BaseFilter implements IResourceFilterV2 {
    isLinkedWithUser?: boolean | undefined;
    hasAnySkuUserAgreement?: boolean | undefined;
    organizationUserId?: string | undefined;
    skuId?: string | undefined;

    constructor(data?: IResourceFilterV2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isLinkedWithUser = _data["isLinkedWithUser"];
            this.hasAnySkuUserAgreement = _data["hasAnySkuUserAgreement"];
            this.organizationUserId = _data["organizationUserId"];
            this.skuId = _data["skuId"];
        }
    }

    static override fromJS(data: any): ResourceFilterV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceFilterV2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLinkedWithUser"] = this.isLinkedWithUser;
        data["hasAnySkuUserAgreement"] = this.hasAnySkuUserAgreement;
        data["organizationUserId"] = this.organizationUserId;
        data["skuId"] = this.skuId;
        super.toJSON(data);
        return data;
    }
}

export interface IResourceFilterV2 extends IBaseFilter {
    isLinkedWithUser?: boolean | undefined;
    hasAnySkuUserAgreement?: boolean | undefined;
    organizationUserId?: string | undefined;
    skuId?: string | undefined;
}

export class ResponseOfResourceV2AndString implements IResponseOfResourceV2AndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceV2 | undefined;

    constructor(data?: IResponseOfResourceV2AndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ResourceV2.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfResourceV2AndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfResourceV2AndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfResourceV2AndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ResourceV2 | undefined;
}

export class ResponseOfResourceV2 extends ResponseOfResourceV2AndString implements IResponseOfResourceV2 {

    constructor(data?: IResponseOfResourceV2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfResourceV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfResourceV2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfResourceV2 extends IResponseOfResourceV2AndString {
}

export class ResourceV2 implements IResourceV2 {
    id!: string;
    name!: string;
    prefix?: string | undefined;
    bio?: string | undefined;
    summary?: string | undefined;
    mediaLibraryItemId?: string | undefined;
    crmEmail?: string | undefined;
    crmId?: string | undefined;
    organizationName?: string | undefined;
    organizationId?: string;
    organizationUserId?: string | undefined;
    hasSkus?: boolean;

    constructor(data?: IResourceV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            this.bio = _data["bio"];
            this.summary = _data["summary"];
            this.mediaLibraryItemId = _data["mediaLibraryItemId"];
            this.crmEmail = _data["crmEmail"];
            this.crmId = _data["crmId"];
            this.organizationName = _data["organizationName"];
            this.organizationId = _data["organizationId"];
            this.organizationUserId = _data["organizationUserId"];
            this.hasSkus = _data["hasSkus"];
        }
    }

    static fromJS(data: any): ResourceV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["bio"] = this.bio;
        data["summary"] = this.summary;
        data["mediaLibraryItemId"] = this.mediaLibraryItemId;
        data["crmEmail"] = this.crmEmail;
        data["crmId"] = this.crmId;
        data["organizationName"] = this.organizationName;
        data["organizationId"] = this.organizationId;
        data["organizationUserId"] = this.organizationUserId;
        data["hasSkus"] = this.hasSkus;
        return data;
    }
}

export interface IResourceV2 {
    id: string;
    name: string;
    prefix?: string | undefined;
    bio?: string | undefined;
    summary?: string | undefined;
    mediaLibraryItemId?: string | undefined;
    crmEmail?: string | undefined;
    crmId?: string | undefined;
    organizationName?: string | undefined;
    organizationId?: string;
    organizationUserId?: string | undefined;
    hasSkus?: boolean;
}

export class SaveUserResponse extends SaveResponse implements ISaveUserResponse {
    userAccountId?: string;

    constructor(data?: ISaveUserResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userAccountId = _data["userAccountId"];
        }
    }

    static override fromJS(data: any): SaveUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userAccountId"] = this.userAccountId;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveUserResponse extends ISaveResponse {
    userAccountId?: string;
}

export class LinkFacultyPortalUserRequest implements ILinkFacultyPortalUserRequest {
    resourceId!: string;
    firstName!: string;
    lastName!: string;
    email!: string;

    constructor(data?: ILinkFacultyPortalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): LinkFacultyPortalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkFacultyPortalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface ILinkFacultyPortalUserRequest {
    resourceId: string;
    firstName: string;
    lastName: string;
    email: string;
}

export class AdminLinkFacultyPortalUserRequest extends LinkFacultyPortalUserRequest implements IAdminLinkFacultyPortalUserRequest {
    organizationId?: string;

    constructor(data?: IAdminLinkFacultyPortalUserRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminLinkFacultyPortalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminLinkFacultyPortalUserRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminLinkFacultyPortalUserRequest extends ILinkFacultyPortalUserRequest {
    organizationId?: string;
}

export class AdminUnlinkFacultyPortalUserRequest implements IAdminUnlinkFacultyPortalUserRequest {
    resourceId?: string;
    organizationId?: string;

    constructor(data?: IAdminUnlinkFacultyPortalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): AdminUnlinkFacultyPortalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUnlinkFacultyPortalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IAdminUnlinkFacultyPortalUserRequest {
    resourceId?: string;
    organizationId?: string;
}

export class HasPendingOrAcceptedAgreementRequest implements IHasPendingOrAcceptedAgreementRequest {
    skuId!: string;
    agreementId!: string;
    organizationUserId!: string;

    constructor(data?: IHasPendingOrAcceptedAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.agreementId = _data["agreementId"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static fromJS(data: any): HasPendingOrAcceptedAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HasPendingOrAcceptedAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["agreementId"] = this.agreementId;
        data["organizationUserId"] = this.organizationUserId;
        return data;
    }
}

export interface IHasPendingOrAcceptedAgreementRequest {
    skuId: string;
    agreementId: string;
    organizationUserId: string;
}

export class ResponseOfListOfProgressionGateTypeAndString implements IResponseOfListOfProgressionGateTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProgressionGateType[] | undefined;

    constructor(data?: IResponseOfListOfProgressionGateTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProgressionGateType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProgressionGateTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProgressionGateTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProgressionGateTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProgressionGateType[] | undefined;
}

export class ResponseOfListOfProgressionGateType extends ResponseOfListOfProgressionGateTypeAndString implements IResponseOfListOfProgressionGateType {

    constructor(data?: IResponseOfListOfProgressionGateType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProgressionGateType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProgressionGateType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProgressionGateType extends IResponseOfListOfProgressionGateTypeAndString {
}

export class ListResponseOfProgressionGateType extends ResponseOfListOfProgressionGateType implements IListResponseOfProgressionGateType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProgressionGateType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProgressionGateType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProgressionGateType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProgressionGateType extends IResponseOfListOfProgressionGateType {
    totalRecords?: number | undefined;
}

export class ProgressionGateType implements IProgressionGateType {
    id?: string;
    name?: string | undefined;
    sequence?: number;

    constructor(data?: IProgressionGateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): ProgressionGateType {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressionGateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IProgressionGateType {
    id?: string;
    name?: string | undefined;
    sequence?: number;
}

export class ListRequestOfProgressionGateTypeFilter implements IListRequestOfProgressionGateTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProgressionGateTypeFilter | undefined;

    constructor(data?: IListRequestOfProgressionGateTypeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ProgressionGateTypeFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfProgressionGateTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfProgressionGateTypeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfProgressionGateTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProgressionGateTypeFilter | undefined;
}

export class ProgressionGateTypeFilter extends BaseFilter implements IProgressionGateTypeFilter {
    includeGateTypeNone?: boolean;

    constructor(data?: IProgressionGateTypeFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.includeGateTypeNone = _data["includeGateTypeNone"];
        }
    }

    static override fromJS(data: any): ProgressionGateTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressionGateTypeFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeGateTypeNone"] = this.includeGateTypeNone;
        super.toJSON(data);
        return data;
    }
}

export interface IProgressionGateTypeFilter extends IBaseFilter {
    includeGateTypeNone?: boolean;
}

export class ResponseOfListOfProductAndString implements IResponseOfListOfProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Product[] | undefined;

    constructor(data?: IResponseOfListOfProductAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProductAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Product[] | undefined;
}

export class ResponseOfListOfProduct extends ResponseOfListOfProductAndString implements IResponseOfListOfProduct {

    constructor(data?: IResponseOfListOfProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProduct extends IResponseOfListOfProductAndString {
}

export class ListResponseOfProduct extends ResponseOfListOfProduct implements IListResponseOfProduct {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProduct extends IResponseOfListOfProduct {
    totalRecords?: number | undefined;
}

export class Product extends BaseModel implements IProduct {
    deleted?: boolean;
    productTypeId?: string;
    title?: string | undefined;
    urlPath?: string | undefined;
    productType?: ProductType | undefined;
    computedName?: string | undefined;
    crmId?: string | undefined;
    ownerOrganizationId?: string;
    ownerOrganizationName?: string | undefined;

    constructor(data?: IProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deleted = _data["deleted"];
            this.productTypeId = _data["productTypeId"];
            this.title = _data["title"];
            this.urlPath = _data["urlPath"];
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : undefined as any;
            this.computedName = _data["computedName"];
            this.crmId = _data["crmId"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.ownerOrganizationName = _data["ownerOrganizationName"];
        }
    }

    static override fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleted"] = this.deleted;
        data["productTypeId"] = this.productTypeId;
        data["title"] = this.title;
        data["urlPath"] = this.urlPath;
        data["productType"] = this.productType ? this.productType.toJSON() : undefined as any;
        data["computedName"] = this.computedName;
        data["crmId"] = this.crmId;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["ownerOrganizationName"] = this.ownerOrganizationName;
        super.toJSON(data);
        return data;
    }
}

export interface IProduct extends IBaseModel {
    deleted?: boolean;
    productTypeId?: string;
    title?: string | undefined;
    urlPath?: string | undefined;
    productType?: ProductType | undefined;
    computedName?: string | undefined;
    crmId?: string | undefined;
    ownerOrganizationId?: string;
    ownerOrganizationName?: string | undefined;
}

export class ProductType extends BaseModel implements IProductType {
    enumValue?: ProductTypes;

    constructor(data?: IProductType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumValue = _data["enumValue"];
        }
    }

    static override fromJS(data: any): ProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumValue"] = this.enumValue;
        super.toJSON(data);
        return data;
    }
}

export interface IProductType extends IBaseModel {
    enumValue?: ProductTypes;
}

export class ListRequestOfProductFilterV2 implements IListRequestOfProductFilterV2 {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProductFilterV2 | undefined;

    constructor(data?: IListRequestOfProductFilterV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ProductFilterV2.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfProductFilterV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfProductFilterV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfProductFilterV2 {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ProductFilterV2 | undefined;
}

export class AdminListRequestOfProductFilterV2 extends ListRequestOfProductFilterV2 implements IAdminListRequestOfProductFilterV2 {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfProductFilterV2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfProductFilterV2 {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfProductFilterV2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfProductFilterV2 extends IListRequestOfProductFilterV2 {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class ProductFilterV2 extends BaseFilter implements IProductFilterV2 {
    productTypeId?: string | undefined;
    searchByName?: boolean;

    constructor(data?: IProductFilterV2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productTypeId = _data["productTypeId"];
            this.searchByName = _data["searchByName"];
        }
    }

    static override fromJS(data: any): ProductFilterV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFilterV2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productTypeId"] = this.productTypeId;
        data["searchByName"] = this.searchByName;
        super.toJSON(data);
        return data;
    }
}

export interface IProductFilterV2 extends IBaseFilter {
    productTypeId?: string | undefined;
    searchByName?: boolean;
}

export class ResponseOfProductAndString implements IResponseOfProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Product | undefined;

    constructor(data?: IResponseOfProductAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Product.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfProductAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProductAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfProductAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Product | undefined;
}

export class ResponseOfProduct extends ResponseOfProductAndString implements IResponseOfProduct {

    constructor(data?: IResponseOfProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfProduct extends IResponseOfProductAndString {
}

export class SaveProduct implements ISaveProduct {
    id?: string | undefined;
    productTypeId?: string;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    urlPath?: string | undefined;
    externalSourceId?: string | undefined;
    skuIds?: string[] | undefined;
    ownerOrganizationId?: string;

    constructor(data?: ISaveProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productTypeId = _data["productTypeId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.urlPath = _data["urlPath"];
            this.externalSourceId = _data["externalSourceId"];
            if (Array.isArray(_data["skuIds"])) {
                this.skuIds = [] as any;
                for (let item of _data["skuIds"])
                    this.skuIds!.push(item);
            }
            this.ownerOrganizationId = _data["ownerOrganizationId"];
        }
    }

    static fromJS(data: any): SaveProduct {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productTypeId"] = this.productTypeId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["description"] = this.description;
        data["urlPath"] = this.urlPath;
        data["externalSourceId"] = this.externalSourceId;
        if (Array.isArray(this.skuIds)) {
            data["skuIds"] = [];
            for (let item of this.skuIds)
                data["skuIds"].push(item);
        }
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        return data;
    }
}

export interface ISaveProduct {
    id?: string | undefined;
    productTypeId?: string;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    urlPath?: string | undefined;
    externalSourceId?: string | undefined;
    skuIds?: string[] | undefined;
    ownerOrganizationId?: string;
}

export class ResponseOfProductTypeAndString implements IResponseOfProductTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductType | undefined;

    constructor(data?: IResponseOfProductTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ProductType.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfProductTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProductTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfProductTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductType | undefined;
}

export class ResponseOfProductType extends ResponseOfProductTypeAndString implements IResponseOfProductType {

    constructor(data?: IResponseOfProductType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProductType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfProductType extends IResponseOfProductTypeAndString {
}

export class ResponseOfListOfProductTypeAndString implements IResponseOfListOfProductTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductType[] | undefined;

    constructor(data?: IResponseOfListOfProductTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProductTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProductTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductType[] | undefined;
}

export class ResponseOfListOfProductType extends ResponseOfListOfProductTypeAndString implements IResponseOfListOfProductType {

    constructor(data?: IResponseOfListOfProductType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProductType extends IResponseOfListOfProductTypeAndString {
}

export class ListResponseOfProductType extends ResponseOfListOfProductType implements IListResponseOfProductType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProductType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProductType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProductType extends IResponseOfListOfProductType {
    totalRecords?: number | undefined;
}

export class ResponseOfProductVersionAndString implements IResponseOfProductVersionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductVersion | undefined;

    constructor(data?: IResponseOfProductVersionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ProductVersion.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfProductVersionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProductVersionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfProductVersionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductVersion | undefined;
}

export class ResponseOfProductVersion extends ResponseOfProductVersionAndString implements IResponseOfProductVersion {

    constructor(data?: IResponseOfProductVersion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfProductVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProductVersion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfProductVersion extends IResponseOfProductVersionAndString {
}

export class ProductVersion extends BaseModel implements IProductVersion {

    constructor(data?: IProductVersion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProductVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVersion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProductVersion extends IBaseModel {
}

export class ResponseOfListOfProductVersionAndString implements IResponseOfListOfProductVersionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductVersion[] | undefined;

    constructor(data?: IResponseOfListOfProductVersionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductVersion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProductVersionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductVersionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProductVersionAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductVersion[] | undefined;
}

export class ResponseOfListOfProductVersion extends ResponseOfListOfProductVersionAndString implements IResponseOfListOfProductVersion {

    constructor(data?: IResponseOfListOfProductVersion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProductVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductVersion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProductVersion extends IResponseOfListOfProductVersionAndString {
}

export class ListResponseOfProductVersion extends ResponseOfListOfProductVersion implements IListResponseOfProductVersion {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProductVersion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProductVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProductVersion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProductVersion extends IResponseOfListOfProductVersion {
    totalRecords?: number | undefined;
}

export class SaveProductVersion implements ISaveProductVersion {
    id?: string | undefined;
    name!: string;
    value!: string;

    constructor(data?: ISaveProductVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SaveProductVersion {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISaveProductVersion {
    id?: string | undefined;
    name: string;
    value: string;
}

export class ResponseOfProductYearAndString implements IResponseOfProductYearAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductYear | undefined;

    constructor(data?: IResponseOfProductYearAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? ProductYear.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfProductYearAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProductYearAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfProductYearAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductYear | undefined;
}

export class ResponseOfProductYear extends ResponseOfProductYearAndString implements IResponseOfProductYear {

    constructor(data?: IResponseOfProductYear) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfProductYear {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfProductYear();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfProductYear extends IResponseOfProductYearAndString {
}

export class ProductYear extends BaseModel implements IProductYear {

    constructor(data?: IProductYear) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProductYear {
        data = typeof data === 'object' ? data : {};
        let result = new ProductYear();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProductYear extends IBaseModel {
}

export class ResponseOfListOfProductYearAndString implements IResponseOfListOfProductYearAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductYear[] | undefined;

    constructor(data?: IResponseOfListOfProductYearAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductYear.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProductYearAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductYearAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProductYearAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: ProductYear[] | undefined;
}

export class ResponseOfListOfProductYear extends ResponseOfListOfProductYearAndString implements IResponseOfListOfProductYear {

    constructor(data?: IResponseOfListOfProductYear) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProductYear {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProductYear();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProductYear extends IResponseOfListOfProductYearAndString {
}

export class ListResponseOfProductYear extends ResponseOfListOfProductYear implements IListResponseOfProductYear {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfProductYear) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProductYear {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProductYear();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProductYear extends IResponseOfListOfProductYear {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfLocationTypeAndString implements IResponseOfListOfLocationTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LocationType[] | undefined;

    constructor(data?: IResponseOfListOfLocationTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocationType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfLocationTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLocationTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfLocationTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: LocationType[] | undefined;
}

export class ResponseOfListOfLocationType extends ResponseOfListOfLocationTypeAndString implements IResponseOfListOfLocationType {

    constructor(data?: IResponseOfListOfLocationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfLocationType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLocationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfLocationType extends IResponseOfListOfLocationTypeAndString {
}

export class ListResponseOfLocationType extends ResponseOfListOfLocationType implements IListResponseOfLocationType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfLocationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfLocationType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfLocationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfLocationType extends IResponseOfListOfLocationType {
    totalRecords?: number | undefined;
}

export class LocationType implements ILocationType {
    id?: string;
    name?: string | undefined;

    constructor(data?: ILocationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocationType {
        data = typeof data === 'object' ? data : {};
        let result = new LocationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocationType {
    id?: string;
    name?: string | undefined;
}

export class ResponseOfCorporateEntityAndString implements IResponseOfCorporateEntityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CorporateEntity | undefined;

    constructor(data?: IResponseOfCorporateEntityAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CorporateEntity.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCorporateEntityAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCorporateEntityAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCorporateEntityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CorporateEntity | undefined;
}

export class ResponseOfCorporateEntity extends ResponseOfCorporateEntityAndString implements IResponseOfCorporateEntity {

    constructor(data?: IResponseOfCorporateEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCorporateEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCorporateEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCorporateEntity extends IResponseOfCorporateEntityAndString {
}

export class CorporateEntity implements ICorporateEntity {
    id!: string;
    name!: string;

    constructor(data?: ICorporateEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CorporateEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICorporateEntity {
    id: string;
    name: string;
}

export class ResponseOfListOfCorporateEntityAndString implements IResponseOfListOfCorporateEntityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CorporateEntity[] | undefined;

    constructor(data?: IResponseOfListOfCorporateEntityAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CorporateEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCorporateEntityAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCorporateEntityAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCorporateEntityAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CorporateEntity[] | undefined;
}

export class ResponseOfListOfCorporateEntity extends ResponseOfListOfCorporateEntityAndString implements IResponseOfListOfCorporateEntity {

    constructor(data?: IResponseOfListOfCorporateEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCorporateEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCorporateEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCorporateEntity extends IResponseOfListOfCorporateEntityAndString {
}

export class ListResponseOfCorporateEntity extends ResponseOfListOfCorporateEntity implements IListResponseOfCorporateEntity {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCorporateEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCorporateEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCorporateEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCorporateEntity extends IResponseOfListOfCorporateEntity {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfAttributeAndString implements IResponseOfListOfAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Attribute[] | undefined;

    constructor(data?: IResponseOfListOfAttributeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Attribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAttributeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttributeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Attribute[] | undefined;
}

export class ResponseOfListOfAttribute extends ResponseOfListOfAttributeAndString implements IResponseOfListOfAttribute {

    constructor(data?: IResponseOfListOfAttribute) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAttribute extends IResponseOfListOfAttributeAndString {
}

export class ListResponseOfAttribute extends ResponseOfListOfAttribute implements IListResponseOfAttribute {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAttribute) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAttribute extends IResponseOfListOfAttribute {
    totalRecords?: number | undefined;
}

export class ResponseOfAttributeAndString implements IResponseOfAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Attribute | undefined;

    constructor(data?: IResponseOfAttributeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Attribute.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAttributeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAttributeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAttributeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Attribute | undefined;
}

export class ResponseOfAttribute extends ResponseOfAttributeAndString implements IResponseOfAttribute {

    constructor(data?: IResponseOfAttribute) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAttribute extends IResponseOfAttributeAndString {
}

export class SaveAttributeRequest implements ISaveAttributeRequest {
    id?: string | undefined;
    attributeTypeId?: string;
    organizationAttributeTypeId?: string;
    value!: string;
    displayText?: string | undefined;
    sequence?: number;
    attributeMetaValues?: AttributeMetaValue[] | undefined;

    constructor(data?: ISaveAttributeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeTypeId = _data["attributeTypeId"];
            this.organizationAttributeTypeId = _data["organizationAttributeTypeId"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.sequence = _data["sequence"];
            if (Array.isArray(_data["attributeMetaValues"])) {
                this.attributeMetaValues = [] as any;
                for (let item of _data["attributeMetaValues"])
                    this.attributeMetaValues!.push(AttributeMetaValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAttributeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAttributeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeTypeId"] = this.attributeTypeId;
        data["organizationAttributeTypeId"] = this.organizationAttributeTypeId;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["sequence"] = this.sequence;
        if (Array.isArray(this.attributeMetaValues)) {
            data["attributeMetaValues"] = [];
            for (let item of this.attributeMetaValues)
                data["attributeMetaValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveAttributeRequest {
    id?: string | undefined;
    attributeTypeId?: string;
    organizationAttributeTypeId?: string;
    value: string;
    displayText?: string | undefined;
    sequence?: number;
    attributeMetaValues?: AttributeMetaValue[] | undefined;
}

export class ResponseOfListOfAttributeTypeAndString implements IResponseOfListOfAttributeTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AttributeType[] | undefined;

    constructor(data?: IResponseOfListOfAttributeTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AttributeType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAttributeTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttributeTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAttributeTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AttributeType[] | undefined;
}

export class ResponseOfListOfAttributeType extends ResponseOfListOfAttributeTypeAndString implements IResponseOfListOfAttributeType {

    constructor(data?: IResponseOfListOfAttributeType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAttributeType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttributeType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAttributeType extends IResponseOfListOfAttributeTypeAndString {
}

export class ListResponseOfAttributeType extends ResponseOfListOfAttributeType implements IListResponseOfAttributeType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAttributeType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAttributeType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAttributeType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAttributeType extends IResponseOfListOfAttributeType {
    totalRecords?: number | undefined;
}

export class ResponseOfListOfOrganizationAttributeTypeAndString implements IResponseOfListOfOrganizationAttributeTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationAttributeType[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationAttributeTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationAttributeType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationAttributeTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationAttributeTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationAttributeTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationAttributeType[] | undefined;
}

export class ResponseOfListOfOrganizationAttributeType extends ResponseOfListOfOrganizationAttributeTypeAndString implements IResponseOfListOfOrganizationAttributeType {

    constructor(data?: IResponseOfListOfOrganizationAttributeType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationAttributeType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationAttributeType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationAttributeType extends IResponseOfListOfOrganizationAttributeTypeAndString {
}

export class ListResponseOfOrganizationAttributeType extends ResponseOfListOfOrganizationAttributeType implements IListResponseOfOrganizationAttributeType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfOrganizationAttributeType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationAttributeType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationAttributeType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationAttributeType extends IResponseOfListOfOrganizationAttributeType {
    totalRecords?: number | undefined;
}

export class ListRequestOfOrganizationAttributeTypeFilter implements IListRequestOfOrganizationAttributeTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationAttributeTypeFilter | undefined;

    constructor(data?: IListRequestOfOrganizationAttributeTypeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? OrganizationAttributeTypeFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfOrganizationAttributeTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfOrganizationAttributeTypeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfOrganizationAttributeTypeFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationAttributeTypeFilter | undefined;
}

export class OrganizationAttributeTypeRequest extends ListRequestOfOrganizationAttributeTypeFilter implements IOrganizationAttributeTypeRequest {
    organizationId?: string;

    constructor(data?: IOrganizationAttributeTypeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): OrganizationAttributeTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAttributeTypeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationAttributeTypeRequest extends IListRequestOfOrganizationAttributeTypeFilter {
    organizationId?: string;
}

export class OrganizationAttributeTypeFilter extends BaseFilter implements IOrganizationAttributeTypeFilter {
    codeConstant?: string | undefined;
    attributeDisplayTypeId?: string | undefined;
    isAttributeManagementAvailable?: boolean | undefined;

    constructor(data?: IOrganizationAttributeTypeFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codeConstant = _data["codeConstant"];
            this.attributeDisplayTypeId = _data["attributeDisplayTypeId"];
            this.isAttributeManagementAvailable = _data["isAttributeManagementAvailable"];
        }
    }

    static override fromJS(data: any): OrganizationAttributeTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAttributeTypeFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeConstant"] = this.codeConstant;
        data["attributeDisplayTypeId"] = this.attributeDisplayTypeId;
        data["isAttributeManagementAvailable"] = this.isAttributeManagementAvailable;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationAttributeTypeFilter extends IBaseFilter {
    codeConstant?: string | undefined;
    attributeDisplayTypeId?: string | undefined;
    isAttributeManagementAvailable?: boolean | undefined;
}

export class ResponseOfListOfClaimAndString implements IResponseOfListOfClaimAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Claim[] | undefined;

    constructor(data?: IResponseOfListOfClaimAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Claim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfClaimAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfClaimAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfClaimAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Claim[] | undefined;
}

export class ResponseOfListOfClaim extends ResponseOfListOfClaimAndString implements IResponseOfListOfClaim {

    constructor(data?: IResponseOfListOfClaim) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfClaim {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfClaim();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfClaim extends IResponseOfListOfClaimAndString {
}

export class ListResponseOfClaim extends ResponseOfListOfClaim implements IListResponseOfClaim {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfClaim) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfClaim {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfClaim();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfClaim extends IResponseOfListOfClaim {
    totalRecords?: number | undefined;
}

export class Claim implements IClaim {
    id?: string;
    name?: string | undefined;
    applicationId?: string;
    applicationName?: string | undefined;
    groupName?: string | undefined;
    sequence?: number;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.groupName = _data["groupName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["groupName"] = this.groupName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IClaim {
    id?: string;
    name?: string | undefined;
    applicationId?: string;
    applicationName?: string | undefined;
    groupName?: string | undefined;
    sequence?: number;
}

export class ResponseOfListOfRoleAndString implements IResponseOfListOfRoleAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Role[] | undefined;

    constructor(data?: IResponseOfListOfRoleAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Role.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRoleAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRoleAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRoleAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Role[] | undefined;
}

export class ResponseOfListOfRole extends ResponseOfListOfRoleAndString implements IResponseOfListOfRole {

    constructor(data?: IResponseOfListOfRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRole {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRole extends IResponseOfListOfRoleAndString {
}

export class ListResponseOfRole extends ResponseOfListOfRole implements IListResponseOfRole {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRole {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRole extends IResponseOfListOfRole {
    totalRecords?: number | undefined;
}

export class Role implements IRole {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    canAssign?: boolean;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.canAssign = _data["canAssign"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["canAssign"] = this.canAssign;
        return data;
    }
}

export interface IRole {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    canAssign?: boolean;
}

export class ResponseOfRoleDetailsAndString implements IResponseOfRoleDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RoleDetails | undefined;

    constructor(data?: IResponseOfRoleDetailsAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RoleDetails.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRoleDetailsAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRoleDetailsAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRoleDetailsAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RoleDetails | undefined;
}

export class ResponseOfRoleDetails extends ResponseOfRoleDetailsAndString implements IResponseOfRoleDetails {

    constructor(data?: IResponseOfRoleDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRoleDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRoleDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRoleDetails extends IResponseOfRoleDetailsAndString {
}

export class RoleDetails extends Role implements IRoleDetails {
    claimIds?: string[] | undefined;

    constructor(data?: IRoleDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["claimIds"])) {
                this.claimIds = [] as any;
                for (let item of _data["claimIds"])
                    this.claimIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): RoleDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claimIds)) {
            data["claimIds"] = [];
            for (let item of this.claimIds)
                data["claimIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRoleDetails extends IRole {
    claimIds?: string[] | undefined;
}

export class SaveRoleRequest implements ISaveRoleRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    claimIds?: string[] | undefined;

    constructor(data?: ISaveRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["claimIds"])) {
                this.claimIds = [] as any;
                for (let item of _data["claimIds"])
                    this.claimIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.claimIds)) {
            data["claimIds"] = [];
            for (let item of this.claimIds)
                data["claimIds"].push(item);
        }
        return data;
    }
}

export interface ISaveRoleRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    claimIds?: string[] | undefined;
}

export class ResponseOfListOfTimeZoneAndString implements IResponseOfListOfTimeZoneAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TimeZone[] | undefined;

    constructor(data?: IResponseOfListOfTimeZoneAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimeZone.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfTimeZoneAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTimeZoneAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfTimeZoneAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TimeZone[] | undefined;
}

export class ResponseOfListOfTimeZone extends ResponseOfListOfTimeZoneAndString implements IResponseOfListOfTimeZone {

    constructor(data?: IResponseOfListOfTimeZone) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTimeZone();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfTimeZone extends IResponseOfListOfTimeZoneAndString {
}

export class ListResponseOfTimeZone extends ResponseOfListOfTimeZone implements IListResponseOfTimeZone {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfTimeZone) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfTimeZone();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfTimeZone extends IResponseOfListOfTimeZone {
    totalRecords?: number | undefined;
}

export class TimeZone implements ITimeZone {
    id!: string;
    countryName?: string | undefined;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface ITimeZone {
    id: string;
    countryName?: string | undefined;
}

export class SaveUserRequest implements ISaveUserRequest {
    id?: string | undefined;
    organizationId!: string;
    email!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    externalSourceId?: string | undefined;
    roleNames?: string[] | undefined;
    timeZone?: string | undefined;

    constructor(data?: ISaveUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.externalSourceId = _data["externalSourceId"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): SaveUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["externalSourceId"] = this.externalSourceId;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface ISaveUserRequest {
    id?: string | undefined;
    organizationId: string;
    email: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    externalSourceId?: string | undefined;
    roleNames?: string[] | undefined;
    timeZone?: string | undefined;
}

export class ImpersonationResponse implements IImpersonationResponse {
    redirectUrl?: string | undefined;

    constructor(data?: IImpersonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): ImpersonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IImpersonationResponse {
    redirectUrl?: string | undefined;
}

export class CreateUserLoginRequest implements ICreateUserLoginRequest {
    userId!: string;
    organizationId!: string;

    constructor(data?: ICreateUserLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): CreateUserLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ICreateUserLoginRequest {
    userId: string;
    organizationId: string;
}

export class UserLoginUrlResponse implements IUserLoginUrlResponse {
    returnUrl?: string | undefined;

    constructor(data?: IUserLoginUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): UserLoginUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IUserLoginUrlResponse {
    returnUrl?: string | undefined;
}

export class MergeUserRequest implements IMergeUserRequest {
    originalUserId!: string;
    newUserId!: string;
    reason!: string;

    constructor(data?: IMergeUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalUserId = _data["originalUserId"];
            this.newUserId = _data["newUserId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MergeUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MergeUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalUserId"] = this.originalUserId;
        data["newUserId"] = this.newUserId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMergeUserRequest {
    originalUserId: string;
    newUserId: string;
    reason: string;
}

export class GetUserCredentialsResponse implements IGetUserCredentialsResponse {
    userCredentials!: UserCredentialModel[];

    constructor(data?: IGetUserCredentialsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userCredentials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userCredentials"])) {
                this.userCredentials = [] as any;
                for (let item of _data["userCredentials"])
                    this.userCredentials!.push(UserCredentialModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserCredentialsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserCredentialsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userCredentials)) {
            data["userCredentials"] = [];
            for (let item of this.userCredentials)
                data["userCredentials"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserCredentialsResponse {
    userCredentials: UserCredentialModel[];
}

export class UserCredentialModel implements IUserCredentialModel {
    id?: string | undefined;
    externalUserId?: string;
    userCredentialTypeId?: string;
    userCredentialTypeDisplayName?: string;
    applicationId?: string | undefined;
    applicationName?: string | undefined;
    isInheritedFromUserAccount?: boolean;

    constructor(data?: IUserCredentialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalUserId = _data["externalUserId"];
            this.userCredentialTypeId = _data["userCredentialTypeId"];
            this.userCredentialTypeDisplayName = _data["userCredentialTypeDisplayName"];
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.isInheritedFromUserAccount = _data["isInheritedFromUserAccount"];
        }
    }

    static fromJS(data: any): UserCredentialModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCredentialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalUserId"] = this.externalUserId;
        data["userCredentialTypeId"] = this.userCredentialTypeId;
        data["userCredentialTypeDisplayName"] = this.userCredentialTypeDisplayName;
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["isInheritedFromUserAccount"] = this.isInheritedFromUserAccount;
        return data;
    }
}

export interface IUserCredentialModel {
    id?: string | undefined;
    externalUserId?: string;
    userCredentialTypeId?: string;
    userCredentialTypeDisplayName?: string;
    applicationId?: string | undefined;
    applicationName?: string | undefined;
    isInheritedFromUserAccount?: boolean;
}

export class GenerateWebinarRequest implements IGenerateWebinarRequest {
    organizationId?: string;
    sku?: string | undefined;
    title?: string | undefined;
    eventStartDate?: Date;
    eventEndDate?: Date;
    corporateEntityId?: string;

    constructor(data?: IGenerateWebinarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.sku = _data["sku"];
            this.title = _data["title"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            this.corporateEntityId = _data["corporateEntityId"];
        }
    }

    static fromJS(data: any): GenerateWebinarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateWebinarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["sku"] = this.sku;
        data["title"] = this.title;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        data["corporateEntityId"] = this.corporateEntityId;
        return data;
    }
}

export interface IGenerateWebinarRequest {
    organizationId?: string;
    sku?: string | undefined;
    title?: string | undefined;
    eventStartDate?: Date;
    eventEndDate?: Date;
    corporateEntityId?: string;
}

export class ResponseOfOrganizationTreeItemAndString implements IResponseOfOrganizationTreeItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationTreeItem | undefined;

    constructor(data?: IResponseOfOrganizationTreeItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? OrganizationTreeItem.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfOrganizationTreeItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationTreeItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfOrganizationTreeItemAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: OrganizationTreeItem | undefined;
}

export class ResponseOfOrganizationTreeItem extends ResponseOfOrganizationTreeItemAndString implements IResponseOfOrganizationTreeItem {

    constructor(data?: IResponseOfOrganizationTreeItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfOrganizationTreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationTreeItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfOrganizationTreeItem extends IResponseOfOrganizationTreeItemAndString {
}

export class OrganizationTreeItem implements IOrganizationTreeItem {
    id!: string;
    name?: string | undefined;
    displayName?: string | undefined;
    isDisplayOnly?: boolean;
    organizationTypeId?: string;
    organizations?: OrganizationTreeItem[] | undefined;

    constructor(data?: IOrganizationTreeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDisplayOnly = _data["isDisplayOnly"];
            this.organizationTypeId = _data["organizationTypeId"];
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationTreeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationTreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTreeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDisplayOnly"] = this.isDisplayOnly;
        data["organizationTypeId"] = this.organizationTypeId;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationTreeItem {
    id: string;
    name?: string | undefined;
    displayName?: string | undefined;
    isDisplayOnly?: boolean;
    organizationTypeId?: string;
    organizations?: OrganizationTreeItem[] | undefined;
}

export class ResponseOfSwitchOrganizationResponseAndString implements IResponseOfSwitchOrganizationResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SwitchOrganizationResponse | undefined;

    constructor(data?: IResponseOfSwitchOrganizationResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SwitchOrganizationResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSwitchOrganizationResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSwitchOrganizationResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSwitchOrganizationResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: SwitchOrganizationResponse | undefined;
}

export class ResponseOfSwitchOrganizationResponse extends ResponseOfSwitchOrganizationResponseAndString implements IResponseOfSwitchOrganizationResponse {

    constructor(data?: IResponseOfSwitchOrganizationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSwitchOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSwitchOrganizationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSwitchOrganizationResponse extends IResponseOfSwitchOrganizationResponseAndString {
}

export class SwitchOrganizationResponse implements ISwitchOrganizationResponse {
    sessionId?: string | undefined;

    constructor(data?: ISwitchOrganizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): SwitchOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchOrganizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ISwitchOrganizationResponse {
    sessionId?: string | undefined;
}

export class SwitchOrganizationRequest implements ISwitchOrganizationRequest {
    organizationId?: string;

    constructor(data?: ISwitchOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): SwitchOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ISwitchOrganizationRequest {
    organizationId?: string;
}

export class ResponseOfListOfApplicationAndString implements IResponseOfListOfApplicationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Application[] | undefined;

    constructor(data?: IResponseOfListOfApplicationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Application.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfApplicationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfApplicationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfApplicationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Application[] | undefined;
}

export class ResponseOfListOfApplication extends ResponseOfListOfApplicationAndString implements IResponseOfListOfApplication {

    constructor(data?: IResponseOfListOfApplication) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfApplication();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfApplication extends IResponseOfListOfApplicationAndString {
}

export class ListResponseOfApplication extends ResponseOfListOfApplication implements IListResponseOfApplication {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfApplication) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfApplication();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfApplication extends IResponseOfListOfApplication {
    totalRecords?: number | undefined;
}

export class Application implements IApplication {
    id?: string;
    name?: string | undefined;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IApplication {
    id?: string;
    name?: string | undefined;
}

export class ListRequestOfAdminApplicationFilter implements IListRequestOfAdminApplicationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AdminApplicationFilter | undefined;

    constructor(data?: IListRequestOfAdminApplicationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? AdminApplicationFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfAdminApplicationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfAdminApplicationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfAdminApplicationFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: AdminApplicationFilter | undefined;
}

export class AdminApplicationFilter extends BaseFilter implements IAdminApplicationFilter {
    allowGrantingUserAccess?: boolean | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminApplicationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allowGrantingUserAccess = _data["allowGrantingUserAccess"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminApplicationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminApplicationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowGrantingUserAccess"] = this.allowGrantingUserAccess;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminApplicationFilter extends IBaseFilter {
    allowGrantingUserAccess?: boolean | undefined;
    organizationId?: string | undefined;
}

export class ListRequestOfApplicationsByOrganizationUsersFilter implements IListRequestOfApplicationsByOrganizationUsersFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ApplicationsByOrganizationUsersFilter | undefined;

    constructor(data?: IListRequestOfApplicationsByOrganizationUsersFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? ApplicationsByOrganizationUsersFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfApplicationsByOrganizationUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfApplicationsByOrganizationUsersFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfApplicationsByOrganizationUsersFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: ApplicationsByOrganizationUsersFilter | undefined;
}

export class ApplicationsByOrganizationUsersFilter extends BaseFilter implements IApplicationsByOrganizationUsersFilter {
    organizationId?: string;

    constructor(data?: IApplicationsByOrganizationUsersFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): ApplicationsByOrganizationUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationsByOrganizationUsersFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationsByOrganizationUsersFilter extends IBaseFilter {
    organizationId?: string;
}

export class ResponseOfApplicationAndString implements IResponseOfApplicationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Application | undefined;

    constructor(data?: IResponseOfApplicationAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? Application.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfApplicationAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfApplicationAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfApplicationAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Application | undefined;
}

export class ResponseOfApplication extends ResponseOfApplicationAndString implements IResponseOfApplication {

    constructor(data?: IResponseOfApplication) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfApplication();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfApplication extends IResponseOfApplicationAndString {
}

export class PrintReferenceRequest implements IPrintReferenceRequest {
    organizationId?: string;

    constructor(data?: IPrintReferenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): PrintReferenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintReferenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IPrintReferenceRequest {
    organizationId?: string;
}

export class ResponseOfListOfTemplateAdminAndString implements IResponseOfListOfTemplateAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateAdmin[] | undefined;

    constructor(data?: IResponseOfListOfTemplateAdminAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TemplateAdmin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfTemplateAdminAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTemplateAdminAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfTemplateAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateAdmin[] | undefined;
}

export class ResponseOfListOfTemplateAdmin extends ResponseOfListOfTemplateAdminAndString implements IResponseOfListOfTemplateAdmin {

    constructor(data?: IResponseOfListOfTemplateAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfTemplateAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTemplateAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfTemplateAdmin extends IResponseOfListOfTemplateAdminAndString {
}

export class ListResponseOfTemplateAdmin extends ResponseOfListOfTemplateAdmin implements IListResponseOfTemplateAdmin {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfTemplateAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfTemplateAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfTemplateAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfTemplateAdmin extends IResponseOfListOfTemplateAdmin {
    totalRecords?: number | undefined;
}

export class TemplateAdmin implements ITemplateAdmin {
    organizationId?: string;
    organizationName?: string | undefined;
    id?: string;
    templateTypeId?: string;
    templateTypeName?: string | undefined;
    templateEntityId?: string;
    templateEntityName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    placeholderName?: string | undefined;
    codeConstant?: string | undefined;
    templateVersionId?: string | undefined;
    content?: string | undefined;
    templateVersionStatusId?: string | undefined;
    isDraft?: boolean;

    constructor(data?: ITemplateAdmin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.id = _data["id"];
            this.templateTypeId = _data["templateTypeId"];
            this.templateTypeName = _data["templateTypeName"];
            this.templateEntityId = _data["templateEntityId"];
            this.templateEntityName = _data["templateEntityName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.placeholderName = _data["placeholderName"];
            this.codeConstant = _data["codeConstant"];
            this.templateVersionId = _data["templateVersionId"];
            this.content = _data["content"];
            this.templateVersionStatusId = _data["templateVersionStatusId"];
            this.isDraft = _data["isDraft"];
        }
    }

    static fromJS(data: any): TemplateAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAdmin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["id"] = this.id;
        data["templateTypeId"] = this.templateTypeId;
        data["templateTypeName"] = this.templateTypeName;
        data["templateEntityId"] = this.templateEntityId;
        data["templateEntityName"] = this.templateEntityName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["placeholderName"] = this.placeholderName;
        data["codeConstant"] = this.codeConstant;
        data["templateVersionId"] = this.templateVersionId;
        data["content"] = this.content;
        data["templateVersionStatusId"] = this.templateVersionStatusId;
        data["isDraft"] = this.isDraft;
        return data;
    }
}

export interface ITemplateAdmin {
    organizationId?: string;
    organizationName?: string | undefined;
    id?: string;
    templateTypeId?: string;
    templateTypeName?: string | undefined;
    templateEntityId?: string;
    templateEntityName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    placeholderName?: string | undefined;
    codeConstant?: string | undefined;
    templateVersionId?: string | undefined;
    content?: string | undefined;
    templateVersionStatusId?: string | undefined;
    isDraft?: boolean;
}

export class ListRequestOfTemplateFilter implements IListRequestOfTemplateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: TemplateFilter | undefined;

    constructor(data?: IListRequestOfTemplateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? TemplateFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfTemplateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfTemplateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfTemplateFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: TemplateFilter | undefined;
}

export class AdminListRequestOfTemplateFilter extends ListRequestOfTemplateFilter implements IAdminListRequestOfTemplateFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdminListRequestOfTemplateFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): AdminListRequestOfTemplateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdminListRequestOfTemplateFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminListRequestOfTemplateFilter extends IListRequestOfTemplateFilter {
    applicationId?: string | undefined;
    organizationId?: string | undefined;
}

export class TemplateFilter extends BaseFilter implements ITemplateFilter {
    typeId?: string | undefined;
    entityTypeId?: string | undefined;
    statusId?: string | undefined;
    excludedTemplateEntityIds?: string[] | undefined;
    excludedTemplateTypeIds?: string[] | undefined;

    constructor(data?: ITemplateFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeId = _data["typeId"];
            this.entityTypeId = _data["entityTypeId"];
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["excludedTemplateEntityIds"])) {
                this.excludedTemplateEntityIds = [] as any;
                for (let item of _data["excludedTemplateEntityIds"])
                    this.excludedTemplateEntityIds!.push(item);
            }
            if (Array.isArray(_data["excludedTemplateTypeIds"])) {
                this.excludedTemplateTypeIds = [] as any;
                for (let item of _data["excludedTemplateTypeIds"])
                    this.excludedTemplateTypeIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): TemplateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["entityTypeId"] = this.entityTypeId;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.excludedTemplateEntityIds)) {
            data["excludedTemplateEntityIds"] = [];
            for (let item of this.excludedTemplateEntityIds)
                data["excludedTemplateEntityIds"].push(item);
        }
        if (Array.isArray(this.excludedTemplateTypeIds)) {
            data["excludedTemplateTypeIds"] = [];
            for (let item of this.excludedTemplateTypeIds)
                data["excludedTemplateTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateFilter extends IBaseFilter {
    typeId?: string | undefined;
    entityTypeId?: string | undefined;
    statusId?: string | undefined;
    excludedTemplateEntityIds?: string[] | undefined;
    excludedTemplateTypeIds?: string[] | undefined;
}

export class ResponseOfTemplateAdminAndString implements IResponseOfTemplateAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateAdmin | undefined;

    constructor(data?: IResponseOfTemplateAdminAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? TemplateAdmin.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfTemplateAdminAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfTemplateAdminAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfTemplateAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateAdmin | undefined;
}

export class ResponseOfTemplateAdmin extends ResponseOfTemplateAdminAndString implements IResponseOfTemplateAdmin {

    constructor(data?: IResponseOfTemplateAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfTemplateAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfTemplateAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfTemplateAdmin extends IResponseOfTemplateAdminAndString {
}

export class TemplateSaveRequest implements ITemplateSaveRequest {
    organizationId!: string;
    id?: string | undefined;
    templateTypeId!: string;
    templateEntityId!: string;
    name!: string;
    description?: string | undefined;
    placeholderName?: string | undefined;
    codeConstant?: string | undefined;

    constructor(data?: ITemplateSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.id = _data["id"];
            this.templateTypeId = _data["templateTypeId"];
            this.templateEntityId = _data["templateEntityId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.placeholderName = _data["placeholderName"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static fromJS(data: any): TemplateSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["id"] = this.id;
        data["templateTypeId"] = this.templateTypeId;
        data["templateEntityId"] = this.templateEntityId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["placeholderName"] = this.placeholderName;
        data["codeConstant"] = this.codeConstant;
        return data;
    }
}

export interface ITemplateSaveRequest {
    organizationId: string;
    id?: string | undefined;
    templateTypeId: string;
    templateEntityId: string;
    name: string;
    description?: string | undefined;
    placeholderName?: string | undefined;
    codeConstant?: string | undefined;
}

export class TemplateVersionSaveRequest implements ITemplateVersionSaveRequest {
    id?: string | undefined;
    templateId!: string;
    content!: string;

    constructor(data?: ITemplateVersionSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateId = _data["templateId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): TemplateVersionSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateVersionSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateId"] = this.templateId;
        data["content"] = this.content;
        return data;
    }
}

export interface ITemplateVersionSaveRequest {
    id?: string | undefined;
    templateId: string;
    content: string;
}

export class ResponseOfListOfTemplateTypeAdminAndString implements IResponseOfListOfTemplateTypeAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateTypeAdmin[] | undefined;

    constructor(data?: IResponseOfListOfTemplateTypeAdminAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TemplateTypeAdmin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfTemplateTypeAdminAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTemplateTypeAdminAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfTemplateTypeAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateTypeAdmin[] | undefined;
}

export class ResponseOfListOfTemplateTypeAdmin extends ResponseOfListOfTemplateTypeAdminAndString implements IResponseOfListOfTemplateTypeAdmin {

    constructor(data?: IResponseOfListOfTemplateTypeAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfTemplateTypeAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTemplateTypeAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfTemplateTypeAdmin extends IResponseOfListOfTemplateTypeAdminAndString {
}

export class ListResponseOfTemplateTypeAdmin extends ResponseOfListOfTemplateTypeAdmin implements IListResponseOfTemplateTypeAdmin {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfTemplateTypeAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfTemplateTypeAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfTemplateTypeAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfTemplateTypeAdmin extends IResponseOfListOfTemplateTypeAdmin {
    totalRecords?: number | undefined;
}

export class TemplateTypeAdmin implements ITemplateTypeAdmin {
    id?: string;
    name?: string | undefined;

    constructor(data?: ITemplateTypeAdmin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TemplateTypeAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateTypeAdmin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITemplateTypeAdmin {
    id?: string;
    name?: string | undefined;
}

export class ResponseOfListOfTemplateEntityAdminAndString implements IResponseOfListOfTemplateEntityAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateEntityAdmin[] | undefined;

    constructor(data?: IResponseOfListOfTemplateEntityAdminAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TemplateEntityAdmin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfTemplateEntityAdminAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTemplateEntityAdminAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfTemplateEntityAdminAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplateEntityAdmin[] | undefined;
}

export class ResponseOfListOfTemplateEntityAdmin extends ResponseOfListOfTemplateEntityAdminAndString implements IResponseOfListOfTemplateEntityAdmin {

    constructor(data?: IResponseOfListOfTemplateEntityAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfTemplateEntityAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfTemplateEntityAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfTemplateEntityAdmin extends IResponseOfListOfTemplateEntityAdminAndString {
}

export class ListResponseOfTemplateEntityAdmin extends ResponseOfListOfTemplateEntityAdmin implements IListResponseOfTemplateEntityAdmin {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfTemplateEntityAdmin) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfTemplateEntityAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfTemplateEntityAdmin();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfTemplateEntityAdmin extends IResponseOfListOfTemplateEntityAdmin {
    totalRecords?: number | undefined;
}

export class TemplateEntityAdmin implements ITemplateEntityAdmin {
    id?: string;
    name?: string | undefined;
    dtoName?: string | undefined;

    constructor(data?: ITemplateEntityAdmin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dtoName = _data["dtoName"];
        }
    }

    static fromJS(data: any): TemplateEntityAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateEntityAdmin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dtoName"] = this.dtoName;
        return data;
    }
}

export interface ITemplateEntityAdmin {
    id?: string;
    name?: string | undefined;
    dtoName?: string | undefined;
}

export class ResponseOfListOfCodeConstantAndString implements IResponseOfListOfCodeConstantAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CodeConstant[] | undefined;

    constructor(data?: IResponseOfListOfCodeConstantAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CodeConstant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCodeConstantAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCodeConstantAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCodeConstantAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: CodeConstant[] | undefined;
}

export class ResponseOfListOfCodeConstant extends ResponseOfListOfCodeConstantAndString implements IResponseOfListOfCodeConstant {

    constructor(data?: IResponseOfListOfCodeConstant) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCodeConstant {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCodeConstant();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCodeConstant extends IResponseOfListOfCodeConstantAndString {
}

export class ListResponseOfCodeConstant extends ResponseOfListOfCodeConstant implements IListResponseOfCodeConstant {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfCodeConstant) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCodeConstant {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCodeConstant();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCodeConstant extends IResponseOfListOfCodeConstant {
    totalRecords?: number | undefined;
}

export class CodeConstant implements ICodeConstant {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICodeConstant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CodeConstant {
        data = typeof data === 'object' ? data : {};
        let result = new CodeConstant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICodeConstant {
    id?: string | undefined;
    name?: string | undefined;
}

export class ResponseOfTemplatesByPlaceholderNameAndString implements IResponseOfTemplatesByPlaceholderNameAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplatesByPlaceholderName | undefined;

    constructor(data?: IResponseOfTemplatesByPlaceholderNameAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? TemplatesByPlaceholderName.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfTemplatesByPlaceholderNameAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfTemplatesByPlaceholderNameAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfTemplatesByPlaceholderNameAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: TemplatesByPlaceholderName | undefined;
}

export class ResponseOfTemplatesByPlaceholderName extends ResponseOfTemplatesByPlaceholderNameAndString implements IResponseOfTemplatesByPlaceholderName {

    constructor(data?: IResponseOfTemplatesByPlaceholderName) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfTemplatesByPlaceholderName {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfTemplatesByPlaceholderName();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfTemplatesByPlaceholderName extends IResponseOfTemplatesByPlaceholderNameAndString {
}

export class TemplatesByPlaceholderName implements ITemplatesByPlaceholderName {
    templates?: TemplateAdmin[] | undefined;
    organizationIds?: string[] | undefined;
    hasMultipleOrganizations?: boolean;
    hasDefaultTemplate?: boolean;

    constructor(data?: ITemplatesByPlaceholderName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(TemplateAdmin.fromJS(item));
            }
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            this.hasMultipleOrganizations = _data["hasMultipleOrganizations"];
            this.hasDefaultTemplate = _data["hasDefaultTemplate"];
        }
    }

    static fromJS(data: any): TemplatesByPlaceholderName {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatesByPlaceholderName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        data["hasMultipleOrganizations"] = this.hasMultipleOrganizations;
        data["hasDefaultTemplate"] = this.hasDefaultTemplate;
        return data;
    }
}

export interface ITemplatesByPlaceholderName {
    templates?: TemplateAdmin[] | undefined;
    organizationIds?: string[] | undefined;
    hasMultipleOrganizations?: boolean;
    hasDefaultTemplate?: boolean;
}

export class ResponseOfListOfAdminPartnerAndString implements IResponseOfListOfAdminPartnerAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminPartner[] | undefined;

    constructor(data?: IResponseOfListOfAdminPartnerAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdminPartner.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAdminPartnerAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminPartnerAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAdminPartnerAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AdminPartner[] | undefined;
}

export class ResponseOfListOfAdminPartner extends ResponseOfListOfAdminPartnerAndString implements IResponseOfListOfAdminPartner {

    constructor(data?: IResponseOfListOfAdminPartner) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAdminPartner {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAdminPartner();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAdminPartner extends IResponseOfListOfAdminPartnerAndString {
}

export class ListResponseOfAdminPartner extends ResponseOfListOfAdminPartner implements IListResponseOfAdminPartner {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfAdminPartner) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAdminPartner {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAdminPartner();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAdminPartner extends IResponseOfListOfAdminPartner {
    totalRecords?: number | undefined;
}

export class AdminPartner implements IAdminPartner {
    id?: string;
    name?: string | undefined;
    organizationId?: string;
    secret?: string | undefined;
    orderType?: string | undefined;
    companyCode?: string | undefined;
    sendExternalMessages?: boolean;
    examReviewPartnerId?: string | undefined;
    type?: PartnerType;

    constructor(data?: IAdminPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.secret = _data["secret"];
            this.orderType = _data["orderType"];
            this.companyCode = _data["companyCode"];
            this.sendExternalMessages = _data["sendExternalMessages"];
            this.examReviewPartnerId = _data["examReviewPartnerId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AdminPartner {
        data = typeof data === 'object' ? data : {};
        let result = new AdminPartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["secret"] = this.secret;
        data["orderType"] = this.orderType;
        data["companyCode"] = this.companyCode;
        data["sendExternalMessages"] = this.sendExternalMessages;
        data["examReviewPartnerId"] = this.examReviewPartnerId;
        data["type"] = this.type;
        return data;
    }
}

export interface IAdminPartner {
    id?: string;
    name?: string | undefined;
    organizationId?: string;
    secret?: string | undefined;
    orderType?: string | undefined;
    companyCode?: string | undefined;
    sendExternalMessages?: boolean;
    examReviewPartnerId?: string | undefined;
    type?: PartnerType;
}

export enum PartnerType {
    Internal = "Internal",
    External = "External",
}

export class ListRequestOfOrganizationIdFilter implements IListRequestOfOrganizationIdFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationIdFilter | undefined;

    constructor(data?: IListRequestOfOrganizationIdFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? OrganizationIdFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfOrganizationIdFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfOrganizationIdFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfOrganizationIdFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: OrganizationIdFilter | undefined;
}

export class OrganizationIdFilter extends BaseFilter implements IOrganizationIdFilter {
    organizationId?: string | undefined;

    constructor(data?: IOrganizationIdFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static override fromJS(data: any): OrganizationIdFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationIdFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationIdFilter extends IBaseFilter {
    organizationId?: string | undefined;
}

export class PartnerSaveRequest implements IPartnerSaveRequest {
    id?: string | undefined;
    name?: string | undefined;
    organizationId?: string;
    orderType?: string | undefined;
    companyCode?: string | undefined;
    sendExternalMessages?: boolean;
    type?: PartnerType;

    constructor(data?: IPartnerSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.orderType = _data["orderType"];
            this.companyCode = _data["companyCode"];
            this.sendExternalMessages = _data["sendExternalMessages"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PartnerSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["orderType"] = this.orderType;
        data["companyCode"] = this.companyCode;
        data["sendExternalMessages"] = this.sendExternalMessages;
        data["type"] = this.type;
        return data;
    }
}

export interface IPartnerSaveRequest {
    id?: string | undefined;
    name?: string | undefined;
    organizationId?: string;
    orderType?: string | undefined;
    companyCode?: string | undefined;
    sendExternalMessages?: boolean;
    type?: PartnerType;
}

export class ResponseOfListOfRequestAndString implements IResponseOfListOfRequestAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Request[] | undefined;

    constructor(data?: IResponseOfListOfRequestAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Request.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRequestAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequestAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRequestAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: Request[] | undefined;
}

export class ResponseOfListOfRequest extends ResponseOfListOfRequestAndString implements IResponseOfListOfRequest {

    constructor(data?: IResponseOfListOfRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRequest extends IResponseOfListOfRequestAndString {
}

export class ListResponseOfRequest extends ResponseOfListOfRequest implements IListResponseOfRequest {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRequest extends IResponseOfListOfRequest {
    totalRecords?: number | undefined;
}

export class Request implements IRequest {
    id?: string;
    partnerId?: string;
    createdOn?: Date;
    partnerName?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    requestObject?: string | undefined;
    responseObject?: string | undefined;

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerId = _data["partnerId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.partnerName = _data["partnerName"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.requestObject = _data["requestObject"];
            this.responseObject = _data["responseObject"];
        }
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerId"] = this.partnerId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["partnerName"] = this.partnerName;
        data["type"] = this.type;
        data["status"] = this.status;
        data["requestObject"] = this.requestObject;
        data["responseObject"] = this.responseObject;
        return data;
    }
}

export interface IRequest {
    id?: string;
    partnerId?: string;
    createdOn?: Date;
    partnerName?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    requestObject?: string | undefined;
    responseObject?: string | undefined;
}

export class ListRequestOfRequestFilter implements IListRequestOfRequestFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RequestFilter | undefined;

    constructor(data?: IListRequestOfRequestFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? RequestFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfRequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfRequestFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfRequestFilter {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RequestFilter | undefined;
}

export class RequestFilter extends BaseFilter implements IRequestFilter {
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    statusId?: string | undefined;
    typeId?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IRequestFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.typeId = _data["typeId"];
            this.userId = _data["userId"];
        }
    }

    static override fromJS(data: any): RequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RequestFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["typeId"] = this.typeId;
        data["userId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestFilter extends IBaseFilter {
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    statusId?: string | undefined;
    typeId?: string | undefined;
    userId?: string | undefined;
}

export class ResponseOfListOfRequestStatusAndString implements IResponseOfListOfRequestStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequestStatus[] | undefined;

    constructor(data?: IResponseOfListOfRequestStatusAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequestStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRequestStatusAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequestStatusAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRequestStatusAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequestStatus[] | undefined;
}

export class ResponseOfListOfRequestStatus extends ResponseOfListOfRequestStatusAndString implements IResponseOfListOfRequestStatus {

    constructor(data?: IResponseOfListOfRequestStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequestStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRequestStatus extends IResponseOfListOfRequestStatusAndString {
}

export class ListResponseOfRequestStatus extends ResponseOfListOfRequestStatus implements IListResponseOfRequestStatus {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRequestStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRequestStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRequestStatus extends IResponseOfListOfRequestStatus {
    totalRecords?: number | undefined;
}

export class RequestStatus implements IRequestStatus {
    id?: string;
    name?: string | undefined;

    constructor(data?: IRequestStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RequestStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRequestStatus {
    id?: string;
    name?: string | undefined;
}

export class ResponseOfListOfRequestTypeAndString implements IResponseOfListOfRequestTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequestType[] | undefined;

    constructor(data?: IResponseOfListOfRequestTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequestType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfRequestTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequestTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfRequestTypeAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RequestType[] | undefined;
}

export class ResponseOfListOfRequestType extends ResponseOfListOfRequestTypeAndString implements IResponseOfListOfRequestType {

    constructor(data?: IResponseOfListOfRequestType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfRequestType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfRequestType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfRequestType extends IResponseOfListOfRequestTypeAndString {
}

export class ListResponseOfRequestType extends ResponseOfListOfRequestType implements IListResponseOfRequestType {
    totalRecords?: number | undefined;

    constructor(data?: IListResponseOfRequestType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfRequestType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfRequestType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfRequestType extends IResponseOfListOfRequestType {
    totalRecords?: number | undefined;
}

export class RequestType implements IRequestType {
    id?: string;
    name?: string | undefined;

    constructor(data?: IRequestType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RequestType {
        data = typeof data === 'object' ? data : {};
        let result = new RequestType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRequestType {
    id?: string;
    name?: string | undefined;
}

export class ListRequestOfRequestReprocess implements IListRequestOfRequestReprocess {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RequestReprocess | undefined;

    constructor(data?: IListRequestOfRequestReprocess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? RequestReprocess.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfRequestReprocess {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfRequestReprocess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfRequestReprocess {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sortField?: string | undefined;
    sortDescending?: boolean;
    parameters?: RequestReprocess | undefined;
}

export class RequestReprocess implements IRequestReprocess {
    requestIds?: string[] | undefined;

    constructor(data?: IRequestReprocess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requestIds"])) {
                this.requestIds = [] as any;
                for (let item of _data["requestIds"])
                    this.requestIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RequestReprocess {
        data = typeof data === 'object' ? data : {};
        let result = new RequestReprocess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestIds)) {
            data["requestIds"] = [];
            for (let item of this.requestIds)
                data["requestIds"].push(item);
        }
        return data;
    }
}

export interface IRequestReprocess {
    requestIds?: string[] | undefined;
}

export class SaveUserCredentialsRequest implements ISaveUserCredentialsRequest {
    id?: string | undefined;
    externalUserId!: string;
    userCredentialTypeId?: string;
    applicationId?: string | undefined;
    organizationUserId?: string;

    constructor(data?: ISaveUserCredentialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalUserId = _data["externalUserId"];
            this.userCredentialTypeId = _data["userCredentialTypeId"];
            this.applicationId = _data["applicationId"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static fromJS(data: any): SaveUserCredentialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserCredentialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalUserId"] = this.externalUserId;
        data["userCredentialTypeId"] = this.userCredentialTypeId;
        data["applicationId"] = this.applicationId;
        data["organizationUserId"] = this.organizationUserId;
        return data;
    }
}

export interface ISaveUserCredentialsRequest {
    id?: string | undefined;
    externalUserId: string;
    userCredentialTypeId?: string;
    applicationId?: string | undefined;
    organizationUserId?: string;
}

export class DeleteUserCredentialsRequest implements IDeleteUserCredentialsRequest {
    id?: string;
    organizationUserId?: string;

    constructor(data?: IDeleteUserCredentialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static fromJS(data: any): DeleteUserCredentialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserCredentialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationUserId"] = this.organizationUserId;
        return data;
    }
}

export interface IDeleteUserCredentialsRequest {
    id?: string;
    organizationUserId?: string;
}

export class ResponseOfAuthenticationResponseAndString implements IResponseOfAuthenticationResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthenticationResponse | undefined;

    constructor(data?: IResponseOfAuthenticationResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? AuthenticationResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAuthenticationResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthenticationResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAuthenticationResponseAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: AuthenticationResponse | undefined;
}

export class ResponseOfAuthenticationResponse extends ResponseOfAuthenticationResponseAndString implements IResponseOfAuthenticationResponse {

    constructor(data?: IResponseOfAuthenticationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthenticationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAuthenticationResponse extends IResponseOfAuthenticationResponseAndString {
}

export class AuthenticationResponse implements IAuthenticationResponse {
    result?: boolean;
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organizationId?: string | undefined;
    returnUrl?: string | undefined;
    permissions?: string[] | undefined;
    impersonatedUserEmail?: string | undefined;
    impersonatingOrganizationUserId?: string | undefined;

    constructor(data?: IAuthenticationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.returnUrl = _data["returnUrl"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.impersonatedUserEmail = _data["impersonatedUserEmail"];
            this.impersonatingOrganizationUserId = _data["impersonatingOrganizationUserId"];
        }
    }

    static fromJS(data: any): AuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["returnUrl"] = this.returnUrl;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["impersonatedUserEmail"] = this.impersonatedUserEmail;
        data["impersonatingOrganizationUserId"] = this.impersonatingOrganizationUserId;
        return data;
    }
}

export interface IAuthenticationResponse {
    result?: boolean;
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organizationId?: string | undefined;
    returnUrl?: string | undefined;
    permissions?: string[] | undefined;
    impersonatedUserEmail?: string | undefined;
    impersonatingOrganizationUserId?: string | undefined;
}

export class ResponseOfRedirectUrlAndString implements IResponseOfRedirectUrlAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RedirectUrl | undefined;

    constructor(data?: IResponseOfRedirectUrlAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RedirectUrl.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRedirectUrlAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRedirectUrlAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRedirectUrlAndString {
    responseCode?: ResponseCode;
    responseReason?: string | undefined;
    data?: RedirectUrl | undefined;
}

export class ResponseOfRedirectUrl extends ResponseOfRedirectUrlAndString implements IResponseOfRedirectUrl {

    constructor(data?: IResponseOfRedirectUrl) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRedirectUrl {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRedirectUrl();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRedirectUrl extends IResponseOfRedirectUrlAndString {
}

export class RedirectUrl implements IRedirectUrl {
    url?: string | undefined;

    constructor(data?: IRedirectUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): RedirectUrl {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IRedirectUrl {
    url?: string | undefined;
}

export class AuthData implements IAuthData {
    applicationId?: string;
    organizationId?: string;
    userId?: string | undefined;
    isImpersonating?: boolean;
    stopImpersonationUrl?: string | undefined;

    constructor(data?: IAuthData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.isImpersonating = _data["isImpersonating"];
            this.stopImpersonationUrl = _data["stopImpersonationUrl"];
        }
    }

    static fromJS(data: any): AuthData {
        data = typeof data === 'object' ? data : {};
        let result = new AuthData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["isImpersonating"] = this.isImpersonating;
        data["stopImpersonationUrl"] = this.stopImpersonationUrl;
        return data;
    }
}

export interface IAuthData {
    applicationId?: string;
    organizationId?: string;
    userId?: string | undefined;
    isImpersonating?: boolean;
    stopImpersonationUrl?: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}